import { endpointUrl, fetchParams } from './graphql-fetch-config';
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, QueryFunctionContext } from 'react-query';
import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(endpointUrl as string, {
    method: "POST",
    ...(fetchParams),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  /** A RFC-3339 compliant date time scalar that accepts string values like `1996-12-19T16:39:57-08:00` and produces `java.time.OffsetDateTime` objects at runtime. */
  DateTime: string;
  Email: string;
  LocalTime: string;
  /** A phone number string following the [E.164 specification](https://en.wikipedia.org/wiki/E.164), e.g. `+12223334444`. */
  PhoneNumber: string;
  Upload: any;
  Url: string;
};

export type ActiveForwardAccountNode = Node & {
  candidateId: Scalars['ID'];
  demographicInfo?: Maybe<CandidateDemographicInfo>;
  /** No duplicate emails. Primary email will come first. */
  emails: Array<ForwardAccountEmailNode>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  jobPreferences?: Maybe<ForwardJobPreferences>;
  loggedInEmail: Scalars['Email'];
  profile?: Maybe<ForwardProfileNode>;
  shouldShowEventsInterviewsFeedGettingStarted: Scalars['Boolean'];
};

export type AddEvaluationQuestionInput = {
  id?: InputMaybe<Scalars['ID']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  orgFeedbackId: Scalars['Int'];
};

export type AddOfficeToOrgInput = {
  officeName: Scalars['String'];
};

export type AddOfficeToOrgPayload = {
  success: Scalars['Boolean'];
};

export type AdminUserAnalyticsInfo = {
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  /** A cross-environment, cross-product unique ID for FullStory. */
  fullStoryId: Scalars['ID'];
  id: Scalars['ID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  isPaying?: Maybe<Scalars['Boolean']>;
  orgId?: Maybe<Scalars['ID']>;
  orgName?: Maybe<Scalars['String']>;
  /** A cross-environment, cross-product unique account ID for Pendo. */
  pendoAccountId: Scalars['ID'];
  /** A cross-environment, cross-product unique visitor ID for Pendo. */
  pendoVisitorId: Scalars['ID'];
};

export type AgencyContactJobAuthorizationNode = {
  agencyContactId?: Maybe<Scalars['Int']>;
  agencyJobAuthorizationId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type AgencyContactNode = Node & {
  agencyId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type AgencyContactWithAgencyInfoInput = {
  agencyName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type AgencyInput = {
  id?: InputMaybe<Scalars['ID']>;
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type AgencyJobAuthorizationNode = {
  agencyContactJobAuthorizations?: Maybe<Array<Maybe<AgencyContactJobAuthorizationNode>>>;
  agencyId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isEntireAgency?: Maybe<Scalars['Boolean']>;
  jobId?: Maybe<Scalars['Int']>;
};

export type AgencyNode = Node & {
  agencyContacts?: Maybe<Array<Maybe<AgencyContactNode>>>;
  feeAgreements?: Maybe<Array<Maybe<FeeAgreementNode>>>;
  id: Scalars['ID'];
  isEnabled?: Maybe<Scalars['Boolean']>;
  isUnregisteredAgency?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type AppSourceGraph = {
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AssignQualifyingQuestionsToEventInput = {
  eventId: Scalars['ID'];
  /** Questions are assigned in the order provided. */
  questionIds: Array<Scalars['ID']>;
};

export type AssignQualifyingQuestionsToEventPayload = {
  success: Scalars['Boolean'];
};

export enum AssignmentType {
  Closings = 'CLOSINGS',
  DocumentReview = 'DOCUMENT_REVIEW',
  Draft = 'DRAFT',
  DraftingDocuments = 'DRAFTING_DOCUMENTS',
  DueDiligence = 'DUE_DILIGENCE',
  EditDocument = 'EDIT_DOCUMENT',
  Meeting = 'MEETING',
  None = 'NONE',
  Observational = 'OBSERVATIONAL',
  Other = 'OTHER',
  ResearchAnalysis = 'RESEARCH_ANALYSIS',
  ResearchMemo = 'RESEARCH_MEMO',
  WriteArticle = 'WRITE_ARTICLE'
}

export type AssociateNode = Node & {
  candidate: CandidateNode;
  evaluations?: Maybe<Array<Maybe<MatterEvaluationNode>>>;
  id: Scalars['ID'];
};

export type AtsJobApplicationNode = JobApplicationNode & Node & {
  corePipelineBucketName?: Maybe<CorePipelineBucketName>;
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  job?: Maybe<AtsJobNode>;
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
  recruitId: Scalars['ID'];
  /** The careers page for the applied job. */
  sourceLink?: Maybe<Scalars['Url']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
};

export type AtsJobNode = JobNode & Node & {
  closeDate?: Maybe<DateTimeZone>;
  description?: Maybe<Scalars['String']>;
  descriptionTextContent?: Maybe<Scalars['String']>;
  employer?: Maybe<PublicOrgInfo>;
  extension?: Maybe<Scalars['String']>;
  hasJobBoardAudienceSet: Scalars['Boolean'];
  id: Scalars['ID'];
  is1L: Scalars['Boolean'];
  is2L: Scalars['Boolean'];
  offices?: Maybe<JobOfficeConnection>;
  openDate?: Maybe<DateTimeZone>;
  orgId: Scalars['ID'];
  requiredDocuments?: Maybe<Array<Maybe<CandidateDocument>>>;
  /** The careers page link for the job. */
  sourceLink?: Maybe<Scalars['Url']>;
  statuses?: Maybe<Array<JobAppStatusNode>>;
  title?: Maybe<Scalars['String']>;
};


export type AtsJobNodeDescriptionTextContentArgs = {
  numChars?: InputMaybe<Scalars['Int']>;
};


export type AtsJobNodeOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type BooleanFilterBy = {
  equals?: InputMaybe<Scalars['Boolean']>;
};

export type BulkCreateCandidateMissingInfoRequestInput = {
  jobAppIds: Array<Scalars['Int']>;
  jobId: Scalars['Int'];
  recipientType: CandidateMissingInfoRequestRecipientType;
};

export type BulkCreateCandidateMissingInfoRequestPayload = {
  successful: Scalars['Int'];
};

export type BulkDownloadDocumentsInput = {
  interviewerExtension: Scalars['String'];
  jobApplicationIds: Array<Scalars['Int']>;
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};

export type CallbackEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  employerRegistrationDeadline?: Maybe<DateTimeZone>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type CallbackEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CancelLotteryStudentMatchInput = {
  matchId: Scalars['ID'];
  scheduleId: Scalars['ID'];
};

export type CancelLotteryStudentMatchPayload = {
  successful?: Maybe<Scalars['Boolean']>;
};

export type CandidateBasicInformationInput = {
  email?: InputMaybe<Scalars['Email']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  linkedIn?: InputMaybe<Scalars['Url']>;
  phone?: InputMaybe<Scalars['PhoneNumber']>;
  recruitId: Scalars['Int'];
};

export type CandidateCallbackEventNode = CandidateEventNode & Node & {
  end?: Maybe<DateTimeZone>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  start?: Maybe<DateTimeZone>;
};

export type CandidateConnection = Connection & {
  edges?: Maybe<Array<Maybe<CandidateEdge>>>;
  nodes?: Maybe<Array<Maybe<CandidateNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CandidateDemographicInfo = {
  ethnicityAnswers?: Maybe<Array<Maybe<Scalars['String']>>>;
  genderAnswers?: Maybe<Array<Maybe<Scalars['String']>>>;
  sexualIdentityAnswer?: Maybe<Scalars['String']>;
  sexualIdentityAnswers?: Maybe<Array<Maybe<Scalars['String']>>>;
  veteranStatusAnswer?: Maybe<Scalars['String']>;
};

export type CandidateDocument = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type CandidateEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CandidateNode>;
};

export type CandidateEducationHistoryEntryConnection = Connection & {
  edges: Array<CandidateEducationHistoryEntryEdge>;
  nodes: Array<CandidateEducationHistoryEntryNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CandidateEducationHistoryEntryEdge = Edge & {
  cursor: Scalars['String'];
  node?: Maybe<CandidateEducationHistoryEntryNode>;
};

export type CandidateEducationHistoryEntryNode = {
  candidateId: Scalars['ID'];
  degree: SchoolDegreeNode;
  degreeId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  /** Private field. */
  gpa?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  school: SchoolNode;
  schoolId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
};

export type CandidateEducationHistoryLawSchoolEntryNode = CandidateEducationHistoryEntryNode & Node & {
  candidateId: Scalars['ID'];
  classYear?: Maybe<LawSchoolClassYear>;
  degree: SchoolDegreeNode;
  degreeId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  /** Private field. */
  gpa?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  school: LawSchoolNode;
  schoolId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
};

export type CandidateEducationHistoryUniversityEntryNode = CandidateEducationHistoryEntryNode & Node & {
  candidateId: Scalars['ID'];
  degree: SchoolDegreeNode;
  degreeId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  /** Private field. */
  gpa?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  school: UniversityNode;
  schoolId: Scalars['ID'];
  startDate?: Maybe<Scalars['Date']>;
};

export type CandidateEvaluationAnswerInput = {
  comment?: InputMaybe<Scalars['String']>;
  freeText?: InputMaybe<Scalars['String']>;
  multiSelectAnswers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orgFeedbackId: Scalars['ID'];
  ratingAnswer?: InputMaybe<Scalars['Int']>;
  singleSelectAnswer?: InputMaybe<Scalars['String']>;
  yesNoAnswer?: InputMaybe<Scalars['Int']>;
};

export type CandidateEvaluationNode = {
  comment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
};

export type CandidateEventConnection = Connection & {
  edges?: Maybe<Array<Maybe<CandidateEventEdge>>>;
  nodes?: Maybe<Array<Maybe<EventNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** TODO: More generic? */
export type CandidateEventContactNode = Node & {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type CandidateEventEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<EventNode>;
};

/** A Candidate's perspective of an Event. */
export type CandidateEventNode = {
  end?: Maybe<DateTimeZone>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  start?: Maybe<DateTimeZone>;
};

export type CandidateFilterBy = {
  candidateIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type CandidateInput = {
  email: Scalars['Email'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  linkedInUrl?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CandidateInviteEmployerEventNode = CandidateEventNode & Node & {
  end?: Maybe<DateTimeZone>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  start?: Maybe<DateTimeZone>;
};

export type CandidateJobAppConnection = Connection & {
  edges?: Maybe<Array<Maybe<CandidateJobAppEdge>>>;
  nodes?: Maybe<Array<Maybe<JobAppNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CandidateJobAppEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<JobAppNode>;
};

export type CandidateJobApplicationStatusSelection = {
  jobId: Scalars['Int'];
  jobPipelineStatusId: Scalars['Int'];
};

export type CandidateLawDegreeNode = Node & {
  classification?: Maybe<LawSchoolClassification>;
  degreeType?: Maybe<LawDegree>;
  gpa?: Maybe<Scalars['Float']>;
  graduationDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lawSchool?: Maybe<LawSchoolNode>;
};

export type CandidateMergeInput = {
  jobApplicationStatusSelections?: InputMaybe<Array<CandidateJobApplicationStatusSelection>>;
  primaryRecruitId: Scalars['Int'];
  subordinateRecruitId: Scalars['Int'];
};

export type CandidateMissingInfoRequestJobEmailTemplateInput = {
  bccUserId?: InputMaybe<Scalars['Int']>;
  body?: InputMaybe<Scalars['String']>;
  ccUserId?: InputMaybe<Scalars['Int']>;
  replyToUserId?: InputMaybe<Scalars['Int']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type CandidateMissingInfoRequestJobEmailTemplateNode = {
  bccUserId?: Maybe<Scalars['Int']>;
  body?: Maybe<Scalars['String']>;
  ccUserId?: Maybe<Scalars['Int']>;
  replyToUserId?: Maybe<Scalars['Int']>;
  subject?: Maybe<Scalars['String']>;
};

export enum CandidateMissingInfoRequestRecipientType {
  AgencyContact = 'AGENCY_CONTACT',
  Candidate = 'CANDIDATE'
}

export type CandidateNetworkingEventNode = CandidateEventNode & Node & {
  end?: Maybe<DateTimeZone>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  start?: Maybe<DateTimeZone>;
};

export type CandidateNode = Node & {
  authzReasons?: Maybe<Array<WorkAllocationAuthorizationReason>>;
  candidateNotifications?: Maybe<CandidateNotificationConnection>;
  email?: Maybe<Scalars['String']>;
  events?: Maybe<CandidateEventConnection>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalFieldAnswers?: Maybe<Array<Maybe<InternalFieldAnswerNode>>>;
  jobApps?: Maybe<CandidateJobAppConnection>;
  lastName?: Maybe<Scalars['String']>;
  lawSchool?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  qualifyingQuestions?: Maybe<CandidateQualifyingQuestionConnection>;
};


export type CandidateNodeCandidateNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateNodeJobAppsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateNodeQualifyingQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CandidateNotificationConnection = Connection & {
  edges?: Maybe<Array<Maybe<CandidateNotificationEdge>>>;
  nodes?: Maybe<Array<Maybe<CandidateNotificationNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CandidateNotificationEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CandidateNotificationNode>;
};

export type CandidateNotificationNode = Node & {
  candidateId: Scalars['Int'];
  id: Scalars['ID'];
  notification?: Maybe<NotificationNode>;
  notificationId: Scalars['Int'];
  timeSent: Scalars['DateTime'];
};

export type CandidatePhysicalEventNode = CandidateEventNode & Node & {
  /** Available to logged-in users. */
  assignedQualifyingQuestions?: Maybe<QualifyingQuestionEventAssignmentConnection>;
  /** Whether DEI information is requested on the Event. */
  deiRequested: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** Available to logged-in users. */
  documentAssignments?: Maybe<EventDocumentAssignmentConnection>;
  end?: Maybe<DateTimeZone>;
  headshotUploadRequested: Scalars['Boolean'];
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  isInviteOnly: Scalars['Boolean'];
  isPublishedToForward: Scalars['Boolean'];
  location?: Maybe<Scalars['String']>;
  /**
   * The different profiles that a Candidate could use for the Event.
   *
   * Can have up to one for each Recruit record the Candidate has with the Event host.
   */
  myPotentialProfiles?: Maybe<RecruitEventProfileConnection>;
  name: Scalars['String'];
  registrationEnds?: Maybe<DateTimeZone>;
  registrationLink?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
  targetedSchools?: Maybe<EventTargetsSchoolConnection>;
  university?: Maybe<Scalars['String']>;
};


export type CandidatePhysicalEventNodeAssignedQualifyingQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidatePhysicalEventNodeDocumentAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidatePhysicalEventNodeMyPotentialProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidatePhysicalEventNodeTargetedSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CandidatePreselectEventNode = CandidateEventNode & Node & {
  end?: Maybe<DateTimeZone>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Currently only works in query for Forward dashboard.
   */
  jobsPageLink?: Maybe<Scalars['Url']>;
  name: Scalars['String'];
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Currently only works in query for Forward dashboard.
   */
  rawJobsPageLink?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
};

export type CandidateQualifyingQuestionConnection = Connection & {
  edges?: Maybe<Array<Maybe<CandidateQualifyingQuestionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CandidateQualifyingQuestionEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<CandidateQualifyingQuestionNode>;
};

export type CandidateQualifyingQuestionNode = Node & {
  answers?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  lastUpdated?: Maybe<Scalars['String']>;
  lastUpdatedAnswer?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentAdditionalInfoNode = {
  applicationQuestions?: Maybe<Array<Maybe<CandidateReviewContentApplicationQuestionNode>>>;
  internalFields?: Maybe<Array<Maybe<CandidateReviewContentInternalFieldNode>>>;
  qualifyingQuestions?: Maybe<Array<Maybe<CandidateReviewContentQualifyingQuestionNode>>>;
};

export type CandidateReviewContentApplicationQuestionNode = {
  answer?: Maybe<Array<Maybe<Scalars['String']>>>;
  appQuestionId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  questionLabel?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentDocumentNode = {
  documentLink?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  uploadedDate?: Maybe<Scalars['String']>;
  userFileName?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentEvaluationNode = {
  comment?: Maybe<Scalars['String']>;
  evaluatorId: Scalars['Int'];
  evaluatorName?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  eventTitle?: Maybe<Scalars['String']>;
  freeTextResponse?: Maybe<Scalars['String']>;
  highLabel?: Maybe<Scalars['String']>;
  highScale?: Maybe<Scalars['Int']>;
  lowLabel?: Maybe<Scalars['String']>;
  lowScale?: Maybe<Scalars['Int']>;
  multiSelectResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  order?: Maybe<Scalars['Int']>;
  questionLabel?: Maybe<Scalars['String']>;
  questionType?: Maybe<FeedbackQuestionType>;
  ratingResponse?: Maybe<Scalars['Int']>;
  selectOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  singleSelectResponse?: Maybe<Scalars['String']>;
  yesNoResponse?: Maybe<Scalars['Boolean']>;
};

export type CandidateReviewContentInternalFieldNode = {
  answer?: Maybe<Array<Maybe<Scalars['String']>>>;
  internalFieldId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  questionLabel?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentInterviewScheduleNode = {
  eventId: Scalars['Int'];
  eventName?: Maybe<Scalars['String']>;
  eventTimezone?: Maybe<Scalars['String']>;
  interviewDate?: Maybe<Scalars['String']>;
  interviewEndTime?: Maybe<Scalars['String']>;
  interviewStartTime?: Maybe<Scalars['String']>;
  interviewers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CandidateReviewContentJobAppAddressInfoSection = {
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentJobAppCustomQuestionSection = {
  applicationQuestions?: Maybe<Array<Maybe<CandidateReviewContentApplicationQuestionNode>>>;
  order?: Maybe<Scalars['Int']>;
  questionSectionName?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentJobAppEducationHistorySection = {
  candidateEducationHistory?: Maybe<Array<Maybe<PublicCandidateJobAppEducationHistoryNode>>>;
  order?: Maybe<Scalars['Int']>;
};

export type CandidateReviewContentJobAppNode = {
  addressInfoSection?: Maybe<CandidateReviewContentJobAppAddressInfoSection>;
  customQuestionsSections?: Maybe<Array<Maybe<CandidateReviewContentJobAppCustomQuestionSection>>>;
  educationHistorySection?: Maybe<CandidateReviewContentJobAppEducationHistorySection>;
  jobAppId: Scalars['Int'];
  jobAppStatus?: Maybe<Scalars['String']>;
  jobId: Scalars['Int'];
  jobTitle?: Maybe<Scalars['String']>;
  personalInfoSection?: Maybe<CandidateReviewContentJobAppPersonalInfoSection>;
  workHistorySection?: Maybe<CandidateReviewContentJobAppWorkHistorySection>;
};

export type CandidateReviewContentJobAppPersonalInfoSection = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentJobAppWorkHistorySection = {
  candidateWorkHistory?: Maybe<Array<Maybe<PublicCandidateJobAppWorkHistoryNode>>>;
  order?: Maybe<Scalars['Int']>;
};

export type CandidateReviewContentNode = {
  candidateId: Scalars['Int'];
  candidateLawSchool?: Maybe<Scalars['String']>;
  candidateName?: Maybe<Scalars['String']>;
  candidateReviewTemplateId: Scalars['Int'];
  dateAddedToReview?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<CandidateReviewContentSectionNode>>>;
  title?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentProgramEvaluationNode = {
  evaluations?: Maybe<Array<Maybe<CandidateReviewContentProgramEvaluationResponseNode>>>;
  id: Scalars['Int'];
  mostRecentEvaluationDate?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type CandidateReviewContentProgramEvaluationResponseNode = {
  comment?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  evaluationId: Scalars['Int'];
  evaluationTitle?: Maybe<Scalars['String']>;
  evaluatorId?: Maybe<Scalars['Int']>;
  evaluatorName?: Maybe<Scalars['String']>;
  freeTextResponse?: Maybe<Scalars['String']>;
  highLabel?: Maybe<Scalars['String']>;
  highScale?: Maybe<Scalars['Int']>;
  lowLabel?: Maybe<Scalars['String']>;
  lowScale?: Maybe<Scalars['Int']>;
  multiSelectResponse?: Maybe<Array<Maybe<Scalars['String']>>>;
  questionFeedbackId?: Maybe<Scalars['Int']>;
  questionLabel?: Maybe<Scalars['String']>;
  questionOrder?: Maybe<Scalars['Int']>;
  questionSubtext?: Maybe<Scalars['String']>;
  questionType?: Maybe<FeedbackQuestionType>;
  ratingResponse?: Maybe<Scalars['Int']>;
  selectOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  singleSelectResponse?: Maybe<Scalars['String']>;
  yesNoResponse?: Maybe<Scalars['Boolean']>;
};

export type CandidateReviewContentProjectEvaluationNode = {
  documents?: Maybe<Array<Maybe<CandidateReviewContentDocumentNode>>>;
  evaluations?: Maybe<Array<Maybe<CandidateReviewContentProgramEvaluationResponseNode>>>;
  mostRecentEvaluationDate?: Maybe<Scalars['DateTime']>;
  projectCompletedAt?: Maybe<Scalars['String']>;
  projectDescription?: Maybe<Scalars['String']>;
  projectId: Scalars['Int'];
  projectPracticeAreas?: Maybe<Array<Maybe<Scalars['String']>>>;
  projectTitle?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentQualifyingQuestionNode = {
  answer?: Maybe<Array<Maybe<Scalars['String']>>>;
  order?: Maybe<Scalars['Int']>;
  qqId?: Maybe<Scalars['Int']>;
  questionLabel?: Maybe<Scalars['String']>;
};

export type CandidateReviewContentSectionNode = {
  additionalInfo?: Maybe<CandidateReviewContentAdditionalInfoNode>;
  documents?: Maybe<Array<Maybe<CandidateReviewContentDocumentNode>>>;
  evaluationAverage?: Maybe<Scalars['Float']>;
  evaluationSortEnum?: Maybe<EvaluationSortEnum>;
  evaluations?: Maybe<Array<Maybe<CandidateReviewContentEvaluationNode>>>;
  interviewSchedules?: Maybe<Array<Maybe<CandidateReviewContentInterviewScheduleNode>>>;
  jobApps?: Maybe<Array<Maybe<CandidateReviewContentJobAppNode>>>;
  order?: Maybe<Scalars['Int']>;
  programEvaluations?: Maybe<Array<Maybe<CandidateReviewContentProgramEvaluationNode>>>;
  projectsWithEvaluations?: Maybe<Array<Maybe<CandidateReviewContentProjectEvaluationNode>>>;
  recruitId?: Maybe<Scalars['Int']>;
  sectionType?: Maybe<CandidateReviewTemplateSectionType>;
};

export type CandidateReviewPdfExport = {
  pdf?: Maybe<Scalars['String']>;
};

export type CandidateReviewPdfExportContent = {
  candidateReviewContentNodes?: Maybe<Array<Maybe<CandidateReviewContentNode>>>;
  candidateReviewTemplateId: Scalars['Int'];
  candidateReviewTitle?: Maybe<Scalars['String']>;
  candidateReviewType?: Maybe<Scalars['String']>;
  clientTimezone?: Maybe<Scalars['String']>;
  includeVoting?: Maybe<Scalars['Boolean']>;
  orgName?: Maybe<Scalars['String']>;
  programEvaluationConfig?: Maybe<CandidateReviewTemplateProgramEvaluationConfigNode>;
  votingInfo?: Maybe<Array<Maybe<CandidateReviewVotingRecordNode>>>;
};

export type CandidateReviewPdfExportRequest = {
  candidateReviewTemplateId: Scalars['Int'];
  clientTimezone?: InputMaybe<Scalars['String']>;
  includeVoting: Scalars['Boolean'];
  jobAppIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  recruitIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export enum CandidateReviewTemplateAdditionalInformationQuestionType {
  ApplicationQuestion = 'APPLICATION_QUESTION',
  InternalFields = 'INTERNAL_FIELDS',
  QualifyingQuestion = 'QUALIFYING_QUESTION'
}

export type CandidateReviewTemplateAdditionalInformationSectionInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  includedAdditionalInformationInput?: InputMaybe<Array<InputMaybe<CandidateReviewTemplateIncludedAdditionalInformationInput>>>;
  order?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateCandidateNode = Node & {
  candidate?: Maybe<CandidateNode>;
  candidateReviewTemplateId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  evaluationAverage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  votingRecords?: Maybe<Array<Maybe<CandidateReviewVotingRecordNode>>>;
};

export type CandidateReviewTemplateCandidateVotingInput = {
  candidateId?: InputMaybe<Scalars['Int']>;
  candidateReviewTemplateId?: InputMaybe<Scalars['Int']>;
  castedVote?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  userIdOfVoter?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateCandidatesInput = {
  candidateReviewTemplateId?: InputMaybe<Scalars['Int']>;
  recruitIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CandidateReviewTemplateDocumentSectionInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  includedDocumentInputs?: InputMaybe<Array<InputMaybe<CandidateReviewTemplateIncludedDocumentInput>>>;
  order?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateEvaluationSectionInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  evaluationSortEnum?: InputMaybe<EvaluationSortEnum>;
  id?: InputMaybe<Scalars['Int']>;
  includedEvaluationQuestionInputs?: InputMaybe<Array<InputMaybe<CandidateReviewTemplateIncludedEvaluationQuestionInput>>>;
  includedWorkAllocationEvaluationInputs?: InputMaybe<Array<InputMaybe<CandidateReviewTemplateIncludedWorkAllocationEvaluationInput>>>;
  includedWorkAllocationEvaluationQuestionInputs?: InputMaybe<Array<InputMaybe<CandidateReviewTemplateIncludedWorkAllocationEvaluationQuestionInput>>>;
  order?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateEventsInput = {
  candidateReviewTemplateId?: InputMaybe<Scalars['Int']>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CandidateReviewTemplateIncludedAdditionalInformationInput = {
  appQuestionId?: InputMaybe<Scalars['Int']>;
  internalFieldId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  qqId?: InputMaybe<Scalars['Int']>;
  questionType: CandidateReviewTemplateAdditionalInformationQuestionType;
};

export type CandidateReviewTemplateIncludedAdditionalInformationNode = Node & {
  appQuestionId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  internalFieldId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  qqId?: Maybe<Scalars['Int']>;
  questionType?: Maybe<CandidateReviewTemplateAdditionalInformationQuestionType>;
};

export type CandidateReviewTemplateIncludedDocumentInput = {
  order?: InputMaybe<Scalars['Int']>;
  orgDocumentId: Scalars['Int'];
};

export type CandidateReviewTemplateIncludedDocumentNode = Node & {
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  orgDocumentId: Scalars['Int'];
};

export type CandidateReviewTemplateIncludedEvaluationNode = Node & {
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  programEvaluationId?: Maybe<Scalars['Int']>;
};

export type CandidateReviewTemplateIncludedEvaluationQuestionInput = {
  order?: InputMaybe<Scalars['Int']>;
  orgEvalQuestionId: Scalars['Int'];
};

export type CandidateReviewTemplateIncludedEvaluationQuestionNode = Node & {
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  orgEvalQuestionId?: Maybe<Scalars['Int']>;
  programEvaluationId?: Maybe<Scalars['Int']>;
};

export type CandidateReviewTemplateIncludedJobAppQuestionInput = {
  jobQuestionId: Scalars['Int'];
  order: Scalars['Int'];
};

export type CandidateReviewTemplateIncludedJobAppQuestionNode = Node & {
  id: Scalars['ID'];
  jobQuestionId: Scalars['Int'];
  order: Scalars['Int'];
};

export type CandidateReviewTemplateIncludedJobSectionInput = {
  includedJobAppQuestionInputs: Array<CandidateReviewTemplateIncludedJobAppQuestionInput>;
  jobSectionId: Scalars['Int'];
  order: Scalars['Int'];
};

export type CandidateReviewTemplateIncludedJobSectionNode = Node & {
  id: Scalars['ID'];
  includedJobAppQuestions?: Maybe<Array<CandidateReviewTemplateIncludedJobAppQuestionNode>>;
  jobSectionId: Scalars['Int'];
  order: Scalars['Int'];
};

export type CandidateReviewTemplateIncludedWorkAllocationEvaluationInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  programEvaluationId?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateIncludedWorkAllocationEvaluationQuestionInput = {
  order?: InputMaybe<Scalars['Int']>;
  orgEvalQuestionId: Scalars['Int'];
  programEvaluationId?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateInput = {
  candidateReviewType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  reviewTitle?: InputMaybe<Scalars['String']>;
  votingEnabled?: InputMaybe<Scalars['Boolean']>;
  votingEndDate?: InputMaybe<Scalars['String']>;
  votingEndTimeZone?: InputMaybe<Scalars['String']>;
  votingStartDate?: InputMaybe<Scalars['String']>;
  votingStartTimeZone?: InputMaybe<Scalars['String']>;
};

export type CandidateReviewTemplateInterviewScheduleSectionInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateJobAppSectionInput = {
  enabled: Scalars['Boolean'];
  id?: InputMaybe<Scalars['Int']>;
  includedJobSectionInputs: Array<CandidateReviewTemplateIncludedJobSectionInput>;
  order: Scalars['Int'];
};

export type CandidateReviewTemplateJobsInput = {
  candidateReviewTemplateId?: InputMaybe<Scalars['Int']>;
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CandidateReviewTemplateJobsWithEventsInput = {
  candidateReviewTemplateId: Scalars['Int'];
  eventIds: Array<Scalars['Int']>;
  jobIds: Array<Scalars['Int']>;
};

export type CandidateReviewTemplateNode = Node & {
  candidateReviewTemplateCandidates?: Maybe<Array<Maybe<CandidateReviewTemplateCandidateNode>>>;
  candidateReviewType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  creatorFirstName?: Maybe<Scalars['String']>;
  creatorLastName?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<EventNode>>>;
  id: Scalars['ID'];
  jobs?: Maybe<Array<Maybe<JobGraph>>>;
  programEvaluationConfig?: Maybe<CandidateReviewTemplateProgramEvaluationConfigNode>;
  programs?: Maybe<Array<Maybe<ProgramNode>>>;
  sections?: Maybe<Array<Maybe<CandidateReviewTemplateSectionNode>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  votingEnabled?: Maybe<Scalars['Boolean']>;
  votingInfo?: Maybe<CandidateReviewVotingInfoNode>;
};


export type CandidateReviewTemplateNodeCandidateReviewTemplateCandidatesArgs = {
  recruitId?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateProgramEvaluationConfigNode = Node & {
  candidateReviewTemplateId: Scalars['Int'];
  evaluationEndDate?: Maybe<Scalars['String']>;
  evaluationEndTimeZone?: Maybe<Scalars['String']>;
  evaluationScope?: Maybe<CandidateReviewTemplateProgramsEvaluationScope>;
  evaluationStartDate?: Maybe<Scalars['String']>;
  evaluationStartTimeZone?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum CandidateReviewTemplateProgramsEvaluationScope {
  Both = 'BOTH',
  ProgramEvaluations = 'PROGRAM_EVALUATIONS',
  ProjectEvaluations = 'PROJECT_EVALUATIONS'
}

export type CandidateReviewTemplateProgramsInput = {
  candidateReviewTemplateId: Scalars['Int'];
  evaluationEndDate?: InputMaybe<Scalars['String']>;
  evaluationEndTimeZone?: InputMaybe<Scalars['String']>;
  evaluationScope?: InputMaybe<CandidateReviewTemplateProgramsEvaluationScope>;
  evaluationStartDate?: InputMaybe<Scalars['String']>;
  evaluationStartTimeZone?: InputMaybe<Scalars['String']>;
  programIds: Array<Scalars['Int']>;
};

export type CandidateReviewTemplateProjectDocumentsSectionInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewTemplateSectionNode = Node & {
  enabled?: Maybe<Scalars['Boolean']>;
  evaluationSortEnum?: Maybe<EvaluationSortEnum>;
  id: Scalars['ID'];
  includedAdditionalInformation?: Maybe<Array<Maybe<CandidateReviewTemplateIncludedAdditionalInformationNode>>>;
  includedDocuments?: Maybe<Array<Maybe<CandidateReviewTemplateIncludedDocumentNode>>>;
  includedEvaluationQuestions?: Maybe<Array<Maybe<CandidateReviewTemplateIncludedEvaluationQuestionNode>>>;
  includedEvaluations?: Maybe<Array<Maybe<CandidateReviewTemplateIncludedEvaluationNode>>>;
  includedJobAppSections?: Maybe<Array<Maybe<CandidateReviewTemplateIncludedJobSectionNode>>>;
  order?: Maybe<Scalars['Int']>;
  sectionType?: Maybe<CandidateReviewTemplateSectionType>;
};

export enum CandidateReviewTemplateSectionType {
  AdditionalInformation = 'ADDITIONAL_INFORMATION',
  Documents = 'DOCUMENTS',
  Evaluations = 'EVALUATIONS',
  InterviewSchedules = 'INTERVIEW_SCHEDULES',
  JobApps = 'JOB_APPS',
  ProjectDocuments = 'PROJECT_DOCUMENTS'
}

export type CandidateReviewVotingInfoNode = Node & {
  candidateReviewTemplateId: Scalars['Int'];
  id: Scalars['ID'];
  votingEndDate?: Maybe<Scalars['String']>;
  votingEndTimeZone?: Maybe<Scalars['String']>;
  votingStartDate?: Maybe<Scalars['String']>;
  votingStartTimeZone?: Maybe<Scalars['String']>;
};

export type CandidateReviewVotingRecordCastedVotedInput = {
  candidateId?: InputMaybe<Scalars['Int']>;
  candidateReviewTemplateId?: InputMaybe<Scalars['Int']>;
  castedVote?: InputMaybe<Scalars['String']>;
  userIdOfVoter?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewVotingRecordCommentInput = {
  candidateId?: InputMaybe<Scalars['Int']>;
  candidateReviewTemplateId?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  userIdOfVoter?: InputMaybe<Scalars['Int']>;
};

export type CandidateReviewVotingRecordNode = Node & {
  candidateId?: Maybe<Scalars['Int']>;
  candidateReviewTemplateId?: Maybe<Scalars['Int']>;
  castedVote?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  fname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lname?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type CandidateSerendipitousEventNode = CandidateEventNode & Node & {
  end?: Maybe<DateTimeZone>;
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Currently only works in query for Forward dashboard.
   */
  eventPageLink?: Maybe<Scalars['Url']>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Currently only works in query for Forward dashboard.
   */
  rawEventPageLink?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
};

export type CandidateSortBy = {
  email?: InputMaybe<SortDirection>;
  lawSchool?: InputMaybe<SortDirection>;
  name?: InputMaybe<SortDirection>;
  phone?: InputMaybe<SortDirection>;
};

export type CandidateSymplicityEventNode = CandidateEventNode & Node & {
  end?: Maybe<DateTimeZone>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  start?: Maybe<DateTimeZone>;
};

export type CandidateUserAnalyticsInfo = {
  biographicalInfo?: Maybe<CandidateUserAnalyticsInfoBiographicalInfo>;
  /** `null` if does not have an account. */
  forwardAccount?: Maybe<CandidateUserAnalyticsInfoForwardAccount>;
  fullName?: Maybe<Scalars['String']>;
  /** A cross-environment, cross-product unique ID for FullStory. */
  fullStoryId: Scalars['ID'];
  /** @deprecated 2024-12-03 FWD-866 */
  hasTakenDiscoveryQuiz?: Maybe<Scalars['Boolean']>;
  /** `CANDIDATES.ID` */
  id: Scalars['ID'];
  loggedInEmail?: Maybe<Scalars['String']>;
  /** A cross-environment, cross-product unique account ID for Pendo. */
  pendoAccountId: Scalars['ID'];
  /** A cross-environment, cross-product unique visitor ID for Pendo. */
  pendoVisitorId: Scalars['ID'];
};

export type CandidateUserAnalyticsInfoBiographicalInfo = {
  gpa?: Maybe<Scalars['Float']>;
  /** E.g. "Spring 2023", "Fall 2024". */
  graduationDate?: Maybe<Scalars['String']>;
  /**
   * Pulls from three sources, in order of precedence:
   * 1. Forward registration,
   * 2. Qualifying question answers, "Graduation Year",
   * 3. Qualifying question answers, "Graduation Date", parsed from answer
   */
  graduationYear?: Maybe<Scalars['Int']>;
  humanReadableLawDegree?: Maybe<Scalars['String']>;
  humanReadableLawSchoolClassification?: Maybe<Scalars['String']>;
  lawDegree?: Maybe<LawDegree>;
  lawSchool?: Maybe<Scalars['String']>;
  lawSchoolClassification?: Maybe<LawSchoolClassification>;
  undergraduateMajor?: Maybe<Scalars['String']>;
};

export type CandidateUserAnalyticsInfoDiscoveryQuizAnswers = {
  demographicInfo?: Maybe<CandidateDemographicInfo>;
  officeLocations?: Maybe<Array<Maybe<OfficeLocationNode>>>;
  practiceCategories?: Maybe<Array<Maybe<PracticeCategoryNode>>>;
};

export type CandidateUserAnalyticsInfoForwardAccount = {
  activeSince?: Maybe<Scalars['DateTime']>;
  /**
   * `null` if has not taken Discovery quiz
   * @deprecated 2024-12-03 FWD-866. Replace with separate fields for demographic info and job preferences
   */
  discoveryQuizAnswers?: Maybe<CandidateUserAnalyticsInfoDiscoveryQuizAnswers>;
  /** `CANDIDATE_ACCOUNT.ID` */
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  numberOfEmails?: Maybe<Scalars['Int']>;
  primaryEmail?: Maybe<Scalars['String']>;
};

export type CandidateVirtualChatEventNode = CandidateEventNode & Node & {
  areAllTimeslotsFull: Scalars['Boolean'];
  /** Available to logged-in users. */
  assignedQualifyingQuestions?: Maybe<QualifyingQuestionEventAssignmentConnection>;
  contact?: Maybe<CandidateEventContactNode>;
  contactId: Scalars['ID'];
  /** Whether DEI information is requested on the Event. */
  deiRequested: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** Available to logged-in users. */
  documentAssignments?: Maybe<EventDocumentAssignmentConnection>;
  end?: Maybe<DateTimeZone>;
  headshotUploadRequested: Scalars['Boolean'];
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  isInviteOnly: Scalars['Boolean'];
  isPublishedToForward: Scalars['Boolean'];
  /**
   * The maximum number of Timeslots a Candidate can select during registration.
   *
   * `null` means unlimited.
   */
  maxNumTimeslotsForCandidate?: Maybe<Scalars['Int']>;
  /**
   * The different profiles that a Candidate could use for the Event.
   *
   * Can have up to one for each Recruit record the Candidate has with the Event host.
   */
  myPotentialProfiles?: Maybe<RecruitEventProfileConnection>;
  name: Scalars['String'];
  registrationEnds?: Maybe<DateTimeZone>;
  registrationLink?: Maybe<Scalars['String']>;
  /**
   * Candidate must:
   * - Be registered for the Event
   * - If the Event is invite-only, they must have been accepted
   *
   * Otherwise, returns `null`.
   */
  schedules?: Maybe<VirtualChatScheduleConnection>;
  start?: Maybe<DateTimeZone>;
  targetedSchools?: Maybe<EventTargetsSchoolConnection>;
  university?: Maybe<Scalars['String']>;
};


export type CandidateVirtualChatEventNodeAssignedQualifyingQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateVirtualChatEventNodeDocumentAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateVirtualChatEventNodeMyPotentialProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateVirtualChatEventNodeSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateVirtualChatEventNodeTargetedSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CandidateWebinarEventNode = CandidateEventNode & Node & {
  /** Available to logged-in users. */
  assignedQualifyingQuestions?: Maybe<QualifyingQuestionEventAssignmentConnection>;
  /** Whether DEI information is requested on the Event. */
  deiRequested: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  /** Available to logged-in users. */
  documentAssignments?: Maybe<EventDocumentAssignmentConnection>;
  end?: Maybe<DateTimeZone>;
  headshotUploadRequested: Scalars['Boolean'];
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  isInviteOnly: Scalars['Boolean'];
  isPublishedToForward: Scalars['Boolean'];
  /**
   * The different profiles that a Candidate could use for the Event.
   *
   * Can have up to one for each Recruit record the Candidate has with the Event host.
   */
  myPotentialProfiles?: Maybe<RecruitEventProfileConnection>;
  name: Scalars['String'];
  rawWebinarLink?: Maybe<Scalars['String']>;
  registrationEnds?: Maybe<DateTimeZone>;
  registrationLink?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
  targetedSchools?: Maybe<EventTargetsSchoolConnection>;
  university?: Maybe<Scalars['String']>;
  webinarLink?: Maybe<Scalars['Url']>;
};


export type CandidateWebinarEventNodeAssignedQualifyingQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateWebinarEventNodeDocumentAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateWebinarEventNodeMyPotentialProfilesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CandidateWebinarEventNodeTargetedSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CandidateWorkHistoryEntryConnection = Connection & {
  edges: Array<CandidateWorkHistoryEntryEdge>;
  nodes: Array<CandidateWorkHistoryEntryNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CandidateWorkHistoryEntryEdge = Edge & {
  cursor: Scalars['String'];
  node: CandidateWorkHistoryEntryNode;
};

export type CandidateWorkHistoryEntryNode = Node & {
  candidateId: Scalars['ID'];
  /** `null` if name does not match a Workplace in the core list. */
  coreWorkplace?: Maybe<WorkplaceNode>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isCurrentJob: Scalars['Boolean'];
  jobTitle: Scalars['String'];
  officeLocation?: Maybe<OfficeLocationNode>;
  officeLocationId?: Maybe<Scalars['ID']>;
  practiceAreaIds: Array<Scalars['ID']>;
  practiceAreas: PracticeAreaConnection;
  startDate: Scalars['Date'];
  workArrangement?: Maybe<WorkArrangement>;
  workplaceName: Scalars['String'];
};


export type CandidateWorkHistoryEntryNodePracticeAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CannedReportIncludedJobsInput = {
  cannedReportId?: InputMaybe<Scalars['Int']>;
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type CannedReportInput = {
  id?: InputMaybe<Scalars['Int']>;
  isSaved?: InputMaybe<Scalars['Boolean']>;
  reportTitle?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Scalars['String']>;
};

export type CannedReportNode = Node & {
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  creatorFirstName?: Maybe<Scalars['String']>;
  creatorLastName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latestActivityDate?: Maybe<Scalars['String']>;
  reportType?: Maybe<Scalars['String']>;
  saved?: Maybe<Scalars['Boolean']>;
  selectedJobs?: Maybe<Array<Maybe<CannedReportSelectedJobs>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type CannedReportSelectedJobs = {
  jobId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type CarouselEvent = {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  pinned: Scalars['Boolean'];
  ranking?: InputMaybe<Scalars['Int']>;
};

export enum ClientType {
  AnonymousUser = 'ANONYMOUS_USER',
  EmployerAdmin = 'EMPLOYER_ADMIN',
  EmployerAssociate = 'EMPLOYER_ASSOCIATE',
  EmployerMember = 'EMPLOYER_MEMBER',
  University = 'UNIVERSITY'
}

export type CoffeeChatEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  forwardEventPublishingSettings?: Maybe<ForwardEventPublishingSettings>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  registrationEnd?: Maybe<DateTimeZone>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  targetedSchools?: Maybe<EventTargetsSchoolConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type CoffeeChatEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type CoffeeChatEventNodeTargetedSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type CompleteOutreachEventCandidateRegistrationInput = {
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
};

export type CompleteOutreachEventCandidateRegistrationPayload = {
  attendeeExtension?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ConfirmAppliedToExternalJobInput = {
  jobId: Scalars['ID'];
};

export type ConfirmAppliedToExternalJobPayload = {
  jobAppId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type ConflictingJobAppsNode = {
  job: AtsJobNode;
  jobAppIds: Array<Scalars['Int']>;
  jobApps: Array<JobAppNode>;
  jobId: Scalars['Int'];
  recruitIds: Array<Scalars['Int']>;
};

/** An object describing a relationship between one Node and some class of Nodes. */
export type Connection = {
  /** An object used for cursor-based pagination. */
  pageInfo?: Maybe<PageInfo>;
  /** The total number of Edges in this Connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type ConversionReportConnection = Connection & {
  edges: Array<ConversionReportEdge>;
  nodes: Array<ReportCandidateNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ConversionReportDataTable = Node & {
  id: Scalars['ID'];
  lawSchoolValues?: Maybe<Array<Maybe<LawSchoolValue>>>;
  sourceValues?: Maybe<Array<Maybe<SourceValue>>>;
};

export type ConversionReportEdge = Edge & {
  cursor: Scalars['String'];
  node: ReportCandidateNode;
};

export type ConversionReportFilterBy = {
  appSource?: InputMaybe<FilterByString>;
  email?: InputMaybe<FilterByString>;
  firstName?: InputMaybe<FilterByString>;
  jobId?: InputMaybe<FilterByString>;
  lastName?: InputMaybe<FilterByString>;
  lawSchool?: InputMaybe<FilterByString>;
  title?: InputMaybe<FilterByString>;
};

export type ConversionReportLink = {
  count?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
};

export type ConversionReportVisual = {
  differingPipelineBuckets?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  offerAcceptedYieldRate?: Maybe<Scalars['Float']>;
  offerRejectedYieldRate?: Maybe<Scalars['Float']>;
  reportTitle?: Maybe<Scalars['String']>;
  sankey?: Maybe<Array<Maybe<SankeyStageNodeConversionReport>>>;
  selectedJobs?: Maybe<Array<Maybe<SelectedJobNode>>>;
  totalCandidates?: Maybe<Scalars['Int']>;
};

export enum CorePipelineBucketName {
  Applied = 'APPLIED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Hired = 'HIRED',
  Interviewing = 'INTERVIEWING',
  Offer = 'OFFER',
  Rejected = 'REJECTED',
  Screening = 'SCREENING',
  Withdrew = 'WITHDREW'
}

export type CreateEmployerMemberInput = {
  bioLink?: InputMaybe<Scalars['Url']>;
  email: Scalars['Email'];
  firstName: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  lawSchool?: InputMaybe<Scalars['String']>;
  officeLocationName?: InputMaybe<Scalars['String']>;
  practiceAreaName?: InputMaybe<Scalars['String']>;
  /** Only necessary if the Member's Org uses SSO. Only applies to admin members. */
  ssoLogin?: InputMaybe<CreateSsoOrgMemberLoginInput>;
  workArrangement?: InputMaybe<WorkArrangement>;
};

export type CreateEmployerMemberPayload = CreateEmployerMemberSuccess | EmailTakenWarning | SsoUserIdTakenWarning;

export type CreateEmployerMemberSuccess = {
  member?: Maybe<CreatedEmployerMember>;
};

export type CreateSsoOrgMemberLoginInput = {
  loginType: SsoOrgMemberLoginType;
  /** Only necessary if the member is using SSO rather than MFA to log in. */
  ssoUserId?: InputMaybe<Scalars['String']>;
};

export type CreateTagInput = {
  label: Scalars['String'];
};

export type CreateTagPayload = {
  tag?: Maybe<TagNode>;
};

export type CreateUniversityMemberInput = {
  email: Scalars['Email'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  /** Only necessary if the Member's Org uses SSO. Only applies to admin members. */
  ssoLogin?: InputMaybe<CreateSsoOrgMemberLoginInput>;
};

export type CreateUniversityMemberPayload = CreateUniversityMemberSuccess | EmailTakenWarning | SsoUserIdTakenWarning;

export type CreateUniversityMemberSuccess = {
  member?: Maybe<CreatedUniversityMember>;
};

export type CreatedEmployerMember = {
  id: Scalars['ID'];
};

export type CreatedUniversityMember = {
  id: Scalars['ID'];
};

export type CsvProblem = {
  rowIndex: Scalars['Int'];
  userMessage: Scalars['String'];
};

export type CustomBreak = {
  breakLengthMinutes: Scalars['Int'];
  breakPosition: Scalars['Int'];
  startTime: Scalars['LocalTime'];
};

export type CustomDocumentInput = {
  /** mimics v1 / currently v1 will pass the type in */
  documentType: CustomDocumentType;
  /** documentUrl: `null` to remove document. */
  documentUrl?: InputMaybe<Scalars['String']>;
  orgDocId: Scalars['ID'];
};

export enum CustomDocumentType {
  CustomDocument = 'CUSTOM_DOCUMENT',
  Resume = 'RESUME',
  Transcript = 'TRANSCRIPT'
}

export type CustomEvaluation = {
  email?: InputMaybe<EmailInput>;
  emailEnabled?: InputMaybe<Scalars['Boolean']>;
  evaluationName: Scalars['String'];
  evaluationType: Scalars['String'];
  feedbackReminderEmailTemplateId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  questions?: InputMaybe<Array<InputMaybe<AddEvaluationQuestionInput>>>;
};

export type CustomEvaluationResponseNode = Node & {
  answers?: Maybe<Array<Maybe<ProgramCustomEvaluationResponseAnswerNode>>>;
  associateRecruitId: Scalars['ID'];
  attorneyUserId?: Maybe<Scalars['ID']>;
  customProgramEvaluationId: Scalars['ID'];
  id: Scalars['ID'];
  isComplete: Scalars['Boolean'];
  programId: Scalars['ID'];
  requestedAt: Scalars['String'];
  submittedAt?: Maybe<Scalars['String']>;
};

export type DateTimeZone = {
  date: Scalars['Date'];
  time: Scalars['LocalTime'];
  zone: FloTimezone;
};

export type DateTimeZoneInput = {
  date: Scalars['Date'];
  time: Scalars['LocalTime'];
  zone: FloTimezone;
};

export type DeleteMemberInput = {
  id: Scalars['ID'];
};

export type DeleteMemberPayload = {
  member?: Maybe<DeletedMember>;
};

export type DeleteProgramGroupInput = {
  id: Scalars['ID'];
};

export type DeleteProgramGroupPayload = {
  deletedGroupId: Scalars['ID'];
};

export type DeleteTagInput = {
  id: Scalars['ID'];
};

export type DeleteTagPayload = {
  deletedTag?: Maybe<DeletedTagNode>;
};

export type DeletedMember = {
  id: Scalars['ID'];
};

export type DeletedTagNode = {
  id: Scalars['ID'];
  isCustom: Scalars['Boolean'];
  label: Scalars['String'];
};

export type DirectoryEvent = {
  eventId: Scalars['ID'];
  featured: Scalars['Boolean'];
  id: Scalars['ID'];
};

/** Certain Questions require distinct input methods for answering them. */
export enum DistinguishedQualifyingQuestionType {
  /** A semester single-select drop-down and a numeric year input. */
  GraduationDate = 'GRADUATION_DATE',
  /** A single-select dropdown pulling from our static list of law schools. */
  LawSchool = 'LAW_SCHOOL'
}

/** Degree types for which we want special behavior. */
export enum DistinguishedSchoolDegreeType {
  JurisDoctor = 'JURIS_DOCTOR',
  MasterOfLaws = 'MASTER_OF_LAWS'
}

export type DocumentNode = Node & {
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  documentFileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  userFileName?: Maybe<Scalars['String']>;
};

export enum DocumentRequirementEnum {
  NotNeeded = 'NOT_NEEDED',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

/** An object describing a relationship between two particular Nodes. */
export type Edge = {
  cursor?: Maybe<Scalars['String']>;
};

export type EditEmployerMemberAuthInfoInput = {
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  /** Only required if the Org uses SSO, and if the Member is becoming an admin. */
  ssoAuthInfo?: InputMaybe<EditEmployerMemberAuthInfoInputSsoAuthInfo>;
};

export type EditEmployerMemberAuthInfoInputSsoAuthInfo = {
  loginType: SsoOrgMemberLoginType;
  /** Only used if the SSO Org uses non-email SSO IDs. In that case, this field is required. */
  ssoUserId?: InputMaybe<Scalars['String']>;
};

export type EditEmployerMemberAuthInfoPayload = EditEmployerMemberAuthInfoSuccess | SsoUserIdTakenWarning;

export type EditEmployerMemberAuthInfoSuccess = {
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type EditEmployerMemberInfoInput = {
  bioLink?: InputMaybe<Scalars['Url']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  lawSchool?: InputMaybe<Scalars['String']>;
  officeLocationName?: InputMaybe<Scalars['String']>;
  practiceAreaName?: InputMaybe<Scalars['String']>;
  workArrangement?: InputMaybe<WorkArrangement>;
};

export type EditEmployerMemberInfoPayload = {
  member?: Maybe<EditedEmployerMember>;
};

export type EditForwardProfileAboutBioInput = {
  bio: Scalars['String'];
};

export type EditForwardProfileAboutBioPayload = {
  success: Scalars['Boolean'];
};

export type EditForwardProfileInput = {
  firstName: Scalars['String'];
  /**
   * Not all law schools have GPAs (e.g. Yale), and 1Ls aren't required to submit GPAs.
   * @deprecated FWD-944: No longer use after release Forward Education History
   */
  gpa?: InputMaybe<Scalars['Float']>;
  /** @deprecated FWD-944: No longer use after release Forward Education History */
  graduationDate?: InputMaybe<Scalars['Date']>;
  lastName: Scalars['String'];
  /** @deprecated FWD-944: No longer use after release Forward Education History */
  lawDegree?: InputMaybe<LawDegree>;
  /**
   * Required depending on the law degree and graduation date.
   * @deprecated FWD-944: No longer use after release Forward Education History
   */
  lawSchoolClassification?: InputMaybe<LawSchoolClassification>;
  /** @deprecated FWD-944: No longer use after release Forward Education History */
  lawSchoolId?: InputMaybe<Scalars['ID']>;
  linkedInUrl?: InputMaybe<Scalars['Url']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type EditForwardProfilePayload = {
  success: Scalars['Boolean'];
};

export type EditForwardProfilePhotoInput = {
  file: Scalars['String'];
};

export type EditForwardProfilePhotoPayload = {
  successful?: Maybe<Scalars['Boolean']>;
};

export type EditTagInput = {
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type EditTagPayload = {
  tag?: Maybe<TagNode>;
};

export type EditUniversityMemberInfoInput = {
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type EditUniversityMemberInfoPayload = {
  member?: Maybe<EditedUniversityMember>;
};

export type EditedEmployerMember = {
  id: Scalars['ID'];
};

export type EditedForwardProfileInformation = {
  id: Scalars['ID'];
};

export type EditedUniversityMember = {
  id: Scalars['ID'];
};

export type EmailAutomationGraph = {
  bccEmail?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  emailAutomationTemplateId?: Maybe<Scalars['Int']>;
  fromEmail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobPipelineStepId?: Maybe<Scalars['Int']>;
  markedForDeletion?: Maybe<Scalars['Boolean']>;
  replyToEmail?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  timeDelay?: Maybe<Scalars['Int']>;
};

export type EmailAutomationNode = Node & {
  bccEmail?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  ccEmail?: Maybe<Scalars['String']>;
  fromEmail?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobPipelineStepId?: Maybe<Scalars['Int']>;
  markedForDeletion?: Maybe<Scalars['Boolean']>;
  replyToEmail?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  timeDelay?: Maybe<Scalars['String']>;
};

export type EmailForm = Node & {
  bccEmail?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  ccEmail?: Maybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  id: Scalars['ID'];
  replyToEmail?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type EmailInput = {
  bccEmail?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  ccEmail?: InputMaybe<Scalars['String']>;
  fromEmail: Scalars['String'];
  replyToEmail?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type EmailTakenWarning = UserWarning & {
  email: Scalars['Email'];
  userMessage: Scalars['String'];
};

export type EmployeeIdentificationInfoUpdateInput = {
  employeeId: Scalars['ID'];
  employersEmployeeId?: InputMaybe<Scalars['String']>;
};

export type EmployeeIdentityUpdateInput = {
  employeeId: Scalars['ID'];
  employeeIdentificationInfoUpdate?: InputMaybe<EmployeeIdentificationInfoUpdateInput>;
  employeeNameUpdate?: InputMaybe<EmployeeNameUpdateInput>;
};

export type EmployeeLanguagesUpdateInput = {
  employeeId: Scalars['ID'];
  languageIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type EmployeeLinkedRecruitsUpdateInput = {
  associatedRecruitIds?: InputMaybe<Array<Scalars['Int']>>;
  employeeId: Scalars['ID'];
};

export type EmployeeNameUpdateInput = {
  employeeId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type EmployeeWorkContactInfoUpdateInput = {
  employeeId: Scalars['ID'];
  workContactPhoneUpdate?: InputMaybe<EmployeeWorkContactPhoneUpdateInput>;
  workLocationUpdate?: InputMaybe<EmployeeWorkContactLocationUpdateInput>;
};

export type EmployeeWorkContactLocationUpdateInput = {
  employeeId: Scalars['ID'];
  locationDescription?: InputMaybe<Scalars['String']>;
};

export type EmployeeWorkContactPhoneUpdateInput = {
  employeeId: Scalars['ID'];
  phoneExtension?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type EmployerEventNode = {
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
};

export enum EmployerMatchReviewPeriod {
  PostFinalSchedule = 'POST_FINAL_SCHEDULE',
  PreReview = 'PRE_REVIEW'
}

export type EmployerMemberDetails = {
  bioLink?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lawSchool?: Maybe<LawSchoolNode>;
  officeLocation?: Maybe<OfficeLocationNode>;
  practiceArea?: Maybe<PracticeAreaNode>;
  workArrangement?: Maybe<WorkArrangement>;
};

/** An Employer Org. */
export type EmployerOrgNode = Node & OrgNode & {
  activeInternalFieldQuestions: Array<InternalFieldQuestionNode>;
  availableTags?: Maybe<OrgAvailableTagConnection>;
  candidatePhotoManagementSettings?: Maybe<OrgCandidatePhotoManagementSettingsNode>;
  color?: Maybe<Scalars['String']>;
  emailDomain?: Maybe<Scalars['String']>;
  evaluationQuestionTemplates?: Maybe<Array<Maybe<EvaluationQuestionTemplateNode>>>;
  evaluationQuestions?: Maybe<OrgFeedbackConnection>;
  hasAts?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isGovernmentContractor?: Maybe<Scalars['Boolean']>;
  isMfaEnabled: Scalars['Boolean'];
  jobs: Array<JobGraph>;
  logoUrl?: Maybe<Scalars['String']>;
  members?: Maybe<OrgMemberConnection>;
  name?: Maybe<Scalars['String']>;
  officeLocations?: Maybe<OrgOfficeLocationConnection>;
  orgForwardPrivileges?: Maybe<OrgForwardPrivilegesNode>;
  organizingEvents?: Maybe<OrgOrganizesEventConnection>;
  requestsDNI?: Maybe<Scalars['Boolean']>;
  /** `null` if the Org does not use SSO. */
  ssoAuthInfo?: Maybe<OrgSsoAuthInfoNode>;
  ssoType: SsoType;
  timezonePlan?: Maybe<TimezonePlan>;
  urlFriendlyName?: Maybe<Scalars['String']>;
};


/** An Employer Org. */
export type EmployerOrgNodeAvailableTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** An Employer Org. */
export type EmployerOrgNodeEvaluationQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** An Employer Org. */
export type EmployerOrgNodeMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** An Employer Org. */
export type EmployerOrgNodeOfficeLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<OfficeLocationFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};


/** An Employer Org. */
export type EmployerOrgNodeOrganizingEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<EventFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};

export type EmployerRegistrationDates = {
  registrationDeadline?: Maybe<DateTimeZone>;
  registrationStartDate?: Maybe<DateTimeZone>;
};

export type EmployerRegistrationDatesInput = {
  registrationDeadline: DateTimeZoneInput;
  registrationStartDate: DateTimeZoneInput;
};

export type EvaluationQuestionInput = {
  commentsEnabled?: InputMaybe<Scalars['Boolean']>;
  evaluationType: EvaluationType;
  highLabel?: InputMaybe<Scalars['String']>;
  highScale?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
  lowLabel?: InputMaybe<Scalars['String']>;
  lowScale?: InputMaybe<Scalars['Int']>;
  selectOptions?: InputMaybe<Array<Scalars['String']>>;
  subtext?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FeedbackQuestionType>;
};

export type EvaluationQuestionNode = Node & {
  commentsEnabled?: Maybe<Scalars['Boolean']>;
  evaluationType?: Maybe<EvaluationType>;
  highLabel?: Maybe<Scalars['String']>;
  highScale?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  lowLabel?: Maybe<Scalars['String']>;
  lowScale?: Maybe<Scalars['Int']>;
  selectOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtext?: Maybe<Scalars['String']>;
  type?: Maybe<FeedbackQuestionType>;
};

export type EvaluationQuestionTemplateInput = {
  evaluationType: EvaluationType;
  id?: InputMaybe<Scalars['ID']>;
  questions?: InputMaybe<Array<InputMaybe<EvaluationTemplateQuestionInput>>>;
  title: Scalars['String'];
};

export type EvaluationQuestionTemplateNode = Node & {
  createdAt?: Maybe<Scalars['DateTime']>;
  evaluationType?: Maybe<EvaluationType>;
  id: Scalars['ID'];
  questions?: Maybe<Array<Maybe<EvaluationTemplateQuestionNode>>>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EvaluationResponse = {
  programEvaluationResponses?: Maybe<Array<Maybe<CustomEvaluationResponseNode>>>;
  projectEvaluationResponses?: Maybe<Array<Maybe<ProjectEvaluationResponseNode>>>;
};

export enum EvaluationSortEnum {
  ByEvaluator = 'BY_EVALUATOR',
  ByQuestion = 'BY_QUESTION'
}

export type EvaluationTemplateQuestionInput = {
  isRequired: Scalars['Boolean'];
  questionId: Scalars['Int'];
};

export type EvaluationTemplateQuestionNode = Node & {
  commentsEnabled?: Maybe<Scalars['Boolean']>;
  evaluationType?: Maybe<EvaluationType>;
  highLabel?: Maybe<Scalars['String']>;
  highScale?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  lowLabel?: Maybe<Scalars['String']>;
  lowScale?: Maybe<Scalars['Int']>;
  selectOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtext?: Maybe<Scalars['String']>;
  type?: Maybe<FeedbackQuestionType>;
};

export enum EvaluationType {
  Event = 'EVENT',
  WorkAllocation = 'WORK_ALLOCATION'
}

export type EventConnection = Connection & {
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  nodes?: Maybe<Array<Maybe<EventNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EventDirectoryConnection = Connection & {
  edges: Array<EventDirectoryEdge>;
  nodes: Array<CandidateEventNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EventDirectoryEdge = Edge & {
  cursor: Scalars['String'];
  metadata: EventDirectoryEdgeMetadata;
  node: CandidateEventNode;
};

export type EventDirectoryEdgeMetadata = {
  eventDirectoryId: Scalars['ID'];
  isFeatured: Scalars['Boolean'];
  rotation: Scalars['Float'];
};

export type EventDirectoryFilterBy = {
  firmId?: InputMaybe<IdFilterBy>;
  /** Full text search on firm name, event name, description */
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type EventDirectorySortBy = {
  endDate?: InputMaybe<SortDirection>;
  featured?: InputMaybe<SortDirection>;
  firmName?: InputMaybe<SortDirection>;
  registrationClose?: InputMaybe<SortDirection>;
  rotation?: InputMaybe<SortDirection>;
  start?: InputMaybe<SortDirection>;
};

export type EventDocumentAssignmentConnection = Connection & {
  edges: Array<EventDocumentAssignmentEdge>;
  nodes: Array<EventDocumentAssignmentNode>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EventDocumentAssignmentEdge = Edge & {
  cursor: Scalars['String'];
  node: EventDocumentAssignmentNode;
};

export type EventDocumentAssignmentNode = Node & {
  assignedDocument?: Maybe<OrgCustomDocumentNode>;
  documentType: CustomDocumentType;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  orgDocId: Scalars['ID'];
  orgId: Scalars['ID'];
  uploadRequestType: EventDocumentUploadRequestType;
};

export enum EventDocumentUploadRequestType {
  /** Always request the Document from the Candidate. */
  Always = 'ALWAYS',
  /** Request the Document from the Candidate if they have not already uploaded it in the past. */
  IfNotExists = 'IF_NOT_EXISTS',
  /** Never request the Document from the Candidate. */
  Never = 'NEVER',
  /**
   * Upload type not specified.
   *
   * As of this writing, if the admin adds a Document to an Event and does not specify the type, then even though the radio input is over "Always", `UNDEFINED` gets stored instead.
   */
  Undefined = 'UNDEFINED'
}

export type EventEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<EventNode>;
};

export type EventEvaluationQuestionNode = {
  eventId: Scalars['Int'];
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  label: Scalars['String'];
  orgFeedbackId: Scalars['Int'];
  sortOrder: Scalars['Int'];
};

export type EventFilterBy = {
  end?: InputMaybe<FilterByDateTime>;
  start?: InputMaybe<FilterByDateTime>;
};

export type EventNode = {
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
};


export type EventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type EventPublishingSettings = {
  carouselEventShown: Scalars['Boolean'];
  directoryEventShown: Scalars['Boolean'];
  eventId: Scalars['ID'];
};

export type EventTagConnection = Connection & {
  edges?: Maybe<Array<Maybe<EventTagEdge>>>;
  nodes?: Maybe<Array<Maybe<TagNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EventTagEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TagNode>;
};

export type EventTargetsSchoolConnection = Connection & {
  edges: Array<EventTargetsSchoolEdge>;
  /** TODO: Update to be more generic `SchoolNode` */
  nodes: Array<LawSchoolNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type EventTargetsSchoolEdge = Edge & {
  cursor: Scalars['String'];
  /** TODO: Update to be more generic `SchoolNode` */
  node: LawSchoolNode;
};

export enum EventType {
  CallbackInterviews = 'CALLBACK_INTERVIEWS',
  FirmSideLottery = 'FIRM_SIDE_LOTTERY',
  FirmSideUniversityInviteEmployer = 'FIRM_SIDE_UNIVERSITY_INVITE_EMPLOYER',
  FirmSideUniversityNetworkingUploadSchedules = 'FIRM_SIDE_UNIVERSITY_NETWORKING_UPLOAD_SCHEDULES',
  FirmSideUniversityOci = 'FIRM_SIDE_UNIVERSITY_OCI',
  InterviewSchedulingEmployer = 'INTERVIEW_SCHEDULING_EMPLOYER',
  InterviewSchedulingUniversity = 'INTERVIEW_SCHEDULING_UNIVERSITY',
  Physical = 'PHYSICAL',
  Serendipitous = 'SERENDIPITOUS',
  UniversityInviteEmployer = 'UNIVERSITY_INVITE_EMPLOYER',
  UniversityLottery = 'UNIVERSITY_LOTTERY',
  UniversityNetworkingUploadSchedules = 'UNIVERSITY_NETWORKING_UPLOAD_SCHEDULES',
  UniversityOci = 'UNIVERSITY_OCI',
  VirtualChats = 'VIRTUAL_CHATS',
  Webinar = 'WEBINAR'
}

export type ExternalJobApplicationNode = JobApplicationNode & Node & {
  id: Scalars['ID'];
  /** Currently, always `true` for external job applications. */
  isComplete?: Maybe<Scalars['Boolean']>;
  job?: Maybe<ExternalJobNode>;
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
  recruitId: Scalars['ID'];
  /** Job detail page in Forward. */
  sourceLink?: Maybe<Scalars['Url']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
};

export type ExternalJobImportBatchConnection = Connection & {
  edges: Array<ExternalJobImportBatchEdge>;
  nodes: Array<ExternalJobImportBatchNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ExternalJobImportBatchEdge = Edge & {
  cursor: Scalars['String'];
  node: ExternalJobImportBatchNode;
};

export type ExternalJobImportBatchNode = Node & {
  id: Scalars['ID'];
  importDate: Scalars['DateTime'];
  imports: ExternalJobImportConnection;
  processedJobsRatio: ProcessedJobsRatio;
  source: Scalars['String'];
};


export type ExternalJobImportBatchNodeImportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type ExternalJobImportConnection = Connection & {
  edges: Array<ExternalJobImportEdge>;
  nodes: Array<ExternalJobImportNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ExternalJobImportEdge = Edge & {
  cursor: Scalars['String'];
  node: ExternalJobImportNode;
};

export type ExternalJobImportNode = Node & {
  applicationUrl?: Maybe<Scalars['String']>;
  applicationsCloseDate?: Maybe<Scalars['String']>;
  applicationsOpenDate?: Maybe<Scalars['String']>;
  batchId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  firmName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['ID']>;
  jobTitle?: Maybe<Scalars['String']>;
  officeLocations?: Maybe<Scalars['String']>;
  processingStatus: ExternalJobImportProcessingStatus;
  programLength?: Maybe<Scalars['String']>;
  requiredDocuments?: Maybe<Scalars['String']>;
  salary?: Maybe<Scalars['String']>;
};

export enum ExternalJobImportProcessingStatus {
  Complete = 'COMPLETE',
  DoNotSubmit = 'DO_NOT_SUBMIT',
  NotStarted = 'NOT_STARTED'
}

export type ExternalJobNode = JobNode & Node & {
  closeDate?: Maybe<DateTimeZone>;
  description?: Maybe<Scalars['String']>;
  descriptionTextContent?: Maybe<Scalars['String']>;
  employer?: Maybe<PublicOrgInfo>;
  hasJobBoardAudienceSet: Scalars['Boolean'];
  id: Scalars['ID'];
  is1L: Scalars['Boolean'];
  is2L: Scalars['Boolean'];
  offices?: Maybe<JobOfficeConnection>;
  openDate?: Maybe<DateTimeZone>;
  orgId: Scalars['ID'];
  practiceCategories?: Maybe<PracticeCategoryConnection>;
  programLength?: Maybe<JobProgramLength>;
  requiredDocuments?: Maybe<Array<Maybe<CandidateDocument>>>;
  salaryInfo?: Maybe<JobSalaryInfo>;
  /** The external page for the job. */
  sourceLink?: Maybe<Scalars['Url']>;
  title?: Maybe<Scalars['String']>;
};


export type ExternalJobNodeDescriptionTextContentArgs = {
  numChars?: InputMaybe<Scalars['Int']>;
};


export type ExternalJobNodeOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type ExternalJobNodePracticeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type FeatureFlagNode = Node & {
  enabledOrgIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  on?: Maybe<Scalars['Boolean']>;
  orgEnabled?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type FeeAgreementNode = Node & {
  agencyId?: Maybe<Scalars['Int']>;
  documentUrl?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  feePercentage?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  officeLocations?: Maybe<Array<Maybe<OfficeLocationNode>>>;
  startDate?: Maybe<Scalars['Date']>;
};

export enum FeedbackQuestionType {
  Freetext = 'FREETEXT',
  Multiselect = 'MULTISELECT',
  Rating = 'RATING',
  Singleselect = 'SINGLESELECT',
  Yesno = 'YESNO'
}

export type FilterByDateTime = {
  greaterThan?: InputMaybe<Scalars['DateTime']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']>;
  lessThan?: InputMaybe<Scalars['DateTime']>;
  lessThanOrEqual?: InputMaybe<Scalars['DateTime']>;
};

export type FilterByString = {
  contains?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
};

export type FirmCarouselEventConnection = Connection & {
  edges: Array<FirmCarouselEventEdge>;
  nodes: Array<CandidateEventNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FirmCarouselEventEdge = Edge & {
  cursor: Scalars['String'];
  metadata: FirmCarouselEventEdgeMetadata;
  node: CandidateEventNode;
};

export type FirmCarouselEventEdgeMetadata = {
  carouselEventId: Scalars['ID'];
  isPinned: Scalars['Boolean'];
  ranking?: Maybe<Scalars['Int']>;
};

export type FirmDirectoryFilterBy = {
  firmName?: InputMaybe<FilterByString>;
  forwardTierIn?: InputMaybe<Array<ForwardTier>>;
  hasForwardTier?: InputMaybe<Scalars['Boolean']>;
  hasPublicFirmProfile?: InputMaybe<Scalars['Boolean']>;
  /** Firm has offices at these locations. */
  officeLocationId?: InputMaybe<IdFilterBy>;
  /** Firm has jobs with these practice categories. */
  practiceCategoryId?: InputMaybe<IdFilterBy>;
};

export type FirmDirectorySortBy = {
  carouselRotation?: InputMaybe<SortDirection>;
  directoryRotation?: InputMaybe<SortDirection>;
  firmName?: InputMaybe<SortDirection>;
  /** If firm does not have a Forward tier, has order of 0. */
  forwardTier?: InputMaybe<SortDirection>;
  /** Spotlight tier -> 1, otherwise -> 0. */
  isSpotlightTier?: InputMaybe<SortDirection>;
};

export enum FirmForwardRotationAction {
  RecordAttempt = 'RECORD_ATTEMPT',
  Rotate = 'ROTATE'
}

export enum FirmForwardRotationInitiator {
  Manual = 'MANUAL',
  Scheduled = 'SCHEDULED'
}

export type FirmForwardRotationLogActionTypeInput = {
  action: FirmForwardRotationAction;
  initiator: FirmForwardRotationInitiator;
  rotationType: FirmForwardRotationType;
};

export enum FirmForwardRotationResult {
  Failure = 'FAILURE',
  Success = 'SUCCESS'
}

export enum FirmForwardRotationType {
  Carousel = 'CAROUSEL',
  Directory = 'DIRECTORY',
  EventDirectory = 'EVENT_DIRECTORY',
  JobBoard = 'JOB_BOARD'
}

export type FirmProfileCustomLink = {
  display: Scalars['String'];
  url: Scalars['Url'];
};

export type FirmProfileCustomSectionLearnMoreLink = {
  /** May be `null` if, for example, the firm didn't specify it. For public-facing, use some human-friendly text like "Learn more on Firm Website". */
  display?: Maybe<Scalars['String']>;
  url: Scalars['Url'];
};

export type FirmProfileCustomSectionNode = Node & {
  /** `null` if no response. */
  answer?: Maybe<Scalars['String']>;
  coverImageSrc?: Maybe<Scalars['Url']>;
  firmProfileId: Scalars['ID'];
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: Maybe<FirmProfileCustomSectionLearnMoreLink>;
  moreAboutLifeAt?: Maybe<Scalars['String']>;
  orgId: Scalars['ID'];
  richMediaSubsection?: Maybe<RichMediaSubsection>;
  title?: Maybe<Scalars['String']>;
};

export type FirmProfileDiversityAndInclusionSectionNode = Node & {
  additionalStatisticsAsOf?: Maybe<Scalars['DateTime']>;
  /** `null` if no response. */
  answer?: Maybe<Scalars['String']>;
  ethnicityStatisticsAsOf?: Maybe<Scalars['DateTime']>;
  firmProfileId: Scalars['ID'];
  genderStatisticsAsOf?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: Maybe<Scalars['Url']>;
  orgId: Scalars['ID'];
  richMediaSubsection?: Maybe<RichMediaSubsection>;
  statistics?: Maybe<FirmProfileDiversityStatistics>;
};

export type FirmProfileDiversityStatisticNode = Node & {
  firmProfileId: Scalars['ID'];
  id: Scalars['ID'];
  numAssociates?: Maybe<Scalars['Int']>;
  numCounsels?: Maybe<Scalars['Int']>;
  /** Currently not being shown on frontend. */
  numNonEquityPartners?: Maybe<Scalars['Int']>;
  numPartners?: Maybe<Scalars['Int']>;
  numSummerAssociates?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  selfIdDefault: SelfIdDefaultNode;
  selfIdDefaultId: Scalars['ID'];
  selfIdDefaultOption: SelfIdDefaultOptionNode;
  selfIdDefaultOptionId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirmProfileDiversityStatistics = {
  additional: Array<FirmProfileDiversityStatisticNode>;
  gender: Array<FirmProfileDiversityStatisticNode>;
  raceOrEthnicity: Array<FirmProfileDiversityStatisticNode>;
};

export type FirmProfileEventCarouselSectionNode = Node & {
  firmCarouselEvents?: Maybe<FirmCarouselEventConnection>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  orgId: Scalars['ID'];
};


export type FirmProfileEventCarouselSectionNodeFirmCarouselEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type FirmProfileNode = Node & {
  bannerImageSrc?: Maybe<Scalars['Url']>;
  bio?: Maybe<Scalars['String']>;
  bioTextContent?: Maybe<Scalars['String']>;
  customLink?: Maybe<FirmProfileCustomLink>;
  /** `null` if the section is disabled and the user is not an admin. */
  customSection?: Maybe<FirmProfileCustomSectionNode>;
  daysInOfficeContext?: Maybe<Scalars['String']>;
  daysInOfficePerWeek?: Maybe<Scalars['Float']>;
  /** `null` if the section is disabled and the user is not an admin. */
  diversityAndInclusionSection?: Maybe<FirmProfileDiversityAndInclusionSectionNode>;
  eventCarousel?: Maybe<FirmProfileEventCarouselSectionNode>;
  firm: PublicOrgInfo;
  id: Scalars['ID'];
  isPublic: Scalars['Boolean'];
  numAssociates?: Maybe<Scalars['Int']>;
  numCounsels?: Maybe<Scalars['Int']>;
  numPartners?: Maybe<Scalars['Int']>;
  numPartnershipTiers?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  /** `null` if the section is disabled and the user is not an admin. */
  practiceAreaSection?: Maybe<FirmProfilePracticeAreaSectionNode>;
  /** `null` if the section is disabled and the user is not an admin. */
  proBonoSection?: Maybe<FirmProfileProBonoSectionNode>;
  profitsPerPartnerDollars?: Maybe<Scalars['String']>;
  revenueDollars?: Maybe<Scalars['String']>;
  socialMediaLinks?: Maybe<FirmProfileSocialMediaLinks>;
  /** `null` if the section is disabled and the user is not an admin. */
  summerProgramSection?: Maybe<FirmProfileSummerProgramSectionNode>;
  websiteLinkUrl?: Maybe<Scalars['Url']>;
};


export type FirmProfileNodeBioTextContentArgs = {
  numChars?: InputMaybe<Scalars['Int']>;
};

export type FirmProfilePracticeAreaSectionNode = Node & {
  /** `null` if no response. */
  answer?: Maybe<Scalars['String']>;
  firmProfileId: Scalars['ID'];
  headcounts: Array<PracticeAreaAttorneyHeadcount>;
  headcountsAsOf?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: Maybe<Scalars['Url']>;
  orgId: Scalars['ID'];
  richMediaSubsection?: Maybe<RichMediaSubsection>;
};

export enum FirmProfileProBonoAreProBonoHoursBillableOption {
  No = 'NO',
  Other = 'OTHER',
  Yes = 'YES'
}

export enum FirmProfileProBonoHaveOpportunitiesForSummersOption {
  No = 'NO',
  Other = 'OTHER',
  Yes = 'YES'
}

export type FirmProfileProBonoSectionAverageHours = {
  associate?: Maybe<Scalars['Int']>;
  otherLawyers?: Maybe<Scalars['Int']>;
  partner?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirmProfileProBonoSectionNode = Node & {
  /** `null` if no response. Currently answers the question "How do your pro bono initiatives help associates to grow into their practice at your firm?". */
  answer?: Maybe<Scalars['String']>;
  /** `null` if no response. Currently answers the question "How is pro bono work assigned or distributed?". */
  answer2?: Maybe<Scalars['String']>;
  areProBonoHoursBillable?: Maybe<FirmProfileProBonoAreProBonoHoursBillableOption>;
  averageHours?: Maybe<FirmProfileProBonoSectionAverageHours>;
  averageHoursAsOf?: Maybe<Scalars['DateTime']>;
  /** E.g. why hours aren't billable, specifying there's no maximum, etc. */
  billableHoursContext?: Maybe<Scalars['String']>;
  firmProfileId: Scalars['ID'];
  haveOpportunitiesForSummersOption?: Maybe<FirmProfileProBonoHaveOpportunitiesForSummersOption>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: Maybe<Scalars['Url']>;
  numBillableProBonoHours?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  participationPercentage?: Maybe<FirmProfileProBonoSectionParticipationPercentage>;
  participationPercentagesAsOf?: Maybe<Scalars['DateTime']>;
  richMediaSubsection?: Maybe<RichMediaSubsection>;
};

export type FirmProfileProBonoSectionParticipationPercentage = {
  associate?: Maybe<Scalars['Float']>;
  otherLawyers?: Maybe<Scalars['Float']>;
  partner?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FirmProfileRichMediaData = {
  mediaLink?: Maybe<Scalars['Url']>;
  mediaLinkText?: Maybe<Scalars['String']>;
  mediaThumbnailLink?: Maybe<Scalars['Url']>;
  mediaTitle?: Maybe<Scalars['String']>;
};

export type FirmProfileRichMediaNode = Node & {
  firmProfileId: Scalars['ID'];
  firmProfileRichMediaData?: Maybe<FirmProfileRichMediaData>;
  firmProfileRichMediaType?: Maybe<FirmProfileRichMediaType>;
  firmProfileSection: FirmProfileSection;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
};

export enum FirmProfileRichMediaType {
  Article = 'ARTICLE',
  Video = 'VIDEO'
}

export enum FirmProfileSection {
  Custom = 'CUSTOM',
  DiversityAndInclusion = 'DIVERSITY_AND_INCLUSION',
  PracticeArea = 'PRACTICE_AREA',
  ProBono = 'PRO_BONO',
  SummerProgram = 'SUMMER_PROGRAM'
}

export type FirmProfileSocialMediaLinks = {
  facebookUrl?: Maybe<Scalars['Url']>;
  instagramUrl?: Maybe<Scalars['Url']>;
  linkedInUrl?: Maybe<Scalars['Url']>;
  twitterUrl?: Maybe<Scalars['Url']>;
  youtubeUrl?: Maybe<Scalars['Url']>;
};

export enum FirmProfileSummerProgramAssignedPracticeAreasOption {
  CaseByCase = 'CASE_BY_CASE',
  No = 'NO',
  Other = 'OTHER',
  RotationalProgram = 'ROTATIONAL_PROGRAM',
  VariesByOffice = 'VARIES_BY_OFFICE',
  Yes = 'YES'
}

export type FirmProfileSummerProgramContactConnection = Connection & {
  edges: Array<FirmProfileSummerProgramContactEdge>;
  nodes: Array<FirmProfileSummerProgramContactNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FirmProfileSummerProgramContactEdge = Edge & {
  cursor: Scalars['String'];
  node: FirmProfileSummerProgramContactNode;
};

export type FirmProfileSummerProgramContactInput = {
  email?: InputMaybe<Scalars['Email']>;
  /**
   * `null` if creating a new contact. Updates the contact with this ID if one exists at the firm, otherwise creates a new one.
   *
   * In other words, if a contact with ID `73` belongs to firm A, but the section is being submitted for firm B, providing an ID of `73` will still create a new contact.
   */
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  orgOfficeId?: InputMaybe<Scalars['ID']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FirmProfileSummerProgramContactNode = Node & {
  email?: Maybe<Scalars['Email']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  orgId: Scalars['ID'];
  orgOfficeId: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  title?: Maybe<Scalars['String']>;
};

export enum FirmProfileSummerProgramEarlyInterviewAvailableOption {
  No = 'NO',
  Other = 'OTHER',
  Yes = 'YES'
}

export enum FirmProfileSummerProgramFirstYearHiredIntoPracticeAreaOption {
  CaseByCase = 'CASE_BY_CASE',
  No = 'NO',
  Other = 'OTHER',
  RotationalProgram = 'ROTATIONAL_PROGRAM',
  VariesByOffice = 'VARIES_BY_OFFICE',
  Yes = 'YES'
}

export enum FirmProfileSummerProgramHowIsWorkAssignedOption {
  CaseByCase = 'CASE_BY_CASE',
  FreeMarketSystem = 'FREE_MARKET_SYSTEM',
  Other = 'OTHER',
  Rotation = 'ROTATION',
  VariesByOffice = 'VARIES_BY_OFFICE'
}

export type FirmProfileSummerProgramLength = {
  unit: FirmProfileSummerProgramProgramLengthUnit;
  value: Scalars['Int'];
};

export type FirmProfileSummerProgramLengthInput = {
  unit: FirmProfileSummerProgramProgramLengthUnit;
  value: Scalars['Int'];
};

export type FirmProfileSummerProgramPrimaryContact = {
  email?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type FirmProfileSummerProgramPrimaryContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export enum FirmProfileSummerProgramProgramLengthUnit {
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type FirmProfileSummerProgramSectionNode = Node & {
  answer?: Maybe<Scalars['String']>;
  assignedPracticeAreasOption?: Maybe<FirmProfileSummerProgramAssignedPracticeAreasOption>;
  contacts: FirmProfileSummerProgramContactConnection;
  earlyInterviewAvailableOption?: Maybe<FirmProfileSummerProgramEarlyInterviewAvailableOption>;
  firmProfileId: Scalars['ID'];
  firstYearHiredIntoPracticeAreaOption?: Maybe<FirmProfileSummerProgramFirstYearHiredIntoPracticeAreaOption>;
  /** Whether the firm has has summer by practice data and wants us to input it. */
  hasSummerByPracticeDataToInput: Scalars['Boolean'];
  howIsWorkAssignedContext?: Maybe<Scalars['String']>;
  howIsWorkAssignedOption?: Maybe<FirmProfileSummerProgramHowIsWorkAssignedOption>;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: Maybe<Scalars['Url']>;
  noResponse?: Maybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
  /** @deprecated Use 'contacts' instead. */
  primaryContact?: Maybe<FirmProfileSummerProgramPrimaryContact>;
  programLength?: Maybe<FirmProfileSummerProgramLength>;
  resumeAcceptanceDeadline1L?: Maybe<Scalars['Date']>;
  resumeAcceptanceDeadline2L?: Maybe<Scalars['Date']>;
  resumeAcceptanceText1L?: Maybe<Scalars['String']>;
  resumeAcceptanceText2L?: Maybe<Scalars['String']>;
  richMediaSubsection?: Maybe<RichMediaSubsection>;
  /** Context for the "Summer by Practice" chart section. */
  summerByPracticeContext?: Maybe<Scalars['String']>;
  summerCount1L?: Maybe<Scalars['Int']>;
  summerCount2L?: Maybe<Scalars['Int']>;
  summerCountsAsOf?: Maybe<Scalars['DateTime']>;
  summerPracticeAreaByOfficeAsOf?: Maybe<Scalars['DateTime']>;
  summerSalary?: Maybe<SummerSalary>;
  summerTopOfficeLocations?: Maybe<Array<SummerTopOfficeLocationAssociateCount>>;
  summerTopOfficeLocationsAsOf?: Maybe<Scalars['DateTime']>;
  summerTopPracticeAreas?: Maybe<Array<SummerTopPracticeAreaAssociateCount>>;
  summerTopPracticeAreasAsOf?: Maybe<Scalars['DateTime']>;
};


export type FirmProfileSummerProgramSectionNodeContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export enum FirmProfileSummerProgramSummerSalaryLengthUnit {
  BiWeekly = 'BI_WEEKLY',
  Months = 'MONTHS',
  SemiMonthly = 'SEMI_MONTHLY',
  Weeks = 'WEEKS',
  Yearly = 'YEARLY'
}

export type FirmProfileSummerSalaryInput = {
  unit: FirmProfileSummerProgramSummerSalaryLengthUnit;
  value: Scalars['Int'];
};

export type FirmSummerPracticeAreaOfficeConnection = Connection & {
  edges: Array<FirmSummerPracticeAreaOfficeEdge>;
  nodes: Array<OrgOfficeNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FirmSummerPracticeAreaOfficeEdge = Edge & {
  cursor: Scalars['String'];
  node: OrgOfficeNode;
};

export enum FloTimezone {
  AmericaChicago = 'AMERICA_CHICAGO',
  AmericaDenver = 'AMERICA_DENVER',
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AsiaHongKong = 'ASIA_HONG_KONG',
  AsiaTokyo = 'ASIA_TOKYO',
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  AustraliaBrokenhill = 'AUSTRALIA_BROKENHILL',
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  AustraliaHobart = 'AUSTRALIA_HOBART',
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  AustraliaLordhowe = 'AUSTRALIA_LORDHOWE',
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  AustraliaPerth = 'AUSTRALIA_PERTH',
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  EuropeLondon = 'EUROPE_LONDON'
}

export type ForwardAccountEmailNode = Node & {
  email: Scalars['Email'];
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
};

export type ForwardAccountNode = ActiveForwardAccountNode | InactiveForwardAccountNode;

export type ForwardEventPublishingSettings = {
  carouselEventShown: Scalars['Boolean'];
  directoryEventShown: Scalars['Boolean'];
  eventId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export enum ForwardEventRegistrationSource {
  EventDetailPage = 'EVENT_DETAIL_PAGE',
  EventDirectory = 'EVENT_DIRECTORY',
  FirmProfileEventCarousel = 'FIRM_PROFILE_EVENT_CAROUSEL'
}

export enum ForwardEventsInterviewsFeedCategory {
  All = 'ALL',
  Completed = 'COMPLETED',
  Events = 'EVENTS',
  Interviews = 'INTERVIEWS'
}

export type ForwardEventsInterviewsFeedConnection = Connection & {
  edges: Array<ForwardEventsInterviewsFeedEdge>;
  nodes: Array<ForwardEventsInterviewsFeedNode>;
  /** An object used for cursor-based pagination. */
  pageInfo: PageInfo;
  progress: ForwardEventsInterviewsFeedProgress;
  /** The total number of Edges in this Connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type ForwardEventsInterviewsFeedEdge = ForwardEventsInterviewsFeedEventEdge | ForwardEventsInterviewsFeedTimeslotEdge;

export type ForwardEventsInterviewsFeedEventEdge = Edge & {
  cursor: Scalars['String'];
  node: ForwardEventsInterviewsFeedEventNode;
};

export type ForwardEventsInterviewsFeedEventNode = CandidatePhysicalEventNode | CandidatePreselectEventNode | CandidateSerendipitousEventNode | CandidateWebinarEventNode | LotteryStudentEventNode;

export type ForwardEventsInterviewsFeedFilterBy = {
  category?: InputMaybe<ForwardEventsInterviewsFeedCategory>;
  eventName?: InputMaybe<FilterByString>;
  orgName?: InputMaybe<FilterByString>;
};

export type ForwardEventsInterviewsFeedNode = CandidatePhysicalEventNode | CandidatePreselectEventNode | CandidateSerendipitousEventNode | CandidateWebinarEventNode | InPersonTimeslotNode | LotteryStudentEventNode | VirtualTimeslotNode;

export type ForwardEventsInterviewsFeedProgress = {
  numCompletedEvents: Scalars['Int'];
  numCompletedInterviews: Scalars['Int'];
  numTotalEvents: Scalars['Int'];
  numTotalInterviews: Scalars['Int'];
};

export type ForwardEventsInterviewsFeedTimeslotEdge = Edge & {
  cursor: Scalars['String'];
  metadata: ForwardEventsInterviewsFeedTimeslotEdgeMetadata;
  node: TimeslotNode;
};

export type ForwardEventsInterviewsFeedTimeslotEdgeMetadata = {
  eventId: Scalars['ID'];
  eventName?: Maybe<Scalars['String']>;
  eventType: EventType;
  hostSchoolLogo?: Maybe<Scalars['String']>;
  hostSchoolName?: Maybe<Scalars['String']>;
  isPublishedToForward?: Maybe<Scalars['Boolean']>;
};

export type ForwardJobApplicationFeedConnection = Connection & {
  edges: Array<ForwardJobApplicationFeedEdge>;
  nodes: Array<JobApplicationNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ForwardJobApplicationFeedEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<JobApplicationNode>;
};

export type ForwardJobApplicationFeedFilterBy = {
  /** Not currently in use */
  jobTitle?: InputMaybe<FilterByString>;
  jobTypeIn?: InputMaybe<Array<ForwardJobApplicationFeedJobType>>;
  /** Not currently in use */
  officeLocationName?: InputMaybe<FilterByString>;
  orgName?: InputMaybe<FilterByString>;
  /** Not currently in use */
  practiceAreaName?: InputMaybe<FilterByString>;
  /** Not currently in use */
  status?: InputMaybe<ForwardJobApplicationFilterByStatus>;
};

export enum ForwardJobApplicationFeedJobType {
  Ats = 'ATS',
  External = 'EXTERNAL',
  InterviewScheduling = 'INTERVIEW_SCHEDULING'
}

export type ForwardJobApplicationFeedSortBy = {
  closeDate?: InputMaybe<SortDirection>;
  dateApplied?: InputMaybe<SortDirection>;
};

export type ForwardJobApplicationFilterByStatus = {
  corePipelineBucket?: InputMaybe<Array<InputMaybe<CorePipelineBucketName>>>;
  interviewSchedulingEmployerInvitationStatus?: InputMaybe<Array<InputMaybe<InterviewSchedulingEmployerInvitationStatus>>>;
  interviewSchedulingJobApplicationStatus?: InputMaybe<Array<InputMaybe<InterviewSchedulingJobApplicationStatus>>>;
  interviewSchedulingStudentInvitationResponseStatus?: InputMaybe<Array<InputMaybe<InterviewSchedulingStudentInvitationResponseStatus>>>;
};

export type ForwardJobBookmarkConnection = Connection & {
  edges: Array<ForwardJobBookmarkEdge>;
  nodes: Array<ForwardJobBookmarkNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ForwardJobBookmarkEdge = Edge & {
  cursor: Scalars['String'];
  node: ForwardJobBookmarkNode;
};

export type ForwardJobBookmarkFeedFilterBy = {
  isJobOpen?: InputMaybe<BooleanFilterBy>;
};

export type ForwardJobBookmarkNode = Node & {
  id: Scalars['ID'];
  job?: Maybe<JobNode>;
  jobId: Scalars['ID'];
};

export type ForwardJobFeedFilterBy = {
  hasCloseDate?: InputMaybe<Scalars['Boolean']>;
  hasJobBoardAudienceSet?: InputMaybe<BooleanFilterBy>;
  is1L?: InputMaybe<BooleanFilterBy>;
  is2L?: InputMaybe<BooleanFilterBy>;
  /** A job without a close date is considered non-expired. */
  isExpired?: InputMaybe<Scalars['Boolean']>;
  isOpen?: InputMaybe<Scalars['Boolean']>;
  jobTypeIn?: InputMaybe<Array<ForwardJobFeedFilterByJobType>>;
  officeLocationId?: InputMaybe<IdFilterBy>;
  practiceCategoryId?: InputMaybe<IdFilterBy>;
  /** Full text search on job title, firm name, and job description. */
  searchTerm?: InputMaybe<Scalars['String']>;
};

export enum ForwardJobFeedFilterByJobType {
  Ats = 'ATS',
  ManualEntry = 'MANUAL_ENTRY'
}

export type ForwardJobPreferences = {
  officeLocationIds?: Maybe<Array<Scalars['ID']>>;
  practiceCategoryIds?: Maybe<Array<Scalars['ID']>>;
};

export type ForwardProfileAnswers = {
  /** E.g. "Spring 2023", "Fall 2024". */
  graduationDate?: Maybe<Scalars['String']>;
  graduationYear?: Maybe<Scalars['Int']>;
  humanReadableLawSchoolClassification?: Maybe<Scalars['String']>;
  lawSchool?: Maybe<Scalars['String']>;
  lawSchoolClassification?: Maybe<LawSchoolClassification>;
  undergraduateMajor?: Maybe<Scalars['String']>;
};

export type ForwardProfileNode = Node & {
  answers?: Maybe<ForwardProfileAnswers>;
  bio?: Maybe<Scalars['String']>;
  /** TODO: Dedicated aggregate type for education history if we need it in the future. */
  educationHistoryEntries: CandidateEducationHistoryEntryConnection;
  firstName?: Maybe<Scalars['String']>;
  /** `CANDIDATES.ID` */
  id: Scalars['ID'];
  /** @deprecated Use ActiveForwardAccountNode instead */
  jobPreferences?: Maybe<ForwardJobPreferences>;
  lastName?: Maybe<Scalars['String']>;
  lawDegree?: Maybe<CandidateLawDegreeNode>;
  linkedInUrl?: Maybe<Scalars['Url']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  profilePhotoUrl?: Maybe<Scalars['String']>;
  rawLinkedInUrl?: Maybe<Scalars['String']>;
  rawPhoneNumber?: Maybe<Scalars['String']>;
  workHistoryEntries: CandidateWorkHistoryEntryConnection;
};


export type ForwardProfileNodeEducationHistoryEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type ForwardProfileNodeWorkHistoryEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export enum ForwardTier {
  Premium = 'PREMIUM',
  Spotlight = 'SPOTLIGHT',
  Standard = 'STANDARD'
}

export type ForwardTierConnection = Connection & {
  edges: Array<ForwardTierEdge>;
  nodes: Array<ForwardTierNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ForwardTierEdge = Edge & {
  cursor: Scalars['String'];
  node: ForwardTierNode;
};

export type ForwardTierNode = Node & {
  asEnum: ForwardTier;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Client should not rely on a particular value (e.g. 3 vs. 4), but they will be able to use this for sorting purposes (e.g. "Premium" comes after "Standard"). */
  order: Scalars['Int'];
};

export type GenerateCandidateInput = {
  email: Scalars['Email'];
  eventIds?: InputMaybe<Array<Scalars['Int']>>;
  firstName: Scalars['String'];
  internalFieldQuestionIds?: InputMaybe<Array<Scalars['Int']>>;
  jobIds?: InputMaybe<Array<Scalars['Int']>>;
  lastName: Scalars['String'];
  linkedIn?: InputMaybe<Scalars['String']>;
  numberOfAdminNotes?: InputMaybe<Scalars['Int']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type GeneratedCandidate = {
  email: Scalars['Email'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  linkedIn?: Maybe<Scalars['String']>;
  orgFriendlyName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
};

/** Used for answering the Graduation Date Qualifying Question. */
export enum GraduationDateSemester {
  Fall = 'FALL',
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Winter = 'WINTER'
}

export type HistoricalCandidateDataNode = {
  id?: Maybe<Scalars['ID']>;
  rows?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HistoricalCandidateNode = {
  documents?: Maybe<Array<Maybe<Scalars['Int']>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastName?: Maybe<Scalars['String']>;
  recruitId?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type IdFilterBy = {
  equals?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
};

export type InPersonTimeslotNode = Node & TimeslotNode & {
  end?: Maybe<DateTimeZone>;
  hostEventId: Scalars['ID'];
  id: Scalars['ID'];
  interviewerOrg?: Maybe<PublicOrgInfo>;
  interviewerOrgId: Scalars['ID'];
  /** `null` if not available to show. */
  interviewers?: Maybe<Array<Maybe<Interviewer>>>;
  location?: Maybe<Scalars['String']>;
  rawVideoLink?: Maybe<Scalars['String']>;
  roomNumber?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
  videoLink?: Maybe<Scalars['Url']>;
};

export type InactiveForwardAccountNode = Node & {
  candidateId: Scalars['ID'];
  id: Scalars['ID'];
  loggedInEmail: Scalars['Email'];
};

export type IncrementTimesViewedForwardEventsInterviewsFeedPayload = {
  successful: Scalars['Boolean'];
};

export type InitialRunCannedReportInput = {
  jobIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  reportType?: InputMaybe<Scalars['String']>;
};

export type InternalFieldAnswerNode = {
  hasAnswer: Scalars['Boolean'];
  question: InternalFieldQuestionNode;
  questionId: Scalars['Int'];
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InternalFieldQuestionNode = {
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isDefaultQuestion?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Maybe<Scalars['String']>>>;
  order?: Maybe<Scalars['Int']>;
  showOnJobApplication?: Maybe<Scalars['Boolean']>;
  showOnProfile?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type: QuestionType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InterviewSchedulingAvailableJobConnection = Connection & {
  edges?: Maybe<Array<Maybe<InterviewSchedulingAvailableJobEdge>>>;
  nodes?: Maybe<Array<Maybe<InterviewSchedulingAvailableJobNode>>>;
  /** An object used for cursor-based pagination. */
  pageInfo?: Maybe<PageInfo>;
  /** The total number of Edges in this Connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type InterviewSchedulingAvailableJobEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<InterviewSchedulingAvailableJobNode>;
};

export type InterviewSchedulingAvailableJobNode = Node & {
  description?: Maybe<Scalars['String']>;
  employer?: Maybe<PublicOrgInfo>;
  employerAllowsMultipleApplicants?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  numberOfAvailableTimeSlots?: Maybe<Scalars['Int']>;
  offices?: Maybe<JobOfficeConnection>;
  orgId: Scalars['ID'];
  practiceAreas?: Maybe<PracticeAreaConnection>;
  supportingDocuments?: Maybe<Array<Maybe<InterviewSchedulingSupportingDocumentNode>>>;
  title?: Maybe<Scalars['String']>;
  universityEventId?: Maybe<Scalars['ID']>;
};


export type InterviewSchedulingAvailableJobNodeOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type InterviewSchedulingAvailableJobNodePracticeAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type InterviewSchedulingAvailableTimeSlotNode = Node & {
  endTime?: Maybe<DateTimeZone>;
  id: Scalars['ID'];
  scheduleId: Scalars['ID'];
  startTime?: Maybe<DateTimeZone>;
};

export enum InterviewSchedulingBlockBreakOptionEnum {
  After_1 = 'AFTER_1',
  After_2 = 'AFTER_2',
  After_3 = 'AFTER_3',
  BetweenEvery = 'BETWEEN_EVERY',
  BetweenEveryOther = 'BETWEEN_EVERY_OTHER',
  None = 'NONE'
}

export enum InterviewSchedulingCustomQuestionType {
  Date = 'DATE',
  FreeText = 'FREE_TEXT',
  MultiSelect = 'MULTI_SELECT',
  Numerical = 'NUMERICAL',
  SingleSelect = 'SINGLE_SELECT'
}

export type InterviewSchedulingEmployerEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
};


export type InterviewSchedulingEmployerEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export enum InterviewSchedulingEmployerInvitationStatus {
  Alternate = 'ALTERNATE',
  Invited = 'INVITED',
  NotInvited = 'NOT_INVITED',
  NoResponse = 'NO_RESPONSE'
}

export type InterviewSchedulingEventAttendeeNode = {
  employerEventId: Scalars['ID'];
  employerOrgId: Scalars['ID'];
  employerOrgName: Scalars['String'];
  numberOfJobsSubmitted?: Maybe<Scalars['Int']>;
  registrationContactEmail?: Maybe<Scalars['String']>;
  registrationContactFirstName?: Maybe<Scalars['String']>;
  registrationContactLastName?: Maybe<Scalars['String']>;
};

export type InterviewSchedulingEventCreationStepperStatusNode = Node & {
  emails: StepStatus;
  employerSettings: StepStatus;
  eventDetails: StepStatus;
  id: Scalars['ID'];
  timeBlocks: StepStatus;
  timeline: StepStatus;
};

export type InterviewSchedulingJobApplicationNode = JobApplicationNode & Node & {
  applicationStatus?: Maybe<InterviewSchedulingJobApplicationStatus>;
  id: Scalars['ID'];
  invitationStatus?: Maybe<InterviewSchedulingEmployerInvitationStatus>;
  isComplete?: Maybe<Scalars['Boolean']>;
  job?: Maybe<InterviewSchedulingJobNode>;
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
  recruitId: Scalars['ID'];
  /** Job detail page in interview scheduling. */
  sourceLink?: Maybe<Scalars['Url']>;
  studentResponseStatus?: Maybe<InterviewSchedulingStudentInvitationResponseStatus>;
  submittedAt?: Maybe<Scalars['DateTime']>;
};

export enum InterviewSchedulingJobApplicationStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS'
}

export type InterviewSchedulingJobNode = JobNode & Node & {
  /** TODO: Doesn't currently have a meaningful value. */
  closeDate?: Maybe<DateTimeZone>;
  description?: Maybe<Scalars['String']>;
  descriptionTextContent?: Maybe<Scalars['String']>;
  employer?: Maybe<PublicOrgInfo>;
  id: Scalars['ID'];
  /** All of the employer's offices if they did not specify an office. */
  offices?: Maybe<JobOfficeConnection>;
  /** TODO: Doesn't currently have a meaningful value. */
  openDate?: Maybe<DateTimeZone>;
  /** Refers to the employer org. */
  orgId: Scalars['ID'];
  /** All practice areas if the employer did not specify one. */
  practiceAreas?: Maybe<PracticeAreaConnection>;
  requiredDocuments?: Maybe<Array<Maybe<CandidateDocument>>>;
  scheduleId: Scalars['ID'];
  /**
   * The detail view of the job in Interview Scheduling.
   *
   * TODO: Data loader
   */
  sourceLink?: Maybe<Scalars['Url']>;
  supportingDocuments?: Maybe<Array<Maybe<InterviewSchedulingSupportingDocumentNode>>>;
  title?: Maybe<Scalars['String']>;
};


export type InterviewSchedulingJobNodeDescriptionTextContentArgs = {
  numChars?: InputMaybe<Scalars['Int']>;
};


export type InterviewSchedulingJobNodeOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type InterviewSchedulingJobNodePracticeAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type InterviewSchedulingStudentApplicationConnection = Connection & {
  edges?: Maybe<Array<Maybe<InterviewSchedulingStudentApplicationEdge>>>;
  nodes?: Maybe<Array<Maybe<InterviewSchedulingStudentApplicationNode>>>;
  /** An object used for cursor-based pagination. */
  pageInfo?: Maybe<PageInfo>;
  /** The total number of Edges in this Connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type InterviewSchedulingStudentApplicationDocumentNode = Node & {
  documentName?: Maybe<Scalars['String']>;
  /**
   * Student extension currently required to view the filename to ensure only student/university can see it.
   *
   * TODO: If we reuse this, e.g. in Forward, update to only require student extension when user is not logged in. If they are logged in, allow candidate to view the filename, based on `recruitId`, and deny others without an extension.
   */
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  link?: Maybe<Scalars['Url']>;
  recruitId: Scalars['ID'];
  uploadDate?: Maybe<Scalars['DateTime']>;
  /** TODO: Not implemented */
  visibilityOption?: Maybe<UniversityDocumentVisibilityEnum>;
  /** TODO: Not implemented */
  visibilityTime?: Maybe<DateTimeZone>;
};


export type InterviewSchedulingStudentApplicationDocumentNodeFilenameArgs = {
  auth?: InputMaybe<InterviewSchedulingStudentApplicationDocumentNodeFilenameAuth>;
};

export type InterviewSchedulingStudentApplicationDocumentNodeFilenameAuth = {
  studentExtension: Scalars['String'];
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
};

export type InterviewSchedulingStudentApplicationEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<InterviewSchedulingStudentApplicationNode>;
};

export type InterviewSchedulingStudentApplicationNode = Node & {
  /** TODO: Not implemented */
  candidateId: Scalars['ID'];
  documents?: Maybe<Array<Maybe<InterviewSchedulingStudentApplicationDocumentNode>>>;
  id: Scalars['ID'];
  /** TODO: Not implemented */
  jobInformation?: Maybe<JobInformationNode>;
  recruitId: Scalars['ID'];
  scheduleId: Scalars['ID'];
  /** TODO: Not implemented */
  studentInformation?: Maybe<StudentInformationNode>;
  /** TODO: Not implemented */
  studentResponse?: Maybe<InterviewSchedulingStudentInvitationResponseStatus>;
};

export enum InterviewSchedulingStudentInvitationResponseStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  NoResponse = 'NO_RESPONSE'
}

export type InterviewSchedulingStudentOfficeLocationPreferenceForJobNode = Node & {
  id: Scalars['ID'];
  officeLocationId: Scalars['Int'];
  recruitId: Scalars['Int'];
  scheduleId: Scalars['Int'];
  universityEventId: Scalars['Int'];
  universityOrgId: Scalars['Int'];
};

export type InterviewSchedulingStudentOfficeLocationPreferencesListForJobNode = Node & {
  id: Scalars['ID'];
  officeLocationPreferences?: Maybe<Array<Maybe<InterviewSchedulingStudentOfficeLocationPreferenceForJobNode>>>;
  recruitId: Scalars['Int'];
  scheduleId: Scalars['Int'];
  universityEventId: Scalars['Int'];
  universityOrgId: Scalars['Int'];
};

export type InterviewSchedulingStudentPracticeAreaPreferenceForJobNode = Node & {
  id: Scalars['ID'];
  practiceAreaId: Scalars['Int'];
  recruitId: Scalars['Int'];
  scheduleId: Scalars['Int'];
  universityEventId: Scalars['Int'];
  universityOrgId: Scalars['Int'];
};

export type InterviewSchedulingStudentPracticeAreaPreferencesListForJobNode = Node & {
  id: Scalars['ID'];
  practiceAreaPreferences?: Maybe<Array<Maybe<InterviewSchedulingStudentPracticeAreaPreferenceForJobNode>>>;
  recruitId: Scalars['Int'];
  scheduleId: Scalars['Int'];
  universityEventId: Scalars['Int'];
  universityOrgId: Scalars['Int'];
};

export type InterviewSchedulingStudentPreferenceForJobInput = {
  officeLocationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  practiceAreaIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  scheduleId: Scalars['Int'];
};

export type InterviewSchedulingStudentPreferencesListsInput = {
  preferences?: InputMaybe<Array<InputMaybe<InterviewSchedulingStudentPreferenceForJobInput>>>;
};

export type InterviewSchedulingSupportingDocumentNode = Node & {
  documentName: Scalars['String'];
  documentVisibilityOption: UniversityDocumentVisibilityEnum;
  documentVisibilityTime?: Maybe<DateTimeZone>;
  eventDocumentId: Scalars['ID'];
  fileLocation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  orgDocumentId: Scalars['ID'];
  uploadDate?: Maybe<DateTimeZone>;
  userFilename?: Maybe<Scalars['String']>;
};

export type InterviewSchedulingUniversityEventNode = EventNode & Node & {
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  employerDescription?: Maybe<Scalars['String']>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  start?: Maybe<DateTimeZone>;
  studentDescription?: Maybe<Scalars['String']>;
  tags?: Maybe<EventTagConnection>;
};


export type InterviewSchedulingUniversityEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type Interviewer = {
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type InvalidLawSchoolRowProblem = CsvProblem & UserWarning & {
  lawSchool: Scalars['String'];
  rowIndex: Scalars['Int'];
  userMessage: Scalars['String'];
};

export type InvalidOfficeLocationRowProblem = CsvProblem & UserWarning & {
  officeLocation: Scalars['String'];
  rowIndex: Scalars['Int'];
  userMessage: Scalars['String'];
};

export type InvalidPracticeAreaRowProblem = CsvProblem & UserWarning & {
  practiceArea: Scalars['String'];
  rowIndex: Scalars['Int'];
  userMessage: Scalars['String'];
};

export type InvalidSsoIdRowProblem = CsvProblem & UserWarning & {
  rowIndex: Scalars['Int'];
  ssoId: Scalars['String'];
  userMessage: Scalars['String'];
};

export type InvitedEmployerEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  employerRegistrationDeadline?: Maybe<DateTimeZone>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type InvitedEmployerEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type JobAppNode = Node & {
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  agencyContactId?: Maybe<Scalars['Int']>;
  appSource?: Maybe<Scalars['String']>;
  candidateNotifications?: Maybe<CandidateNotificationConnection>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creationType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalFieldAnswers?: Maybe<Array<Maybe<InternalFieldAnswerNode>>>;
  job?: Maybe<AtsJobNode>;
  jobId?: Maybe<Scalars['Int']>;
  jobPipelineStatusId?: Maybe<Scalars['Int']>;
  offerAffirmationDate?: Maybe<Scalars['String']>;
  offerDate?: Maybe<Scalars['String']>;
  offerExpirationDate?: Maybe<Scalars['String']>;
  previousOfferAffirmationDate?: Maybe<Scalars['String']>;
  previousOfferDate?: Maybe<Scalars['String']>;
  previousOfferExpirationDate?: Maybe<Scalars['String']>;
  recruitId?: Maybe<Scalars['Int']>;
  sectionResponses?: Maybe<Array<Maybe<JobAppSectionGraph>>>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<JobAppStatusNode>;
  statusUpdatedAt?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};


export type JobAppNodeCandidateNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type JobAppQuestionAnswerConnection = Connection & {
  edges?: Maybe<Array<Maybe<JobAppQuestionAnswerEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobAppQuestionAnswerEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<JobAppQuestionAnswerNode>;
};

export type JobAppQuestionAnswerNode = Node & {
  dateValue?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobAppId?: Maybe<Scalars['Int']>;
  jobAppQuestionAnswerSelections?: Maybe<JobAppQuestionAnswerSelectionConnection>;
  label?: Maybe<Scalars['String']>;
  numericValue?: Maybe<Scalars['Float']>;
  options?: Maybe<Array<Maybe<OrgQuestionOptionResponseNode>>>;
  orgQuestionId?: Maybe<Scalars['Int']>;
  questionType?: Maybe<QuestionType>;
  subText?: Maybe<Scalars['String']>;
  textValue?: Maybe<Scalars['String']>;
};

export type JobAppQuestionAnswerSelectionConnection = Connection & {
  edges?: Maybe<Array<Maybe<JobAppQuestionAnswerSelectionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobAppQuestionAnswerSelectionEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<JobAppQuestionAnswerSelectionNode>;
};

export type JobAppQuestionAnswerSelectionNode = Node & {
  id: Scalars['ID'];
  jobAppQuestionAnswerId?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  orgQuestionOptionId?: Maybe<Scalars['Int']>;
};

export type JobAppSectionGraph = {
  id?: Maybe<Scalars['Int']>;
  jobAppId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  sectionId?: Maybe<Scalars['Int']>;
  sectionName?: Maybe<Scalars['Int']>;
  sectionType?: Maybe<Scalars['String']>;
};

export type JobAppSelfIdQuestionAnswerGraph = {
  id: Scalars['ID'];
  jobAppId?: Maybe<Scalars['Int']>;
  jobAppSelfIdQuestionAnswerSelections?: Maybe<Array<Maybe<JobAppSelfIdQuestionAnswerSelectionGraph>>>;
  orgSelfIdQuestionId?: Maybe<Scalars['Int']>;
  orgSelfIdQuestionOptions?: Maybe<Array<Maybe<OrgSelfIdQuestionOptionNode>>>;
};

export type JobAppSelfIdQuestionAnswerSelectionGraph = {
  id: Scalars['ID'];
  orgSelfIdQuestionOptionId?: Maybe<Scalars['Int']>;
};

export type JobAppStatusNode = {
  corePipelineStepId?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  jobPipelineBucketId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type JobApplicationNode = {
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  job?: Maybe<JobNode>;
  jobId: Scalars['ID'];
  /** The ID of the firm of the applied-to job. */
  orgId: Scalars['ID'];
  recruitId: Scalars['ID'];
  sourceLink?: Maybe<Scalars['Url']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
};

export type JobCandidateDocumentGraph = {
  docName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  jobSectionId?: Maybe<Scalars['Int']>;
  orgDocId?: Maybe<Scalars['Int']>;
};

export type JobConnection = Connection & {
  edges: Array<JobEdge>;
  nodes: Array<JobNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobDepartmentGraph = {
  departmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  jobId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type JobEdge = Edge & {
  cursor: Scalars['String'];
  node: JobFeedNode;
};

export type JobEmploymentTypeGraph = {
  employmentType?: Maybe<Scalars['String']>;
  employmentTypeId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  jobId?: Maybe<Scalars['Int']>;
};

export type JobFeedConnection = Connection & {
  edges: Array<JobFeedEdge>;
  nodes: Array<JobFeedNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobFeedEdge = Edge & {
  cursor: Scalars['String'];
  node: JobFeedNode;
};

export type JobFeedNode = AtsJobNode | ExternalJobNode;

export type JobFeedSortBy = {
  close?: InputMaybe<SortDirection>;
  firmName?: InputMaybe<SortDirection>;
  jobBoardRotation?: InputMaybe<SortDirection>;
  open?: InputMaybe<SortDirection>;
};

export type JobFilterOptions = {
  title?: InputMaybe<Scalars['String']>;
};

export type JobGraph = {
  agencyJobAuthorizations?: Maybe<Array<Maybe<AgencyJobAuthorizationNode>>>;
  closeDate?: Maybe<Scalars['String']>;
  closeTimezone?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  departments?: Maybe<Array<Maybe<JobDepartmentGraph>>>;
  hiringLeads?: Maybe<Array<Maybe<UserNode>>>;
  id?: Maybe<Scalars['Int']>;
  incomplete?: Maybe<Scalars['Boolean']>;
  isPublic?: Maybe<Scalars['Boolean']>;
  jobEmploymentTypes?: Maybe<Array<Maybe<JobEmploymentTypeGraph>>>;
  jobOffices?: Maybe<Array<Maybe<JobOfficeGraph>>>;
  jobPipelineId?: Maybe<Scalars['Int']>;
  jobSchema?: Maybe<Array<Maybe<JobSectionGraph>>>;
  openDate?: Maybe<Scalars['String']>;
  openTimezone?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  pipeline?: Maybe<JobPipelineGraph>;
  positionTypes?: Maybe<Array<Maybe<JobPositionTypeGraph>>>;
  processYear?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type JobInformationNode = Node & {
  employerName: Scalars['String'];
  id: Scalars['ID'];
  jobTitle: Scalars['String'];
  officeLocations: Array<Maybe<Scalars['String']>>;
  practiceAreas: Array<Maybe<Scalars['String']>>;
  scheduleId: Scalars['ID'];
};

export type JobNode = {
  /** Not every job will have a close date. */
  closeDate?: Maybe<DateTimeZone>;
  /** Rich text description of the job. For the job list query, will always be `null` since we do not cache the description. */
  description?: Maybe<Scalars['String']>;
  /** The text content of the description for this job, optionally truncated. For the job list query, will always be at most `300` characters since we cache that many characters. */
  descriptionTextContent?: Maybe<Scalars['String']>;
  employer?: Maybe<PublicOrgInfo>;
  id: Scalars['ID'];
  offices?: Maybe<JobOfficeConnection>;
  /** Every job should have an open date. */
  openDate?: Maybe<DateTimeZone>;
  orgId: Scalars['ID'];
  requiredDocuments?: Maybe<Array<Maybe<CandidateDocument>>>;
  sourceLink?: Maybe<Scalars['Url']>;
  title?: Maybe<Scalars['String']>;
};


export type JobNodeDescriptionTextContentArgs = {
  numChars?: InputMaybe<Scalars['Int']>;
};


export type JobNodeOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type JobOfficeConnection = Connection & {
  edges?: Maybe<Array<JobOfficeEdge>>;
  nodes?: Maybe<Array<OfficeLocationNode>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobOfficeEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<OfficeLocationNode>;
};

export type JobOfficeGraph = {
  id?: Maybe<Scalars['Int']>;
  jobId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  officeId?: Maybe<Scalars['Int']>;
};

export type JobPipelineBucketGraph = {
  color?: Maybe<Scalars['String']>;
  corePipelineBucketId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  jobPipelineId?: Maybe<Scalars['Int']>;
  jobPipelineStepResponses?: Maybe<Array<Maybe<JobPipelineStepGraph>>>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type JobPipelineGraph = {
  id?: Maybe<Scalars['Int']>;
  jobId?: Maybe<Scalars['Int']>;
  jobPipelineBucketResponses?: Maybe<Array<Maybe<JobPipelineBucketGraph>>>;
  pipelineTemplateId?: Maybe<Scalars['Int']>;
};

export type JobPipelineStepGraph = {
  corePipelineBucketId?: Maybe<Scalars['Int']>;
  corePipelineStepId?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  emailAutomationResponse?: Maybe<EmailAutomationGraph>;
  id: Scalars['ID'];
  jobPipelineBucketId?: Maybe<Scalars['Int']>;
  markedForDeletion?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pipelineTemplateStepId?: Maybe<Scalars['Int']>;
};

export type JobPositionTypeGraph = {
  id?: Maybe<Scalars['Int']>;
  jobId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  positionTypeId?: Maybe<Scalars['Int']>;
};

export type JobProgramLength = {
  amount: Scalars['Int'];
  timeUnit: JobProgramLengthTimeUnit;
};

export enum JobProgramLengthTimeUnit {
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type JobQuestionGraph = {
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  jobQuestionOptions?: Maybe<Array<Maybe<JobQuestionOptionGraph>>>;
  jobSectionId?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  orgQuestionId?: Maybe<Scalars['Int']>;
  questionType?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
};

export type JobQuestionNode = {
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  jobQuestionAnswers?: Maybe<JobAppQuestionAnswerConnection>;
  jobQuestionOptions?: Maybe<JobQuestionOptionConnection>;
  jobSectionId?: Maybe<Scalars['Int']>;
  /** Label, QuestionType,d and Subtext come from the OrgQuestionNode. */
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  orgQuestionId?: Maybe<Scalars['Int']>;
  questionType?: Maybe<Scalars['String']>;
  subText?: Maybe<Scalars['String']>;
};

export type JobQuestionOptionConnection = Connection & {
  edges?: Maybe<Array<Maybe<JobQuestionOptionEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type JobQuestionOptionEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<JobQuestionOptionNode>;
};

export type JobQuestionOptionGraph = {
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  jobQuestionId?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  orgQuestionOptionId?: Maybe<Scalars['Int']>;
};

export type JobQuestionOptionNode = Node & {
  id: Scalars['ID'];
  isDeleted?: Maybe<Scalars['Boolean']>;
  jobQuestionId?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  orgQuestionOptionId?: Maybe<Scalars['Int']>;
};

export type JobSalaryInfo = {
  amount: Scalars['Int'];
  timeUnit: JobSalaryInfoTimeUnit;
};

export enum JobSalaryInfoTimeUnit {
  Months = 'MONTHS',
  Weeks = 'WEEKS'
}

export type JobSectionGraph = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  jobCandidateDocuments?: Maybe<Array<Maybe<JobCandidateDocumentGraph>>>;
  jobId?: Maybe<Scalars['Int']>;
  jobQuestions?: Maybe<Array<Maybe<JobQuestionGraph>>>;
  jobSectionType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export enum JobSectionType {
  AddressInformation = 'ADDRESS_INFORMATION',
  CandidateDocuments = 'CANDIDATE_DOCUMENTS',
  CustomQuestions = 'CUSTOM_QUESTIONS',
  EducationHistory = 'EDUCATION_HISTORY',
  EeoQuestions = 'EEO_QUESTIONS',
  PersonalInfo = 'PERSONAL_INFO',
  SelfIdentification = 'SELF_IDENTIFICATION',
  WorkHistory = 'WORK_HISTORY'
}

export type LanguageNode = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum LawDegree {
  /** @deprecated Use 'DistinguishedSchoolDegreeType' instead */
  JurisDoctor = 'JURIS_DOCTOR',
  /** @deprecated Use 'DistinguishedSchoolDegreeType' instead */
  MasterOfLaws = 'MASTER_OF_LAWS'
}

export type LawDegreeConnection = Connection & {
  edges: Array<LawDegreeEdge>;
  nodes: Array<LawDegreeNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LawDegreeEdge = Edge & {
  cursor: Scalars['String'];
  node: LawDegreeNode;
};

export type LawDegreeNode = Node & {
  asEnum?: Maybe<LawDegree>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum LawSchoolClassYear {
  FirstYear = 'FIRST_YEAR',
  SecondYear = 'SECOND_YEAR',
  ThirdYear = 'THIRD_YEAR'
}

export enum LawSchoolClassification {
  /** @deprecated Use 'LawSchoolClassYear' enum instead */
  FirstYear = 'FIRST_YEAR',
  /** @deprecated Use 'LawSchoolClassYear' enum instead */
  MasterOfLaws = 'MASTER_OF_LAWS',
  /** @deprecated Use 'LawSchoolClassYear' enum instead */
  PostGraduate = 'POST_GRADUATE',
  /** @deprecated Use 'LawSchoolClassYear' enum instead */
  SecondYear = 'SECOND_YEAR',
  /** @deprecated Use 'LawSchoolClassYear' enum instead */
  ThirdYear = 'THIRD_YEAR'
}

export type LawSchoolClassificationConnection = Connection & {
  edges: Array<LawSchoolClassificationEdge>;
  nodes: Array<LawSchoolClassificationNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LawSchoolClassificationEdge = Edge & {
  cursor: Scalars['String'];
  node: LawSchoolClassificationNode;
};

export type LawSchoolClassificationNode = Node & {
  asEnum?: Maybe<LawSchoolClassification>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LawSchoolConnection = Connection & {
  edges: Array<LawSchoolEdge>;
  nodes: Array<LawSchoolNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LawSchoolEdge = Edge & {
  cursor: Scalars['String'];
  node: LawSchoolNode;
};

export type LawSchoolFilterBy = {
  name?: InputMaybe<FilterByString>;
};

export type LawSchoolNode = Node & SchoolNode & {
  emailDomains: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LawSchoolValue = {
  applied?: Maybe<ConversionReportConnection>;
  cancelled?: Maybe<ConversionReportConnection>;
  declined?: Maybe<ConversionReportConnection>;
  hired?: Maybe<ConversionReportConnection>;
  id?: Maybe<Scalars['String']>;
  interviewing?: Maybe<ConversionReportConnection>;
  lawSchoolName?: Maybe<Scalars['String']>;
  offer?: Maybe<ConversionReportConnection>;
  rejected?: Maybe<ConversionReportConnection>;
  screening?: Maybe<ConversionReportConnection>;
  withdrew?: Maybe<ConversionReportConnection>;
};


export type LawSchoolValueAppliedArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueCancelledArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueDeclinedArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueHiredArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueInterviewingArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueOfferArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueRejectedArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueScreeningArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type LawSchoolValueWithdrewArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type LotteryAvailableStudentJobsNode = Node & {
  id: Scalars['ID'];
  studentAvailableJobs?: Maybe<InterviewSchedulingAvailableJobConnection>;
  studentUnmatchedBids?: Maybe<LotteryStudentBidConnection>;
};

export enum LotteryBidListType {
  InitialBid = 'INITIAL_BID',
  OptIn = 'OPT_IN'
}

export type LotteryEmployerCustomQuestionNode = {
  eventQuestionId: Scalars['ID'];
  label: Scalars['String'];
  options?: Maybe<Array<Maybe<LotteryEmployerQuestionOptionsNode>>>;
  orgQuestionId: Scalars['ID'];
  questionType: QuestionType;
  required?: Maybe<Scalars['Boolean']>;
  subText: Scalars['String'];
};

export type LotteryEmployerEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  employerOrgName?: Maybe<Scalars['String']>;
  employerQuestionOptions?: Maybe<Array<Maybe<LotteryEmployerQuestionOptionsNode>>>;
  employerSettings?: Maybe<LotteryEmployerSettingsNode>;
  end?: Maybe<DateTimeZone>;
  eventDetails?: Maybe<LotteryEventDetailsNode>;
  eventTimeline?: Maybe<LotteryEventTimelineNode>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  preferredDateOptions?: Maybe<Array<Maybe<DateTimeZone>>>;
  recruitmentPolicy?: Maybe<Scalars['String']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  universityContact?: Maybe<UniversityContactNode>;
};


export type LotteryEmployerEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type LotteryEmployerQuestionOptionsNode = {
  isDeleted: Scalars['Boolean'];
  label: Scalars['String'];
  order: Scalars['Int'];
  orgQuestionOptionId: Scalars['Int'];
};

export type LotteryEmployerRegistrationSettingsNode = {
  allowEmployerToSelectMultipleTimeBlocks: Scalars['Boolean'];
  allowEmployersToCreateDocumentCollectJobs: Scalars['Boolean'];
  eventUniversityRecruitmentPolicyEnabled: Scalars['Boolean'];
  hasDocumentCollectJobsCreated: Scalars['Boolean'];
  multipleDatesEnabled: Scalars['Boolean'];
  numberOfDateChoices: Scalars['Int'];
  provideVideoLinkEnabled: Scalars['Boolean'];
  selectInterviewFormatEnabled: Scalars['Boolean'];
  selectPreferredInterviewLengthEnabled: Scalars['Boolean'];
  selectPreferredTimeEnabled: Scalars['Boolean'];
  studentInterviewOptionsEnabled: Scalars['Boolean'];
  supplyInterviewInformationEnabled: Scalars['Boolean'];
  supplyJobInformationEnabled: Scalars['Boolean'];
  supportingDocuments?: Maybe<Array<Maybe<InterviewSchedulingSupportingDocumentNode>>>;
};

export type LotteryEmployerSettingsNode = Node & {
  employerCustomQuestions?: Maybe<Array<Maybe<LotteryEmployerCustomQuestionNode>>>;
  id: Scalars['ID'];
  registrationSettings?: Maybe<LotteryEmployerRegistrationSettingsNode>;
};

export type LotteryEventDetailsNode = Node & {
  employerEventDescription: Scalars['String'];
  eventOrganizerUserEmail: Scalars['String'];
  eventOrganizerUserId: Scalars['ID'];
  id: Scalars['ID'];
  studentEventDescription: Scalars['String'];
};

export type LotteryEventTimeBlockNode = Node & {
  breakLengthMinutes: Scalars['Int'];
  breakOption: InterviewSchedulingBlockBreakOptionEnum;
  customBreaks?: Maybe<Array<Maybe<CustomBreak>>>;
  date: Scalars['Date'];
  endTime: Scalars['LocalTime'];
  id: Scalars['ID'];
  interviewLength: Scalars['Int'];
  numberOfInterviews: Scalars['Int'];
  startTime: Scalars['LocalTime'];
  timezone: FloTimezone;
};

export type LotteryEventTimelineInput = {
  employerRegistrationDates: EmployerRegistrationDatesInput;
  scheduleVisibility: ScheduleVisibilityInput;
  studentBidding: StudentBiddingPeriodInput;
  studentCancellation?: InputMaybe<StudentCancellationPeriodInput>;
  studentOptIn?: InputMaybe<StudentOptInPeriodInput>;
  studentSelfSchedule?: InputMaybe<StudentSelfSchedulePeriodInput>;
  universityEventId: Scalars['Int'];
};

export type LotteryEventTimelineNode = Node & {
  employerRegistrationDates: EmployerRegistrationDates;
  eventPeriods?: Maybe<LotteryEventTimelinePeriods>;
  id: Scalars['ID'];
  scheduleVisibility: ScheduleVisibility;
  studentBidding: StudentBidding;
  studentCancellation?: Maybe<StudentCancellation>;
  studentCancellationEnabled?: Maybe<Scalars['Boolean']>;
  studentOptIn?: Maybe<StudentOptIn>;
  studentOptInEnabled?: Maybe<Scalars['Boolean']>;
  studentSelfSchedule?: Maybe<StudentSelfSchedule>;
  studentSelfScheduleEnabled?: Maybe<Scalars['Boolean']>;
};

export type LotteryEventTimelinePeriods = {
  employerMatchReviewPeriod?: Maybe<EmployerMatchReviewPeriod>;
  studentBiddingPeriod?: Maybe<StudentBiddingPeriod>;
  studentCancellationPeriod?: Maybe<StudentCancellationPeriod>;
  studentFinalSchedulePeriod?: Maybe<StudentFinalSchedulePeriod>;
  studentMatchReviewPeriod?: Maybe<StudentMatchReviewPeriod>;
  studentOptInPeriod?: Maybe<StudentOptInPeriod>;
  studentSelfSchedulePeriod?: Maybe<StudentSelfSchedulePeriod>;
};

export type LotteryStudentBidConnection = Connection & {
  edges?: Maybe<Array<Maybe<LotteryStudentBidEdge>>>;
  nodes?: Maybe<Array<Maybe<LotteryStudentBidNode>>>;
  /** An object used for cursor-based pagination. */
  pageInfo?: Maybe<PageInfo>;
  /** The total number of Edges in this Connection. */
  totalCount?: Maybe<Scalars['Int']>;
};

export type LotteryStudentBidEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LotteryStudentBidNode>;
};

export type LotteryStudentBidInput = {
  ranking: Scalars['Int'];
  scheduleId: Scalars['Int'];
};

export type LotteryStudentBidListInput = {
  id?: InputMaybe<Scalars['ID']>;
  studentBids: Array<InputMaybe<LotteryStudentBidInput>>;
};

export type LotteryStudentBidListNode = Node & {
  id: Scalars['ID'];
  studentBids: Array<Maybe<LotteryStudentBidNode>>;
};

export type LotteryStudentBidNode = Node & {
  id: Scalars['ID'];
  /** TODO: Only works for single event/single org/single recruit (e.g. not for unified candidate in Forward). */
  job?: Maybe<InterviewSchedulingJobNode>;
  /** Starts at 0. */
  ranking: Scalars['Int'];
  scheduleId: Scalars['Int'];
  universityEventId: Scalars['ID'];
  universityOrgId: Scalars['ID'];
};

export type LotteryStudentEventNode = CandidateEventNode & Node & {
  end?: Maybe<DateTimeZone>;
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Data loader. Will currently not work outside of 'lotteryUniversityEventByIdForStudent'
   */
  eventDetails?: Maybe<LotteryEventDetailsNode>;
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Data loader. Will currently not work outside of 'lotteryUniversityEventByIdForStudent'
   */
  eventTimeline?: Maybe<LotteryEventTimelineNode>;
  host?: Maybe<PublicOrgInfo>;
  hostOrgId: Scalars['ID'];
  id: Scalars['ID'];
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Currently only works in query for Forward dashboard.
   */
  mySchedulePageLink?: Maybe<Scalars['Url']>;
  name: Scalars['String'];
  /**
   * Candidate must be logged in and attending the Event.
   *
   * TODO: Currently only works in query for Forward dashboard.
   */
  rawMySchedulePageLink?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
};

export type LotteryStudentMatchConnection = Connection & {
  edges?: Maybe<Array<Maybe<LotteryStudentMatchEdge>>>;
  nodes?: Maybe<Array<Maybe<LotteryStudentMatchNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LotteryStudentMatchEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<LotteryStudentMatchNode>;
};

export type LotteryStudentMatchNode = Node & {
  /**
   * Can be `null` if the university added this match without the student bidding on the schedule.
   *
   * TODO: Only works for single event/single org/single recruit (e.g. not for unified candidate in Forward).
   */
  bid?: Maybe<LotteryStudentBidNode>;
  end?: Maybe<DateTimeZone>;
  id: Scalars['ID'];
  isNewInterview?: Maybe<Scalars['Boolean']>;
  /** TODO: Only works for single event/single org/single recruit (e.g. not for unified candidate in Forward). */
  job?: Maybe<InterviewSchedulingJobNode>;
  recruitId: Scalars['ID'];
  scheduleId: Scalars['ID'];
  start?: Maybe<DateTimeZone>;
  universityEventId: Scalars['ID'];
  universityOrgId: Scalars['ID'];
};

export type LotteryUniversityEventNode = EventNode & Node & {
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  employerSettings?: Maybe<LotteryEmployerSettingsNode>;
  end?: Maybe<DateTimeZone>;
  eventDetails?: Maybe<LotteryEventDetailsNode>;
  eventSchedule?: Maybe<Array<Maybe<LotteryEventTimeBlockNode>>>;
  eventTimeline?: Maybe<LotteryEventTimelineNode>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  isDraft: Scalars['Boolean'];
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  start?: Maybe<DateTimeZone>;
  stepperStatus?: Maybe<InterviewSchedulingEventCreationStepperStatusNode>;
  tags?: Maybe<EventTagConnection>;
};


export type LotteryUniversityEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type MatterEvaluationAnswerNode = Node & {
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  freeText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  multiSelectAnswers?: Maybe<Array<Maybe<Scalars['String']>>>;
  orgFeedbackId?: Maybe<Scalars['ID']>;
  ratingAnswer?: Maybe<Scalars['Int']>;
  recruitId?: Maybe<Scalars['ID']>;
  singleSelectAnswer?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
  yesNoAnswer?: Maybe<Scalars['Int']>;
};

export type MatterEvaluationNode = Node & {
  id: Scalars['ID'];
  questions: Array<ProgramFeedbackNode>;
};

export type MatterNode = Node & {
  assignees?: Maybe<Array<Maybe<CandidateNode>>>;
  assignmentType?: Maybe<AssignmentType>;
  attorneys?: Maybe<Array<Maybe<MemberNode>>>;
  authzReasons?: Maybe<Array<WorkAllocationAuthorizationReason>>;
  clientMatterName: Scalars['String'];
  clientMatterNumber: Scalars['String'];
  clientNumber: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  deadline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<DocumentNode>>;
  evaluations?: Maybe<Array<Maybe<MatterEvaluationAnswerNode>>>;
  id: Scalars['ID'];
  matterAssociates?: Maybe<Array<Maybe<CandidateNode>>>;
  offices?: Maybe<Array<Maybe<OfficeLocationNode>>>;
  org: Scalars['ID'];
  orgPracticeAreas?: Maybe<Array<Maybe<OrgPracticeAreaNode>>>;
  practiceAreas?: Maybe<Array<Maybe<PracticeAreaNode>>>;
  programId: Scalars['ID'];
  requestedProjectEvaluations?: Maybe<Array<Maybe<ProjectEvaluationResponseNode>>>;
  /** Whether the matter has been approved or not */
  submittedStatus?: Maybe<SubmissionStatus>;
  timeToComplete?: Maybe<TimeToComplete>;
  timezone?: Maybe<Scalars['String']>;
  /** Associate work status */
  workStatus?: Maybe<MatterStatus>;
  workStatusUpdatedAt?: Maybe<Scalars['String']>;
};

export type MatterPetNode = Node & {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  matterId?: Maybe<Scalars['Int']>;
  petName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export enum MatterStatus {
  Approved = 'APPROVED',
  Assigned = 'ASSIGNED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Submitted = 'SUBMITTED'
}

export type MemberAuthInfo = {
  isMfaUser: Scalars['Boolean'];
  /** `null` if Member does not belong to an SSO Org. */
  ssoUserId?: Maybe<Scalars['String']>;
};

export type MemberConnection = Connection & {
  edges?: Maybe<Array<Maybe<MemberEdge>>>;
  nodes?: Maybe<Array<Maybe<MemberNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MemberEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberNode>;
};

export type MemberNode = Node & {
  authInfo?: Maybe<MemberAuthInfo>;
  details?: Maybe<EmployerMemberDetails>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  isAdmin: Scalars['Boolean'];
  lastName: Scalars['String'];
  ownedPrograms?: Maybe<Array<ProgramNode>>;
};

export type MemberRow = {
  bioLink?: InputMaybe<Scalars['Url']>;
  clientMemberId?: InputMaybe<Scalars['String']>;
  email: Scalars['Email'];
  firstName: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  /** Only necessary if the org uses both SSO and MFA. In that case, it only applies to admin members, and if not specified, it will default to 'null'. */
  isMfa?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  lawSchool?: InputMaybe<Scalars['String']>;
  officeLocationName?: InputMaybe<Scalars['String']>;
  practiceAreaName?: InputMaybe<Scalars['String']>;
  workArrangement?: InputMaybe<WorkArrangement>;
};

export type MembersCsvProblems = UserWarning & {
  invalidRows: Array<MembersCsvRowProblem>;
  userMessage: Scalars['String'];
};

export type MembersCsvRowProblem = InvalidLawSchoolRowProblem | InvalidOfficeLocationRowProblem | InvalidPracticeAreaRowProblem | InvalidSsoIdRowProblem | MfaValueForNonApplicableOrgRowProblem | MissingMfaValueRowProblem;

export type MentorInfo = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  memberId: Scalars['Int'];
  mentorRole: MentorRole;
};

export type MentorInput = {
  memberId: Scalars['ID'];
  mentorRole: MentorRole;
};

export enum MentorRole {
  Associate = 'ASSOCIATE',
  OfficeMate = 'OFFICE_MATE',
  Partner = 'PARTNER'
}

export type MfaValueForNonApplicableOrgRowProblem = CsvProblem & UserWarning & {
  rowIndex: Scalars['Int'];
  userMessage: Scalars['String'];
};

export type MissingMfaValueRowProblem = CsvProblem & UserWarning & {
  rowIndex: Scalars['Int'];
  userMessage: Scalars['String'];
};

export type Mutation = {
  addAssociatesToWorkAllocationMatter: Array<Maybe<Scalars['ID']>>;
  addAssociatesToWorkAllocationProgram: Array<Maybe<Scalars['ID']>>;
  addOfficeToOrg?: Maybe<AddOfficeToOrgPayload>;
  addOrgToFlag?: Maybe<Scalars['Int']>;
  archiveInternalFieldQuestion?: Maybe<Scalars['ID']>;
  assignQualifyingQuestionsToEvent: AssignQualifyingQuestionsToEventPayload;
  bulkCreateCandidateMissingInfoRequest: BulkCreateCandidateMissingInfoRequestPayload;
  cancelLotteryStudentMatch?: Maybe<CancelLotteryStudentMatchPayload>;
  completeOutreachEventCandidateRegistration: CompleteOutreachEventCandidateRegistrationPayload;
  confirmAppliedToExternalJob: ConfirmAppliedToExternalJobPayload;
  createAgency?: Maybe<Scalars['Int']>;
  createCandidateMissingInfoRequest?: Maybe<Scalars['ID']>;
  createEmployerMember?: Maybe<CreateEmployerMemberPayload>;
  createProgramAssociate: Scalars['Int'];
  createSSOConnection: Scalars['Boolean'];
  createTag: CreateTagPayload;
  createUniversityMember?: Maybe<CreateUniversityMemberPayload>;
  createWorkAllocationAssociate: Scalars['Int'];
  deleteCandidateReviewTemplate?: Maybe<Scalars['Boolean']>;
  deleteCannedReport: Scalars['Boolean'];
  deleteEvaluationQuestion?: Maybe<Scalars['Boolean']>;
  deleteEvaluationQuestionTemplate?: Maybe<Scalars['Int']>;
  deleteMatter: Scalars['Boolean'];
  deleteMatterDocuments?: Maybe<Scalars['Boolean']>;
  deleteMatterDocumentsByAssociate: Scalars['Boolean'];
  deleteMember?: Maybe<DeleteMemberPayload>;
  /** Delete a program group */
  deleteProgramGroup: DeleteProgramGroupPayload;
  deleteTag: DeleteTagPayload;
  deleteWorkAllocationProgram?: Maybe<Scalars['Boolean']>;
  deleteWorkAllocationProgramMatter?: Maybe<Scalars['Boolean']>;
  dummyField?: Maybe<Scalars['String']>;
  editAgency?: Maybe<Scalars['Int']>;
  editEmployerMemberAuthInfo?: Maybe<EditEmployerMemberAuthInfoPayload>;
  editEmployerMemberInfo?: Maybe<EditEmployerMemberInfoPayload>;
  editForwardProfile: EditForwardProfilePayload;
  editForwardProfileAboutBio: EditForwardProfileAboutBioPayload;
  editForwardProfilePhoto: EditForwardProfilePhotoPayload;
  editTag: EditTagPayload;
  editUniversityMemberInfo?: Maybe<EditUniversityMemberInfoPayload>;
  incrementTimesViewedForwardEventsInterviewsFeed: IncrementTimesViewedForwardEventsInterviewsFeedPayload;
  initialRunCannedReport: Scalars['Int'];
  mergeCandidates?: Maybe<Scalars['Boolean']>;
  mergeDuplicateAgencies?: Maybe<Scalars['Int']>;
  migrateOrgToGovernmentContractor?: Maybe<Scalars['Boolean']>;
  registerForwardUser: RegisterForwardUserPayload;
  removeAssociatesFromWorkAllocationMatter?: Maybe<Scalars['Boolean']>;
  removeAssociatesFromWorkAllocationProgram?: Maybe<Scalars['Boolean']>;
  removeCandidateEducationHistoryEntry: RemoveCandidateEducationHistoryEntryPayload;
  removeCandidateWorkHistoryEntry?: Maybe<RemoveCandidateWorkHistoryEntryPayload>;
  removeEmailFromForwardAccount: RemoveEmailFromForwardAccountPayload;
  removeOfficeFromOrg?: Maybe<RemoveOfficeFromOrgPayload>;
  removeOrgFromFlag?: Maybe<Scalars['Int']>;
  resetUserPassword: PasswordResetResultNode;
  selfAssignToMatter: Scalars['Boolean'];
  sendAddEmailToForwardAccountLink: SendAddEmailToForwardAccountLinkPayload;
  sendBulkProjectEvaluationRequestEmails: Array<Scalars['Int']>;
  sendPasswordResetEmail: Scalars['Boolean'];
  sendProgramEvaluationRequestEmailForAssociates?: Maybe<Scalars['Boolean']>;
  sendProjectEvaluationRequestEmail?: Maybe<Scalars['Boolean']>;
  submitAndMarkExternalJobImportAsCompleted?: Maybe<SubmitAndMarkExternalJobImportAsCompletedPayload>;
  submitCandidateEducationHistoryEntry: SubmitCandidateEducationHistoryEntryPayload;
  submitCandidateWorkHistoryEntry?: Maybe<SubmitCandidateWorkHistoryEntryPayload>;
  submitDemographicAnswersForOutreachEventCandidateRegistration: SubmitDemographicAnswersForOutreachEventCandidateRegistrationPayload;
  /** Submit uploaded Documents to an Employer Event using the email with which the Candidate is logged in. */
  submitDocumentsForEmployerEvent: SubmitDocumentsForEmployerEventPayload;
  submitEventSchoolTargeting: SubmitEventSchoolTargetingPayload;
  submitForwardDemographicInfo: SubmitForwardDemographicInfoPayload;
  submitForwardEventPublishingSettings: SubmitForwardEventPublishingSettingsPayload;
  submitForwardJobPreferences: SubmitForwardJobPreferencesPayload;
  submitForwardOfficeLocationPreferences?: Maybe<SubmitForwardOfficeLocationPreferencesPayload>;
  submitForwardPracticeCategoryPreferences?: Maybe<SubmitForwardPracticeCategoryPreferencesPayload>;
  submitHeadshotForOutreachEventCandidateRegistration: SubmitHeadshotForOutreachEventCandidateRegistrationPayload;
  submitLotteryEventTimeline?: Maybe<SubmitLotteryEventTimelinePayload>;
  /**
   * Adds the Candidate to the Firm's list of Candidates with their logged-in email, if not already present, so that the Candidate may:
   * 1. Answer Qualifying Questions;
   * 2. Answer Demographic Questions;
   * 3. Upload Documents;
   * 4. Submit uploaded Documents;
   * 5. Have an Extension created for them.
   * The above requires a `RECRUITS` record to be present.
   */
  submitPersonalInfoForOutreachEventCandidateRegistration: SubmitPersonalInfoForOutreachEventCandidateRegistrationPayload;
  submitQualifyingQuestionAnswersForOutreachEventCandidateRegistration: SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationPayload;
  submitStudentBids?: Maybe<SubmitStudentBidsPayload>;
  submitStudentInterviewSchedulingPreferencesForJobs?: Maybe<SubmitStudentInterviewSchedulingPreferencesPayload>;
  submitVirtualChatRecruitTimeslotSelections: SubmitVirtualChatRecruitTimeslotSelectionsPayload;
  superAdminAddDocumentToFirm: SuperAdminAddDocumentToFirmPayload;
  superAdminAddOfficeToFirm: SuperAdminAddOfficeToFirmPayload;
  superAdminAddPracticeAreaToFirm: SuperAdminAddPracticeAreaToFirmPayload;
  superAdminArchiveWorkplace: SuperAdminArchiveWorkplacePayload;
  superAdminAssignLawSchoolToUniversity: SuperAdminAssignLawSchoolToUniversityOrgPayload;
  /** Assign law school data, with a name that doesn't belong to our law school list, to an existing item in the list. For example, "Columbia Unverisity [sic] School of Law" to "Columbia University School of Law". */
  superAdminAssignOutlierLawSchoolData: SuperAdminAssignOutlierLawSchoolDataPayload;
  /** Assign office location data, with a name that doesn't belong to our office location list, to an existing item in the list. */
  superAdminAssignOutlierOfficeLocationData: SuperAdminAssignOutlierOfficeLocationDataPayload;
  /** Assign practice area data, with a name that doesn't belong to our practice area list, to an existing item in the list. */
  superAdminAssignOutlierPracticeAreaData: SuperAdminAssignOutlierPracticeAreaDataPayload;
  /** Closes jobs by setting their close date to some point in the past. Does not affect jobs that are already closed. A job with `null` close date is considered not closed. */
  superAdminCloseJobs: SuperAdminCloseJobsPayload;
  superAdminCreateInactiveFirm: SuperAdminCreateInactiveFirmPayload;
  superAdminCreateLawSchool: SuperAdminCreateLawSchoolPayload;
  superAdminCreateOfficeLocation: SuperAdminCreateOfficeLocationPayload;
  superAdminCreatePracticeArea: SuperAdminCreatePracticeAreaPayload;
  superAdminCreatePracticeCategory: SuperAdminCreatePracticeCategoryPayload;
  superAdminCreateUniversity: SuperAdminCreateUniversityPayload;
  superAdminCreateWorkplace: SuperAdminCreateWorkplacePayload;
  superAdminDeleteExternalJob?: Maybe<SuperAdminDeleteExternalJobPayload>;
  superAdminDeleteWorkplace: SuperAdminDeleteWorkplacePayload;
  superAdminEditLawSchool: SuperAdminEditLawSchoolPayload;
  superAdminEditOfficeLocation: SuperAdminEditOfficeLocationPayload;
  superAdminEditOrgEmailDomain: SuperAdminEditOrgEmailDomainPayload;
  superAdminEditPracticeArea: SuperAdminEditPracticeAreaPayload;
  superAdminEditPracticeAreaForFirm: SuperAdminEditPracticeAreaForFirmPayload;
  superAdminEditPracticeCategory: SuperAdminEditPracticeCategoryPayload;
  superAdminEditUniversity: SuperAdminEditUniversityPayload;
  superAdminEditWorkplace: SuperAdminEditWorkplacePayload;
  superAdminEnableEventCarousel: SuperAdminEnableEventCarouselPayload;
  superAdminGenerateCandidate: GeneratedCandidate;
  /** Merge the data from one existing law school into that of another. For example, suppose we have both UC Hastings and UC Law SF in the law school list, where "UC Hastings" was the former name of UC Law SF. Then we should merge UC Hastings (giver) into UC Law SF (receiver). */
  superAdminMergeLawSchool: SuperAdminMergeLawSchoolPayload;
  /** Merge the data from one existing office location into that of another. */
  superAdminMergeOfficeLocation: SuperAdminMergeOfficeLocationPayload;
  /** Merge the data from one existing practice area into that of another. */
  superAdminMergePracticeArea: SuperAdminMergePracticeAreaPayload;
  superAdminRemoveOfficeFromFirm: SuperAdminRemoveOfficeFromFirmPayload;
  superAdminRemovePracticeAreaFromFirm: SuperAdminRemovePracticeAreaFromFirmPayload;
  superAdminRotateEventDirectory: SuperAdminRotateFirmsPayload;
  superAdminRotateFirms: SuperAdminRotateFirmsPayload;
  /** Submit email domains for a given School. Currently only works for Law Schools. */
  superAdminSubmitEmailDomainsForSchool: SuperAdminSubmitEmailDomainsForSchoolPayload;
  superAdminSubmitFirmProfileCustomSection: SuperAdminSubmitFirmProfileCustomSectionPayload;
  superAdminSubmitFirmProfileDiversityAndInclusionSection: SuperAdminSubmitFirmProfileDiversityAndInclusionSectionPayload;
  superAdminSubmitFirmProfileIsPublic: SuperAdminSubmitFirmProfileIsPublicPayload;
  superAdminSubmitFirmProfileMain: SuperAdminSubmitFirmProfileMainPayload;
  superAdminSubmitFirmProfilePracticeAreaSection: SuperAdminSubmitFirmProfilePracticeAreaSectionPayload;
  superAdminSubmitFirmProfileProBonoSection: SuperAdminSubmitFirmProfileProBonoSectionPayload;
  superAdminSubmitFirmProfileSummerProgramSection: SuperAdminSubmitFirmProfileSummerProgramSectionPayload;
  superAdminSubmitForwardEventPublishingSettings: SuperAdminSubmitForwardEventPublishingSettingsPayload;
  superAdminSubmitJobBoardAudience: SuperAdminSubmitJobBoardAudiencePayload;
  superAdminSubmitJobForFirm: SuperAdminSubmitJobForFirmPayload;
  superAdminToggleOrgSSO: Scalars['Boolean'];
  superAdminUpdateEventCarouselRankings: SuperAdminUpdateEventCarouselRankingsPayload;
  superAdminUpdateForwardTier: SuperAdminUpdateForwardTierPayload;
  superAdminUpdateOrgFeaturedEvents: SuperAdminUpdateOrgFeaturedEventsPayload;
  superAdminUpdateOrgForwardPrivileges: SuperAdminUpdateOrgForwardPrivilegesPayload;
  superAdminUpdateOrgOfficeRankings: SuperAdminUpdateOrgOfficeRankingPayload;
  superAdminUpdateOrgSSO: SuperAdminUpdateOrgSsoPayload;
  test?: Maybe<TestPayload>;
  toggleExternalJobImportDoNotSubmitStatus?: Maybe<ToggleExternalJobImportDoNotSubmitStatusPayload>;
  toggleFlag?: Maybe<Scalars['Int']>;
  toggleJobBookmark: ToggleJobBookmarkPayload;
  trackActivateForwardAccountFromEvent?: Maybe<TrackActivateForwardAccountFromEventPayload>;
  trackApplyToExternalJob?: Maybe<TrackApplyToExternalJobPayload>;
  trackForwardEventCompleteRegistration?: Maybe<TrackForwardEventCompleteRegistrationPayload>;
  trackForwardEventStartRegistration?: Maybe<TrackForwardEventStartRegistrationPayload>;
  trackGoToExternalJobPage?: Maybe<TrackGoToExternalJobPagePayload>;
  trackQuickApplyToJob?: Maybe<TrackQuickApplyToJobPayload>;
  unarchiveInternalFieldQuestion?: Maybe<Scalars['ID']>;
  updateAgencyRegistrationStatus?: Maybe<Scalars['Boolean']>;
  updateCandidateMissingInfoRequestJobEmailTemplate?: Maybe<Scalars['ID']>;
  updateFlagUrl?: Maybe<Scalars['Int']>;
  updateInternalFieldsOrder?: Maybe<Array<Maybe<Scalars['Int']>>>;
  updateJobAppOfferDetails?: Maybe<JobAppNode>;
  updateMatterPet?: Maybe<Scalars['ID']>;
  updateMatterSubmissionStatus?: Maybe<Scalars['Boolean']>;
  updateMatterWorkStatus?: Maybe<Scalars['Boolean']>;
  updateMatterWorkStatusByAssociate?: Maybe<Scalars['Boolean']>;
  updateOrgCandidatePhotoManagementSettings?: Maybe<Scalars['Boolean']>;
  updateProgramAssociate: ProgramAssociate;
  updateProgramAssociatePracticeAreas: ProgramAssociate;
  /** Update a program group's associate list */
  updateProgramGroupAssociates: UpdateProgramGroupAssociatesPayload;
  /** Update a program group's member list */
  updateProgramGroupMembers: UpdateProgramGroupMembersPayload;
  updateWorkAllocationProgramContributors: UpdateProgramContributorsPayload;
  uploadMatterDocument: Scalars['Int'];
  /** @deprecated Use uploadMatterDocument instead */
  uploadMatterDocumentByAssociate: Scalars['Int'];
  /** This mutation is not currently accessible to Orgs who use non-email SSO IDs. */
  uploadMembersCsv?: Maybe<UploadMembersCsvPayload>;
  upsertCandidateBasicInformation?: Maybe<Scalars['Boolean']>;
  upsertCandidateDocuments?: Maybe<Scalars['Boolean']>;
  upsertCandidateInternalFieldAnswers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  upsertCandidateProfile?: Maybe<Scalars['Boolean']>;
  /** profileImageUrl: `null` to remove headshot. */
  upsertCandidateProfileImage?: Maybe<Scalars['Boolean']>;
  upsertCandidateQualifyingQuestionAnswers?: Maybe<Scalars['Boolean']>;
  upsertCandidateReviewTemplate: Scalars['Int'];
  upsertCandidateReviewTemplateCandidateVotingRecord?: Maybe<Scalars['Boolean']>;
  upsertCandidateReviewTemplateCandidates: Scalars['Boolean'];
  upsertCandidateReviewTemplateEvents: Scalars['Boolean'];
  upsertCandidateReviewTemplateJobs: Scalars['Boolean'];
  upsertCandidateReviewTemplateJobsWithEvents: Scalars['Boolean'];
  upsertCandidateReviewTemplatePrograms: Scalars['Boolean'];
  upsertCandidateReviewTemplateSections?: Maybe<Scalars['Boolean']>;
  upsertCandidateReviewVotingRecordCastedVoted?: Maybe<Scalars['Boolean']>;
  upsertCandidateReviewVotingRecordComment?: Maybe<Scalars['Boolean']>;
  upsertCannedReport: Scalars['Int'];
  upsertCannedReportIncludedJobs: Scalars['Boolean'];
  upsertEvaluationQuestion: Scalars['ID'];
  upsertEvaluationQuestionTemplate?: Maybe<Scalars['Int']>;
  upsertIndividualProgramEvaluationResponse?: Maybe<Scalars['Boolean']>;
  upsertInternalFieldQuestion?: Maybe<Scalars['ID']>;
  upsertJobAppInternalFieldAnswers?: Maybe<Scalars['ID']>;
  upsertMatterAssociateEvaluation?: Maybe<Scalars['Boolean']>;
  /**
   * Create a new group or update an existing group's name.
   * If id is provided, updates the name of that group.
   * If id is not provided, creates a new group in the specified program.
   */
  upsertProgramGroup: UpsertProgramGroupPayload;
  upsertWorkAllocationCustomProgramEvaluationTemplates: Scalars['Boolean'];
  upsertWorkAllocationEmailAlerts: Scalars['Int'];
  upsertWorkAllocationPermissions: Scalars['Int'];
  upsertWorkAllocationProgram: Scalars['Int'];
  upsertWorkAllocationProgramEvaluationTemplate: Scalars['Boolean'];
  upsertWorkAllocationProgramMatter: Scalars['Int'];
  upsertWorkAllocationProgramMatterByAssociate: Scalars['Int'];
  upsertWorkAllocationProgramMatterByMember: Scalars['Int'];
  upsertWorkAllocationProgramReminderEmail: Scalars['Boolean'];
};


export type MutationAddAssociatesToWorkAllocationMatterArgs = {
  associateIds: Array<Scalars['ID']>;
  matterId: Scalars['ID'];
};


export type MutationAddAssociatesToWorkAllocationProgramArgs = {
  associateIds: Array<Scalars['ID']>;
  programId: Scalars['ID'];
};


export type MutationAddOfficeToOrgArgs = {
  input: AddOfficeToOrgInput;
};


export type MutationAddOrgToFlagArgs = {
  key: Scalars['String'];
  orgId: Scalars['Int'];
};


export type MutationArchiveInternalFieldQuestionArgs = {
  id: Scalars['Int'];
};


export type MutationAssignQualifyingQuestionsToEventArgs = {
  input: AssignQualifyingQuestionsToEventInput;
};


export type MutationBulkCreateCandidateMissingInfoRequestArgs = {
  input: BulkCreateCandidateMissingInfoRequestInput;
};


export type MutationCancelLotteryStudentMatchArgs = {
  input: CancelLotteryStudentMatchInput;
  studentExtension: Scalars['String'];
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
};


export type MutationCompleteOutreachEventCandidateRegistrationArgs = {
  input: CompleteOutreachEventCandidateRegistrationInput;
};


export type MutationConfirmAppliedToExternalJobArgs = {
  input?: InputMaybe<ConfirmAppliedToExternalJobInput>;
};


export type MutationCreateAgencyArgs = {
  input: AgencyInput;
};


export type MutationCreateCandidateMissingInfoRequestArgs = {
  jobAppId: Scalars['Int'];
  recipientType: CandidateMissingInfoRequestRecipientType;
  recruitId: Scalars['Int'];
};


export type MutationCreateEmployerMemberArgs = {
  input: CreateEmployerMemberInput;
};


export type MutationCreateProgramAssociateArgs = {
  associate: ProgramAssociateInput;
};


export type MutationCreateSsoConnectionArgs = {
  connectionName: Scalars['String'];
  orgId: Scalars['ID'];
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateUniversityMemberArgs = {
  input: CreateUniversityMemberInput;
};


export type MutationCreateWorkAllocationAssociateArgs = {
  associate?: InputMaybe<CandidateInput>;
};


export type MutationDeleteCandidateReviewTemplateArgs = {
  candidateReviewTemplateId: Scalars['Int'];
};


export type MutationDeleteCannedReportArgs = {
  cannedReportId: Scalars['Int'];
};


export type MutationDeleteEvaluationQuestionArgs = {
  questionId: Scalars['ID'];
};


export type MutationDeleteEvaluationQuestionTemplateArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteMatterArgs = {
  matterId: Scalars['ID'];
};


export type MutationDeleteMatterDocumentsArgs = {
  documentIds: Array<Scalars['ID']>;
  matterId: Scalars['ID'];
};


export type MutationDeleteMatterDocumentsByAssociateArgs = {
  documentIds: Array<Scalars['ID']>;
  matterId: Scalars['ID'];
};


export type MutationDeleteMemberArgs = {
  input: DeleteMemberInput;
};


export type MutationDeleteProgramGroupArgs = {
  input: DeleteProgramGroupInput;
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteWorkAllocationProgramArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWorkAllocationProgramMatterArgs = {
  id: Scalars['ID'];
};


export type MutationEditAgencyArgs = {
  input: AgencyInput;
};


export type MutationEditEmployerMemberAuthInfoArgs = {
  input: EditEmployerMemberAuthInfoInput;
};


export type MutationEditEmployerMemberInfoArgs = {
  input: EditEmployerMemberInfoInput;
};


export type MutationEditForwardProfileArgs = {
  input: EditForwardProfileInput;
};


export type MutationEditForwardProfileAboutBioArgs = {
  input: EditForwardProfileAboutBioInput;
};


export type MutationEditForwardProfilePhotoArgs = {
  input: EditForwardProfilePhotoInput;
};


export type MutationEditTagArgs = {
  input: EditTagInput;
};


export type MutationEditUniversityMemberInfoArgs = {
  input: EditUniversityMemberInfoInput;
};


export type MutationInitialRunCannedReportArgs = {
  initialRunCannedReportInput: InitialRunCannedReportInput;
};


export type MutationMergeCandidatesArgs = {
  input: CandidateMergeInput;
};


export type MutationMergeDuplicateAgenciesArgs = {
  agencyIdsToMerge: Array<InputMaybe<Scalars['ID']>>;
};


export type MutationRegisterForwardUserArgs = {
  input: RegisterForwardUserInput;
};


export type MutationRemoveAssociatesFromWorkAllocationMatterArgs = {
  associateIds: Array<Scalars['ID']>;
  matterId: Scalars['ID'];
};


export type MutationRemoveAssociatesFromWorkAllocationProgramArgs = {
  associateIds: Array<Scalars['ID']>;
  programId: Scalars['ID'];
};


export type MutationRemoveCandidateEducationHistoryEntryArgs = {
  input: RemoveCandidateEducationHistoryEntryInput;
};


export type MutationRemoveCandidateWorkHistoryEntryArgs = {
  input: RemoveCandidateWorkHistoryEntryInput;
};


export type MutationRemoveEmailFromForwardAccountArgs = {
  input: RemoveEmailFromForwardAccountInput;
};


export type MutationRemoveOfficeFromOrgArgs = {
  input: RemoveOfficeFromOrgInput;
};


export type MutationRemoveOrgFromFlagArgs = {
  key: Scalars['String'];
  orgId: Scalars['Int'];
};


export type MutationResetUserPasswordArgs = {
  input: UpdateUserPasswordInput;
};


export type MutationSelfAssignToMatterArgs = {
  matterId: Scalars['ID'];
  programId: Scalars['ID'];
};


export type MutationSendAddEmailToForwardAccountLinkArgs = {
  input: SendAddEmailToForwardAccountLinkInput;
};


export type MutationSendBulkProjectEvaluationRequestEmailsArgs = {
  programId: Scalars['ID'];
  projectIds: Array<Scalars['ID']>;
};


export type MutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


export type MutationSendProgramEvaluationRequestEmailForAssociatesArgs = {
  associateRecruitIds: Array<Scalars['ID']>;
  options?: InputMaybe<ProgramEvaluationRequestOptions>;
  programEvaluationId: Scalars['ID'];
  programId: Scalars['ID'];
};


export type MutationSendProjectEvaluationRequestEmailArgs = {
  associateRecruitId: Scalars['ID'];
  attorneyUserId: Scalars['ID'];
  programId: Scalars['ID'];
  projectId: Scalars['ID'];
};


export type MutationSubmitAndMarkExternalJobImportAsCompletedArgs = {
  input: SubmitAndMarkExternalJobImportAsCompletedInput;
};


export type MutationSubmitCandidateEducationHistoryEntryArgs = {
  input: SubmitCandidateEducationHistoryEntryInput;
};


export type MutationSubmitCandidateWorkHistoryEntryArgs = {
  input: SubmitCandidateWorkHistoryEntryInput;
};


export type MutationSubmitDemographicAnswersForOutreachEventCandidateRegistrationArgs = {
  input: SubmitDemographicAnswersForOutreachEventCandidateRegistrationInput;
};


export type MutationSubmitDocumentsForEmployerEventArgs = {
  input?: InputMaybe<SubmitDocumentsForEmployerEventInput>;
};


export type MutationSubmitEventSchoolTargetingArgs = {
  input: SubmitEventSchoolTargetingInput;
};


export type MutationSubmitForwardDemographicInfoArgs = {
  input: SubmitForwardDemographicInfoInput;
};


export type MutationSubmitForwardEventPublishingSettingsArgs = {
  input: SubmitForwardEventPublishingSettingsInput;
};


export type MutationSubmitForwardJobPreferencesArgs = {
  input: SubmitForwardJobPreferencesInput;
};


export type MutationSubmitForwardOfficeLocationPreferencesArgs = {
  input: SubmitForwardOfficeLocationPreferencesInput;
};


export type MutationSubmitForwardPracticeCategoryPreferencesArgs = {
  input: SubmitForwardPracticeCategoryPreferencesInput;
};


export type MutationSubmitHeadshotForOutreachEventCandidateRegistrationArgs = {
  input: SubmitHeadshotForOutreachEventCandidateRegistrationInput;
};


export type MutationSubmitLotteryEventTimelineArgs = {
  input: LotteryEventTimelineInput;
};


export type MutationSubmitPersonalInfoForOutreachEventCandidateRegistrationArgs = {
  input: SubmitPersonalInfoForOutreachEventCandidateRegistrationInput;
};


export type MutationSubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationArgs = {
  input: SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInput;
};


export type MutationSubmitStudentBidsArgs = {
  input?: InputMaybe<LotteryStudentBidListInput>;
  studentExtension: Scalars['String'];
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type MutationSubmitStudentInterviewSchedulingPreferencesForJobsArgs = {
  input?: InputMaybe<InterviewSchedulingStudentPreferencesListsInput>;
  studentExtension: Scalars['String'];
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type MutationSubmitVirtualChatRecruitTimeslotSelectionsArgs = {
  input: SubmitVirtualChatRecruitTimeslotSelectionsInput;
};


export type MutationSuperAdminAddDocumentToFirmArgs = {
  input: SuperAdminAddDocumentToFirmInput;
};


export type MutationSuperAdminAddOfficeToFirmArgs = {
  input: SuperAdminAddOfficeToFirmInput;
};


export type MutationSuperAdminAddPracticeAreaToFirmArgs = {
  input: SuperAdminAddPracticeAreaToFirmInput;
};


export type MutationSuperAdminArchiveWorkplaceArgs = {
  input: SuperAdminArchiveWorkplaceInput;
};


export type MutationSuperAdminAssignLawSchoolToUniversityArgs = {
  input: SuperAdminAssignLawSchoolToUniversityOrgInput;
};


export type MutationSuperAdminAssignOutlierLawSchoolDataArgs = {
  input: SuperAdminAssignOutlierLawSchoolDataInput;
};


export type MutationSuperAdminAssignOutlierOfficeLocationDataArgs = {
  input: SuperAdminAssignOutlierOfficeLocationDataInput;
};


export type MutationSuperAdminAssignOutlierPracticeAreaDataArgs = {
  input: SuperAdminAssignOutlierPracticeAreaDataInput;
};


export type MutationSuperAdminCloseJobsArgs = {
  input: SuperAdminCloseJobsInput;
};


export type MutationSuperAdminCreateInactiveFirmArgs = {
  input: SuperAdminCreateInactiveFirmInput;
};


export type MutationSuperAdminCreateLawSchoolArgs = {
  input: SuperAdminCreateLawSchoolInput;
};


export type MutationSuperAdminCreateOfficeLocationArgs = {
  input: SuperAdminCreateOfficeLocationInput;
};


export type MutationSuperAdminCreatePracticeAreaArgs = {
  input: SuperAdminCreatePracticeAreaInput;
};


export type MutationSuperAdminCreatePracticeCategoryArgs = {
  input: SuperAdminCreatePracticeCategoryInput;
};


export type MutationSuperAdminCreateUniversityArgs = {
  input: SuperAdminCreateUniversityInput;
};


export type MutationSuperAdminCreateWorkplaceArgs = {
  input: SuperAdminCreateWorkplaceInput;
};


export type MutationSuperAdminDeleteExternalJobArgs = {
  input: SuperAdminDeleteExternalJobInput;
};


export type MutationSuperAdminDeleteWorkplaceArgs = {
  input: SuperAdminDeleteWorkplaceInput;
};


export type MutationSuperAdminEditLawSchoolArgs = {
  input: SuperAdminEditLawSchoolInput;
};


export type MutationSuperAdminEditOfficeLocationArgs = {
  input: SuperAdminEditOfficeLocationInput;
};


export type MutationSuperAdminEditOrgEmailDomainArgs = {
  input: SuperAdminEditOrgEmailDomainInput;
};


export type MutationSuperAdminEditPracticeAreaArgs = {
  input: SuperAdminEditPracticeAreaInput;
};


export type MutationSuperAdminEditPracticeAreaForFirmArgs = {
  input: SuperAdminEditPracticeAreaForFirmInput;
};


export type MutationSuperAdminEditPracticeCategoryArgs = {
  input: SuperAdminEditPracticeCategoryInput;
};


export type MutationSuperAdminEditUniversityArgs = {
  input: SuperAdminEditUniversityInput;
};


export type MutationSuperAdminEditWorkplaceArgs = {
  input: SuperAdminEditWorkplaceInput;
};


export type MutationSuperAdminEnableEventCarouselArgs = {
  input: SuperAdminEnableEventCarouselInput;
};


export type MutationSuperAdminGenerateCandidateArgs = {
  input: GenerateCandidateInput;
  orgId: Scalars['Int'];
};


export type MutationSuperAdminMergeLawSchoolArgs = {
  input: SuperAdminMergeLawSchoolInput;
};


export type MutationSuperAdminMergeOfficeLocationArgs = {
  input: SuperAdminMergeOfficeLocationInput;
};


export type MutationSuperAdminMergePracticeAreaArgs = {
  input: SuperAdminMergePracticeAreaInput;
};


export type MutationSuperAdminRemoveOfficeFromFirmArgs = {
  input: SuperAdminRemoveOfficeFromFirmInput;
};


export type MutationSuperAdminRemovePracticeAreaFromFirmArgs = {
  input: SuperAdminRemovePracticeAreaFromFirmInput;
};


export type MutationSuperAdminRotateEventDirectoryArgs = {
  input: SuperAdminRotateFirmsInput;
};


export type MutationSuperAdminRotateFirmsArgs = {
  input: SuperAdminRotateFirmsInput;
};


export type MutationSuperAdminSubmitEmailDomainsForSchoolArgs = {
  input: SuperAdminSubmitEmailDomainsForSchoolInput;
};


export type MutationSuperAdminSubmitFirmProfileCustomSectionArgs = {
  input: SuperAdminSubmitFirmProfileCustomSectionInput;
};


export type MutationSuperAdminSubmitFirmProfileDiversityAndInclusionSectionArgs = {
  input: SuperAdminSubmitFirmProfileDiversityAndInclusionSectionInput;
};


export type MutationSuperAdminSubmitFirmProfileIsPublicArgs = {
  input: SuperAdminSubmitFirmProfileIsPublicInput;
};


export type MutationSuperAdminSubmitFirmProfileMainArgs = {
  input: SuperAdminSubmitFirmProfileMainInput;
};


export type MutationSuperAdminSubmitFirmProfilePracticeAreaSectionArgs = {
  input: SuperAdminSubmitFirmProfilePracticeAreaSectionInput;
};


export type MutationSuperAdminSubmitFirmProfileProBonoSectionArgs = {
  input: SuperAdminSubmitFirmProfileProBonoSectionInput;
};


export type MutationSuperAdminSubmitFirmProfileSummerProgramSectionArgs = {
  input: SuperAdminSubmitFirmProfileSummerProgramSectionInput;
};


export type MutationSuperAdminSubmitForwardEventPublishingSettingsArgs = {
  input: SuperAdminSubmitForwardEventPublishingSettingsInput;
};


export type MutationSuperAdminSubmitJobBoardAudienceArgs = {
  input: SuperAdminSubmitJobBoardAudienceInput;
};


export type MutationSuperAdminSubmitJobForFirmArgs = {
  input: SuperAdminSubmitJobForFirmInput;
};


export type MutationSuperAdminToggleOrgSsoArgs = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  orgId: Scalars['ID'];
};


export type MutationSuperAdminUpdateEventCarouselRankingsArgs = {
  input: SuperAdminUpdateEventCarouselRankingsInput;
};


export type MutationSuperAdminUpdateForwardTierArgs = {
  input: SuperAdminUpdateForwardTierInput;
};


export type MutationSuperAdminUpdateOrgFeaturedEventsArgs = {
  input: SuperAdminUpdateOrgFeaturedEventsInput;
};


export type MutationSuperAdminUpdateOrgForwardPrivilegesArgs = {
  input: SuperAdminUpdateOrgForwardPrivilegesInput;
};


export type MutationSuperAdminUpdateOrgOfficeRankingsArgs = {
  input: SuperAdminUpdateOrgOfficeRankingInput;
};


export type MutationSuperAdminUpdateOrgSsoArgs = {
  input: SuperAdminUpdateOrgSsoInput;
};


export type MutationTestArgs = {
  input: TestInput;
};


export type MutationToggleExternalJobImportDoNotSubmitStatusArgs = {
  input: ToggleExternalJobImportDoNotSubmitStatusInput;
};


export type MutationToggleFlagArgs = {
  key: Scalars['String'];
};


export type MutationToggleJobBookmarkArgs = {
  input: ToggleJobBookmarkInput;
};


export type MutationTrackActivateForwardAccountFromEventArgs = {
  input: TrackActivateForwardAccountFromEventInput;
};


export type MutationTrackApplyToExternalJobArgs = {
  input: TrackApplyToExternalJobInput;
};


export type MutationTrackForwardEventCompleteRegistrationArgs = {
  input: TrackForwardEventCompleteRegistrationInput;
};


export type MutationTrackForwardEventStartRegistrationArgs = {
  input: TrackForwardEventStartRegistrationInput;
};


export type MutationTrackGoToExternalJobPageArgs = {
  input: TrackGoToExternalJobPageInput;
};


export type MutationTrackQuickApplyToJobArgs = {
  input: TrackQuickApplyToJobInput;
};


export type MutationUnarchiveInternalFieldQuestionArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateAgencyRegistrationStatusArgs = {
  agencyId: Scalars['ID'];
  isUnregisteredAgency: Scalars['Boolean'];
};


export type MutationUpdateCandidateMissingInfoRequestJobEmailTemplateArgs = {
  input: CandidateMissingInfoRequestJobEmailTemplateInput;
  jobId: Scalars['Int'];
};


export type MutationUpdateFlagUrlArgs = {
  key: Scalars['String'];
  url: Scalars['String'];
};


export type MutationUpdateInternalFieldsOrderArgs = {
  ids: Array<InputMaybe<Scalars['Int']>>;
};


export type MutationUpdateJobAppOfferDetailsArgs = {
  jobAppId?: InputMaybe<Scalars['Int']>;
  offerDetails?: InputMaybe<OfferDetailsInput>;
};


export type MutationUpdateMatterPetArgs = {
  matterId: Scalars['ID'];
  petName: Scalars['String'];
};


export type MutationUpdateMatterSubmissionStatusArgs = {
  matterId: Scalars['ID'];
  status: SubmissionStatus;
};


export type MutationUpdateMatterWorkStatusArgs = {
  matterId: Scalars['ID'];
  status: MatterStatus;
};


export type MutationUpdateMatterWorkStatusByAssociateArgs = {
  matterId: Scalars['ID'];
  status: MatterStatus;
};


export type MutationUpdateOrgCandidatePhotoManagementSettingsArgs = {
  input: UpdateOrgCandidatePhotoManagementSettingsInput;
};


export type MutationUpdateProgramAssociateArgs = {
  updateInfo: ProgramAssociateUpdateInput;
};


export type MutationUpdateProgramAssociatePracticeAreasArgs = {
  practiceAreaUpdate: ProgramAssociatePreferredPracticeAreasUpdateInput;
};


export type MutationUpdateProgramGroupAssociatesArgs = {
  input: UpdateProgramGroupAssociatesInput;
};


export type MutationUpdateProgramGroupMembersArgs = {
  input: UpdateProgramGroupMembersInput;
};


export type MutationUpdateWorkAllocationProgramContributorsArgs = {
  input: UpdateProgramContributorsInput;
};


export type MutationUploadMatterDocumentArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  input: UploadMatterDocumentInput;
};


export type MutationUploadMatterDocumentByAssociateArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  input: UploadMatterDocumentInput;
};


export type MutationUploadMembersCsvArgs = {
  input: UploadMembersCsvInput;
};


export type MutationUpsertCandidateBasicInformationArgs = {
  candidateBasicInformationInput: CandidateBasicInformationInput;
};


export type MutationUpsertCandidateDocumentsArgs = {
  documents?: InputMaybe<Array<InputMaybe<CustomDocumentInput>>>;
  recruitId: Scalars['ID'];
};


export type MutationUpsertCandidateInternalFieldAnswersArgs = {
  answers: Array<UpsertInternalFieldAnswerInput>;
  recruitId: Scalars['Int'];
};


export type MutationUpsertCandidateProfileArgs = {
  candidateBasicInformationInput: CandidateBasicInformationInput;
  documents?: InputMaybe<Array<InputMaybe<CustomDocumentInput>>>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  qualifyingQuestionAnswers?: InputMaybe<Array<InputMaybe<QualifyingQuestionAnswerInput>>>;
};


export type MutationUpsertCandidateProfileImageArgs = {
  profileImageUrl?: InputMaybe<Scalars['String']>;
  recruitId: Scalars['ID'];
};


export type MutationUpsertCandidateQualifyingQuestionAnswersArgs = {
  qualifyingQuestionAnswers?: InputMaybe<Array<InputMaybe<QualifyingQuestionAnswerInput>>>;
  recruitId: Scalars['ID'];
};


export type MutationUpsertCandidateReviewTemplateArgs = {
  candidateReviewTemplateInput: CandidateReviewTemplateInput;
};


export type MutationUpsertCandidateReviewTemplateCandidateVotingRecordArgs = {
  candidateReviewCandidateVotingInput: CandidateReviewTemplateCandidateVotingInput;
};


export type MutationUpsertCandidateReviewTemplateCandidatesArgs = {
  candidateReviewTemplateCandidatesInput: CandidateReviewTemplateCandidatesInput;
};


export type MutationUpsertCandidateReviewTemplateEventsArgs = {
  candidateReviewTemplateEventsInput: CandidateReviewTemplateEventsInput;
};


export type MutationUpsertCandidateReviewTemplateJobsArgs = {
  candidateReviewTemplateJobsInput: CandidateReviewTemplateJobsInput;
};


export type MutationUpsertCandidateReviewTemplateJobsWithEventsArgs = {
  candidateReviewTemplateJobsWithEventsInput: CandidateReviewTemplateJobsWithEventsInput;
};


export type MutationUpsertCandidateReviewTemplateProgramsArgs = {
  candidateReviewTemplateProgramsInput: CandidateReviewTemplateProgramsInput;
};


export type MutationUpsertCandidateReviewTemplateSectionsArgs = {
  additionalInformationSectionInput?: InputMaybe<CandidateReviewTemplateAdditionalInformationSectionInput>;
  candidateReviewTemplateId: Scalars['Int'];
  documentSectionInput?: InputMaybe<CandidateReviewTemplateDocumentSectionInput>;
  evaluationSectionInput?: InputMaybe<CandidateReviewTemplateEvaluationSectionInput>;
  interviewScheduleSectionInput?: InputMaybe<CandidateReviewTemplateInterviewScheduleSectionInput>;
  jobAppSectionInput?: InputMaybe<CandidateReviewTemplateJobAppSectionInput>;
  projectDocumentsSectionInput?: InputMaybe<CandidateReviewTemplateProjectDocumentsSectionInput>;
};


export type MutationUpsertCandidateReviewVotingRecordCastedVotedArgs = {
  candidateReviewVotingRecordCastedVotedInput: CandidateReviewVotingRecordCastedVotedInput;
};


export type MutationUpsertCandidateReviewVotingRecordCommentArgs = {
  candidateReviewVotingRecordCommentInput: CandidateReviewVotingRecordCommentInput;
};


export type MutationUpsertCannedReportArgs = {
  cannedReportInput: CannedReportInput;
};


export type MutationUpsertCannedReportIncludedJobsArgs = {
  cannedReportIncludedJobsInput: CannedReportIncludedJobsInput;
};


export type MutationUpsertEvaluationQuestionArgs = {
  input: EvaluationQuestionInput;
};


export type MutationUpsertEvaluationQuestionTemplateArgs = {
  input: EvaluationQuestionTemplateInput;
};


export type MutationUpsertIndividualProgramEvaluationResponseArgs = {
  answers: Array<ProgramEvaluationAnswerInput>;
  associateRecruitId: Scalars['ID'];
  attorneyUserId?: InputMaybe<Scalars['ID']>;
  customProgramEvaluationId: Scalars['ID'];
  programId: Scalars['ID'];
};


export type MutationUpsertInternalFieldQuestionArgs = {
  input: UpsertInternalFieldQuestionInput;
};


export type MutationUpsertJobAppInternalFieldAnswersArgs = {
  answers: Array<UpsertInternalFieldAnswerInput>;
  jobAppId: Scalars['Int'];
  recruitId: Scalars['Int'];
};


export type MutationUpsertMatterAssociateEvaluationArgs = {
  answers: Array<CandidateEvaluationAnswerInput>;
  candidateId: Scalars['ID'];
  matterId: Scalars['ID'];
};


export type MutationUpsertProgramGroupArgs = {
  input: UpsertProgramGroupInput;
};


export type MutationUpsertWorkAllocationCustomProgramEvaluationTemplatesArgs = {
  input?: InputMaybe<UpsertCustomEvaluationTemplateOnProgramInput>;
};


export type MutationUpsertWorkAllocationEmailAlertsArgs = {
  input: UpsertWorkAllocationEmailAlertsInput;
};


export type MutationUpsertWorkAllocationPermissionsArgs = {
  input: UpsertWorkAllocationPermissionsInput;
};


export type MutationUpsertWorkAllocationProgramArgs = {
  input: UpsertWorkAllocationProgramInput;
};


export type MutationUpsertWorkAllocationProgramEvaluationTemplateArgs = {
  input: UpsertEvaluationTemplateOnProgramInput;
};


export type MutationUpsertWorkAllocationProgramMatterArgs = {
  input: UpsertWorkAllocationProgramMatterInput;
  programId: Scalars['ID'];
};


export type MutationUpsertWorkAllocationProgramMatterByAssociateArgs = {
  input: UpsertWorkAllocationProgramMatterInput;
  programId: Scalars['ID'];
};


export type MutationUpsertWorkAllocationProgramMatterByMemberArgs = {
  input: UpsertWorkAllocationProgramMatterInput;
  programId: Scalars['ID'];
};


export type MutationUpsertWorkAllocationProgramReminderEmailArgs = {
  input: UpsertReminderEmailsOnProgramInput;
};

export type NetworkingEventNode = EventNode & Node & {
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  employerRegistrationDeadline?: Maybe<DateTimeZone>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  studentRegistrationDeadline?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type NetworkingEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** A generic object, representing a "node" in a set of relational data. */
export type Node = {
  id: Scalars['ID'];
};

export type NotificationNode = Node & {
  email?: Maybe<EmailAutomationNode>;
  id: Scalars['ID'];
  notificationMetaDataJson: Scalars['String'];
};

export type OciEmployerEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type OciEmployerEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type OciUniversityEventNode = EventNode & Node & {
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  employerRegistrationDeadline?: Maybe<DateTimeZone>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  studentRegistrationDeadline?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type OciUniversityEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type OfferDetailsInput = {
  offerAffirmationDate?: InputMaybe<Scalars['String']>;
  offerDate?: InputMaybe<Scalars['String']>;
  offerExpirationDate?: InputMaybe<Scalars['String']>;
};

export type OfficeLocationConnection = Connection & {
  edges: Array<OfficeLocationEdge>;
  nodes: Array<OfficeLocationNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OfficeLocationEdge = Edge & {
  cursor: Scalars['String'];
  node: OfficeLocationNode;
};

export type OfficeLocationFilterBy = {
  name?: InputMaybe<FilterByString>;
};

export type OfficeLocationNode = Node & {
  /** As of this writing, this may be the same as the name of the office location. It is a tech debt item to make this always be the database id. */
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type OrgAvailableTagConnection = Connection & {
  edges?: Maybe<Array<Maybe<OrgAvailableTagEdge>>>;
  nodes?: Maybe<Array<Maybe<TagNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgAvailableTagEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TagNode>;
};

export type OrgCandidatePhotoManagementSettingsNode = {
  disableCandidatePhotoSyncing: Scalars['Boolean'];
  disableCandidatePhotoUpload: Scalars['Boolean'];
  hideUploadedCandidatePhotos: Scalars['Boolean'];
};

export type OrgCustomDocumentNode = Node & {
  documentType: CustomDocumentType;
  id: Scalars['ID'];
  /** For a logged-in Candidate, the S3 path of their most recent submissions for this Document. */
  myMostRecentSubmissions?: Maybe<RecruitDocumentSubmissionConnection>;
  name?: Maybe<Scalars['String']>;
  orgId: Scalars['ID'];
};


export type OrgCustomDocumentNodeMyMostRecentSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type OrgFeedbackConnection = Connection & {
  edges?: Maybe<Array<Maybe<OrgFeedbackEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgFeedbackEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<EvaluationQuestionNode>;
};

export type OrgForwardPrivilegesNode = Node & {
  carouselEventPublishing: Scalars['Boolean'];
  directoryEventPublishing: Scalars['Boolean'];
  id: Scalars['ID'];
  lawSchoolTargeting: Scalars['Boolean'];
  orgId: Scalars['ID'];
};

export type OrgIdEventIdForwardPublishingSettings = {
  carouselEventShown: Scalars['Boolean'];
  directoryEventShown: Scalars['Boolean'];
  eventId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export type OrgMemberConnection = Connection & {
  edges?: Maybe<Array<Maybe<OrgMemberEdge>>>;
  nodes?: Maybe<Array<Maybe<MemberNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgMemberEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MemberNode>;
};

export type OrgNode = {
  availableTags?: Maybe<OrgAvailableTagConnection>;
  /** The Org's color as a hexadecimal RGB string. */
  color?: Maybe<Scalars['String']>;
  emailDomain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  /** Whether the Org is currently paying for Flo Recruit. */
  isActive?: Maybe<Scalars['Boolean']>;
  isMfaEnabled: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  members?: Maybe<OrgMemberConnection>;
  name?: Maybe<Scalars['String']>;
  organizingEvents?: Maybe<OrgOrganizesEventConnection>;
  /** Whether the Org requests diversity and inclusion information. */
  requestsDNI?: Maybe<Scalars['Boolean']>;
  /** `null` if the Org does not use SSO. */
  ssoAuthInfo?: Maybe<OrgSsoAuthInfoNode>;
  ssoType: SsoType;
  timezonePlan?: Maybe<TimezonePlan>;
  /** A URL-friendly name for the Org. */
  urlFriendlyName?: Maybe<Scalars['String']>;
};


export type OrgNodeAvailableTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type OrgNodeMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type OrgNodeOrganizingEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<EventFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};

export type OrgOfficeConnection = Connection & {
  edges: Array<OrgOfficeEdge>;
  nodes: Array<OrgOfficeNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgOfficeEdge = Edge & {
  cursor: Scalars['String'];
  node: OrgOfficeNode;
};

export type OrgOfficeLocationConnection = Connection & {
  edges?: Maybe<Array<Maybe<OrgOfficeLocationEdge>>>;
  nodes?: Maybe<Array<Maybe<OfficeLocationNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgOfficeLocationEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<OfficeLocationNode>;
  ugPresetId?: Maybe<Scalars['Int']>;
};

export type OrgOfficeNode = Node & {
  id: Scalars['ID'];
  officeLocation: OfficeLocationNode;
  officeLocationId: Scalars['ID'];
  orgId: Scalars['ID'];
  /** Areas in which attorneys of the firm at this office practice. */
  practiceAreas: OrgOfficePracticeAreaConnection;
  ranking: Scalars['Int'];
};


export type OrgOfficeNodePracticeAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type OrgOfficePracticeAreaConnection = Connection & {
  edges: Array<OrgOfficePracticeAreaEdge>;
  nodes: Array<OrgPracticeAreaNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgOfficePracticeAreaEdge = Edge & {
  cursor: Scalars['String'];
  node: OrgPracticeAreaNode;
};

export type OrgOfficeRanking = {
  orgOfficeId: Scalars['ID'];
  ranking: Scalars['Int'];
};

export type OrgOrganizesEventConnection = Connection & {
  edges?: Maybe<Array<Maybe<OrgOrganizesEventEdge>>>;
  nodes?: Maybe<Array<Maybe<EventNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgOrganizesEventEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<EventNode>;
};

export type OrgPracticeAreaConnection = Connection & {
  edges: Array<OrgPracticeAreaEdge>;
  nodes: Array<OrgPracticeAreaNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgPracticeAreaEdge = Edge & {
  cursor: Scalars['String'];
  node: OrgPracticeAreaNode;
};

/** TODO: Once product gives us a static list of practice areas, this `Node` will reference that `PracticeAreaNode` as well. */
export type OrgPracticeAreaNode = Node & {
  /**
   * As opposed to the name of the practice area that we use internally.
   * TODO: This will be come relevant once product gives us a static list of practice areas.
   */
  firmSpecificName: Scalars['String'];
  id: Scalars['ID'];
  /** Offices in which this firm has people in this practice area. */
  offices: OrgPracticeAreaOfficeConnection;
  orgId: Scalars['ID'];
  /** Offices in which this firm has summer associates in this practice area */
  summerOffices: FirmSummerPracticeAreaOfficeConnection;
};


/** TODO: Once product gives us a static list of practice areas, this `Node` will reference that `PracticeAreaNode` as well. */
export type OrgPracticeAreaNodeOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** TODO: Once product gives us a static list of practice areas, this `Node` will reference that `PracticeAreaNode` as well. */
export type OrgPracticeAreaNodeSummerOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type OrgPracticeAreaOfficeConnection = Connection & {
  edges: Array<OrgPracticeAreaOfficeEdge>;
  nodes: Array<OrgOfficeNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type OrgPracticeAreaOfficeEdge = Edge & {
  cursor: Scalars['String'];
  node: OrgOfficeNode;
};

export type OrgQuestionOptionResponseNode = {
  coreQuestionOptionId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  option?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  orgQuestionId?: Maybe<Scalars['Int']>;
};

export type OrgSelfIdQuestionAnswerNode = {
  appSource?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  orgSelfIdQuestionAnswerSelections?: Maybe<Array<Maybe<OrgSelfIdQuestionAnswerSelectionNode>>>;
  orgSelfIdQuestionId?: Maybe<Scalars['Int']>;
  orgSelfIdQuestionOptions?: Maybe<Array<Maybe<OrgSelfIdQuestionOptionNode>>>;
  recruitId?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type OrgSelfIdQuestionAnswerSelectionNode = {
  id?: Maybe<Scalars['Int']>;
  orgSelfIdQuestionAnswerId?: Maybe<Scalars['Int']>;
  orgSelfIdQuestionOptionId?: Maybe<Scalars['Int']>;
};

export type OrgSelfIdQuestionNode = {
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isGovernment?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgSelfIdQuestionOptions?: Maybe<Array<Maybe<OrgSelfIdQuestionOptionNode>>>;
  questionType?: Maybe<Scalars['String']>;
  selfIdDefaultId?: Maybe<Scalars['Int']>;
  selfIdType?: Maybe<Scalars['String']>;
};

export type OrgSelfIdQuestionOptionNode = {
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type OrgSsoAuthInfoFrontendAttribute = {
  /** If not email, then a separate frontend field is required. */
  isEmail: Scalars['Boolean'];
  label: Scalars['String'];
  validationErrorMessage: Scalars['String'];
  validationRegex: Scalars['String'];
};

export type OrgSsoAuthInfoNode = Node & {
  connectionName: Scalars['String'];
  frontendAttribute: OrgSsoAuthInfoFrontendAttribute;
  id: Scalars['ID'];
  isEnabled: Scalars['Boolean'];
  ssoIdIsEmail: Scalars['Boolean'];
};

/** An object with data for pagination. */
export type PageInfo = {
  /**
   * The cursor of the last Edge in `edges`.
   * If connection is empty, endCursor will be null.
   */
  endCursor?: Maybe<Scalars['String']>;
  /** Whether there is more data after the last Edge in `edges`. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** Whether there is more data before the first edge in `edges`. */
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  /**
   * The cursor of the first Edge in `edges`.
   * If connection is empty, startCursor will be null.
   */
  startCursor?: Maybe<Scalars['String']>;
};

export enum PasswordResetError {
  InvalidPassword = 'INVALID_PASSWORD',
  InvalidToken = 'INVALID_TOKEN',
  MatchesOldPassword = 'MATCHES_OLD_PASSWORD',
  Other = 'OTHER',
  TokenNotFound = 'TOKEN_NOT_FOUND'
}

export type PasswordResetResultNode = {
  error?: Maybe<PasswordResetError>;
  success: Scalars['Boolean'];
};

export type PhysicalEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  forwardEventPublishingSettings?: Maybe<ForwardEventPublishingSettings>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  registrationEnd?: Maybe<DateTimeZone>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  targetedSchools?: Maybe<EventTargetsSchoolConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type PhysicalEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type PhysicalEventNodeTargetedSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type PracticeAreaAttorneyHeadcount = {
  numAssociates?: Maybe<Scalars['Int']>;
  numCounsels?: Maybe<Scalars['Int']>;
  numEntryLevelPlacements?: Maybe<Scalars['Int']>;
  numNonEquityPartners?: Maybe<Scalars['Int']>;
  numNonTraditionalTrackOrStaff?: Maybe<Scalars['Int']>;
  numPartners?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  orgPracticeArea: OrgPracticeAreaNode;
  orgPracticeAreaId: Scalars['ID'];
  ranking: Scalars['Int'];
  totalNumAttorneys?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PracticeAreaConnection = Connection & {
  edges?: Maybe<Array<PracticeAreaEdge>>;
  nodes?: Maybe<Array<PracticeAreaNode>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PracticeAreaEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<PracticeAreaNode>;
};

export type PracticeAreaFilterBy = {
  name?: InputMaybe<FilterByString>;
};

export type PracticeAreaNode = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
  practiceCategory?: Maybe<PracticeCategoryNode>;
};

export type PracticeAreaOffice = {
  orgOfficeId: Scalars['ID'];
};

export type PracticeAreaPreferenceInput = {
  order: Scalars['Int'];
  orgSpecificPracticeAreaId?: InputMaybe<Scalars['ID']>;
  practiceAreaId?: InputMaybe<Scalars['ID']>;
};

export type PracticeCategoryConnection = Connection & {
  edges: Array<PracticeCategoryEdge>;
  nodes: Array<PracticeCategoryNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PracticeCategoryEdge = Edge & {
  cursor: Scalars['String'];
  node: PracticeCategoryNode;
};

export type PracticeCategoryNode = Node & {
  id: Scalars['ID'];
  name: Scalars['String'];
  practiceAreas: PracticeAreaConnection;
};


export type PracticeCategoryNodePracticeAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type ProcessedJobsRatio = {
  processed: Scalars['Int'];
  total: Scalars['Int'];
};

export type ProgramAssociate = {
  authzReasons?: Maybe<Array<WorkAllocationAuthorizationReason>>;
  email: Scalars['Email'];
  employersEmployeeId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['Date']>;
  firstName: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  languages?: Maybe<Array<Scalars['String']>>;
  lastName: Scalars['String'];
  lawSchools?: Maybe<Array<Scalars['String']>>;
  linkedRecruitIds?: Maybe<Array<Scalars['Int']>>;
  location?: Maybe<Scalars['String']>;
  mentors?: Maybe<Array<MentorInfo>>;
  phoneExtension?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  preferredPracticeAreas?: Maybe<Array<ProgramPreferredPracticeArea>>;
  programId: Scalars['ID'];
  recruitIdForAssociateWorkEmail?: Maybe<Scalars['Int']>;
  splitOffice?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type ProgramAssociateInput = {
  email: Scalars['Email'];
  employersEmployeeId?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  languages?: InputMaybe<Array<Scalars['ID']>>;
  lastName: Scalars['String'];
  lawSchools?: InputMaybe<Array<Scalars['ID']>>;
  linkedRecruitIds?: InputMaybe<Array<Scalars['Int']>>;
  location?: InputMaybe<Scalars['String']>;
  mentors?: InputMaybe<Array<MentorInput>>;
  phoneExtension?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  preferredPracticeAreas?: InputMaybe<Array<PracticeAreaPreferenceInput>>;
  programId: Scalars['ID'];
  splitOffice?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type ProgramAssociateLawSchoolsUpdateInput = {
  employeeId: Scalars['ID'];
  lawSchools?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProgramAssociateMentorsUpdateInput = {
  employeeId: Scalars['ID'];
  mentors?: InputMaybe<Array<MentorInput>>;
  programId: Scalars['ID'];
};

export type ProgramAssociatePreferredPracticeAreasUpdateInput = {
  employeeId: Scalars['ID'];
  preferredPracticeAreas?: InputMaybe<Array<PracticeAreaPreferenceInput>>;
  programId: Scalars['ID'];
};

export type ProgramAssociateSplitOfficeUpdateInput = {
  employeeId: Scalars['ID'];
  programId: Scalars['ID'];
  splitOffice?: InputMaybe<Scalars['ID']>;
};

export type ProgramAssociateStartEndDateUpdateInput = {
  employeeId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['Date']>;
  programId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
};

export type ProgramAssociateUpdateInput = {
  employeeId: Scalars['ID'];
  programAssociateContactInfoUpdate?: InputMaybe<EmployeeWorkContactInfoUpdateInput>;
  programAssociateIdentityUpdate?: InputMaybe<EmployeeIdentityUpdateInput>;
  programAssociateLanguagesUpdate?: InputMaybe<EmployeeLanguagesUpdateInput>;
  programAssociateLawSchoolsUpdate?: InputMaybe<ProgramAssociateLawSchoolsUpdateInput>;
  programAssociateLinkedRecruitsUpdate?: InputMaybe<EmployeeLinkedRecruitsUpdateInput>;
  programId: Scalars['ID'];
  programMentorsUpdate?: InputMaybe<ProgramAssociateMentorsUpdateInput>;
  programPreferredPracticeAreasUpdate?: InputMaybe<ProgramAssociatePreferredPracticeAreasUpdateInput>;
  programSplitOfficeUpdate?: InputMaybe<ProgramAssociateSplitOfficeUpdateInput>;
  programStartEndDateUpdate?: InputMaybe<ProgramAssociateStartEndDateUpdateInput>;
};

export enum ProgramContributorAccessLevel {
  FullAccess = 'FULL_ACCESS',
  FullView = 'FULL_VIEW',
  LimitedAccess = 'LIMITED_ACCESS',
  LimitedView = 'LIMITED_VIEW'
}

export type ProgramContributorEdge = {
  accessLevel: ProgramContributorAccessLevel;
  member: MemberNode;
};

export type ProgramContributorInput = {
  accessLevel: ProgramContributorAccessLevel;
  memberId: Scalars['ID'];
};

export type ProgramCustomEvaluationNode = Node & {
  email?: Maybe<EmailForm>;
  evaluationName: Scalars['String'];
  evaluationType: Scalars['String'];
  feedbackReminderEmailEnabled?: Maybe<Scalars['Boolean']>;
  feedbackReminderEmailTemplateId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  programId: Scalars['ID'];
  questions?: Maybe<Array<Maybe<ProgramFeedbackNode>>>;
  responses?: Maybe<Array<ProgramCustomEvaluationResponseNode>>;
  responsesForAssociate?: Maybe<Array<ProgramCustomEvaluationResponseNode>>;
  responsesForAttorney?: Maybe<Array<ProgramCustomEvaluationResponseNode>>;
};


export type ProgramCustomEvaluationNodeResponsesForAssociateArgs = {
  associateRecruitId: Scalars['ID'];
};


export type ProgramCustomEvaluationNodeResponsesForAttorneyArgs = {
  attorneyUserId: Scalars['ID'];
};

export type ProgramCustomEvaluationResponseAnswerNode = Node & {
  comment?: Maybe<Scalars['String']>;
  freeText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  multiSelectAnswers?: Maybe<Array<Scalars['String']>>;
  orgFeedbackId: Scalars['ID'];
  ratingAnswer?: Maybe<Scalars['Int']>;
  singleSelectAnswer?: Maybe<Scalars['String']>;
  yesNoAnswer?: Maybe<Scalars['Int']>;
};

export type ProgramCustomEvaluationResponseNode = Node & {
  answers: Array<ProgramCustomEvaluationResponseAnswerNode>;
  associate: AssociateNode;
  associateRecruitId: Scalars['ID'];
  attorney?: Maybe<MemberNode>;
  attorneyUserId?: Maybe<Scalars['ID']>;
  completedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  requestedAt: Scalars['String'];
};

export type ProgramEvaluationAnswerInput = {
  comment?: InputMaybe<Scalars['String']>;
  freeText?: InputMaybe<Scalars['String']>;
  multiSelectAnswers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orgFeedbackId: Scalars['ID'];
  ratingAnswer?: InputMaybe<Scalars['Int']>;
  singleSelectAnswer?: InputMaybe<Scalars['String']>;
  yesNoAnswer?: InputMaybe<Scalars['Int']>;
};

export type ProgramEvaluationRequestAttorneys = {
  associateRecruitId: Scalars['ID'];
  attorneyUserIds: Array<Scalars['ID']>;
};

export enum ProgramEvaluationRequestAttorneysRecipientOption {
  AllAttorneysAssignedToProjects = 'ALL_ATTORNEYS_ASSIGNED_TO_PROJECTS',
  SelectAttorneys = 'SELECT_ATTORNEYS'
}

export type ProgramEvaluationRequestOptions = {
  attorneysRecipientOption: ProgramEvaluationRequestAttorneysRecipientOption;
  selectedAttorneys?: InputMaybe<Array<ProgramEvaluationRequestAttorneys>>;
};

export type ProgramFeedbackNode = Node & {
  evaluationQuestion?: Maybe<EvaluationQuestionNode>;
  id: Scalars['ID'];
  isRequired?: Maybe<Scalars['Boolean']>;
  orgFeedbackId?: Maybe<Scalars['Int']>;
};

export type ProgramGroupNode = Node & {
  associates: Array<CandidateNode>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  members: Array<MemberNode>;
  name: Scalars['String'];
  program: ProgramNode;
  programId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProgramNode = Node & {
  allowSummerAssociatesToCreateEditProjects?: Maybe<Scalars['Boolean']>;
  allowSummerAssociatesToDeleteProjects?: Maybe<Scalars['Boolean']>;
  allowSummerAssociatesToSelfAssignProjects?: Maybe<Scalars['Boolean']>;
  attorneyFeedbackReminderEmailEnabled?: Maybe<Scalars['Boolean']>;
  authzReasons?: Maybe<Array<WorkAllocationAuthorizationReason>>;
  contributors?: Maybe<Array<ProgramContributorEdge>>;
  createdAt?: Maybe<Scalars['String']>;
  customEvaluations?: Maybe<Array<Maybe<ProgramCustomEvaluationNode>>>;
  description?: Maybe<Scalars['String']>;
  emailAdminWhenAttorneyCreatesProject?: Maybe<Scalars['Boolean']>;
  emailAdminWhenFeedbackSubmitted?: Maybe<Scalars['Boolean']>;
  emailAdminWhenSummerAssociateCreatesProject?: Maybe<Scalars['Boolean']>;
  emailAdminWhenSummerAssociateDeletesProject?: Maybe<Scalars['Boolean']>;
  emailAdminWhenSummerAssociateIsAssignedToProject?: Maybe<Scalars['Boolean']>;
  emailAdminWhenSummerAssociateIsRemovedFromProject?: Maybe<Scalars['Boolean']>;
  emailAssignedAttorneysWhenAssociateAssignedToProject?: Maybe<Scalars['Boolean']>;
  emailAssignedAttorneysWhenAssociateDeletesProject?: Maybe<Scalars['Boolean']>;
  emailAssignedAttorneysWhenAssociateIsRemovedFromProject?: Maybe<Scalars['Boolean']>;
  emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: Maybe<Scalars['Boolean']>;
  emailContributorWhenAssociateCreatesProject: Scalars['Boolean'];
  emailContributorWhenAssociateDeletesProject: Scalars['Boolean'];
  emailContributorWhenAssociateIsRemovedFromProject: Scalars['Boolean'];
  emailContributorWhenAttorneyCreatesProject: Scalars['Boolean'];
  emailSummerAssociateWhenAssignedToProject?: Maybe<Scalars['Boolean']>;
  emails?: Maybe<Array<Maybe<EmailForm>>>;
  endDate?: Maybe<Scalars['String']>;
  evaluationQuestions?: Maybe<Array<Maybe<ProgramFeedbackNode>>>;
  groups: Array<ProgramGroupNode>;
  id: Scalars['ID'];
  matters?: Maybe<Array<Maybe<MatterNode>>>;
  ownerUser?: Maybe<UserNode>;
  ownerUserId?: Maybe<Scalars['ID']>;
  programAssociates?: Maybe<Array<Maybe<CandidateNode>>>;
  startDate?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ProgramPreferredPracticeArea = {
  order: Scalars['Int'];
  orgSpecificPracticeAreaId?: Maybe<Scalars['ID']>;
  practiceAreaId?: Maybe<Scalars['ID']>;
  preferredPracticeAreaName?: Maybe<Scalars['String']>;
};

export type ProjectEvaluationResponseNode = Node & {
  associateRecruitId: Scalars['ID'];
  attorneyUserId: Scalars['ID'];
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  matterId: Scalars['ID'];
  programId: Scalars['ID'];
  requestedAt?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['String']>;
};

export type PublicCandidateJobAppDocumentResponseNode = {
  createdAt?: Maybe<Scalars['String']>;
  documentName?: Maybe<Scalars['String']>;
  jobAppDocumentId?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['String']>;
  orgCustomDocName?: Maybe<Scalars['String']>;
  orgDocId?: Maybe<Scalars['Int']>;
};

export type PublicCandidateJobAppEducationHistoryNode = {
  degree?: Maybe<UniversityDegreeEnum>;
  degreeEnum?: Maybe<Scalars['Int']>;
  endDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobAppId?: Maybe<Scalars['Int']>;
  startDate?: Maybe<Scalars['String']>;
  university?: Maybe<Scalars['String']>;
};

export type PublicCandidateJobAppNode = {
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  answers?: Maybe<Array<Maybe<JobAppQuestionAnswerNode>>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creationType?: Maybe<Scalars['String']>;
  educationHistory?: Maybe<Array<Maybe<PublicCandidateJobAppEducationHistoryNode>>>;
  id?: Maybe<Scalars['Int']>;
  isComplete?: Maybe<Scalars['Boolean']>;
  jobAppDocuments?: Maybe<Array<Maybe<PublicCandidateJobAppDocumentResponseNode>>>;
  jobId?: Maybe<Scalars['Int']>;
  missingInfoRequestToAgencyContact?: Maybe<Scalars['Boolean']>;
  missingInfoRequestToCandidate?: Maybe<Scalars['Boolean']>;
  recruitId?: Maybe<Scalars['Int']>;
  sections?: Maybe<Array<Maybe<PublicCandidateJobAppSectionNode>>>;
  selfIdAnswers?: Maybe<Array<Maybe<PublicJobAppSelfIdQuestionAnswerGraph>>>;
  state?: Maybe<Scalars['String']>;
  workHistory?: Maybe<Array<Maybe<PublicCandidateJobAppWorkHistoryNode>>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PublicCandidateJobAppSectionNode = {
  id?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  sectionDescription?: Maybe<Scalars['String']>;
  sectionId?: Maybe<Scalars['Int']>;
  sectionName?: Maybe<Scalars['String']>;
  sectionType?: Maybe<JobSectionType>;
};

export type PublicCandidateJobAppWorkHistoryNode = {
  employer?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isCurrentEmployer?: Maybe<Scalars['Boolean']>;
  jobAppId?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
};

export type PublicJobAppSelfIdQuestionAnswerGraph = {
  id: Scalars['ID'];
  jobAppId?: Maybe<Scalars['Int']>;
  jobAppSelfIdQuestionAnswerSelections?: Maybe<Array<Maybe<JobAppSelfIdQuestionAnswerSelectionGraph>>>;
  orgSelfIdQuestionId?: Maybe<Scalars['Int']>;
  orgSelfIdQuestionOptions?: Maybe<Array<Maybe<OrgSelfIdQuestionOptionNode>>>;
  text?: Maybe<Scalars['String']>;
};

export type PublicJobAppSelfIdQuestionAnswerSelectionGraph = {
  id: Scalars['ID'];
  orgSelfIdQuestionOptionId?: Maybe<Scalars['Int']>;
};

export type PublicJobCandidateDocumentGraph = {
  docName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  jobSectionId?: Maybe<Scalars['Int']>;
  orgDocId?: Maybe<Scalars['Int']>;
};

export type PublicJobGraph = {
  closeDate?: Maybe<Scalars['String']>;
  closeTimezone?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  departments?: Maybe<Array<Maybe<JobDepartmentGraph>>>;
  description?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobEmploymentTypes?: Maybe<Array<Maybe<JobEmploymentTypeGraph>>>;
  jobOffices?: Maybe<Array<Maybe<JobOfficeGraph>>>;
  jobSections?: Maybe<Array<Maybe<PublicJobSectionGraph>>>;
  openDate?: Maybe<Scalars['String']>;
  openTimezone?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  positionTypes?: Maybe<Array<Maybe<JobPositionTypeGraph>>>;
  title?: Maybe<Scalars['String']>;
};

export type PublicJobSectionGraph = {
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  jobCandidateDocuments?: Maybe<Array<Maybe<PublicJobCandidateDocumentGraph>>>;
  jobId?: Maybe<Scalars['Int']>;
  jobQuestions?: Maybe<Array<Maybe<JobQuestionNode>>>;
  jobSectionType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

/** TODO: Make into an interface, with separate implementations for Firm vs. School */
export type PublicOrgInfo = Node & {
  firmPracticeAreas?: Maybe<OrgPracticeAreaConnection>;
  /**
   * Will return `null` if the user cannot see the firm profile:
   *
   * - If the firm profile is public, anyone can see it.
   * - If the user is an admin, they can always see their own firm profile.
   * - If the user is a super admin, they can always see any firm profile.
   */
  firmProfile?: Maybe<FirmProfileNode>;
  forwardTier?: Maybe<ForwardTierNode>;
  hasPublicFirmProfile: Scalars['Boolean'];
  id: Scalars['ID'];
  isAtsCustomer: Scalars['Boolean'];
  isFloCustomer?: Maybe<Scalars['Boolean']>;
  logoUrl?: Maybe<Scalars['Url']>;
  name?: Maybe<Scalars['String']>;
  /** The locations at which the firm has offices. */
  officeLocations?: Maybe<OfficeLocationConnection>;
  /** The offices that this firm has. */
  offices: OrgOfficeConnection;
  /** Jobs of the firm that are currently open. Sorted by close date, ascending. */
  openJobs?: Maybe<JobConnection>;
  /** Same as `id`; this field was present before we decided to make the type a `Node`. */
  orgId: Scalars['ID'];
  /** Whether the Firm requests DEI info. */
  requestsDei: Scalars['Boolean'];
  urlFriendlyName?: Maybe<Scalars['String']>;
};


/** TODO: Make into an interface, with separate implementations for Firm vs. School */
export type PublicOrgInfoFirmPracticeAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** TODO: Make into an interface, with separate implementations for Firm vs. School */
export type PublicOrgInfoOfficeLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** TODO: Make into an interface, with separate implementations for Firm vs. School */
export type PublicOrgInfoOfficesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** TODO: Make into an interface, with separate implementations for Firm vs. School */
export type PublicOrgInfoOpenJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type PublicOrgInfoConnection = Connection & {
  edges: Array<PublicOrgInfoEdge>;
  nodes: Array<PublicOrgInfo>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PublicOrgInfoEdge = Edge & {
  cursor: Scalars['String'];
  node: PublicOrgInfo;
};

export type PublicOrgSelfIdQuestionNode = {
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orgSelfIdQuestionOptions?: Maybe<Array<Maybe<PublicOrgSelfIdQuestionOptionNode>>>;
  questionType?: Maybe<Scalars['String']>;
  selfIdDefaultId?: Maybe<Scalars['Int']>;
  selfIdType?: Maybe<Scalars['String']>;
};

export type PublicOrgSelfIdQuestionOptionNode = {
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PublicUniversityOrgConnection = Connection & {
  edges: Array<PublicUniversityOrgEdge>;
  nodes: Array<PublicUniversityOrgNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type PublicUniversityOrgEdge = Edge & {
  cursor: Scalars['String'];
  node: PublicUniversityOrgNode;
};

export type PublicUniversityOrgNode = Node & {
  /** May be multiple if the University Org is a Consortium. */
  associatedLawSchools?: Maybe<LawSchoolConnection>;
  emailDomain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFloCustomer?: Maybe<Scalars['Boolean']>;
  logoUrl?: Maybe<Scalars['Url']>;
  name?: Maybe<Scalars['String']>;
  /** Same as `id`; this field was present before we decided to make the type a `Node`. */
  orgId: Scalars['ID'];
  urlFriendlyName?: Maybe<Scalars['String']>;
};


export type PublicUniversityOrgNodeAssociatedLawSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type QualifyingQuestionAnswerConnection = Connection & {
  edges: Array<QualifyingQuestionAnswerEdge>;
  nodes: Array<QualifyingQuestionAnswerNode>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QualifyingQuestionAnswerEdge = Edge & {
  cursor: Scalars['String'];
  node: QualifyingQuestionAnswerNode;
};

export type QualifyingQuestionAnswerInput = {
  answer?: InputMaybe<Scalars['String']>;
  questionId: Scalars['Int'];
};

export type QualifyingQuestionAnswerNode = Node & {
  /**
   * The Applicant's answer to the Question as a `String`.
   *
   * - For Questions with Presets, this will be the name of the Preset
   * - For the Law School Question, this will be the name of the Law School
   * - For the Graduation Date Question, this will be of the form "Spring 2024"
   */
  answerString?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  question?: Maybe<QualifyingQuestionNode>;
  questionId: Scalars['ID'];
  recruitId: Scalars['ID'];
};

export type QualifyingQuestionConnection = Connection & {
  edges: Array<QualifyingQuestionEdge>;
  nodes: Array<QualifyingQuestionNode>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QualifyingQuestionEdge = Edge & {
  cursor: Scalars['String'];
  node: QualifyingQuestionNode;
};

export type QualifyingQuestionEventAssignmentConnection = Connection & {
  edges: Array<QualifyingQuestionEventAssignmentEdge>;
  nodes: Array<QualifyingQuestionEventAssignmentNode>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QualifyingQuestionEventAssignmentEdge = Edge & {
  cursor: Scalars['String'];
  node: QualifyingQuestionEventAssignmentNode;
};

export type QualifyingQuestionEventAssignmentNode = Node & {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  question?: Maybe<QualifyingQuestionNode>;
  questionId: Scalars['ID'];
};

/** The degree to which an Admin can update a Question. */
export enum QualifyingQuestionMutability {
  /** Cannot update Question name. Can update Question type and presets. */
  Locked = 'LOCKED',
  /** Cannot update any aspect of the Question. */
  LockedByFlo = 'LOCKED_BY_FLO',
  /** Can update Question name, type, and presets. */
  Unlocked = 'UNLOCKED'
}

export type QualifyingQuestionNode = Node & {
  /** If this is non-`null`, it trumps the regular `type` field. */
  distinguishedType?: Maybe<DistinguishedQualifyingQuestionType>;
  id: Scalars['ID'];
  /** The degree to which an Admin can update this Question. */
  mutability?: Maybe<QualifyingQuestionMutability>;
  /**
   * The logged-in Applicant's answers for this Question. Cases of multiple answers include:
   *
   * - Multi-select Questions
   * - The Law School Question
   * - The Applicant has answered the Question multiple times under different Recruit ids (i.e. signed in with different emails)
   */
  myAnswers?: Maybe<QualifyingQuestionAnswerConnection>;
  name?: Maybe<Scalars['String']>;
  orgId: Scalars['ID'];
  /** `null` if the Question does not have Presets, e.g. if it's a free text or the distinguished Law School Question. */
  presets?: Maybe<QualifyingQuestionPresetConnection>;
  /** The input method that should be used for answering this Question. */
  type?: Maybe<QualifyingQuestionType>;
};


export type QualifyingQuestionNodeMyAnswersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QualifyingQuestionNodePresetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type QualifyingQuestionPresetConnection = Connection & {
  edges: Array<QualifyingQuestionPresetEdge>;
  nodes: Array<QualifyingQuestionPresetNode>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type QualifyingQuestionPresetEdge = Edge & {
  cursor: Scalars['String'];
  node: QualifyingQuestionPresetNode;
};

export type QualifyingQuestionPresetNode = Node & {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  orgId: Scalars['ID'];
  questionId: Scalars['ID'];
};

export enum QualifyingQuestionType {
  FreeText = 'FREE_TEXT',
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT',
  YesOrNo = 'YES_OR_NO'
}

export type Query = {
  activeInternalFieldQuestions?: Maybe<Array<Maybe<InternalFieldQuestionNode>>>;
  agencies?: Maybe<Array<Maybe<AgencyNode>>>;
  agency?: Maybe<AgencyNode>;
  agencyContact?: Maybe<AgencyContactNode>;
  agencyContacts?: Maybe<Array<Maybe<AgencyContactNode>>>;
  /** Returns list of Forward tiers. Will return sorted by tier order, ascending. Pagination is optional. */
  allForwardTiers?: Maybe<ForwardTierConnection>;
  allLanguages: Array<LanguageNode>;
  /** @deprecated Use 'allSchoolDegrees' instead */
  allLawDegrees?: Maybe<LawDegreeConnection>;
  /** @deprecated Use 'LawSchoolClassYear' enum instead */
  allLawSchoolClassifications?: Maybe<LawSchoolClassificationConnection>;
  allLawSchools?: Maybe<LawSchoolConnection>;
  allOfficeLocations?: Maybe<OfficeLocationConnection>;
  allPracticeAreas?: Maybe<PracticeAreaConnection>;
  allPracticeCategories?: Maybe<PracticeCategoryConnection>;
  allSchoolDegrees: SchoolDegreeConnection;
  allSchools: SchoolConnection;
  allUniversities: UniversityConnection;
  archivedWorkplaces: WorkplaceConnection;
  assignedWorkAllocationMattersForAssociate: Array<MatterNode>;
  availableTimeSlotsForJob?: Maybe<Array<Maybe<InterviewSchedulingAvailableTimeSlotNode>>>;
  /** Available to any user. */
  candidateEventById?: Maybe<CandidateEventNode>;
  candidateMissingInfoRequestJobEmailTemplate?: Maybe<CandidateMissingInfoRequestJobEmailTemplateNode>;
  conflictingJobAppsOfCandidates: Array<ConflictingJobAppsNode>;
  eventById?: Maybe<EventNode>;
  eventDirectory?: Maybe<EventDirectoryConnection>;
  eventEvaluationQuestionsByEventIds: Array<EventEvaluationQuestionNode>;
  fetchAppSourceOptions?: Maybe<Array<Maybe<AppSourceGraph>>>;
  fetchCandidateOrgSelfIdQuestionAnswers?: Maybe<Array<Maybe<OrgSelfIdQuestionAnswerNode>>>;
  fetchSelfIdJobsCount?: Maybe<Scalars['Int']>;
  findAgencyByLoggedInUserEmail?: Maybe<AgencyNode>;
  findPossibleDuplicateAgencies?: Maybe<Array<Maybe<AgencyNode>>>;
  firmDirectory?: Maybe<PublicOrgInfoConnection>;
  firmProfileByFirmFriendlyName?: Maybe<FirmProfileNode>;
  firmProfileByFirmId?: Maybe<FirmProfileNode>;
  flagFromKey?: Maybe<FeatureFlagNode>;
  flags?: Maybe<Array<Maybe<FeatureFlagNode>>>;
  /** `null` if account doesn't exist for currently logged-in user. */
  forwardAccount?: Maybe<ForwardAccountNode>;
  forwardAppliedJobIds?: Maybe<Array<Scalars['ID']>>;
  /** Available to logged in users */
  forwardCandidateEventById?: Maybe<CandidateEventNode>;
  /** `null` if the user is not logged in. */
  forwardEventsInterviewsFeed?: Maybe<ForwardEventsInterviewsFeedConnection>;
  forwardJobApplicationFeed?: Maybe<ForwardJobApplicationFeedConnection>;
  forwardJobBookmarks?: Maybe<ForwardJobBookmarkConnection>;
  /** Only returns ATS or External jobs. */
  forwardJobById?: Maybe<JobFeedNode>;
  forwardJobFeed?: Maybe<JobFeedConnection>;
  /**
   * Returns `null` if a job is not found for that `id`, or if it should not be visible to a general candidate.
   *
   * For example, interview scheduling jobs should only be visible to candidates who are attending the corresponding event, so they will not be visible here.
   */
  forwardJobsById: Array<Maybe<JobNode>>;
  forwardTierById?: Maybe<ForwardTierNode>;
  getCandidate?: Maybe<CandidateNode>;
  getCandidateReviewContentForCandidate: CandidateReviewContentNode;
  getCandidateReviewTemplate: CandidateReviewTemplateNode;
  getCandidateReviewTemplatesForOrg: Array<Maybe<CandidateReviewTemplateNode>>;
  getCandidates?: Maybe<Array<Maybe<CandidateNode>>>;
  getCandidatesByAppSourceAndBucket?: Maybe<ConversionReportConnection>;
  getCandidatesByLawSchoolAndBucket?: Maybe<ConversionReportConnection>;
  getCandidatesForCandidateDataTable?: Maybe<ConversionReportConnection>;
  getCandidatesOfEvents?: Maybe<Array<Maybe<CandidateNode>>>;
  getCandidatesOfJob?: Maybe<CandidateConnection>;
  getCandidatesOfJobs?: Maybe<CandidateConnection>;
  getCandidatesOfPrograms?: Maybe<Array<Maybe<CandidateNode>>>;
  getCandidatesSCLP?: Maybe<CandidateConnection>;
  getCannedReport: CannedReportNode;
  getConversionReportCandidates?: Maybe<ConversionReportConnection>;
  getConversionReportDataTable?: Maybe<ConversionReportDataTable>;
  getConversionReportSankeyData?: Maybe<ConversionReportVisual>;
  getHistoricalCandidateByEmail?: Maybe<HistoricalCandidateNode>;
  getHistoricalCandidateByRecruitId?: Maybe<HistoricalCandidateNode>;
  getNotificationsForCandidate?: Maybe<Array<Maybe<CandidateNotificationNode>>>;
  getNotificationsForCandidateByJobId?: Maybe<Array<Maybe<CandidateNotificationNode>>>;
  getNotificationsForJob?: Maybe<Array<Maybe<CandidateNotificationNode>>>;
  getOrg?: Maybe<OrgNode>;
  getOrgEmployerMember?: Maybe<OrgNode>;
  getOrgHistoricalData?: Maybe<Array<Maybe<HistoricalCandidateNode>>>;
  getSavedCannedReportsForOrg: Array<Maybe<CannedReportNode>>;
  getSavedEvaluationQuestionTemplatesForOrg: Array<Maybe<EvaluationQuestionTemplateNode>>;
  getTotalAppSourceCandidatesByBucket?: Maybe<ConversionReportConnection>;
  getTotalBucketValuesForAppSourceDataTable?: Maybe<SourceValue>;
  getTotalBucketValuesForLawSchoolDataTable?: Maybe<LawSchoolValue>;
  getTotalLawSchoolCandidatesByBucket?: Maybe<ConversionReportConnection>;
  /** For load testing (simple database query). Equivalent to our corresponding REST endpoint. */
  healthCheck: Scalars['String'];
  internalFieldQuestions?: Maybe<Array<Maybe<InternalFieldQuestionNode>>>;
  interviewSchedulingEventAttendees?: Maybe<Array<Maybe<InterviewSchedulingEventAttendeeNode>>>;
  job?: Maybe<JobGraph>;
  jobApps?: Maybe<Array<Maybe<JobAppNode>>>;
  jobAppsOfCandidate?: Maybe<Array<Maybe<JobAppNode>>>;
  jobQuestion?: Maybe<JobQuestionNode>;
  jobs?: Maybe<Array<Maybe<JobGraph>>>;
  jobsForPipelineTemplate?: Maybe<Array<Maybe<JobGraph>>>;
  jobsFromIds: Array<JobGraph>;
  lawSchoolById?: Maybe<LawSchoolNode>;
  lawSchoolsById: Array<Maybe<LawSchoolNode>>;
  lotteryEmployerEventById?: Maybe<LotteryEmployerEventNode>;
  lotteryUniversityEventById?: Maybe<LotteryUniversityEventNode>;
  lotteryUniversityEventByIdForStudent?: Maybe<LotteryStudentEventNode>;
  matterEvaluationAnswersByAttorney: Array<MatterEvaluationAnswerNode>;
  matterPet?: Maybe<MatterPetNode>;
  memberById?: Maybe<MemberNode>;
  officeLocationById?: Maybe<OfficeLocationNode>;
  officeLocationsById: Array<Maybe<OfficeLocationNode>>;
  orgSelfIdQuestion?: Maybe<OrgSelfIdQuestionNode>;
  orgSelfIdQuestions?: Maybe<Array<Maybe<OrgSelfIdQuestionNode>>>;
  practiceAreaById?: Maybe<PracticeAreaNode>;
  practiceAreasById: Array<Maybe<PracticeAreaNode>>;
  practiceCategoriesById?: Maybe<Array<Maybe<PracticeCategoryNode>>>;
  practiceCategoryById?: Maybe<PracticeCategoryNode>;
  programAssociateByEmployeeEmail?: Maybe<ProgramAssociate>;
  programAssociateByRecruitId: ProgramAssociate;
  programAssociateByRecruitIdAndProgramId: ProgramAssociate;
  programAssociatesByProgramId: Array<ProgramAssociate>;
  programAssociatesByRecruitIds: Array<ProgramAssociate>;
  programAssociatesForOrg: Array<ProgramAssociate>;
  /** Get a program group by ID */
  programGroup?: Maybe<ProgramGroupNode>;
  /** Get all groups in a program */
  programGroups: Array<ProgramGroupNode>;
  programTitle: Scalars['String'];
  publicCandidateJobApp?: Maybe<PublicCandidateJobAppNode>;
  publicCandidateJobAppOfRecruit?: Maybe<PublicCandidateJobAppNode>;
  publicCandidateOrgJobApps?: Maybe<Array<Maybe<PublicCandidateJobAppNode>>>;
  publicJob?: Maybe<PublicJobGraph>;
  publicJobForAgencyContactByExtension?: Maybe<PublicJobGraph>;
  publicJobsForAgencyContact?: Maybe<Array<Maybe<PublicJobGraph>>>;
  publicOrgInfoByOrgFriendlyName?: Maybe<PublicOrgInfo>;
  publicOrgInfoByOrgId?: Maybe<PublicOrgInfo>;
  publicOrgSelfIdQuestions?: Maybe<Array<Maybe<PublicOrgSelfIdQuestionNode>>>;
  publicUniversityOrgs?: Maybe<PublicUniversityOrgConnection>;
  /** Admin-only. */
  qualifyingQuestionsForOrg?: Maybe<QualifyingQuestionConnection>;
  registeredAgencies?: Maybe<Array<Maybe<AgencyNode>>>;
  schoolById?: Maybe<SchoolNode>;
  schoolsById?: Maybe<Array<Maybe<SchoolNode>>>;
  selfIdDefaultOptions?: Maybe<SelfIdDefaultOptionConnection>;
  selfIdDefaults?: Maybe<SelfIdDefaultConnection>;
  selfIdDefaultsByType: Array<SelfIdDefaultNode>;
  studentBidList?: Maybe<LotteryStudentBidListNode>;
  studentInterviewSchedulingApplications?: Maybe<InterviewSchedulingStudentApplicationConnection>;
  studentInterviewSchedulingOfficeLocationsPreferencesForJobs?: Maybe<Array<Maybe<InterviewSchedulingStudentOfficeLocationPreferencesListForJobNode>>>;
  studentInterviewSchedulingPracticeAreasPreferencesForJobs?: Maybe<Array<Maybe<InterviewSchedulingStudentPracticeAreaPreferencesListForJobNode>>>;
  studentListOfAvailableJobs?: Maybe<LotteryAvailableStudentJobsNode>;
  studentLotteryMatches?: Maybe<LotteryStudentMatchConnection>;
  studentLotteryUnmatchedBids?: Maybe<LotteryStudentBidConnection>;
  superAdminExternalJobImportBatchById?: Maybe<ExternalJobImportBatchNode>;
  superAdminExternalJobImportBatches?: Maybe<ExternalJobImportBatchConnection>;
  superAdminExternalJobImportById?: Maybe<ExternalJobImportNode>;
  superAdminGetAllActiveOrgs: Array<OrgNode>;
  superAdminGetDocumentsForFirm: Array<SuperAdminFirmDocument>;
  superAdminGetEventForOrg?: Maybe<EventNode>;
  superAdminGetEventsForOrg: Array<EventNode>;
  /** TODO: More filter opportunities (e.g. exclude existing ATS firms) */
  superAdminGetExistingFirms: Array<SuperAdminFirm>;
  superAdminGetFirm?: Maybe<SuperAdminFirm>;
  superAdminGetFirmPracticeAreas?: Maybe<OrgPracticeAreaConnection>;
  superAdminGetOfficesForFirm: Array<SuperAdminFirmOffice>;
  superAdminGetOrg?: Maybe<OrgNode>;
  superAdminGetOrgForwardPrivileges?: Maybe<OrgForwardPrivilegesNode>;
  superAdminGetSsoConnectionOptions?: Maybe<Array<SsoAuthInfoNode>>;
  superAdminMostRecentFirmForwardRotationLogByActionType?: Maybe<SuperAdminFirmForwardRotationLog>;
  superAdminMostRecentFirmForwardRotationLogsByActionType: Array<Maybe<SuperAdminFirmForwardRotationLog>>;
  /** Shows data we have in the database for law school names that aren't in the law school dropdown. */
  superAdminOutlierLawSchoolData?: Maybe<SuperAdminLawSchoolOutlierData>;
  /** Shows data we have in the database for office location names that aren't in the office location dropdown. */
  superAdminOutlierOfficeLocationData?: Maybe<SuperAdminOfficeLocationOutlierData>;
  /** Shows data we have in the database for practice area names that aren't in the practice area dropdown. */
  superAdminOutlierPracticeAreaData?: Maybe<SuperAdminPracticeAreaOutlierData>;
  tagById?: Maybe<TagNode>;
  test: TestObject;
  /** For load testing (evaluation of feature flag). */
  testFeatureFlag: Scalars['Boolean'];
  /** For load testing (parsing/validating GraphQL document). The arguments are not used in resolving the query. */
  testObject: TestObject;
  /** For load testing (simple query). */
  testString: Scalars['String'];
  unassignedWorkAllocationMattersForAssociate: Array<MatterNode>;
  universitiesById?: Maybe<Array<Maybe<UniversityNode>>>;
  universityById?: Maybe<UniversityNode>;
  unregisteredAgencies?: Maybe<Array<Maybe<AgencyNode>>>;
  /** `null` if the user is anonymous. */
  userAnalyticsInfo?: Maybe<UserAnalyticsInfo>;
  userWorkAllocationPermissions?: Maybe<UserWorkAllocationPermissions>;
  /** Authentication-relevant information about requester. */
  whoAmI: WhoAmI;
  workAllocationEvaluationsForAssociate?: Maybe<Array<Maybe<CustomEvaluationResponseNode>>>;
  workAllocationEvaluationsForAttorney?: Maybe<EvaluationResponse>;
  workAllocationMatter: MatterNode;
  /** @deprecated Use 'workAllocationMatter' instead */
  workAllocationMatterForAssociate: MatterNode;
  workAllocationMattersByAssociate: Array<MatterNode>;
  workAllocationMattersByProgram: Array<MatterNode>;
  workAllocationMattersForAssociate: Array<MatterNode>;
  workAllocationOrgAssociates: Array<CandidateNode>;
  workAllocationOrgPrograms: Array<ProgramNode>;
  workAllocationProgram: ProgramNode;
  workAllocationProgramForAssociate: ProgramNode;
  workAllocationPrograms: Array<ProgramNode>;
  workplaceById?: Maybe<WorkplaceNode>;
  /** Returns non-archived Workplaces, sorted alphabetically (ascending). */
  workplaces: WorkplaceConnection;
  workplacesById: Array<Maybe<WorkplaceNode>>;
};


export type QueryAgencyArgs = {
  agencyId?: InputMaybe<Scalars['Int']>;
};


export type QueryAgencyContactArgs = {
  agencyContactId?: InputMaybe<Scalars['Int']>;
};


export type QueryAgencyContactsArgs = {
  agencyContactIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryAllForwardTiersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllLawDegreesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllLawSchoolClassificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllLawSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<LawSchoolFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllOfficeLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<OfficeLocationFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllPracticeAreasArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<PracticeAreaFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllPracticeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllSchoolDegreesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAllUniversitiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryArchivedWorkplacesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryAssignedWorkAllocationMattersForAssociateArgs = {
  programId: Scalars['ID'];
};


export type QueryAvailableTimeSlotsForJobArgs = {
  scheduleId: Scalars['Int'];
  studentExtension?: InputMaybe<Scalars['String']>;
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryCandidateEventByIdArgs = {
  id: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
};


export type QueryCandidateMissingInfoRequestJobEmailTemplateArgs = {
  jobId: Scalars['Int'];
};


export type QueryConflictingJobAppsOfCandidatesArgs = {
  recruitId1: Scalars['Int'];
  recruitId2: Scalars['Int'];
};


export type QueryEventByIdArgs = {
  eventId?: InputMaybe<Scalars['Int']>;
};


export type QueryEventDirectoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<EventDirectoryFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Array<EventDirectorySortBy>>;
};


export type QueryEventEvaluationQuestionsByEventIdsArgs = {
  eventIds: Array<Scalars['Int']>;
};


export type QueryFetchCandidateOrgSelfIdQuestionAnswersArgs = {
  recruitId?: InputMaybe<Scalars['Int']>;
};


export type QueryFetchSelfIdJobsCountArgs = {
  orgFriendlyName?: InputMaybe<Scalars['String']>;
};


export type QueryFindPossibleDuplicateAgenciesArgs = {
  agencyId: Scalars['ID'];
  agencyName: Scalars['String'];
};


export type QueryFirmDirectoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<FirmDirectoryFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Array<FirmDirectorySortBy>>;
};


export type QueryFirmProfileByFirmFriendlyNameArgs = {
  firmFriendlyName: Scalars['String'];
};


export type QueryFirmProfileByFirmIdArgs = {
  firmId: Scalars['ID'];
};


export type QueryFlagFromKeyArgs = {
  key: Scalars['String'];
};


export type QueryForwardCandidateEventByIdArgs = {
  id: Scalars['ID'];
};


export type QueryForwardEventsInterviewsFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardEventsInterviewsFeedFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryForwardJobApplicationFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobApplicationFeedFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<ForwardJobApplicationFeedSortBy>;
};


export type QueryForwardJobBookmarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobBookmarkFeedFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryForwardJobByIdArgs = {
  id: Scalars['ID'];
};


export type QueryForwardJobFeedArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Array<JobFeedSortBy>>;
};


export type QueryForwardJobsByIdArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryForwardTierByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetCandidateArgs = {
  candidateId: Scalars['Int'];
};


export type QueryGetCandidateReviewContentForCandidateArgs = {
  candidateReviewTemplateId: Scalars['Int'];
  recruitId: Scalars['Int'];
};


export type QueryGetCandidateReviewTemplateArgs = {
  candidateReviewTemplateId: Scalars['Int'];
};


export type QueryGetCandidatesArgs = {
  recruitIds: Array<Scalars['Int']>;
};


export type QueryGetCandidatesByAppSourceAndBucketArgs = {
  after?: InputMaybe<Scalars['String']>;
  appSourceName: Scalars['String'];
  bucket: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};


export type QueryGetCandidatesByLawSchoolAndBucketArgs = {
  after?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  lawSchoolName: Scalars['String'];
};


export type QueryGetCandidatesForCandidateDataTableArgs = {
  after?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  filterBy?: InputMaybe<ConversionReportFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  targetBucket?: InputMaybe<Scalars['String']>;
};


export type QueryGetCandidatesOfEventsArgs = {
  eventIds: Array<Scalars['Int']>;
};


export type QueryGetCandidatesOfJobArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCandidatesOfJobsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  jobIds: Array<Scalars['Int']>;
};


export type QueryGetCandidatesOfProgramsArgs = {
  programIds: Array<Scalars['Int']>;
};


export type QueryGetCandidatesSclpArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<CandidateFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<CandidateSortBy>;
};


export type QueryGetCannedReportArgs = {
  cannedReportId: Scalars['Int'];
};


export type QueryGetConversionReportCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ConversionReportFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};


export type QueryGetConversionReportDataTableArgs = {
  id: Scalars['ID'];
};


export type QueryGetConversionReportSankeyDataArgs = {
  id: Scalars['ID'];
};


export type QueryGetHistoricalCandidateByEmailArgs = {
  email?: InputMaybe<Scalars['String']>;
};


export type QueryGetHistoricalCandidateByRecruitIdArgs = {
  recruitId?: InputMaybe<Scalars['Int']>;
};


export type QueryGetNotificationsForCandidateArgs = {
  recruitId: Scalars['Int'];
};


export type QueryGetNotificationsForCandidateByJobIdArgs = {
  jobId: Scalars['Int'];
  recruitId: Scalars['Int'];
};


export type QueryGetNotificationsForJobArgs = {
  jobId: Scalars['Int'];
};


export type QueryGetTotalAppSourceCandidatesByBucketArgs = {
  after?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};


export type QueryGetTotalBucketValuesForAppSourceDataTableArgs = {
  id: Scalars['ID'];
};


export type QueryGetTotalBucketValuesForLawSchoolDataTableArgs = {
  id: Scalars['ID'];
};


export type QueryGetTotalLawSchoolCandidatesByBucketArgs = {
  after?: InputMaybe<Scalars['String']>;
  bucket: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};


export type QueryInterviewSchedulingEventAttendeesArgs = {
  universityEventId: Scalars['Int'];
};


export type QueryJobArgs = {
  jobId?: InputMaybe<Scalars['Int']>;
};


export type QueryJobAppsArgs = {
  jobId?: InputMaybe<Scalars['Int']>;
};


export type QueryJobAppsOfCandidateArgs = {
  recruitId?: InputMaybe<Scalars['Int']>;
};


export type QueryJobQuestionArgs = {
  jobId?: InputMaybe<Scalars['Int']>;
  jobQuestionId?: InputMaybe<Scalars['Int']>;
};


export type QueryJobsForPipelineTemplateArgs = {
  pipelineTemplateId?: InputMaybe<Scalars['Int']>;
};


export type QueryJobsFromIdsArgs = {
  jobIds: Array<Scalars['Int']>;
};


export type QueryLawSchoolByIdArgs = {
  id: Scalars['ID'];
};


export type QueryLawSchoolsByIdArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryLotteryEmployerEventByIdArgs = {
  employerEventId: Scalars['Int'];
};


export type QueryLotteryUniversityEventByIdArgs = {
  universityEventId: Scalars['Int'];
};


export type QueryLotteryUniversityEventByIdForStudentArgs = {
  studentExtension: Scalars['String'];
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryMatterEvaluationAnswersByAttorneyArgs = {
  attorneyId: Scalars['String'];
};


export type QueryMatterPetArgs = {
  matterId: Scalars['ID'];
};


export type QueryMemberByIdArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryOfficeLocationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryOfficeLocationsByIdArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryOrgSelfIdQuestionArgs = {
  orgFriendlyName?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['Int']>;
};


export type QueryOrgSelfIdQuestionsArgs = {
  orgFriendlyName?: InputMaybe<Scalars['String']>;
};


export type QueryPracticeAreaByIdArgs = {
  id: Scalars['ID'];
};


export type QueryPracticeAreasByIdArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPracticeCategoriesByIdArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPracticeCategoryByIdArgs = {
  id: Scalars['ID'];
};


export type QueryProgramAssociateByEmployeeEmailArgs = {
  email: Scalars['String'];
};


export type QueryProgramAssociateByRecruitIdArgs = {
  associateRecruitId: Scalars['Int'];
};


export type QueryProgramAssociateByRecruitIdAndProgramIdArgs = {
  associateRecruitId: Scalars['Int'];
  programId: Scalars['ID'];
};


export type QueryProgramAssociatesByProgramIdArgs = {
  programId: Scalars['ID'];
};


export type QueryProgramAssociatesByRecruitIdsArgs = {
  associateRecruitIds: Array<Scalars['Int']>;
  programId: Scalars['ID'];
};


export type QueryProgramGroupArgs = {
  id: Scalars['ID'];
};


export type QueryProgramGroupsArgs = {
  programId: Scalars['ID'];
};


export type QueryProgramTitleArgs = {
  programId: Scalars['ID'];
};


export type QueryPublicCandidateJobAppArgs = {
  jobExtension?: InputMaybe<Scalars['String']>;
  orgFriendlyName?: InputMaybe<Scalars['String']>;
};


export type QueryPublicCandidateJobAppOfRecruitArgs = {
  jobExtension?: InputMaybe<Scalars['String']>;
  orgFriendlyName?: InputMaybe<Scalars['String']>;
  recruitId?: InputMaybe<Scalars['Int']>;
};


export type QueryPublicCandidateOrgJobAppsArgs = {
  orgFriendlyName?: InputMaybe<Scalars['String']>;
};


export type QueryPublicJobArgs = {
  jobExtension?: InputMaybe<Scalars['String']>;
  orgFriendlyName?: InputMaybe<Scalars['String']>;
};


export type QueryPublicJobForAgencyContactByExtensionArgs = {
  jobExtension?: InputMaybe<Scalars['String']>;
};


export type QueryPublicOrgInfoByOrgFriendlyNameArgs = {
  orgFriendlyName: Scalars['String'];
};


export type QueryPublicOrgInfoByOrgIdArgs = {
  orgId: Scalars['ID'];
};


export type QueryPublicOrgSelfIdQuestionsArgs = {
  orgFriendlyName?: InputMaybe<Scalars['String']>;
};


export type QueryPublicUniversityOrgsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryQualifyingQuestionsForOrgArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySchoolByIdArgs = {
  id: Scalars['ID'];
};


export type QuerySchoolsByIdArgs = {
  ids: Array<Scalars['ID']>;
};


export type QuerySelfIdDefaultOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySelfIdDefaultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySelfIdDefaultsByTypeArgs = {
  type: SelfIdType;
};


export type QueryStudentBidListArgs = {
  studentExtension: Scalars['String'];
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryStudentInterviewSchedulingApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  studentExtension: Scalars['String'];
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryStudentInterviewSchedulingOfficeLocationsPreferencesForJobsArgs = {
  studentExtension: Scalars['String'];
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryStudentInterviewSchedulingPracticeAreasPreferencesForJobsArgs = {
  studentExtension: Scalars['String'];
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryStudentListOfAvailableJobsArgs = {
  studentExtension?: InputMaybe<Scalars['String']>;
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryStudentLotteryMatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  studentExtension: Scalars['String'];
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QueryStudentLotteryUnmatchedBidsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  studentExtension: Scalars['String'];
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
};


export type QuerySuperAdminExternalJobImportBatchByIdArgs = {
  id: Scalars['ID'];
};


export type QuerySuperAdminExternalJobImportBatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySuperAdminExternalJobImportByIdArgs = {
  id: Scalars['ID'];
};


export type QuerySuperAdminGetDocumentsForFirmArgs = {
  orgId: Scalars['ID'];
};


export type QuerySuperAdminGetEventForOrgArgs = {
  eventId: Scalars['ID'];
  orgId: Scalars['ID'];
};


export type QuerySuperAdminGetEventsForOrgArgs = {
  eventTypes: Array<EventType>;
  orgId: Scalars['ID'];
};


export type QuerySuperAdminGetFirmArgs = {
  orgId: Scalars['ID'];
};


export type QuerySuperAdminGetFirmPracticeAreasArgs = {
  orgId: Scalars['ID'];
};


export type QuerySuperAdminGetOfficesForFirmArgs = {
  orgId: Scalars['ID'];
};


export type QuerySuperAdminGetOrgArgs = {
  orgId: Scalars['ID'];
};


export type QuerySuperAdminGetOrgForwardPrivilegesArgs = {
  orgId: Scalars['ID'];
};


export type QuerySuperAdminMostRecentFirmForwardRotationLogByActionTypeArgs = {
  actionType: FirmForwardRotationLogActionTypeInput;
};


export type QuerySuperAdminMostRecentFirmForwardRotationLogsByActionTypeArgs = {
  actionTypes: Array<FirmForwardRotationLogActionTypeInput>;
};


export type QueryTagByIdArgs = {
  id: Scalars['ID'];
};


export type QueryTestArgs = {
  argument: Scalars['ID'];
};


export type QueryTestObjectArgs = {
  argument1?: InputMaybe<Scalars['ID']>;
  argument2?: InputMaybe<Scalars['Int']>;
  argument3?: InputMaybe<Array<Scalars['String']>>;
  argument4?: InputMaybe<Array<Scalars['Int']>>;
  argument5?: InputMaybe<TestInput2>;
};


export type QueryUnassignedWorkAllocationMattersForAssociateArgs = {
  programId: Scalars['ID'];
};


export type QueryUniversitiesByIdArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryUniversityByIdArgs = {
  id: Scalars['ID'];
};


export type QueryUserWorkAllocationPermissionsArgs = {
  programId: Scalars['ID'];
};


export type QueryWorkAllocationEvaluationsForAssociateArgs = {
  programId: Scalars['ID'];
};


export type QueryWorkAllocationEvaluationsForAttorneyArgs = {
  programId: Scalars['ID'];
};


export type QueryWorkAllocationMatterArgs = {
  id: Scalars['ID'];
};


export type QueryWorkAllocationMatterForAssociateArgs = {
  matterId: Scalars['ID'];
};


export type QueryWorkAllocationMattersByAssociateArgs = {
  candidateId: Scalars['ID'];
};


export type QueryWorkAllocationMattersByProgramArgs = {
  programId: Scalars['ID'];
};


export type QueryWorkAllocationMattersForAssociateArgs = {
  programId: Scalars['ID'];
};


export type QueryWorkAllocationProgramArgs = {
  programId: Scalars['ID'];
};


export type QueryWorkAllocationProgramForAssociateArgs = {
  programId: Scalars['ID'];
};


export type QueryWorkAllocationProgramsArgs = {
  programIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryWorkplaceByIdArgs = {
  id: Scalars['ID'];
};


export type QueryWorkplacesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkplacesByIdArgs = {
  ids: Array<Scalars['ID']>;
};

export enum QuestionType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  FreeText = 'FREE_TEXT',
  Monetary = 'MONETARY',
  MultiSelect = 'MULTI_SELECT',
  Numerical = 'NUMERICAL',
  SingleSelect = 'SINGLE_SELECT'
}

export enum RecruitAttendeeAcceptedState {
  Accepted = 'ACCEPTED',
  Maybe = 'MAYBE',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export enum RecruitAttendeeCheckInState {
  CheckedIn = 'CHECKED_IN',
  NoShow = 'NO_SHOW',
  Pending = 'PENDING'
}

export type RecruitAttendeeNode = {
  accepted?: Maybe<RecruitAttendeeAcceptedState>;
  checkIn?: Maybe<RecruitAttendeeCheckInState>;
  email?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  fname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lname?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  preregister?: Maybe<Scalars['Boolean']>;
};

export type RecruitDocumentSubmissionConnection = Connection & {
  edges: Array<RecruitDocumentSubmissionEdge>;
  nodes: Array<RecruitDocumentSubmissionNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RecruitDocumentSubmissionEdge = Edge & {
  cursor: Scalars['String'];
  node: RecruitDocumentSubmissionNode;
};

export type RecruitDocumentSubmissionNode = Node & {
  /** As of this writing, only the last-updated-at timestamp is stored for Resumes and Transcripts, so in such cases we populate this created-at field with the updated-at one. */
  createdAtUtc?: Maybe<Scalars['DateTime']>;
  documentType: CustomDocumentType;
  /** Only refers to a database ID for Custom Documents; for Resume and Transcript, this is synthesized from other information. */
  id: Scalars['ID'];
  orgDocId: Scalars['ID'];
  orgId: Scalars['ID'];
  recruitId: Scalars['ID'];
  /** As of this writing, only the date is actually stored for _Custom_ Document submissions, so the time will be arbitrary. */
  updatedAtUtc?: Maybe<Scalars['DateTime']>;
};

export type RecruitEventProfileConnection = Connection & {
  edges: Array<RecruitEventProfileEdge>;
  nodes: Array<RecruitEventProfileNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RecruitEventProfileEdge = Edge & {
  cursor: Scalars['String'];
  node: RecruitEventProfileNode;
};

export type RecruitEventProfileNode = Node & {
  /** Only available to the logged-in Candidate, and they must own the Recruit record. */
  demographicInfo?: Maybe<RecruitEventProfileNodeDemographicInfo>;
  email: Scalars['String'];
  eventId: Scalars['ID'];
  headshotUrl?: Maybe<Scalars['Url']>;
  id: Scalars['ID'];
  isRegistered: Scalars['Boolean'];
  orgId: Scalars['ID'];
  personalInfo?: Maybe<RecruitEventProfileNodePersonalInfo>;
  recruitId: Scalars['ID'];
  timeslotChoices?: Maybe<RecruitTimeslotChoiceConnection>;
};


export type RecruitEventProfileNodeTimeslotChoicesArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** Wrapper type for the Recruit's */
export type RecruitEventProfileNodeDemographicInfo = {
  /** @deprecated Replace with Self id defaults once we fully move the registration to v2 */
  ethnicityNames?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Replace with Self id defaults once we fully move the registration to v2 */
  fixedGenderNames?: Maybe<Array<Scalars['String']>>;
  /** @deprecated Replace with Self id defaults once we fully move the registration to v2 */
  writeYourOwnGenderName?: Maybe<Scalars['String']>;
};

export type RecruitEventProfileNodePersonalInfo = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  linkedInUrl?: Maybe<Scalars['Url']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
};

export type RecruitTimeslotChoiceConnection = Connection & {
  edges: Array<RecruitTimeslotChoiceEdge>;
  nodes: Array<RecruitTimeslotChoiceNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RecruitTimeslotChoiceEdge = Edge & {
  cursor: Scalars['String'];
  node: RecruitTimeslotChoiceNode;
};

export type RecruitTimeslotChoiceNode = Node & {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  recruitId: Scalars['ID'];
  timeslotId: Scalars['ID'];
};

export type RegisterForwardUserAccountAlreadyExists = UserWarning & {
  /** A user-friendly message describing the problem. */
  userMessage: Scalars['String'];
};

export type RegisterForwardUserInput = {
  firstName: Scalars['String'];
  /** Not all law schools have GPAs (e.g. Yale), and 1Ls aren't required to submit GPAs. */
  gpa?: InputMaybe<Scalars['Float']>;
  graduationDate: Scalars['Date'];
  lastName: Scalars['String'];
  lawDegree: LawDegree;
  /** Required depending on the law degree and graduation date. */
  lawSchoolClassification?: InputMaybe<LawSchoolClassification>;
  lawSchoolId: Scalars['ID'];
  linkedInUrl?: InputMaybe<Scalars['Url']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  preferredOfficeLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  preferredPracticeCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  profilePhotoUrl?: InputMaybe<Scalars['Url']>;
};

export type RegisterForwardUserPayload = RegisterForwardUserAccountAlreadyExists | RegisterForwardUserSuccess;

export type RegisterForwardUserSuccess = {
  accountId: Scalars['ID'];
};

export type RemoveCandidateEducationHistoryEntryInput = {
  entryId: Scalars['ID'];
};

export type RemoveCandidateEducationHistoryEntryPayload = {
  success: Scalars['Boolean'];
};

export type RemoveCandidateWorkHistoryEntryInput = {
  entryId: Scalars['ID'];
};

export type RemoveCandidateWorkHistoryEntryPayload = {
  success: Scalars['Boolean'];
};

export type RemoveEmailFromForwardAccountInput = {
  email: Scalars['Email'];
};

export type RemoveEmailFromForwardAccountLoggedInWithEmail = UserWarning & {
  email: Scalars['Email'];
  /** A user-friendly message describing the problem. */
  userMessage: Scalars['String'];
};

export type RemoveEmailFromForwardAccountPayload = RemoveEmailFromForwardAccountLoggedInWithEmail | RemoveEmailFromForwardAccountSuccess;

export type RemoveEmailFromForwardAccountSuccess = {
  successful?: Maybe<Scalars['Boolean']>;
};

export type RemoveOfficeFromOrgInput = {
  officeName: Scalars['String'];
};

export type RemoveOfficeFromOrgPayload = {
  success: Scalars['Boolean'];
};

export type ReportCandidateNode = Node & {
  appSource?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lawSchool?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ReportingNode = {
  color?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type RichMediaSubsection = {
  blurb: Scalars['String'];
  firmProfileId: Scalars['ID'];
  orgId: Scalars['ID'];
  richMedia: Array<FirmProfileRichMediaNode>;
  section: FirmProfileSection;
  title: Scalars['String'];
};

export type SankeyStageNodeConversionReport = {
  link?: Maybe<Array<Maybe<ConversionReportLink>>>;
  node?: Maybe<ReportingNode>;
  order?: Maybe<Scalars['Int']>;
};

export type ScheduleVisibility = {
  employerFinalScheduleDate?: Maybe<DateTimeZone>;
  studentFinalScheduleDate?: Maybe<DateTimeZone>;
};

export type ScheduleVisibilityInput = {
  employerFinalScheduleDate: DateTimeZoneInput;
  studentFinalScheduleDate: DateTimeZoneInput;
};

export type SchoolConnection = Connection & {
  edges: Array<SchoolEdge>;
  nodes: Array<SchoolNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SchoolDegreeConnection = Connection & {
  edges: Array<SchoolDegreeEdge>;
  nodes: Array<SchoolDegreeNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SchoolDegreeEdge = Edge & {
  cursor: Scalars['String'];
  node: SchoolDegreeNode;
};

export type SchoolDegreeNode = Node & {
  distinguishedType?: Maybe<DistinguishedSchoolDegreeType>;
  id: Scalars['ID'];
  name: Scalars['String'];
  schoolType: SchoolType;
};

export type SchoolEdge = Edge & {
  cursor: Scalars['String'];
  node: SchoolNode;
};

export type SchoolNode = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum SchoolType {
  LawSchool = 'LAW_SCHOOL',
  Other = 'OTHER'
}

export type SelectedJobNode = {
  id: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
};

export type SelfIdDefaultConnection = Connection & {
  edges: Array<SelfIdDefaultEdge>;
  nodes: Array<SelfIdDefaultNode>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SelfIdDefaultEdge = Edge & {
  cursor: Scalars['String'];
  node: SelfIdDefaultNode;
};

export type SelfIdDefaultNode = Node & {
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<SelfIdDefaultOptionConnection>;
  questionType?: Maybe<SelfIdQuestionType>;
  type?: Maybe<SelfIdType>;
};


export type SelfIdDefaultNodeOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type SelfIdDefaultOptionConnection = Connection & {
  edges?: Maybe<Array<Maybe<SelfIdDefaultOptionEdge>>>;
  nodes?: Maybe<Array<Maybe<SelfIdDefaultOptionNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SelfIdDefaultOptionEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<SelfIdDefaultOptionNode>;
};

export type SelfIdDefaultOptionNode = Node & {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  selfIdDefault?: Maybe<SelfIdDefaultNode>;
  selfIdDefaultId: Scalars['ID'];
};

export enum SelfIdQuestionType {
  FreeText = 'FREE_TEXT',
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT'
}

export enum SelfIdType {
  CustomQuestion = 'CUSTOM_QUESTION',
  Description = 'DESCRIPTION',
  DisabilityStatus = 'DISABILITY_STATUS',
  EthnicityId = 'ETHNICITY_ID',
  GenderId = 'GENDER_ID',
  GovDemographic_1 = 'GOV_DEMOGRAPHIC_1',
  GovDemographic_2 = 'GOV_DEMOGRAPHIC_2',
  GovDemographic_3 = 'GOV_DEMOGRAPHIC_3',
  GovDemographic_3_1 = 'GOV_DEMOGRAPHIC_3_1',
  GovDemographic_3_2 = 'GOV_DEMOGRAPHIC_3_2',
  GovDisability_1 = 'GOV_DISABILITY_1',
  GovDisability_2 = 'GOV_DISABILITY_2',
  GovDisability_3 = 'GOV_DISABILITY_3',
  GovDisability_4 = 'GOV_DISABILITY_4',
  GovOptOut_1 = 'GOV_OPT_OUT_1',
  GovVeteran_1 = 'GOV_VETERAN_1',
  NalpAdditional = 'NALP_ADDITIONAL',
  SexualOrientation = 'SEXUAL_ORIENTATION',
  VeteranStatus = 'VETERAN_STATUS'
}

export type SendAddEmailToForwardAccountLinkEmailAlreadyWithUser = UserWarning & {
  email: Scalars['Email'];
  /** A user-friendly message describing the problem. */
  userMessage: Scalars['String'];
};

export type SendAddEmailToForwardAccountLinkInput = {
  email: Scalars['Email'];
};

export type SendAddEmailToForwardAccountLinkPayload = SendAddEmailToForwardAccountLinkEmailAlreadyWithUser | SendAddEmailToForwardAccountLinkSuccess;

export type SendAddEmailToForwardAccountLinkSuccess = {
  email: Scalars['Email'];
};

export type SendPasswordResetEmailInput = {
  email: Scalars['Email'];
  orgFriendlyName: Scalars['String'];
};

export type SerendipitousEventNode = EventNode & Node & {
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  employerRegistrationDeadline?: Maybe<DateTimeZone>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  start?: Maybe<DateTimeZone>;
  studentRegistrationDeadline?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
};


export type SerendipitousEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type SharedNetworkingEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  employerRegistrationDeadline?: Maybe<DateTimeZone>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type SharedNetworkingEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SourceValue = {
  appSourceName?: Maybe<Scalars['String']>;
  applied?: Maybe<ConversionReportConnection>;
  cancelled?: Maybe<ConversionReportConnection>;
  declined?: Maybe<ConversionReportConnection>;
  hired?: Maybe<ConversionReportConnection>;
  id?: Maybe<Scalars['String']>;
  interviewing?: Maybe<ConversionReportConnection>;
  offer?: Maybe<ConversionReportConnection>;
  rejected?: Maybe<ConversionReportConnection>;
  screening?: Maybe<ConversionReportConnection>;
  withdrew?: Maybe<ConversionReportConnection>;
};


export type SourceValueAppliedArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueCancelledArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueDeclinedArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueHiredArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueInterviewingArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueOfferArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueRejectedArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueScreeningArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type SourceValueWithdrewArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type SsoAuthInfoNode = Node & {
  connectionName: Scalars['String'];
  frontendAttribute?: Maybe<OrgSsoAuthInfoFrontendAttribute>;
  id: Scalars['ID'];
  ssoIdIsEmail: Scalars['Boolean'];
};

export enum SsoOrgMemberLoginType {
  Mfa = 'MFA',
  Sso = 'SSO'
}

export enum SsoType {
  Off = 'OFF',
  On = 'ON'
}

export type SsoUserIdTakenWarning = UserWarning & {
  ssoUserId: Scalars['String'];
  userMessage: Scalars['String'];
};

export enum StepStatus {
  Available = 'AVAILABLE',
  Complete = 'COMPLETE',
  Unavailable = 'UNAVAILABLE'
}

export type StudentBidding = {
  biddingDeadline?: Maybe<DateTimeZone>;
  biddingStartDate?: Maybe<DateTimeZone>;
  lotteryResultsVisibleToStudents?: Maybe<DateTimeZone>;
  maxNumberOfBids?: Maybe<Scalars['Int']>;
  maxNumberOfInterviews?: Maybe<Scalars['Int']>;
  reviewPeriodStartDate?: Maybe<DateTimeZone>;
};

export enum StudentBiddingPeriod {
  Bidding = 'BIDDING',
  PostBidding = 'POST_BIDDING',
  PreReview = 'PRE_REVIEW',
  Review = 'REVIEW'
}

export type StudentBiddingPeriodInput = {
  biddingDeadline: DateTimeZoneInput;
  biddingStartDate: DateTimeZoneInput;
  lotteryResultsVisibleToStudents: DateTimeZoneInput;
  maxNumberOfBids: Scalars['Int'];
  maxNumberOfInterviews: Scalars['Int'];
  reviewPeriodStartDate?: InputMaybe<DateTimeZoneInput>;
};

export type StudentCancellation = {
  studentCancellationEndDate?: Maybe<DateTimeZone>;
  studentCancellationStartDate?: Maybe<DateTimeZone>;
};

export enum StudentCancellationPeriod {
  Cancellation = 'CANCELLATION',
  PostCancellation = 'POST_CANCELLATION',
  PreCancellation = 'PRE_CANCELLATION'
}

export type StudentCancellationPeriodInput = {
  studentCancellationEndDate: DateTimeZoneInput;
  studentCancellationStartDate: DateTimeZoneInput;
};

export enum StudentFinalSchedulePeriod {
  PostFinalSchedule = 'POST_FINAL_SCHEDULE',
  PreFinalSchedule = 'PRE_FINAL_SCHEDULE'
}

export type StudentInformationNode = Node & {
  classYear?: Maybe<LawSchoolClassification>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  graduationYear?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  profileImageLink?: Maybe<Scalars['String']>;
  rawPhoneNumber?: Maybe<Scalars['String']>;
};

export enum StudentMatchReviewPeriod {
  MatchReviewPeriod = 'MATCH_REVIEW_PERIOD',
  PostMatchReviewPeriod = 'POST_MATCH_REVIEW_PERIOD',
  PreMatchReviewPeriod = 'PRE_MATCH_REVIEW_PERIOD'
}

export type StudentOptIn = {
  studentOptInEndDate?: Maybe<DateTimeZone>;
  studentOptInStartDate?: Maybe<DateTimeZone>;
};

export enum StudentOptInPeriod {
  OptIn = 'OPT_IN',
  PostOptIn = 'POST_OPT_IN',
  PreOptIn = 'PRE_OPT_IN'
}

export type StudentOptInPeriodInput = {
  studentOptInEndDate: DateTimeZoneInput;
  studentOptInStartDate: DateTimeZoneInput;
};

export type StudentSelfSchedule = {
  studentSelfScheduleEndDate?: Maybe<DateTimeZone>;
  studentSelfScheduleStartDate?: Maybe<DateTimeZone>;
};

export enum StudentSelfSchedulePeriod {
  PostSelfSchedulePeriod = 'POST_SELF_SCHEDULE_PERIOD',
  PreSelfSchedulePeriod = 'PRE_SELF_SCHEDULE_PERIOD',
  SelfSchedulePeriod = 'SELF_SCHEDULE_PERIOD'
}

export type StudentSelfSchedulePeriodInput = {
  studentSelfScheduleEndDate: DateTimeZoneInput;
  studentSelfScheduleStartDate: DateTimeZoneInput;
};

export enum SubmissionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type SubmitAndMarkExternalJobImportAsCompletedInput = {
  id: Scalars['ID'];
  jobId: Scalars['ID'];
};

export type SubmitAndMarkExternalJobImportAsCompletedPayload = {
  success: Scalars['Boolean'];
};

export type SubmitCandidateEducationHistoryEntryInput = {
  classYear?: InputMaybe<LawSchoolClassYear>;
  degreeId: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['Date'];
  entryId?: InputMaybe<Scalars['ID']>;
  gpa?: InputMaybe<Scalars['Float']>;
  schoolId: Scalars['ID'];
  schoolType: SchoolType;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type SubmitCandidateEducationHistoryEntryPayload = {
  success: Scalars['Boolean'];
};

export type SubmitCandidateWorkHistoryEntryInput = {
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Date']>;
  entryId?: InputMaybe<Scalars['ID']>;
  isCurrentJob: Scalars['Boolean'];
  jobTitle: Scalars['String'];
  officeLocationId?: InputMaybe<Scalars['ID']>;
  practiceAreaIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate: Scalars['Date'];
  workArrangement?: InputMaybe<WorkArrangement>;
  workplaceName: Scalars['String'];
};

export type SubmitCandidateWorkHistoryEntryPayload = {
  success: Scalars['Boolean'];
};

export type SubmitDemographicAnswersForOutreachEventCandidateRegistrationInput = {
  eventId: Scalars['ID'];
  info: SubmitDemographicAnswersForOutreachEventCandidateRegistrationInputDemographicAnswersInput;
  orgFriendlyName: Scalars['String'];
};

export type SubmitDemographicAnswersForOutreachEventCandidateRegistrationInputDemographicAnswersInput = {
  ethnicityNames: Array<Scalars['String']>;
  /**
   * Don't submit 'Write your own', use the separate field.
   * TODO: Once we move the entire flow to v2, refactor to use Self Id Default Option ids instead.
   */
  genderNames: Array<Scalars['String']>;
  /** `null` if only using the specified gender names. */
  writeYourOwnGender?: InputMaybe<Scalars['String']>;
};

export type SubmitDemographicAnswersForOutreachEventCandidateRegistrationPayload = {
  success: Scalars['Boolean'];
};

export type SubmitDocumentsForEmployerEventDocumentInput = {
  orgDocId: Scalars['ID'];
  path: Scalars['String'];
};

export type SubmitDocumentsForEmployerEventInput = {
  documents: Array<SubmitDocumentsForEmployerEventDocumentInput>;
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
};

export type SubmitDocumentsForEmployerEventPayload = {
  success: Scalars['Boolean'];
};

export type SubmitEventSchoolTargetingInput = {
  eventId: Scalars['ID'];
  /** Currently only supports ids of Law Schools. */
  schoolIds: Array<Scalars['ID']>;
};

export type SubmitEventSchoolTargetingPayload = {
  success: Scalars['Boolean'];
};

export type SubmitForwardDemographicInfoInput = {
  ethnicityAnswers: Array<Scalars['String']>;
  genderAnswers: Array<Scalars['String']>;
  sexualIdentityAnswers?: InputMaybe<Array<Scalars['String']>>;
  veteranStatusAnswer: Scalars['String'];
};

export type SubmitForwardDemographicInfoPayload = {
  success: Scalars['Boolean'];
};

export type SubmitForwardEventPublishingSettingsInput = {
  events: Array<EventPublishingSettings>;
};

export type SubmitForwardEventPublishingSettingsPayload = {
  success: Scalars['Boolean'];
};

export type SubmitForwardJobPreferencesInput = {
  officeLocationIds: Array<Scalars['ID']>;
  practiceCategoryIds: Array<Scalars['ID']>;
};

export type SubmitForwardJobPreferencesPayload = {
  success: Scalars['Boolean'];
};

export type SubmitForwardOfficeLocationPreferencesInput = {
  officeLocationIds: Array<Scalars['ID']>;
};

export type SubmitForwardOfficeLocationPreferencesPayload = {
  success: Scalars['Boolean'];
};

export type SubmitForwardPracticeCategoryPreferencesInput = {
  practiceCategoryIds: Array<Scalars['ID']>;
};

export type SubmitForwardPracticeCategoryPreferencesPayload = {
  success: Scalars['Boolean'];
};

export type SubmitHeadshotForOutreachEventCandidateRegistrationInput = {
  eventId: Scalars['ID'];
  /** `null` to remove headshot. */
  imageUrl?: InputMaybe<Scalars['Url']>;
  orgFriendlyName: Scalars['String'];
};

export type SubmitHeadshotForOutreachEventCandidateRegistrationPayload = {
  success: Scalars['Boolean'];
};

export type SubmitLotteryEventTimelinePayload = {
  successful?: Maybe<Scalars['Boolean']>;
};

export type SubmitPersonalInfoForOutreachEventCandidateRegistrationInput = {
  eventId: Scalars['ID'];
  info: SubmitPersonalInfoForOutreachEventCandidateRegistrationInputPersonalInfoInput;
  orgFriendlyName: Scalars['String'];
};

export type SubmitPersonalInfoForOutreachEventCandidateRegistrationInputPersonalInfoInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  linkedInUrl?: InputMaybe<Scalars['Url']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
};

export type SubmitPersonalInfoForOutreachEventCandidateRegistrationPayload = {
  success: Scalars['Boolean'];
  /**
   * If a new Recruit is created, the id of that new record.
   * Otherwise, the id of the Recruit record corresponding to that Firm and the Candidate's logged-in email.
   */
  upsertedRecruitId?: Maybe<Scalars['ID']>;
};

export type SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInput = {
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
  /** One per answered Question. */
  questionAnswers: Array<SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInputQuestionAnswerInput>;
};

export type SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInputGraduationDateQuestionAnswerInput = {
  semester: GraduationDateSemester;
  year: Scalars['Int'];
};

/** Use precisely one of the Answer fields. */
export type SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInputQuestionAnswerInput = {
  freeText?: InputMaybe<Scalars['String']>;
  graduationDate?: InputMaybe<SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInputGraduationDateQuestionAnswerInput>;
  lawSchoolId?: InputMaybe<Scalars['ID']>;
  multiSelectPresetIds?: InputMaybe<Array<Scalars['String']>>;
  questionId: Scalars['ID'];
  singleSelectPresetId?: InputMaybe<Scalars['String']>;
  /** Submit `true` for 'Yes', `false` for 'No'. */
  yesOrNo?: InputMaybe<Scalars['Boolean']>;
};

export type SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationPayload = {
  success: Scalars['Boolean'];
};

export type SubmitStudentBidsPayload = {
  successful?: Maybe<Scalars['Boolean']>;
};

export type SubmitStudentInterviewSchedulingPreferencesPayload = {
  successful?: Maybe<Scalars['Boolean']>;
};

export type SubmitVirtualChatRecruitTimeslotSelectionsInput = {
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
  timeslotIds: Array<Scalars['ID']>;
};

export type SubmitVirtualChatRecruitTimeslotSelectionsPayload = {
  success: Scalars['Boolean'];
  /**
   * For now, this mutation calls a v1 endpoint. This exposes the error message from that endpoint.
   * @deprecated Will be removed once we refactor to no longer use the v1 endpoint
   */
  v1StatusMessageForTesting?: Maybe<Scalars['String']>;
};

export type SummerSalary = {
  unit: FirmProfileSummerProgramSummerSalaryLengthUnit;
  value: Scalars['Int'];
};

export type SummerTopOfficeLocationAssociateCount = {
  numSummerAssociate: Scalars['Int'];
  officeLocation?: Maybe<OfficeLocationNode>;
  orgId: Scalars['ID'];
  orgOfficeId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SummerTopPracticeAreaAssociateCount = {
  numSummerAssociates: Scalars['Int'];
  orgId: Scalars['ID'];
  orgPracticeArea: OrgPracticeAreaNode;
  orgPracticeAreaId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SuperAdminAddDocumentToFirmInput = {
  documentName: Scalars['String'];
  orgId: Scalars['ID'];
};

export type SuperAdminAddDocumentToFirmPayload = {
  documentId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminAddOfficeToFirmInput = {
  officeLocationId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export type SuperAdminAddOfficeToFirmPayload = {
  success: Scalars['Boolean'];
};

/** TODO: Once product gets us a list of practice areas, we'll include the ID of the practice area. */
export type SuperAdminAddPracticeAreaToFirmInput = {
  /** TODO: Once product gets us a list of practice areas, we'll make this optional; `null` would indicate that the firm wants to use the Flo name for the practice area. */
  firmSpecificName: Scalars['String'];
  offices: Array<PracticeAreaOffice>;
  orgId: Scalars['ID'];
};

export type SuperAdminAddPracticeAreaToFirmPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminArchiveWorkplaceInput = {
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
};

export type SuperAdminArchiveWorkplacePayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminAssignLawSchoolToUniversityOrgInput = {
  /** `null` to remove all associations. */
  lawSchoolId?: InputMaybe<Scalars['ID']>;
  universityOrgId: Scalars['ID'];
};

export type SuperAdminAssignLawSchoolToUniversityOrgPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminAssignOutlierLawSchoolDataInput = {
  outlierName: Scalars['String'];
  receiverId: Scalars['ID'];
};

export type SuperAdminAssignOutlierLawSchoolDataPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminAssignOutlierOfficeLocationDataInput = {
  outlierName: Scalars['String'];
  receiverId: Scalars['ID'];
};

export type SuperAdminAssignOutlierOfficeLocationDataPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminAssignOutlierPracticeAreaDataInput = {
  outlierName: Scalars['String'];
  receiverId: Scalars['ID'];
};

export type SuperAdminAssignOutlierPracticeAreaDataPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminCloseJobsInput = {
  orgIdJobIds: Array<SuperAdminCloseJobsInputOrgIdJobId>;
};

export type SuperAdminCloseJobsInputOrgIdJobId = {
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export type SuperAdminCloseJobsPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminCreateInactiveFirmInput = {
  name: Scalars['String'];
};

export type SuperAdminCreateInactiveFirmNameTaken = UserWarning & {
  orgName: Scalars['String'];
  userMessage: Scalars['String'];
};

export type SuperAdminCreateInactiveFirmPayload = SuperAdminCreateInactiveFirmNameTaken | SuperAdminCreateInactiveFirmSuccess;

export type SuperAdminCreateInactiveFirmSuccess = {
  orgId?: Maybe<Scalars['ID']>;
};

export type SuperAdminCreateLawSchoolInput = {
  name: Scalars['String'];
};

export type SuperAdminCreateLawSchoolPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminCreateOfficeLocationInput = {
  name: Scalars['String'];
};

export type SuperAdminCreateOfficeLocationPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminCreatePracticeAreaInput = {
  name: Scalars['String'];
};

export type SuperAdminCreatePracticeAreaPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminCreatePracticeCategoryInput = {
  name: Scalars['String'];
};

export type SuperAdminCreatePracticeCategoryPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminCreateUniversityInput = {
  name: Scalars['String'];
};

export type SuperAdminCreateUniversityPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminCreateWorkplaceInput = {
  connectedOrgId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type SuperAdminCreateWorkplacePayload = {
  createdId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminDeleteExternalJobInput = {
  jobId: Scalars['ID'];
};

export type SuperAdminDeleteExternalJobPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminDeleteWorkplaceInput = {
  id: Scalars['ID'];
};

export type SuperAdminDeleteWorkplacePayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditLawSchoolInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SuperAdminEditLawSchoolPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditOfficeLocationInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SuperAdminEditOfficeLocationPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditOrgEmailDomainInput = {
  /** `null` to remove. */
  domain?: InputMaybe<Scalars['String']>;
};

export type SuperAdminEditOrgEmailDomainPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditPracticeAreaForFirmInput = {
  firmSpecificName: Scalars['String'];
  offices: Array<PracticeAreaOffice>;
  orgId: Scalars['ID'];
  orgPracticeAreaId: Scalars['ID'];
};

export type SuperAdminEditPracticeAreaForFirmPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditPracticeAreaInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SuperAdminEditPracticeAreaPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditPracticeCategoryInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SuperAdminEditPracticeCategoryPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditUniversityInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SuperAdminEditUniversityPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEditWorkplaceInput = {
  connectedOrgId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SuperAdminEditWorkplacePayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminEnableEventCarouselInput = {
  enabled: Scalars['Boolean'];
  orgId: Scalars['ID'];
};

export type SuperAdminEnableEventCarouselPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminFirm = {
  id: Scalars['ID'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SuperAdminFirmDocument = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SuperAdminFirmForwardRotationLog = {
  action: FirmForwardRotationAction;
  id: Scalars['ID'];
  initiatedBy: Scalars['String'];
  initiator: FirmForwardRotationInitiator;
  occurredAt: Scalars['DateTime'];
  result: FirmForwardRotationResult;
  rotationType: FirmForwardRotationType;
};

export type SuperAdminFirmOffice = {
  /** Org office ID */
  id: Scalars['ID'];
  locationId: Scalars['ID'];
  name: Scalars['String'];
  ranking: Scalars['Int'];
};

export type SuperAdminFirmProfileDiversityStatisticInput = {
  numAssociates?: InputMaybe<Scalars['Int']>;
  numCounsels?: InputMaybe<Scalars['Int']>;
  /** Currently not being shown on frontend. */
  numNonEquityPartners?: InputMaybe<Scalars['Int']>;
  numPartners?: InputMaybe<Scalars['Int']>;
  numSummerAssociates?: InputMaybe<Scalars['Int']>;
  selfIdDefaultId: Scalars['ID'];
  selfIdDefaultOptionId: Scalars['ID'];
};

export type SuperAdminLawSchoolOutlierByArea = {
  eventLawSchool: Array<Scalars['String']>;
  jobAppEducationHistoryLawSchoolEntry: Array<Scalars['String']>;
  lawSchoolMemberAnswer: Array<Scalars['String']>;
  lawSchoolQualifyingQuestionAnswer: Array<Scalars['String']>;
  /** @deprecated We no longer use the underlying table with these outliers */
  universityDegreeLawSchool: Array<Scalars['String']>;
};

export type SuperAdminLawSchoolOutlierByName = {
  eventLawSchoolCount: Scalars['Int'];
  jobAppEducationHistoryLawSchoolEntryCount: Scalars['Int'];
  lawSchoolMemberAnswerCount: Scalars['Int'];
  lawSchoolQualifyingQuestionAnswerCount: Scalars['Int'];
  outlierName: Scalars['String'];
  /** @deprecated We no longer use the underlying table with these outliers */
  universityDegreeLawSchoolCount: Scalars['Int'];
};

export type SuperAdminLawSchoolOutlierData = {
  byArea: SuperAdminLawSchoolOutlierByArea;
  byName: Array<SuperAdminLawSchoolOutlierByName>;
};

export type SuperAdminMergeLawSchoolInput = {
  giverId: Scalars['ID'];
  receiverId: Scalars['ID'];
};

export type SuperAdminMergeLawSchoolPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminMergeOfficeLocationInput = {
  giverId: Scalars['ID'];
  receiverId: Scalars['ID'];
};

export type SuperAdminMergeOfficeLocationPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminMergePracticeAreaInput = {
  giverId: Scalars['ID'];
  receiverId: Scalars['ID'];
};

export type SuperAdminMergePracticeAreaPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminOfficeLocationOutlierByArea = {
  employerInterviewScheduleOfficeLocation: Array<Scalars['String']>;
  officeLocationMemberAnswer: Array<Scalars['String']>;
};

export type SuperAdminOfficeLocationOutlierByName = {
  employerInterviewScheduleOfficeLocationCount: Scalars['Int'];
  officeLocationMemberAnswerCount: Scalars['Int'];
  outlierName: Scalars['String'];
};

export type SuperAdminOfficeLocationOutlierData = {
  byArea: SuperAdminOfficeLocationOutlierByArea;
  byName: Array<SuperAdminOfficeLocationOutlierByName>;
};

export type SuperAdminPracticeAreaOutlierByArea = {
  employerInterviewSchedulePracticeArea: Array<Scalars['String']>;
  practiceAreaMemberAnswer: Array<Scalars['String']>;
};

export type SuperAdminPracticeAreaOutlierByName = {
  employerInterviewSchedulePracticeAreaCount: Scalars['Int'];
  outlierName: Scalars['String'];
  practiceAreaMemberAnswerCount: Scalars['Int'];
};

export type SuperAdminPracticeAreaOutlierData = {
  byArea: SuperAdminPracticeAreaOutlierByArea;
  byName: Array<SuperAdminPracticeAreaOutlierByName>;
};

export type SuperAdminRemoveOfficeFromFirmInput = {
  orgId: Scalars['ID'];
  orgOfficeId: Scalars['ID'];
};

export type SuperAdminRemoveOfficeFromFirmPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminRemovePracticeAreaFromFirmInput = {
  orgId: Scalars['ID'];
  orgPracticeAreaId: Scalars['ID'];
};

export type SuperAdminRemovePracticeAreaFromFirmPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminRotateFirmsInput = {
  rotationType: FirmForwardRotationType;
};

export type SuperAdminRotateFirmsPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitEmailDomainsForSchoolInput = {
  /** The new list of domains for the School. Present domains are added if they don't already exist with the School, and absent domains are removed from the School. */
  domains: Array<Scalars['String']>;
  schoolId: Scalars['ID'];
};

export type SuperAdminSubmitEmailDomainsForSchoolPayload = {
  success?: Maybe<Scalars['Boolean']>;
};

export type SuperAdminSubmitFirmProfileCustomSectionInput = {
  /** `null` if no response. */
  answer?: InputMaybe<Scalars['String']>;
  coverImageSrc?: InputMaybe<Scalars['Url']>;
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: InputMaybe<SuperAdminSubmitFirmProfileCustomSectionLearnMoreLinkInput>;
  moreAboutLifeAt?: InputMaybe<Scalars['String']>;
  orgId: Scalars['ID'];
  richMedia?: InputMaybe<SuperAdminSubmitFirmProfileRichMediaSubsectionInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type SuperAdminSubmitFirmProfileCustomSectionLearnMoreLinkInput = {
  /** Not necessary to specify; up to the client to provide a default when querying. */
  display?: InputMaybe<Scalars['String']>;
  url: Scalars['Url'];
};

export type SuperAdminSubmitFirmProfileCustomSectionPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitFirmProfileDiversityAndInclusionSectionInput = {
  additionalStatisticsAsOf?: InputMaybe<Scalars['DateTime']>;
  /** `null` if no response. */
  answer?: InputMaybe<Scalars['String']>;
  ethnicityStatisticsAsOf?: InputMaybe<Scalars['DateTime']>;
  genderStatisticsAsOf?: InputMaybe<Scalars['DateTime']>;
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: InputMaybe<Scalars['Url']>;
  orgId: Scalars['ID'];
  richMedia?: InputMaybe<SuperAdminSubmitFirmProfileRichMediaSubsectionInput>;
  statistics: Array<SuperAdminFirmProfileDiversityStatisticInput>;
};

export type SuperAdminSubmitFirmProfileDiversityAndInclusionSectionPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitFirmProfileIsPublicInput = {
  isPublic: Scalars['Boolean'];
  orgId: Scalars['ID'];
};

export type SuperAdminSubmitFirmProfileIsPublicPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitFirmProfileMainInput = {
  bannerImageSrc?: InputMaybe<Scalars['Url']>;
  bio: Scalars['String'];
  customLink?: InputMaybe<SuperAdminSubmitFirmProfileMainInputCustomLink>;
  daysInOfficeContext?: InputMaybe<Scalars['String']>;
  daysInOfficePerWeek?: InputMaybe<Scalars['Float']>;
  isPublic: Scalars['Boolean'];
  numAssociates?: InputMaybe<Scalars['Int']>;
  numCounsels?: InputMaybe<Scalars['Int']>;
  numPartners?: InputMaybe<Scalars['Int']>;
  numPartnershipTiers?: InputMaybe<Scalars['Int']>;
  /** A firm can have at most one firm profile, so this `orgId` identifies the firm profile to create or update. */
  orgId: Scalars['ID'];
  profitsPerPartnerDollars?: InputMaybe<Scalars['String']>;
  revenueDollars?: InputMaybe<Scalars['String']>;
  socialMediaLinks?: InputMaybe<SuperAdminSubmitFirmProfileMainInputSocialMediaLinks>;
  websiteLinkUrl?: InputMaybe<Scalars['Url']>;
};

export type SuperAdminSubmitFirmProfileMainInputCustomLink = {
  display: Scalars['String'];
  url: Scalars['Url'];
};

export type SuperAdminSubmitFirmProfileMainInputSocialMediaLinks = {
  facebookUrl?: InputMaybe<Scalars['Url']>;
  instagramUrl?: InputMaybe<Scalars['Url']>;
  linkedInUrl?: InputMaybe<Scalars['Url']>;
  twitterUrl?: InputMaybe<Scalars['Url']>;
  youtubeUrl?: InputMaybe<Scalars['Url']>;
};

export type SuperAdminSubmitFirmProfileMainPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitFirmProfilePracticeAreaSectionInput = {
  /** `null` if no response. */
  answer?: InputMaybe<Scalars['String']>;
  headcounts: Array<SuperAdminSubmitFirmProfilePracticeAreaSectionInputHeadcounts>;
  headcountsAsOf?: InputMaybe<Scalars['DateTime']>;
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: InputMaybe<Scalars['Url']>;
  orgId: Scalars['ID'];
  richMedia?: InputMaybe<SuperAdminSubmitFirmProfileRichMediaSubsectionInput>;
};

export type SuperAdminSubmitFirmProfilePracticeAreaSectionInputHeadcounts = {
  numAssociates?: InputMaybe<Scalars['Int']>;
  numCounsels?: InputMaybe<Scalars['Int']>;
  numEntryLevelPlacements?: InputMaybe<Scalars['Int']>;
  numNonEquityPartners?: InputMaybe<Scalars['Int']>;
  numNonTraditionalTrackOrStaff?: InputMaybe<Scalars['Int']>;
  numPartners?: InputMaybe<Scalars['Int']>;
  orgPracticeAreaId: Scalars['ID'];
  ranking: Scalars['Int'];
  totalNumAttorneys?: InputMaybe<Scalars['Int']>;
};

export type SuperAdminSubmitFirmProfilePracticeAreaSectionPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitFirmProfileProBonoSectionInput = {
  /** `null` if no response. Currently answers the question "How do your pro bono initiatives help associates to grow into their practice at your firm?". */
  answer?: InputMaybe<Scalars['String']>;
  /** `null` if no response. Currently answers the question "How is pro bono work assigned or distributed?". */
  answer2?: InputMaybe<Scalars['String']>;
  areProBonoHoursBillable?: InputMaybe<FirmProfileProBonoAreProBonoHoursBillableOption>;
  averageHours?: InputMaybe<SuperAdminSubmitFirmProfileProBonoSectionInputAverageHours>;
  averageHoursAsOf?: InputMaybe<Scalars['DateTime']>;
  /** E.g. why hours aren't billable, specifying there's no maximum, etc. */
  billableHoursContext?: InputMaybe<Scalars['String']>;
  haveOpportunitiesForSummersOption?: InputMaybe<FirmProfileProBonoHaveOpportunitiesForSummersOption>;
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: InputMaybe<Scalars['Url']>;
  numBillableProBonoHours?: InputMaybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  participationPercentage?: InputMaybe<SuperAdminSubmitFirmProfileProBonoSectionInputParticipationPercentage>;
  participationPercentagesAsOf?: InputMaybe<Scalars['DateTime']>;
  richMedia?: InputMaybe<SuperAdminSubmitFirmProfileRichMediaSubsectionInput>;
};

export type SuperAdminSubmitFirmProfileProBonoSectionInputAverageHours = {
  associate?: InputMaybe<Scalars['Int']>;
  otherLawyers?: InputMaybe<Scalars['Int']>;
  partner?: InputMaybe<Scalars['Int']>;
};

export type SuperAdminSubmitFirmProfileProBonoSectionInputParticipationPercentage = {
  associate?: InputMaybe<Scalars['Float']>;
  otherLawyers?: InputMaybe<Scalars['Float']>;
  partner?: InputMaybe<Scalars['Float']>;
};

export type SuperAdminSubmitFirmProfileProBonoSectionPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitFirmProfileRichMediaInput = {
  firmProfileRichMediaData: SuperAdminSubmitFirmProfileRichMediaInputData;
  firmProfileRichMediaType: FirmProfileRichMediaType;
  firmProfileSection: FirmProfileSection;
  order: Scalars['Int'];
};

export type SuperAdminSubmitFirmProfileRichMediaInputData = {
  mediaLink: Scalars['Url'];
  mediaLinkText: Scalars['String'];
  mediaThumbnailLink?: InputMaybe<Scalars['Url']>;
  mediaTitle: Scalars['String'];
};

export type SuperAdminSubmitFirmProfileRichMediaSubsectionInput = {
  blurb: Scalars['String'];
  richMedia: Array<SuperAdminSubmitFirmProfileRichMediaInput>;
  title: Scalars['String'];
};

export type SuperAdminSubmitFirmProfileSummerProgramSectionInput = {
  answer?: InputMaybe<Scalars['String']>;
  assignedPracticeAreasOption?: InputMaybe<FirmProfileSummerProgramAssignedPracticeAreasOption>;
  contacts: Array<FirmProfileSummerProgramContactInput>;
  earlyInterviewAvailableOption?: InputMaybe<FirmProfileSummerProgramEarlyInterviewAvailableOption>;
  firstYearHiredIntoPracticeAreaOption?: InputMaybe<FirmProfileSummerProgramFirstYearHiredIntoPracticeAreaOption>;
  /** Whether the firm has has summer by practice data and wants us to input it. */
  hasSummerByPracticeDataToInput: Scalars['Boolean'];
  howIsWorkAssignedContext?: InputMaybe<Scalars['String']>;
  howIsWorkAssignedOption?: InputMaybe<FirmProfileSummerProgramHowIsWorkAssignedOption>;
  isEnabled: Scalars['Boolean'];
  learnMoreLink?: InputMaybe<Scalars['Url']>;
  noResponse: Scalars['Boolean'];
  orgId: Scalars['ID'];
  /** @deprecated Use 'contacts' instead. */
  primaryContact?: InputMaybe<FirmProfileSummerProgramPrimaryContactInput>;
  programLength?: InputMaybe<FirmProfileSummerProgramLengthInput>;
  resumeAcceptanceDeadline1L?: InputMaybe<Scalars['Date']>;
  resumeAcceptanceDeadline2L?: InputMaybe<Scalars['Date']>;
  resumeAcceptanceText1L?: InputMaybe<Scalars['String']>;
  resumeAcceptanceText2L?: InputMaybe<Scalars['String']>;
  richMedia?: InputMaybe<SuperAdminSubmitFirmProfileRichMediaSubsectionInput>;
  /** Context for the "Summer by Practice" chart section. */
  summerByPracticeContext?: InputMaybe<Scalars['String']>;
  summerCount1L?: InputMaybe<Scalars['Int']>;
  summerCount2L?: InputMaybe<Scalars['Int']>;
  summerCountsAsOf?: InputMaybe<Scalars['DateTime']>;
  summerPracticeAreaByOfficeAsOf?: InputMaybe<Scalars['DateTime']>;
  summerPracticeAreaOffices: Array<SuperAdminSubmitFirmProfileSummerProgramSectionPracticeAreaOfficesInput>;
  summerSalary?: InputMaybe<FirmProfileSummerSalaryInput>;
  summerTopOfficeLocations: Array<SuperAdminSubmitFirmProfileSummerProgramSectionTopOfficeLocationInput>;
  summerTopOfficeLocationsAsOf?: InputMaybe<Scalars['DateTime']>;
  summerTopPracticeAreas: Array<SuperAdminSubmitFirmProfileSummerProgramSectionTopPracticeAreaInput>;
  summerTopPracticeAreasAsOf?: InputMaybe<Scalars['DateTime']>;
};

export type SuperAdminSubmitFirmProfileSummerProgramSectionPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitFirmProfileSummerProgramSectionPracticeAreaOfficesInput = {
  orgOfficeId: Scalars['ID'];
  orgPracticeAreaId: Scalars['ID'];
};

export type SuperAdminSubmitFirmProfileSummerProgramSectionTopOfficeLocationInput = {
  numSummerAssociates: Scalars['Int'];
  orgOfficeId: Scalars['ID'];
};

export type SuperAdminSubmitFirmProfileSummerProgramSectionTopPracticeAreaInput = {
  numSummerAssociates: Scalars['Int'];
  orgPracticeAreaId: Scalars['ID'];
};

export type SuperAdminSubmitForwardEventPublishingSettingsInput = {
  event: OrgIdEventIdForwardPublishingSettings;
};

export type SuperAdminSubmitForwardEventPublishingSettingsPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitJobBoardAudienceInput = {
  is1L: Scalars['Boolean'];
  is2L: Scalars['Boolean'];
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export type SuperAdminSubmitJobBoardAudiencePayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitJobForFirmInput = {
  careersPageUrl: Scalars['Url'];
  close?: InputMaybe<SuperAdminSubmitJobForFirmInputDateTimeZone>;
  description: Scalars['String'];
  is1L: Scalars['Boolean'];
  is2L: Scalars['Boolean'];
  /** `null` if creating, non-`null` if updating. */
  jobId?: InputMaybe<Scalars['ID']>;
  open: SuperAdminSubmitJobForFirmInputDateTimeZone;
  orgId: Scalars['ID'];
  orgOfficeIds?: InputMaybe<Array<Scalars['ID']>>;
  practiceCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  programLength?: InputMaybe<SuperAdminSubmitJobForFirmInputProgramLength>;
  requiredDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  salaryInfo?: InputMaybe<SuperAdminSubmitJobForFirmInputSalaryInfo>;
  title: Scalars['String'];
};

export type SuperAdminSubmitJobForFirmInputDateTimeZone = {
  date: Scalars['Date'];
  time: Scalars['LocalTime'];
  zone: FloTimezone;
};

export type SuperAdminSubmitJobForFirmInputProgramLength = {
  amount: Scalars['Int'];
  timeUnit: JobProgramLengthTimeUnit;
};

export type SuperAdminSubmitJobForFirmInputSalaryInfo = {
  amount: Scalars['Int'];
  timeUnit: JobSalaryInfoTimeUnit;
};

export type SuperAdminSubmitJobForFirmPayload = {
  jobId?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminSubmitRichMediaPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminToggleJobIs1LInput = {
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
};

export type SuperAdminToggleJobIs1LPayload = {
  newIs1L?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

export type SuperAdminUpdateEventCarouselRankingsInput = {
  carouselEventRankings: Array<CarouselEvent>;
  orgId: Scalars['ID'];
};

export type SuperAdminUpdateEventCarouselRankingsPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminUpdateForwardTierInput = {
  forwardTier?: InputMaybe<ForwardTier>;
  orgId: Scalars['ID'];
};

export type SuperAdminUpdateForwardTierPayload = {
  /** ID of the created `ORG_FORWARD_TIER` record, if exists. */
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type SuperAdminUpdateOrgFeaturedEventsInput = {
  featuredDirectoryEvents: Array<DirectoryEvent>;
  orgId: Scalars['ID'];
};

export type SuperAdminUpdateOrgFeaturedEventsPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminUpdateOrgForwardPrivilegesInput = {
  carouselEventPublishing: Scalars['Boolean'];
  directoryEventPublishing: Scalars['Boolean'];
  lawSchoolTargeting: Scalars['Boolean'];
  orgId: Scalars['ID'];
};

export type SuperAdminUpdateOrgForwardPrivilegesPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminUpdateOrgOfficeRankingInput = {
  orgId: Scalars['ID'];
  orgOfficeRankings: Array<OrgOfficeRanking>;
};

export type SuperAdminUpdateOrgOfficeRankingPayload = {
  success: Scalars['Boolean'];
};

export type SuperAdminUpdateOrgSsoInput = {
  connectionName: Scalars['String'];
  orgId: Scalars['ID'];
};

export type SuperAdminUpdateOrgSsoPayload = {
  success: Scalars['Boolean'];
};

export type TagConnection = Connection & {
  edges?: Maybe<Array<Maybe<TagEdge>>>;
  nodes?: Maybe<Array<Maybe<TagNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TagEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<TagNode>;
};

export type TagEventConnection = Connection & {
  edges?: Maybe<Array<Maybe<TagEventEdge>>>;
  nodes?: Maybe<Array<Maybe<EventNode>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type TagEventEdge = Edge & {
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<EventNode>;
};

export type TagNode = Node & {
  events?: Maybe<TagEventConnection>;
  id: Scalars['ID'];
  isCustom?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
};


export type TagNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type TestInput = {
  test: Scalars['ID'];
};

/** For load testing (validating of arguments). */
export type TestInput2 = {
  arg1: Scalars['ID'];
  arg2: Scalars['Int'];
  arg3: Scalars['String'];
  arg4: Scalars['Float'];
  arg5: Scalars['Date'];
  arg6: Scalars['DateTime'];
  arg7: TestInput;
  arg8: Scalars['Email'];
  arg9: Scalars['PhoneNumber'];
  arg10: Scalars['Url'];
};

export type TestObject = {
  /** Internally keep track of how far in the tree we've gone. */
  depth: Scalars['Int'];
  test: Scalars['String'];
  test2: Scalars['Int'];
  test3: Array<Scalars['String']>;
  test4: Array<Scalars['Int']>;
  /** Resolves up to depth 3. */
  testObject1?: Maybe<TestObject>;
  /** Resolves up to depth 3. */
  testObject2?: Maybe<TestObject>;
  /** Resolves up to depth 3. */
  testObject3?: Maybe<TestObject>;
};

export type TestPayload = {
  test: Scalars['String'];
};

export type TimeToComplete = {
  unit: TimeToCompleteUnit;
  value: Scalars['Float'];
};

export type TimeToCompleteInput = {
  unit: TimeToCompleteUnit;
  value: Scalars['Float'];
};

/** The unit of time to complete the matter. Can be in hours, days, or weeks. */
export enum TimeToCompleteUnit {
  Days = 'DAYS',
  Hours = 'HOURS',
  Weeks = 'WEEKS'
}

/** Placeholder name; will change to TimeslotNode later */
export type TimeslotNode = {
  end?: Maybe<DateTimeZone>;
  hostEventId: Scalars['ID'];
  id: Scalars['ID'];
  interviewerOrg?: Maybe<PublicOrgInfo>;
  interviewerOrgId: Scalars['ID'];
  /** `null` if not available to show. */
  interviewers?: Maybe<Array<Maybe<Interviewer>>>;
  rawVideoLink?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
  videoLink?: Maybe<Scalars['Url']>;
};

export enum TimezonePlan {
  Europe = 'EUROPE',
  International = 'INTERNATIONAL',
  NorthAmerica = 'NORTH_AMERICA'
}

export type ToggleExternalJobImportDoNotSubmitStatusInput = {
  id: Scalars['ID'];
  markedAsDoNotSubmit: Scalars['Boolean'];
};

export type ToggleExternalJobImportDoNotSubmitStatusPayload = {
  success: Scalars['Boolean'];
};

export type ToggleJobBookmarkInput = {
  jobId: Scalars['ID'];
};

export type ToggleJobBookmarkPayload = {
  id?: Maybe<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type TrackActivateForwardAccountFromEventInput = {
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
};

export type TrackActivateForwardAccountFromEventPayload = {
  success: Scalars['Boolean'];
};

export type TrackApplyToExternalJobInput = {
  jobId: Scalars['ID'];
  pageTitle?: InputMaybe<Scalars['String']>;
};

export type TrackApplyToExternalJobPayload = {
  success: Scalars['Boolean'];
};

export type TrackForwardEventCompleteRegistrationInput = {
  alreadyRegistered: Scalars['Boolean'];
  eventId: Scalars['ID'];
  registrationSource: ForwardEventRegistrationSource;
};

export type TrackForwardEventCompleteRegistrationPayload = {
  success: Scalars['Boolean'];
};

export type TrackForwardEventStartRegistrationInput = {
  alreadyRegistered: Scalars['Boolean'];
  eventId: Scalars['ID'];
  registrationSource: ForwardEventRegistrationSource;
};

export type TrackForwardEventStartRegistrationPayload = {
  success: Scalars['Boolean'];
};

export type TrackGoToExternalJobPageInput = {
  jobId: Scalars['ID'];
  pageTitle?: InputMaybe<Scalars['String']>;
};

export type TrackGoToExternalJobPagePayload = {
  success: Scalars['Boolean'];
};

export type TrackQuickApplyToJobInput = {
  jobId: Scalars['ID'];
  pageTitle?: InputMaybe<Scalars['String']>;
};

export type TrackQuickApplyToJobPayload = {
  success: Scalars['Boolean'];
};

export type UniversityConnection = Connection & {
  edges: Array<UniversityEdge>;
  nodes: Array<UniversityNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UniversityContactNode = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export enum UniversityDegreeEnum {
  BachelorOfArtsAndBachelorsOfLaws = 'BACHELOR_OF_ARTS_AND_BACHELORS_OF_LAWS',
  BachelorOfBusinessAdministrationAndBachelorOfLaws = 'BACHELOR_OF_BUSINESS_ADMINISTRATION_AND_BACHELOR_OF_LAWS',
  BachelorOfCommerce = 'BACHELOR_OF_COMMERCE',
  BachelorOfCommerceAndBachelorOfLaws = 'BACHELOR_OF_COMMERCE_AND_BACHELOR_OF_LAWS',
  BachelorOfEconomicsAndBachelorOfLaws = 'BACHELOR_OF_ECONOMICS_AND_BACHELOR_OF_LAWS',
  BachelorOfEngineeringAndBachelorOfLaws = 'BACHELOR_OF_ENGINEERING_AND_BACHELOR_OF_LAWS',
  BachelorOfLaws = 'BACHELOR_OF_LAWS',
  BachelorOfScience = 'BACHELOR_OF_SCIENCE',
  BachelorOfSciencesAndBachelorOfLaws = 'BACHELOR_OF_SCIENCES_AND_BACHELOR_OF_LAWS',
  BachelorOfSocialSciencesAndBachelorOfLaws = 'BACHELOR_OF_SOCIAL_SCIENCES_AND_BACHELOR_OF_LAWS',
  BachelorOrArts = 'BACHELOR_OR_ARTS',
  Doctorate = 'DOCTORATE',
  DoctorOfDentistry = 'DOCTOR_OF_DENTISTRY',
  DoctorOfMedicine = 'DOCTOR_OF_MEDICINE',
  DoctorOfOsteopathicMedicine = 'DOCTOR_OF_OSTEOPATHIC_MEDICINE',
  DoctorOfPharmacy = 'DOCTOR_OF_PHARMACY',
  JurisDoctor = 'JURIS_DOCTOR',
  MasterOfArts = 'MASTER_OF_ARTS',
  MasterOfBusinessAdministration = 'MASTER_OF_BUSINESS_ADMINISTRATION',
  MasterOfEducation = 'MASTER_OF_EDUCATION',
  MasterOfFinance = 'MASTER_OF_FINANCE',
  MasterOfFineArts = 'MASTER_OF_FINE_ARTS',
  MasterOfLaws = 'MASTER_OF_LAWS',
  MasterOfPublicAdministration = 'MASTER_OF_PUBLIC_ADMINISTRATION',
  MasterOfScience = 'MASTER_OF_SCIENCE',
  MasterOfSocialWork = 'MASTER_OF_SOCIAL_WORK',
  Other = 'OTHER'
}

export enum UniversityDocumentVisibilityEnum {
  CustomDateTime = 'CUSTOM_DATE_TIME',
  Immediately = 'IMMEDIATELY',
  InterviewStartTime = 'INTERVIEW_START_TIME',
  ReviewStartTime = 'REVIEW_START_TIME',
  Undefined = 'UNDEFINED'
}

export type UniversityEdge = Edge & {
  cursor: Scalars['String'];
  node: UniversityNode;
};

export type UniversityEventNode = EventNode & Node & {
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  employerRegistrationDeadline?: Maybe<DateTimeZone>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  studentRegistrationDeadline?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type UniversityEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

/** A non-law school educational institution. */
export type UniversityNode = Node & SchoolNode & {
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** A University Org. */
export type UniversityOrgNode = Node & OrgNode & {
  availableTags?: Maybe<OrgAvailableTagConnection>;
  color?: Maybe<Scalars['String']>;
  emailDomain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  industry?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isMfaEnabled: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  members?: Maybe<OrgMemberConnection>;
  name?: Maybe<Scalars['String']>;
  organizingEvents?: Maybe<OrgOrganizesEventConnection>;
  requestsDNI?: Maybe<Scalars['Boolean']>;
  /** `null` if the Org does not use SSO. */
  ssoAuthInfo?: Maybe<OrgSsoAuthInfoNode>;
  ssoType: SsoType;
  timezonePlan?: Maybe<TimezonePlan>;
  urlFriendlyName?: Maybe<Scalars['String']>;
};


/** A University Org. */
export type UniversityOrgNodeAvailableTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** A University Org. */
export type UniversityOrgNodeMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** A University Org. */
export type UniversityOrgNodeOrganizingEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<EventFilterBy>;
  first?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrgCandidatePhotoManagementSettingsInput = {
  disableCandidatePhotoSyncing: Scalars['Boolean'];
  disableCandidatePhotoUpload: Scalars['Boolean'];
  hideUploadedCandidatePhotos: Scalars['Boolean'];
};

export type UpdateProgramContributorsInput = {
  contributors: Array<ProgramContributorInput>;
  programId: Scalars['ID'];
};

export type UpdateProgramContributorsPayload = {
  contributors: Array<ProgramContributorEdge>;
};

export type UpdateProgramGroupAssociatesInput = {
  associateIds: Array<Scalars['ID']>;
  id: Scalars['ID'];
};

export type UpdateProgramGroupAssociatesPayload = {
  group: ProgramGroupNode;
};

export type UpdateProgramGroupMembersInput = {
  id: Scalars['ID'];
  memberIds: Array<Scalars['ID']>;
};

export type UpdateProgramGroupMembersPayload = {
  group: ProgramGroupNode;
};

export type UpdateUserPasswordInput = {
  email: Scalars['Email'];
  newPassword: Scalars['String'];
  orgFriendlyName: Scalars['String'];
  token: Scalars['String'];
};

export type UploadMatterDocumentInput = {
  documentFileName: Scalars['String'];
  matterId: Scalars['ID'];
  userFileName: Scalars['String'];
};

export type UploadMembersCsvInput = {
  rows: Array<MemberRow>;
};

export type UploadMembersCsvPayload = MembersCsvProblems | UploadMembersCsvSuccess;

export type UploadMembersCsvSuccess = {
  createdIds: Array<Scalars['ID']>;
  updatedIds: Array<Scalars['ID']>;
};

export type UpsertCustomEvaluationTemplateOnProgramInput = {
  customEvaluations?: InputMaybe<Array<InputMaybe<CustomEvaluation>>>;
  programId: Scalars['ID'];
};

export type UpsertEvaluationTemplateOnProgramInput = {
  programId: Scalars['ID'];
  questions?: InputMaybe<Array<AddEvaluationQuestionInput>>;
};

export type UpsertInternalFieldAnswerInput = {
  booleanValue?: InputMaybe<Scalars['Boolean']>;
  dateValue?: InputMaybe<Scalars['String']>;
  numericValue?: InputMaybe<Scalars['Float']>;
  questionId: Scalars['Int'];
  selectValue?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  textValue?: InputMaybe<Scalars['String']>;
};

export type UpsertInternalFieldQuestionInput = {
  id?: InputMaybe<Scalars['ID']>;
  options?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showOnJobApplication?: InputMaybe<Scalars['Boolean']>;
  showOnProfile?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type: QuestionType;
};

export type UpsertProgramGroupInput = {
  /** If id is provided, update existing group's name. If not, create new group. */
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  /** Required only when creating a new group */
  programId?: InputMaybe<Scalars['ID']>;
};

export type UpsertProgramGroupPayload = {
  group: ProgramGroupNode;
};

export type UpsertReminderEmailsOnProgramInput = {
  email?: InputMaybe<EmailInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  programId: Scalars['ID'];
};

export type UpsertWorkAllocationEmailAlertsInput = {
  emailAdminWhenAttorneyCreatesProject: Scalars['Boolean'];
  emailAdminWhenFeedbackSubmitted: Scalars['Boolean'];
  emailAdminWhenSummerAssociateCreatesProject: Scalars['Boolean'];
  emailAdminWhenSummerAssociateDeletesProject: Scalars['Boolean'];
  emailAdminWhenSummerAssociateIsAssignedToProject: Scalars['Boolean'];
  emailAdminWhenSummerAssociateIsRemovedFromProject: Scalars['Boolean'];
  emailAssignedAttorneysWhenAssociateAssignedToProject: Scalars['Boolean'];
  emailAssignedAttorneysWhenAssociateDeletesProject: Scalars['Boolean'];
  emailAssignedAttorneysWhenAssociateIsRemovedFromProject: Scalars['Boolean'];
  emailAssignedAttorneysWhenDocumentsAreUploadedToProject: Scalars['Boolean'];
  emailContributorWhenAssociateCreatesProject: Scalars['Boolean'];
  emailContributorWhenAssociateDeletesProject: Scalars['Boolean'];
  emailContributorWhenAssociateIsRemovedFromProject: Scalars['Boolean'];
  emailContributorWhenAttorneyCreatesProject: Scalars['Boolean'];
  emailSummerAssociateWhenAssignedToProject: Scalars['Boolean'];
  programId: Scalars['ID'];
};

export type UpsertWorkAllocationPermissionsInput = {
  allowSummerAssociatesToCreateEditProjects: Scalars['Boolean'];
  allowSummerAssociatesToDeleteProjects: Scalars['Boolean'];
  allowSummerAssociatesToSelfAssignProjects: Scalars['Boolean'];
  programId: Scalars['ID'];
};

export type UpsertWorkAllocationProgramInput = {
  description?: InputMaybe<Scalars['String']>;
  endDate: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  ownerUserId: Scalars['ID'];
  startDate: Scalars['String'];
  timezone: Scalars['String'];
  title: Scalars['String'];
};

export type UpsertWorkAllocationProgramMatterInput = {
  assignmentType?: InputMaybe<AssignmentType>;
  attorneys?: InputMaybe<Array<Scalars['ID']>>;
  clientMatterName: Scalars['String'];
  clientMatterNumber?: InputMaybe<Scalars['String']>;
  clientNumber?: InputMaybe<Scalars['String']>;
  deadline?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  offices?: InputMaybe<Array<Scalars['ID']>>;
  practiceAreas?: InputMaybe<Array<Scalars['ID']>>;
  timeToComplete?: InputMaybe<TimeToCompleteInput>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UserAnalyticsInfo = AdminUserAnalyticsInfo | CandidateUserAnalyticsInfo;

export type UserAttendeeNode = {
  admin?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['Int']>;
  extension?: Maybe<Scalars['String']>;
  feedback?: Maybe<Array<CandidateEvaluationNode>>;
  fname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lname?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
};

export type UserNode = {
  admin?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  fname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lname?: Maybe<Scalars['String']>;
};

export type UserNotificationNode = Node & {
  id: Scalars['ID'];
  notificationId: Scalars['Int'];
  timeSent: Scalars['String'];
  uid: Scalars['Int'];
};

/** An object for exposing data on user-actionable errors (e.g. email is taken). */
export type UserWarning = {
  /** A user-friendly message describing the problem. */
  userMessage: Scalars['String'];
};

export type UserWorkAllocationPermissions = {
  permissions?: Maybe<Array<Maybe<WorkAllocationPermission>>>;
  programId: Scalars['ID'];
};

export type VirtualChatMemberConnection = Connection & {
  edges: Array<VirtualChatMemberEdge>;
  nodes: Array<VirtualChatMemberNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VirtualChatMemberEdge = Edge & {
  cursor: Scalars['String'];
  node: VirtualChatMemberNode;
};

/** An individual Member of a Member Group with whom the Candidate can meet. */
export type VirtualChatMemberNode = Node & {
  bioLink?: Maybe<Scalars['Url']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  orgId: Scalars['ID'];
  rawBioLink?: Maybe<Scalars['String']>;
};

export type VirtualChatScheduleConnection = Connection & {
  edges: Array<VirtualChatScheduleEdge>;
  nodes: Array<VirtualChatScheduleNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VirtualChatScheduleEdge = Edge & {
  cursor: Scalars['String'];
  node: VirtualChatScheduleNode;
};

/** A group of Members with whom the Candidate can select Timeslots. */
export type VirtualChatScheduleNode = Node & {
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  members?: Maybe<VirtualChatMemberConnection>;
  orgId: Scalars['ID'];
  timeslots?: Maybe<VirtualChatTimeslotConnection>;
};


/** A group of Members with whom the Candidate can select Timeslots. */
export type VirtualChatScheduleNodeMembersArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


/** A group of Members with whom the Candidate can select Timeslots. */
export type VirtualChatScheduleNodeTimeslotsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type VirtualChatTimeslotConnection = Connection & {
  edges: Array<VirtualChatTimeslotEdge>;
  nodes: Array<VirtualChatTimeslotNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type VirtualChatTimeslotEdge = Edge & {
  cursor: Scalars['String'];
  node: VirtualChatTimeslotNode;
};

/** An individual timeframe during which a Candidate can participate in a meeting with a group of the Firm's Members. */
export type VirtualChatTimeslotNode = Node & {
  end?: Maybe<DateTimeZone>;
  eventId: Scalars['ID'];
  id: Scalars['ID'];
  /**
   * The maximum number of Candidates allowed for this Timeslot.
   *
   * `null` if unlimited.
   */
  maxCandidateCapacity?: Maybe<Scalars['Int']>;
  /** The current number of Candidates registered for this Timeslot. */
  numCandidatesRegistered?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  rawVideoLink?: Maybe<Scalars['String']>;
  /** The id of the Event User Schedule, not to be confused with the id of an Interivew Schedule from Interview Scheduling. */
  scheduleId: Scalars['ID'];
  start?: Maybe<DateTimeZone>;
  videoLink?: Maybe<Scalars['Url']>;
};

export type VirtualTimeslotNode = Node & TimeslotNode & {
  end?: Maybe<DateTimeZone>;
  hostEventId: Scalars['ID'];
  id: Scalars['ID'];
  interviewerOrg?: Maybe<PublicOrgInfo>;
  interviewerOrgId: Scalars['ID'];
  /** `null` if not available to show. */
  interviewers?: Maybe<Array<Maybe<Interviewer>>>;
  rawVideoLink?: Maybe<Scalars['String']>;
  start?: Maybe<DateTimeZone>;
  videoLink?: Maybe<Scalars['Url']>;
};

export type WebinarEventNode = EmployerEventNode & EventNode & Node & {
  associatedUniversityName?: Maybe<Scalars['String']>;
  candidateReminderDisabled?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<DateTimeZone>;
  eventType?: Maybe<EventType>;
  forwardEventPublishingSettings?: Maybe<ForwardEventPublishingSettings>;
  id: Scalars['ID'];
  inviteOnly?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  memberFeedbackDisabled?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgId?: Maybe<Scalars['Int']>;
  registeredCandidates?: Maybe<Array<RecruitAttendeeNode>>;
  registeredMembers?: Maybe<Array<UserAttendeeNode>>;
  registrationEnd?: Maybe<DateTimeZone>;
  resumeRequirement?: Maybe<DocumentRequirementEnum>;
  start?: Maybe<DateTimeZone>;
  tags?: Maybe<EventTagConnection>;
  targetedSchools?: Maybe<EventTargetsSchoolConnection>;
  transcriptRequirement?: Maybe<DocumentRequirementEnum>;
};


export type WebinarEventNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};


export type WebinarEventNodeTargetedSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type WhoAmI = {
  /** Non-`null` if and only if requester has agency contact role. */
  asAgencyContact?: Maybe<WhoAmIAgencyContact>;
  /** Non-`null` if and only if requester has associate role. */
  asAssociate?: Maybe<WhoAmIAssociate>;
  /** Non-`null` if and only if requester has candidate role. */
  asCandidate?: Maybe<WhoAmICandidate>;
  /** Non-`null` if and only if requester has org admin role. */
  asOrgAdmin?: Maybe<WhoAmIOrgAdmin>;
  /** Non-`null` if and only if requester has org member role. */
  asOrgMember?: Maybe<WhoAmIOrgMember>;
  /**
   * Non-`null` if and only if requester has org admin or org member role.
   *
   * This field's choice of implementation should not be depended upon in multi-role situations. In other words, don't count on this always returning an admin for a user that's both admin and member.
   */
  asOrgUser?: Maybe<WhoAmIOrgUser>;
  isLoggedIn: Scalars['Boolean'];
  /** Convenience field, checks against `roles`. */
  isLoggedInWithRole: Scalars['Boolean'];
  roles: Array<WhoAmIRole>;
};


export type WhoAmIIsLoggedInWithRoleArgs = {
  role: WhoAmIRole;
};

export type WhoAmIAgencyContact = {
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type WhoAmIAssociate = {
  orgId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type WhoAmICandidate = {
  forwardAccountStatus: WhoAmICandidateForwardAccountStatus;
  loggedInEmail: Scalars['String'];
  userId: Scalars['ID'];
};

export enum WhoAmICandidateForwardAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  None = 'NONE'
}

export type WhoAmIOrgAdmin = WhoAmIOrgUser & {
  loggedInEmail?: Maybe<Scalars['String']>;
  orgFriendlyName: Scalars['String'];
  orgId: Scalars['ID'];
  orgType: WhoAmIOrgType;
  userId: Scalars['ID'];
};

export type WhoAmIOrgMember = WhoAmIOrgUser & {
  loggedInEmail?: Maybe<Scalars['String']>;
  orgFriendlyName: Scalars['String'];
  orgId: Scalars['ID'];
  orgType: WhoAmIOrgType;
  userId: Scalars['ID'];
};

export enum WhoAmIOrgType {
  Employer = 'EMPLOYER',
  Internal = 'INTERNAL',
  University = 'UNIVERSITY',
  /** Fall-back, but shouldn't happen in practice. */
  Unknown = 'UNKNOWN'
}

/** Either an org admin or an org member. */
export type WhoAmIOrgUser = {
  /** This should almost always be non-`null`, but the client should handle the `null` case. */
  loggedInEmail?: Maybe<Scalars['String']>;
  orgFriendlyName: Scalars['String'];
  orgId: Scalars['ID'];
  orgType: WhoAmIOrgType;
  userId: Scalars['ID'];
};

export enum WhoAmIRole {
  AgencyContact = 'AGENCY_CONTACT',
  /** Represents a non-logged-in user, or a fall-back case where we could not determine the role. */
  Anonymous = 'ANONYMOUS',
  Associate = 'ASSOCIATE',
  Candidate = 'CANDIDATE',
  OrgAdmin = 'ORG_ADMIN',
  OrgMember = 'ORG_MEMBER'
}

export enum WorkAllocationAuthorizationReason {
  Admin = 'ADMIN',
  AssignedAssociate = 'ASSIGNED_ASSOCIATE',
  AssignedAttorney = 'ASSIGNED_ATTORNEY',
  Contributor = 'CONTRIBUTOR',
  MemberWithProgramEvalRequest = 'MEMBER_WITH_PROGRAM_EVAL_REQUEST'
}

export enum WorkAllocationPermission {
  AssignProjects = 'ASSIGN_PROJECTS',
  EditProjects = 'EDIT_PROJECTS',
  ReadEvaluations = 'READ_EVALUATIONS'
}

export enum WorkArrangement {
  Hybrid = 'HYBRID',
  InPerson = 'IN_PERSON',
  Remote = 'REMOTE'
}

export type WorkplaceConnection = Connection & {
  edges: Array<WorkplaceEdge>;
  nodes: Array<WorkplaceNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WorkplaceEdge = Edge & {
  cursor: Scalars['String'];
  node: WorkplaceNode;
};

export type WorkplaceNode = Node & {
  connectedOrg?: Maybe<PublicOrgInfo>;
  connectedOrgId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
};

export type UpdateAgencyRegistrationStatusMutationVariables = Exact<{
  agencyId: Scalars['ID'];
  isUnregisteredAgency: Scalars['Boolean'];
}>;


export type UpdateAgencyRegistrationStatusMutation = { updateAgencyRegistrationStatus?: boolean | null };

export type FindAgencyByLoggedInUserEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type FindAgencyByLoggedInUserEmailQuery = { findAgencyByLoggedInUserEmail?: { isUnregisteredAgency?: boolean | null } | null };

export type SendPasswordResetEmailMutationVariables = Exact<{
  input: SendPasswordResetEmailInput;
}>;


export type SendPasswordResetEmailMutation = { sendPasswordResetEmail: boolean };

export type ResetUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput;
}>;


export type ResetUserPasswordMutation = { resetUserPassword: { success: boolean, error?: PasswordResetError | null } };

export type CandidatesToBeMergedQueryVariables = Exact<{
  recruitIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CandidatesToBeMergedQuery = { getCandidates?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, jobApps?: { nodes?: Array<{ id: string, appSource?: string | null, createdAt?: string | null, job?: { title?: string | null } | null, status?: { name?: string | null } | null } | null> | null } | null } | null> | null };

export type MergeCandidatesMutationVariables = Exact<{
  input: CandidateMergeInput;
}>;


export type MergeCandidatesMutation = { mergeCandidates?: boolean | null };

export type JobAppSourceOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type JobAppSourceOptionsQuery = { fetchAppSourceOptions?: Array<{ name?: string | null, label?: string | null } | null> | null };

export type ConflictingJobAppsOfCandidatesQueryVariables = Exact<{
  recruitId1: Scalars['Int'];
  recruitId2: Scalars['Int'];
}>;


export type ConflictingJobAppsOfCandidatesQuery = { conflictingJobAppsOfCandidates: Array<{ jobId: number, recruitIds: Array<number>, job: { id: string, title?: string | null, statuses?: Array<{ id: string, name?: string | null, corePipelineStepId?: number | null, jobPipelineBucketId?: number | null }> | null }, jobApps: Array<{ id: string, recruitId?: number | null, status?: { id: string, jobPipelineBucketId?: number | null, corePipelineStepId?: number | null, name?: string | null } | null }> }> };

export type GetCandidateReviewContentForCandidateQueryVariables = Exact<{
  candidateReviewTemplateId: Scalars['Int'];
  recruitId: Scalars['Int'];
}>;


export type GetCandidateReviewContentForCandidateQuery = { getCandidateReviewContentForCandidate: { candidateId: number, candidateReviewTemplateId: number, sections?: Array<{ sectionType?: CandidateReviewTemplateSectionType | null, order?: number | null, evaluationSortEnum?: EvaluationSortEnum | null, documents?: Array<{ documentLink?: string | null, uploadedDate?: string | null, title?: string | null } | null> | null, jobApps?: Array<{ jobId: number, jobAppId: number, personalInfoSection?: { firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, linkedin?: string | null, order?: number | null } | null, addressInfoSection?: { addressLineOne?: string | null, addressLineTwo?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, order?: number | null } | null, workHistorySection?: { order?: number | null, candidateWorkHistory?: Array<{ employer?: string | null, position?: string | null, startDate?: string | null, endDate?: string | null, isCurrentEmployer?: boolean | null } | null> | null } | null, educationHistorySection?: { order?: number | null, candidateEducationHistory?: Array<{ university?: string | null, degree?: UniversityDegreeEnum | null, degreeEnum?: number | null, startDate?: string | null, endDate?: string | null } | null> | null } | null, customQuestionsSections?: Array<{ order?: number | null, questionSectionName?: string | null, applicationQuestions?: Array<{ order?: number | null, appQuestionId?: number | null, questionLabel?: string | null, answer?: Array<string | null> | null } | null> | null } | null> | null } | null> | null, additionalInfo?: { qualifyingQuestions?: Array<{ order?: number | null, qqId?: number | null, questionLabel?: string | null, answer?: Array<string | null> | null } | null> | null, internalFields?: Array<{ order?: number | null, internalFieldId?: number | null, questionLabel?: string | null, answer?: Array<string | null> | null } | null> | null, applicationQuestions?: Array<{ order?: number | null, appQuestionId?: number | null, questionLabel?: string | null, answer?: Array<string | null> | null } | null> | null } | null, interviewSchedules?: Array<{ eventId: number, eventName?: string | null, interviewDate?: string | null, interviewStartTime?: string | null, interviewEndTime?: string | null, interviewers?: Array<string | null> | null } | null> | null, evaluations?: Array<{ eventId?: number | null, eventTitle?: string | null, evaluatorId: number, evaluatorName?: string | null, questionType?: FeedbackQuestionType | null, questionLabel?: string | null, freeTextResponse?: string | null, yesNoResponse?: boolean | null, ratingResponse?: number | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, singleSelectResponse?: string | null, multiSelectResponse?: Array<string | null> | null, selectOptions?: Array<string | null> | null, comment?: string | null } | null> | null, programEvaluations?: Array<{ id: number, title: string, mostRecentEvaluationDate?: string | null, evaluations?: Array<{ completedAt?: string | null, evaluationId: number, evaluationTitle?: string | null, evaluatorId?: number | null, evaluatorName?: string | null, questionType?: FeedbackQuestionType | null, questionLabel?: string | null, questionSubtext?: string | null, questionOrder?: number | null, questionFeedbackId?: number | null, freeTextResponse?: string | null, yesNoResponse?: boolean | null, ratingResponse?: number | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, singleSelectResponse?: string | null, multiSelectResponse?: Array<string | null> | null, selectOptions?: Array<string | null> | null, comment?: string | null } | null> | null } | null> | null, projectsWithEvaluations?: Array<{ projectId: number, projectTitle?: string | null, projectDescription?: string | null, projectPracticeAreas?: Array<string | null> | null, projectCompletedAt?: string | null, mostRecentEvaluationDate?: string | null, evaluations?: Array<{ completedAt?: string | null, evaluationId: number, evaluationTitle?: string | null, evaluatorId?: number | null, evaluatorName?: string | null, questionType?: FeedbackQuestionType | null, questionLabel?: string | null, questionSubtext?: string | null, questionOrder?: number | null, questionFeedbackId?: number | null, freeTextResponse?: string | null, yesNoResponse?: boolean | null, ratingResponse?: number | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, singleSelectResponse?: string | null, multiSelectResponse?: Array<string | null> | null, selectOptions?: Array<string | null> | null, comment?: string | null } | null> | null, documents?: Array<{ documentLink?: string | null, uploadedDate?: string | null, userFileName?: string | null, title?: string | null } | null> | null } | null> | null } | null> | null } };

export type IndividualCandidateReviewQueryVariables = Exact<{
  candidateReviewTemplateId: Scalars['Int'];
}>;


export type IndividualCandidateReviewQuery = { getCandidateReviewTemplate: { title?: string | null, id: string, candidateReviewType?: string | null, creatorFirstName?: string | null, creatorLastName?: string | null, createdBy?: string | null, createdAt?: string | null, votingEnabled?: boolean | null, votingInfo?: { id: string, candidateReviewTemplateId: number, votingEndDate?: string | null, votingEndTimeZone?: string | null, votingStartDate?: string | null, votingStartTimeZone?: string | null } | null, programEvaluationConfig?: { evaluationScope?: CandidateReviewTemplateProgramsEvaluationScope | null, evaluationStartDate?: string | null, evaluationStartTimeZone?: string | null, evaluationEndDate?: string | null, evaluationEndTimeZone?: string | null } | null, jobs?: Array<{ id?: number | null, title?: string | null } | null> | null, events?: Array<{ id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | null> | null, programs?: Array<{ id: string, title?: string | null } | null> | null, candidateReviewTemplateCandidates?: Array<{ candidateReviewTemplateId?: number | null, createdAt?: string | null, evaluationAverage?: number | null, candidate?: { firstName?: string | null, lastName?: string | null, id: string, email?: string | null, qualifyingQuestions?: { edges?: Array<{ node?: { id: string, question?: string | null, answers?: Array<string | null> | null } | null } | null> | null } | null } | null, votingRecords?: Array<{ id: string, fname?: string | null, lname?: string | null, candidateReviewTemplateId?: number | null, userId?: number | null, castedVote?: string | null, comment?: string | null, candidateId?: number | null } | null> | null } | null> | null, sections?: Array<{ __typename: 'CandidateReviewTemplateSectionNode', id: string, enabled?: boolean | null, order?: number | null, evaluationSortEnum?: EvaluationSortEnum | null, sectionType?: CandidateReviewTemplateSectionType | null, includedDocuments?: Array<{ id: string, order?: number | null, orgDocumentId: number } | null> | null, includedEvaluationQuestions?: Array<{ id: string, order?: number | null, orgEvalQuestionId?: number | null } | null> | null, includedAdditionalInformation?: Array<{ id: string, order?: number | null, questionType?: CandidateReviewTemplateAdditionalInformationQuestionType | null, qqId?: number | null, internalFieldId?: number | null, appQuestionId?: number | null } | null> | null } | null> | null } };

export type IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables = Exact<{
  candidateReviewTemplateId: Scalars['Int'];
}>;


export type IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery = { getCandidateReviewTemplate: { title?: string | null, id: string, candidateReviewType?: string | null, creatorFirstName?: string | null, creatorLastName?: string | null, createdBy?: string | null, createdAt?: string | null, votingEnabled?: boolean | null, votingInfo?: { id: string, candidateReviewTemplateId: number, votingEndDate?: string | null, votingEndTimeZone?: string | null, votingStartDate?: string | null, votingStartTimeZone?: string | null } | null, jobs?: Array<{ id?: number | null, title?: string | null } | null> | null, events?: Array<{ id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | null> | null, programs?: Array<{ id: string, title?: string | null, evaluationQuestions?: Array<{ id: string, orgFeedbackId?: number | null, evaluationQuestion?: { id: string, label?: string | null } | null } | null> | null, customEvaluations?: Array<{ id: string, evaluationName: string, evaluationType: string, questions?: Array<{ id: string, orgFeedbackId?: number | null, evaluationQuestion?: { id: string, label?: string | null } | null } | null> | null } | null> | null } | null> | null, programEvaluationConfig?: { evaluationScope?: CandidateReviewTemplateProgramsEvaluationScope | null, evaluationStartDate?: string | null, evaluationStartTimeZone?: string | null, evaluationEndDate?: string | null, evaluationEndTimeZone?: string | null } | null, candidateReviewTemplateCandidates?: Array<{ candidateReviewTemplateId?: number | null, createdAt?: string | null, evaluationAverage?: number | null, candidate?: { firstName?: string | null, lastName?: string | null, id: string, email?: string | null, jobApps?: { nodes?: Array<{ id: string, recruitId?: number | null, job?: { id: string, title?: string | null, orgId: string, is1L: boolean, is2L: boolean, hasJobBoardAudienceSet: boolean } | null, status?: { id: string, name?: string | null } | null } | null> | null } | null, qualifyingQuestions?: { edges?: Array<{ node?: { id: string, question?: string | null, answers?: Array<string | null> | null } | null } | null> | null } | null } | null, votingRecords?: Array<{ id: string, fname?: string | null, lname?: string | null, candidateReviewTemplateId?: number | null, userId?: number | null, castedVote?: string | null, comment?: string | null, candidateId?: number | null } | null> | null } | null> | null, sections?: Array<{ __typename: 'CandidateReviewTemplateSectionNode', id: string, enabled?: boolean | null, order?: number | null, evaluationSortEnum?: EvaluationSortEnum | null, sectionType?: CandidateReviewTemplateSectionType | null, includedDocuments?: Array<{ id: string, order?: number | null, orgDocumentId: number } | null> | null, includedEvaluationQuestions?: Array<{ id: string, order?: number | null, orgEvalQuestionId?: number | null, programEvaluationId?: number | null } | null> | null, includedEvaluations?: Array<{ id: string, enabled?: boolean | null, programEvaluationId?: number | null } | null> | null, includedAdditionalInformation?: Array<{ id: string, order?: number | null, questionType?: CandidateReviewTemplateAdditionalInformationQuestionType | null, qqId?: number | null, internalFieldId?: number | null, appQuestionId?: number | null } | null> | null, includedJobAppSections?: Array<{ id: string, order: number, jobSectionId: number, includedJobAppQuestions?: Array<{ id: string, order: number, jobQuestionId: number }> | null } | null> | null } | null> | null } };

export type CandidateReviewVotingRecordsQueryVariables = Exact<{
  candidateReviewTemplateId: Scalars['Int'];
}>;


export type CandidateReviewVotingRecordsQuery = { getCandidateReviewTemplate: { candidateReviewTemplateCandidates?: Array<{ votingRecords?: Array<{ id: string, fname?: string | null, lname?: string | null, candidateReviewTemplateId?: number | null, userId?: number | null, castedVote?: string | null, comment?: string | null, candidateId?: number | null } | null> | null } | null> | null } };

export type CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables = Exact<{
  candidateReviewTemplateId: Scalars['Int'];
  recruitId: Scalars['Int'];
}>;


export type CandidateReviewVotingRecordsOfIndividualRecruitQuery = { getCandidateReviewTemplate: { candidateReviewTemplateCandidates?: Array<{ votingRecords?: Array<{ id: string, fname?: string | null, lname?: string | null, candidateReviewTemplateId?: number | null, userId?: number | null, castedVote?: string | null, comment?: string | null, candidateId?: number | null } | null> | null } | null> | null } };

export type CandidateReviewTemplatesForOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidateReviewTemplatesForOrgQuery = { getCandidateReviewTemplatesForOrg: Array<{ title?: string | null, id: string, candidateReviewType?: string | null, creatorFirstName?: string | null, creatorLastName?: string | null, createdBy?: string | null, createdAt?: string | null, jobs?: Array<{ id?: number | null, title?: string | null } | null> | null, events?: Array<{ id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | null> | null, candidateReviewTemplateCandidates?: Array<{ candidate?: { firstName?: string | null, lastName?: string | null, id: string, email?: string | null, qualifyingQuestions?: { edges?: Array<{ node?: { id: string, question?: string | null, answers?: Array<string | null> | null } | null } | null> | null } | null } | null } | null> | null, sections?: Array<{ id: string, enabled?: boolean | null, order?: number | null, evaluationSortEnum?: EvaluationSortEnum | null, sectionType?: CandidateReviewTemplateSectionType | null, includedDocuments?: Array<{ id: string, order?: number | null, orgDocumentId: number } | null> | null } | null> | null } | null> };

export type CandidateReviewTemplateOverviewsForOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidateReviewTemplateOverviewsForOrgQuery = { getCandidateReviewTemplatesForOrg: Array<{ title?: string | null, id: string, creatorFirstName?: string | null, creatorLastName?: string | null, createdBy?: string | null, createdAt?: string | null, candidateReviewType?: string | null, candidateReviewTemplateCandidates?: Array<{ candidate?: { id: string } | null } | null> | null, sections?: Array<{ id: string } | null> | null } | null> };

export type CandidateReviewProgramAssociatesQueryVariables = Exact<{
  programId: Scalars['ID'];
  associateRecruitIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type CandidateReviewProgramAssociatesQuery = { programAssociatesByRecruitIds: Array<{ id?: string | null, lawSchools?: Array<string> | null, recruitIdForAssociateWorkEmail?: number | null }> };

export type UpsertCandidateReviewTemplateMutationVariables = Exact<{
  candidateReviewTemplateInput: CandidateReviewTemplateInput;
}>;


export type UpsertCandidateReviewTemplateMutation = { upsertCandidateReviewTemplate: number };

export type UpsertCandidateReviewTemplateCandidatesMutationVariables = Exact<{
  candidateReviewTemplateCandidatesInput: CandidateReviewTemplateCandidatesInput;
}>;


export type UpsertCandidateReviewTemplateCandidatesMutation = { upsertCandidateReviewTemplateCandidates: boolean };

export type UpsertCandidateReviewTemplateEventsMutationVariables = Exact<{
  candidateReviewTemplateEventsInput: CandidateReviewTemplateEventsInput;
}>;


export type UpsertCandidateReviewTemplateEventsMutation = { upsertCandidateReviewTemplateEvents: boolean };

export type UpsertCandidateReviewTemplateJobsMutationVariables = Exact<{
  candidateReviewTemplateJobsInput: CandidateReviewTemplateJobsInput;
}>;


export type UpsertCandidateReviewTemplateJobsMutation = { upsertCandidateReviewTemplateJobs: boolean };

export type UpsertCandidateReviewTemplateJobsWithEventsMutationVariables = Exact<{
  candidateReviewTemplateJobsWithEventsInput: CandidateReviewTemplateJobsWithEventsInput;
}>;


export type UpsertCandidateReviewTemplateJobsWithEventsMutation = { upsertCandidateReviewTemplateJobsWithEvents: boolean };

export type UpsertCandidateReviewTemplateProgramsMutationVariables = Exact<{
  candidateReviewTemplateProgramsInput: CandidateReviewTemplateProgramsInput;
}>;


export type UpsertCandidateReviewTemplateProgramsMutation = { upsertCandidateReviewTemplatePrograms: boolean };

export type UpsertCandidateReviewTemplateSectionsMutationVariables = Exact<{
  candidateReviewTemplateId: Scalars['Int'];
  documentSectionInput?: InputMaybe<CandidateReviewTemplateDocumentSectionInput>;
  evaluationSectionInput?: InputMaybe<CandidateReviewTemplateEvaluationSectionInput>;
  additionalInformationSectionInput?: InputMaybe<CandidateReviewTemplateAdditionalInformationSectionInput>;
  interviewScheduleSectionInput?: InputMaybe<CandidateReviewTemplateInterviewScheduleSectionInput>;
  jobAppSectionInput?: InputMaybe<CandidateReviewTemplateJobAppSectionInput>;
  projectDocumentsSectionInput?: InputMaybe<CandidateReviewTemplateProjectDocumentsSectionInput>;
}>;


export type UpsertCandidateReviewTemplateSectionsMutation = { upsertCandidateReviewTemplateSections?: boolean | null };

export type DeleteCandidateReviewTemplateMutationVariables = Exact<{
  candidateReviewTemplateId: Scalars['Int'];
}>;


export type DeleteCandidateReviewTemplateMutation = { deleteCandidateReviewTemplate?: boolean | null };

export type UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables = Exact<{
  candidateReviewCandidateVotingInput: CandidateReviewTemplateCandidateVotingInput;
}>;


export type UpsertCandidateReviewTemplateCandidateVotingRecordMutation = { upsertCandidateReviewTemplateCandidateVotingRecord?: boolean | null };

export type UpsertCandidateReviewVotingRecordCastedVotedMutationVariables = Exact<{
  candidateReviewVotingRecordCastedVotedInput: CandidateReviewVotingRecordCastedVotedInput;
}>;


export type UpsertCandidateReviewVotingRecordCastedVotedMutation = { upsertCandidateReviewVotingRecordCastedVoted?: boolean | null };

export type UpsertCandidateReviewVotingRecordCommentMutationVariables = Exact<{
  candidateReviewVotingRecordCommentInput: CandidateReviewVotingRecordCommentInput;
}>;


export type UpsertCandidateReviewVotingRecordCommentMutation = { upsertCandidateReviewVotingRecordComment?: boolean | null };

export type EventEvaluationQuestionsByEventIdQueryVariables = Exact<{
  eventIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type EventEvaluationQuestionsByEventIdQuery = { eventEvaluationQuestionsByEventIds: Array<{ id: string, eventId: number, orgFeedbackId: number, sortOrder: number, label: string }> };

export type AllLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLanguagesQuery = { allLanguages: Array<{ id: string, name: string }> };

export type TrackActivateForwardAccountFromEventMutationVariables = Exact<{
  input: TrackActivateForwardAccountFromEventInput;
}>;


export type TrackActivateForwardAccountFromEventMutation = { trackActivateForwardAccountFromEvent?: { success: boolean } | null };

export type ForwardEventDetailPageQueryVariables = Exact<{
  eventId: Scalars['ID'];
  numChars: Scalars['Int'];
}>;


export type ForwardEventDetailPageQuery = { forwardCandidateEventById?: { __typename: 'CandidateCallbackEventNode', id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateNetworkingEventNode', id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidatePhysicalEventNode', location?: string | null, description?: string | null, university?: string | null, id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateSymplicityEventNode', id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateVirtualChatEventNode', description?: string | null, university?: string | null, id: string, name: string, areAllTimeslotsFull: boolean, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, timeslotChoices?: { totalCount?: number | null } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', description?: string | null, university?: string | null, id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | null };

export type EventDirectoryQueryVariables = Exact<{
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<EventDirectoryFilterBy>;
  sortBy?: InputMaybe<Array<EventDirectorySortBy> | EventDirectorySortBy>;
}>;


export type EventDirectoryQuery = { eventDirectory?: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ metadata: { isFeatured: boolean, rotation: number }, node: { __typename: 'CandidateCallbackEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateNetworkingEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidatePhysicalEventNode', location?: string | null, description?: string | null, university?: string | null, id: string, name: string, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateSymplicityEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateVirtualChatEventNode', description?: string | null, university?: string | null, id: string, name: string, areAllTimeslotsFull: boolean, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, timeslotChoices?: { totalCount?: number | null } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', description?: string | null, university?: string | null, id: string, name: string, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } }> } | null };

export type EventDirectoryAvailableCountQueryVariables = Exact<{
  filterBy?: InputMaybe<EventDirectoryFilterBy>;
}>;


export type EventDirectoryAvailableCountQuery = { eventDirectory?: { totalCount?: number | null } | null };

export type EventRegistrationModalDemographicInfoQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type EventRegistrationModalDemographicInfoQuery = { candidateEventById?: { __typename: 'CandidateCallbackEventNode' } | { __typename: 'CandidateInviteEmployerEventNode' } | { __typename: 'CandidateNetworkingEventNode' } | { __typename: 'CandidatePhysicalEventNode', myPotentialProfiles?: { nodes: Array<{ recruitId: string, demographicInfo?: { fixedGenderNames?: Array<string> | null, writeYourOwnGenderName?: string | null, ethnicityNames?: Array<string> | null } | null }> } | null } | { __typename: 'CandidatePreselectEventNode' } | { __typename: 'CandidateSerendipitousEventNode' } | { __typename: 'CandidateSymplicityEventNode' } | { __typename: 'CandidateVirtualChatEventNode', myPotentialProfiles?: { nodes: Array<{ recruitId: string, demographicInfo?: { fixedGenderNames?: Array<string> | null, writeYourOwnGenderName?: string | null, ethnicityNames?: Array<string> | null } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', myPotentialProfiles?: { nodes: Array<{ recruitId: string, demographicInfo?: { fixedGenderNames?: Array<string> | null, writeYourOwnGenderName?: string | null, ethnicityNames?: Array<string> | null } | null }> } | null } | { __typename: 'LotteryStudentEventNode' } | null };

export type EventRegistrationModalDemographicInfoMyPotentialProfileFieldsFragment = { nodes: Array<{ recruitId: string, demographicInfo?: { fixedGenderNames?: Array<string> | null, writeYourOwnGenderName?: string | null, ethnicityNames?: Array<string> | null } | null }> };

export type EventRegistrationSubmitDemographicInfoMutationVariables = Exact<{
  input: SubmitDemographicAnswersForOutreachEventCandidateRegistrationInput;
  shouldCompleteRegistration: Scalars['Boolean'];
  finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput;
}>;


export type EventRegistrationSubmitDemographicInfoMutation = { submitDemographicAnswersForOutreachEventCandidateRegistration: { success: boolean }, completeOutreachEventCandidateRegistration?: { success: boolean } };

export type EventRegistrationModalDocumentSubmissionQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type EventRegistrationModalDocumentSubmissionQuery = { candidateEventById?: { __typename: 'CandidateCallbackEventNode', id: string } | { __typename: 'CandidateInviteEmployerEventNode', id: string } | { __typename: 'CandidateNetworkingEventNode', id: string } | { __typename: 'CandidatePhysicalEventNode', id: string, documentAssignments?: { totalCount?: number | null, nodes: Array<{ isRequired: boolean, uploadRequestType: EventDocumentUploadRequestType, assignedDocument?: { id: string, name?: string | null, myMostRecentSubmissions?: { nodes: Array<{ recruitId: string }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ recruitId: string }> } | null } | { __typename: 'CandidatePreselectEventNode', id: string } | { __typename: 'CandidateSerendipitousEventNode', id: string } | { __typename: 'CandidateSymplicityEventNode', id: string } | { __typename: 'CandidateVirtualChatEventNode', id: string, documentAssignments?: { totalCount?: number | null, nodes: Array<{ isRequired: boolean, uploadRequestType: EventDocumentUploadRequestType, assignedDocument?: { id: string, name?: string | null, myMostRecentSubmissions?: { nodes: Array<{ recruitId: string }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ recruitId: string }> } | null } | { __typename: 'CandidateWebinarEventNode', id: string, documentAssignments?: { totalCount?: number | null, nodes: Array<{ isRequired: boolean, uploadRequestType: EventDocumentUploadRequestType, assignedDocument?: { id: string, name?: string | null, myMostRecentSubmissions?: { nodes: Array<{ recruitId: string }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ recruitId: string }> } | null } | { __typename: 'LotteryStudentEventNode', id: string } | null };

export type EventRegistrationModalDocumentFieldsFragment = { totalCount?: number | null, nodes: Array<{ isRequired: boolean, uploadRequestType: EventDocumentUploadRequestType, assignedDocument?: { id: string, name?: string | null, myMostRecentSubmissions?: { nodes: Array<{ recruitId: string }> } | null } | null }> };

export type EventRegistrationModalDocumentSubmissionMyPotentialProfileFieldsFragment = { nodes: Array<{ recruitId: string }> };

export type EventRegistrationSubmitDocumentsMutationVariables = Exact<{
  input: SubmitDocumentsForEmployerEventInput;
  shouldCompleteRegistration: Scalars['Boolean'];
  finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput;
}>;


export type EventRegistrationSubmitDocumentsMutation = { submitDocumentsForEmployerEvent: { success: boolean }, completeOutreachEventCandidateRegistration?: { success: boolean } };

export type EventRegistrationModalQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type EventRegistrationModalQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', loggedInEmail: string, profile?: { firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, linkedInUrl?: string | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null, candidateEventById?: { __typename: 'CandidateCallbackEventNode', id: string, name: string, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidateNetworkingEventNode', id: string, name: string, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidatePhysicalEventNode', deiRequested: boolean, headshotUploadRequested: boolean, isInviteOnly: boolean, id: string, name: string, assignedQualifyingQuestions?: { totalCount?: number | null } | null, documentAssignments?: { totalCount?: number | null, nodes: Array<{ isRequired: boolean, uploadRequestType: EventDocumentUploadRequestType, assignedDocument?: { id: string, name?: string | null, myMostRecentSubmissions?: { nodes: Array<{ recruitId: string }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, recruitId: string }> } | null, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidateSymplicityEventNode', id: string, name: string, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidateVirtualChatEventNode', deiRequested: boolean, headshotUploadRequested: boolean, isInviteOnly: boolean, id: string, name: string, assignedQualifyingQuestions?: { totalCount?: number | null } | null, documentAssignments?: { totalCount?: number | null, nodes: Array<{ isRequired: boolean, uploadRequestType: EventDocumentUploadRequestType, assignedDocument?: { id: string, name?: string | null, myMostRecentSubmissions?: { nodes: Array<{ recruitId: string }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, recruitId: string }> } | null, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'CandidateWebinarEventNode', deiRequested: boolean, headshotUploadRequested: boolean, isInviteOnly: boolean, id: string, name: string, assignedQualifyingQuestions?: { totalCount?: number | null } | null, documentAssignments?: { totalCount?: number | null, nodes: Array<{ isRequired: boolean, uploadRequestType: EventDocumentUploadRequestType, assignedDocument?: { id: string, name?: string | null, myMostRecentSubmissions?: { nodes: Array<{ recruitId: string }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, recruitId: string }> } | null, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, host?: { id: string, logoUrl?: string | null, name?: string | null, hasPublicFirmProfile: boolean } | null } | null };

export type TrackForwardEventStartRegistrationMutationVariables = Exact<{
  input: TrackForwardEventStartRegistrationInput;
}>;


export type TrackForwardEventStartRegistrationMutation = { trackForwardEventStartRegistration?: { success: boolean } | null };

export type TrackForwardEventCompleteRegistrationMutationVariables = Exact<{
  input: TrackForwardEventCompleteRegistrationInput;
}>;


export type TrackForwardEventCompleteRegistrationMutation = { trackForwardEventCompleteRegistration?: { success: boolean } | null };

export type EventRegistrationModalPersonalInfoQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type EventRegistrationModalPersonalInfoQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', loggedInEmail: string, profile?: { firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, linkedInUrl?: string | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null, candidateEventById?: { __typename: 'CandidateCallbackEventNode' } | { __typename: 'CandidateInviteEmployerEventNode' } | { __typename: 'CandidateNetworkingEventNode' } | { __typename: 'CandidatePhysicalEventNode', myPotentialProfiles?: { nodes: Array<{ recruitId: string, email: string, personalInfo?: { firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, linkedInUrl?: string | null } | null }> } | null } | { __typename: 'CandidatePreselectEventNode' } | { __typename: 'CandidateSerendipitousEventNode' } | { __typename: 'CandidateSymplicityEventNode' } | { __typename: 'CandidateVirtualChatEventNode', myPotentialProfiles?: { nodes: Array<{ recruitId: string, email: string, personalInfo?: { firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, linkedInUrl?: string | null } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', myPotentialProfiles?: { nodes: Array<{ recruitId: string, email: string, personalInfo?: { firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, linkedInUrl?: string | null } | null }> } | null } | { __typename: 'LotteryStudentEventNode' } | null };

export type EventRegistrationModalPersonalInfoMyPotentialProfileFieldsFragment = { nodes: Array<{ recruitId: string, email: string, personalInfo?: { firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, linkedInUrl?: string | null } | null }> };

export type EventRegistrationSubmitPersonalInfoMutationVariables = Exact<{
  input: SubmitPersonalInfoForOutreachEventCandidateRegistrationInput;
  shouldCompleteRegistration: Scalars['Boolean'];
  finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput;
}>;


export type EventRegistrationSubmitPersonalInfoMutation = { submitPersonalInfoForOutreachEventCandidateRegistration: { success: boolean }, completeOutreachEventCandidateRegistration?: { success: boolean } };

export type EventRegistrationModalQualifyingQuestionsQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type EventRegistrationModalQualifyingQuestionsQuery = { candidateEventById?: { __typename: 'CandidateCallbackEventNode', id: string } | { __typename: 'CandidateInviteEmployerEventNode', id: string } | { __typename: 'CandidateNetworkingEventNode', id: string } | { __typename: 'CandidatePhysicalEventNode', id: string, assignedQualifyingQuestions?: { nodes: Array<{ order?: number | null, question?: { id: string, name?: string | null, type?: QualifyingQuestionType | null, distinguishedType?: DistinguishedQualifyingQuestionType | null, presets?: { nodes: Array<{ id: string, name?: string | null }> } | null, myAnswers?: { nodes: Array<{ recruitId: string, answerString?: string | null }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ recruitId: string }> } | null } | { __typename: 'CandidatePreselectEventNode', id: string } | { __typename: 'CandidateSerendipitousEventNode', id: string } | { __typename: 'CandidateSymplicityEventNode', id: string } | { __typename: 'CandidateVirtualChatEventNode', id: string, assignedQualifyingQuestions?: { nodes: Array<{ order?: number | null, question?: { id: string, name?: string | null, type?: QualifyingQuestionType | null, distinguishedType?: DistinguishedQualifyingQuestionType | null, presets?: { nodes: Array<{ id: string, name?: string | null }> } | null, myAnswers?: { nodes: Array<{ recruitId: string, answerString?: string | null }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ recruitId: string }> } | null } | { __typename: 'CandidateWebinarEventNode', id: string, assignedQualifyingQuestions?: { nodes: Array<{ order?: number | null, question?: { id: string, name?: string | null, type?: QualifyingQuestionType | null, distinguishedType?: DistinguishedQualifyingQuestionType | null, presets?: { nodes: Array<{ id: string, name?: string | null }> } | null, myAnswers?: { nodes: Array<{ recruitId: string, answerString?: string | null }> } | null } | null }> } | null, myPotentialProfiles?: { nodes: Array<{ recruitId: string }> } | null } | { __typename: 'LotteryStudentEventNode', id: string } | null };

export type EventRegistrationModalQualifyingQuestionFieldsFragment = { nodes: Array<{ order?: number | null, question?: { id: string, name?: string | null, type?: QualifyingQuestionType | null, distinguishedType?: DistinguishedQualifyingQuestionType | null, presets?: { nodes: Array<{ id: string, name?: string | null }> } | null, myAnswers?: { nodes: Array<{ recruitId: string, answerString?: string | null }> } | null } | null }> };

export type EventRegistrationModalQualifyingQuestionsMyPotentialProfileFieldsFragment = { nodes: Array<{ recruitId: string }> };

export type EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables = Exact<{
  input: SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInput;
  shouldCompleteRegistration: Scalars['Boolean'];
  finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput;
}>;


export type EventRegistrationSubmitQualifyingQuestionAnswersMutation = { submitQualifyingQuestionAnswersForOutreachEventCandidateRegistration: { success: boolean }, completeOutreachEventCandidateRegistration?: { success: boolean } };

export type EventRegistrationModalVirtualChatSchedulerQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type EventRegistrationModalVirtualChatSchedulerQuery = { candidateEventById?: { __typename: 'CandidateCallbackEventNode', id: string } | { __typename: 'CandidateInviteEmployerEventNode', id: string } | { __typename: 'CandidateNetworkingEventNode', id: string } | { __typename: 'CandidatePhysicalEventNode', id: string } | { __typename: 'CandidatePreselectEventNode', id: string } | { __typename: 'CandidateSerendipitousEventNode', id: string } | { __typename: 'CandidateSymplicityEventNode', id: string } | { __typename: 'CandidateVirtualChatEventNode', maxNumTimeslotsForCandidate?: number | null, areAllTimeslotsFull: boolean, id: string, schedules?: { nodes: Array<{ id: string, orgId: string, eventId: string, members?: { nodes: Array<{ id: string, orgId: string, firstName?: string | null, lastName?: string | null, rawBioLink?: string | null, bioLink?: string | null }> } | null, timeslots?: { nodes: Array<{ id: string, orgId: string, eventId: string, scheduleId: string, maxCandidateCapacity?: number | null, numCandidatesRegistered?: number | null, rawVideoLink?: string | null, videoLink?: string | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null }> } | null }> } | null, contact?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null, myPotentialProfiles?: { nodes: Array<{ timeslotChoices?: { nodes: Array<{ timeslotId: string }> } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', id: string } | { __typename: 'LotteryStudentEventNode', id: string } | null };

export type EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables = Exact<{
  input: SubmitVirtualChatRecruitTimeslotSelectionsInput;
}>;


export type EventRegistrationSubmitVirtualChatTimeslotSelectionsMutation = { submitVirtualChatRecruitTimeslotSelections: { success: boolean } };

export type EventRegistrationModalSubmitHeadshotQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type EventRegistrationModalSubmitHeadshotQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', loggedInEmail: string, profile?: { firstName?: string | null, lastName?: string | null, profilePhotoUrl?: string | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null, candidateEventById?: { __typename: 'CandidateCallbackEventNode', id: string } | { __typename: 'CandidateInviteEmployerEventNode', id: string } | { __typename: 'CandidateNetworkingEventNode', id: string } | { __typename: 'CandidatePhysicalEventNode', id: string, myPotentialProfiles?: { nodes: Array<{ recruitId: string, headshotUrl?: string | null, personalInfo?: { firstName?: string | null, lastName?: string | null } | null }> } | null } | { __typename: 'CandidatePreselectEventNode', id: string } | { __typename: 'CandidateSerendipitousEventNode', id: string } | { __typename: 'CandidateSymplicityEventNode', id: string } | { __typename: 'CandidateVirtualChatEventNode', id: string, myPotentialProfiles?: { nodes: Array<{ recruitId: string, headshotUrl?: string | null, personalInfo?: { firstName?: string | null, lastName?: string | null } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', id: string, myPotentialProfiles?: { nodes: Array<{ recruitId: string, headshotUrl?: string | null, personalInfo?: { firstName?: string | null, lastName?: string | null } | null }> } | null } | { __typename: 'LotteryStudentEventNode', id: string } | null };

export type EventRegistrationModalSubmitHeadshotMyPotentialProfileFieldsFragment = { nodes: Array<{ recruitId: string, headshotUrl?: string | null, personalInfo?: { firstName?: string | null, lastName?: string | null } | null }> };

export type EventRegistrationSubmitHeadshotMutationVariables = Exact<{
  input: SubmitHeadshotForOutreachEventCandidateRegistrationInput;
  shouldCompleteRegistration: Scalars['Boolean'];
  finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput;
}>;


export type EventRegistrationSubmitHeadshotMutation = { submitHeadshotForOutreachEventCandidateRegistration: { success: boolean }, completeOutreachEventCandidateRegistration?: { success: boolean } };

export type ForwardAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardAccountQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', shouldShowEventsInterviewsFeedGettingStarted: boolean, emails: Array<{ email: string, isPrimary: boolean }>, profile?: { id: string, profilePhotoUrl?: string | null, firstName?: string | null, lastName?: string | null, rawPhoneNumber?: string | null, phoneNumber?: string | null, rawLinkedInUrl?: string | null, linkedInUrl?: string | null, lawDegree?: { graduationDate?: string | null, degreeType?: LawDegree | null, classification?: LawSchoolClassification | null, gpa?: number | null, lawSchool?: { id: string, name: string } | null } | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

export type ForwardProfileFragment = { id: string, profilePhotoUrl?: string | null, firstName?: string | null, lastName?: string | null, rawPhoneNumber?: string | null, phoneNumber?: string | null, rawLinkedInUrl?: string | null, linkedInUrl?: string | null, lawDegree?: { graduationDate?: string | null, degreeType?: LawDegree | null, classification?: LawSchoolClassification | null, gpa?: number | null, lawSchool?: { id: string, name: string } | null } | null };

export type ForwardProfileFormFragment = { firstName?: string | null, lastName?: string | null, rawPhoneNumber?: string | null, phoneNumber?: string | null, rawLinkedInUrl?: string | null, linkedInUrl?: string | null };

export type SendAddEmailToForwardAccountLinkMutationVariables = Exact<{
  input: SendAddEmailToForwardAccountLinkInput;
}>;


export type SendAddEmailToForwardAccountLinkMutation = { sendAddEmailToForwardAccountLink: { __typename: 'SendAddEmailToForwardAccountLinkEmailAlreadyWithUser', userMessage: string } | { __typename: 'SendAddEmailToForwardAccountLinkSuccess', email: string } };

export type RemoveEmailFromForwardAccountMutationVariables = Exact<{
  input: RemoveEmailFromForwardAccountInput;
}>;


export type RemoveEmailFromForwardAccountMutation = { removeEmailFromForwardAccount: { __typename: 'RemoveEmailFromForwardAccountLoggedInWithEmail', userMessage: string } | { __typename: 'RemoveEmailFromForwardAccountSuccess', successful?: boolean | null } };

export type IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables = Exact<{ [key: string]: never; }>;


export type IncrementTimesViewedForwardEventsInterviewsFeedMutation = { incrementTimesViewedForwardEventsInterviewsFeed: { successful: boolean } };

export type EditForwardProfileMutationVariables = Exact<{
  input: EditForwardProfileInput;
}>;


export type EditForwardProfileMutation = { editForwardProfile: { success: boolean } };

export type ForwardDashboardRecentJobApplicationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<ForwardJobApplicationFeedSortBy>;
}>;


export type ForwardDashboardRecentJobApplicationsQuery = { forwardJobApplicationFeed?: { nodes: Array<{ __typename: 'AtsJobApplicationNode', id: string, job?: { __typename: 'AtsJobNode', id: string, title?: string | null, employer?: { name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null } | { __typename: 'ExternalJobApplicationNode', id: string, job?: { __typename: 'ExternalJobNode', id: string, title?: string | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null, salaryInfo?: { amount: number, timeUnit: JobSalaryInfoTimeUnit } | null, employer?: { name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null } | { __typename: 'InterviewSchedulingJobApplicationNode', id: string, job?: { __typename: 'InterviewSchedulingJobNode', id: string, title?: string | null, practiceAreas?: { nodes?: Array<{ id: string, name: string }> | null } | null, employer?: { name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null }> } | null };

export type ForwardEventsInterviewsFeedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardEventsInterviewsFeedFilterBy>;
}>;


export type ForwardEventsInterviewsFeedQuery = { forwardEventsInterviewsFeed?: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, progress: { numTotalEvents: number, numTotalInterviews: number, numCompletedEvents: number, numCompletedInterviews: number }, edges: Array<{ __typename: 'ForwardEventsInterviewsFeedEventEdge', cursor: string, node: { __typename: 'CandidatePhysicalEventNode', id: string, name: string, location?: string | null, isPublishedToForward: boolean, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, rawJobsPageLink?: string | null, jobsPageLink?: string | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, rawEventPageLink?: string | null, eventPageLink?: string | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateWebinarEventNode', id: string, name: string, rawWebinarLink?: string | null, webinarLink?: string | null, isPublishedToForward: boolean, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, rawMySchedulePageLink?: string | null, mySchedulePageLink?: string | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null } } | { __typename: 'ForwardEventsInterviewsFeedTimeslotEdge', cursor: string, metadata: { eventId: string, eventName?: string | null, eventType: EventType, hostSchoolName?: string | null, hostSchoolLogo?: string | null, isPublishedToForward?: boolean | null }, node: { __typename: 'InPersonTimeslotNode', location?: string | null, roomNumber?: string | null, rawVideoLink?: string | null, videoLink?: string | null, id: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, interviewerOrg?: { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, interviewers?: Array<{ id: string, firstName?: string | null, lastName?: string | null } | null> | null } | { __typename: 'VirtualTimeslotNode', rawVideoLink?: string | null, videoLink?: string | null, id: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, interviewerOrg?: { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, interviewers?: Array<{ id: string, firstName?: string | null, lastName?: string | null } | null> | null } }> } | null };

export type ForwardDashboardOrgInfoFragment = { logoUrl?: string | null, id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null };

export type FirmProfileLinkInfoFragment = { id: string, urlFriendlyName?: string | null, name?: string | null, hasPublicFirmProfile: boolean };

type FirmEventCardFields_CandidateCallbackEventNode_Fragment = { __typename: 'CandidateCallbackEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardFields_CandidateInviteEmployerEventNode_Fragment = { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardFields_CandidateNetworkingEventNode_Fragment = { __typename: 'CandidateNetworkingEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardFields_CandidatePhysicalEventNode_Fragment = { __typename: 'CandidatePhysicalEventNode', location?: string | null, description?: string | null, university?: string | null, id: string, name: string, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null };

type FirmEventCardFields_CandidatePreselectEventNode_Fragment = { __typename: 'CandidatePreselectEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardFields_CandidateSerendipitousEventNode_Fragment = { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardFields_CandidateSymplicityEventNode_Fragment = { __typename: 'CandidateSymplicityEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardFields_CandidateVirtualChatEventNode_Fragment = { __typename: 'CandidateVirtualChatEventNode', description?: string | null, university?: string | null, id: string, name: string, areAllTimeslotsFull: boolean, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, timeslotChoices?: { totalCount?: number | null } | null }> } | null };

type FirmEventCardFields_CandidateWebinarEventNode_Fragment = { __typename: 'CandidateWebinarEventNode', description?: string | null, university?: string | null, id: string, name: string, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null };

type FirmEventCardFields_LotteryStudentEventNode_Fragment = { __typename: 'LotteryStudentEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

export type FirmEventCardFieldsFragment = FirmEventCardFields_CandidateCallbackEventNode_Fragment | FirmEventCardFields_CandidateInviteEmployerEventNode_Fragment | FirmEventCardFields_CandidateNetworkingEventNode_Fragment | FirmEventCardFields_CandidatePhysicalEventNode_Fragment | FirmEventCardFields_CandidatePreselectEventNode_Fragment | FirmEventCardFields_CandidateSerendipitousEventNode_Fragment | FirmEventCardFields_CandidateSymplicityEventNode_Fragment | FirmEventCardFields_CandidateVirtualChatEventNode_Fragment | FirmEventCardFields_CandidateWebinarEventNode_Fragment | FirmEventCardFields_LotteryStudentEventNode_Fragment;

type FirmEventCardHostFields_CandidateCallbackEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidateInviteEmployerEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidateNetworkingEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidatePhysicalEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidatePreselectEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidateSerendipitousEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidateSymplicityEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidateVirtualChatEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_CandidateWebinarEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

type FirmEventCardHostFields_LotteryStudentEventNode_Fragment = { host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null };

export type FirmEventCardHostFieldsFragment = FirmEventCardHostFields_CandidateCallbackEventNode_Fragment | FirmEventCardHostFields_CandidateInviteEmployerEventNode_Fragment | FirmEventCardHostFields_CandidateNetworkingEventNode_Fragment | FirmEventCardHostFields_CandidatePhysicalEventNode_Fragment | FirmEventCardHostFields_CandidatePreselectEventNode_Fragment | FirmEventCardHostFields_CandidateSerendipitousEventNode_Fragment | FirmEventCardHostFields_CandidateSymplicityEventNode_Fragment | FirmEventCardHostFields_CandidateVirtualChatEventNode_Fragment | FirmEventCardHostFields_CandidateWebinarEventNode_Fragment | FirmEventCardHostFields_LotteryStudentEventNode_Fragment;

type FirmEventCardRegistrationButtonFields_CandidateCallbackEventNode_Fragment = { __typename: 'CandidateCallbackEventNode' };

type FirmEventCardRegistrationButtonFields_CandidateInviteEmployerEventNode_Fragment = { __typename: 'CandidateInviteEmployerEventNode' };

type FirmEventCardRegistrationButtonFields_CandidateNetworkingEventNode_Fragment = { __typename: 'CandidateNetworkingEventNode' };

type FirmEventCardRegistrationButtonFields_CandidatePhysicalEventNode_Fragment = { __typename: 'CandidatePhysicalEventNode', myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null };

type FirmEventCardRegistrationButtonFields_CandidatePreselectEventNode_Fragment = { __typename: 'CandidatePreselectEventNode' };

type FirmEventCardRegistrationButtonFields_CandidateSerendipitousEventNode_Fragment = { __typename: 'CandidateSerendipitousEventNode' };

type FirmEventCardRegistrationButtonFields_CandidateSymplicityEventNode_Fragment = { __typename: 'CandidateSymplicityEventNode' };

type FirmEventCardRegistrationButtonFields_CandidateVirtualChatEventNode_Fragment = { __typename: 'CandidateVirtualChatEventNode', areAllTimeslotsFull: boolean, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, timeslotChoices?: { totalCount?: number | null } | null }> } | null };

type FirmEventCardRegistrationButtonFields_CandidateWebinarEventNode_Fragment = { __typename: 'CandidateWebinarEventNode', myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null };

type FirmEventCardRegistrationButtonFields_LotteryStudentEventNode_Fragment = { __typename: 'LotteryStudentEventNode' };

export type FirmEventCardRegistrationButtonFieldsFragment = FirmEventCardRegistrationButtonFields_CandidateCallbackEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidateInviteEmployerEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidateNetworkingEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidatePhysicalEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidatePreselectEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidateSerendipitousEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidateSymplicityEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidateVirtualChatEventNode_Fragment | FirmEventCardRegistrationButtonFields_CandidateWebinarEventNode_Fragment | FirmEventCardRegistrationButtonFields_LotteryStudentEventNode_Fragment;

export type FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables = Exact<{
  eventId: Scalars['ID'];
  orgFriendlyName: Scalars['String'];
}>;


export type FirmEventCardRegistrationButtonFieldsByEventIdQuery = { candidateEventById?: { __typename: 'CandidateCallbackEventNode' } | { __typename: 'CandidateInviteEmployerEventNode' } | { __typename: 'CandidateNetworkingEventNode' } | { __typename: 'CandidatePhysicalEventNode', myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'CandidatePreselectEventNode' } | { __typename: 'CandidateSerendipitousEventNode' } | { __typename: 'CandidateSymplicityEventNode' } | { __typename: 'CandidateVirtualChatEventNode', areAllTimeslotsFull: boolean, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, timeslotChoices?: { totalCount?: number | null } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'LotteryStudentEventNode' } | null };

export type ManageForwardEventPublishingSettingsQueryVariables = Exact<{
  eventId: Scalars['Int'];
}>;


export type ManageForwardEventPublishingSettingsQuery = { eventById?: { __typename: 'CallbackEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'CoffeeChatEventNode', associatedUniversityName?: string | null, id: string, orgId?: number | null, name: string, forwardEventPublishingSettings?: { carouselEventShown: boolean, directoryEventShown: boolean } | null, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null } | { __typename: 'InterviewSchedulingEmployerEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'InterviewSchedulingUniversityEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'InvitedEmployerEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'LotteryEmployerEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'LotteryUniversityEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'NetworkingEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'OCIEmployerEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'OCIUniversityEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'PhysicalEventNode', associatedUniversityName?: string | null, id: string, orgId?: number | null, name: string, forwardEventPublishingSettings?: { carouselEventShown: boolean, directoryEventShown: boolean } | null, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null } | { __typename: 'SerendipitousEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'SharedNetworkingEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'UniversityEventNode', id: string, orgId?: number | null, name: string } | { __typename: 'WebinarEventNode', associatedUniversityName?: string | null, id: string, orgId?: number | null, name: string, forwardEventPublishingSettings?: { carouselEventShown: boolean, directoryEventShown: boolean } | null, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null } | null };

export type GetOrgForwardPrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgForwardPrivilegesQuery = { getOrgEmployerMember?: { __typename: 'EmployerOrgNode', orgForwardPrivileges?: { id: string, carouselEventPublishing: boolean, directoryEventPublishing: boolean, lawSchoolTargeting: boolean } | null } | { __typename: 'UniversityOrgNode' } | null };

export type SubmitForwardEventPublishingSettingsMutationVariables = Exact<{
  input: SubmitForwardEventPublishingSettingsInput;
}>;


export type SubmitForwardEventPublishingSettingsMutation = { submitForwardEventPublishingSettings: { success: boolean } };

export type SubmitEventSchoolTargetingMutationVariables = Exact<{
  input: SubmitEventSchoolTargetingInput;
}>;


export type SubmitEventSchoolTargetingMutation = { submitEventSchoolTargeting: { success: boolean } };

export type FirmDirectoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<FirmDirectoryFilterBy>;
  sortBy?: InputMaybe<Array<FirmDirectorySortBy> | FirmDirectorySortBy>;
  numChars?: InputMaybe<Scalars['Int']>;
}>;


export type FirmDirectoryQuery = { firmDirectory?: { totalCount?: number | null, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { id: string, name: string, asEnum: ForwardTier } | null, offices: { nodes: Array<{ officeLocation: { id: string, name: string } }> }, firmProfile?: { id: string, orgId: string, revenueDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, isPublic: boolean } | null } }> } | null };

export type FirmProfilePreviewFieldsFragment = { name?: string | null, orgId: string, isFloCustomer?: boolean | null, logoUrl?: string | null, urlFriendlyName?: string | null, hasPublicFirmProfile: boolean, officeLocations?: { nodes: Array<{ name: string }> } | null, forwardTier?: { asEnum: ForwardTier } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null };

export type SummerProgramStatsQueryVariables = Exact<{
  firmFriendlyName: Scalars['String'];
}>;


export type SummerProgramStatsQuery = { firmProfileByFirmFriendlyName?: { id: string, firm: { firmPracticeAreas?: { nodes: Array<{ id: string, firmSpecificName: string, summerOffices: { nodes: Array<{ id: string, officeLocation: { name: string } }> } }> } | null }, summerProgramSection?: { summerTopPracticeAreasAsOf?: string | null, hasSummerByPracticeDataToInput: boolean, summerTopOfficeLocationsAsOf?: string | null, summerPracticeAreaByOfficeAsOf?: string | null, summerTopPracticeAreas?: Array<{ numSummerAssociates: number, orgPracticeArea: { firmSpecificName: string } }> | null, summerTopOfficeLocations?: Array<{ numSummerAssociate: number, officeLocation?: { name: string } | null }> | null } | null } | null };

export type DiversityAndInclusionStatsQueryVariables = Exact<{
  firmFriendlyName: Scalars['String'];
}>;


export type DiversityAndInclusionStatsQuery = { firmProfileByFirmFriendlyName?: { id: string, diversityAndInclusionSection?: { genderStatisticsAsOf?: string | null, ethnicityStatisticsAsOf?: string | null, additionalStatisticsAsOf?: string | null, statistics?: { gender: Array<{ numAssociates?: number | null, numCounsels?: number | null, numNonEquityPartners?: number | null, numPartners?: number | null, numSummerAssociates?: number | null, selfIdDefault: { label?: string | null }, selfIdDefaultOption: { name?: string | null } }>, raceOrEthnicity: Array<{ numAssociates?: number | null, numCounsels?: number | null, numNonEquityPartners?: number | null, numPartners?: number | null, numSummerAssociates?: number | null, selfIdDefault: { name?: string | null }, selfIdDefaultOption: { name?: string | null } }>, additional: Array<{ numAssociates?: number | null, numCounsels?: number | null, numNonEquityPartners?: number | null, numPartners?: number | null, numSummerAssociates?: number | null, selfIdDefault: { label?: string | null }, selfIdDefaultOption: { name?: string | null } }> } | null } | null } | null };

export type PracticeAreaStatsQueryVariables = Exact<{
  firmFriendlyName: Scalars['String'];
}>;


export type PracticeAreaStatsQuery = { firmProfileByFirmFriendlyName?: { id: string, orgId: string, practiceAreaSection?: { headcountsAsOf?: string | null, headcounts: Array<{ totalNumAttorneys?: number | null, numAssociates?: number | null, numCounsels?: number | null, numPartners?: number | null, numNonEquityPartners?: number | null, numNonTraditionalTrackOrStaff?: number | null, numEntryLevelPlacements?: number | null, ranking: number, orgPracticeArea: { firmSpecificName: string, offices: { nodes: Array<{ officeLocation: { name: string } }> } } }> } | null } | null };

export type ProBonoStatsQueryVariables = Exact<{
  firmFriendlyName: Scalars['String'];
}>;


export type ProBonoStatsQuery = { firmProfileByFirmFriendlyName?: { id: string, proBonoSection?: { averageHoursAsOf?: string | null, participationPercentagesAsOf?: string | null, participationPercentage?: { associate?: number | null, partner?: number | null, otherLawyers?: number | null } | null, averageHours?: { associate?: number | null, partner?: number | null, otherLawyers?: number | null } | null } | null } | null };

export type FirmProfileEventCarouselQueryVariables = Exact<{
  orgId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type FirmProfileEventCarouselQuery = { publicOrgInfoByOrgId?: { firmProfile?: { eventCarousel?: { isEnabled: boolean, firmCarouselEvents?: { totalCount?: number | null, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ node: { __typename: 'CandidateCallbackEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateNetworkingEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidatePhysicalEventNode', location?: string | null, description?: string | null, university?: string | null, id: string, name: string, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateSymplicityEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } | { __typename: 'CandidateVirtualChatEventNode', description?: string | null, university?: string | null, id: string, name: string, areAllTimeslotsFull: boolean, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean, timeslotChoices?: { totalCount?: number | null } | null }> } | null } | { __typename: 'CandidateWebinarEventNode', description?: string | null, university?: string | null, id: string, name: string, registrationEnds?: { date: string, time: string, zone: FloTimezone } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, myPotentialProfiles?: { nodes: Array<{ isRegistered: boolean }> } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, urlFriendlyName?: string | null, name?: string | null, logoUrl?: string | null, hasPublicFirmProfile: boolean, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null } }> } | null } | null } | null } | null };

export type FirmProfileJobCarouselQueryVariables = Exact<{
  firmFriendlyName: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
  descriptionTextContentNumChars: Scalars['Int'];
}>;


export type FirmProfileJobCarouselQuery = { publicOrgInfoByOrgFriendlyName?: { name?: string | null, openJobs?: { pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, edges: Array<{ cursor: string, node: { __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, extension?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null } | { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null, practiceCategories?: { nodes: Array<{ name: string, id: string }> } | null, salaryInfo?: { amount: number, timeUnit: JobSalaryInfoTimeUnit } | null } }> } | null } | null };

export type FirmProfileByFirmFriendlyNameQueryVariables = Exact<{
  firmFriendlyName: Scalars['String'];
}>;


export type FirmProfileByFirmFriendlyNameQuery = { firmProfileByFirmFriendlyName?: { id: string, bio?: string | null, revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numPartnershipTiers?: number | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null, websiteLinkUrl?: string | null, isPublic: boolean, daysInOfficePerWeek?: number | null, daysInOfficeContext?: string | null, firm: { id: string, name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null, offices: { nodes: Array<{ officeLocation: { id: string, name: string } }> }, firmPracticeAreas?: { nodes: Array<{ summerOffices: { nodes: Array<{ officeLocation: { name: string } }> } }> } | null }, customLink?: { url: string, display: string } | null, socialMediaLinks?: { twitterUrl?: string | null, youtubeUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null } | null, customSection?: { firmProfileId: string, title?: string | null, coverImageSrc?: string | null, answer?: string | null, moreAboutLifeAt?: string | null, isEnabled: boolean, learnMoreLink?: { url: string, display?: string | null } | null, richMediaSubsection?: { section: FirmProfileSection, title: string, blurb: string, richMedia: Array<{ firmProfileSection: FirmProfileSection, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaLink?: string | null, mediaTitle?: string | null, mediaLinkText?: string | null, mediaThumbnailLink?: string | null } | null }> } | null } | null, diversityAndInclusionSection?: { answer?: string | null, learnMoreLink?: string | null, isEnabled: boolean, statistics?: { gender: Array<{ numAssociates?: number | null, numCounsels?: number | null, numPartners?: number | null, numSummerAssociates?: number | null, selfIdDefault: { label?: string | null }, selfIdDefaultOption: { name?: string | null } }>, raceOrEthnicity: Array<{ numAssociates?: number | null, numCounsels?: number | null, numPartners?: number | null, numSummerAssociates?: number | null, selfIdDefault: { name?: string | null }, selfIdDefaultOption: { name?: string | null } }>, additional: Array<{ numAssociates?: number | null, numCounsels?: number | null, numPartners?: number | null, numSummerAssociates?: number | null, selfIdDefault: { label?: string | null }, selfIdDefaultOption: { name?: string | null } }> } | null, richMediaSubsection?: { section: FirmProfileSection, title: string, blurb: string, richMedia: Array<{ firmProfileSection: FirmProfileSection, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaLink?: string | null, mediaTitle?: string | null, mediaLinkText?: string | null, mediaThumbnailLink?: string | null } | null }> } | null } | null, practiceAreaSection?: { id: string, answer?: string | null, learnMoreLink?: string | null, isEnabled: boolean, headcounts: Array<{ numAssociates?: number | null, numCounsels?: number | null, numPartners?: number | null, numEntryLevelPlacements?: number | null, ranking: number, orgPracticeArea: { id: string, firmSpecificName: string, offices: { totalCount?: number | null } } }>, richMediaSubsection?: { section: FirmProfileSection, title: string, blurb: string, richMedia: Array<{ firmProfileSection: FirmProfileSection, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaLink?: string | null, mediaTitle?: string | null, mediaLinkText?: string | null, mediaThumbnailLink?: string | null } | null }> } | null } | null, proBonoSection?: { id: string, answer?: string | null, answer2?: string | null, learnMoreLink?: string | null, isEnabled: boolean, haveOpportunitiesForSummersOption?: FirmProfileProBonoHaveOpportunitiesForSummersOption | null, areProBonoHoursBillable?: FirmProfileProBonoAreProBonoHoursBillableOption | null, numBillableProBonoHours?: number | null, billableHoursContext?: string | null, participationPercentage?: { associate?: number | null, partner?: number | null, otherLawyers?: number | null } | null, averageHours?: { associate?: number | null, partner?: number | null, otherLawyers?: number | null } | null, richMediaSubsection?: { section: FirmProfileSection, title: string, blurb: string, richMedia: Array<{ firmProfileSection: FirmProfileSection, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaLink?: string | null, mediaTitle?: string | null, mediaLinkText?: string | null, mediaThumbnailLink?: string | null } | null }> } | null } | null, summerProgramSection?: { id: string, isEnabled: boolean, answer?: string | null, noResponse?: boolean | null, summerCount1L?: number | null, summerCount2L?: number | null, summerCountsAsOf?: string | null, earlyInterviewAvailableOption?: FirmProfileSummerProgramEarlyInterviewAvailableOption | null, resumeAcceptanceDeadline1L?: string | null, resumeAcceptanceText1L?: string | null, resumeAcceptanceDeadline2L?: string | null, resumeAcceptanceText2L?: string | null, assignedPracticeAreasOption?: FirmProfileSummerProgramAssignedPracticeAreasOption | null, firstYearHiredIntoPracticeAreaOption?: FirmProfileSummerProgramFirstYearHiredIntoPracticeAreaOption | null, howIsWorkAssignedOption?: FirmProfileSummerProgramHowIsWorkAssignedOption | null, howIsWorkAssignedContext?: string | null, learnMoreLink?: string | null, hasSummerByPracticeDataToInput: boolean, summerByPracticeContext?: string | null, summerTopPracticeAreasAsOf?: string | null, summerTopOfficeLocationsAsOf?: string | null, primaryContact?: { name: string, title?: string | null, email?: string | null } | null, summerSalary?: { unit: FirmProfileSummerProgramSummerSalaryLengthUnit, value: number } | null, programLength?: { unit: FirmProfileSummerProgramProgramLengthUnit, value: number } | null, summerTopPracticeAreas?: Array<{ orgPracticeAreaId: string, numSummerAssociates: number, orgPracticeArea: { firmSpecificName: string } }> | null, summerTopOfficeLocations?: Array<{ orgOfficeId: string, numSummerAssociate: number, officeLocation?: { name: string } | null }> | null, richMediaSubsection?: { section: FirmProfileSection, title: string, blurb: string, richMedia: Array<{ firmProfileSection: FirmProfileSection, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaLink?: string | null, mediaTitle?: string | null, mediaLinkText?: string | null, mediaThumbnailLink?: string | null } | null }> } | null } | null, eventCarousel?: { isEnabled: boolean } | null } | null };

export type FirmProfileSocialMediaLinksFieldsFragment = { twitterUrl?: string | null, youtubeUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null };

export type RichMediaFragment = { section: FirmProfileSection, title: string, blurb: string, richMedia: Array<{ firmProfileSection: FirmProfileSection, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaLink?: string | null, mediaTitle?: string | null, mediaLinkText?: string | null, mediaThumbnailLink?: string | null } | null }> };

export type ForwardLoginGuardQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardLoginGuardQuery = { whoAmI: { isLoggedIn: boolean, asCandidate?: { forwardAccountStatus: WhoAmICandidateForwardAccountStatus, loggedInEmail: string } | null } };

export type FirmCardQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  filterBy?: InputMaybe<FirmDirectoryFilterBy>;
  sortBy?: InputMaybe<Array<FirmDirectorySortBy> | FirmDirectorySortBy>;
}>;


export type FirmCardQuery = { firmDirectory?: { edges: Array<{ cursor: string, node: { name?: string | null, id: string, urlFriendlyName?: string | null, logoUrl?: string | null, forwardTier?: { asEnum: ForwardTier } | null } }> } | null };

export type ForwardJobApplicationFeedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobApplicationFeedFilterBy>;
  sortBy?: InputMaybe<ForwardJobApplicationFeedSortBy>;
}>;


export type ForwardJobApplicationFeedQuery = { forwardJobApplicationFeed?: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, nodes: Array<{ __typename: 'AtsJobApplicationNode', id: string, recruitId: string, jobId: string, isComplete?: boolean | null, submittedAt?: string | null, sourceLink?: string | null, job?: { __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, id: string, urlFriendlyName?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null } | { __typename: 'ExternalJobApplicationNode', id: string, recruitId: string, jobId: string, isComplete?: boolean | null, submittedAt?: string | null, sourceLink?: string | null, job?: { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null, salaryInfo?: { amount: number, timeUnit: JobSalaryInfoTimeUnit } | null, employer?: { name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, id: string, urlFriendlyName?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null } | { __typename: 'InterviewSchedulingJobApplicationNode', id: string, recruitId: string, jobId: string, isComplete?: boolean | null, submittedAt?: string | null, sourceLink?: string | null, job?: { __typename: 'InterviewSchedulingJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, practiceAreas?: { nodes?: Array<{ id: string, name: string }> | null } | null, employer?: { name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, id: string, urlFriendlyName?: string | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null }> } | null };

export type ForwardJobApplicationTotalCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardJobApplicationTotalCountQuery = { forwardJobApplicationFeed?: { totalCount?: number | null } | null };

export type JobBoardLoadTestFullQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  orderBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type JobBoardLoadTestFullQuery = { forwardJobFeed?: { totalCount?: number | null, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { id: string, orgId: string, title?: string | null, description?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null } | { id: string, orgId: string, title?: string | null, description?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null } }> } | null };

export type JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  orderBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type JobBoardLoadTestJobsOnlyNoDocumentsQuery = { forwardJobFeed?: { pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { id: string, orgId: string, title?: string | null, description?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null } | { id: string, orgId: string, title?: string | null, description?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null } }> } | null };

export type JobBoardLoadTestCountQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  orderBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type JobBoardLoadTestCountQuery = { forwardJobFeed?: { totalCount?: number | null } | null };

export type JobBoardLoadTestByIdQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type JobBoardLoadTestByIdQuery = { forwardJobById?: { id: string, orgId: string, title?: string | null, description?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null } | { id: string, orgId: string, title?: string | null, description?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null } | null };

export type JobBoardLoadTestWithoutDescriptionOrCountQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  orderBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type JobBoardLoadTestWithoutDescriptionOrCountQuery = { forwardJobFeed?: { pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { id: string, orgId: string, title?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null } | { id: string, orgId: string, title?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null } }> } | null };

export type JobBoardLoadTestWithoutCountQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  orderBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type JobBoardLoadTestWithoutCountQuery = { forwardJobFeed?: { pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { id: string, orgId: string, description?: string | null, title?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null } | { id: string, orgId: string, description?: string | null, title?: string | null, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null } }> } | null };

export type ForwardFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardFiltersQuery = { allOfficeLocations?: { nodes: Array<{ name: string, id: string }> } | null, allPracticeCategories?: { nodes: Array<{ name: string, id: string }> } | null };

export type ForwardJobPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardJobPreferencesQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', jobPreferences?: { officeLocationIds?: Array<string> | null, practiceCategoryIds?: Array<string> | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

export type SubmitForwardJobPreferencesMutationVariables = Exact<{
  input: SubmitForwardJobPreferencesInput;
}>;


export type SubmitForwardJobPreferencesMutation = { submitForwardJobPreferences: { success: boolean } };

export type ConfirmAppliedToExternalJobMutationVariables = Exact<{
  input: ConfirmAppliedToExternalJobInput;
}>;


export type ConfirmAppliedToExternalJobMutation = { confirmAppliedToExternalJob: { success: boolean } };

export type TrackGoToExternalJobPageMutationVariables = Exact<{
  input: TrackGoToExternalJobPageInput;
}>;


export type TrackGoToExternalJobPageMutation = { trackGoToExternalJobPage?: { success: boolean } | null };

export type TrackApplyToExternalJobMutationVariables = Exact<{
  input: TrackApplyToExternalJobInput;
}>;


export type TrackApplyToExternalJobMutation = { trackApplyToExternalJob?: { success: boolean } | null };

export type TrackQuickApplyToJobMutationVariables = Exact<{
  input: TrackQuickApplyToJobInput;
}>;


export type TrackQuickApplyToJobMutation = { trackQuickApplyToJob?: { success: boolean } | null };

export type ForwardAppliedJobIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardAppliedJobIdsQuery = { forwardAppliedJobIds?: Array<string> | null };

export type ForwardJobBoardFeedQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  sortBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
  descriptionTextContentNumChars: Scalars['Int'];
}>;


export type ForwardJobBoardFeedQuery = { forwardJobFeed?: { totalCount?: number | null, pageInfo: { startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPrevPage?: boolean | null }, edges: Array<{ cursor: string, node: { __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, extension?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null } | { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null, practiceCategories?: { nodes: Array<{ name: string, id: string }> } | null, salaryInfo?: { amount: number, timeUnit: JobSalaryInfoTimeUnit } | null } }> } | null };

type DiscoveryJobCardFields_AtsJobNode_Fragment = { __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, extension?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null };

type DiscoveryJobCardFields_ExternalJobNode_Fragment = { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null, practiceCategories?: { nodes: Array<{ name: string, id: string }> } | null, salaryInfo?: { amount: number, timeUnit: JobSalaryInfoTimeUnit } | null };

export type DiscoveryJobCardFieldsFragment = DiscoveryJobCardFields_AtsJobNode_Fragment | DiscoveryJobCardFields_ExternalJobNode_Fragment;

export type ForwardAvailableJobsCountQueryVariables = Exact<{
  filterBy: ForwardJobFeedFilterBy;
}>;


export type ForwardAvailableJobsCountQuery = { forwardJobFeed?: { totalCount?: number | null } | null };

export type ForwardJobDetailsQueryVariables = Exact<{
  jobId: Scalars['ID'];
  numChars?: InputMaybe<Scalars['Int']>;
  descriptionTextContentNumChars: Scalars['Int'];
}>;


export type ForwardJobDetailsQuery = { forwardJobById?: { __typename: 'AtsJobNode', description?: string | null, id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, extension?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null } | { __typename: 'ExternalJobNode', description?: string | null, id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, sourceLink?: string | null, employer?: { id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, isFloCustomer?: boolean | null, hasPublicFirmProfile: boolean, orgId: string, forwardTier?: { asEnum: ForwardTier } | null, officeLocations?: { nodes: Array<{ name: string }> } | null, firmProfile?: { revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bioTextContent?: string | null, bannerImageSrc?: string | null } | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ name: string, id: string }> | null } | null, practiceCategories?: { nodes: Array<{ name: string, id: string }> } | null, salaryInfo?: { amount: number, timeUnit: JobSalaryInfoTimeUnit } | null } | null };

export type CandidateNavBarQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidateNavBarQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', loggedInEmail: string, profile?: { id: string, firstName?: string | null, lastName?: string | null, profilePhotoUrl?: string | null } | null } | { __typename: 'InactiveForwardAccountNode', loggedInEmail: string } | null };

export type MyForwardEducationHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyForwardEducationHistoryQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', profile?: { educationHistoryEntries: { nodes: Array<{ __typename: 'CandidateEducationHistoryLawSchoolEntryNode', id: string, candidateId: string, classYear?: LawSchoolClassYear | null, degreeId: string, schoolId: string, startDate?: string | null, endDate: string, gpa?: number | null, description?: string | null, degree: { id: string, name: string }, school: { id: string, name: string } } | { __typename: 'CandidateEducationHistoryUniversityEntryNode', id: string, candidateId: string, degreeId: string, schoolId: string, startDate?: string | null, endDate: string, gpa?: number | null, description?: string | null, degree: { id: string, name: string }, school: { id: string, name: string } }> } } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

type MyForwardEducationHistoryEntry_CandidateEducationHistoryLawSchoolEntryNode_Fragment = { __typename: 'CandidateEducationHistoryLawSchoolEntryNode', id: string, candidateId: string, classYear?: LawSchoolClassYear | null, degreeId: string, schoolId: string, startDate?: string | null, endDate: string, gpa?: number | null, description?: string | null, degree: { id: string, name: string }, school: { id: string, name: string } };

type MyForwardEducationHistoryEntry_CandidateEducationHistoryUniversityEntryNode_Fragment = { __typename: 'CandidateEducationHistoryUniversityEntryNode', id: string, candidateId: string, degreeId: string, schoolId: string, startDate?: string | null, endDate: string, gpa?: number | null, description?: string | null, degree: { id: string, name: string }, school: { id: string, name: string } };

export type MyForwardEducationHistoryEntryFragment = MyForwardEducationHistoryEntry_CandidateEducationHistoryLawSchoolEntryNode_Fragment | MyForwardEducationHistoryEntry_CandidateEducationHistoryUniversityEntryNode_Fragment;

type MyForwardEducationHistoryEntryFormFields_CandidateEducationHistoryLawSchoolEntryNode_Fragment = { __typename: 'CandidateEducationHistoryLawSchoolEntryNode', classYear?: LawSchoolClassYear | null, degreeId: string, schoolId: string, startDate?: string | null, endDate: string, gpa?: number | null, description?: string | null };

type MyForwardEducationHistoryEntryFormFields_CandidateEducationHistoryUniversityEntryNode_Fragment = { __typename: 'CandidateEducationHistoryUniversityEntryNode', degreeId: string, schoolId: string, startDate?: string | null, endDate: string, gpa?: number | null, description?: string | null };

export type MyForwardEducationHistoryEntryFormFieldsFragment = MyForwardEducationHistoryEntryFormFields_CandidateEducationHistoryLawSchoolEntryNode_Fragment | MyForwardEducationHistoryEntryFormFields_CandidateEducationHistoryUniversityEntryNode_Fragment;

export type MyForwardEducationHistoryDropdownDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MyForwardEducationHistoryDropdownDataQuery = { allSchools: { nodes: Array<{ __typename: 'LawSchoolNode', id: string, name: string } | { __typename: 'UniversityNode', id: string, name: string }> }, allSchoolDegrees: { nodes: Array<{ id: string, name: string, schoolType: SchoolType, distinguishedType?: DistinguishedSchoolDegreeType | null }> } };

export type SubmitEntryOfMyForwardEducationHistoryMutationVariables = Exact<{
  input: SubmitCandidateEducationHistoryEntryInput;
}>;


export type SubmitEntryOfMyForwardEducationHistoryMutation = { submitCandidateEducationHistoryEntry: { success: boolean } };

export type RemoveEntryFromMyForwardEducationHistoryMutationVariables = Exact<{
  input: RemoveCandidateEducationHistoryEntryInput;
}>;


export type RemoveEntryFromMyForwardEducationHistoryMutation = { removeCandidateEducationHistoryEntry: { success: boolean } };

export type ForwardProfileAboutBioQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardProfileAboutBioQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', candidateId: string, profile?: { firstName?: string | null, bio?: string | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

export type EditForwardProfileAboutBioMutationVariables = Exact<{
  input: EditForwardProfileAboutBioInput;
}>;


export type EditForwardProfileAboutBioMutation = { editForwardProfileAboutBio: { success: boolean } };

export type MyForwardWorkHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyForwardWorkHistoryQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', profile?: { workHistoryEntries: { nodes: Array<{ id: string, candidateId: string, jobTitle: string, workplaceName: string, startDate: string, endDate?: string | null, isCurrentJob: boolean, workArrangement?: WorkArrangement | null, description?: string | null, officeLocationId?: string | null, practiceAreaIds: Array<string>, practiceAreas: { nodes?: Array<{ id: string, name: string }> | null }, officeLocation?: { id: string, name: string } | null, coreWorkplace?: { connectedOrg?: { logoUrl?: string | null } | null } | null }> } } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

export type MyForwardWorkHistoryEntryFragment = { id: string, candidateId: string, jobTitle: string, workplaceName: string, startDate: string, endDate?: string | null, isCurrentJob: boolean, workArrangement?: WorkArrangement | null, description?: string | null, officeLocationId?: string | null, practiceAreaIds: Array<string>, practiceAreas: { nodes?: Array<{ id: string, name: string }> | null }, officeLocation?: { id: string, name: string } | null, coreWorkplace?: { connectedOrg?: { logoUrl?: string | null } | null } | null };

export type MyForwardWorkHistoryEntryFormFieldsFragment = { jobTitle: string, workplaceName: string, startDate: string, endDate?: string | null, isCurrentJob: boolean, workArrangement?: WorkArrangement | null, description?: string | null, officeLocationId?: string | null, practiceAreaIds: Array<string>, coreWorkplace?: { connectedOrg?: { logoUrl?: string | null } | null } | null };

export type SubmitEntryOfMyForwardWorkHistoryMutationVariables = Exact<{
  submitInput: SubmitCandidateWorkHistoryEntryInput;
}>;


export type SubmitEntryOfMyForwardWorkHistoryMutation = { submitCandidateWorkHistoryEntry?: { success: boolean } | null };

export type RemoveEntryFromMyForwardWorkHistoryMutationVariables = Exact<{
  removeInput: RemoveCandidateWorkHistoryEntryInput;
}>;


export type RemoveEntryFromMyForwardWorkHistoryMutation = { removeCandidateWorkHistoryEntry?: { success: boolean } | null };

export type MyForwardWorkHistoryDropdownDataQueryVariables = Exact<{ [key: string]: never; }>;


export type MyForwardWorkHistoryDropdownDataQuery = { allPracticeAreas?: { nodes?: Array<{ id: string, name: string }> | null } | null, allOfficeLocations?: { nodes: Array<{ id: string, name: string }> } | null, workplaces: { nodes: Array<{ id: string, name: string }> } };

export type ForwardSettingsPersonalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardSettingsPersonalInfoQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', demographicInfo?: { ethnicityAnswers?: Array<string | null> | null, genderAnswers?: Array<string | null> | null, sexualIdentityAnswers?: Array<string | null> | null, veteranStatusAnswer?: string | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

export type EditForwardSettingsPersonalInfoMutationVariables = Exact<{
  input: SubmitForwardDemographicInfoInput;
}>;


export type EditForwardSettingsPersonalInfoMutation = { submitForwardDemographicInfo: { success: boolean } };

export type ForwardSettingsOfficeLocationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardSettingsOfficeLocationPreferencesQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', jobPreferences?: { officeLocationIds?: Array<string> | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

export type ForwardSettingsPracticeCategoryPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ForwardSettingsPracticeCategoryPreferencesQuery = { forwardAccount?: { __typename: 'ActiveForwardAccountNode', jobPreferences?: { practiceCategoryIds?: Array<string> | null } | null } | { __typename: 'InactiveForwardAccountNode' } | null };

export type EditForwardSettingsOfficeLocationPreferencesMutationVariables = Exact<{
  input: SubmitForwardOfficeLocationPreferencesInput;
}>;


export type EditForwardSettingsOfficeLocationPreferencesMutation = { submitForwardOfficeLocationPreferences?: { success: boolean } | null };

export type EditForwardSettingsPracticeCategoryPreferencesMutationVariables = Exact<{
  input: SubmitForwardPracticeCategoryPreferencesInput;
}>;


export type EditForwardSettingsPracticeCategoryPreferencesMutation = { submitForwardPracticeCategoryPreferences?: { success: boolean } | null };

export type RegisterForwardUserMutationVariables = Exact<{
  input: RegisterForwardUserInput;
}>;


export type RegisterForwardUserMutation = { registerForwardUser: { userMessage: string } | { accountId: string } };

export type EmployerAttendeesQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
}>;


export type EmployerAttendeesQuery = { interviewSchedulingEventAttendees?: Array<{ employerOrgId: string, employerEventId: string, employerOrgName: string, registrationContactFirstName?: string | null, registrationContactLastName?: string | null, registrationContactEmail?: string | null, numberOfJobsSubmitted?: number | null } | null> | null };

export type EmployerAttendeesFragment = { employerOrgId: string, employerEventId: string, employerOrgName: string, registrationContactFirstName?: string | null, registrationContactLastName?: string | null, registrationContactEmail?: string | null, numberOfJobsSubmitted?: number | null };

export type StudentListOfAvailableJobsQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
}>;


export type StudentListOfAvailableJobsQuery = { studentListOfAvailableJobs?: { id: string, studentUnmatchedBids?: { pageInfo?: { hasNextPage?: boolean | null } | null, nodes?: Array<{ id: string, scheduleId: number, universityOrgId: string, universityEventId: string, ranking: number, job?: { id: string, orgId: string, title?: string | null, description?: string | null, employer?: { id: string, orgId: string, name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, supportingDocuments?: Array<{ id: string, orgDocumentId: string, eventDocumentId: string, documentName: string, documentVisibilityOption: UniversityDocumentVisibilityEnum, isRequired: boolean, userFilename?: string | null, fileLocation?: string | null, documentVisibilityTime?: { date: string, time: string, zone: FloTimezone } | null, uploadDate?: { date: string, time: string, zone: FloTimezone } | null } | null> | null, offices?: { pageInfo?: { hasNextPage?: boolean | null } | null, nodes?: Array<{ id: string, name: string }> | null } | null, practiceAreas?: { pageInfo?: { hasNextPage?: boolean | null } | null, nodes?: Array<{ id: string, name: string }> | null } | null } | null } | null> | null } | null, studentAvailableJobs?: { pageInfo?: { hasNextPage?: boolean | null } | null, nodes?: Array<{ id: string, orgId: string, title?: string | null, description?: string | null, numberOfAvailableTimeSlots?: number | null, employerAllowsMultipleApplicants?: boolean | null, employer?: { id: string, orgId: string, name?: string | null, logoUrl?: string | null, isFloCustomer?: boolean | null, forwardTier?: { asEnum: ForwardTier } | null } | null, offices?: { pageInfo?: { hasNextPage?: boolean | null } | null, nodes?: Array<{ id: string, name: string }> | null } | null, practiceAreas?: { pageInfo?: { hasNextPage?: boolean | null } | null, nodes?: Array<{ id: string, name: string }> | null } | null, supportingDocuments?: Array<{ id: string, orgDocumentId: string, eventDocumentId: string, documentName: string, documentVisibilityOption: UniversityDocumentVisibilityEnum, isRequired: boolean, userFilename?: string | null, fileLocation?: string | null, documentVisibilityTime?: { date: string, time: string, zone: FloTimezone } | null, uploadDate?: { date: string, time: string, zone: FloTimezone } | null } | null> | null } | null> | null } | null } | null };

export type AvailableTimeSlotsForJobQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  scheduleId: Scalars['Int'];
  studentExtension: Scalars['String'];
}>;


export type AvailableTimeSlotsForJobQuery = { availableTimeSlotsForJob?: Array<{ id: string, scheduleId: string, startTime?: { date: string, time: string, zone: FloTimezone } | null, endTime?: { date: string, time: string, zone: FloTimezone } | null } | null> | null };

export type StudentBidListQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
}>;


export type StudentBidListQuery = { studentBidList?: { id: string, studentBids: Array<{ id: string, scheduleId: number, ranking: number } | null> } | null };

export type LotteryUniversityEventByIdForStudentQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
}>;


export type LotteryUniversityEventByIdForStudentQuery = { lotteryUniversityEventByIdForStudent?: { id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, eventDetails?: { id: string, studentEventDescription: string, eventOrganizerUserEmail: string } | null, eventTimeline?: { id: string, studentCancellationEnabled?: boolean | null, studentOptInEnabled?: boolean | null, studentBidding: { maxNumberOfBids?: number | null, maxNumberOfInterviews?: number | null, reviewPeriodStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingDeadline?: { date: string, time: string, zone: FloTimezone } | null, lotteryResultsVisibleToStudents?: { date: string, time: string, zone: FloTimezone } | null }, studentCancellation?: { studentCancellationStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentCancellationEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentOptIn?: { studentOptInStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentOptInEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, scheduleVisibility: { employerFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null, studentFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null }, studentSelfSchedule?: { studentSelfScheduleStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentSelfScheduleEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, eventPeriods?: { studentBiddingPeriod?: StudentBiddingPeriod | null, studentCancellationPeriod?: StudentCancellationPeriod | null, studentOptInPeriod?: StudentOptInPeriod | null, studentMatchReviewPeriod?: StudentMatchReviewPeriod | null, studentFinalSchedulePeriod?: StudentFinalSchedulePeriod | null, studentSelfSchedulePeriod?: StudentSelfSchedulePeriod | null } | null } | null } | null };

export type LotteryEventTimelineFragmentFragment = { id: string, studentCancellationEnabled?: boolean | null, studentOptInEnabled?: boolean | null, studentBidding: { maxNumberOfBids?: number | null, maxNumberOfInterviews?: number | null, reviewPeriodStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingDeadline?: { date: string, time: string, zone: FloTimezone } | null, lotteryResultsVisibleToStudents?: { date: string, time: string, zone: FloTimezone } | null }, studentCancellation?: { studentCancellationStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentCancellationEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentOptIn?: { studentOptInStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentOptInEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, scheduleVisibility: { employerFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null, studentFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null }, studentSelfSchedule?: { studentSelfScheduleStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentSelfScheduleEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, eventPeriods?: { studentBiddingPeriod?: StudentBiddingPeriod | null, studentCancellationPeriod?: StudentCancellationPeriod | null, studentOptInPeriod?: StudentOptInPeriod | null, studentMatchReviewPeriod?: StudentMatchReviewPeriod | null, studentFinalSchedulePeriod?: StudentFinalSchedulePeriod | null, studentSelfSchedulePeriod?: StudentSelfSchedulePeriod | null } | null };

export type DateTimeZoneFragment = { date: string, time: string, zone: FloTimezone };

export type SubmitStudentBidsMutationVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
  input?: InputMaybe<LotteryStudentBidListInput>;
}>;


export type SubmitStudentBidsMutation = { submitStudentBids?: { successful?: boolean | null } | null };

export type StudentInterviewSchedulingApplicationsQueryVariables = Exact<{
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
}>;


export type StudentInterviewSchedulingApplicationsQuery = { studentInterviewSchedulingApplications?: { nodes?: Array<{ id: string, recruitId: string, scheduleId: string, documents?: Array<{ id: string, recruitId: string, documentName?: string | null, link?: string | null, uploadDate?: string | null, filename?: string | null } | null> | null } | null> | null } | null };

export type StudentLotteryMatchesQueryVariables = Exact<{
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
}>;


export type StudentLotteryMatchesQuery = { studentLotteryMatches?: { nodes?: Array<{ id: string, scheduleId: string, isNewInterview?: boolean | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, bid?: { id: string, scheduleId: number, ranking: number } | null, job?: { id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, scheduleId: string, employer?: { isFloCustomer?: boolean | null, urlFriendlyName?: string | null, logoUrl?: string | null, name?: string | null, forwardTier?: { asEnum: ForwardTier } | null } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, supportingDocuments?: Array<{ id: string, orgDocumentId: string, documentName: string, isRequired: boolean } | null> | null, practiceAreas?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null } | null> | null } | null };

export type StudentLotteryUnmatchedBidsQueryVariables = Exact<{
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type StudentLotteryUnmatchedBidsQuery = { studentLotteryUnmatchedBids?: { totalCount?: number | null, nodes?: Array<{ id: string, scheduleId: number, ranking: number, job?: { id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, scheduleId: string, employer?: { isFloCustomer?: boolean | null, urlFriendlyName?: string | null, logoUrl?: string | null, name?: string | null, forwardTier?: { asEnum: ForwardTier } | null } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, supportingDocuments?: Array<{ id: string, orgDocumentId: string, documentName: string, isRequired: boolean } | null> | null, practiceAreas?: { nodes?: Array<{ id: string, name: string }> | null } | null } | null } | null> | null } | null };

export type JobFieldsFragment = { id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, scheduleId: string, employer?: { isFloCustomer?: boolean | null, urlFriendlyName?: string | null, logoUrl?: string | null, name?: string | null, forwardTier?: { asEnum: ForwardTier } | null } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, supportingDocuments?: Array<{ id: string, orgDocumentId: string, documentName: string, isRequired: boolean } | null> | null, practiceAreas?: { nodes?: Array<{ id: string, name: string }> | null } | null };

export type CancelLotteryStudentMatchMutationVariables = Exact<{
  universityEventId: Scalars['ID'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
  cancelLotteryStudentMatchInput: CancelLotteryStudentMatchInput;
}>;


export type CancelLotteryStudentMatchMutation = { cancelLotteryStudentMatch?: { successful?: boolean | null } | null };

export type SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
  input?: InputMaybe<InterviewSchedulingStudentPreferencesListsInput>;
}>;


export type SubmitStudentInterviewSchedulingPreferencesForJobsMutation = { submitStudentInterviewSchedulingPreferencesForJobs?: { successful?: boolean | null } | null };

export type StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
}>;


export type StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery = { studentInterviewSchedulingOfficeLocationsPreferencesForJobs?: Array<{ scheduleId: number, officeLocationPreferences?: Array<{ id: string, scheduleId: number, universityOrgId: number, universityEventId: number, officeLocationId: number, recruitId: number } | null> | null } | null> | null };

export type StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
  universityOrgFriendlyName: Scalars['String'];
  studentExtension: Scalars['String'];
}>;


export type StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery = { studentInterviewSchedulingPracticeAreasPreferencesForJobs?: Array<{ scheduleId: number, practiceAreaPreferences?: Array<{ id: string, scheduleId: number, universityOrgId: number, universityEventId: number, practiceAreaId: number, recruitId: number } | null> | null } | null> | null };

export type SubmitLotteryEventTimelineMutationVariables = Exact<{
  input: LotteryEventTimelineInput;
}>;


export type SubmitLotteryEventTimelineMutation = { submitLotteryEventTimeline?: { successful?: boolean | null } | null };

export type LotteryEventTimelineQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
}>;


export type LotteryEventTimelineQuery = { lotteryUniversityEventById?: { id: string, name: string, isDraft: boolean, eventTimeline?: { id: string, studentCancellationEnabled?: boolean | null, studentOptInEnabled?: boolean | null, studentSelfScheduleEnabled?: boolean | null, employerRegistrationDates: { registrationStartDate?: { date: string, time: string, zone: FloTimezone } | null, registrationDeadline?: { date: string, time: string, zone: FloTimezone } | null }, studentBidding: { maxNumberOfBids?: number | null, maxNumberOfInterviews?: number | null, reviewPeriodStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingDeadline?: { date: string, time: string, zone: FloTimezone } | null, lotteryResultsVisibleToStudents?: { date: string, time: string, zone: FloTimezone } | null }, studentCancellation?: { studentCancellationStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentCancellationEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentOptIn?: { studentOptInStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentOptInEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentSelfSchedule?: { studentSelfScheduleStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentSelfScheduleEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, scheduleVisibility: { employerFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null, studentFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null }, eventPeriods?: { studentBiddingPeriod?: StudentBiddingPeriod | null, studentCancellationPeriod?: StudentCancellationPeriod | null, studentSelfSchedulePeriod?: StudentSelfSchedulePeriod | null, employerMatchReviewPeriod?: EmployerMatchReviewPeriod | null } | null } | null, stepperStatus?: { id: string, eventDetails: StepStatus, timeBlocks: StepStatus, timeline: StepStatus, employerSettings: StepStatus, emails: StepStatus } | null } | null };

export type LotteryEventDetailsQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
}>;


export type LotteryEventDetailsQuery = { lotteryUniversityEventById?: { id: string, name: string, isDraft: boolean, tags?: { nodes?: Array<{ id: string, label?: string | null } | null> | null } | null, eventDetails?: { id: string, employerEventDescription: string, studentEventDescription: string, eventOrganizerUserId: string } | null, stepperStatus?: { id: string, eventDetails: StepStatus, timeBlocks: StepStatus, timeline: StepStatus, employerSettings: StepStatus, emails: StepStatus } | null, eventTimeline?: { id: string, studentCancellationEnabled?: boolean | null, studentOptInEnabled?: boolean | null, studentSelfScheduleEnabled?: boolean | null, employerRegistrationDates: { registrationStartDate?: { date: string, time: string, zone: FloTimezone } | null, registrationDeadline?: { date: string, time: string, zone: FloTimezone } | null }, studentBidding: { maxNumberOfBids?: number | null, maxNumberOfInterviews?: number | null, reviewPeriodStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingDeadline?: { date: string, time: string, zone: FloTimezone } | null, lotteryResultsVisibleToStudents?: { date: string, time: string, zone: FloTimezone } | null }, studentCancellation?: { studentCancellationStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentCancellationEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentOptIn?: { studentOptInStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentOptInEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentSelfSchedule?: { studentSelfScheduleStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentSelfScheduleEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, scheduleVisibility: { employerFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null, studentFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null }, eventPeriods?: { studentBiddingPeriod?: StudentBiddingPeriod | null, studentCancellationPeriod?: StudentCancellationPeriod | null, studentSelfSchedulePeriod?: StudentSelfSchedulePeriod | null, employerMatchReviewPeriod?: EmployerMatchReviewPeriod | null } | null } | null } | null };

export type LotteryEventTimeBlocksQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
}>;


export type LotteryEventTimeBlocksQuery = { lotteryUniversityEventById?: { id: string, name: string, isDraft: boolean, eventSchedule?: Array<{ id: string, date: string, startTime: string, endTime: string, timezone: FloTimezone, breakOption: InterviewSchedulingBlockBreakOptionEnum, breakLengthMinutes: number, interviewLength: number, numberOfInterviews: number, customBreaks?: Array<{ startTime: string, breakLengthMinutes: number, breakPosition: number } | null> | null } | null> | null, stepperStatus?: { id: string, eventDetails: StepStatus, timeBlocks: StepStatus, timeline: StepStatus, employerSettings: StepStatus, emails: StepStatus } | null } | null };

export type LotteryEventDetailsEmployerQueryVariables = Exact<{
  employerEventId: Scalars['Int'];
}>;


export type LotteryEventDetailsEmployerQuery = { lotteryEmployerEventById?: { __typename: 'LotteryEmployerEventNode', id: string, name: string, employerOrgName?: string | null, associatedUniversityName?: string | null, recruitmentPolicy?: string | null, tags?: { nodes?: Array<{ id: string, label?: string | null } | null> | null } | null, eventDetails?: { id: string, employerEventDescription: string, studentEventDescription: string, eventOrganizerUserId: string } | null, eventTimeline?: { id: string, studentCancellationEnabled?: boolean | null, studentOptInEnabled?: boolean | null, studentSelfScheduleEnabled?: boolean | null, employerRegistrationDates: { registrationStartDate?: { date: string, time: string, zone: FloTimezone } | null, registrationDeadline?: { date: string, time: string, zone: FloTimezone } | null }, studentBidding: { maxNumberOfBids?: number | null, maxNumberOfInterviews?: number | null, reviewPeriodStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingDeadline?: { date: string, time: string, zone: FloTimezone } | null, lotteryResultsVisibleToStudents?: { date: string, time: string, zone: FloTimezone } | null }, studentCancellation?: { studentCancellationStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentCancellationEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentOptIn?: { studentOptInStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentOptInEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentSelfSchedule?: { studentSelfScheduleStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentSelfScheduleEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, scheduleVisibility: { employerFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null, studentFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null }, eventPeriods?: { studentBiddingPeriod?: StudentBiddingPeriod | null, studentCancellationPeriod?: StudentCancellationPeriod | null, studentSelfSchedulePeriod?: StudentSelfSchedulePeriod | null, employerMatchReviewPeriod?: EmployerMatchReviewPeriod | null } | null } | null, employerSettings?: { id: string, employerCustomQuestions?: Array<{ eventQuestionId: string, orgQuestionId: string, questionType: QuestionType, label: string, subText: string, required?: boolean | null } | null> | null, registrationSettings?: { numberOfDateChoices: number, multipleDatesEnabled: boolean, selectPreferredTimeEnabled: boolean, selectInterviewFormatEnabled: boolean, selectPreferredInterviewLengthEnabled: boolean, provideVideoLinkEnabled: boolean, studentInterviewOptionsEnabled: boolean, supplyJobInformationEnabled: boolean, supplyInterviewInformationEnabled: boolean, eventUniversityRecruitmentPolicyEnabled: boolean, allowEmployerToSelectMultipleTimeBlocks: boolean, allowEmployersToCreateDocumentCollectJobs: boolean, hasDocumentCollectJobsCreated: boolean, supportingDocuments?: Array<{ id: string, orgDocumentId: string, eventDocumentId: string, documentName: string, documentVisibilityOption: UniversityDocumentVisibilityEnum, isRequired: boolean, documentVisibilityTime?: { date: string, time: string, zone: FloTimezone } | null } | null> | null } | null } | null, preferredDateOptions?: Array<{ date: string, time: string, zone: FloTimezone } | null> | null } | null };

export type LotteryEmployerSettingsQueryVariables = Exact<{
  universityEventId: Scalars['Int'];
}>;


export type LotteryEmployerSettingsQuery = { lotteryUniversityEventById?: { id: string, name: string, isDraft: boolean, eventTimeline?: { id: string, studentCancellationEnabled?: boolean | null, studentOptInEnabled?: boolean | null, studentSelfScheduleEnabled?: boolean | null, employerRegistrationDates: { registrationStartDate?: { date: string, time: string, zone: FloTimezone } | null, registrationDeadline?: { date: string, time: string, zone: FloTimezone } | null }, studentBidding: { maxNumberOfBids?: number | null, maxNumberOfInterviews?: number | null, reviewPeriodStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingDeadline?: { date: string, time: string, zone: FloTimezone } | null, lotteryResultsVisibleToStudents?: { date: string, time: string, zone: FloTimezone } | null }, studentCancellation?: { studentCancellationStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentCancellationEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentOptIn?: { studentOptInStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentOptInEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentSelfSchedule?: { studentSelfScheduleStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentSelfScheduleEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, scheduleVisibility: { employerFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null, studentFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null }, eventPeriods?: { studentBiddingPeriod?: StudentBiddingPeriod | null, studentCancellationPeriod?: StudentCancellationPeriod | null, studentSelfSchedulePeriod?: StudentSelfSchedulePeriod | null, employerMatchReviewPeriod?: EmployerMatchReviewPeriod | null } | null } | null, employerSettings?: { id: string, employerCustomQuestions?: Array<{ eventQuestionId: string, orgQuestionId: string, questionType: QuestionType, label: string, subText: string, required?: boolean | null } | null> | null, registrationSettings?: { numberOfDateChoices: number, multipleDatesEnabled: boolean, selectPreferredTimeEnabled: boolean, selectInterviewFormatEnabled: boolean, selectPreferredInterviewLengthEnabled: boolean, provideVideoLinkEnabled: boolean, studentInterviewOptionsEnabled: boolean, supplyJobInformationEnabled: boolean, supplyInterviewInformationEnabled: boolean, eventUniversityRecruitmentPolicyEnabled: boolean, allowEmployerToSelectMultipleTimeBlocks: boolean, allowEmployersToCreateDocumentCollectJobs: boolean, hasDocumentCollectJobsCreated: boolean, supportingDocuments?: Array<{ id: string, orgDocumentId: string, eventDocumentId: string, documentName: string, documentVisibilityOption: UniversityDocumentVisibilityEnum, isRequired: boolean, documentVisibilityTime?: { date: string, time: string, zone: FloTimezone } | null } | null> | null } | null } | null, stepperStatus?: { id: string, eventDetails: StepStatus, timeBlocks: StepStatus, timeline: StepStatus, employerSettings: StepStatus, emails: StepStatus } | null } | null };

export type EventStepperStatusFragment = { id: string, eventDetails: StepStatus, timeBlocks: StepStatus, timeline: StepStatus, employerSettings: StepStatus, emails: StepStatus };

export type LotteryEventDetailsFragment = { id: string, employerEventDescription: string, studentEventDescription: string, eventOrganizerUserId: string };

export type LotteryEventTimeBlocksFragment = { id: string, date: string, startTime: string, endTime: string, timezone: FloTimezone, breakOption: InterviewSchedulingBlockBreakOptionEnum, breakLengthMinutes: number, interviewLength: number, numberOfInterviews: number, customBreaks?: Array<{ startTime: string, breakLengthMinutes: number, breakPosition: number } | null> | null };

export type LotteryEventTimelineFragment = { id: string, studentCancellationEnabled?: boolean | null, studentOptInEnabled?: boolean | null, studentSelfScheduleEnabled?: boolean | null, employerRegistrationDates: { registrationStartDate?: { date: string, time: string, zone: FloTimezone } | null, registrationDeadline?: { date: string, time: string, zone: FloTimezone } | null }, studentBidding: { maxNumberOfBids?: number | null, maxNumberOfInterviews?: number | null, reviewPeriodStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingStartDate?: { date: string, time: string, zone: FloTimezone } | null, biddingDeadline?: { date: string, time: string, zone: FloTimezone } | null, lotteryResultsVisibleToStudents?: { date: string, time: string, zone: FloTimezone } | null }, studentCancellation?: { studentCancellationStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentCancellationEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentOptIn?: { studentOptInStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentOptInEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, studentSelfSchedule?: { studentSelfScheduleStartDate?: { date: string, time: string, zone: FloTimezone } | null, studentSelfScheduleEndDate?: { date: string, time: string, zone: FloTimezone } | null } | null, scheduleVisibility: { employerFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null, studentFinalScheduleDate?: { date: string, time: string, zone: FloTimezone } | null }, eventPeriods?: { studentBiddingPeriod?: StudentBiddingPeriod | null, studentCancellationPeriod?: StudentCancellationPeriod | null, studentSelfSchedulePeriod?: StudentSelfSchedulePeriod | null, employerMatchReviewPeriod?: EmployerMatchReviewPeriod | null } | null };

export type LotteryEmployerCustomQuestionFragment = { eventQuestionId: string, orgQuestionId: string, questionType: QuestionType, label: string, subText: string, required?: boolean | null };

export type LotteryEmployerRegistrationSettingsFragment = { numberOfDateChoices: number, multipleDatesEnabled: boolean, selectPreferredTimeEnabled: boolean, selectInterviewFormatEnabled: boolean, selectPreferredInterviewLengthEnabled: boolean, provideVideoLinkEnabled: boolean, studentInterviewOptionsEnabled: boolean, supplyJobInformationEnabled: boolean, supplyInterviewInformationEnabled: boolean, eventUniversityRecruitmentPolicyEnabled: boolean, allowEmployerToSelectMultipleTimeBlocks: boolean, allowEmployersToCreateDocumentCollectJobs: boolean, hasDocumentCollectJobsCreated: boolean, supportingDocuments?: Array<{ id: string, orgDocumentId: string, eventDocumentId: string, documentName: string, documentVisibilityOption: UniversityDocumentVisibilityEnum, isRequired: boolean, documentVisibilityTime?: { date: string, time: string, zone: FloTimezone } | null } | null> | null };

export type InternalFieldQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalFieldQuestionsQuery = { internalFieldQuestions?: Array<{ id: string, title: string, type: QuestionType, options?: Array<string | null> | null, isDefaultQuestion?: boolean | null, showOnProfile?: boolean | null, showOnJobApplication?: boolean | null, archivedAt?: string | null, createdAt?: string | null, order?: number | null } | null> | null };

export type ActiveInternalFieldQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveInternalFieldQuestionsQuery = { activeInternalFieldQuestions?: Array<{ id: string, title: string, type: QuestionType, options?: Array<string | null> | null, isDefaultQuestion?: boolean | null, showOnProfile?: boolean | null, showOnJobApplication?: boolean | null, archivedAt?: string | null, createdAt?: string | null, order?: number | null } | null> | null };

export type UpsertInternalFieldJobApplicationAnswerMutationVariables = Exact<{
  recruitId: Scalars['Int'];
  jobAppId: Scalars['Int'];
  answers: Array<UpsertInternalFieldAnswerInput> | UpsertInternalFieldAnswerInput;
}>;


export type UpsertInternalFieldJobApplicationAnswerMutation = { upsertJobAppInternalFieldAnswers?: string | null };

export type CreateCandidateMissingInfoRequestMutationVariables = Exact<{
  recruitId: Scalars['Int'];
  jobAppId: Scalars['Int'];
  recipientType: CandidateMissingInfoRequestRecipientType;
}>;


export type CreateCandidateMissingInfoRequestMutation = { createCandidateMissingInfoRequest?: string | null };

export type BulkCreateCandidateMissingInfoRequestMutationVariables = Exact<{
  input: BulkCreateCandidateMissingInfoRequestInput;
}>;


export type BulkCreateCandidateMissingInfoRequestMutation = { bulkCreateCandidateMissingInfoRequest: { successful: number } };

export type MissingInfoRequestJobEmailTemplateQueryVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type MissingInfoRequestJobEmailTemplateQuery = { candidateMissingInfoRequestJobEmailTemplate?: { replyToUserId?: number | null, ccUserId?: number | null, bccUserId?: number | null, subject?: string | null, body?: string | null } | null };

export type UpdateMissingInfoRequestJobEmailTemplateMutationVariables = Exact<{
  jobId: Scalars['Int'];
  input: CandidateMissingInfoRequestJobEmailTemplateInput;
}>;


export type UpdateMissingInfoRequestJobEmailTemplateMutation = { updateCandidateMissingInfoRequestJobEmailTemplate?: string | null };

export type RequestMissingInfoJobInfoQueryVariables = Exact<{
  jobId: Scalars['Int'];
}>;


export type RequestMissingInfoJobInfoQuery = { job?: { title?: string | null, hiringLeads?: Array<{ id?: number | null } | null> | null } | null, getOrg?: { name?: string | null, urlFriendlyName?: string | null } | { name?: string | null, urlFriendlyName?: string | null } | null };

export type CandidateProfileCandidateInfoQueryVariables = Exact<{
  candidateId: Scalars['Int'];
}>;


export type CandidateProfileCandidateInfoQuery = { getCandidate?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null };

export type LoadTestHealthCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadTestHealthCheckQuery = { healthCheck: string };

export type LoadTestSimpleQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadTestSimpleQuery = { testString: string };

export type LoadTestFeatureFlagQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadTestFeatureFlagQuery = { testFeatureFlag: boolean };

export type LoadTestSimpleObjectQueryVariables = Exact<{ [key: string]: never; }>;


export type LoadTestSimpleObjectQuery = { testObject: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number } };

export type LoadTestComplexObjectQueryVariables = Exact<{
  argument1?: InputMaybe<Scalars['ID']>;
  argument2?: InputMaybe<Scalars['Int']>;
  argument3?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  argument4?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  argument5?: InputMaybe<TestInput2>;
}>;


export type LoadTestComplexObjectQuery = { testObject: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null, testObject2?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null, testObject3?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null } | null, testObject2?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null, testObject2?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null, testObject3?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null, testObject3?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null, testObject2?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null, testObject3?: { test: string, test2: number, test3: Array<string>, test4: Array<number>, depth: number, testObject1?: { test: string } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } | null } | null } | null, testObject2?: { test: string } | null, testObject3?: { test: string } | null } };

export type GetMembersForCurrentOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMembersForCurrentOrgQuery = { getOrg?: { members?: { nodes?: Array<{ id: string, firstName: string, lastName: string, email: string, isAdmin: boolean, details?: { jobTitle?: string | null, workArrangement?: WorkArrangement | null, bioLink?: string | null, officeLocation?: { name: string } | null, practiceArea?: { name: string } | null, lawSchool?: { name: string } | null } | null, ownedPrograms?: Array<{ id: string, title?: string | null }> | null, authInfo?: { isMfaUser: boolean, ssoUserId?: string | null } | null } | null> | null } | null } | { members?: { nodes?: Array<{ id: string, firstName: string, lastName: string, email: string, isAdmin: boolean, details?: { jobTitle?: string | null, workArrangement?: WorkArrangement | null, bioLink?: string | null, officeLocation?: { name: string } | null, practiceArea?: { name: string } | null, lawSchool?: { name: string } | null } | null, ownedPrograms?: Array<{ id: string, title?: string | null }> | null, authInfo?: { isMfaUser: boolean, ssoUserId?: string | null } | null } | null> | null } | null } | null };

export type GetMemberByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMemberByIdQuery = { memberById?: { id: string, firstName: string, lastName: string, email: string, isAdmin: boolean, details?: { jobTitle?: string | null, workArrangement?: WorkArrangement | null, bioLink?: string | null, officeLocation?: { name: string } | null, practiceArea?: { name: string } | null, lawSchool?: { name: string } | null } | null, ownedPrograms?: Array<{ id: string, title?: string | null }> | null, authInfo?: { isMfaUser: boolean, ssoUserId?: string | null } | null } | null };

export type FullMemberInfoFragment = { id: string, firstName: string, lastName: string, email: string, isAdmin: boolean, details?: { jobTitle?: string | null, workArrangement?: WorkArrangement | null, bioLink?: string | null, officeLocation?: { name: string } | null, practiceArea?: { name: string } | null, lawSchool?: { name: string } | null } | null, ownedPrograms?: Array<{ id: string, title?: string | null }> | null, authInfo?: { isMfaUser: boolean, ssoUserId?: string | null } | null };

export type GetOrgSsoInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgSsoInfoQuery = { getOrg?: { isMfaEnabled: boolean, ssoType: SsoType, ssoAuthInfo?: { ssoIdIsEmail: boolean, frontendAttribute: { isEmail: boolean, label: string, validationRegex: string, validationErrorMessage: string } } | null } | { isMfaEnabled: boolean, ssoType: SsoType, ssoAuthInfo?: { ssoIdIsEmail: boolean, frontendAttribute: { isEmail: boolean, label: string, validationRegex: string, validationErrorMessage: string } } | null } | null };

export type CreateEmployerMemberMutationVariables = Exact<{
  input: CreateEmployerMemberInput;
}>;


export type CreateEmployerMemberMutation = { createEmployerMember?: { __typename: 'CreateEmployerMemberSuccess', member?: { id: string } | null } | { __typename: 'EmailTakenWarning', userMessage: string } | { __typename: 'SsoUserIdTakenWarning', userMessage: string } | null };

export type EditEmployerMemberInfoMutationVariables = Exact<{
  input: EditEmployerMemberInfoInput;
}>;


export type EditEmployerMemberInfoMutation = { editEmployerMemberInfo?: { member?: { id: string } | null } | null };

export type EditEmployerMemberAuthInfoMutationVariables = Exact<{
  input: EditEmployerMemberAuthInfoInput;
}>;


export type EditEmployerMemberAuthInfoMutation = { editEmployerMemberAuthInfo?: { __typename: 'EditEmployerMemberAuthInfoSuccess', id: string } | { __typename: 'SsoUserIdTakenWarning', userMessage: string } | null };

export type DeleteMemberMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteMemberMutation = { deleteMember?: { member?: { id: string } | null } | null };

export type UploadMembersCsvMutationVariables = Exact<{
  input: UploadMembersCsvInput;
}>;


export type UploadMembersCsvMutation = { uploadMembersCsv?: { __typename: 'MembersCsvProblems', userMessage: string } | { __typename: 'UploadMembersCsvSuccess', createdIds: Array<string>, updatedIds: Array<string> } | null };

export type UpsertCannedReportMutationVariables = Exact<{
  input: CannedReportInput;
}>;


export type UpsertCannedReportMutation = { upsertCannedReport: number };

export type UpsertCannedReportIncludedJobsMutationVariables = Exact<{
  input: CannedReportIncludedJobsInput;
}>;


export type UpsertCannedReportIncludedJobsMutation = { upsertCannedReportIncludedJobs: boolean };

export type InitialRunCannedReportMutationVariables = Exact<{
  input: InitialRunCannedReportInput;
}>;


export type InitialRunCannedReportMutation = { initialRunCannedReport: number };

export type DeleteCannedReportMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteCannedReportMutation = { deleteCannedReport: boolean };

export type GetCannedReportQueryVariables = Exact<{
  cannedReportId: Scalars['Int'];
}>;


export type GetCannedReportQuery = { getCannedReport: { id: string, title?: string | null, reportType?: string | null, createdBy?: string | null, createdAt?: string | null, updatedAt?: string | null, updatedBy?: string | null, creatorFirstName?: string | null, creatorLastName?: string | null, saved?: boolean | null, selectedJobs?: Array<{ jobId: string, title?: string | null } | null> | null } };

export type GetSavedCannedReportsForOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedCannedReportsForOrgQuery = { getSavedCannedReportsForOrg: Array<{ id: string, title?: string | null, reportType?: string | null, createdBy?: string | null, createdAt?: string | null, updatedAt?: string | null, updatedBy?: string | null, creatorFirstName?: string | null, creatorLastName?: string | null, latestActivityDate?: string | null, selectedJobs?: Array<{ jobId: string, title?: string | null } | null> | null } | null> };

export type GetTotalBucketValuesForLawSchoolDataTableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTotalBucketValuesForLawSchoolDataTableQuery = { getTotalBucketValuesForLawSchoolDataTable?: { id?: string | null, lawSchoolName?: string | null, applied?: { totalCount?: number | null } | null, screening?: { totalCount?: number | null } | null, interviewing?: { totalCount?: number | null } | null, offer?: { totalCount?: number | null } | null, hired?: { totalCount?: number | null } | null, rejected?: { totalCount?: number | null } | null, declined?: { totalCount?: number | null } | null, withdrew?: { totalCount?: number | null } | null, cancelled?: { totalCount?: number | null } | null } | null };

export type GetTotalBucketValuesForAppSourceDataTableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTotalBucketValuesForAppSourceDataTableQuery = { getTotalBucketValuesForAppSourceDataTable?: { id?: string | null, appSourceName?: string | null, applied?: { totalCount?: number | null } | null, screening?: { totalCount?: number | null } | null, interviewing?: { totalCount?: number | null } | null, offer?: { totalCount?: number | null } | null, hired?: { totalCount?: number | null } | null, rejected?: { totalCount?: number | null } | null, declined?: { totalCount?: number | null } | null, withdrew?: { totalCount?: number | null } | null, cancelled?: { totalCount?: number | null } | null } | null };

export type GetConversionReportSankeyDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetConversionReportSankeyDataQuery = { getConversionReportSankeyData?: { id?: string | null, reportTitle?: string | null, totalCandidates?: number | null, offerAcceptedYieldRate?: number | null, offerRejectedYieldRate?: number | null, differingPipelineBuckets?: boolean | null, selectedJobs?: Array<{ id: string, title?: string | null } | null> | null, sankey?: Array<{ order?: number | null, node?: { title: string, count?: number | null, color?: string | null } | null, link?: Array<{ source?: string | null, target?: string | null, count?: number | null } | null> | null } | null> | null } | null };

export type GetConversionReportDataTableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetConversionReportDataTableQuery = { getConversionReportDataTable?: { id: string, lawSchoolValues?: Array<{ id?: string | null, lawSchoolName?: string | null, applied?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, screening?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, interviewing?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, offer?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, hired?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, rejected?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, declined?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, withdrew?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, cancelled?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null } | null> | null, sourceValues?: Array<{ id?: string | null, appSourceName?: string | null, applied?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, screening?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, interviewing?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, offer?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, hired?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, rejected?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, declined?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, withdrew?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null, cancelled?: { totalCount?: number | null, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null } | null> | null } | null };

export type GetConversionReportCandidatesQueryVariables = Exact<{
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ConversionReportFilterBy>;
}>;


export type GetConversionReportCandidatesQuery = { getConversionReportCandidates?: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null }> } | null };

export type GetTotalLawSchoolCandidatesByBucketQueryVariables = Exact<{
  id: Scalars['ID'];
  bucket: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetTotalLawSchoolCandidatesByBucketQuery = { getTotalLawSchoolCandidatesByBucket?: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null };

export type GetTotalAppSourceCandidatesByBucketQueryVariables = Exact<{
  id: Scalars['ID'];
  bucket: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetTotalAppSourceCandidatesByBucketQuery = { getTotalAppSourceCandidatesByBucket?: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null };

export type GetCandidatesForCandidateDataTableQueryVariables = Exact<{
  id: Scalars['ID'];
  bucket: Scalars['String'];
  targetBucket?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidatesForCandidateDataTableQuery = { getCandidatesForCandidateDataTable?: { totalCount?: number | null, pageInfo: { hasNextPage?: boolean | null, endCursor?: string | null }, nodes: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, appSource?: string | null, lawSchool?: string | null, jobId?: string | null, title?: string | null, status?: string | null }> } | null };

export type DateTimeZonePartsFragment = { date: string, time: string, zone: FloTimezone };

export type ContractorFragmentFragment = { isGovernmentContractor?: boolean | null };

export type UpdateJobAppOfferDetailsMutationVariables = Exact<{
  jobAppId?: InputMaybe<Scalars['Int']>;
  input: OfferDetailsInput;
}>;


export type UpdateJobAppOfferDetailsMutation = { updateJobAppOfferDetails?: { id: string, offerDate?: string | null, offerExpirationDate?: string | null, offerAffirmationDate?: string | null } | null };

export type MigrateOrgToGovernmentContractorMutationVariables = Exact<{ [key: string]: never; }>;


export type MigrateOrgToGovernmentContractorMutation = { migrateOrgToGovernmentContractor?: boolean | null };

export type JobWithTitleQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']>;
}>;


export type JobWithTitleQuery = { job?: { title?: string | null, closeDate?: string | null } | null };

export type OrgJobSchemasQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgJobSchemasQuery = { jobs?: Array<{ id?: number | null, jobSchema?: Array<{ id?: number | null, name?: string | null, jobSectionType?: string | null, jobQuestions?: Array<{ id?: number | null, orgQuestionId?: number | null, label?: string | null, subText?: string | null, questionType?: string | null, isDeleted?: boolean | null, isRequired?: boolean | null, order?: number | null, jobQuestionOptions?: Array<{ id?: number | null, option?: string | null, isDeleted?: boolean | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type JobSectionsAndQuestionsQueryVariables = Exact<{
  jobIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type JobSectionsAndQuestionsQuery = { jobsFromIds: Array<{ id?: number | null, title?: string | null, jobSchema?: Array<{ id?: number | null, name?: string | null, jobSectionType?: string | null, order?: number | null, jobQuestions?: Array<{ id?: number | null, orgQuestionId?: number | null, label?: string | null, subText?: string | null, questionType?: string | null, isDeleted?: boolean | null, isRequired?: boolean | null, order?: number | null } | null> | null } | null> | null }> };

export type PublicJobQueryVariables = Exact<{
  jobExtension?: InputMaybe<Scalars['String']>;
  orgFriendlyName?: InputMaybe<Scalars['String']>;
}>;


export type PublicJobQuery = { publicJob?: { jobSections?: Array<{ id?: number | null, name?: string | null, jobSectionType?: string | null, description?: string | null, order?: number | null, isRequired?: boolean | null, jobCandidateDocuments?: Array<{ id?: number | null, docName?: string | null, jobSectionId?: number | null, isRequired?: boolean | null, orgDocId?: number | null, isDeleted?: boolean | null } | null> | null, jobQuestions?: Array<{ id?: number | null, orgQuestionId?: number | null, label?: string | null, order?: number | null, subText?: string | null, questionType?: string | null, isRequired?: boolean | null, jobQuestionOptions?: { edges?: Array<{ node?: { id: string, option?: string | null, orgQuestionOptionId?: number | null, jobQuestionId?: number | null } | null } | null> | null } | null } | null> | null } | null> | null } | null };

export type CandidateOrgJobAppOverviewsQueryVariables = Exact<{
  orgFriendlyName?: InputMaybe<Scalars['String']>;
}>;


export type CandidateOrgJobAppOverviewsQuery = { publicCandidateOrgJobApps?: Array<{ id?: number | null, jobId?: number | null, createdAt?: string | null, isComplete?: boolean | null, creationType?: string | null } | null> | null };

export type PublicJobAppQueryVariables = Exact<{
  orgFriendlyName?: InputMaybe<Scalars['String']>;
  jobExtension?: InputMaybe<Scalars['String']>;
}>;


export type PublicJobAppQuery = { publicCandidateJobApp?: { addressLineOne?: string | null, addressLineTwo?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, isComplete?: boolean | null, creationType?: string | null, recruitId?: number | null, missingInfoRequestToCandidate?: boolean | null, missingInfoRequestToAgencyContact?: boolean | null, workHistory?: Array<{ id?: number | null, employer?: string | null, position?: string | null, startDate?: string | null, endDate?: string | null, isCurrentEmployer?: boolean | null } | null> | null, educationHistory?: Array<{ id?: number | null, university?: string | null, degreeEnum?: number | null, startDate?: string | null, endDate?: string | null } | null> | null, jobAppDocuments?: Array<{ orgDocId?: number | null, documentName?: string | null, orgCustomDocName?: string | null, createdAt?: string | null, location?: string | null } | null> | null, answers?: Array<{ id: string, label?: string | null, subText?: string | null, questionType?: QuestionType | null, dateValue?: string | null, numericValue?: number | null, textValue?: string | null, orgQuestionId?: number | null, jobAppQuestionAnswerSelections?: { edges?: Array<{ node?: { id: string, orgQuestionOptionId?: number | null, jobAppQuestionAnswerId?: number | null, option?: string | null } | null } | null> | null } | null, options?: Array<{ orgQuestionId?: number | null, option?: string | null, order?: number | null, isDeleted?: boolean | null } | null> | null } | null> | null, selfIdAnswers?: Array<{ id: string, orgSelfIdQuestionId?: number | null, jobAppSelfIdQuestionAnswerSelections?: Array<{ id: string, orgSelfIdQuestionOptionId?: number | null } | null> | null } | null> | null } | null };

export type PublicJobAppAgencyViewQueryVariables = Exact<{
  orgFriendlyName?: InputMaybe<Scalars['String']>;
  jobExtension?: InputMaybe<Scalars['String']>;
  recruitId?: InputMaybe<Scalars['Int']>;
}>;


export type PublicJobAppAgencyViewQuery = { publicCandidateJobAppOfRecruit?: { addressLineOne?: string | null, addressLineTwo?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, isComplete?: boolean | null, creationType?: string | null, recruitId?: number | null, missingInfoRequestToCandidate?: boolean | null, missingInfoRequestToAgencyContact?: boolean | null, workHistory?: Array<{ id?: number | null, employer?: string | null, position?: string | null, startDate?: string | null, endDate?: string | null, isCurrentEmployer?: boolean | null } | null> | null, educationHistory?: Array<{ id?: number | null, university?: string | null, degreeEnum?: number | null, startDate?: string | null, endDate?: string | null } | null> | null, jobAppDocuments?: Array<{ orgDocId?: number | null, documentName?: string | null, orgCustomDocName?: string | null, createdAt?: string | null, location?: string | null } | null> | null, answers?: Array<{ id: string, label?: string | null, subText?: string | null, questionType?: QuestionType | null, dateValue?: string | null, numericValue?: number | null, textValue?: string | null, orgQuestionId?: number | null, jobAppQuestionAnswerSelections?: { edges?: Array<{ node?: { id: string, orgQuestionOptionId?: number | null, jobAppQuestionAnswerId?: number | null, option?: string | null } | null } | null> | null } | null, options?: Array<{ orgQuestionId?: number | null, option?: string | null, order?: number | null, isDeleted?: boolean | null } | null> | null } | null> | null, selfIdAnswers?: Array<{ id: string, orgSelfIdQuestionId?: number | null, jobAppSelfIdQuestionAnswerSelections?: Array<{ id: string, orgSelfIdQuestionOptionId?: number | null } | null> | null } | null> | null } | null };

export type PublicJobOverviewQueryVariables = Exact<{
  jobExtension?: InputMaybe<Scalars['String']>;
  orgFriendlyName?: InputMaybe<Scalars['String']>;
}>;


export type PublicJobOverviewQuery = { publicJob?: { id?: number | null, orgId?: number | null, title?: string | null } | null };

export type AppSourceOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSourceOptionsQuery = { fetchAppSourceOptions?: Array<{ name?: string | null, label?: string | null } | null> | null };

export type OrgSelfIdQuestionsQueryVariables = Exact<{
  orgFriendlyName?: InputMaybe<Scalars['String']>;
}>;


export type OrgSelfIdQuestionsQuery = { orgSelfIdQuestions?: Array<{ id: string, label?: string | null, name?: string | null, description?: string | null, selfIdDefaultId?: number | null, enabled?: boolean | null, selfIdType?: string | null, isGovernment?: boolean | null, questionType?: string | null, orgSelfIdQuestionOptions?: Array<{ id: string, name?: string | null, deletedAt?: string | null } | null> | null } | null> | null };

export type GetSingleOrgSelfIdQuestionQueryVariables = Exact<{
  orgFriendlyName?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['Int']>;
}>;


export type GetSingleOrgSelfIdQuestionQuery = { orgSelfIdQuestion?: { id: string, label?: string | null, name?: string | null, description?: string | null, selfIdDefaultId?: number | null, enabled?: boolean | null, selfIdType?: string | null, isGovernment?: boolean | null, questionType?: string | null, orgSelfIdQuestionOptions?: Array<{ id: string, name?: string | null } | null> | null } | null };

export type PublicOrgSelfIdQuestionsQueryVariables = Exact<{
  orgFriendlyName?: InputMaybe<Scalars['String']>;
}>;


export type PublicOrgSelfIdQuestionsQuery = { publicOrgSelfIdQuestions?: Array<{ id: string, label?: string | null, name?: string | null, selfIdDefaultId?: number | null, enabled?: boolean | null, selfIdType?: string | null, questionType?: string | null, orgSelfIdQuestionOptions?: Array<{ id: string, name?: string | null, deletedAt?: string | null } | null> | null } | null> | null };

export type CandidateOrgSelfIdQuestionAnswersQueryVariables = Exact<{
  recruitId?: InputMaybe<Scalars['Int']>;
}>;


export type CandidateOrgSelfIdQuestionAnswersQuery = { fetchCandidateOrgSelfIdQuestionAnswers?: Array<{ orgSelfIdQuestionId?: number | null, text?: string | null, appSource?: string | null, orgSelfIdQuestionOptions?: Array<{ id: string, name?: string | null } | null> | null, orgSelfIdQuestionAnswerSelections?: Array<{ id?: number | null, orgSelfIdQuestionAnswerId?: number | null, orgSelfIdQuestionOptionId?: number | null } | null> | null } | null> | null };

export type AgencyListQueryVariables = Exact<{ [key: string]: never; }>;


export type AgencyListQuery = { agencies?: Array<{ id: string, name?: string | null, isEnabled?: boolean | null } | null> | null };

export type RegisteredAgencyListQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisteredAgencyListQuery = { registeredAgencies?: Array<{ id: string, name?: string | null, isEnabled?: boolean | null } | null> | null };

export type AgencyListWithContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type AgencyListWithContactsQuery = { agencies?: Array<{ id: string, name?: string | null, isEnabled?: boolean | null, isUnregisteredAgency?: boolean | null, agencyContacts?: Array<{ id: string, agencyId?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null } | null> | null };

export type RegisteredAgencyListWithContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisteredAgencyListWithContactsQuery = { registeredAgencies?: Array<{ id: string, name?: string | null, isEnabled?: boolean | null, isUnregisteredAgency?: boolean | null, agencyContacts?: Array<{ id: string, agencyId?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null } | null> | null };

export type GetAgencyQueryVariables = Exact<{
  agencyId?: InputMaybe<Scalars['Int']>;
}>;


export type GetAgencyQuery = { agency?: { id: string, name?: string | null, isEnabled?: boolean | null, agencyContacts?: Array<{ id: string, agencyId?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null } | null };

export type GetAgencyContactQueryVariables = Exact<{
  agencyContactId?: InputMaybe<Scalars['Int']>;
}>;


export type GetAgencyContactQuery = { agencyContact?: { id: string, agencyId?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null };

export type GetAgencyContactsQueryVariables = Exact<{
  agencyContactIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GetAgencyContactsQuery = { agencyContacts?: Array<{ id: string, agencyId?: number | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null } | null> | null };

export type SelfIdJobsCountQueryVariables = Exact<{
  orgFriendlyName?: InputMaybe<Scalars['String']>;
}>;


export type SelfIdJobsCountQuery = { fetchSelfIdJobsCount?: number | null };

export type PublicJobsForAgencyContactQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicJobsForAgencyContactQuery = { publicJobsForAgencyContact?: Array<{ id?: number | null, title?: string | null, orgId?: number | null, openDate?: string | null, closeDate?: string | null, openTimezone?: string | null, closeTimezone?: string | null, createdAt?: string | null, extension?: string | null, jobEmploymentTypes?: Array<{ id?: number | null, jobId?: number | null, employmentTypeId?: number | null, employmentType?: string | null } | null> | null, positionTypes?: Array<{ id?: number | null, jobId?: number | null, positionTypeId?: number | null, name?: string | null } | null> | null, departments?: Array<{ id?: number | null, jobId?: number | null, departmentId?: number | null, name?: string | null } | null> | null, jobOffices?: Array<{ id?: number | null, jobId?: number | null, name?: string | null } | null> | null } | null> | null };

export type PublicJobForAgencyContactByExtensionQueryVariables = Exact<{
  jobExtension?: InputMaybe<Scalars['String']>;
}>;


export type PublicJobForAgencyContactByExtensionQuery = { publicJobForAgencyContactByExtension?: { id?: number | null, title?: string | null, orgId?: number | null, openDate?: string | null, closeDate?: string | null, description?: string | null, openTimezone?: string | null, closeTimezone?: string | null, createdAt?: string | null, extension?: string | null, jobEmploymentTypes?: Array<{ id?: number | null, jobId?: number | null, employmentTypeId?: number | null, employmentType?: string | null } | null> | null, positionTypes?: Array<{ id?: number | null, jobId?: number | null, positionTypeId?: number | null, name?: string | null } | null> | null, departments?: Array<{ id?: number | null, jobId?: number | null, departmentId?: number | null, name?: string | null } | null> | null, jobOffices?: Array<{ id?: number | null, jobId?: number | null, name?: string | null } | null> | null } | null };

export type OrgHistoricalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgHistoricalDataQuery = { getOrgHistoricalData?: Array<{ id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, recruitId?: number | null, documents?: Array<number | null> | null, rows?: Array<string | null> | null } | null> | null };

export type HistoricalDataCandidateByEmailQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type HistoricalDataCandidateByEmailQuery = { getHistoricalCandidateByEmail?: { recruitId?: number | null } | null };

export type HistoricalDataCandidateByRecruitIdQueryVariables = Exact<{
  recruitId: Scalars['Int'];
}>;


export type HistoricalDataCandidateByRecruitIdQuery = { getHistoricalCandidateByRecruitId?: { email?: string | null } | null };

export type GetJobAppsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']>;
}>;


export type GetJobAppsQuery = { jobApps?: Array<{ id: string, jobId?: number | null, recruitId?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, city?: string | null, state?: string | null, country?: string | null, zipCode?: string | null, jobPipelineStatusId?: number | null, createdAt?: string | null, statusUpdatedAt?: string | null, appSource?: string | null, agencyContactId?: number | null, sectionResponses?: Array<{ id?: number | null, jobAppId?: number | null, sectionId?: number | null, sectionName?: number | null, sectionType?: string | null, order?: number | null } | null> | null } | null> | null };

export type GetEmployerOrgFeedbackQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployerOrgFeedbackQuery = { getOrg?: { __typename: 'EmployerOrgNode', evaluationQuestions?: { edges?: Array<{ cursor?: string | null, node?: { id: string, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, selectOptions?: Array<string | null> | null, label?: string | null, evaluationType?: EvaluationType | null, type?: FeedbackQuestionType | null, commentsEnabled?: boolean | null, subtext?: string | null } | null } | null> | null } | null } | { __typename: 'UniversityOrgNode' } | null };

export type GetCandidatesQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidatesQuery = { getCandidatesOfJob?: { nodes?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, qualifyingQuestions?: { totalCount?: number | null, edges?: Array<{ node?: { id: string, question?: string | null, answers?: Array<string | null> | null, lastUpdated?: string | null, lastUpdatedAnswer?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetCandidatesWithEventsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidatesWithEventsQuery = { getCandidatesOfJob?: { nodes?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, events?: { nodes?: Array<{ name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | null> | null } | null } | null> | null } | null };

export type GetCandidatesWithEventsAndJobsQueryVariables = Exact<{
  jobIds: Array<Scalars['Int']> | Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidatesWithEventsAndJobsQuery = { getCandidatesOfJobs?: { nodes?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, events?: { nodes?: Array<{ name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | null> | null } | null, jobApps?: { nodes?: Array<{ job?: { id: string, title?: string | null } | null, status?: { name?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetCandidatesForProgramsQueryVariables = Exact<{
  programIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetCandidatesForProgramsQuery = { getCandidatesOfPrograms?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null> | null };

export type GetCandidatesForEventsQueryVariables = Exact<{
  eventIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GetCandidatesForEventsQuery = { getCandidatesOfEvents?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, events?: { nodes?: Array<{ name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | { name: string, id: string } | null> | null } | null } | null> | null };

export type GetFullCandidatesQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetFullCandidatesQuery = { getCandidatesOfJob?: { nodes?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, events?: { nodes?: Array<{ name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | { name: string } | null> | null } | null, qualifyingQuestions?: { totalCount?: number | null, edges?: Array<{ node?: { id: string, question?: string | null, answers?: Array<string | null> | null, lastUpdated?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetQualifyingQuestionsForCandidatesQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetQualifyingQuestionsForCandidatesQuery = { getCandidatesOfJob?: { nodes?: Array<{ id: string, qualifyingQuestions?: { totalCount?: number | null, edges?: Array<{ node?: { id: string, question?: string | null, answers?: Array<string | null> | null, lastUpdated?: string | null } | null } | null> | null } | null } | null> | null } | null };

export type GetOfficeLocationsForCurrentOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfficeLocationsForCurrentOrgQuery = { getOrg?: { __typename: 'EmployerOrgNode', officeLocations?: { nodes?: Array<{ id: string, name: string } | null> | null, edges?: Array<{ ugPresetId?: number | null, node?: { id: string, name: string } | null } | null> | null } | null } | { __typename: 'UniversityOrgNode' } | null };

export type GetOfficeLocationsForCurrentOrgV2QueryVariables = Exact<{ [key: string]: never; }>;


export type GetOfficeLocationsForCurrentOrgV2Query = { getOrgEmployerMember?: { __typename: 'EmployerOrgNode', officeLocations?: { edges?: Array<{ ugPresetId?: number | null, node?: { id: string, name: string } | null } | null> | null } | null } | { __typename: 'UniversityOrgNode' } | null };

export type GetEmployerEventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployerEventsQuery = { getOrg?: { __typename: 'EmployerOrgNode', organizingEvents?: { nodes?: Array<{ id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | null> | null } | null } | { __typename: 'UniversityOrgNode' } | null };

export type GetJobQuestionColumnQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['Int']>;
  jobQuestionId?: InputMaybe<Scalars['Int']>;
}>;


export type GetJobQuestionColumnQuery = { jobQuestion?: { id?: number | null, jobSectionId?: number | null, questionType?: string | null, isDeleted?: boolean | null, isRequired?: boolean | null, orgQuestionId?: number | null, label?: string | null, subText?: string | null, jobQuestionAnswers?: { edges?: Array<{ node?: { id: string, jobAppId?: number | null, orgQuestionId?: number | null, questionType?: QuestionType | null, dateValue?: string | null, numericValue?: number | null, textValue?: string | null, options?: Array<{ id?: number | null, orgQuestionId?: number | null, option?: string | null, order?: number | null, isDeleted?: boolean | null, coreQuestionOptionId?: number | null } | null> | null, jobAppQuestionAnswerSelections?: { edges?: Array<{ node?: { __typename: 'JobAppQuestionAnswerSelectionNode', id: string, option?: string | null, orgQuestionOptionId?: number | null } | null } | null> | null } | null } | null } | null> | null } | null } | null };

export type GetUserAnalyticsInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAnalyticsInfoQuery = { userAnalyticsInfo?: { __typename: 'AdminUserAnalyticsInfo', id: string, pendoVisitorId: string, pendoAccountId: string, fullStoryId: string, orgId?: string | null, orgName?: string | null, isAdmin?: boolean | null, isPaying?: boolean | null, fullName?: string | null, email?: string | null } | { __typename: 'CandidateUserAnalyticsInfo', id: string, pendoVisitorId: string, pendoAccountId: string, fullStoryId: string, loggedInEmail?: string | null, fullName?: string | null, forwardAccount?: { id: string, isActive?: boolean | null, activeSince?: string | null, primaryEmail?: string | null, numberOfEmails?: number | null, discoveryQuizAnswers?: { officeLocations?: Array<{ id: string, name: string } | null> | null, practiceCategories?: Array<{ id: string, name: string } | null> | null, demographicInfo?: { ethnicityAnswers?: Array<string | null> | null, genderAnswers?: Array<string | null> | null, veteranStatusAnswer?: string | null, sexualIdentityAnswer?: string | null } | null } | null } | null, biographicalInfo?: { graduationDate?: string | null, graduationYear?: number | null, lawSchool?: string | null, lawSchoolClassification?: LawSchoolClassification | null, humanReadableLawSchoolClassification?: string | null, undergraduateMajor?: string | null, gpa?: number | null } | null } | null };

export type GetOrgIsGovernmentContractorQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgIsGovernmentContractorQuery = { getOrg?: { __typename: 'EmployerOrgNode', isGovernmentContractor?: boolean | null } | { __typename: 'UniversityOrgNode' } | null };

export type JobsForPipelineTemplateQueryVariables = Exact<{
  pipelineTemplateId?: InputMaybe<Scalars['Int']>;
}>;


export type JobsForPipelineTemplateQuery = { jobsForPipelineTemplate?: Array<{ id?: number | null, title?: string | null, jobOffices?: Array<{ id?: number | null, name?: string | null } | null> | null } | null> | null };

export type CandidatePhotoManagementSettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidatePhotoManagementSettingsPageQuery = { getOrg?: { candidatePhotoManagementSettings?: { disableCandidatePhotoUpload: boolean, disableCandidatePhotoSyncing: boolean, hideUploadedCandidatePhotos: boolean } | null } | {} | null };

export type UpdateCandidatePhotoManagementSettingsMutationVariables = Exact<{
  input: UpdateOrgCandidatePhotoManagementSettingsInput;
}>;


export type UpdateCandidatePhotoManagementSettingsMutation = { updateOrgCandidatePhotoManagementSettings?: boolean | null };

export type InternalFieldQuestionsSettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalFieldQuestionsSettingsPageQuery = { internalFieldQuestions?: Array<{ id: string, title: string, type: QuestionType, options?: Array<string | null> | null, isDefaultQuestion?: boolean | null, showOnProfile?: boolean | null, showOnJobApplication?: boolean | null, archivedAt?: string | null, createdAt?: string | null, order?: number | null } | null> | null };

export type UpsertInternalFieldQuestionMutationVariables = Exact<{
  input: UpsertInternalFieldQuestionInput;
}>;


export type UpsertInternalFieldQuestionMutation = { upsertInternalFieldQuestion?: string | null };

export type ArchiveInternalFieldQuestionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ArchiveInternalFieldQuestionMutation = { archiveInternalFieldQuestion?: string | null };

export type UnarchiveInternalFieldQuestionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UnarchiveInternalFieldQuestionMutation = { unarchiveInternalFieldQuestion?: string | null };

export type UpdateInternalFieldsOrderMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type UpdateInternalFieldsOrderMutation = { updateInternalFieldsOrder?: Array<number | null> | null };

export type EmployerSettingsPageOrgOfficeLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployerSettingsPageOrgOfficeLocationsQuery = { getOrg?: { __typename: 'EmployerOrgNode', officeLocations?: { __typename: 'OrgOfficeLocationConnection', nodes?: Array<{ __typename: 'OfficeLocationNode', id: string, name: string } | null> | null } | null } | { __typename: 'UniversityOrgNode' } | null };

export type AddOfficeToOrgMutationVariables = Exact<{
  input: AddOfficeToOrgInput;
}>;


export type AddOfficeToOrgMutation = { addOfficeToOrg?: { success: boolean } | null };

export type RemoveOfficeFromOrgMutationVariables = Exact<{
  input: RemoveOfficeFromOrgInput;
}>;


export type RemoveOfficeFromOrgMutation = { removeOfficeFromOrg?: { success: boolean } | null };

export type SuperAdminCloseJobsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  sortBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type SuperAdminCloseJobsListQuery = { forwardJobFeed?: { totalCount?: number | null, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, nodes: Array<{ __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null }> } | null };

export type SuperAdminCloseJobsByIdQueryVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SuperAdminCloseJobsByIdQuery = { forwardJobsById: Array<{ __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'InterviewSchedulingJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null } | null> };

type SuperAdminCloseJobsJobFields_AtsJobNode_Fragment = { __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null };

type SuperAdminCloseJobsJobFields_ExternalJobNode_Fragment = { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null };

type SuperAdminCloseJobsJobFields_InterviewSchedulingJobNode_Fragment = { __typename: 'InterviewSchedulingJobNode', id: string, orgId: string, title?: string | null, descriptionTextContent?: string | null, employer?: { name?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null };

export type SuperAdminCloseJobsJobFieldsFragment = SuperAdminCloseJobsJobFields_AtsJobNode_Fragment | SuperAdminCloseJobsJobFields_ExternalJobNode_Fragment | SuperAdminCloseJobsJobFields_InterviewSchedulingJobNode_Fragment;

export type SuperAdminCloseJobsMutationVariables = Exact<{
  closeJobsInput: SuperAdminCloseJobsInput;
}>;


export type SuperAdminCloseJobsMutation = { superAdminCloseJobs: { success: boolean } };

export type SuperAdminFirmProfileCustomQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfileCustomQuery = { firmProfileByFirmId?: { id: string, orgId: string, customSection?: { id: string, orgId: string, firmProfileId: string, title?: string | null, answer?: string | null, coverImageSrc?: string | null, isEnabled: boolean, learnMoreLink?: { url: string, display?: string | null } | null, richMediaSubsection?: { title: string, blurb: string, richMedia: Array<{ id: string, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaTitle?: string | null, mediaThumbnailLink?: string | null, mediaLink?: string | null, mediaLinkText?: string | null } | null }> } | null } | null } | null };

export type SuperAdminSubmitFirmProfileCustomSectionMutationVariables = Exact<{
  input: SuperAdminSubmitFirmProfileCustomSectionInput;
}>;


export type SuperAdminSubmitFirmProfileCustomSectionMutation = { superAdminSubmitFirmProfileCustomSection: { success: boolean, id?: string | null } };

export type FirmProfileSelfIdDefaultsQueryVariables = Exact<{ [key: string]: never; }>;


export type FirmProfileSelfIdDefaultsQuery = { genderDefaults: Array<{ id: string, label?: string | null, name?: string | null, type?: SelfIdType | null, questionType?: SelfIdQuestionType | null, options?: { nodes?: Array<{ id: string, selfIdDefaultId: string, name?: string | null } | null> | null } | null }>, ethnicityDefaults: Array<{ id: string, label?: string | null, name?: string | null, type?: SelfIdType | null, questionType?: SelfIdQuestionType | null, options?: { nodes?: Array<{ id: string, selfIdDefaultId: string, name?: string | null } | null> | null } | null }>, nalpAdditionalDefaults: Array<{ id: string, label?: string | null, name?: string | null, type?: SelfIdType | null, questionType?: SelfIdQuestionType | null, options?: { nodes?: Array<{ id: string, selfIdDefaultId: string, name?: string | null } | null> | null } | null }> };

export type SelfIdDefaultFragment = { id: string, label?: string | null, name?: string | null, type?: SelfIdType | null, questionType?: SelfIdQuestionType | null };

export type SelfIdDefaultOptionFragment = { id: string, selfIdDefaultId: string, name?: string | null };

export type SuperAdminFirmProfileDiversityAndInclusionQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfileDiversityAndInclusionQuery = { firmProfileByFirmId?: { id: string, orgId: string, diversityAndInclusionSection?: { id: string, orgId: string, firmProfileId: string, answer?: string | null, learnMoreLink?: string | null, genderStatisticsAsOf?: string | null, ethnicityStatisticsAsOf?: string | null, additionalStatisticsAsOf?: string | null, isEnabled: boolean, statistics?: { gender: Array<{ id: string, orgId: string, firmProfileId: string, selfIdDefaultOptionId: string, numCounsels?: number | null, numPartners?: number | null, numAssociates?: number | null, numSummerAssociates?: number | null }>, raceOrEthnicity: Array<{ id: string, orgId: string, firmProfileId: string, selfIdDefaultOptionId: string, numCounsels?: number | null, numPartners?: number | null, numAssociates?: number | null, numSummerAssociates?: number | null }>, additional: Array<{ id: string, orgId: string, firmProfileId: string, selfIdDefaultOptionId: string, numCounsels?: number | null, numPartners?: number | null, numAssociates?: number | null, numSummerAssociates?: number | null }> } | null, richMediaSubsection?: { title: string, blurb: string, richMedia: Array<{ id: string, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaTitle?: string | null, mediaThumbnailLink?: string | null, mediaLink?: string | null, mediaLinkText?: string | null } | null }> } | null } | null } | null };

export type SuperAdminFirmProfileDiversityStatisticFragment = { id: string, orgId: string, firmProfileId: string, selfIdDefaultOptionId: string, numCounsels?: number | null, numPartners?: number | null, numAssociates?: number | null, numSummerAssociates?: number | null };

export type SuperAdminSubmitDiversityAndInclusionMutationVariables = Exact<{
  input: SuperAdminSubmitFirmProfileDiversityAndInclusionSectionInput;
}>;


export type SuperAdminSubmitDiversityAndInclusionMutation = { superAdminSubmitFirmProfileDiversityAndInclusionSection: { success: boolean, id?: string | null } };

export type SuperAdminFirmEventCarouselQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type SuperAdminFirmEventCarouselQuery = { publicOrgInfoByOrgId?: { firmProfile?: { eventCarousel?: { isEnabled: boolean, firmCarouselEvents?: { pageInfo: { startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { __typename: 'CandidateCallbackEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidateNetworkingEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidatePhysicalEventNode', university?: string | null, id: string, name: string, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidateSymplicityEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidateVirtualChatEventNode', university?: string | null, id: string, name: string, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'CandidateWebinarEventNode', university?: string | null, id: string, name: string, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { orgId: string, name?: string | null } | null }, metadata: { carouselEventId: string, isPinned: boolean, ranking?: number | null } }> } | null } | null } | null } | null };

export type SuperAdminSubmitEventCarouselSectionMutationVariables = Exact<{
  enableInput: SuperAdminEnableEventCarouselInput;
  updateInput: SuperAdminUpdateEventCarouselRankingsInput;
}>;


export type SuperAdminSubmitEventCarouselSectionMutation = { enablePayload: { success: boolean }, updatePayload: { success: boolean } };

export type SuperAdminFirmProfileHighlightsQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfileHighlightsQuery = { firmProfileByFirmId?: { id: string, orgId: string, revenueDollars?: string | null, profitsPerPartnerDollars?: string | null, numPartnershipTiers?: number | null, numAssociates?: number | null, numPartners?: number | null, numCounsels?: number | null, bio?: string | null, bannerImageSrc?: string | null, websiteLinkUrl?: string | null, isPublic: boolean, daysInOfficePerWeek?: number | null, daysInOfficeContext?: string | null, customLink?: { url: string, display: string } | null, socialMediaLinks?: { twitterUrl?: string | null, youtubeUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, linkedInUrl?: string | null } | null } | null };

export type SuperAdminSubmitFirmProfileHighlightsMutationVariables = Exact<{
  input: SuperAdminSubmitFirmProfileMainInput;
}>;


export type SuperAdminSubmitFirmProfileHighlightsMutation = { superAdminSubmitFirmProfileMain: { success: boolean, id?: string | null } };

export type SuperAdminFirmProfilePracticeAreaSectionQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfilePracticeAreaSectionQuery = { firmProfileByFirmId?: { id: string, orgId: string, practiceAreaSection?: { id: string, orgId: string, firmProfileId: string, answer?: string | null, learnMoreLink?: string | null, headcountsAsOf?: string | null, isEnabled: boolean, headcounts: Array<{ numAssociates?: number | null, numCounsels?: number | null, numPartners?: number | null, numEntryLevelPlacements?: number | null, ranking: number, orgId: string, orgPracticeAreaId: string, orgPracticeArea: { id: string, orgId: string, firmSpecificName: string } }>, richMediaSubsection?: { title: string, blurb: string, richMedia: Array<{ id: string, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaTitle?: string | null, mediaThumbnailLink?: string | null, mediaLink?: string | null, mediaLinkText?: string | null } | null }> } | null } | null } | null };

export type SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables = Exact<{
  input: SuperAdminSubmitFirmProfilePracticeAreaSectionInput;
}>;


export type SuperAdminSubmitFirmProfilePracticeAreaSectionMutation = { superAdminSubmitFirmProfilePracticeAreaSection: { success: boolean, id?: string | null } };

export type SuperAdminGetFirmPracticeAreasQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type SuperAdminGetFirmPracticeAreasQuery = { superAdminGetFirmPracticeAreas?: { nodes: Array<{ id: string, orgId: string, firmSpecificName: string, summerOffices: { nodes: Array<{ officeLocation: { id: string, name: string } }> } }> } | null };

export type SuperAdminAddPracticeAreaToFirmMutationVariables = Exact<{
  addInput: SuperAdminAddPracticeAreaToFirmInput;
}>;


export type SuperAdminAddPracticeAreaToFirmMutation = { superAdminAddPracticeAreaToFirm: { success: boolean } };

export type SuperAdminRemovePracticeAreaFromFirmMutationVariables = Exact<{
  removeInput: SuperAdminRemovePracticeAreaFromFirmInput;
}>;


export type SuperAdminRemovePracticeAreaFromFirmMutation = { superAdminRemovePracticeAreaFromFirm: { success: boolean } };

export type SuperAdminFirmProfilePreviewSectionQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfilePreviewSectionQuery = { firmProfileByFirmId?: { isPublic: boolean } | null };

export type SuperAdminEditFirmProfileIsPublicMutationVariables = Exact<{
  input: SuperAdminSubmitFirmProfileIsPublicInput;
}>;


export type SuperAdminEditFirmProfileIsPublicMutation = { superAdminSubmitFirmProfileIsPublic: { success: boolean } };

export type SuperAdminFirmProfileProBonoQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfileProBonoQuery = { firmProfileByFirmId?: { id: string, orgId: string, proBonoSection?: { id: string, orgId: string, firmProfileId: string, answer?: string | null, answer2?: string | null, learnMoreLink?: string | null, haveOpportunitiesForSummersOption?: FirmProfileProBonoHaveOpportunitiesForSummersOption | null, areProBonoHoursBillable?: FirmProfileProBonoAreProBonoHoursBillableOption | null, numBillableProBonoHours?: number | null, billableHoursContext?: string | null, participationPercentagesAsOf?: string | null, averageHoursAsOf?: string | null, isEnabled: boolean, participationPercentage?: { associate?: number | null, partner?: number | null, otherLawyers?: number | null } | null, averageHours?: { associate?: number | null, partner?: number | null, otherLawyers?: number | null } | null, richMediaSubsection?: { title: string, blurb: string, richMedia: Array<{ id: string, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaTitle?: string | null, mediaThumbnailLink?: string | null, mediaLink?: string | null, mediaLinkText?: string | null } | null }> } | null } | null } | null };

export type SuperAdminSubmitFirmProfileProBonoSectionMutationVariables = Exact<{
  input: SuperAdminSubmitFirmProfileProBonoSectionInput;
}>;


export type SuperAdminSubmitFirmProfileProBonoSectionMutation = { superAdminSubmitFirmProfileProBonoSection: { success: boolean, id?: string | null } };

export type SuperAdminFirmProfileRichMediaSubsectionFragment = { title: string, blurb: string, richMedia: Array<{ id: string, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaTitle?: string | null, mediaThumbnailLink?: string | null, mediaLink?: string | null, mediaLinkText?: string | null } | null }> };

export type SuperAdminFirmProfileSummerProgramSectionQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfileSummerProgramSectionQuery = { firmProfileByFirmId?: { id: string, orgId: string, firm: { firmPracticeAreas?: { nodes: Array<{ id: string, firmSpecificName: string, summerOffices: { nodes: Array<{ id: string, officeLocation: { name: string } }> } }> } | null }, summerProgramSection?: { id: string, orgId: string, firmProfileId: string, answer?: string | null, noResponse?: boolean | null, summerCount1L?: number | null, summerCount2L?: number | null, summerCountsAsOf?: string | null, earlyInterviewAvailableOption?: FirmProfileSummerProgramEarlyInterviewAvailableOption | null, resumeAcceptanceDeadline1L?: string | null, resumeAcceptanceText1L?: string | null, resumeAcceptanceDeadline2L?: string | null, resumeAcceptanceText2L?: string | null, assignedPracticeAreasOption?: FirmProfileSummerProgramAssignedPracticeAreasOption | null, firstYearHiredIntoPracticeAreaOption?: FirmProfileSummerProgramFirstYearHiredIntoPracticeAreaOption | null, howIsWorkAssignedOption?: FirmProfileSummerProgramHowIsWorkAssignedOption | null, howIsWorkAssignedContext?: string | null, learnMoreLink?: string | null, hasSummerByPracticeDataToInput: boolean, summerByPracticeContext?: string | null, summerTopPracticeAreasAsOf?: string | null, summerTopOfficeLocationsAsOf?: string | null, summerPracticeAreaByOfficeAsOf?: string | null, isEnabled: boolean, primaryContact?: { name: string, title?: string | null, email?: string | null } | null, summerSalary?: { value: number, unit: FirmProfileSummerProgramSummerSalaryLengthUnit } | null, programLength?: { value: number, unit: FirmProfileSummerProgramProgramLengthUnit } | null, summerTopPracticeAreas?: Array<{ orgId: string, orgPracticeAreaId: string, numSummerAssociates: number, orgPracticeArea: { id: string, orgId: string, firmSpecificName: string, summerOffices: { nodes: Array<{ id: string, officeLocation: { name: string } }> } } }> | null, summerTopOfficeLocations?: Array<{ orgId: string, orgOfficeId: string, numSummerAssociate: number, officeLocation?: { id: string, name: string } | null }> | null, richMediaSubsection?: { title: string, blurb: string, richMedia: Array<{ id: string, order?: number | null, firmProfileRichMediaType?: FirmProfileRichMediaType | null, firmProfileRichMediaData?: { mediaTitle?: string | null, mediaThumbnailLink?: string | null, mediaLink?: string | null, mediaLinkText?: string | null } | null }> } | null } | null } | null };

export type SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables = Exact<{
  input: SuperAdminSubmitFirmProfileSummerProgramSectionInput;
}>;


export type SuperAdminSubmitFirmProfileSummerProgramSectionMutation = { superAdminSubmitFirmProfileSummerProgramSection: { success: boolean, id?: string | null } };

export type SuperAdminFirmOfficesQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type SuperAdminFirmOfficesQuery = { superAdminGetOfficesForFirm: Array<{ id: string, locationId: string, name: string }> };

export type OrgFriendlyNameByIdQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type OrgFriendlyNameByIdQuery = { publicOrgInfoByOrgId?: { urlFriendlyName?: string | null } | null };

export type SuperAdminFirmProfileFormQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminFirmProfileFormQuery = { publicOrgInfoByOrgId?: { name?: string | null, forwardTier?: { asEnum: ForwardTier } | null } | null, firmProfileByFirmId?: { id: string, summerProgramSection?: { id: string } | null, diversityAndInclusionSection?: { id: string } | null, practiceAreaSection?: { id: string } | null, eventCarousel?: { id: string } | null, proBonoSection?: { id: string } | null, customSection?: { id: string } | null } | null };

export type SuperAdminGetUpcomingOrgEventsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  filterBy?: InputMaybe<EventDirectoryFilterBy>;
  sortBy?: InputMaybe<Array<EventDirectorySortBy> | EventDirectorySortBy>;
}>;


export type SuperAdminGetUpcomingOrgEventsQuery = { publicOrgInfoByOrgId?: { name?: string | null } | null, eventDirectory?: { totalCount?: number | null, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { __typename: 'CandidateCallbackEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateNetworkingEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidatePhysicalEventNode', university?: string | null, id: string, name: string, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateSymplicityEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateVirtualChatEventNode', university?: string | null, id: string, name: string, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'CandidateWebinarEventNode', university?: string | null, id: string, name: string, targetedSchools?: { nodes: Array<{ id: string, name: string }> } | null, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null }, metadata: { eventDirectoryId: string, isFeatured: boolean } }> } | null };

export type SuperAdminGetUpcomingEventsQueryVariables = Exact<{
  filterBy?: InputMaybe<EventDirectoryFilterBy>;
  sortBy?: InputMaybe<Array<EventDirectorySortBy> | EventDirectorySortBy>;
}>;


export type SuperAdminGetUpcomingEventsQuery = { eventDirectory?: { totalCount?: number | null, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { __typename: 'CandidateCallbackEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidateInviteEmployerEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidateNetworkingEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidatePhysicalEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidatePreselectEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidateSerendipitousEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidateSymplicityEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidateVirtualChatEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'CandidateWebinarEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null } | { __typename: 'LotteryStudentEventNode', id: string, name: string, start?: { date: string, time: string, zone: FloTimezone } | null, end?: { date: string, time: string, zone: FloTimezone } | null, host?: { id: string, name?: string | null, logoUrl?: string | null } | null }, metadata: { eventDirectoryId: string } }> } | null };

export type SuperAdminUpdateOrgFeaturedEventsMutationVariables = Exact<{
  input: SuperAdminUpdateOrgFeaturedEventsInput;
}>;


export type SuperAdminUpdateOrgFeaturedEventsMutation = { superAdminUpdateOrgFeaturedEvents: { success: boolean } };

export type SuperAdminSubmitForwardEventPublishingSettingsMutationVariables = Exact<{
  input: SuperAdminSubmitForwardEventPublishingSettingsInput;
}>;


export type SuperAdminSubmitForwardEventPublishingSettingsMutation = { superAdminSubmitForwardEventPublishingSettings: { success: boolean } };

export type SuperAdminForwardTierPanelFirmsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<FirmDirectoryFilterBy>;
  sortBy?: InputMaybe<Array<FirmDirectorySortBy> | FirmDirectorySortBy>;
}>;


export type SuperAdminForwardTierPanelFirmsQuery = { firmDirectory?: { totalCount?: number | null, pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, nodes: Array<{ id: string, name?: string | null, logoUrl?: string | null, urlFriendlyName?: string | null, forwardTier?: { id: string, name: string, asEnum: ForwardTier } | null, firmProfile?: { id: string, isPublic: boolean } | null }> } | null };

export type SuperAdminUpdateForwardTierMutationVariables = Exact<{
  input: SuperAdminUpdateForwardTierInput;
}>;


export type SuperAdminUpdateForwardTierMutation = { superAdminUpdateForwardTier: { success: boolean, id?: string | null } };

export type GenerateCandidateMutationVariables = Exact<{
  orgId: Scalars['Int'];
  input: GenerateCandidateInput;
}>;


export type GenerateCandidateMutation = { superAdminGenerateCandidate: { id: string, orgFriendlyName: string, firstName: string, lastName: string, email: string } };

export type SuperAdminOrgForGenerateCandidatesQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type SuperAdminOrgForGenerateCandidatesQuery = { superAdminGetOrg?: { activeInternalFieldQuestions: Array<{ id: string, title: string, showOnProfile?: boolean | null, showOnJobApplication?: boolean | null }>, jobs: Array<{ id?: number | null, title?: string | null, incomplete?: boolean | null }>, organizingEvents?: { nodes?: Array<{ id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | { id: string, name: string } | null> | null } | null } | {} | null };

export type UpdateFlagUrlMutationVariables = Exact<{
  key: Scalars['String'];
  url: Scalars['String'];
}>;


export type UpdateFlagUrlMutation = { updateFlagUrl?: number | null };

export type ToggleFlagMutationVariables = Exact<{
  key: Scalars['String'];
}>;


export type ToggleFlagMutation = { toggleFlag?: number | null };

export type RemoveOrgMutationVariables = Exact<{
  key: Scalars['String'];
  orgId: Scalars['Int'];
}>;


export type RemoveOrgMutation = { removeOrgFromFlag?: number | null };

export type AddOrgFlagMutationVariables = Exact<{
  key: Scalars['String'];
  orgId: Scalars['Int'];
}>;


export type AddOrgFlagMutation = { addOrgToFlag?: number | null };

export type FlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type FlagsQuery = { flags?: Array<{ id: string, name?: string | null, key?: string | null, url?: string | null, on?: boolean | null } | null> | null };

export type FlagFromKeyQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type FlagFromKeyQuery = { flagFromKey?: { id: string, name?: string | null, key?: string | null, url?: string | null, on?: boolean | null, orgEnabled?: boolean | null } | null };

export type EnabledOrgsQueryVariables = Exact<{
  key: Scalars['String'];
}>;


export type EnabledOrgsQuery = { flagFromKey?: { id: string, enabledOrgIds?: Array<number | null> | null } | null };

export type SuperAdminExternalJobImportBatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminExternalJobImportBatchesQuery = { superAdminExternalJobImportBatches?: { nodes: Array<{ id: string, importDate: string, source: string, processedJobsRatio: { processed: number, total: number } }> } | null };

export type SuperAdminExternalJobImportBatchByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SuperAdminExternalJobImportBatchByIdQuery = { superAdminExternalJobImportBatchById?: { id: string, importDate: string, source: string, processedJobsRatio: { processed: number, total: number }, imports: { nodes: Array<{ id: string, firmName?: string | null, jobTitle?: string | null, processingStatus: ExternalJobImportProcessingStatus, jobId?: string | null }> } } | null };

export type SuperAdminExternalJobImportByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SuperAdminExternalJobImportByIdQuery = { superAdminExternalJobImportById?: { id: string, batchId: string, processingStatus: ExternalJobImportProcessingStatus, jobId?: string | null, firmName?: string | null, jobTitle?: string | null, officeLocations?: string | null, description?: string | null, programLength?: string | null, applicationsOpenDate?: string | null, applicationsCloseDate?: string | null, salary?: string | null, requiredDocuments?: string | null, applicationUrl?: string | null } | null };

export type SuperAdminExternalJobImportCsvRowFragment = { firmName?: string | null, jobTitle?: string | null, officeLocations?: string | null, description?: string | null, programLength?: string | null, applicationsOpenDate?: string | null, applicationsCloseDate?: string | null, salary?: string | null, requiredDocuments?: string | null, applicationUrl?: string | null };

export type SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminExternalJobImportFirmIndependentDropdownDataQuery = { superAdminGetExistingFirms: Array<{ id: string, name: string }>, allPracticeCategories?: { nodes: Array<{ id: string, name: string }> } | null };

export type SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type SuperAdminExternalJobImportFirmDependentDropdownDataQuery = { publicOrgInfoByOrgId?: { isAtsCustomer: boolean, forwardTier?: { asEnum: ForwardTier } | null } | null, superAdminGetOfficesForFirm: Array<{ id: string, name: string }>, superAdminGetDocumentsForFirm: Array<{ id: string, name: string }> };

export type SubmitExternalJobImportMutationVariables = Exact<{
  submitInput: SubmitAndMarkExternalJobImportAsCompletedInput;
}>;


export type SubmitExternalJobImportMutation = { submitAndMarkExternalJobImportAsCompleted?: { success: boolean } | null };

export type ToggleExternalJobImportDoNotSubmitStatusMutationVariables = Exact<{
  input: ToggleExternalJobImportDoNotSubmitStatusInput;
}>;


export type ToggleExternalJobImportDoNotSubmitStatusMutation = { toggleExternalJobImportDoNotSubmitStatus?: { success: boolean } | null };

export type SuperAdminAddLawSchoolMutationVariables = Exact<{
  input: SuperAdminCreateLawSchoolInput;
}>;


export type SuperAdminAddLawSchoolMutation = { superAdminCreateLawSchool: { success: boolean, id?: string | null } };

export type SuperAdminRenameLawSchoolMutationVariables = Exact<{
  input: SuperAdminEditLawSchoolInput;
}>;


export type SuperAdminRenameLawSchoolMutation = { superAdminEditLawSchool: { success: boolean } };

export type SuperAdminMergeLawSchoolMutationVariables = Exact<{
  input: SuperAdminMergeLawSchoolInput;
}>;


export type SuperAdminMergeLawSchoolMutation = { superAdminMergeLawSchool: { success: boolean } };

export type SuperAdminOutlierLawSchoolDataByNameQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminOutlierLawSchoolDataByNameQuery = { superAdminOutlierLawSchoolData?: { byName: Array<{ outlierName: string, lawSchoolQualifyingQuestionAnswerCount: number, lawSchoolMemberAnswerCount: number, jobAppEducationHistoryLawSchoolEntryCount: number, eventLawSchoolCount: number, universityDegreeLawSchoolCount: number }> } | null };

export type SuperAdminAssignOutlierLawSchoolDataMutationVariables = Exact<{
  input: SuperAdminAssignOutlierLawSchoolDataInput;
}>;


export type SuperAdminAssignOutlierLawSchoolDataMutation = { superAdminAssignOutlierLawSchoolData: { success: boolean } };

export type LawSchoolsWithDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type LawSchoolsWithDomainsQuery = { allLawSchools?: { nodes: Array<{ id: string, name: string, emailDomains: Array<string> }> } | null };

export type SuperAdminSubmitEmailDomainsForSchoolMutationVariables = Exact<{
  input: SuperAdminSubmitEmailDomainsForSchoolInput;
}>;


export type SuperAdminSubmitEmailDomainsForSchoolMutation = { superAdminSubmitEmailDomainsForSchool: { success?: boolean | null } };

export type SuperAdminAddOfficeLocationMutationVariables = Exact<{
  input: SuperAdminCreateOfficeLocationInput;
}>;


export type SuperAdminAddOfficeLocationMutation = { superAdminCreateOfficeLocation: { success: boolean, id?: string | null } };

export type SuperAdminRenameOfficeLocationMutationVariables = Exact<{
  input: SuperAdminEditOfficeLocationInput;
}>;


export type SuperAdminRenameOfficeLocationMutation = { superAdminEditOfficeLocation: { success: boolean } };

export type SuperAdminAddPracticeAreaMutationVariables = Exact<{
  input: SuperAdminCreatePracticeAreaInput;
}>;


export type SuperAdminAddPracticeAreaMutation = { superAdminCreatePracticeArea: { success: boolean, id?: string | null } };

export type SuperAdminRenamePracticeAreaMutationVariables = Exact<{
  input: SuperAdminEditPracticeAreaInput;
}>;


export type SuperAdminRenamePracticeAreaMutation = { superAdminEditPracticeArea: { success: boolean } };

export type SuperAdminAddPracticeCategoryMutationVariables = Exact<{
  input: SuperAdminCreatePracticeCategoryInput;
}>;


export type SuperAdminAddPracticeCategoryMutation = { superAdminCreatePracticeCategory: { success: boolean, id?: string | null } };

export type SuperAdminRenamePracticeCategoryMutationVariables = Exact<{
  input: SuperAdminEditPracticeCategoryInput;
}>;


export type SuperAdminRenamePracticeCategoryMutation = { superAdminEditPracticeCategory: { success: boolean } };

export type SuperAdminAddUniversityMutationVariables = Exact<{
  input: SuperAdminCreateUniversityInput;
}>;


export type SuperAdminAddUniversityMutation = { superAdminCreateUniversity: { success: boolean, id?: string | null } };

export type SuperAdminRenameUniversityMutationVariables = Exact<{
  input: SuperAdminEditUniversityInput;
}>;


export type SuperAdminRenameUniversityMutation = { superAdminEditUniversity: { success: boolean } };

export type SuperAdminActiveWorkplacesQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminActiveWorkplacesQuery = { workplaces: { nodes: Array<{ id: string, name: string, isArchived: boolean, connectedOrg?: { id: string, name?: string | null, logoUrl?: string | null } | null }> } };

export type SuperAdminArchivedWorkplacesQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminArchivedWorkplacesQuery = { archivedWorkplaces: { nodes: Array<{ id: string, name: string, isArchived: boolean, connectedOrg?: { id: string, name?: string | null, logoUrl?: string | null } | null }> } };

export type SuperAdminListManagementWorkplaceFragment = { id: string, name: string, isArchived: boolean, connectedOrg?: { id: string, name?: string | null, logoUrl?: string | null } | null };

export type SuperAdminWorkplaceManagementExistingFirmsListQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminWorkplaceManagementExistingFirmsListQuery = { superAdminGetExistingFirms: Array<{ id: string, name: string }> };

export type SuperAdminAddWorkplaceMutationVariables = Exact<{
  input: SuperAdminCreateWorkplaceInput;
}>;


export type SuperAdminAddWorkplaceMutation = { superAdminCreateWorkplace: { success: boolean } };

export type SuperAdminEditWorkplaceMutationVariables = Exact<{
  input: SuperAdminEditWorkplaceInput;
}>;


export type SuperAdminEditWorkplaceMutation = { superAdminEditWorkplace: { success: boolean } };

export type SuperAdminArchiveWorkplaceMutationVariables = Exact<{
  input: SuperAdminArchiveWorkplaceInput;
}>;


export type SuperAdminArchiveWorkplaceMutation = { superAdminArchiveWorkplace: { success: boolean } };

export type SuperAdminAtsJobListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  orderBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type SuperAdminAtsJobListQuery = { forwardJobFeed?: { pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, description?: string | null, is1L: boolean, is2L: boolean, hasJobBoardAudienceSet: boolean, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null } | { __typename: 'ExternalJobNode' } }> } | null };

export type SuperAdminAtsJobFragment = { id: string, orgId: string, title?: string | null, description?: string | null, is1L: boolean, is2L: boolean, hasJobBoardAudienceSet: boolean, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null };

export type SuperAdminSubmitJobBoardAudienceMutationVariables = Exact<{
  input: SuperAdminSubmitJobBoardAudienceInput;
}>;


export type SuperAdminSubmitJobBoardAudienceMutation = { superAdminSubmitJobBoardAudience: { success: boolean } };

export type SuperAdminExternalJobListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filterBy?: InputMaybe<ForwardJobFeedFilterBy>;
  orderBy?: InputMaybe<Array<JobFeedSortBy> | JobFeedSortBy>;
}>;


export type SuperAdminExternalJobListQuery = { forwardJobFeed?: { pageInfo: { endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ cursor: string, node: { __typename: 'AtsJobNode' } | { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, description?: string | null, sourceLink?: string | null, is1L: boolean, is2L: boolean, employer?: { name?: string | null, logoUrl?: string | null } | null } }> } | null };

export type SuperAdminJobByIdQueryVariables = Exact<{
  jobId: Scalars['ID'];
}>;


export type SuperAdminJobByIdQuery = { forwardJobById?: { __typename: 'AtsJobNode', id: string, orgId: string, title?: string | null, description?: string | null, is1L: boolean, is2L: boolean, hasJobBoardAudienceSet: boolean, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null } | { __typename: 'ExternalJobNode', id: string, orgId: string, title?: string | null, description?: string | null, sourceLink?: string | null, is1L: boolean, is2L: boolean, employer?: { name?: string | null, logoUrl?: string | null } | null, openDate?: { date: string, time: string, zone: FloTimezone } | null, closeDate?: { date: string, time: string, zone: FloTimezone } | null, offices?: { nodes?: Array<{ id: string, name: string }> | null } | null, requiredDocuments?: Array<{ id: string, name?: string | null } | null> | null, practiceCategories?: { nodes: Array<{ id: string, name: string }> } | null, salaryInfo?: { amount: number, timeUnit: JobSalaryInfoTimeUnit } | null, programLength?: { amount: number, timeUnit: JobProgramLengthTimeUnit } | null } | null };

export type SuperAdminExternalJobFormStaticListsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminExternalJobFormStaticListsQuery = { superAdminGetExistingFirms: Array<{ id: string, name: string }>, allOfficeLocations?: { nodes: Array<{ id: string, name: string }> } | null, allPracticeCategories?: { nodes: Array<{ id: string, name: string }> } | null };

export type SuperAdminExternalJobFormFirmDependentListsQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type SuperAdminExternalJobFormFirmDependentListsQuery = { superAdminGetOfficesForFirm: Array<{ id: string, locationId: string, name: string }>, superAdminGetDocumentsForFirm: Array<{ id: string, name: string }> };

export type SuperAdminAddOfficeMutationVariables = Exact<{
  addOfficeInput: SuperAdminAddOfficeToFirmInput;
}>;


export type SuperAdminAddOfficeMutation = { superAdminAddOfficeToFirm: { success: boolean } };

export type SuperAdminAddDocumentMutationVariables = Exact<{
  addDocumentInput: SuperAdminAddDocumentToFirmInput;
}>;


export type SuperAdminAddDocumentMutation = { superAdminAddDocumentToFirm: { success: boolean, documentId?: string | null } };

export type SuperAdminSubmitJobMutationVariables = Exact<{
  submitJobInput: SuperAdminSubmitJobForFirmInput;
}>;


export type SuperAdminSubmitJobMutation = { superAdminSubmitJobForFirm: { success: boolean, jobId?: string | null } };

export type SuperAdminGetOrgForwardPrivilegesQueryVariables = Exact<{
  orgId: Scalars['ID'];
}>;


export type SuperAdminGetOrgForwardPrivilegesQuery = { publicOrgInfoByOrgId?: { name?: string | null } | null, superAdminGetOrgForwardPrivileges?: { id: string, carouselEventPublishing: boolean, directoryEventPublishing: boolean, lawSchoolTargeting: boolean } | null };

export type SuperAdminUpdateOrgForwardPrivilegesMutationVariables = Exact<{
  input: SuperAdminUpdateOrgForwardPrivilegesInput;
}>;


export type SuperAdminUpdateOrgForwardPrivilegesMutation = { superAdminUpdateOrgForwardPrivileges: { success: boolean } };

export type SuperAdminGetFirmAndItsOfficesQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminGetFirmAndItsOfficesQuery = { publicOrgInfoByOrgId?: { name?: string | null } | null, superAdminGetOfficesForFirm: Array<{ id: string, locationId: string, name: string, ranking: number }> };

export type SuperAdminCreateOfficeForFirmMutationVariables = Exact<{
  input: SuperAdminAddOfficeToFirmInput;
}>;


export type SuperAdminCreateOfficeForFirmMutation = { superAdminAddOfficeToFirm: { success: boolean } };

export type SuperAdminRemoveOfficeFromFirmMutationVariables = Exact<{
  input: SuperAdminRemoveOfficeFromFirmInput;
}>;


export type SuperAdminRemoveOfficeFromFirmMutation = { superAdminRemoveOfficeFromFirm: { success: boolean } };

export type SuperAdminUpdateOrgOfficeRankingsMutationVariables = Exact<{
  input: SuperAdminUpdateOrgOfficeRankingInput;
}>;


export type SuperAdminUpdateOrgOfficeRankingsMutation = { superAdminUpdateOrgOfficeRankings: { success: boolean } };

export type SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables = Exact<{
  firmId: Scalars['ID'];
}>;


export type SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery = { publicOrgInfoByOrgId?: { name?: string | null, offices: { nodes: Array<{ id: string, officeLocation: { id: string, name: string } }> }, firmPracticeAreas?: { nodes: Array<{ id: string, firmSpecificName: string, offices: { nodes: Array<{ id: string, officeLocation: { name: string } }> } }> } | null } | null };

export type SuperAdminGetFirmPracticeAreasFieldsFragment = { id: string, firmSpecificName: string, offices: { nodes: Array<{ id: string, officeLocation: { name: string } }> } };

export type SuperAdminCreatePracticeAreaForFirmMutationVariables = Exact<{
  input: SuperAdminAddPracticeAreaToFirmInput;
}>;


export type SuperAdminCreatePracticeAreaForFirmMutation = { superAdminAddPracticeAreaToFirm: { success: boolean } };

export type SuperAdminEditPracticeAreaForFirmMutationVariables = Exact<{
  input: SuperAdminEditPracticeAreaForFirmInput;
}>;


export type SuperAdminEditPracticeAreaForFirmMutation = { superAdminEditPracticeAreaForFirm: { success: boolean } };

export type SuperAdminDeletePracticeAreaForFirmMutationVariables = Exact<{
  input: SuperAdminRemovePracticeAreaFromFirmInput;
}>;


export type SuperAdminDeletePracticeAreaForFirmMutation = { superAdminRemovePracticeAreaFromFirm: { success: boolean } };

export type UpdateOrgSsoMutationVariables = Exact<{
  input: SuperAdminUpdateOrgSsoInput;
}>;


export type UpdateOrgSsoMutation = { superAdminUpdateOrgSSO: { success: boolean } };

export type ToggleOrgSsoOnOffMutationVariables = Exact<{
  orgId: Scalars['ID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type ToggleOrgSsoOnOffMutation = { superAdminToggleOrgSSO: boolean };

export type OrganizationSecuritySettingsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationSecuritySettingsPageQuery = { superAdminGetAllActiveOrgs: Array<{ id: string, name?: string | null, ssoAuthInfo?: { id: string, connectionName: string, isEnabled: boolean } | null } | { id: string, name?: string | null, ssoAuthInfo?: { id: string, connectionName: string, isEnabled: boolean } | null }> };

export type GetSsoConnectionOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSsoConnectionOptionsQuery = { superAdminGetSsoConnectionOptions?: Array<{ id: string, connectionName: string, ssoIdIsEmail: boolean }> | null };

export type SuperAdminGetAllActiveEmployerOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminGetAllActiveEmployerOrgsQuery = { superAdminGetAllActiveOrgs: Array<{ id: string, name?: string | null, urlFriendlyName?: string | null, emailDomain?: string | null } | {}> };

export type SuperAdminGetAllActiveUniversityOrgsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminGetAllActiveUniversityOrgsQuery = { superAdminGetAllActiveOrgs: Array<{ id: string, name?: string | null, urlFriendlyName?: string | null, emailDomain?: string | null } | {}> };

export type SuperAdminGetEventsForOrgQueryVariables = Exact<{
  orgId: Scalars['ID'];
  eventTypes: Array<EventType> | EventType;
}>;


export type SuperAdminGetEventsForOrgQuery = { superAdminGetEventsForOrg: Array<{ id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null } | { id: string, name: string, eventType?: EventType | null, memberFeedbackDisabled?: boolean | null, candidateReminderDisabled?: boolean | null, inviteOnly?: boolean | null, start?: { date: string } | null }> };

type RegisteredMemberDetails_CallbackEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_CoffeeChatEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_InterviewSchedulingEmployerEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_InvitedEmployerEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_LotteryEmployerEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_OciEmployerEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_PhysicalEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_SharedNetworkingEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

type RegisteredMemberDetails_WebinarEventNode_Fragment = { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null };

export type RegisteredMemberDetailsFragment = RegisteredMemberDetails_CallbackEventNode_Fragment | RegisteredMemberDetails_CoffeeChatEventNode_Fragment | RegisteredMemberDetails_InterviewSchedulingEmployerEventNode_Fragment | RegisteredMemberDetails_InvitedEmployerEventNode_Fragment | RegisteredMemberDetails_LotteryEmployerEventNode_Fragment | RegisteredMemberDetails_OciEmployerEventNode_Fragment | RegisteredMemberDetails_PhysicalEventNode_Fragment | RegisteredMemberDetails_SharedNetworkingEventNode_Fragment | RegisteredMemberDetails_WebinarEventNode_Fragment;

export type SuperAdminGetMemberAttendeesForOrgQueryVariables = Exact<{
  orgId: Scalars['ID'];
  eventId: Scalars['ID'];
}>;


export type SuperAdminGetMemberAttendeesForOrgQuery = { superAdminGetEventForOrg?: { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | { registeredMembers?: Array<{ id?: number | null, email?: string | null, fname?: string | null, lname?: string | null, feedback?: Array<{ id?: number | null }> | null }> | null } | {} | null };

export type GetCandidatesSclpQueryVariables = Exact<{
  filterBy?: InputMaybe<CandidateFilterBy>;
  sortBy?: InputMaybe<CandidateSortBy>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidatesSclpQuery = { getCandidatesSCLP?: { totalCount?: number | null, pageInfo?: { startCursor?: string | null, endCursor?: string | null, hasNextPage?: boolean | null, hasPrevPage?: boolean | null } | null, nodes?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, lawSchool?: string | null } | null> | null, edges?: Array<{ cursor?: string | null, node?: { id: string } | null } | null> | null } | null };

export type AllLawSchoolsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllLawSchoolsQuery = { allLawSchools?: { nodes: Array<{ id: string, name: string }> } | null };

export type AllOfficeLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllOfficeLocationsQuery = { allOfficeLocations?: { nodes: Array<{ id: string, name: string }> } | null };

export type AllPracticeAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPracticeAreasQuery = { allPracticeAreas?: { nodes?: Array<{ id: string, name: string }> | null } | null };

export type AllPracticeCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPracticeCategoriesQuery = { allPracticeCategories?: { nodes: Array<{ id: string, name: string }> } | null };

export type AllUniversitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUniversitiesQuery = { allUniversities: { nodes: Array<{ id: string, name: string }> } };

export type SuperAdminLoginGuardQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminLoginGuardQuery = { whoAmI: { isLoggedIn: boolean, asOrgUser?: { __typename: 'WhoAmIOrgAdmin', orgId: string, userId: string, loggedInEmail?: string | null, orgType: WhoAmIOrgType, orgFriendlyName: string } | { __typename: 'WhoAmIOrgMember', orgId: string, userId: string, loggedInEmail?: string | null, orgType: WhoAmIOrgType, orgFriendlyName: string } | null } };

export type AllCustomProgramEvaluationResponsesQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type AllCustomProgramEvaluationResponsesQuery = { workAllocationProgram: { customEvaluations?: Array<{ id: string, evaluationType: string, evaluationName: string, feedbackReminderEmailEnabled?: boolean | null, questions?: Array<{ evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, highScale?: number | null, lowScale?: number | null, type?: FeedbackQuestionType | null } | null } | null> | null, responses?: Array<{ id: string, requestedAt: string, completedAt?: string | null, associate: { id: string, candidate: { id: string, firstName?: string | null, lastName?: string | null } }, attorney?: { id: string, firstName: string, lastName: string } | null, answers: Array<{ id: string, orgFeedbackId: string, ratingAnswer?: number | null, yesNoAnswer?: number | null, singleSelectAnswer?: string | null, multiSelectAnswers?: Array<string> | null, freeText?: string | null, comment?: string | null }> }> | null } | null> | null } };

export type SendProjectEvaluationRequestEmailMutationVariables = Exact<{
  programId: Scalars['ID'];
  projectId: Scalars['ID'];
  associateRecruitId: Scalars['ID'];
  attorneyUserId: Scalars['ID'];
}>;


export type SendProjectEvaluationRequestEmailMutation = { sendProjectEvaluationRequestEmail?: boolean | null };

export type SendProgramEvaluationRequestEmailForAssociatesMutationVariables = Exact<{
  programId: Scalars['ID'];
  programEvaluationId: Scalars['ID'];
  associateRecruitIds: Array<Scalars['ID']> | Scalars['ID'];
  options?: InputMaybe<ProgramEvaluationRequestOptions>;
}>;


export type SendProgramEvaluationRequestEmailForAssociatesMutation = { sendProgramEvaluationRequestEmailForAssociates?: boolean | null };

export type CreateProgramAssociateMutationVariables = Exact<{
  associate: ProgramAssociateInput;
}>;


export type CreateProgramAssociateMutation = { createProgramAssociate: number };

export type UpdateProgramAssociateMutationVariables = Exact<{
  updateInfo: ProgramAssociateUpdateInput;
}>;


export type UpdateProgramAssociateMutation = { updateProgramAssociate: { id?: string | null } };

export type UpdateProgramAssociatePracticeAreasMutationVariables = Exact<{
  updateInfo: ProgramAssociatePreferredPracticeAreasUpdateInput;
}>;


export type UpdateProgramAssociatePracticeAreasMutation = { updateProgramAssociatePracticeAreas: { id?: string | null } };

export type ProgramAssociatesForOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramAssociatesForOrgQuery = { programAssociatesForOrg: Array<{ id?: string | null, programId: string, firstName: string, lastName: string, email: string, phoneNumber?: string | null, phoneExtension?: string | null, location?: string | null, languages?: Array<string> | null, lawSchools?: Array<string> | null, employersEmployeeId?: string | null, startDate?: string | null, endDate?: string | null, splitOffice?: string | null, recruitIdForAssociateWorkEmail?: number | null, linkedRecruitIds?: Array<number> | null, preferredPracticeAreas?: Array<{ order: number, practiceAreaId?: string | null, orgSpecificPracticeAreaId?: string | null, preferredPracticeAreaName?: string | null }> | null, mentors?: Array<{ memberId: number, firstName: string, lastName: string, email: string, mentorRole: MentorRole }> | null }> };

export type ProgramAssociatesByProgramIdQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type ProgramAssociatesByProgramIdQuery = { programAssociatesByProgramId: Array<{ id?: string | null, programId: string, firstName: string, lastName: string, email: string, phoneNumber?: string | null, phoneExtension?: string | null, location?: string | null, languages?: Array<string> | null, lawSchools?: Array<string> | null, employersEmployeeId?: string | null, startDate?: string | null, endDate?: string | null, splitOffice?: string | null, recruitIdForAssociateWorkEmail?: number | null, linkedRecruitIds?: Array<number> | null, preferredPracticeAreas?: Array<{ order: number, practiceAreaId?: string | null, orgSpecificPracticeAreaId?: string | null, preferredPracticeAreaName?: string | null }> | null, mentors?: Array<{ memberId: number, firstName: string, lastName: string, email: string, mentorRole: MentorRole }> | null }> };

export type ProgramAssociateByRecruitIdAndProgramIdQueryVariables = Exact<{
  programId: Scalars['ID'];
  associateRecruitId: Scalars['Int'];
}>;


export type ProgramAssociateByRecruitIdAndProgramIdQuery = { programAssociateByRecruitIdAndProgramId: { id?: string | null, programId: string, firstName: string, lastName: string, email: string, phoneNumber?: string | null, phoneExtension?: string | null, location?: string | null, languages?: Array<string> | null, lawSchools?: Array<string> | null, employersEmployeeId?: string | null, startDate?: string | null, endDate?: string | null, splitOffice?: string | null, recruitIdForAssociateWorkEmail?: number | null, linkedRecruitIds?: Array<number> | null, preferredPracticeAreas?: Array<{ order: number, practiceAreaId?: string | null, orgSpecificPracticeAreaId?: string | null, preferredPracticeAreaName?: string | null }> | null, mentors?: Array<{ memberId: number, firstName: string, lastName: string, email: string, mentorRole: MentorRole }> | null } };

export type ProgramDetailsFragment = { id: string, title?: string | null, description?: string | null, startDate?: string | null, endDate?: string | null, timezone?: string | null, ownerUser?: { id?: number | null, fname?: string | null, lname?: string | null } | null };

export type ProgramContributorFragment = { accessLevel: ProgramContributorAccessLevel, member: { id: string, firstName: string, lastName: string, email: string } };

export type ProgramPermissionsFragment = { allowSummerAssociatesToCreateEditProjects?: boolean | null, allowSummerAssociatesToDeleteProjects?: boolean | null, allowSummerAssociatesToSelfAssignProjects?: boolean | null };

export type ProgramEmailAlertsFragment = { emailSummerAssociateWhenAssignedToProject?: boolean | null, emailAdminWhenAttorneyCreatesProject?: boolean | null, emailAdminWhenSummerAssociateCreatesProject?: boolean | null, emailAdminWhenSummerAssociateIsAssignedToProject?: boolean | null, emailAdminWhenSummerAssociateDeletesProject?: boolean | null, emailAdminWhenSummerAssociateIsRemovedFromProject?: boolean | null, emailAdminWhenFeedbackSubmitted?: boolean | null, emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: boolean | null, emailAssignedAttorneysWhenAssociateAssignedToProject?: boolean | null, emailAssignedAttorneysWhenAssociateIsRemovedFromProject?: boolean | null, emailAssignedAttorneysWhenAssociateDeletesProject?: boolean | null, emailContributorWhenAttorneyCreatesProject: boolean, emailContributorWhenAssociateCreatesProject: boolean, emailContributorWhenAssociateDeletesProject: boolean, emailContributorWhenAssociateIsRemovedFromProject: boolean };

export type ProgramDetailsQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type ProgramDetailsQuery = { workAllocationProgram: { id: string, title?: string | null, description?: string | null, startDate?: string | null, endDate?: string | null, timezone?: string | null, ownerUser?: { id?: number | null, fname?: string | null, lname?: string | null } | null } };

export type WorkAllocationProgramContributorsQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationProgramContributorsQuery = { workAllocationProgram: { contributors?: Array<{ accessLevel: ProgramContributorAccessLevel, member: { id: string, firstName: string, lastName: string, email: string } }> | null } };

export type ProgramPermissionsQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type ProgramPermissionsQuery = { workAllocationProgram: { allowSummerAssociatesToCreateEditProjects?: boolean | null, allowSummerAssociatesToDeleteProjects?: boolean | null, allowSummerAssociatesToSelfAssignProjects?: boolean | null } };

export type ProgramEmailAlertsQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type ProgramEmailAlertsQuery = { workAllocationProgram: { emailSummerAssociateWhenAssignedToProject?: boolean | null, emailAdminWhenAttorneyCreatesProject?: boolean | null, emailAdminWhenSummerAssociateCreatesProject?: boolean | null, emailAdminWhenSummerAssociateIsAssignedToProject?: boolean | null, emailAdminWhenSummerAssociateDeletesProject?: boolean | null, emailAdminWhenSummerAssociateIsRemovedFromProject?: boolean | null, emailAdminWhenFeedbackSubmitted?: boolean | null, emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: boolean | null, emailAssignedAttorneysWhenAssociateAssignedToProject?: boolean | null, emailAssignedAttorneysWhenAssociateIsRemovedFromProject?: boolean | null, emailAssignedAttorneysWhenAssociateDeletesProject?: boolean | null, emailContributorWhenAttorneyCreatesProject: boolean, emailContributorWhenAssociateCreatesProject: boolean, emailContributorWhenAssociateDeletesProject: boolean, emailContributorWhenAssociateIsRemovedFromProject: boolean } };

export type CreateWorkAllocationAssociateMutationVariables = Exact<{
  associate?: InputMaybe<CandidateInput>;
}>;


export type CreateWorkAllocationAssociateMutation = { createWorkAllocationAssociate: number };

export type SelfAssignToMatterMutationVariables = Exact<{
  matterId: Scalars['ID'];
  programId: Scalars['ID'];
}>;


export type SelfAssignToMatterMutation = { selfAssignToMatter: boolean };

export type AddAssociatesToWorkAllocationMatterMutationVariables = Exact<{
  matterId: Scalars['ID'];
  associateIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddAssociatesToWorkAllocationMatterMutation = { addAssociatesToWorkAllocationMatter: Array<string | null> };

export type AddAssociatesToWorkAllocationProgramMutationVariables = Exact<{
  programId: Scalars['ID'];
  associateIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type AddAssociatesToWorkAllocationProgramMutation = { addAssociatesToWorkAllocationProgram: Array<string | null> };

export type UpsertWorkAllocationProgramMatterByAssociateMutationVariables = Exact<{
  programId: Scalars['ID'];
  input: UpsertWorkAllocationProgramMatterInput;
}>;


export type UpsertWorkAllocationProgramMatterByAssociateMutation = { upsertWorkAllocationProgramMatterByAssociate: number };

export type UpdateMatterWorkStatusByAssociateMutationVariables = Exact<{
  matterId: Scalars['ID'];
  status: MatterStatus;
}>;


export type UpdateMatterWorkStatusByAssociateMutation = { updateMatterWorkStatusByAssociate?: boolean | null };

export type DeleteMatterByAssociateMutationVariables = Exact<{
  matterId: Scalars['ID'];
}>;


export type DeleteMatterByAssociateMutation = { deleteMatter: boolean };

export type WorkAllocationOrgAssociatesQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkAllocationOrgAssociatesQuery = { workAllocationOrgAssociates: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> };

export type WorkAllocationProgramAssociatesQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationProgramAssociatesQuery = { workAllocationProgram: { programAssociates?: Array<{ firstName?: string | null, lastName?: string | null, id: string, email?: string | null, authzReasons?: Array<WorkAllocationAuthorizationReason> | null } | null> | null, groups: Array<{ name: string, associates: Array<{ id: string }> }> } };

export type ProgramAssociatesForSummerAssociateTableQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type ProgramAssociatesForSummerAssociateTableQuery = { programAssociatesByProgramId: Array<{ recruitIdForAssociateWorkEmail?: number | null, startDate?: string | null, endDate?: string | null }> };

export type WorkAllocationUnassignedMattersForProgramQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationUnassignedMattersForProgramQuery = { unassignedWorkAllocationMattersForAssociate: Array<{ createdBy?: string | null, assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, workStatus?: MatterStatus | null, workStatusUpdatedAt?: string | null, createdAt?: string | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, documentFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null }> };

export type WorkAllocationMattersForAssociateQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationMattersForAssociateQuery = { workAllocationMattersForAssociate: Array<{ createdBy?: string | null, assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, workStatus?: MatterStatus | null, workStatusUpdatedAt?: string | null, createdAt?: string | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, documentFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null }> };

export type AssignedWorkAllocationMattersForAssociateQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type AssignedWorkAllocationMattersForAssociateQuery = { assignedWorkAllocationMattersForAssociate: Array<{ createdBy?: string | null, assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, workStatus?: MatterStatus | null, workStatusUpdatedAt?: string | null, createdAt?: string | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, documentFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null }> };

export type WorkAllocationMatterForAssociateQueryVariables = Exact<{
  matterId: Scalars['ID'];
}>;


export type WorkAllocationMatterForAssociateQuery = { workAllocationMatterForAssociate: { createdBy?: string | null, assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, workStatus?: MatterStatus | null, workStatusUpdatedAt?: string | null, createdAt?: string | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, documentFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null } };

export type WorkAllocationProgramForAssociateQueryVariables = Exact<{
  programId: Scalars['ID'];
  associateRecruitId: Scalars['ID'];
}>;


export type WorkAllocationProgramForAssociateQuery = { workAllocationProgramForAssociate: { title?: string | null, createdAt?: string | null, description?: string | null, endDate?: string | null, startDate?: string | null, id: string, attorneyFeedbackReminderEmailEnabled?: boolean | null, allowSummerAssociatesToCreateEditProjects?: boolean | null, allowSummerAssociatesToDeleteProjects?: boolean | null, allowSummerAssociatesToSelfAssignProjects?: boolean | null, emailAdminWhenAttorneyCreatesProject?: boolean | null, emailAdminWhenSummerAssociateCreatesProject?: boolean | null, emailAdminWhenSummerAssociateIsAssignedToProject?: boolean | null, emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: boolean | null, emailSummerAssociateWhenAssignedToProject?: boolean | null, ownerUser?: { id?: number | null, admin?: boolean | null, fname?: string | null, lname?: string | null, email?: string | null } | null, customEvaluations?: Array<{ id: string, evaluationName: string, evaluationType: string, questions?: Array<{ id: string, orgFeedbackId?: number | null, isRequired?: boolean | null, evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, evaluationType?: EvaluationType | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, commentsEnabled?: boolean | null, selectOptions?: Array<string | null> | null } | null } | null> | null, responsesForAssociate?: Array<{ id: string, answers: Array<{ id: string, orgFeedbackId: string, ratingAnswer?: number | null, yesNoAnswer?: number | null, singleSelectAnswer?: string | null, multiSelectAnswers?: Array<string> | null, freeText?: string | null, comment?: string | null }> }> | null } | null> | null } };

export type SubmitProgramEvaluationResponseForAssociateMutationVariables = Exact<{
  programId: Scalars['ID'];
  customProgramEvaluationId: Scalars['ID'];
  associateRecruitId: Scalars['ID'];
  attorneyUserId?: InputMaybe<Scalars['ID']>;
  answers: Array<ProgramEvaluationAnswerInput> | ProgramEvaluationAnswerInput;
}>;


export type SubmitProgramEvaluationResponseForAssociateMutation = { upsertIndividualProgramEvaluationResponse?: boolean | null };

export type ProgramAssociateExistsByEmployeeEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type ProgramAssociateExistsByEmployeeEmailQuery = { programAssociateByEmployeeEmail?: { email: string } | null };

export type UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables = Exact<{
  contributorsInput: UpdateProgramContributorsInput;
  permissionsInput: UpsertWorkAllocationPermissionsInput;
}>;


export type UpdateWorkAllocationProgramContributorsAndPermissionsMutation = { upsertWorkAllocationPermissions: number, updateWorkAllocationProgramContributors: { contributors: Array<{ accessLevel: ProgramContributorAccessLevel, member: { id: string, firstName: string, lastName: string } }> } };

export type UpdateWorkAllocationProgramContributorsMutationVariables = Exact<{
  programId: Scalars['ID'];
  contributors: Array<ProgramContributorInput> | ProgramContributorInput;
}>;


export type UpdateWorkAllocationProgramContributorsMutation = { updateWorkAllocationProgramContributors: { contributors: Array<{ accessLevel: ProgramContributorAccessLevel, member: { id: string, firstName: string, lastName: string } }> } };

export type MatterFragment = { assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, submittedStatus?: SubmissionStatus | null, workStatus?: MatterStatus | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null };

export type ProgramGroupFragment = { id: string, name: string, createdAt: string, updatedAt?: string | null, members: Array<{ id: string, firstName: string, lastName: string, email: string, details?: { jobTitle?: string | null } | null }>, associates: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> };

export type ProgramGroupContributorFragment = { id: string, firstName: string, lastName: string, email: string, details?: { jobTitle?: string | null } | null };

export type ProgramGroupAssociateFragment = { id: string, firstName?: string | null, lastName?: string | null, email?: string | null };

export type UpsertProgramGroupMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  programId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
}>;


export type UpsertProgramGroupMutation = { upsertProgramGroup: { group: { id: string, name: string, programId: string } } };

export type UpdateProgramGroupMembersMutationVariables = Exact<{
  groupId: Scalars['ID'];
  memberIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateProgramGroupMembersMutation = { updateProgramGroupMembers: { group: { id: string, name: string, createdAt: string, updatedAt?: string | null, members: Array<{ id: string, firstName: string, lastName: string, email: string, details?: { jobTitle?: string | null } | null }>, associates: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> } } };

export type UpdateProgramGroupAssociatesMutationVariables = Exact<{
  groupId: Scalars['ID'];
  associateIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdateProgramGroupAssociatesMutation = { updateProgramGroupAssociates: { group: { id: string, name: string, createdAt: string, updatedAt?: string | null, members: Array<{ id: string, firstName: string, lastName: string, email: string, details?: { jobTitle?: string | null } | null }>, associates: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> } } };

export type DeleteProgramGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProgramGroupMutation = { deleteProgramGroup: { deletedGroupId: string } };

export type ProgramGroupsQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type ProgramGroupsQuery = { programGroups: Array<{ id: string, name: string, createdAt: string, updatedAt?: string | null, members: Array<{ id: string, firstName: string, lastName: string, email: string, details?: { jobTitle?: string | null } | null }>, associates: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> }> };

export type ProgramGroupQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type ProgramGroupQuery = { programGroup?: { id: string, name: string, createdAt: string, updatedAt?: string | null, members: Array<{ id: string, firstName: string, lastName: string, email: string, details?: { jobTitle?: string | null } | null }>, associates: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> } | null };

export type DeleteWorkAllocationProgramMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWorkAllocationProgramMutation = { deleteWorkAllocationProgram?: boolean | null };

export type DeleteWorkAllocationProgramMatterMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteWorkAllocationProgramMatterMutation = { deleteWorkAllocationProgramMatter?: boolean | null };

export type UpsertWorkAllocationProgramEvaluationTemplateMutationVariables = Exact<{
  input: UpsertEvaluationTemplateOnProgramInput;
}>;


export type UpsertWorkAllocationProgramEvaluationTemplateMutation = { upsertWorkAllocationProgramEvaluationTemplate: boolean };

export type UupsertWorkAllocationProgramReminderEmailMutationVariables = Exact<{
  input: UpsertReminderEmailsOnProgramInput;
}>;


export type UupsertWorkAllocationProgramReminderEmailMutation = { upsertWorkAllocationProgramReminderEmail: boolean };

export type UpsertWorkAllocationProgramMutationVariables = Exact<{
  input: UpsertWorkAllocationProgramInput;
}>;


export type UpsertWorkAllocationProgramMutation = { upsertWorkAllocationProgram: number };

export type UpsertWorkAllocationProgramMatterMutationVariables = Exact<{
  programId: Scalars['ID'];
  input: UpsertWorkAllocationProgramMatterInput;
}>;


export type UpsertWorkAllocationProgramMatterMutation = { upsertWorkAllocationProgramMatter: number };

export type UpsertWorkAllocationProgramMatterByMemberMutationVariables = Exact<{
  programId: Scalars['ID'];
  input: UpsertWorkAllocationProgramMatterInput;
}>;


export type UpsertWorkAllocationProgramMatterByMemberMutation = { upsertWorkAllocationProgramMatterByMember: number };

export type UpsertWorkAllocationProgramMatterDocumentMutationVariables = Exact<{
  input: UploadMatterDocumentInput;
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type UpsertWorkAllocationProgramMatterDocumentMutation = { uploadMatterDocument: number };

export type DeleteMatterDocumentMutationVariables = Exact<{
  matterId: Scalars['ID'];
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteMatterDocumentMutation = { deleteMatterDocuments?: boolean | null };

export type UpdateMatterWorkStatusMutationVariables = Exact<{
  matterId: Scalars['ID'];
  status: MatterStatus;
}>;


export type UpdateMatterWorkStatusMutation = { updateMatterWorkStatus?: boolean | null };

export type UpsertMatterAssociateEvaluationMutationVariables = Exact<{
  matterId: Scalars['ID'];
  candidateId: Scalars['ID'];
  answers: Array<CandidateEvaluationAnswerInput> | CandidateEvaluationAnswerInput;
}>;


export type UpsertMatterAssociateEvaluationMutation = { upsertMatterAssociateEvaluation?: boolean | null };

export type UpsertWorkAllocationPermissionsMutationVariables = Exact<{
  input: UpsertWorkAllocationPermissionsInput;
}>;


export type UpsertWorkAllocationPermissionsMutation = { upsertWorkAllocationPermissions: number };

export type UpsertWorkAllocationEmailAlertsMutationVariables = Exact<{
  input: UpsertWorkAllocationEmailAlertsInput;
}>;


export type UpsertWorkAllocationEmailAlertsMutation = { upsertWorkAllocationEmailAlerts: number };

export type WorkAllocationMatterQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type WorkAllocationMatterQuery = { workAllocationMatter: { createdBy?: string | null, assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, submittedStatus?: SubmissionStatus | null, workStatus?: MatterStatus | null, createdAt?: string | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, linkedin?: string | null, authzReasons?: Array<WorkAllocationAuthorizationReason> | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, evaluations?: Array<{ id: string, recruitId?: string | null, userId: string, ratingAnswer?: number | null, yesNoAnswer?: number | null, singleSelectAnswer?: string | null, multiSelectAnswers?: Array<string | null> | null, freeText?: string | null, comment?: string | null, orgFeedbackId?: string | null, createdAt?: string | null } | null> | null, requestedProjectEvaluations?: Array<{ id: string, matterId: string, associateRecruitId: string, attorneyUserId: string, requestedAt?: string | null, submittedAt?: string | null } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, documentFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null } };

export type WorkAllocationMatterForTableRowConversionFragment = { id: string, clientMatterName: string, description?: string | null, clientMatterNumber: string, clientNumber: string, workStatus?: MatterStatus | null, workStatusUpdatedAt?: string | null, createdAt?: string | null, deadline?: string | null, timezone?: string | null, offices?: Array<{ name: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, assignees?: Array<{ firstName?: string | null, lastName?: string | null } | null> | null, attorneys?: Array<{ firstName: string, lastName: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null };

export type WorkAllocationMatterPracticeAreasFragment = { practiceAreas?: Array<{ id: string, name: string } | null> | null };

export type WorkAllocationMatterPracticeAreaFragment = { id: string, name: string };

export type WorkAllocationMatterOrgPracticeAreasFragment = { orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null };

export type WorkAllocationMatterOrgPracticeAreaFragment = { id: string, firmSpecificName: string };

export type WorkAllocationMattersByProgramQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationMattersByProgramQuery = { workAllocationMattersByProgram: Array<{ assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, submittedStatus?: SubmissionStatus | null, workStatus?: MatterStatus | null, createdBy?: string | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null }> };

export type WorkAllocationProgramQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationProgramQuery = { workAllocationProgram: { description?: string | null, endDate?: string | null, startDate?: string | null, id: string, attorneyFeedbackReminderEmailEnabled?: boolean | null, allowSummerAssociatesToCreateEditProjects?: boolean | null, allowSummerAssociatesToDeleteProjects?: boolean | null, allowSummerAssociatesToSelfAssignProjects?: boolean | null, emailSummerAssociateWhenAssignedToProject?: boolean | null, emailAdminWhenAttorneyCreatesProject?: boolean | null, emailAdminWhenSummerAssociateCreatesProject?: boolean | null, emailAdminWhenSummerAssociateIsAssignedToProject?: boolean | null, emailAdminWhenSummerAssociateDeletesProject?: boolean | null, emailAdminWhenSummerAssociateIsRemovedFromProject?: boolean | null, emailAdminWhenFeedbackSubmitted?: boolean | null, emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: boolean | null, emailAssignedAttorneysWhenAssociateAssignedToProject?: boolean | null, emailAssignedAttorneysWhenAssociateIsRemovedFromProject?: boolean | null, emailAssignedAttorneysWhenAssociateDeletesProject?: boolean | null, emailContributorWhenAttorneyCreatesProject: boolean, emailContributorWhenAssociateCreatesProject: boolean, emailContributorWhenAssociateDeletesProject: boolean, emailContributorWhenAssociateIsRemovedFromProject: boolean, timezone?: string | null, title?: string | null, programAssociates?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null } | null> | null, ownerUser?: { id?: number | null, admin?: boolean | null, fname?: string | null, lname?: string | null, email?: string | null } | null, emails?: Array<{ id: string, fromEmail: string, replyToEmail?: string | null, subject: string, body: string, bccEmail?: string | null, ccEmail?: string | null } | null> | null, evaluationQuestions?: Array<{ id: string, orgFeedbackId?: number | null, isRequired?: boolean | null, evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, evaluationType?: EvaluationType | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, commentsEnabled?: boolean | null, selectOptions?: Array<string | null> | null } | null } | null> | null, matters?: Array<{ authzReasons?: Array<WorkAllocationAuthorizationReason> | null, assignmentType?: AssignmentType | null, clientMatterName: string, clientMatterNumber: string, clientNumber: string, deadline?: string | null, timezone?: string | null, description?: string | null, id: string, org: string, submittedStatus?: SubmissionStatus | null, workStatus?: MatterStatus | null, workStatusUpdatedAt?: string | null, createdAt?: string | null, createdBy?: string | null, assignees?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, authzReasons?: Array<WorkAllocationAuthorizationReason> | null } | null> | null, attorneys?: Array<{ id: string, firstName: string, lastName: string, email: string } | null> | null, offices?: Array<{ id: string, name: string } | null> | null, practiceAreas?: Array<{ id: string, name: string } | null> | null, orgPracticeAreas?: Array<{ id: string, firmSpecificName: string } | null> | null, timeToComplete?: { unit: TimeToCompleteUnit, value: number } | null, documents?: Array<{ id: string, userFileName?: string | null, createdAt?: string | null, createdBy?: string | null, updatedBy?: string | null, updatedAt?: string | null }> | null, requestedProjectEvaluations?: Array<{ id: string, matterId: string, associateRecruitId: string, attorneyUserId: string, requestedAt?: string | null, submittedAt?: string | null } | null> | null, evaluations?: Array<{ id: string, orgFeedbackId?: string | null, recruitId?: string | null, userId: string, ratingAnswer?: number | null, yesNoAnswer?: number | null, singleSelectAnswer?: string | null, multiSelectAnswers?: Array<string | null> | null, freeText?: string | null, comment?: string | null, createdAt?: string | null } | null> | null } | null> | null, customEvaluations?: Array<{ id: string, evaluationName: string, evaluationType: string, feedbackReminderEmailEnabled?: boolean | null, feedbackReminderEmailTemplateId?: string | null, questions?: Array<{ id: string, orgFeedbackId?: number | null, isRequired?: boolean | null, evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, evaluationType?: EvaluationType | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, commentsEnabled?: boolean | null, selectOptions?: Array<string | null> | null } | null } | null> | null, email?: { id: string, fromEmail: string, replyToEmail?: string | null, subject: string, body: string, bccEmail?: string | null, ccEmail?: string | null } | null } | null> | null, groups: Array<{ id: string, name: string, createdAt: string, updatedAt?: string | null, members: Array<{ id: string, firstName: string, lastName: string, email: string, details?: { jobTitle?: string | null } | null }>, associates: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> }> } };

export type WorkAllocationProgramTitleQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationProgramTitleQuery = { programTitle: string };

export type WorkAllocationProgramsQueryVariables = Exact<{
  programIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type WorkAllocationProgramsQuery = { workAllocationPrograms: Array<{ description?: string | null, endDate?: string | null, startDate?: string | null, id: string, allowSummerAssociatesToCreateEditProjects?: boolean | null, allowSummerAssociatesToDeleteProjects?: boolean | null, allowSummerAssociatesToSelfAssignProjects?: boolean | null, emailAdminWhenAttorneyCreatesProject?: boolean | null, emailAdminWhenSummerAssociateCreatesProject?: boolean | null, emailAdminWhenSummerAssociateIsAssignedToProject?: boolean | null, emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: boolean | null, emailSummerAssociateWhenAssignedToProject?: boolean | null, timezone?: string | null, title?: string | null, emails?: Array<{ id: string, fromEmail: string, replyToEmail?: string | null, subject: string, body: string, bccEmail?: string | null, ccEmail?: string | null } | null> | null, evaluationQuestions?: Array<{ id: string, orgFeedbackId?: number | null, isRequired?: boolean | null, evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, evaluationType?: EvaluationType | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, commentsEnabled?: boolean | null, selectOptions?: Array<string | null> | null } | null } | null> | null, ownerUser?: { id?: number | null, admin?: boolean | null, fname?: string | null, lname?: string | null, email?: string | null } | null }> };

export type WorkAllocationOrgProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkAllocationOrgProgramsQuery = { workAllocationOrgPrograms: Array<{ description?: string | null, endDate?: string | null, startDate?: string | null, id: string, allowSummerAssociatesToCreateEditProjects?: boolean | null, allowSummerAssociatesToDeleteProjects?: boolean | null, allowSummerAssociatesToSelfAssignProjects?: boolean | null, emailAdminWhenAttorneyCreatesProject?: boolean | null, emailAdminWhenSummerAssociateCreatesProject?: boolean | null, emailAdminWhenSummerAssociateIsAssignedToProject?: boolean | null, emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: boolean | null, emailSummerAssociateWhenAssignedToProject?: boolean | null, timezone?: string | null, title?: string | null, emails?: Array<{ id: string, fromEmail: string, replyToEmail?: string | null, subject: string, body: string, bccEmail?: string | null, ccEmail?: string | null } | null> | null, evaluationQuestions?: Array<{ id: string, orgFeedbackId?: number | null, isRequired?: boolean | null, evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, evaluationType?: EvaluationType | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, commentsEnabled?: boolean | null, selectOptions?: Array<string | null> | null } | null } | null> | null, ownerUser?: { id?: number | null, admin?: boolean | null, fname?: string | null, lname?: string | null, email?: string | null } | null }> };

export type WorkAllocationOrgProgramsForProgramsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkAllocationOrgProgramsForProgramsPageQuery = { workAllocationOrgPrograms: Array<{ description?: string | null, endDate?: string | null, startDate?: string | null, id: string, allowSummerAssociatesToCreateEditProjects?: boolean | null, allowSummerAssociatesToDeleteProjects?: boolean | null, allowSummerAssociatesToSelfAssignProjects?: boolean | null, emailAdminWhenAttorneyCreatesProject?: boolean | null, emailAdminWhenSummerAssociateCreatesProject?: boolean | null, emailAdminWhenSummerAssociateIsAssignedToProject?: boolean | null, emailAssignedAttorneysWhenDocumentsAreUploadedToProject?: boolean | null, emailSummerAssociateWhenAssignedToProject?: boolean | null, timezone?: string | null, title?: string | null, authzReasons?: Array<WorkAllocationAuthorizationReason> | null, evaluationQuestions?: Array<{ id: string, orgFeedbackId?: number | null, isRequired?: boolean | null, evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, evaluationType?: EvaluationType | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, commentsEnabled?: boolean | null, selectOptions?: Array<string | null> | null } | null } | null> | null, ownerUser?: { id?: number | null, admin?: boolean | null, fname?: string | null, lname?: string | null, email?: string | null } | null }> };

export type GetWorkAllocationProgramEvaluationsQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type GetWorkAllocationProgramEvaluationsQuery = { workAllocationProgram: { customEvaluations?: Array<{ id: string, evaluationName: string, evaluationType: string, feedbackReminderEmailEnabled?: boolean | null } | null> | null } };

export type WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables = Exact<{
  programId: Scalars['ID'];
  associateRecruitId: Scalars['ID'];
}>;


export type WorkAllocationProgramEvaluationsForAssociatePortalQuery = { workAllocationProgram: { customEvaluations?: Array<{ id: string, evaluationName: string, evaluationType: string, responsesForAssociate?: Array<{ requestedAt: string, completedAt?: string | null }> | null } | null> | null } };

export type WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables = Exact<{
  programId: Scalars['ID'];
  attorneyUserId: Scalars['ID'];
}>;


export type WorkAllocationProgramEvaluationsForAttorneyPortalQuery = { workAllocationProgram: { customEvaluations?: Array<{ id: string, evaluationName: string, evaluationType: string, responsesForAttorney?: Array<{ requestedAt: string, completedAt?: string | null, associateRecruitId: string, associate: { candidate: { firstName?: string | null, lastName?: string | null } } }> | null } | null> | null } };

export type WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationProjectEvaluationsDatesForAttorneyQuery = { workAllocationEvaluationsForAttorney?: { projectEvaluationResponses?: Array<{ matterId: string, associateRecruitId: string, requestedAt?: string | null, submittedAt?: string | null } | null> | null } | null };

export type WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery = { workAllocationProgram: { customEvaluations?: Array<{ id: string, evaluationName: string, evaluationType: string, questions?: Array<{ id: string, orgFeedbackId?: number | null, isRequired?: boolean | null, evaluationQuestion?: { id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, evaluationType?: EvaluationType | null, lowScale?: number | null, highScale?: number | null, lowLabel?: string | null, highLabel?: string | null, commentsEnabled?: boolean | null, selectOptions?: Array<string | null> | null } | null } | null> | null, responses?: Array<{ id: string, attorneyUserId?: string | null, associateRecruitId: string, associate: { candidate: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null } }, answers: Array<{ id: string, orgFeedbackId: string, ratingAnswer?: number | null, yesNoAnswer?: number | null, singleSelectAnswer?: string | null, multiSelectAnswers?: Array<string> | null, freeText?: string | null, comment?: string | null }> }> | null } | null> | null } };

export type UserWorkAllocationPermissionsQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type UserWorkAllocationPermissionsQuery = { userWorkAllocationPermissions?: { programId: string, permissions?: Array<WorkAllocationPermission | null> | null } | null };

export type RemoveAssociatesFromWorkAllocationProgramMutationVariables = Exact<{
  programId: Scalars['ID'];
  associateIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveAssociatesFromWorkAllocationProgramMutation = { removeAssociatesFromWorkAllocationProgram?: boolean | null };

export type RemoveAssociatesFromWorkAllocationMatterMutationVariables = Exact<{
  matterId: Scalars['ID'];
  associateIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type RemoveAssociatesFromWorkAllocationMatterMutation = { removeAssociatesFromWorkAllocationMatter?: boolean | null };

export type SubmitProgramEvaluationResponseForAttorneyMutationVariables = Exact<{
  programId: Scalars['ID'];
  customProgramEvaluationId: Scalars['ID'];
  associateRecruitId: Scalars['ID'];
  attorneyUserId: Scalars['ID'];
  answers: Array<ProgramEvaluationAnswerInput> | ProgramEvaluationAnswerInput;
}>;


export type SubmitProgramEvaluationResponseForAttorneyMutation = { upsertIndividualProgramEvaluationResponse?: boolean | null };

export type DeleteEvaluationQuestionMutationVariables = Exact<{
  questionId: Scalars['ID'];
}>;


export type DeleteEvaluationQuestionMutation = { deleteEvaluationQuestion?: boolean | null };

export type UpsertEvaluationQuestionMutationVariables = Exact<{
  input: EvaluationQuestionInput;
}>;


export type UpsertEvaluationQuestionMutation = { upsertEvaluationQuestion: string };

export type OrgWorkAllocationEvaluationTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgWorkAllocationEvaluationTemplatesQuery = { getOrg?: { evaluationQuestionTemplates?: Array<{ id: string, evaluationType?: EvaluationType | null, title?: string | null, createdAt?: string | null, updatedAt?: string | null, questions?: Array<{ id: string, label?: string | null, subtext?: string | null, type?: FeedbackQuestionType | null, selectOptions?: Array<string | null> | null, commentsEnabled?: boolean | null, isRequired: boolean } | null> | null } | null> | null } | {} | null };

export type UpsertWorkAllocationEvaluationTemplateMutationVariables = Exact<{
  input: EvaluationQuestionTemplateInput;
}>;


export type UpsertWorkAllocationEvaluationTemplateMutation = { upsertEvaluationQuestionTemplate?: number | null };

export type DeleteWorkAllocationEvaluationTemplateMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteWorkAllocationEvaluationTemplateMutation = { deleteEvaluationQuestionTemplate?: number | null };

export type UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables = Exact<{
  input: UpsertCustomEvaluationTemplateOnProgramInput;
}>;


export type UpsertWorkAllocationCustomProgramEvaluationTemplatesMutation = { upsertWorkAllocationCustomProgramEvaluationTemplates: boolean };

export type UpdateMatterPetMutationVariables = Exact<{
  petName: Scalars['String'];
  matterId: Scalars['ID'];
}>;


export type UpdateMatterPetMutation = { updateMatterPet?: string | null };

export type MatterPetQueryVariables = Exact<{
  matterId: Scalars['ID'];
}>;


export type MatterPetQuery = { matterPet?: { id: string, matterId?: number | null, petName: string } | null };

export type GetSavedEvaluationQuestionTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedEvaluationQuestionTemplatesQuery = { getSavedEvaluationQuestionTemplatesForOrg: Array<{ id: string, evaluationType?: EvaluationType | null, title?: string | null, createdAt?: string | null, updatedAt?: string | null, questions?: Array<{ id: string, label?: string | null } | null> | null } | null> };

export type SendBulkProjectEvaluationRequestEmailsMutationVariables = Exact<{
  programId: Scalars['ID'];
  projectIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SendBulkProjectEvaluationRequestEmailsMutation = { sendBulkProjectEvaluationRequestEmails: Array<number> };

export type IsProjectEvaluationEmailEnabledQueryVariables = Exact<{
  programId: Scalars['ID'];
}>;


export type IsProjectEvaluationEmailEnabledQuery = { workAllocationProgram: { attorneyFeedbackReminderEmailEnabled?: boolean | null } };

export const EventRegistrationModalDemographicInfoMyPotentialProfileFieldsFragmentDoc = `
    fragment EventRegistrationModalDemographicInfoMyPotentialProfileFields on RecruitEventProfileConnection {
  nodes {
    recruitId
    demographicInfo {
      fixedGenderNames
      writeYourOwnGenderName
      ethnicityNames
    }
  }
}
    `;
export const EventRegistrationModalDocumentFieldsFragmentDoc = `
    fragment EventRegistrationModalDocumentFields on EventDocumentAssignmentConnection {
  totalCount
  nodes {
    isRequired
    uploadRequestType
    assignedDocument {
      id
      name
      myMostRecentSubmissions {
        nodes {
          recruitId
        }
      }
    }
  }
}
    `;
export const EventRegistrationModalDocumentSubmissionMyPotentialProfileFieldsFragmentDoc = `
    fragment EventRegistrationModalDocumentSubmissionMyPotentialProfileFields on RecruitEventProfileConnection {
  nodes {
    recruitId
  }
}
    `;
export const EventRegistrationModalPersonalInfoMyPotentialProfileFieldsFragmentDoc = `
    fragment EventRegistrationModalPersonalInfoMyPotentialProfileFields on RecruitEventProfileConnection {
  nodes {
    recruitId
    email
    personalInfo {
      firstName
      lastName
      phoneNumber
      linkedInUrl
    }
  }
}
    `;
export const EventRegistrationModalQualifyingQuestionFieldsFragmentDoc = `
    fragment EventRegistrationModalQualifyingQuestionFields on QualifyingQuestionEventAssignmentConnection {
  nodes {
    order
    question {
      id
      name
      type
      distinguishedType
      presets {
        nodes {
          id
          name
        }
      }
      myAnswers {
        nodes {
          recruitId
          answerString
        }
      }
    }
  }
}
    `;
export const EventRegistrationModalQualifyingQuestionsMyPotentialProfileFieldsFragmentDoc = `
    fragment EventRegistrationModalQualifyingQuestionsMyPotentialProfileFields on RecruitEventProfileConnection {
  nodes {
    recruitId
  }
}
    `;
export const EventRegistrationModalSubmitHeadshotMyPotentialProfileFieldsFragmentDoc = `
    fragment EventRegistrationModalSubmitHeadshotMyPotentialProfileFields on RecruitEventProfileConnection {
  nodes {
    recruitId
    headshotUrl
    personalInfo {
      firstName
      lastName
    }
  }
}
    `;
export const ForwardProfileFormFragmentDoc = `
    fragment ForwardProfileForm on ForwardProfileNode {
  firstName
  lastName
  rawPhoneNumber
  phoneNumber
  rawLinkedInUrl
  linkedInUrl
}
    `;
export const ForwardProfileFragmentDoc = `
    fragment ForwardProfile on ForwardProfileNode {
  id
  ...ForwardProfileForm
  profilePhotoUrl
  lawDegree {
    graduationDate
    degreeType
    lawSchool {
      id
      name
    }
    classification
    gpa
  }
}
    `;
export const FirmProfileLinkInfoFragmentDoc = `
    fragment FirmProfileLinkInfo on PublicOrgInfo {
  id
  urlFriendlyName
  name
  hasPublicFirmProfile
}
    `;
export const ForwardDashboardOrgInfoFragmentDoc = `
    fragment ForwardDashboardOrgInfo on PublicOrgInfo {
  logoUrl
  forwardTier {
    asEnum
  }
  ...FirmProfileLinkInfo
}
    `;
export const FirmEventCardHostFieldsFragmentDoc = `
    fragment FirmEventCardHostFields on CandidateEventNode {
  host {
    id
    urlFriendlyName
    forwardTier {
      asEnum
    }
    name
    logoUrl
    hasPublicFirmProfile
    isFloCustomer
  }
}
    `;
export const FirmEventCardRegistrationButtonFieldsFragmentDoc = `
    fragment FirmEventCardRegistrationButtonFields on CandidateEventNode {
  __typename
  ... on CandidatePhysicalEventNode {
    myPotentialProfiles {
      nodes {
        isRegistered
      }
    }
  }
  ... on CandidateWebinarEventNode {
    myPotentialProfiles {
      nodes {
        isRegistered
      }
    }
  }
  ... on CandidateVirtualChatEventNode {
    areAllTimeslotsFull
    myPotentialProfiles {
      nodes {
        isRegistered
        timeslotChoices {
          totalCount
        }
      }
    }
  }
}
    `;
export const FirmEventCardFieldsFragmentDoc = `
    fragment FirmEventCardFields on CandidateEventNode {
  __typename
  id
  name
  start {
    date
    time
    zone
  }
  end {
    date
    time
    zone
  }
  ... on CandidatePhysicalEventNode {
    location
    description
    university
    registrationEnds {
      date
      time
      zone
    }
  }
  ... on CandidateWebinarEventNode {
    description
    university
    registrationEnds {
      date
      time
      zone
    }
  }
  ... on CandidateVirtualChatEventNode {
    description
    university
    registrationEnds {
      date
      time
      zone
    }
  }
  ...FirmEventCardHostFields
  ...FirmEventCardRegistrationButtonFields
}
    `;
export const FirmProfilePreviewFieldsFragmentDoc = `
    fragment FirmProfilePreviewFields on PublicOrgInfo {
  name
  orgId
  isFloCustomer
  logoUrl
  urlFriendlyName
  hasPublicFirmProfile
  officeLocations {
    nodes {
      name
    }
  }
  forwardTier {
    asEnum
  }
  firmProfile {
    revenueDollars
    profitsPerPartnerDollars
    numAssociates
    numPartners
    numCounsels
    bioTextContent(numChars: $numChars)
    bannerImageSrc
  }
}
    `;
export const FirmProfileSocialMediaLinksFieldsFragmentDoc = `
    fragment FirmProfileSocialMediaLinksFields on FirmProfileSocialMediaLinks {
  twitterUrl
  youtubeUrl
  facebookUrl
  instagramUrl
  linkedInUrl
}
    `;
export const RichMediaFragmentDoc = `
    fragment RichMedia on RichMediaSubsection {
  section
  title
  blurb
  richMedia {
    firmProfileSection
    order
    firmProfileRichMediaType
    firmProfileRichMediaData {
      mediaLink
      mediaTitle
      mediaLinkText
      mediaThumbnailLink
    }
  }
}
    `;
export const DiscoveryJobCardFieldsFragmentDoc = `
    fragment DiscoveryJobCardFields on JobFeedNode {
  ... on JobNode {
    __typename
    id
    orgId
    title
    employer {
      id
      name
      logoUrl
      urlFriendlyName
      forwardTier {
        asEnum
      }
      isFloCustomer
      hasPublicFirmProfile
    }
    descriptionTextContent(numChars: $descriptionTextContentNumChars)
    openDate {
      date
      time
      zone
    }
    closeDate {
      date
      time
      zone
    }
    sourceLink
    offices {
      nodes {
        name
        id
      }
    }
  }
  ... on ExternalJobNode {
    practiceCategories {
      nodes {
        name
        id
      }
    }
    salaryInfo {
      amount
      timeUnit
    }
  }
  ... on AtsJobNode {
    extension
  }
}
    `;
export const MyForwardEducationHistoryEntryFormFieldsFragmentDoc = `
    fragment MyForwardEducationHistoryEntryFormFields on CandidateEducationHistoryEntryNode {
  __typename
  degreeId
  schoolId
  startDate
  endDate
  gpa
  description
  ... on CandidateEducationHistoryLawSchoolEntryNode {
    classYear
  }
}
    `;
export const MyForwardEducationHistoryEntryFragmentDoc = `
    fragment MyForwardEducationHistoryEntry on CandidateEducationHistoryEntryNode {
  id
  candidateId
  degree {
    id
    name
  }
  school {
    id
    name
  }
  ...MyForwardEducationHistoryEntryFormFields
}
    `;
export const MyForwardWorkHistoryEntryFormFieldsFragmentDoc = `
    fragment MyForwardWorkHistoryEntryFormFields on CandidateWorkHistoryEntryNode {
  jobTitle
  workplaceName
  coreWorkplace {
    connectedOrg {
      logoUrl
    }
  }
  startDate
  endDate
  isCurrentJob
  workArrangement
  description
  officeLocationId
  practiceAreaIds
}
    `;
export const MyForwardWorkHistoryEntryFragmentDoc = `
    fragment MyForwardWorkHistoryEntry on CandidateWorkHistoryEntryNode {
  id
  candidateId
  practiceAreas {
    nodes {
      id
      name
    }
  }
  officeLocation {
    id
    name
  }
  ...MyForwardWorkHistoryEntryFormFields
}
    `;
export const EmployerAttendeesFragmentDoc = `
    fragment EmployerAttendees on InterviewSchedulingEventAttendeeNode {
  employerOrgId
  employerEventId
  employerOrgName
  registrationContactFirstName
  registrationContactLastName
  registrationContactEmail
  numberOfJobsSubmitted
}
    `;
export const DateTimeZoneFragmentDoc = `
    fragment DateTimeZone on DateTimeZone {
  date
  time
  zone
}
    `;
export const LotteryEventTimelineFragmentFragmentDoc = `
    fragment LotteryEventTimelineFragment on LotteryEventTimelineNode {
  id
  studentBidding {
    reviewPeriodStartDate {
      ...DateTimeZone
    }
    biddingStartDate {
      ...DateTimeZone
    }
    biddingDeadline {
      ...DateTimeZone
    }
    lotteryResultsVisibleToStudents {
      ...DateTimeZone
    }
    maxNumberOfBids
    maxNumberOfInterviews
  }
  studentCancellation {
    studentCancellationStartDate {
      ...DateTimeZone
    }
    studentCancellationEndDate {
      ...DateTimeZone
    }
  }
  studentOptIn {
    studentOptInStartDate {
      ...DateTimeZone
    }
    studentOptInEndDate {
      ...DateTimeZone
    }
  }
  scheduleVisibility {
    employerFinalScheduleDate {
      ...DateTimeZone
    }
    studentFinalScheduleDate {
      ...DateTimeZone
    }
  }
  studentSelfSchedule {
    studentSelfScheduleStartDate {
      ...DateTimeZone
    }
    studentSelfScheduleEndDate {
      ...DateTimeZone
    }
  }
  studentCancellationEnabled
  studentOptInEnabled
  eventPeriods {
    studentBiddingPeriod
    studentCancellationPeriod
    studentOptInPeriod
    studentMatchReviewPeriod
    studentFinalSchedulePeriod
    studentSelfSchedulePeriod
  }
}
    `;
export const JobFieldsFragmentDoc = `
    fragment jobFields on InterviewSchedulingJobNode {
  id
  orgId
  employer {
    forwardTier {
      asEnum
    }
    isFloCustomer
    urlFriendlyName
    logoUrl
    name
  }
  title
  descriptionTextContent
  offices {
    nodes {
      id
      name
    }
  }
  scheduleId
  supportingDocuments {
    id
    orgDocumentId
    documentName
    isRequired
  }
  practiceAreas {
    nodes {
      id
      name
    }
  }
}
    `;
export const EventStepperStatusFragmentDoc = `
    fragment EventStepperStatus on InterviewSchedulingEventCreationStepperStatusNode {
  id
  eventDetails
  timeBlocks
  timeline
  employerSettings
  emails
}
    `;
export const LotteryEventDetailsFragmentDoc = `
    fragment LotteryEventDetails on LotteryEventDetailsNode {
  id
  employerEventDescription
  studentEventDescription
  eventOrganizerUserId
}
    `;
export const LotteryEventTimeBlocksFragmentDoc = `
    fragment LotteryEventTimeBlocks on LotteryEventTimeBlockNode {
  id
  date
  startTime
  endTime
  timezone
  breakOption
  breakLengthMinutes
  interviewLength
  numberOfInterviews
  numberOfInterviews
  customBreaks {
    startTime
    breakLengthMinutes
    breakPosition
  }
}
    `;
export const DateTimeZonePartsFragmentDoc = `
    fragment DateTimeZoneParts on DateTimeZone {
  date
  time
  zone
}
    `;
export const LotteryEventTimelineFragmentDoc = `
    fragment LotteryEventTimeline on LotteryEventTimelineNode {
  id
  employerRegistrationDates {
    registrationStartDate {
      ...DateTimeZoneParts
    }
    registrationDeadline {
      ...DateTimeZoneParts
    }
  }
  studentBidding {
    reviewPeriodStartDate {
      ...DateTimeZoneParts
    }
    biddingStartDate {
      ...DateTimeZoneParts
    }
    biddingDeadline {
      ...DateTimeZoneParts
    }
    lotteryResultsVisibleToStudents {
      ...DateTimeZoneParts
    }
    maxNumberOfBids
    maxNumberOfInterviews
  }
  studentCancellation {
    studentCancellationStartDate {
      ...DateTimeZoneParts
    }
    studentCancellationEndDate {
      ...DateTimeZoneParts
    }
  }
  studentOptIn {
    studentOptInStartDate {
      ...DateTimeZoneParts
    }
    studentOptInEndDate {
      ...DateTimeZoneParts
    }
  }
  studentSelfSchedule {
    studentSelfScheduleStartDate {
      ...DateTimeZoneParts
    }
    studentSelfScheduleEndDate {
      ...DateTimeZoneParts
    }
  }
  scheduleVisibility {
    employerFinalScheduleDate {
      ...DateTimeZoneParts
    }
    studentFinalScheduleDate {
      ...DateTimeZoneParts
    }
  }
  studentCancellationEnabled
  studentOptInEnabled
  studentSelfScheduleEnabled
  eventPeriods {
    studentBiddingPeriod
    studentCancellationPeriod
    studentSelfSchedulePeriod
    employerMatchReviewPeriod
  }
}
    `;
export const LotteryEmployerCustomQuestionFragmentDoc = `
    fragment LotteryEmployerCustomQuestion on LotteryEmployerCustomQuestionNode {
  eventQuestionId
  orgQuestionId
  questionType
  label
  subText
  required
}
    `;
export const LotteryEmployerRegistrationSettingsFragmentDoc = `
    fragment LotteryEmployerRegistrationSettings on LotteryEmployerRegistrationSettingsNode {
  numberOfDateChoices
  multipleDatesEnabled
  selectPreferredTimeEnabled
  selectInterviewFormatEnabled
  selectPreferredInterviewLengthEnabled
  provideVideoLinkEnabled
  studentInterviewOptionsEnabled
  supplyJobInformationEnabled
  supplyInterviewInformationEnabled
  eventUniversityRecruitmentPolicyEnabled
  allowEmployerToSelectMultipleTimeBlocks
  allowEmployersToCreateDocumentCollectJobs
  hasDocumentCollectJobsCreated
  supportingDocuments {
    id
    orgDocumentId
    eventDocumentId
    documentName
    documentVisibilityOption
    documentVisibilityTime {
      date
      time
      zone
    }
    isRequired
  }
}
    `;
export const FullMemberInfoFragmentDoc = `
    fragment fullMemberInfo on MemberNode {
  id
  firstName
  lastName
  email
  isAdmin
  details {
    jobTitle
    officeLocation {
      name
    }
    practiceArea {
      name
    }
    lawSchool {
      name
    }
    workArrangement
    bioLink
  }
  ownedPrograms {
    id
    title
  }
  authInfo {
    isMfaUser
    ssoUserId
  }
}
    `;
export const ContractorFragmentFragmentDoc = `
    fragment contractorFragment on EmployerOrgNode {
  isGovernmentContractor
}
    `;
export const SuperAdminCloseJobsJobFieldsFragmentDoc = `
    fragment SuperAdminCloseJobsJobFields on JobNode {
  __typename
  id
  orgId
  employer {
    name
  }
  openDate {
    date
    time
    zone
  }
  title
  descriptionTextContent(numChars: 300)
}
    `;
export const SelfIdDefaultFragmentDoc = `
    fragment SelfIdDefault on SelfIdDefaultNode {
  id
  label
  name
  type
  questionType
}
    `;
export const SelfIdDefaultOptionFragmentDoc = `
    fragment SelfIdDefaultOption on SelfIdDefaultOptionNode {
  id
  selfIdDefaultId
  name
}
    `;
export const SuperAdminFirmProfileDiversityStatisticFragmentDoc = `
    fragment SuperAdminFirmProfileDiversityStatistic on FirmProfileDiversityStatisticNode {
  id
  orgId
  firmProfileId
  selfIdDefaultOptionId
  numCounsels
  numPartners
  numAssociates
  numSummerAssociates
}
    `;
export const SuperAdminFirmProfileRichMediaSubsectionFragmentDoc = `
    fragment SuperAdminFirmProfileRichMediaSubsection on RichMediaSubsection {
  title
  blurb
  richMedia {
    id
    order
    firmProfileRichMediaType
    firmProfileRichMediaData {
      mediaTitle
      mediaThumbnailLink
      mediaLink
      mediaLinkText
    }
  }
}
    `;
export const SuperAdminExternalJobImportCsvRowFragmentDoc = `
    fragment SuperAdminExternalJobImportCsvRow on ExternalJobImportNode {
  firmName
  jobTitle
  officeLocations
  description
  programLength
  applicationsOpenDate
  applicationsCloseDate
  salary
  requiredDocuments
  applicationUrl
}
    `;
export const SuperAdminListManagementWorkplaceFragmentDoc = `
    fragment SuperAdminListManagementWorkplace on WorkplaceNode {
  id
  name
  isArchived
  connectedOrg {
    id
    name
    logoUrl
  }
}
    `;
export const SuperAdminAtsJobFragmentDoc = `
    fragment SuperAdminAtsJob on AtsJobNode {
  id
  orgId
  employer {
    name
    logoUrl
  }
  title
  description
  openDate {
    date
    time
    zone
  }
  closeDate {
    date
    time
    zone
  }
  offices {
    nodes {
      id
      name
    }
  }
  requiredDocuments {
    id
    name
  }
  is1L
  is2L
  hasJobBoardAudienceSet
}
    `;
export const SuperAdminGetFirmPracticeAreasFieldsFragmentDoc = `
    fragment SuperAdminGetFirmPracticeAreasFields on OrgPracticeAreaNode {
  id
  firmSpecificName
  offices {
    nodes {
      id
      officeLocation {
        name
      }
    }
  }
}
    `;
export const RegisteredMemberDetailsFragmentDoc = `
    fragment RegisteredMemberDetails on EmployerEventNode {
  registeredMembers {
    id
    email
    fname
    lname
    feedback {
      id
    }
  }
}
    `;
export const ProgramDetailsFragmentDoc = `
    fragment ProgramDetails on ProgramNode {
  id
  title
  description
  startDate
  endDate
  timezone
  ownerUser {
    id
    fname
    lname
  }
}
    `;
export const ProgramContributorFragmentDoc = `
    fragment ProgramContributor on ProgramContributorEdge {
  member {
    id
    firstName
    lastName
    email
  }
  accessLevel
}
    `;
export const ProgramPermissionsFragmentDoc = `
    fragment ProgramPermissions on ProgramNode {
  allowSummerAssociatesToCreateEditProjects
  allowSummerAssociatesToDeleteProjects
  allowSummerAssociatesToSelfAssignProjects
}
    `;
export const ProgramEmailAlertsFragmentDoc = `
    fragment ProgramEmailAlerts on ProgramNode {
  emailSummerAssociateWhenAssignedToProject
  emailAdminWhenAttorneyCreatesProject
  emailAdminWhenSummerAssociateCreatesProject
  emailAdminWhenSummerAssociateIsAssignedToProject
  emailAdminWhenSummerAssociateDeletesProject
  emailAdminWhenSummerAssociateIsRemovedFromProject
  emailAdminWhenFeedbackSubmitted
  emailAssignedAttorneysWhenDocumentsAreUploadedToProject
  emailAssignedAttorneysWhenAssociateAssignedToProject
  emailAssignedAttorneysWhenAssociateIsRemovedFromProject
  emailAssignedAttorneysWhenAssociateDeletesProject
  emailContributorWhenAttorneyCreatesProject
  emailContributorWhenAssociateCreatesProject
  emailContributorWhenAssociateDeletesProject
  emailContributorWhenAssociateIsRemovedFromProject
}
    `;
export const MatterFragmentDoc = `
    fragment Matter on MatterNode {
  assignees {
    id
    firstName
    lastName
    email
  }
  assignmentType
  attorneys {
    id
    firstName
    lastName
    email
  }
  clientMatterName
  clientMatterNumber
  clientNumber
  deadline
  timezone
  description
  id
  offices {
    id
    name
  }
  org
  practiceAreas {
    id
    name
  }
  submittedStatus
  timeToComplete {
    unit
    value
  }
  workStatus
  documents {
    id
    userFileName
    createdAt
    createdBy
    updatedBy
    updatedAt
  }
}
    `;
export const ProgramGroupContributorFragmentDoc = `
    fragment ProgramGroupContributor on MemberNode {
  id
  firstName
  lastName
  email
  details {
    jobTitle
  }
}
    `;
export const ProgramGroupFragmentDoc = `
    fragment ProgramGroup on ProgramGroupNode {
  id
  name
  members {
    ...ProgramGroupContributor
  }
  associates {
    id
    firstName
    lastName
    email
  }
  createdAt
  updatedAt
}
    `;
export const ProgramGroupAssociateFragmentDoc = `
    fragment ProgramGroupAssociate on CandidateNode {
  id
  firstName
  lastName
  email
}
    `;
export const WorkAllocationMatterPracticeAreaFragmentDoc = `
    fragment WorkAllocationMatterPracticeArea on PracticeAreaNode {
  id
  name
}
    `;
export const WorkAllocationMatterPracticeAreasFragmentDoc = `
    fragment WorkAllocationMatterPracticeAreas on MatterNode {
  practiceAreas {
    ...WorkAllocationMatterPracticeArea
  }
}
    `;
export const WorkAllocationMatterOrgPracticeAreaFragmentDoc = `
    fragment WorkAllocationMatterOrgPracticeArea on OrgPracticeAreaNode {
  id
  firmSpecificName
}
    `;
export const WorkAllocationMatterOrgPracticeAreasFragmentDoc = `
    fragment WorkAllocationMatterOrgPracticeAreas on MatterNode {
  orgPracticeAreas {
    ...WorkAllocationMatterOrgPracticeArea
  }
}
    `;
export const WorkAllocationMatterForTableRowConversionFragmentDoc = `
    fragment WorkAllocationMatterForTableRowConversion on MatterNode {
  id
  clientMatterName
  description
  clientMatterNumber
  clientNumber
  workStatus
  workStatusUpdatedAt
  offices {
    name
  }
  ...WorkAllocationMatterPracticeAreas
  ...WorkAllocationMatterOrgPracticeAreas
  createdAt
  deadline
  timezone
  timeToComplete {
    unit
    value
  }
  assignees {
    firstName
    lastName
  }
  attorneys {
    firstName
    lastName
  }
}
    `;
export const UpdateAgencyRegistrationStatusDocument = `
    mutation UpdateAgencyRegistrationStatus($agencyId: ID!, $isUnregisteredAgency: Boolean!) {
  updateAgencyRegistrationStatus(
    agencyId: $agencyId
    isUnregisteredAgency: $isUnregisteredAgency
  )
}
    `;
export const useUpdateAgencyRegistrationStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAgencyRegistrationStatusMutation, TError, UpdateAgencyRegistrationStatusMutationVariables, TContext>) =>
    useMutation<UpdateAgencyRegistrationStatusMutation, TError, UpdateAgencyRegistrationStatusMutationVariables, TContext>(
      ['UpdateAgencyRegistrationStatus'],
      (variables?: UpdateAgencyRegistrationStatusMutationVariables) => fetcher<UpdateAgencyRegistrationStatusMutation, UpdateAgencyRegistrationStatusMutationVariables>(UpdateAgencyRegistrationStatusDocument, variables)(),
      options
    );
useUpdateAgencyRegistrationStatusMutation.fetcher = (variables: UpdateAgencyRegistrationStatusMutationVariables) => fetcher<UpdateAgencyRegistrationStatusMutation, UpdateAgencyRegistrationStatusMutationVariables>(UpdateAgencyRegistrationStatusDocument, variables);
export const FindAgencyByLoggedInUserEmailDocument = `
    query FindAgencyByLoggedInUserEmail {
  findAgencyByLoggedInUserEmail {
    isUnregisteredAgency
  }
}
    `;
export const useFindAgencyByLoggedInUserEmailQuery = <
      TData = FindAgencyByLoggedInUserEmailQuery,
      TError = unknown
    >(
      variables?: FindAgencyByLoggedInUserEmailQueryVariables,
      options?: UseQueryOptions<FindAgencyByLoggedInUserEmailQuery, TError, TData>
    ) =>
    useQuery<FindAgencyByLoggedInUserEmailQuery, TError, TData>(
      variables === undefined ? ['FindAgencyByLoggedInUserEmail'] : ['FindAgencyByLoggedInUserEmail', variables],
      fetcher<FindAgencyByLoggedInUserEmailQuery, FindAgencyByLoggedInUserEmailQueryVariables>(FindAgencyByLoggedInUserEmailDocument, variables),
      options
    );

useFindAgencyByLoggedInUserEmailQuery.getKey = (variables?: FindAgencyByLoggedInUserEmailQueryVariables) => variables === undefined ? ['FindAgencyByLoggedInUserEmail'] : ['FindAgencyByLoggedInUserEmail', variables];
;

export const useInfiniteFindAgencyByLoggedInUserEmailQuery = <
      TData = FindAgencyByLoggedInUserEmailQuery,
      TError = unknown
    >(
      pageParamKey: keyof FindAgencyByLoggedInUserEmailQueryVariables,
      variables?: FindAgencyByLoggedInUserEmailQueryVariables,
      options?: UseInfiniteQueryOptions<FindAgencyByLoggedInUserEmailQuery, TError, TData>
    ) =>
    useInfiniteQuery<FindAgencyByLoggedInUserEmailQuery, TError, TData>(
      variables === undefined ? ['FindAgencyByLoggedInUserEmail.infinite'] : ['FindAgencyByLoggedInUserEmail.infinite', variables],
      (metaData) => fetcher<FindAgencyByLoggedInUserEmailQuery, FindAgencyByLoggedInUserEmailQueryVariables>(FindAgencyByLoggedInUserEmailDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFindAgencyByLoggedInUserEmailQuery.getKey = (variables?: FindAgencyByLoggedInUserEmailQueryVariables) => variables === undefined ? ['FindAgencyByLoggedInUserEmail.infinite'] : ['FindAgencyByLoggedInUserEmail.infinite', variables];
;

useFindAgencyByLoggedInUserEmailQuery.fetcher = (variables?: FindAgencyByLoggedInUserEmailQueryVariables) => fetcher<FindAgencyByLoggedInUserEmailQuery, FindAgencyByLoggedInUserEmailQueryVariables>(FindAgencyByLoggedInUserEmailDocument, variables);
export const SendPasswordResetEmailDocument = `
    mutation SendPasswordResetEmail($input: SendPasswordResetEmailInput!) {
  sendPasswordResetEmail(input: $input)
}
    `;
export const useSendPasswordResetEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendPasswordResetEmailMutation, TError, SendPasswordResetEmailMutationVariables, TContext>) =>
    useMutation<SendPasswordResetEmailMutation, TError, SendPasswordResetEmailMutationVariables, TContext>(
      ['SendPasswordResetEmail'],
      (variables?: SendPasswordResetEmailMutationVariables) => fetcher<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, variables)(),
      options
    );
useSendPasswordResetEmailMutation.fetcher = (variables: SendPasswordResetEmailMutationVariables) => fetcher<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(SendPasswordResetEmailDocument, variables);
export const ResetUserPasswordDocument = `
    mutation ResetUserPassword($input: UpdateUserPasswordInput!) {
  resetUserPassword(input: $input) {
    success
    error
  }
}
    `;
export const useResetUserPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetUserPasswordMutation, TError, ResetUserPasswordMutationVariables, TContext>) =>
    useMutation<ResetUserPasswordMutation, TError, ResetUserPasswordMutationVariables, TContext>(
      ['ResetUserPassword'],
      (variables?: ResetUserPasswordMutationVariables) => fetcher<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, variables)(),
      options
    );
useResetUserPasswordMutation.fetcher = (variables: ResetUserPasswordMutationVariables) => fetcher<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, variables);
export const CandidatesToBeMergedDocument = `
    query CandidatesToBeMerged($recruitIds: [Int!]!) {
  getCandidates(recruitIds: $recruitIds) {
    id
    firstName
    lastName
    email
    jobApps {
      nodes {
        id
        job {
          title
        }
        appSource
        createdAt
        status {
          name
        }
      }
    }
  }
}
    `;
export const useCandidatesToBeMergedQuery = <
      TData = CandidatesToBeMergedQuery,
      TError = unknown
    >(
      variables: CandidatesToBeMergedQueryVariables,
      options?: UseQueryOptions<CandidatesToBeMergedQuery, TError, TData>
    ) =>
    useQuery<CandidatesToBeMergedQuery, TError, TData>(
      ['CandidatesToBeMerged', variables],
      fetcher<CandidatesToBeMergedQuery, CandidatesToBeMergedQueryVariables>(CandidatesToBeMergedDocument, variables),
      options
    );

useCandidatesToBeMergedQuery.getKey = (variables: CandidatesToBeMergedQueryVariables) => ['CandidatesToBeMerged', variables];
;

export const useInfiniteCandidatesToBeMergedQuery = <
      TData = CandidatesToBeMergedQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidatesToBeMergedQueryVariables,
      variables: CandidatesToBeMergedQueryVariables,
      options?: UseInfiniteQueryOptions<CandidatesToBeMergedQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidatesToBeMergedQuery, TError, TData>(
      ['CandidatesToBeMerged.infinite', variables],
      (metaData) => fetcher<CandidatesToBeMergedQuery, CandidatesToBeMergedQueryVariables>(CandidatesToBeMergedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidatesToBeMergedQuery.getKey = (variables: CandidatesToBeMergedQueryVariables) => ['CandidatesToBeMerged.infinite', variables];
;

useCandidatesToBeMergedQuery.fetcher = (variables: CandidatesToBeMergedQueryVariables) => fetcher<CandidatesToBeMergedQuery, CandidatesToBeMergedQueryVariables>(CandidatesToBeMergedDocument, variables);
export const MergeCandidatesDocument = `
    mutation MergeCandidates($input: CandidateMergeInput!) {
  mergeCandidates(input: $input)
}
    `;
export const useMergeCandidatesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MergeCandidatesMutation, TError, MergeCandidatesMutationVariables, TContext>) =>
    useMutation<MergeCandidatesMutation, TError, MergeCandidatesMutationVariables, TContext>(
      ['MergeCandidates'],
      (variables?: MergeCandidatesMutationVariables) => fetcher<MergeCandidatesMutation, MergeCandidatesMutationVariables>(MergeCandidatesDocument, variables)(),
      options
    );
useMergeCandidatesMutation.fetcher = (variables: MergeCandidatesMutationVariables) => fetcher<MergeCandidatesMutation, MergeCandidatesMutationVariables>(MergeCandidatesDocument, variables);
export const JobAppSourceOptionsDocument = `
    query JobAppSourceOptions {
  fetchAppSourceOptions {
    name
    label
  }
}
    `;
export const useJobAppSourceOptionsQuery = <
      TData = JobAppSourceOptionsQuery,
      TError = unknown
    >(
      variables?: JobAppSourceOptionsQueryVariables,
      options?: UseQueryOptions<JobAppSourceOptionsQuery, TError, TData>
    ) =>
    useQuery<JobAppSourceOptionsQuery, TError, TData>(
      variables === undefined ? ['JobAppSourceOptions'] : ['JobAppSourceOptions', variables],
      fetcher<JobAppSourceOptionsQuery, JobAppSourceOptionsQueryVariables>(JobAppSourceOptionsDocument, variables),
      options
    );

useJobAppSourceOptionsQuery.getKey = (variables?: JobAppSourceOptionsQueryVariables) => variables === undefined ? ['JobAppSourceOptions'] : ['JobAppSourceOptions', variables];
;

export const useInfiniteJobAppSourceOptionsQuery = <
      TData = JobAppSourceOptionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobAppSourceOptionsQueryVariables,
      variables?: JobAppSourceOptionsQueryVariables,
      options?: UseInfiniteQueryOptions<JobAppSourceOptionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobAppSourceOptionsQuery, TError, TData>(
      variables === undefined ? ['JobAppSourceOptions.infinite'] : ['JobAppSourceOptions.infinite', variables],
      (metaData) => fetcher<JobAppSourceOptionsQuery, JobAppSourceOptionsQueryVariables>(JobAppSourceOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobAppSourceOptionsQuery.getKey = (variables?: JobAppSourceOptionsQueryVariables) => variables === undefined ? ['JobAppSourceOptions.infinite'] : ['JobAppSourceOptions.infinite', variables];
;

useJobAppSourceOptionsQuery.fetcher = (variables?: JobAppSourceOptionsQueryVariables) => fetcher<JobAppSourceOptionsQuery, JobAppSourceOptionsQueryVariables>(JobAppSourceOptionsDocument, variables);
export const ConflictingJobAppsOfCandidatesDocument = `
    query ConflictingJobAppsOfCandidates($recruitId1: Int!, $recruitId2: Int!) {
  conflictingJobAppsOfCandidates(recruitId1: $recruitId1, recruitId2: $recruitId2) {
    job {
      id
      title
      statuses {
        id
        name
        corePipelineStepId
        jobPipelineBucketId
      }
    }
    jobId
    recruitIds
    jobApps {
      id
      recruitId
      status {
        id
        jobPipelineBucketId
        corePipelineStepId
        name
      }
    }
  }
}
    `;
export const useConflictingJobAppsOfCandidatesQuery = <
      TData = ConflictingJobAppsOfCandidatesQuery,
      TError = unknown
    >(
      variables: ConflictingJobAppsOfCandidatesQueryVariables,
      options?: UseQueryOptions<ConflictingJobAppsOfCandidatesQuery, TError, TData>
    ) =>
    useQuery<ConflictingJobAppsOfCandidatesQuery, TError, TData>(
      ['ConflictingJobAppsOfCandidates', variables],
      fetcher<ConflictingJobAppsOfCandidatesQuery, ConflictingJobAppsOfCandidatesQueryVariables>(ConflictingJobAppsOfCandidatesDocument, variables),
      options
    );

useConflictingJobAppsOfCandidatesQuery.getKey = (variables: ConflictingJobAppsOfCandidatesQueryVariables) => ['ConflictingJobAppsOfCandidates', variables];
;

export const useInfiniteConflictingJobAppsOfCandidatesQuery = <
      TData = ConflictingJobAppsOfCandidatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof ConflictingJobAppsOfCandidatesQueryVariables,
      variables: ConflictingJobAppsOfCandidatesQueryVariables,
      options?: UseInfiniteQueryOptions<ConflictingJobAppsOfCandidatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<ConflictingJobAppsOfCandidatesQuery, TError, TData>(
      ['ConflictingJobAppsOfCandidates.infinite', variables],
      (metaData) => fetcher<ConflictingJobAppsOfCandidatesQuery, ConflictingJobAppsOfCandidatesQueryVariables>(ConflictingJobAppsOfCandidatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteConflictingJobAppsOfCandidatesQuery.getKey = (variables: ConflictingJobAppsOfCandidatesQueryVariables) => ['ConflictingJobAppsOfCandidates.infinite', variables];
;

useConflictingJobAppsOfCandidatesQuery.fetcher = (variables: ConflictingJobAppsOfCandidatesQueryVariables) => fetcher<ConflictingJobAppsOfCandidatesQuery, ConflictingJobAppsOfCandidatesQueryVariables>(ConflictingJobAppsOfCandidatesDocument, variables);
export const GetCandidateReviewContentForCandidateDocument = `
    query GetCandidateReviewContentForCandidate($candidateReviewTemplateId: Int!, $recruitId: Int!) {
  getCandidateReviewContentForCandidate(
    candidateReviewTemplateId: $candidateReviewTemplateId
    recruitId: $recruitId
  ) {
    candidateId
    candidateReviewTemplateId
    sections {
      sectionType
      order
      evaluationSortEnum
      documents {
        documentLink
        uploadedDate
        title
      }
      jobApps {
        jobId
        jobAppId
        personalInfoSection {
          firstName
          lastName
          email
          phone
          linkedin
          order
        }
        addressInfoSection {
          addressLineOne
          addressLineTwo
          city
          state
          country
          zipCode
          order
        }
        workHistorySection {
          candidateWorkHistory {
            employer
            position
            startDate
            endDate
            isCurrentEmployer
          }
          order
        }
        educationHistorySection {
          candidateEducationHistory {
            university
            degree
            degreeEnum
            startDate
            endDate
          }
          order
        }
        customQuestionsSections {
          applicationQuestions {
            order
            appQuestionId
            questionLabel
            answer
          }
          order
          questionSectionName
        }
      }
      additionalInfo {
        qualifyingQuestions {
          order
          qqId
          questionLabel
          answer
        }
        internalFields {
          order
          internalFieldId
          questionLabel
          answer
        }
        applicationQuestions {
          order
          appQuestionId
          questionLabel
          answer
        }
      }
      interviewSchedules {
        eventId
        eventName
        interviewDate
        interviewStartTime
        interviewEndTime
        interviewers
      }
      evaluations {
        eventId
        eventTitle
        evaluatorId
        evaluatorName
        questionType
        questionLabel
        freeTextResponse
        yesNoResponse
        ratingResponse
        lowScale
        highScale
        lowLabel
        highLabel
        singleSelectResponse
        multiSelectResponse
        selectOptions
        comment
      }
      programEvaluations {
        id
        title
        mostRecentEvaluationDate
        evaluations {
          completedAt
          evaluationId
          evaluationTitle
          evaluatorId
          evaluatorName
          questionType
          questionLabel
          questionSubtext
          questionOrder
          questionFeedbackId
          freeTextResponse
          yesNoResponse
          ratingResponse
          lowScale
          highScale
          lowLabel
          highLabel
          singleSelectResponse
          multiSelectResponse
          selectOptions
          comment
        }
      }
      projectsWithEvaluations {
        projectId
        projectTitle
        projectDescription
        projectPracticeAreas
        projectCompletedAt
        mostRecentEvaluationDate
        evaluations {
          completedAt
          evaluationId
          evaluationTitle
          evaluatorId
          evaluatorName
          questionType
          questionLabel
          questionSubtext
          questionOrder
          questionFeedbackId
          freeTextResponse
          yesNoResponse
          ratingResponse
          lowScale
          highScale
          lowLabel
          highLabel
          singleSelectResponse
          multiSelectResponse
          selectOptions
          comment
        }
        documents {
          documentLink
          uploadedDate
          userFileName
          title
        }
      }
    }
  }
}
    `;
export const useGetCandidateReviewContentForCandidateQuery = <
      TData = GetCandidateReviewContentForCandidateQuery,
      TError = unknown
    >(
      variables: GetCandidateReviewContentForCandidateQueryVariables,
      options?: UseQueryOptions<GetCandidateReviewContentForCandidateQuery, TError, TData>
    ) =>
    useQuery<GetCandidateReviewContentForCandidateQuery, TError, TData>(
      ['GetCandidateReviewContentForCandidate', variables],
      fetcher<GetCandidateReviewContentForCandidateQuery, GetCandidateReviewContentForCandidateQueryVariables>(GetCandidateReviewContentForCandidateDocument, variables),
      options
    );

useGetCandidateReviewContentForCandidateQuery.getKey = (variables: GetCandidateReviewContentForCandidateQueryVariables) => ['GetCandidateReviewContentForCandidate', variables];
;

export const useInfiniteGetCandidateReviewContentForCandidateQuery = <
      TData = GetCandidateReviewContentForCandidateQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidateReviewContentForCandidateQueryVariables,
      variables: GetCandidateReviewContentForCandidateQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidateReviewContentForCandidateQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidateReviewContentForCandidateQuery, TError, TData>(
      ['GetCandidateReviewContentForCandidate.infinite', variables],
      (metaData) => fetcher<GetCandidateReviewContentForCandidateQuery, GetCandidateReviewContentForCandidateQueryVariables>(GetCandidateReviewContentForCandidateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidateReviewContentForCandidateQuery.getKey = (variables: GetCandidateReviewContentForCandidateQueryVariables) => ['GetCandidateReviewContentForCandidate.infinite', variables];
;

useGetCandidateReviewContentForCandidateQuery.fetcher = (variables: GetCandidateReviewContentForCandidateQueryVariables) => fetcher<GetCandidateReviewContentForCandidateQuery, GetCandidateReviewContentForCandidateQueryVariables>(GetCandidateReviewContentForCandidateDocument, variables);
export const IndividualCandidateReviewDocument = `
    query IndividualCandidateReview($candidateReviewTemplateId: Int!) {
  getCandidateReviewTemplate(
    candidateReviewTemplateId: $candidateReviewTemplateId
  ) {
    title
    id
    candidateReviewType
    creatorFirstName
    creatorLastName
    createdBy
    createdAt
    votingEnabled
    votingInfo {
      id
      candidateReviewTemplateId
      votingEndDate
      votingEndTimeZone
      votingStartDate
      votingStartTimeZone
    }
    programEvaluationConfig {
      evaluationScope
      evaluationStartDate
      evaluationStartTimeZone
      evaluationEndDate
      evaluationEndTimeZone
    }
    jobs {
      id
      title
    }
    events {
      id
      name
    }
    programs {
      id
      title
    }
    programEvaluationConfig {
      evaluationScope
      evaluationStartDate
      evaluationStartTimeZone
      evaluationEndDate
      evaluationEndTimeZone
    }
    candidateReviewTemplateCandidates {
      candidateReviewTemplateId
      createdAt
      evaluationAverage
      candidate {
        firstName
        lastName
        id
        email
        qualifyingQuestions {
          edges {
            node {
              id
              question
              answers
            }
          }
        }
      }
      votingRecords {
        id
        fname
        lname
        candidateReviewTemplateId
        userId
        castedVote
        comment
        candidateId
      }
    }
    sections {
      __typename
      id
      enabled
      order
      includedDocuments {
        id
        order
        orgDocumentId
      }
      includedEvaluationQuestions {
        id
        order
        orgEvalQuestionId
      }
      includedAdditionalInformation {
        id
        order
        questionType
        qqId
        internalFieldId
        appQuestionId
      }
      evaluationSortEnum
      sectionType
    }
  }
}
    `;
export const useIndividualCandidateReviewQuery = <
      TData = IndividualCandidateReviewQuery,
      TError = unknown
    >(
      variables: IndividualCandidateReviewQueryVariables,
      options?: UseQueryOptions<IndividualCandidateReviewQuery, TError, TData>
    ) =>
    useQuery<IndividualCandidateReviewQuery, TError, TData>(
      ['IndividualCandidateReview', variables],
      fetcher<IndividualCandidateReviewQuery, IndividualCandidateReviewQueryVariables>(IndividualCandidateReviewDocument, variables),
      options
    );

useIndividualCandidateReviewQuery.getKey = (variables: IndividualCandidateReviewQueryVariables) => ['IndividualCandidateReview', variables];
;

export const useInfiniteIndividualCandidateReviewQuery = <
      TData = IndividualCandidateReviewQuery,
      TError = unknown
    >(
      pageParamKey: keyof IndividualCandidateReviewQueryVariables,
      variables: IndividualCandidateReviewQueryVariables,
      options?: UseInfiniteQueryOptions<IndividualCandidateReviewQuery, TError, TData>
    ) =>
    useInfiniteQuery<IndividualCandidateReviewQuery, TError, TData>(
      ['IndividualCandidateReview.infinite', variables],
      (metaData) => fetcher<IndividualCandidateReviewQuery, IndividualCandidateReviewQueryVariables>(IndividualCandidateReviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteIndividualCandidateReviewQuery.getKey = (variables: IndividualCandidateReviewQueryVariables) => ['IndividualCandidateReview.infinite', variables];
;

useIndividualCandidateReviewQuery.fetcher = (variables: IndividualCandidateReviewQueryVariables) => fetcher<IndividualCandidateReviewQuery, IndividualCandidateReviewQueryVariables>(IndividualCandidateReviewDocument, variables);
export const IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsDocument = `
    query IndividualCandidateReviewIncludeCandidateJobsAndEventsAndPrograms($candidateReviewTemplateId: Int!) {
  getCandidateReviewTemplate(
    candidateReviewTemplateId: $candidateReviewTemplateId
  ) {
    title
    id
    candidateReviewType
    creatorFirstName
    creatorLastName
    createdBy
    createdAt
    votingEnabled
    votingInfo {
      id
      candidateReviewTemplateId
      votingEndDate
      votingEndTimeZone
      votingStartDate
      votingStartTimeZone
    }
    jobs {
      id
      title
    }
    events {
      id
      name
    }
    programs {
      id
      title
      evaluationQuestions {
        id
        orgFeedbackId
        evaluationQuestion {
          id
          label
        }
      }
      customEvaluations {
        id
        evaluationName
        evaluationType
        questions {
          id
          orgFeedbackId
          evaluationQuestion {
            id
            label
          }
        }
      }
    }
    programEvaluationConfig {
      evaluationScope
      evaluationStartDate
      evaluationStartTimeZone
      evaluationEndDate
      evaluationEndTimeZone
    }
    candidateReviewTemplateCandidates {
      candidateReviewTemplateId
      createdAt
      evaluationAverage
      candidate {
        firstName
        lastName
        id
        email
        jobApps {
          nodes {
            id
            recruitId
            job {
              id
              title
              orgId
              is1L
              is2L
              hasJobBoardAudienceSet
            }
            status {
              id
              name
            }
          }
        }
        qualifyingQuestions {
          edges {
            node {
              id
              question
              answers
            }
          }
        }
      }
      votingRecords {
        id
        fname
        lname
        candidateReviewTemplateId
        userId
        castedVote
        comment
        candidateId
      }
    }
    sections {
      __typename
      id
      enabled
      order
      includedDocuments {
        id
        order
        orgDocumentId
      }
      includedEvaluationQuestions {
        id
        order
        orgEvalQuestionId
        programEvaluationId
      }
      includedEvaluations {
        id
        enabled
        programEvaluationId
      }
      includedAdditionalInformation {
        id
        order
        questionType
        qqId
        internalFieldId
        appQuestionId
      }
      includedJobAppSections {
        id
        order
        jobSectionId
        includedJobAppQuestions {
          id
          order
          jobQuestionId
        }
      }
      evaluationSortEnum
      sectionType
    }
  }
}
    `;
export const useIndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery = <
      TData = IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery,
      TError = unknown
    >(
      variables: IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables,
      options?: UseQueryOptions<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, TError, TData>
    ) =>
    useQuery<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, TError, TData>(
      ['IndividualCandidateReviewIncludeCandidateJobsAndEventsAndPrograms', variables],
      fetcher<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables>(IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsDocument, variables),
      options
    );

useIndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery.getKey = (variables: IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables) => ['IndividualCandidateReviewIncludeCandidateJobsAndEventsAndPrograms', variables];
;

export const useInfiniteIndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery = <
      TData = IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery,
      TError = unknown
    >(
      pageParamKey: keyof IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables,
      variables: IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables,
      options?: UseInfiniteQueryOptions<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, TError, TData>
    ) =>
    useInfiniteQuery<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, TError, TData>(
      ['IndividualCandidateReviewIncludeCandidateJobsAndEventsAndPrograms.infinite', variables],
      (metaData) => fetcher<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables>(IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteIndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery.getKey = (variables: IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables) => ['IndividualCandidateReviewIncludeCandidateJobsAndEventsAndPrograms.infinite', variables];
;

useIndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery.fetcher = (variables: IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables) => fetcher<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables>(IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsDocument, variables);
export const CandidateReviewVotingRecordsDocument = `
    query CandidateReviewVotingRecords($candidateReviewTemplateId: Int!) {
  getCandidateReviewTemplate(
    candidateReviewTemplateId: $candidateReviewTemplateId
  ) {
    candidateReviewTemplateCandidates {
      votingRecords {
        id
        fname
        lname
        candidateReviewTemplateId
        userId
        castedVote
        comment
        candidateId
      }
    }
  }
}
    `;
export const useCandidateReviewVotingRecordsQuery = <
      TData = CandidateReviewVotingRecordsQuery,
      TError = unknown
    >(
      variables: CandidateReviewVotingRecordsQueryVariables,
      options?: UseQueryOptions<CandidateReviewVotingRecordsQuery, TError, TData>
    ) =>
    useQuery<CandidateReviewVotingRecordsQuery, TError, TData>(
      ['CandidateReviewVotingRecords', variables],
      fetcher<CandidateReviewVotingRecordsQuery, CandidateReviewVotingRecordsQueryVariables>(CandidateReviewVotingRecordsDocument, variables),
      options
    );

useCandidateReviewVotingRecordsQuery.getKey = (variables: CandidateReviewVotingRecordsQueryVariables) => ['CandidateReviewVotingRecords', variables];
;

export const useInfiniteCandidateReviewVotingRecordsQuery = <
      TData = CandidateReviewVotingRecordsQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateReviewVotingRecordsQueryVariables,
      variables: CandidateReviewVotingRecordsQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateReviewVotingRecordsQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateReviewVotingRecordsQuery, TError, TData>(
      ['CandidateReviewVotingRecords.infinite', variables],
      (metaData) => fetcher<CandidateReviewVotingRecordsQuery, CandidateReviewVotingRecordsQueryVariables>(CandidateReviewVotingRecordsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateReviewVotingRecordsQuery.getKey = (variables: CandidateReviewVotingRecordsQueryVariables) => ['CandidateReviewVotingRecords.infinite', variables];
;

useCandidateReviewVotingRecordsQuery.fetcher = (variables: CandidateReviewVotingRecordsQueryVariables) => fetcher<CandidateReviewVotingRecordsQuery, CandidateReviewVotingRecordsQueryVariables>(CandidateReviewVotingRecordsDocument, variables);
export const CandidateReviewVotingRecordsOfIndividualRecruitDocument = `
    query CandidateReviewVotingRecordsOfIndividualRecruit($candidateReviewTemplateId: Int!, $recruitId: Int!) {
  getCandidateReviewTemplate(
    candidateReviewTemplateId: $candidateReviewTemplateId
  ) {
    candidateReviewTemplateCandidates(recruitId: $recruitId) {
      votingRecords {
        id
        fname
        lname
        candidateReviewTemplateId
        userId
        castedVote
        comment
        candidateId
      }
    }
  }
}
    `;
export const useCandidateReviewVotingRecordsOfIndividualRecruitQuery = <
      TData = CandidateReviewVotingRecordsOfIndividualRecruitQuery,
      TError = unknown
    >(
      variables: CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables,
      options?: UseQueryOptions<CandidateReviewVotingRecordsOfIndividualRecruitQuery, TError, TData>
    ) =>
    useQuery<CandidateReviewVotingRecordsOfIndividualRecruitQuery, TError, TData>(
      ['CandidateReviewVotingRecordsOfIndividualRecruit', variables],
      fetcher<CandidateReviewVotingRecordsOfIndividualRecruitQuery, CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables>(CandidateReviewVotingRecordsOfIndividualRecruitDocument, variables),
      options
    );

useCandidateReviewVotingRecordsOfIndividualRecruitQuery.getKey = (variables: CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables) => ['CandidateReviewVotingRecordsOfIndividualRecruit', variables];
;

export const useInfiniteCandidateReviewVotingRecordsOfIndividualRecruitQuery = <
      TData = CandidateReviewVotingRecordsOfIndividualRecruitQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables,
      variables: CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateReviewVotingRecordsOfIndividualRecruitQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateReviewVotingRecordsOfIndividualRecruitQuery, TError, TData>(
      ['CandidateReviewVotingRecordsOfIndividualRecruit.infinite', variables],
      (metaData) => fetcher<CandidateReviewVotingRecordsOfIndividualRecruitQuery, CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables>(CandidateReviewVotingRecordsOfIndividualRecruitDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateReviewVotingRecordsOfIndividualRecruitQuery.getKey = (variables: CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables) => ['CandidateReviewVotingRecordsOfIndividualRecruit.infinite', variables];
;

useCandidateReviewVotingRecordsOfIndividualRecruitQuery.fetcher = (variables: CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables) => fetcher<CandidateReviewVotingRecordsOfIndividualRecruitQuery, CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables>(CandidateReviewVotingRecordsOfIndividualRecruitDocument, variables);
export const CandidateReviewTemplatesForOrgDocument = `
    query CandidateReviewTemplatesForOrg {
  getCandidateReviewTemplatesForOrg {
    title
    id
    candidateReviewType
    creatorFirstName
    creatorLastName
    createdBy
    createdAt
    jobs {
      id
      title
    }
    events {
      id
      name
    }
    candidateReviewTemplateCandidates {
      candidate {
        firstName
        lastName
        id
        email
        qualifyingQuestions {
          edges {
            node {
              id
              question
              answers
            }
          }
        }
      }
    }
    sections {
      id
      enabled
      order
      includedDocuments {
        id
        order
        orgDocumentId
      }
      evaluationSortEnum
      sectionType
    }
  }
}
    `;
export const useCandidateReviewTemplatesForOrgQuery = <
      TData = CandidateReviewTemplatesForOrgQuery,
      TError = unknown
    >(
      variables?: CandidateReviewTemplatesForOrgQueryVariables,
      options?: UseQueryOptions<CandidateReviewTemplatesForOrgQuery, TError, TData>
    ) =>
    useQuery<CandidateReviewTemplatesForOrgQuery, TError, TData>(
      variables === undefined ? ['CandidateReviewTemplatesForOrg'] : ['CandidateReviewTemplatesForOrg', variables],
      fetcher<CandidateReviewTemplatesForOrgQuery, CandidateReviewTemplatesForOrgQueryVariables>(CandidateReviewTemplatesForOrgDocument, variables),
      options
    );

useCandidateReviewTemplatesForOrgQuery.getKey = (variables?: CandidateReviewTemplatesForOrgQueryVariables) => variables === undefined ? ['CandidateReviewTemplatesForOrg'] : ['CandidateReviewTemplatesForOrg', variables];
;

export const useInfiniteCandidateReviewTemplatesForOrgQuery = <
      TData = CandidateReviewTemplatesForOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateReviewTemplatesForOrgQueryVariables,
      variables?: CandidateReviewTemplatesForOrgQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateReviewTemplatesForOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateReviewTemplatesForOrgQuery, TError, TData>(
      variables === undefined ? ['CandidateReviewTemplatesForOrg.infinite'] : ['CandidateReviewTemplatesForOrg.infinite', variables],
      (metaData) => fetcher<CandidateReviewTemplatesForOrgQuery, CandidateReviewTemplatesForOrgQueryVariables>(CandidateReviewTemplatesForOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateReviewTemplatesForOrgQuery.getKey = (variables?: CandidateReviewTemplatesForOrgQueryVariables) => variables === undefined ? ['CandidateReviewTemplatesForOrg.infinite'] : ['CandidateReviewTemplatesForOrg.infinite', variables];
;

useCandidateReviewTemplatesForOrgQuery.fetcher = (variables?: CandidateReviewTemplatesForOrgQueryVariables) => fetcher<CandidateReviewTemplatesForOrgQuery, CandidateReviewTemplatesForOrgQueryVariables>(CandidateReviewTemplatesForOrgDocument, variables);
export const CandidateReviewTemplateOverviewsForOrgDocument = `
    query CandidateReviewTemplateOverviewsForOrg {
  getCandidateReviewTemplatesForOrg {
    title
    id
    creatorFirstName
    creatorLastName
    createdBy
    createdAt
    candidateReviewType
    candidateReviewTemplateCandidates {
      candidate {
        id
      }
    }
    sections {
      id
    }
  }
}
    `;
export const useCandidateReviewTemplateOverviewsForOrgQuery = <
      TData = CandidateReviewTemplateOverviewsForOrgQuery,
      TError = unknown
    >(
      variables?: CandidateReviewTemplateOverviewsForOrgQueryVariables,
      options?: UseQueryOptions<CandidateReviewTemplateOverviewsForOrgQuery, TError, TData>
    ) =>
    useQuery<CandidateReviewTemplateOverviewsForOrgQuery, TError, TData>(
      variables === undefined ? ['CandidateReviewTemplateOverviewsForOrg'] : ['CandidateReviewTemplateOverviewsForOrg', variables],
      fetcher<CandidateReviewTemplateOverviewsForOrgQuery, CandidateReviewTemplateOverviewsForOrgQueryVariables>(CandidateReviewTemplateOverviewsForOrgDocument, variables),
      options
    );

useCandidateReviewTemplateOverviewsForOrgQuery.getKey = (variables?: CandidateReviewTemplateOverviewsForOrgQueryVariables) => variables === undefined ? ['CandidateReviewTemplateOverviewsForOrg'] : ['CandidateReviewTemplateOverviewsForOrg', variables];
;

export const useInfiniteCandidateReviewTemplateOverviewsForOrgQuery = <
      TData = CandidateReviewTemplateOverviewsForOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateReviewTemplateOverviewsForOrgQueryVariables,
      variables?: CandidateReviewTemplateOverviewsForOrgQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateReviewTemplateOverviewsForOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateReviewTemplateOverviewsForOrgQuery, TError, TData>(
      variables === undefined ? ['CandidateReviewTemplateOverviewsForOrg.infinite'] : ['CandidateReviewTemplateOverviewsForOrg.infinite', variables],
      (metaData) => fetcher<CandidateReviewTemplateOverviewsForOrgQuery, CandidateReviewTemplateOverviewsForOrgQueryVariables>(CandidateReviewTemplateOverviewsForOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateReviewTemplateOverviewsForOrgQuery.getKey = (variables?: CandidateReviewTemplateOverviewsForOrgQueryVariables) => variables === undefined ? ['CandidateReviewTemplateOverviewsForOrg.infinite'] : ['CandidateReviewTemplateOverviewsForOrg.infinite', variables];
;

useCandidateReviewTemplateOverviewsForOrgQuery.fetcher = (variables?: CandidateReviewTemplateOverviewsForOrgQueryVariables) => fetcher<CandidateReviewTemplateOverviewsForOrgQuery, CandidateReviewTemplateOverviewsForOrgQueryVariables>(CandidateReviewTemplateOverviewsForOrgDocument, variables);
export const CandidateReviewProgramAssociatesDocument = `
    query CandidateReviewProgramAssociates($programId: ID!, $associateRecruitIds: [Int!]!) {
  programAssociatesByRecruitIds(
    programId: $programId
    associateRecruitIds: $associateRecruitIds
  ) {
    id
    lawSchools
    recruitIdForAssociateWorkEmail
  }
}
    `;
export const useCandidateReviewProgramAssociatesQuery = <
      TData = CandidateReviewProgramAssociatesQuery,
      TError = unknown
    >(
      variables: CandidateReviewProgramAssociatesQueryVariables,
      options?: UseQueryOptions<CandidateReviewProgramAssociatesQuery, TError, TData>
    ) =>
    useQuery<CandidateReviewProgramAssociatesQuery, TError, TData>(
      ['CandidateReviewProgramAssociates', variables],
      fetcher<CandidateReviewProgramAssociatesQuery, CandidateReviewProgramAssociatesQueryVariables>(CandidateReviewProgramAssociatesDocument, variables),
      options
    );

useCandidateReviewProgramAssociatesQuery.getKey = (variables: CandidateReviewProgramAssociatesQueryVariables) => ['CandidateReviewProgramAssociates', variables];
;

export const useInfiniteCandidateReviewProgramAssociatesQuery = <
      TData = CandidateReviewProgramAssociatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateReviewProgramAssociatesQueryVariables,
      variables: CandidateReviewProgramAssociatesQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateReviewProgramAssociatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateReviewProgramAssociatesQuery, TError, TData>(
      ['CandidateReviewProgramAssociates.infinite', variables],
      (metaData) => fetcher<CandidateReviewProgramAssociatesQuery, CandidateReviewProgramAssociatesQueryVariables>(CandidateReviewProgramAssociatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateReviewProgramAssociatesQuery.getKey = (variables: CandidateReviewProgramAssociatesQueryVariables) => ['CandidateReviewProgramAssociates.infinite', variables];
;

useCandidateReviewProgramAssociatesQuery.fetcher = (variables: CandidateReviewProgramAssociatesQueryVariables) => fetcher<CandidateReviewProgramAssociatesQuery, CandidateReviewProgramAssociatesQueryVariables>(CandidateReviewProgramAssociatesDocument, variables);
export const UpsertCandidateReviewTemplateDocument = `
    mutation UpsertCandidateReviewTemplate($candidateReviewTemplateInput: CandidateReviewTemplateInput!) {
  upsertCandidateReviewTemplate(
    candidateReviewTemplateInput: $candidateReviewTemplateInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateMutation, TError, UpsertCandidateReviewTemplateMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateMutation, TError, UpsertCandidateReviewTemplateMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplate'],
      (variables?: UpsertCandidateReviewTemplateMutationVariables) => fetcher<UpsertCandidateReviewTemplateMutation, UpsertCandidateReviewTemplateMutationVariables>(UpsertCandidateReviewTemplateDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateMutation.fetcher = (variables: UpsertCandidateReviewTemplateMutationVariables) => fetcher<UpsertCandidateReviewTemplateMutation, UpsertCandidateReviewTemplateMutationVariables>(UpsertCandidateReviewTemplateDocument, variables);
export const UpsertCandidateReviewTemplateCandidatesDocument = `
    mutation UpsertCandidateReviewTemplateCandidates($candidateReviewTemplateCandidatesInput: CandidateReviewTemplateCandidatesInput!) {
  upsertCandidateReviewTemplateCandidates(
    candidateReviewTemplateCandidatesInput: $candidateReviewTemplateCandidatesInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateCandidatesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateCandidatesMutation, TError, UpsertCandidateReviewTemplateCandidatesMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateCandidatesMutation, TError, UpsertCandidateReviewTemplateCandidatesMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplateCandidates'],
      (variables?: UpsertCandidateReviewTemplateCandidatesMutationVariables) => fetcher<UpsertCandidateReviewTemplateCandidatesMutation, UpsertCandidateReviewTemplateCandidatesMutationVariables>(UpsertCandidateReviewTemplateCandidatesDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateCandidatesMutation.fetcher = (variables: UpsertCandidateReviewTemplateCandidatesMutationVariables) => fetcher<UpsertCandidateReviewTemplateCandidatesMutation, UpsertCandidateReviewTemplateCandidatesMutationVariables>(UpsertCandidateReviewTemplateCandidatesDocument, variables);
export const UpsertCandidateReviewTemplateEventsDocument = `
    mutation UpsertCandidateReviewTemplateEvents($candidateReviewTemplateEventsInput: CandidateReviewTemplateEventsInput!) {
  upsertCandidateReviewTemplateEvents(
    candidateReviewTemplateEventsInput: $candidateReviewTemplateEventsInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateEventsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateEventsMutation, TError, UpsertCandidateReviewTemplateEventsMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateEventsMutation, TError, UpsertCandidateReviewTemplateEventsMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplateEvents'],
      (variables?: UpsertCandidateReviewTemplateEventsMutationVariables) => fetcher<UpsertCandidateReviewTemplateEventsMutation, UpsertCandidateReviewTemplateEventsMutationVariables>(UpsertCandidateReviewTemplateEventsDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateEventsMutation.fetcher = (variables: UpsertCandidateReviewTemplateEventsMutationVariables) => fetcher<UpsertCandidateReviewTemplateEventsMutation, UpsertCandidateReviewTemplateEventsMutationVariables>(UpsertCandidateReviewTemplateEventsDocument, variables);
export const UpsertCandidateReviewTemplateJobsDocument = `
    mutation UpsertCandidateReviewTemplateJobs($candidateReviewTemplateJobsInput: CandidateReviewTemplateJobsInput!) {
  upsertCandidateReviewTemplateJobs(
    candidateReviewTemplateJobsInput: $candidateReviewTemplateJobsInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateJobsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateJobsMutation, TError, UpsertCandidateReviewTemplateJobsMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateJobsMutation, TError, UpsertCandidateReviewTemplateJobsMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplateJobs'],
      (variables?: UpsertCandidateReviewTemplateJobsMutationVariables) => fetcher<UpsertCandidateReviewTemplateJobsMutation, UpsertCandidateReviewTemplateJobsMutationVariables>(UpsertCandidateReviewTemplateJobsDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateJobsMutation.fetcher = (variables: UpsertCandidateReviewTemplateJobsMutationVariables) => fetcher<UpsertCandidateReviewTemplateJobsMutation, UpsertCandidateReviewTemplateJobsMutationVariables>(UpsertCandidateReviewTemplateJobsDocument, variables);
export const UpsertCandidateReviewTemplateJobsWithEventsDocument = `
    mutation UpsertCandidateReviewTemplateJobsWithEvents($candidateReviewTemplateJobsWithEventsInput: CandidateReviewTemplateJobsWithEventsInput!) {
  upsertCandidateReviewTemplateJobsWithEvents(
    candidateReviewTemplateJobsWithEventsInput: $candidateReviewTemplateJobsWithEventsInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateJobsWithEventsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateJobsWithEventsMutation, TError, UpsertCandidateReviewTemplateJobsWithEventsMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateJobsWithEventsMutation, TError, UpsertCandidateReviewTemplateJobsWithEventsMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplateJobsWithEvents'],
      (variables?: UpsertCandidateReviewTemplateJobsWithEventsMutationVariables) => fetcher<UpsertCandidateReviewTemplateJobsWithEventsMutation, UpsertCandidateReviewTemplateJobsWithEventsMutationVariables>(UpsertCandidateReviewTemplateJobsWithEventsDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateJobsWithEventsMutation.fetcher = (variables: UpsertCandidateReviewTemplateJobsWithEventsMutationVariables) => fetcher<UpsertCandidateReviewTemplateJobsWithEventsMutation, UpsertCandidateReviewTemplateJobsWithEventsMutationVariables>(UpsertCandidateReviewTemplateJobsWithEventsDocument, variables);
export const UpsertCandidateReviewTemplateProgramsDocument = `
    mutation UpsertCandidateReviewTemplatePrograms($candidateReviewTemplateProgramsInput: CandidateReviewTemplateProgramsInput!) {
  upsertCandidateReviewTemplatePrograms(
    candidateReviewTemplateProgramsInput: $candidateReviewTemplateProgramsInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateProgramsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateProgramsMutation, TError, UpsertCandidateReviewTemplateProgramsMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateProgramsMutation, TError, UpsertCandidateReviewTemplateProgramsMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplatePrograms'],
      (variables?: UpsertCandidateReviewTemplateProgramsMutationVariables) => fetcher<UpsertCandidateReviewTemplateProgramsMutation, UpsertCandidateReviewTemplateProgramsMutationVariables>(UpsertCandidateReviewTemplateProgramsDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateProgramsMutation.fetcher = (variables: UpsertCandidateReviewTemplateProgramsMutationVariables) => fetcher<UpsertCandidateReviewTemplateProgramsMutation, UpsertCandidateReviewTemplateProgramsMutationVariables>(UpsertCandidateReviewTemplateProgramsDocument, variables);
export const UpsertCandidateReviewTemplateSectionsDocument = `
    mutation UpsertCandidateReviewTemplateSections($candidateReviewTemplateId: Int!, $documentSectionInput: CandidateReviewTemplateDocumentSectionInput, $evaluationSectionInput: CandidateReviewTemplateEvaluationSectionInput, $additionalInformationSectionInput: CandidateReviewTemplateAdditionalInformationSectionInput, $interviewScheduleSectionInput: CandidateReviewTemplateInterviewScheduleSectionInput, $jobAppSectionInput: CandidateReviewTemplateJobAppSectionInput, $projectDocumentsSectionInput: CandidateReviewTemplateProjectDocumentsSectionInput) {
  upsertCandidateReviewTemplateSections(
    candidateReviewTemplateId: $candidateReviewTemplateId
    documentSectionInput: $documentSectionInput
    evaluationSectionInput: $evaluationSectionInput
    additionalInformationSectionInput: $additionalInformationSectionInput
    interviewScheduleSectionInput: $interviewScheduleSectionInput
    jobAppSectionInput: $jobAppSectionInput
    projectDocumentsSectionInput: $projectDocumentsSectionInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateSectionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateSectionsMutation, TError, UpsertCandidateReviewTemplateSectionsMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateSectionsMutation, TError, UpsertCandidateReviewTemplateSectionsMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplateSections'],
      (variables?: UpsertCandidateReviewTemplateSectionsMutationVariables) => fetcher<UpsertCandidateReviewTemplateSectionsMutation, UpsertCandidateReviewTemplateSectionsMutationVariables>(UpsertCandidateReviewTemplateSectionsDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateSectionsMutation.fetcher = (variables: UpsertCandidateReviewTemplateSectionsMutationVariables) => fetcher<UpsertCandidateReviewTemplateSectionsMutation, UpsertCandidateReviewTemplateSectionsMutationVariables>(UpsertCandidateReviewTemplateSectionsDocument, variables);
export const DeleteCandidateReviewTemplateDocument = `
    mutation DeleteCandidateReviewTemplate($candidateReviewTemplateId: Int!) {
  deleteCandidateReviewTemplate(
    candidateReviewTemplateId: $candidateReviewTemplateId
  )
}
    `;
export const useDeleteCandidateReviewTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCandidateReviewTemplateMutation, TError, DeleteCandidateReviewTemplateMutationVariables, TContext>) =>
    useMutation<DeleteCandidateReviewTemplateMutation, TError, DeleteCandidateReviewTemplateMutationVariables, TContext>(
      ['DeleteCandidateReviewTemplate'],
      (variables?: DeleteCandidateReviewTemplateMutationVariables) => fetcher<DeleteCandidateReviewTemplateMutation, DeleteCandidateReviewTemplateMutationVariables>(DeleteCandidateReviewTemplateDocument, variables)(),
      options
    );
useDeleteCandidateReviewTemplateMutation.fetcher = (variables: DeleteCandidateReviewTemplateMutationVariables) => fetcher<DeleteCandidateReviewTemplateMutation, DeleteCandidateReviewTemplateMutationVariables>(DeleteCandidateReviewTemplateDocument, variables);
export const UpsertCandidateReviewTemplateCandidateVotingRecordDocument = `
    mutation UpsertCandidateReviewTemplateCandidateVotingRecord($candidateReviewCandidateVotingInput: CandidateReviewTemplateCandidateVotingInput!) {
  upsertCandidateReviewTemplateCandidateVotingRecord(
    candidateReviewCandidateVotingInput: $candidateReviewCandidateVotingInput
  )
}
    `;
export const useUpsertCandidateReviewTemplateCandidateVotingRecordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewTemplateCandidateVotingRecordMutation, TError, UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewTemplateCandidateVotingRecordMutation, TError, UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables, TContext>(
      ['UpsertCandidateReviewTemplateCandidateVotingRecord'],
      (variables?: UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables) => fetcher<UpsertCandidateReviewTemplateCandidateVotingRecordMutation, UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables>(UpsertCandidateReviewTemplateCandidateVotingRecordDocument, variables)(),
      options
    );
useUpsertCandidateReviewTemplateCandidateVotingRecordMutation.fetcher = (variables: UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables) => fetcher<UpsertCandidateReviewTemplateCandidateVotingRecordMutation, UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables>(UpsertCandidateReviewTemplateCandidateVotingRecordDocument, variables);
export const UpsertCandidateReviewVotingRecordCastedVotedDocument = `
    mutation UpsertCandidateReviewVotingRecordCastedVoted($candidateReviewVotingRecordCastedVotedInput: CandidateReviewVotingRecordCastedVotedInput!) {
  upsertCandidateReviewVotingRecordCastedVoted(
    candidateReviewVotingRecordCastedVotedInput: $candidateReviewVotingRecordCastedVotedInput
  )
}
    `;
export const useUpsertCandidateReviewVotingRecordCastedVotedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewVotingRecordCastedVotedMutation, TError, UpsertCandidateReviewVotingRecordCastedVotedMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewVotingRecordCastedVotedMutation, TError, UpsertCandidateReviewVotingRecordCastedVotedMutationVariables, TContext>(
      ['UpsertCandidateReviewVotingRecordCastedVoted'],
      (variables?: UpsertCandidateReviewVotingRecordCastedVotedMutationVariables) => fetcher<UpsertCandidateReviewVotingRecordCastedVotedMutation, UpsertCandidateReviewVotingRecordCastedVotedMutationVariables>(UpsertCandidateReviewVotingRecordCastedVotedDocument, variables)(),
      options
    );
useUpsertCandidateReviewVotingRecordCastedVotedMutation.fetcher = (variables: UpsertCandidateReviewVotingRecordCastedVotedMutationVariables) => fetcher<UpsertCandidateReviewVotingRecordCastedVotedMutation, UpsertCandidateReviewVotingRecordCastedVotedMutationVariables>(UpsertCandidateReviewVotingRecordCastedVotedDocument, variables);
export const UpsertCandidateReviewVotingRecordCommentDocument = `
    mutation UpsertCandidateReviewVotingRecordComment($candidateReviewVotingRecordCommentInput: CandidateReviewVotingRecordCommentInput!) {
  upsertCandidateReviewVotingRecordComment(
    candidateReviewVotingRecordCommentInput: $candidateReviewVotingRecordCommentInput
  )
}
    `;
export const useUpsertCandidateReviewVotingRecordCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCandidateReviewVotingRecordCommentMutation, TError, UpsertCandidateReviewVotingRecordCommentMutationVariables, TContext>) =>
    useMutation<UpsertCandidateReviewVotingRecordCommentMutation, TError, UpsertCandidateReviewVotingRecordCommentMutationVariables, TContext>(
      ['UpsertCandidateReviewVotingRecordComment'],
      (variables?: UpsertCandidateReviewVotingRecordCommentMutationVariables) => fetcher<UpsertCandidateReviewVotingRecordCommentMutation, UpsertCandidateReviewVotingRecordCommentMutationVariables>(UpsertCandidateReviewVotingRecordCommentDocument, variables)(),
      options
    );
useUpsertCandidateReviewVotingRecordCommentMutation.fetcher = (variables: UpsertCandidateReviewVotingRecordCommentMutationVariables) => fetcher<UpsertCandidateReviewVotingRecordCommentMutation, UpsertCandidateReviewVotingRecordCommentMutationVariables>(UpsertCandidateReviewVotingRecordCommentDocument, variables);
export const EventEvaluationQuestionsByEventIdDocument = `
    query EventEvaluationQuestionsByEventId($eventIds: [Int!]!) {
  eventEvaluationQuestionsByEventIds(eventIds: $eventIds) {
    id
    eventId
    orgFeedbackId
    sortOrder
    label
  }
}
    `;
export const useEventEvaluationQuestionsByEventIdQuery = <
      TData = EventEvaluationQuestionsByEventIdQuery,
      TError = unknown
    >(
      variables: EventEvaluationQuestionsByEventIdQueryVariables,
      options?: UseQueryOptions<EventEvaluationQuestionsByEventIdQuery, TError, TData>
    ) =>
    useQuery<EventEvaluationQuestionsByEventIdQuery, TError, TData>(
      ['EventEvaluationQuestionsByEventId', variables],
      fetcher<EventEvaluationQuestionsByEventIdQuery, EventEvaluationQuestionsByEventIdQueryVariables>(EventEvaluationQuestionsByEventIdDocument, variables),
      options
    );

useEventEvaluationQuestionsByEventIdQuery.getKey = (variables: EventEvaluationQuestionsByEventIdQueryVariables) => ['EventEvaluationQuestionsByEventId', variables];
;

export const useInfiniteEventEvaluationQuestionsByEventIdQuery = <
      TData = EventEvaluationQuestionsByEventIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventEvaluationQuestionsByEventIdQueryVariables,
      variables: EventEvaluationQuestionsByEventIdQueryVariables,
      options?: UseInfiniteQueryOptions<EventEvaluationQuestionsByEventIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventEvaluationQuestionsByEventIdQuery, TError, TData>(
      ['EventEvaluationQuestionsByEventId.infinite', variables],
      (metaData) => fetcher<EventEvaluationQuestionsByEventIdQuery, EventEvaluationQuestionsByEventIdQueryVariables>(EventEvaluationQuestionsByEventIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventEvaluationQuestionsByEventIdQuery.getKey = (variables: EventEvaluationQuestionsByEventIdQueryVariables) => ['EventEvaluationQuestionsByEventId.infinite', variables];
;

useEventEvaluationQuestionsByEventIdQuery.fetcher = (variables: EventEvaluationQuestionsByEventIdQueryVariables) => fetcher<EventEvaluationQuestionsByEventIdQuery, EventEvaluationQuestionsByEventIdQueryVariables>(EventEvaluationQuestionsByEventIdDocument, variables);
export const AllLanguagesDocument = `
    query AllLanguages {
  allLanguages {
    id
    name
  }
}
    `;
export const useAllLanguagesQuery = <
      TData = AllLanguagesQuery,
      TError = unknown
    >(
      variables?: AllLanguagesQueryVariables,
      options?: UseQueryOptions<AllLanguagesQuery, TError, TData>
    ) =>
    useQuery<AllLanguagesQuery, TError, TData>(
      variables === undefined ? ['AllLanguages'] : ['AllLanguages', variables],
      fetcher<AllLanguagesQuery, AllLanguagesQueryVariables>(AllLanguagesDocument, variables),
      options
    );

useAllLanguagesQuery.getKey = (variables?: AllLanguagesQueryVariables) => variables === undefined ? ['AllLanguages'] : ['AllLanguages', variables];
;

export const useInfiniteAllLanguagesQuery = <
      TData = AllLanguagesQuery,
      TError = unknown
    >(
      pageParamKey: keyof AllLanguagesQueryVariables,
      variables?: AllLanguagesQueryVariables,
      options?: UseInfiniteQueryOptions<AllLanguagesQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllLanguagesQuery, TError, TData>(
      variables === undefined ? ['AllLanguages.infinite'] : ['AllLanguages.infinite', variables],
      (metaData) => fetcher<AllLanguagesQuery, AllLanguagesQueryVariables>(AllLanguagesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAllLanguagesQuery.getKey = (variables?: AllLanguagesQueryVariables) => variables === undefined ? ['AllLanguages.infinite'] : ['AllLanguages.infinite', variables];
;

useAllLanguagesQuery.fetcher = (variables?: AllLanguagesQueryVariables) => fetcher<AllLanguagesQuery, AllLanguagesQueryVariables>(AllLanguagesDocument, variables);
export const TrackActivateForwardAccountFromEventDocument = `
    mutation TrackActivateForwardAccountFromEvent($input: TrackActivateForwardAccountFromEventInput!) {
  trackActivateForwardAccountFromEvent(input: $input) {
    success
  }
}
    `;
export const useTrackActivateForwardAccountFromEventMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TrackActivateForwardAccountFromEventMutation, TError, TrackActivateForwardAccountFromEventMutationVariables, TContext>) =>
    useMutation<TrackActivateForwardAccountFromEventMutation, TError, TrackActivateForwardAccountFromEventMutationVariables, TContext>(
      ['TrackActivateForwardAccountFromEvent'],
      (variables?: TrackActivateForwardAccountFromEventMutationVariables) => fetcher<TrackActivateForwardAccountFromEventMutation, TrackActivateForwardAccountFromEventMutationVariables>(TrackActivateForwardAccountFromEventDocument, variables)(),
      options
    );
useTrackActivateForwardAccountFromEventMutation.fetcher = (variables: TrackActivateForwardAccountFromEventMutationVariables) => fetcher<TrackActivateForwardAccountFromEventMutation, TrackActivateForwardAccountFromEventMutationVariables>(TrackActivateForwardAccountFromEventDocument, variables);
export const ForwardEventDetailPageDocument = `
    query ForwardEventDetailPage($eventId: ID!, $numChars: Int!) {
  forwardCandidateEventById(id: $eventId) {
    ...FirmEventCardHostFields
    host {
      ...FirmProfilePreviewFields
    }
    ...FirmEventCardFields
  }
}
    ${FirmEventCardHostFieldsFragmentDoc}
${FirmProfilePreviewFieldsFragmentDoc}
${FirmEventCardFieldsFragmentDoc}
${FirmEventCardRegistrationButtonFieldsFragmentDoc}`;
export const useForwardEventDetailPageQuery = <
      TData = ForwardEventDetailPageQuery,
      TError = unknown
    >(
      variables: ForwardEventDetailPageQueryVariables,
      options?: UseQueryOptions<ForwardEventDetailPageQuery, TError, TData>
    ) =>
    useQuery<ForwardEventDetailPageQuery, TError, TData>(
      ['ForwardEventDetailPage', variables],
      fetcher<ForwardEventDetailPageQuery, ForwardEventDetailPageQueryVariables>(ForwardEventDetailPageDocument, variables),
      options
    );

useForwardEventDetailPageQuery.getKey = (variables: ForwardEventDetailPageQueryVariables) => ['ForwardEventDetailPage', variables];
;

export const useInfiniteForwardEventDetailPageQuery = <
      TData = ForwardEventDetailPageQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardEventDetailPageQueryVariables,
      variables: ForwardEventDetailPageQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardEventDetailPageQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardEventDetailPageQuery, TError, TData>(
      ['ForwardEventDetailPage.infinite', variables],
      (metaData) => fetcher<ForwardEventDetailPageQuery, ForwardEventDetailPageQueryVariables>(ForwardEventDetailPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardEventDetailPageQuery.getKey = (variables: ForwardEventDetailPageQueryVariables) => ['ForwardEventDetailPage.infinite', variables];
;

useForwardEventDetailPageQuery.fetcher = (variables: ForwardEventDetailPageQueryVariables) => fetcher<ForwardEventDetailPageQuery, ForwardEventDetailPageQueryVariables>(ForwardEventDetailPageDocument, variables);
export const EventDirectoryDocument = `
    query EventDirectory($first: Int!, $after: String, $filterBy: EventDirectoryFilterBy, $sortBy: [EventDirectorySortBy!]) {
  eventDirectory(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $sortBy
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      metadata {
        isFeatured
        rotation
      }
      node {
        ...FirmEventCardFields
      }
    }
  }
}
    ${FirmEventCardFieldsFragmentDoc}
${FirmEventCardHostFieldsFragmentDoc}
${FirmEventCardRegistrationButtonFieldsFragmentDoc}`;
export const useEventDirectoryQuery = <
      TData = EventDirectoryQuery,
      TError = unknown
    >(
      variables: EventDirectoryQueryVariables,
      options?: UseQueryOptions<EventDirectoryQuery, TError, TData>
    ) =>
    useQuery<EventDirectoryQuery, TError, TData>(
      ['EventDirectory', variables],
      fetcher<EventDirectoryQuery, EventDirectoryQueryVariables>(EventDirectoryDocument, variables),
      options
    );

useEventDirectoryQuery.getKey = (variables: EventDirectoryQueryVariables) => ['EventDirectory', variables];
;

export const useInfiniteEventDirectoryQuery = <
      TData = EventDirectoryQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventDirectoryQueryVariables,
      variables: EventDirectoryQueryVariables,
      options?: UseInfiniteQueryOptions<EventDirectoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventDirectoryQuery, TError, TData>(
      ['EventDirectory.infinite', variables],
      (metaData) => fetcher<EventDirectoryQuery, EventDirectoryQueryVariables>(EventDirectoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventDirectoryQuery.getKey = (variables: EventDirectoryQueryVariables) => ['EventDirectory.infinite', variables];
;

useEventDirectoryQuery.fetcher = (variables: EventDirectoryQueryVariables) => fetcher<EventDirectoryQuery, EventDirectoryQueryVariables>(EventDirectoryDocument, variables);
export const EventDirectoryAvailableCountDocument = `
    query EventDirectoryAvailableCount($filterBy: EventDirectoryFilterBy) {
  eventDirectory(filterBy: $filterBy) {
    totalCount
  }
}
    `;
export const useEventDirectoryAvailableCountQuery = <
      TData = EventDirectoryAvailableCountQuery,
      TError = unknown
    >(
      variables?: EventDirectoryAvailableCountQueryVariables,
      options?: UseQueryOptions<EventDirectoryAvailableCountQuery, TError, TData>
    ) =>
    useQuery<EventDirectoryAvailableCountQuery, TError, TData>(
      variables === undefined ? ['EventDirectoryAvailableCount'] : ['EventDirectoryAvailableCount', variables],
      fetcher<EventDirectoryAvailableCountQuery, EventDirectoryAvailableCountQueryVariables>(EventDirectoryAvailableCountDocument, variables),
      options
    );

useEventDirectoryAvailableCountQuery.getKey = (variables?: EventDirectoryAvailableCountQueryVariables) => variables === undefined ? ['EventDirectoryAvailableCount'] : ['EventDirectoryAvailableCount', variables];
;

export const useInfiniteEventDirectoryAvailableCountQuery = <
      TData = EventDirectoryAvailableCountQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventDirectoryAvailableCountQueryVariables,
      variables?: EventDirectoryAvailableCountQueryVariables,
      options?: UseInfiniteQueryOptions<EventDirectoryAvailableCountQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventDirectoryAvailableCountQuery, TError, TData>(
      variables === undefined ? ['EventDirectoryAvailableCount.infinite'] : ['EventDirectoryAvailableCount.infinite', variables],
      (metaData) => fetcher<EventDirectoryAvailableCountQuery, EventDirectoryAvailableCountQueryVariables>(EventDirectoryAvailableCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventDirectoryAvailableCountQuery.getKey = (variables?: EventDirectoryAvailableCountQueryVariables) => variables === undefined ? ['EventDirectoryAvailableCount.infinite'] : ['EventDirectoryAvailableCount.infinite', variables];
;

useEventDirectoryAvailableCountQuery.fetcher = (variables?: EventDirectoryAvailableCountQueryVariables) => fetcher<EventDirectoryAvailableCountQuery, EventDirectoryAvailableCountQueryVariables>(EventDirectoryAvailableCountDocument, variables);
export const EventRegistrationModalDemographicInfoDocument = `
    query EventRegistrationModalDemographicInfo($eventId: ID!, $orgFriendlyName: String!) {
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    __typename
    ... on CandidatePhysicalEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalDemographicInfoMyPotentialProfileFields
      }
    }
    ... on CandidateWebinarEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalDemographicInfoMyPotentialProfileFields
      }
    }
    ... on CandidateVirtualChatEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalDemographicInfoMyPotentialProfileFields
      }
    }
  }
}
    ${EventRegistrationModalDemographicInfoMyPotentialProfileFieldsFragmentDoc}`;
export const useEventRegistrationModalDemographicInfoQuery = <
      TData = EventRegistrationModalDemographicInfoQuery,
      TError = unknown
    >(
      variables: EventRegistrationModalDemographicInfoQueryVariables,
      options?: UseQueryOptions<EventRegistrationModalDemographicInfoQuery, TError, TData>
    ) =>
    useQuery<EventRegistrationModalDemographicInfoQuery, TError, TData>(
      ['EventRegistrationModalDemographicInfo', variables],
      fetcher<EventRegistrationModalDemographicInfoQuery, EventRegistrationModalDemographicInfoQueryVariables>(EventRegistrationModalDemographicInfoDocument, variables),
      options
    );

useEventRegistrationModalDemographicInfoQuery.getKey = (variables: EventRegistrationModalDemographicInfoQueryVariables) => ['EventRegistrationModalDemographicInfo', variables];
;

export const useInfiniteEventRegistrationModalDemographicInfoQuery = <
      TData = EventRegistrationModalDemographicInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventRegistrationModalDemographicInfoQueryVariables,
      variables: EventRegistrationModalDemographicInfoQueryVariables,
      options?: UseInfiniteQueryOptions<EventRegistrationModalDemographicInfoQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventRegistrationModalDemographicInfoQuery, TError, TData>(
      ['EventRegistrationModalDemographicInfo.infinite', variables],
      (metaData) => fetcher<EventRegistrationModalDemographicInfoQuery, EventRegistrationModalDemographicInfoQueryVariables>(EventRegistrationModalDemographicInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventRegistrationModalDemographicInfoQuery.getKey = (variables: EventRegistrationModalDemographicInfoQueryVariables) => ['EventRegistrationModalDemographicInfo.infinite', variables];
;

useEventRegistrationModalDemographicInfoQuery.fetcher = (variables: EventRegistrationModalDemographicInfoQueryVariables) => fetcher<EventRegistrationModalDemographicInfoQuery, EventRegistrationModalDemographicInfoQueryVariables>(EventRegistrationModalDemographicInfoDocument, variables);
export const EventRegistrationSubmitDemographicInfoDocument = `
    mutation EventRegistrationSubmitDemographicInfo($input: SubmitDemographicAnswersForOutreachEventCandidateRegistrationInput!, $shouldCompleteRegistration: Boolean!, $finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput!) {
  submitDemographicAnswersForOutreachEventCandidateRegistration(input: $input) {
    success
  }
  completeOutreachEventCandidateRegistration(input: $finishRegistrationInput) @include(if: $shouldCompleteRegistration) {
    success
  }
}
    `;
export const useEventRegistrationSubmitDemographicInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EventRegistrationSubmitDemographicInfoMutation, TError, EventRegistrationSubmitDemographicInfoMutationVariables, TContext>) =>
    useMutation<EventRegistrationSubmitDemographicInfoMutation, TError, EventRegistrationSubmitDemographicInfoMutationVariables, TContext>(
      ['EventRegistrationSubmitDemographicInfo'],
      (variables?: EventRegistrationSubmitDemographicInfoMutationVariables) => fetcher<EventRegistrationSubmitDemographicInfoMutation, EventRegistrationSubmitDemographicInfoMutationVariables>(EventRegistrationSubmitDemographicInfoDocument, variables)(),
      options
    );
useEventRegistrationSubmitDemographicInfoMutation.fetcher = (variables: EventRegistrationSubmitDemographicInfoMutationVariables) => fetcher<EventRegistrationSubmitDemographicInfoMutation, EventRegistrationSubmitDemographicInfoMutationVariables>(EventRegistrationSubmitDemographicInfoDocument, variables);
export const EventRegistrationModalDocumentSubmissionDocument = `
    query EventRegistrationModalDocumentSubmission($eventId: ID!, $orgFriendlyName: String!) {
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    __typename
    id
    ... on CandidatePhysicalEventNode {
      documentAssignments {
        ...EventRegistrationModalDocumentFields
      }
      myPotentialProfiles {
        ...EventRegistrationModalDocumentSubmissionMyPotentialProfileFields
      }
    }
    ... on CandidateWebinarEventNode {
      documentAssignments {
        ...EventRegistrationModalDocumentFields
      }
      myPotentialProfiles {
        ...EventRegistrationModalDocumentSubmissionMyPotentialProfileFields
      }
    }
    ... on CandidateVirtualChatEventNode {
      documentAssignments {
        ...EventRegistrationModalDocumentFields
      }
      myPotentialProfiles {
        ...EventRegistrationModalDocumentSubmissionMyPotentialProfileFields
      }
    }
  }
}
    ${EventRegistrationModalDocumentFieldsFragmentDoc}
${EventRegistrationModalDocumentSubmissionMyPotentialProfileFieldsFragmentDoc}`;
export const useEventRegistrationModalDocumentSubmissionQuery = <
      TData = EventRegistrationModalDocumentSubmissionQuery,
      TError = unknown
    >(
      variables: EventRegistrationModalDocumentSubmissionQueryVariables,
      options?: UseQueryOptions<EventRegistrationModalDocumentSubmissionQuery, TError, TData>
    ) =>
    useQuery<EventRegistrationModalDocumentSubmissionQuery, TError, TData>(
      ['EventRegistrationModalDocumentSubmission', variables],
      fetcher<EventRegistrationModalDocumentSubmissionQuery, EventRegistrationModalDocumentSubmissionQueryVariables>(EventRegistrationModalDocumentSubmissionDocument, variables),
      options
    );

useEventRegistrationModalDocumentSubmissionQuery.getKey = (variables: EventRegistrationModalDocumentSubmissionQueryVariables) => ['EventRegistrationModalDocumentSubmission', variables];
;

export const useInfiniteEventRegistrationModalDocumentSubmissionQuery = <
      TData = EventRegistrationModalDocumentSubmissionQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventRegistrationModalDocumentSubmissionQueryVariables,
      variables: EventRegistrationModalDocumentSubmissionQueryVariables,
      options?: UseInfiniteQueryOptions<EventRegistrationModalDocumentSubmissionQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventRegistrationModalDocumentSubmissionQuery, TError, TData>(
      ['EventRegistrationModalDocumentSubmission.infinite', variables],
      (metaData) => fetcher<EventRegistrationModalDocumentSubmissionQuery, EventRegistrationModalDocumentSubmissionQueryVariables>(EventRegistrationModalDocumentSubmissionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventRegistrationModalDocumentSubmissionQuery.getKey = (variables: EventRegistrationModalDocumentSubmissionQueryVariables) => ['EventRegistrationModalDocumentSubmission.infinite', variables];
;

useEventRegistrationModalDocumentSubmissionQuery.fetcher = (variables: EventRegistrationModalDocumentSubmissionQueryVariables) => fetcher<EventRegistrationModalDocumentSubmissionQuery, EventRegistrationModalDocumentSubmissionQueryVariables>(EventRegistrationModalDocumentSubmissionDocument, variables);
export const EventRegistrationSubmitDocumentsDocument = `
    mutation EventRegistrationSubmitDocuments($input: SubmitDocumentsForEmployerEventInput!, $shouldCompleteRegistration: Boolean!, $finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput!) {
  submitDocumentsForEmployerEvent(input: $input) {
    success
  }
  completeOutreachEventCandidateRegistration(input: $finishRegistrationInput) @include(if: $shouldCompleteRegistration) {
    success
  }
}
    `;
export const useEventRegistrationSubmitDocumentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EventRegistrationSubmitDocumentsMutation, TError, EventRegistrationSubmitDocumentsMutationVariables, TContext>) =>
    useMutation<EventRegistrationSubmitDocumentsMutation, TError, EventRegistrationSubmitDocumentsMutationVariables, TContext>(
      ['EventRegistrationSubmitDocuments'],
      (variables?: EventRegistrationSubmitDocumentsMutationVariables) => fetcher<EventRegistrationSubmitDocumentsMutation, EventRegistrationSubmitDocumentsMutationVariables>(EventRegistrationSubmitDocumentsDocument, variables)(),
      options
    );
useEventRegistrationSubmitDocumentsMutation.fetcher = (variables: EventRegistrationSubmitDocumentsMutationVariables) => fetcher<EventRegistrationSubmitDocumentsMutation, EventRegistrationSubmitDocumentsMutationVariables>(EventRegistrationSubmitDocumentsDocument, variables);
export const EventRegistrationModalDocument = `
    query EventRegistrationModal($eventId: ID!, $orgFriendlyName: String!) {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      loggedInEmail
      profile {
        firstName
        lastName
        phoneNumber
        linkedInUrl
      }
    }
  }
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    __typename
    id
    name
    host {
      id
      logoUrl
      name
      hasPublicFirmProfile
    }
    ... on CandidatePhysicalEventNode {
      deiRequested
      assignedQualifyingQuestions {
        totalCount
      }
      documentAssignments {
        ...EventRegistrationModalDocumentFields
      }
      headshotUploadRequested
      isInviteOnly
      myPotentialProfiles {
        nodes {
          isRegistered
          recruitId
        }
      }
    }
    ... on CandidateWebinarEventNode {
      deiRequested
      assignedQualifyingQuestions {
        totalCount
      }
      documentAssignments {
        ...EventRegistrationModalDocumentFields
      }
      headshotUploadRequested
      isInviteOnly
      myPotentialProfiles {
        nodes {
          isRegistered
          recruitId
        }
      }
    }
    ... on CandidateVirtualChatEventNode {
      deiRequested
      assignedQualifyingQuestions {
        totalCount
      }
      documentAssignments {
        ...EventRegistrationModalDocumentFields
      }
      headshotUploadRequested
      isInviteOnly
      myPotentialProfiles {
        nodes {
          isRegistered
          recruitId
        }
      }
    }
  }
}
    ${EventRegistrationModalDocumentFieldsFragmentDoc}`;
export const useEventRegistrationModalQuery = <
      TData = EventRegistrationModalQuery,
      TError = unknown
    >(
      variables: EventRegistrationModalQueryVariables,
      options?: UseQueryOptions<EventRegistrationModalQuery, TError, TData>
    ) =>
    useQuery<EventRegistrationModalQuery, TError, TData>(
      ['EventRegistrationModal', variables],
      fetcher<EventRegistrationModalQuery, EventRegistrationModalQueryVariables>(EventRegistrationModalDocument, variables),
      options
    );

useEventRegistrationModalQuery.getKey = (variables: EventRegistrationModalQueryVariables) => ['EventRegistrationModal', variables];
;

export const useInfiniteEventRegistrationModalQuery = <
      TData = EventRegistrationModalQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventRegistrationModalQueryVariables,
      variables: EventRegistrationModalQueryVariables,
      options?: UseInfiniteQueryOptions<EventRegistrationModalQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventRegistrationModalQuery, TError, TData>(
      ['EventRegistrationModal.infinite', variables],
      (metaData) => fetcher<EventRegistrationModalQuery, EventRegistrationModalQueryVariables>(EventRegistrationModalDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventRegistrationModalQuery.getKey = (variables: EventRegistrationModalQueryVariables) => ['EventRegistrationModal.infinite', variables];
;

useEventRegistrationModalQuery.fetcher = (variables: EventRegistrationModalQueryVariables) => fetcher<EventRegistrationModalQuery, EventRegistrationModalQueryVariables>(EventRegistrationModalDocument, variables);
export const TrackForwardEventStartRegistrationDocument = `
    mutation TrackForwardEventStartRegistration($input: TrackForwardEventStartRegistrationInput!) {
  trackForwardEventStartRegistration(input: $input) {
    success
  }
}
    `;
export const useTrackForwardEventStartRegistrationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TrackForwardEventStartRegistrationMutation, TError, TrackForwardEventStartRegistrationMutationVariables, TContext>) =>
    useMutation<TrackForwardEventStartRegistrationMutation, TError, TrackForwardEventStartRegistrationMutationVariables, TContext>(
      ['TrackForwardEventStartRegistration'],
      (variables?: TrackForwardEventStartRegistrationMutationVariables) => fetcher<TrackForwardEventStartRegistrationMutation, TrackForwardEventStartRegistrationMutationVariables>(TrackForwardEventStartRegistrationDocument, variables)(),
      options
    );
useTrackForwardEventStartRegistrationMutation.fetcher = (variables: TrackForwardEventStartRegistrationMutationVariables) => fetcher<TrackForwardEventStartRegistrationMutation, TrackForwardEventStartRegistrationMutationVariables>(TrackForwardEventStartRegistrationDocument, variables);
export const TrackForwardEventCompleteRegistrationDocument = `
    mutation TrackForwardEventCompleteRegistration($input: TrackForwardEventCompleteRegistrationInput!) {
  trackForwardEventCompleteRegistration(input: $input) {
    success
  }
}
    `;
export const useTrackForwardEventCompleteRegistrationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TrackForwardEventCompleteRegistrationMutation, TError, TrackForwardEventCompleteRegistrationMutationVariables, TContext>) =>
    useMutation<TrackForwardEventCompleteRegistrationMutation, TError, TrackForwardEventCompleteRegistrationMutationVariables, TContext>(
      ['TrackForwardEventCompleteRegistration'],
      (variables?: TrackForwardEventCompleteRegistrationMutationVariables) => fetcher<TrackForwardEventCompleteRegistrationMutation, TrackForwardEventCompleteRegistrationMutationVariables>(TrackForwardEventCompleteRegistrationDocument, variables)(),
      options
    );
useTrackForwardEventCompleteRegistrationMutation.fetcher = (variables: TrackForwardEventCompleteRegistrationMutationVariables) => fetcher<TrackForwardEventCompleteRegistrationMutation, TrackForwardEventCompleteRegistrationMutationVariables>(TrackForwardEventCompleteRegistrationDocument, variables);
export const EventRegistrationModalPersonalInfoDocument = `
    query EventRegistrationModalPersonalInfo($eventId: ID!, $orgFriendlyName: String!) {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      loggedInEmail
      profile {
        firstName
        lastName
        phoneNumber
        linkedInUrl
      }
    }
  }
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    __typename
    ... on CandidatePhysicalEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalPersonalInfoMyPotentialProfileFields
      }
    }
    ... on CandidateWebinarEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalPersonalInfoMyPotentialProfileFields
      }
    }
    ... on CandidateVirtualChatEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalPersonalInfoMyPotentialProfileFields
      }
    }
  }
}
    ${EventRegistrationModalPersonalInfoMyPotentialProfileFieldsFragmentDoc}`;
export const useEventRegistrationModalPersonalInfoQuery = <
      TData = EventRegistrationModalPersonalInfoQuery,
      TError = unknown
    >(
      variables: EventRegistrationModalPersonalInfoQueryVariables,
      options?: UseQueryOptions<EventRegistrationModalPersonalInfoQuery, TError, TData>
    ) =>
    useQuery<EventRegistrationModalPersonalInfoQuery, TError, TData>(
      ['EventRegistrationModalPersonalInfo', variables],
      fetcher<EventRegistrationModalPersonalInfoQuery, EventRegistrationModalPersonalInfoQueryVariables>(EventRegistrationModalPersonalInfoDocument, variables),
      options
    );

useEventRegistrationModalPersonalInfoQuery.getKey = (variables: EventRegistrationModalPersonalInfoQueryVariables) => ['EventRegistrationModalPersonalInfo', variables];
;

export const useInfiniteEventRegistrationModalPersonalInfoQuery = <
      TData = EventRegistrationModalPersonalInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventRegistrationModalPersonalInfoQueryVariables,
      variables: EventRegistrationModalPersonalInfoQueryVariables,
      options?: UseInfiniteQueryOptions<EventRegistrationModalPersonalInfoQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventRegistrationModalPersonalInfoQuery, TError, TData>(
      ['EventRegistrationModalPersonalInfo.infinite', variables],
      (metaData) => fetcher<EventRegistrationModalPersonalInfoQuery, EventRegistrationModalPersonalInfoQueryVariables>(EventRegistrationModalPersonalInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventRegistrationModalPersonalInfoQuery.getKey = (variables: EventRegistrationModalPersonalInfoQueryVariables) => ['EventRegistrationModalPersonalInfo.infinite', variables];
;

useEventRegistrationModalPersonalInfoQuery.fetcher = (variables: EventRegistrationModalPersonalInfoQueryVariables) => fetcher<EventRegistrationModalPersonalInfoQuery, EventRegistrationModalPersonalInfoQueryVariables>(EventRegistrationModalPersonalInfoDocument, variables);
export const EventRegistrationSubmitPersonalInfoDocument = `
    mutation EventRegistrationSubmitPersonalInfo($input: SubmitPersonalInfoForOutreachEventCandidateRegistrationInput!, $shouldCompleteRegistration: Boolean!, $finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput!) {
  submitPersonalInfoForOutreachEventCandidateRegistration(input: $input) {
    success
  }
  completeOutreachEventCandidateRegistration(input: $finishRegistrationInput) @include(if: $shouldCompleteRegistration) {
    success
  }
}
    `;
export const useEventRegistrationSubmitPersonalInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EventRegistrationSubmitPersonalInfoMutation, TError, EventRegistrationSubmitPersonalInfoMutationVariables, TContext>) =>
    useMutation<EventRegistrationSubmitPersonalInfoMutation, TError, EventRegistrationSubmitPersonalInfoMutationVariables, TContext>(
      ['EventRegistrationSubmitPersonalInfo'],
      (variables?: EventRegistrationSubmitPersonalInfoMutationVariables) => fetcher<EventRegistrationSubmitPersonalInfoMutation, EventRegistrationSubmitPersonalInfoMutationVariables>(EventRegistrationSubmitPersonalInfoDocument, variables)(),
      options
    );
useEventRegistrationSubmitPersonalInfoMutation.fetcher = (variables: EventRegistrationSubmitPersonalInfoMutationVariables) => fetcher<EventRegistrationSubmitPersonalInfoMutation, EventRegistrationSubmitPersonalInfoMutationVariables>(EventRegistrationSubmitPersonalInfoDocument, variables);
export const EventRegistrationModalQualifyingQuestionsDocument = `
    query EventRegistrationModalQualifyingQuestions($eventId: ID!, $orgFriendlyName: String!) {
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    __typename
    id
    ... on CandidatePhysicalEventNode {
      assignedQualifyingQuestions {
        ...EventRegistrationModalQualifyingQuestionFields
      }
      myPotentialProfiles {
        ...EventRegistrationModalQualifyingQuestionsMyPotentialProfileFields
      }
    }
    ... on CandidateWebinarEventNode {
      assignedQualifyingQuestions {
        ...EventRegistrationModalQualifyingQuestionFields
      }
      myPotentialProfiles {
        ...EventRegistrationModalQualifyingQuestionsMyPotentialProfileFields
      }
    }
    ... on CandidateVirtualChatEventNode {
      assignedQualifyingQuestions {
        ...EventRegistrationModalQualifyingQuestionFields
      }
      myPotentialProfiles {
        ...EventRegistrationModalQualifyingQuestionsMyPotentialProfileFields
      }
    }
  }
}
    ${EventRegistrationModalQualifyingQuestionFieldsFragmentDoc}
${EventRegistrationModalQualifyingQuestionsMyPotentialProfileFieldsFragmentDoc}`;
export const useEventRegistrationModalQualifyingQuestionsQuery = <
      TData = EventRegistrationModalQualifyingQuestionsQuery,
      TError = unknown
    >(
      variables: EventRegistrationModalQualifyingQuestionsQueryVariables,
      options?: UseQueryOptions<EventRegistrationModalQualifyingQuestionsQuery, TError, TData>
    ) =>
    useQuery<EventRegistrationModalQualifyingQuestionsQuery, TError, TData>(
      ['EventRegistrationModalQualifyingQuestions', variables],
      fetcher<EventRegistrationModalQualifyingQuestionsQuery, EventRegistrationModalQualifyingQuestionsQueryVariables>(EventRegistrationModalQualifyingQuestionsDocument, variables),
      options
    );

useEventRegistrationModalQualifyingQuestionsQuery.getKey = (variables: EventRegistrationModalQualifyingQuestionsQueryVariables) => ['EventRegistrationModalQualifyingQuestions', variables];
;

export const useInfiniteEventRegistrationModalQualifyingQuestionsQuery = <
      TData = EventRegistrationModalQualifyingQuestionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventRegistrationModalQualifyingQuestionsQueryVariables,
      variables: EventRegistrationModalQualifyingQuestionsQueryVariables,
      options?: UseInfiniteQueryOptions<EventRegistrationModalQualifyingQuestionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventRegistrationModalQualifyingQuestionsQuery, TError, TData>(
      ['EventRegistrationModalQualifyingQuestions.infinite', variables],
      (metaData) => fetcher<EventRegistrationModalQualifyingQuestionsQuery, EventRegistrationModalQualifyingQuestionsQueryVariables>(EventRegistrationModalQualifyingQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventRegistrationModalQualifyingQuestionsQuery.getKey = (variables: EventRegistrationModalQualifyingQuestionsQueryVariables) => ['EventRegistrationModalQualifyingQuestions.infinite', variables];
;

useEventRegistrationModalQualifyingQuestionsQuery.fetcher = (variables: EventRegistrationModalQualifyingQuestionsQueryVariables) => fetcher<EventRegistrationModalQualifyingQuestionsQuery, EventRegistrationModalQualifyingQuestionsQueryVariables>(EventRegistrationModalQualifyingQuestionsDocument, variables);
export const EventRegistrationSubmitQualifyingQuestionAnswersDocument = `
    mutation EventRegistrationSubmitQualifyingQuestionAnswers($input: SubmitQualifyingQuestionAnswersForOutreachEventCandidateRegistrationInput!, $shouldCompleteRegistration: Boolean!, $finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput!) {
  submitQualifyingQuestionAnswersForOutreachEventCandidateRegistration(
    input: $input
  ) {
    success
  }
  completeOutreachEventCandidateRegistration(input: $finishRegistrationInput) @include(if: $shouldCompleteRegistration) {
    success
  }
}
    `;
export const useEventRegistrationSubmitQualifyingQuestionAnswersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EventRegistrationSubmitQualifyingQuestionAnswersMutation, TError, EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables, TContext>) =>
    useMutation<EventRegistrationSubmitQualifyingQuestionAnswersMutation, TError, EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables, TContext>(
      ['EventRegistrationSubmitQualifyingQuestionAnswers'],
      (variables?: EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables) => fetcher<EventRegistrationSubmitQualifyingQuestionAnswersMutation, EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables>(EventRegistrationSubmitQualifyingQuestionAnswersDocument, variables)(),
      options
    );
useEventRegistrationSubmitQualifyingQuestionAnswersMutation.fetcher = (variables: EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables) => fetcher<EventRegistrationSubmitQualifyingQuestionAnswersMutation, EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables>(EventRegistrationSubmitQualifyingQuestionAnswersDocument, variables);
export const EventRegistrationModalVirtualChatSchedulerDocument = `
    query EventRegistrationModalVirtualChatScheduler($eventId: ID!, $orgFriendlyName: String!) {
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    __typename
    id
    ... on CandidateVirtualChatEventNode {
      maxNumTimeslotsForCandidate
      areAllTimeslotsFull
      schedules {
        nodes {
          id
          orgId
          eventId
          members {
            nodes {
              id
              orgId
              firstName
              lastName
              rawBioLink
              bioLink
            }
          }
          timeslots {
            nodes {
              id
              orgId
              eventId
              scheduleId
              start {
                date
                time
                zone
              }
              end {
                date
                time
                zone
              }
              maxCandidateCapacity
              numCandidatesRegistered
              rawVideoLink
              videoLink
            }
          }
        }
      }
      contact {
        firstName
        lastName
        email
      }
      myPotentialProfiles {
        nodes {
          timeslotChoices {
            nodes {
              timeslotId
            }
          }
        }
      }
    }
  }
}
    `;
export const useEventRegistrationModalVirtualChatSchedulerQuery = <
      TData = EventRegistrationModalVirtualChatSchedulerQuery,
      TError = unknown
    >(
      variables: EventRegistrationModalVirtualChatSchedulerQueryVariables,
      options?: UseQueryOptions<EventRegistrationModalVirtualChatSchedulerQuery, TError, TData>
    ) =>
    useQuery<EventRegistrationModalVirtualChatSchedulerQuery, TError, TData>(
      ['EventRegistrationModalVirtualChatScheduler', variables],
      fetcher<EventRegistrationModalVirtualChatSchedulerQuery, EventRegistrationModalVirtualChatSchedulerQueryVariables>(EventRegistrationModalVirtualChatSchedulerDocument, variables),
      options
    );

useEventRegistrationModalVirtualChatSchedulerQuery.getKey = (variables: EventRegistrationModalVirtualChatSchedulerQueryVariables) => ['EventRegistrationModalVirtualChatScheduler', variables];
;

export const useInfiniteEventRegistrationModalVirtualChatSchedulerQuery = <
      TData = EventRegistrationModalVirtualChatSchedulerQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventRegistrationModalVirtualChatSchedulerQueryVariables,
      variables: EventRegistrationModalVirtualChatSchedulerQueryVariables,
      options?: UseInfiniteQueryOptions<EventRegistrationModalVirtualChatSchedulerQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventRegistrationModalVirtualChatSchedulerQuery, TError, TData>(
      ['EventRegistrationModalVirtualChatScheduler.infinite', variables],
      (metaData) => fetcher<EventRegistrationModalVirtualChatSchedulerQuery, EventRegistrationModalVirtualChatSchedulerQueryVariables>(EventRegistrationModalVirtualChatSchedulerDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventRegistrationModalVirtualChatSchedulerQuery.getKey = (variables: EventRegistrationModalVirtualChatSchedulerQueryVariables) => ['EventRegistrationModalVirtualChatScheduler.infinite', variables];
;

useEventRegistrationModalVirtualChatSchedulerQuery.fetcher = (variables: EventRegistrationModalVirtualChatSchedulerQueryVariables) => fetcher<EventRegistrationModalVirtualChatSchedulerQuery, EventRegistrationModalVirtualChatSchedulerQueryVariables>(EventRegistrationModalVirtualChatSchedulerDocument, variables);
export const EventRegistrationSubmitVirtualChatTimeslotSelectionsDocument = `
    mutation EventRegistrationSubmitVirtualChatTimeslotSelections($input: SubmitVirtualChatRecruitTimeslotSelectionsInput!) {
  submitVirtualChatRecruitTimeslotSelections(input: $input) {
    success
  }
}
    `;
export const useEventRegistrationSubmitVirtualChatTimeslotSelectionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EventRegistrationSubmitVirtualChatTimeslotSelectionsMutation, TError, EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables, TContext>) =>
    useMutation<EventRegistrationSubmitVirtualChatTimeslotSelectionsMutation, TError, EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables, TContext>(
      ['EventRegistrationSubmitVirtualChatTimeslotSelections'],
      (variables?: EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables) => fetcher<EventRegistrationSubmitVirtualChatTimeslotSelectionsMutation, EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables>(EventRegistrationSubmitVirtualChatTimeslotSelectionsDocument, variables)(),
      options
    );
useEventRegistrationSubmitVirtualChatTimeslotSelectionsMutation.fetcher = (variables: EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables) => fetcher<EventRegistrationSubmitVirtualChatTimeslotSelectionsMutation, EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables>(EventRegistrationSubmitVirtualChatTimeslotSelectionsDocument, variables);
export const EventRegistrationModalSubmitHeadshotDocument = `
    query EventRegistrationModalSubmitHeadshot($eventId: ID!, $orgFriendlyName: String!) {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      loggedInEmail
      profile {
        firstName
        lastName
        profilePhotoUrl
      }
    }
  }
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    __typename
    id
    ... on CandidatePhysicalEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalSubmitHeadshotMyPotentialProfileFields
      }
    }
    ... on CandidateWebinarEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalSubmitHeadshotMyPotentialProfileFields
      }
    }
    ... on CandidateVirtualChatEventNode {
      myPotentialProfiles {
        ...EventRegistrationModalSubmitHeadshotMyPotentialProfileFields
      }
    }
  }
}
    ${EventRegistrationModalSubmitHeadshotMyPotentialProfileFieldsFragmentDoc}`;
export const useEventRegistrationModalSubmitHeadshotQuery = <
      TData = EventRegistrationModalSubmitHeadshotQuery,
      TError = unknown
    >(
      variables: EventRegistrationModalSubmitHeadshotQueryVariables,
      options?: UseQueryOptions<EventRegistrationModalSubmitHeadshotQuery, TError, TData>
    ) =>
    useQuery<EventRegistrationModalSubmitHeadshotQuery, TError, TData>(
      ['EventRegistrationModalSubmitHeadshot', variables],
      fetcher<EventRegistrationModalSubmitHeadshotQuery, EventRegistrationModalSubmitHeadshotQueryVariables>(EventRegistrationModalSubmitHeadshotDocument, variables),
      options
    );

useEventRegistrationModalSubmitHeadshotQuery.getKey = (variables: EventRegistrationModalSubmitHeadshotQueryVariables) => ['EventRegistrationModalSubmitHeadshot', variables];
;

export const useInfiniteEventRegistrationModalSubmitHeadshotQuery = <
      TData = EventRegistrationModalSubmitHeadshotQuery,
      TError = unknown
    >(
      pageParamKey: keyof EventRegistrationModalSubmitHeadshotQueryVariables,
      variables: EventRegistrationModalSubmitHeadshotQueryVariables,
      options?: UseInfiniteQueryOptions<EventRegistrationModalSubmitHeadshotQuery, TError, TData>
    ) =>
    useInfiniteQuery<EventRegistrationModalSubmitHeadshotQuery, TError, TData>(
      ['EventRegistrationModalSubmitHeadshot.infinite', variables],
      (metaData) => fetcher<EventRegistrationModalSubmitHeadshotQuery, EventRegistrationModalSubmitHeadshotQueryVariables>(EventRegistrationModalSubmitHeadshotDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEventRegistrationModalSubmitHeadshotQuery.getKey = (variables: EventRegistrationModalSubmitHeadshotQueryVariables) => ['EventRegistrationModalSubmitHeadshot.infinite', variables];
;

useEventRegistrationModalSubmitHeadshotQuery.fetcher = (variables: EventRegistrationModalSubmitHeadshotQueryVariables) => fetcher<EventRegistrationModalSubmitHeadshotQuery, EventRegistrationModalSubmitHeadshotQueryVariables>(EventRegistrationModalSubmitHeadshotDocument, variables);
export const EventRegistrationSubmitHeadshotDocument = `
    mutation EventRegistrationSubmitHeadshot($input: SubmitHeadshotForOutreachEventCandidateRegistrationInput!, $shouldCompleteRegistration: Boolean!, $finishRegistrationInput: CompleteOutreachEventCandidateRegistrationInput!) {
  submitHeadshotForOutreachEventCandidateRegistration(input: $input) {
    success
  }
  completeOutreachEventCandidateRegistration(input: $finishRegistrationInput) @include(if: $shouldCompleteRegistration) {
    success
  }
}
    `;
export const useEventRegistrationSubmitHeadshotMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EventRegistrationSubmitHeadshotMutation, TError, EventRegistrationSubmitHeadshotMutationVariables, TContext>) =>
    useMutation<EventRegistrationSubmitHeadshotMutation, TError, EventRegistrationSubmitHeadshotMutationVariables, TContext>(
      ['EventRegistrationSubmitHeadshot'],
      (variables?: EventRegistrationSubmitHeadshotMutationVariables) => fetcher<EventRegistrationSubmitHeadshotMutation, EventRegistrationSubmitHeadshotMutationVariables>(EventRegistrationSubmitHeadshotDocument, variables)(),
      options
    );
useEventRegistrationSubmitHeadshotMutation.fetcher = (variables: EventRegistrationSubmitHeadshotMutationVariables) => fetcher<EventRegistrationSubmitHeadshotMutation, EventRegistrationSubmitHeadshotMutationVariables>(EventRegistrationSubmitHeadshotDocument, variables);
export const ForwardAccountDocument = `
    query ForwardAccount {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      emails {
        email
        isPrimary
      }
      profile {
        ...ForwardProfile
      }
      shouldShowEventsInterviewsFeedGettingStarted
    }
  }
}
    ${ForwardProfileFragmentDoc}
${ForwardProfileFormFragmentDoc}`;
export const useForwardAccountQuery = <
      TData = ForwardAccountQuery,
      TError = unknown
    >(
      variables?: ForwardAccountQueryVariables,
      options?: UseQueryOptions<ForwardAccountQuery, TError, TData>
    ) =>
    useQuery<ForwardAccountQuery, TError, TData>(
      variables === undefined ? ['ForwardAccount'] : ['ForwardAccount', variables],
      fetcher<ForwardAccountQuery, ForwardAccountQueryVariables>(ForwardAccountDocument, variables),
      options
    );

useForwardAccountQuery.getKey = (variables?: ForwardAccountQueryVariables) => variables === undefined ? ['ForwardAccount'] : ['ForwardAccount', variables];
;

export const useInfiniteForwardAccountQuery = <
      TData = ForwardAccountQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardAccountQueryVariables,
      variables?: ForwardAccountQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardAccountQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardAccountQuery, TError, TData>(
      variables === undefined ? ['ForwardAccount.infinite'] : ['ForwardAccount.infinite', variables],
      (metaData) => fetcher<ForwardAccountQuery, ForwardAccountQueryVariables>(ForwardAccountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardAccountQuery.getKey = (variables?: ForwardAccountQueryVariables) => variables === undefined ? ['ForwardAccount.infinite'] : ['ForwardAccount.infinite', variables];
;

useForwardAccountQuery.fetcher = (variables?: ForwardAccountQueryVariables) => fetcher<ForwardAccountQuery, ForwardAccountQueryVariables>(ForwardAccountDocument, variables);
export const SendAddEmailToForwardAccountLinkDocument = `
    mutation SendAddEmailToForwardAccountLink($input: SendAddEmailToForwardAccountLinkInput!) {
  sendAddEmailToForwardAccountLink(input: $input) {
    __typename
    ... on SendAddEmailToForwardAccountLinkSuccess {
      email
    }
    ... on UserWarning {
      userMessage
    }
  }
}
    `;
export const useSendAddEmailToForwardAccountLinkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendAddEmailToForwardAccountLinkMutation, TError, SendAddEmailToForwardAccountLinkMutationVariables, TContext>) =>
    useMutation<SendAddEmailToForwardAccountLinkMutation, TError, SendAddEmailToForwardAccountLinkMutationVariables, TContext>(
      ['SendAddEmailToForwardAccountLink'],
      (variables?: SendAddEmailToForwardAccountLinkMutationVariables) => fetcher<SendAddEmailToForwardAccountLinkMutation, SendAddEmailToForwardAccountLinkMutationVariables>(SendAddEmailToForwardAccountLinkDocument, variables)(),
      options
    );
useSendAddEmailToForwardAccountLinkMutation.fetcher = (variables: SendAddEmailToForwardAccountLinkMutationVariables) => fetcher<SendAddEmailToForwardAccountLinkMutation, SendAddEmailToForwardAccountLinkMutationVariables>(SendAddEmailToForwardAccountLinkDocument, variables);
export const RemoveEmailFromForwardAccountDocument = `
    mutation RemoveEmailFromForwardAccount($input: RemoveEmailFromForwardAccountInput!) {
  removeEmailFromForwardAccount(input: $input) {
    __typename
    ... on RemoveEmailFromForwardAccountSuccess {
      successful
    }
    ... on UserWarning {
      userMessage
    }
  }
}
    `;
export const useRemoveEmailFromForwardAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEmailFromForwardAccountMutation, TError, RemoveEmailFromForwardAccountMutationVariables, TContext>) =>
    useMutation<RemoveEmailFromForwardAccountMutation, TError, RemoveEmailFromForwardAccountMutationVariables, TContext>(
      ['RemoveEmailFromForwardAccount'],
      (variables?: RemoveEmailFromForwardAccountMutationVariables) => fetcher<RemoveEmailFromForwardAccountMutation, RemoveEmailFromForwardAccountMutationVariables>(RemoveEmailFromForwardAccountDocument, variables)(),
      options
    );
useRemoveEmailFromForwardAccountMutation.fetcher = (variables: RemoveEmailFromForwardAccountMutationVariables) => fetcher<RemoveEmailFromForwardAccountMutation, RemoveEmailFromForwardAccountMutationVariables>(RemoveEmailFromForwardAccountDocument, variables);
export const IncrementTimesViewedForwardEventsInterviewsFeedDocument = `
    mutation IncrementTimesViewedForwardEventsInterviewsFeed {
  incrementTimesViewedForwardEventsInterviewsFeed {
    successful
  }
}
    `;
export const useIncrementTimesViewedForwardEventsInterviewsFeedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<IncrementTimesViewedForwardEventsInterviewsFeedMutation, TError, IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables, TContext>) =>
    useMutation<IncrementTimesViewedForwardEventsInterviewsFeedMutation, TError, IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables, TContext>(
      ['IncrementTimesViewedForwardEventsInterviewsFeed'],
      (variables?: IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables) => fetcher<IncrementTimesViewedForwardEventsInterviewsFeedMutation, IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables>(IncrementTimesViewedForwardEventsInterviewsFeedDocument, variables)(),
      options
    );
useIncrementTimesViewedForwardEventsInterviewsFeedMutation.fetcher = (variables?: IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables) => fetcher<IncrementTimesViewedForwardEventsInterviewsFeedMutation, IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables>(IncrementTimesViewedForwardEventsInterviewsFeedDocument, variables);
export const EditForwardProfileDocument = `
    mutation EditForwardProfile($input: EditForwardProfileInput!) {
  editForwardProfile(input: $input) {
    success
  }
}
    `;
export const useEditForwardProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditForwardProfileMutation, TError, EditForwardProfileMutationVariables, TContext>) =>
    useMutation<EditForwardProfileMutation, TError, EditForwardProfileMutationVariables, TContext>(
      ['EditForwardProfile'],
      (variables?: EditForwardProfileMutationVariables) => fetcher<EditForwardProfileMutation, EditForwardProfileMutationVariables>(EditForwardProfileDocument, variables)(),
      options
    );
useEditForwardProfileMutation.fetcher = (variables: EditForwardProfileMutationVariables) => fetcher<EditForwardProfileMutation, EditForwardProfileMutationVariables>(EditForwardProfileDocument, variables);
export const ForwardDashboardRecentJobApplicationsDocument = `
    query ForwardDashboardRecentJobApplications($first: Int, $sortBy: ForwardJobApplicationFeedSortBy) {
  forwardJobApplicationFeed(first: $first, sortBy: $sortBy) {
    nodes {
      __typename
      id
      job {
        __typename
        id
        employer {
          name
          logoUrl
          isFloCustomer
          forwardTier {
            asEnum
          }
        }
        title
        offices {
          nodes {
            id
            name
          }
        }
        ... on ExternalJobNode {
          practiceCategories {
            nodes {
              id
              name
            }
          }
          salaryInfo {
            amount
            timeUnit
          }
        }
        ... on InterviewSchedulingJobNode {
          practiceAreas {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const useForwardDashboardRecentJobApplicationsQuery = <
      TData = ForwardDashboardRecentJobApplicationsQuery,
      TError = unknown
    >(
      variables?: ForwardDashboardRecentJobApplicationsQueryVariables,
      options?: UseQueryOptions<ForwardDashboardRecentJobApplicationsQuery, TError, TData>
    ) =>
    useQuery<ForwardDashboardRecentJobApplicationsQuery, TError, TData>(
      variables === undefined ? ['ForwardDashboardRecentJobApplications'] : ['ForwardDashboardRecentJobApplications', variables],
      fetcher<ForwardDashboardRecentJobApplicationsQuery, ForwardDashboardRecentJobApplicationsQueryVariables>(ForwardDashboardRecentJobApplicationsDocument, variables),
      options
    );

useForwardDashboardRecentJobApplicationsQuery.getKey = (variables?: ForwardDashboardRecentJobApplicationsQueryVariables) => variables === undefined ? ['ForwardDashboardRecentJobApplications'] : ['ForwardDashboardRecentJobApplications', variables];
;

export const useInfiniteForwardDashboardRecentJobApplicationsQuery = <
      TData = ForwardDashboardRecentJobApplicationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardDashboardRecentJobApplicationsQueryVariables,
      variables?: ForwardDashboardRecentJobApplicationsQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardDashboardRecentJobApplicationsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardDashboardRecentJobApplicationsQuery, TError, TData>(
      variables === undefined ? ['ForwardDashboardRecentJobApplications.infinite'] : ['ForwardDashboardRecentJobApplications.infinite', variables],
      (metaData) => fetcher<ForwardDashboardRecentJobApplicationsQuery, ForwardDashboardRecentJobApplicationsQueryVariables>(ForwardDashboardRecentJobApplicationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardDashboardRecentJobApplicationsQuery.getKey = (variables?: ForwardDashboardRecentJobApplicationsQueryVariables) => variables === undefined ? ['ForwardDashboardRecentJobApplications.infinite'] : ['ForwardDashboardRecentJobApplications.infinite', variables];
;

useForwardDashboardRecentJobApplicationsQuery.fetcher = (variables?: ForwardDashboardRecentJobApplicationsQueryVariables) => fetcher<ForwardDashboardRecentJobApplicationsQuery, ForwardDashboardRecentJobApplicationsQueryVariables>(ForwardDashboardRecentJobApplicationsDocument, variables);
export const ForwardEventsInterviewsFeedDocument = `
    query ForwardEventsInterviewsFeed($first: Int, $after: String, $filterBy: ForwardEventsInterviewsFeedFilterBy) {
  forwardEventsInterviewsFeed(first: $first, after: $after, filterBy: $filterBy) {
    pageInfo {
      hasNextPage
      endCursor
    }
    progress {
      numTotalEvents
      numTotalInterviews
      numCompletedEvents
      numCompletedInterviews
    }
    totalCount
    edges {
      __typename
      ... on ForwardEventsInterviewsFeedEventEdge {
        cursor
        node {
          ... on CandidateEventNode {
            __typename
            id
            name
            start {
              date
              time
              zone
            }
            end {
              date
              time
              zone
            }
            host {
              ...ForwardDashboardOrgInfo
            }
          }
          ... on CandidatePhysicalEventNode {
            location
            isPublishedToForward
          }
          ... on CandidateWebinarEventNode {
            rawWebinarLink
            webinarLink
            isPublishedToForward
          }
          ... on CandidateSerendipitousEventNode {
            rawEventPageLink
            eventPageLink
          }
          ... on CandidatePreselectEventNode {
            rawJobsPageLink
            jobsPageLink
          }
          ... on LotteryStudentEventNode {
            rawMySchedulePageLink
            mySchedulePageLink
          }
        }
      }
      ... on ForwardEventsInterviewsFeedTimeslotEdge {
        cursor
        metadata {
          eventId
          eventName
          eventType
          hostSchoolName
          hostSchoolLogo
          isPublishedToForward
        }
        node {
          __typename
          id
          start {
            date
            time
            zone
          }
          end {
            date
            time
            zone
          }
          interviewerOrg {
            ...ForwardDashboardOrgInfo
          }
          interviewers {
            id
            firstName
            lastName
          }
          ... on InPersonTimeslotNode {
            location
            roomNumber
            rawVideoLink
            videoLink
          }
          ... on VirtualTimeslotNode {
            rawVideoLink
            videoLink
          }
        }
      }
    }
  }
}
    ${ForwardDashboardOrgInfoFragmentDoc}
${FirmProfileLinkInfoFragmentDoc}`;
export const useForwardEventsInterviewsFeedQuery = <
      TData = ForwardEventsInterviewsFeedQuery,
      TError = unknown
    >(
      variables?: ForwardEventsInterviewsFeedQueryVariables,
      options?: UseQueryOptions<ForwardEventsInterviewsFeedQuery, TError, TData>
    ) =>
    useQuery<ForwardEventsInterviewsFeedQuery, TError, TData>(
      variables === undefined ? ['ForwardEventsInterviewsFeed'] : ['ForwardEventsInterviewsFeed', variables],
      fetcher<ForwardEventsInterviewsFeedQuery, ForwardEventsInterviewsFeedQueryVariables>(ForwardEventsInterviewsFeedDocument, variables),
      options
    );

useForwardEventsInterviewsFeedQuery.getKey = (variables?: ForwardEventsInterviewsFeedQueryVariables) => variables === undefined ? ['ForwardEventsInterviewsFeed'] : ['ForwardEventsInterviewsFeed', variables];
;

export const useInfiniteForwardEventsInterviewsFeedQuery = <
      TData = ForwardEventsInterviewsFeedQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardEventsInterviewsFeedQueryVariables,
      variables?: ForwardEventsInterviewsFeedQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardEventsInterviewsFeedQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardEventsInterviewsFeedQuery, TError, TData>(
      variables === undefined ? ['ForwardEventsInterviewsFeed.infinite'] : ['ForwardEventsInterviewsFeed.infinite', variables],
      (metaData) => fetcher<ForwardEventsInterviewsFeedQuery, ForwardEventsInterviewsFeedQueryVariables>(ForwardEventsInterviewsFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardEventsInterviewsFeedQuery.getKey = (variables?: ForwardEventsInterviewsFeedQueryVariables) => variables === undefined ? ['ForwardEventsInterviewsFeed.infinite'] : ['ForwardEventsInterviewsFeed.infinite', variables];
;

useForwardEventsInterviewsFeedQuery.fetcher = (variables?: ForwardEventsInterviewsFeedQueryVariables) => fetcher<ForwardEventsInterviewsFeedQuery, ForwardEventsInterviewsFeedQueryVariables>(ForwardEventsInterviewsFeedDocument, variables);
export const FirmEventCardRegistrationButtonFieldsByEventIdDocument = `
    query FirmEventCardRegistrationButtonFieldsByEventId($eventId: ID!, $orgFriendlyName: String!) {
  candidateEventById(id: $eventId, orgFriendlyName: $orgFriendlyName) {
    ...FirmEventCardRegistrationButtonFields
  }
}
    ${FirmEventCardRegistrationButtonFieldsFragmentDoc}`;
export const useFirmEventCardRegistrationButtonFieldsByEventIdQuery = <
      TData = FirmEventCardRegistrationButtonFieldsByEventIdQuery,
      TError = unknown
    >(
      variables: FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables,
      options?: UseQueryOptions<FirmEventCardRegistrationButtonFieldsByEventIdQuery, TError, TData>
    ) =>
    useQuery<FirmEventCardRegistrationButtonFieldsByEventIdQuery, TError, TData>(
      ['FirmEventCardRegistrationButtonFieldsByEventId', variables],
      fetcher<FirmEventCardRegistrationButtonFieldsByEventIdQuery, FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables>(FirmEventCardRegistrationButtonFieldsByEventIdDocument, variables),
      options
    );

useFirmEventCardRegistrationButtonFieldsByEventIdQuery.getKey = (variables: FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables) => ['FirmEventCardRegistrationButtonFieldsByEventId', variables];
;

export const useInfiniteFirmEventCardRegistrationButtonFieldsByEventIdQuery = <
      TData = FirmEventCardRegistrationButtonFieldsByEventIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables,
      variables: FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables,
      options?: UseInfiniteQueryOptions<FirmEventCardRegistrationButtonFieldsByEventIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<FirmEventCardRegistrationButtonFieldsByEventIdQuery, TError, TData>(
      ['FirmEventCardRegistrationButtonFieldsByEventId.infinite', variables],
      (metaData) => fetcher<FirmEventCardRegistrationButtonFieldsByEventIdQuery, FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables>(FirmEventCardRegistrationButtonFieldsByEventIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFirmEventCardRegistrationButtonFieldsByEventIdQuery.getKey = (variables: FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables) => ['FirmEventCardRegistrationButtonFieldsByEventId.infinite', variables];
;

useFirmEventCardRegistrationButtonFieldsByEventIdQuery.fetcher = (variables: FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables) => fetcher<FirmEventCardRegistrationButtonFieldsByEventIdQuery, FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables>(FirmEventCardRegistrationButtonFieldsByEventIdDocument, variables);
export const ManageForwardEventPublishingSettingsDocument = `
    query ManageForwardEventPublishingSettings($eventId: Int!) {
  eventById(eventId: $eventId) {
    id
    orgId
    name
    __typename
    ... on PhysicalEventNode {
      associatedUniversityName
      forwardEventPublishingSettings {
        carouselEventShown
        directoryEventShown
      }
      targetedSchools {
        nodes {
          id
          name
        }
      }
    }
    ... on WebinarEventNode {
      associatedUniversityName
      forwardEventPublishingSettings {
        carouselEventShown
        directoryEventShown
      }
      targetedSchools {
        nodes {
          id
          name
        }
      }
    }
    ... on CoffeeChatEventNode {
      associatedUniversityName
      forwardEventPublishingSettings {
        carouselEventShown
        directoryEventShown
      }
      targetedSchools {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
export const useManageForwardEventPublishingSettingsQuery = <
      TData = ManageForwardEventPublishingSettingsQuery,
      TError = unknown
    >(
      variables: ManageForwardEventPublishingSettingsQueryVariables,
      options?: UseQueryOptions<ManageForwardEventPublishingSettingsQuery, TError, TData>
    ) =>
    useQuery<ManageForwardEventPublishingSettingsQuery, TError, TData>(
      ['ManageForwardEventPublishingSettings', variables],
      fetcher<ManageForwardEventPublishingSettingsQuery, ManageForwardEventPublishingSettingsQueryVariables>(ManageForwardEventPublishingSettingsDocument, variables),
      options
    );

useManageForwardEventPublishingSettingsQuery.getKey = (variables: ManageForwardEventPublishingSettingsQueryVariables) => ['ManageForwardEventPublishingSettings', variables];
;

export const useInfiniteManageForwardEventPublishingSettingsQuery = <
      TData = ManageForwardEventPublishingSettingsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ManageForwardEventPublishingSettingsQueryVariables,
      variables: ManageForwardEventPublishingSettingsQueryVariables,
      options?: UseInfiniteQueryOptions<ManageForwardEventPublishingSettingsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ManageForwardEventPublishingSettingsQuery, TError, TData>(
      ['ManageForwardEventPublishingSettings.infinite', variables],
      (metaData) => fetcher<ManageForwardEventPublishingSettingsQuery, ManageForwardEventPublishingSettingsQueryVariables>(ManageForwardEventPublishingSettingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteManageForwardEventPublishingSettingsQuery.getKey = (variables: ManageForwardEventPublishingSettingsQueryVariables) => ['ManageForwardEventPublishingSettings.infinite', variables];
;

useManageForwardEventPublishingSettingsQuery.fetcher = (variables: ManageForwardEventPublishingSettingsQueryVariables) => fetcher<ManageForwardEventPublishingSettingsQuery, ManageForwardEventPublishingSettingsQueryVariables>(ManageForwardEventPublishingSettingsDocument, variables);
export const GetOrgForwardPrivilegesDocument = `
    query GetOrgForwardPrivileges {
  getOrgEmployerMember {
    __typename
    ... on EmployerOrgNode {
      orgForwardPrivileges {
        id
        carouselEventPublishing
        directoryEventPublishing
        lawSchoolTargeting
      }
    }
  }
}
    `;
export const useGetOrgForwardPrivilegesQuery = <
      TData = GetOrgForwardPrivilegesQuery,
      TError = unknown
    >(
      variables?: GetOrgForwardPrivilegesQueryVariables,
      options?: UseQueryOptions<GetOrgForwardPrivilegesQuery, TError, TData>
    ) =>
    useQuery<GetOrgForwardPrivilegesQuery, TError, TData>(
      variables === undefined ? ['GetOrgForwardPrivileges'] : ['GetOrgForwardPrivileges', variables],
      fetcher<GetOrgForwardPrivilegesQuery, GetOrgForwardPrivilegesQueryVariables>(GetOrgForwardPrivilegesDocument, variables),
      options
    );

useGetOrgForwardPrivilegesQuery.getKey = (variables?: GetOrgForwardPrivilegesQueryVariables) => variables === undefined ? ['GetOrgForwardPrivileges'] : ['GetOrgForwardPrivileges', variables];
;

export const useInfiniteGetOrgForwardPrivilegesQuery = <
      TData = GetOrgForwardPrivilegesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetOrgForwardPrivilegesQueryVariables,
      variables?: GetOrgForwardPrivilegesQueryVariables,
      options?: UseInfiniteQueryOptions<GetOrgForwardPrivilegesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetOrgForwardPrivilegesQuery, TError, TData>(
      variables === undefined ? ['GetOrgForwardPrivileges.infinite'] : ['GetOrgForwardPrivileges.infinite', variables],
      (metaData) => fetcher<GetOrgForwardPrivilegesQuery, GetOrgForwardPrivilegesQueryVariables>(GetOrgForwardPrivilegesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetOrgForwardPrivilegesQuery.getKey = (variables?: GetOrgForwardPrivilegesQueryVariables) => variables === undefined ? ['GetOrgForwardPrivileges.infinite'] : ['GetOrgForwardPrivileges.infinite', variables];
;

useGetOrgForwardPrivilegesQuery.fetcher = (variables?: GetOrgForwardPrivilegesQueryVariables) => fetcher<GetOrgForwardPrivilegesQuery, GetOrgForwardPrivilegesQueryVariables>(GetOrgForwardPrivilegesDocument, variables);
export const SubmitForwardEventPublishingSettingsDocument = `
    mutation SubmitForwardEventPublishingSettings($input: SubmitForwardEventPublishingSettingsInput!) {
  submitForwardEventPublishingSettings(input: $input) {
    success
  }
}
    `;
export const useSubmitForwardEventPublishingSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitForwardEventPublishingSettingsMutation, TError, SubmitForwardEventPublishingSettingsMutationVariables, TContext>) =>
    useMutation<SubmitForwardEventPublishingSettingsMutation, TError, SubmitForwardEventPublishingSettingsMutationVariables, TContext>(
      ['SubmitForwardEventPublishingSettings'],
      (variables?: SubmitForwardEventPublishingSettingsMutationVariables) => fetcher<SubmitForwardEventPublishingSettingsMutation, SubmitForwardEventPublishingSettingsMutationVariables>(SubmitForwardEventPublishingSettingsDocument, variables)(),
      options
    );
useSubmitForwardEventPublishingSettingsMutation.fetcher = (variables: SubmitForwardEventPublishingSettingsMutationVariables) => fetcher<SubmitForwardEventPublishingSettingsMutation, SubmitForwardEventPublishingSettingsMutationVariables>(SubmitForwardEventPublishingSettingsDocument, variables);
export const SubmitEventSchoolTargetingDocument = `
    mutation SubmitEventSchoolTargeting($input: SubmitEventSchoolTargetingInput!) {
  submitEventSchoolTargeting(input: $input) {
    success
  }
}
    `;
export const useSubmitEventSchoolTargetingMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitEventSchoolTargetingMutation, TError, SubmitEventSchoolTargetingMutationVariables, TContext>) =>
    useMutation<SubmitEventSchoolTargetingMutation, TError, SubmitEventSchoolTargetingMutationVariables, TContext>(
      ['SubmitEventSchoolTargeting'],
      (variables?: SubmitEventSchoolTargetingMutationVariables) => fetcher<SubmitEventSchoolTargetingMutation, SubmitEventSchoolTargetingMutationVariables>(SubmitEventSchoolTargetingDocument, variables)(),
      options
    );
useSubmitEventSchoolTargetingMutation.fetcher = (variables: SubmitEventSchoolTargetingMutationVariables) => fetcher<SubmitEventSchoolTargetingMutation, SubmitEventSchoolTargetingMutationVariables>(SubmitEventSchoolTargetingDocument, variables);
export const FirmDirectoryDocument = `
    query FirmDirectory($first: Int, $after: String, $filterBy: FirmDirectoryFilterBy, $sortBy: [FirmDirectorySortBy!], $numChars: Int) {
  firmDirectory(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        urlFriendlyName
        name
        logoUrl
        hasPublicFirmProfile
        forwardTier {
          id
          name
          asEnum
        }
        offices {
          nodes {
            officeLocation {
              id
              name
            }
          }
        }
        firmProfile {
          id
          orgId
          revenueDollars
          numAssociates
          numPartners
          numCounsels
          bioTextContent(numChars: $numChars)
          isPublic
        }
      }
    }
  }
}
    `;
export const useFirmDirectoryQuery = <
      TData = FirmDirectoryQuery,
      TError = unknown
    >(
      variables?: FirmDirectoryQueryVariables,
      options?: UseQueryOptions<FirmDirectoryQuery, TError, TData>
    ) =>
    useQuery<FirmDirectoryQuery, TError, TData>(
      variables === undefined ? ['FirmDirectory'] : ['FirmDirectory', variables],
      fetcher<FirmDirectoryQuery, FirmDirectoryQueryVariables>(FirmDirectoryDocument, variables),
      options
    );

useFirmDirectoryQuery.getKey = (variables?: FirmDirectoryQueryVariables) => variables === undefined ? ['FirmDirectory'] : ['FirmDirectory', variables];
;

export const useInfiniteFirmDirectoryQuery = <
      TData = FirmDirectoryQuery,
      TError = unknown
    >(
      pageParamKey: keyof FirmDirectoryQueryVariables,
      variables?: FirmDirectoryQueryVariables,
      options?: UseInfiniteQueryOptions<FirmDirectoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<FirmDirectoryQuery, TError, TData>(
      variables === undefined ? ['FirmDirectory.infinite'] : ['FirmDirectory.infinite', variables],
      (metaData) => fetcher<FirmDirectoryQuery, FirmDirectoryQueryVariables>(FirmDirectoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFirmDirectoryQuery.getKey = (variables?: FirmDirectoryQueryVariables) => variables === undefined ? ['FirmDirectory.infinite'] : ['FirmDirectory.infinite', variables];
;

useFirmDirectoryQuery.fetcher = (variables?: FirmDirectoryQueryVariables) => fetcher<FirmDirectoryQuery, FirmDirectoryQueryVariables>(FirmDirectoryDocument, variables);
export const SummerProgramStatsDocument = `
    query SummerProgramStats($firmFriendlyName: String!) {
  firmProfileByFirmFriendlyName(firmFriendlyName: $firmFriendlyName) {
    id
    firm {
      firmPracticeAreas {
        nodes {
          id
          firmSpecificName
          summerOffices {
            nodes {
              id
              officeLocation {
                name
              }
            }
          }
        }
      }
    }
    summerProgramSection {
      summerTopPracticeAreasAsOf
      hasSummerByPracticeDataToInput
      summerTopPracticeAreas {
        numSummerAssociates
        orgPracticeArea {
          firmSpecificName
        }
      }
      summerTopOfficeLocationsAsOf
      summerTopOfficeLocations {
        numSummerAssociate
        officeLocation {
          name
        }
      }
      summerPracticeAreaByOfficeAsOf
    }
  }
}
    `;
export const useSummerProgramStatsQuery = <
      TData = SummerProgramStatsQuery,
      TError = unknown
    >(
      variables: SummerProgramStatsQueryVariables,
      options?: UseQueryOptions<SummerProgramStatsQuery, TError, TData>
    ) =>
    useQuery<SummerProgramStatsQuery, TError, TData>(
      ['SummerProgramStats', variables],
      fetcher<SummerProgramStatsQuery, SummerProgramStatsQueryVariables>(SummerProgramStatsDocument, variables),
      options
    );

useSummerProgramStatsQuery.getKey = (variables: SummerProgramStatsQueryVariables) => ['SummerProgramStats', variables];
;

export const useInfiniteSummerProgramStatsQuery = <
      TData = SummerProgramStatsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SummerProgramStatsQueryVariables,
      variables: SummerProgramStatsQueryVariables,
      options?: UseInfiniteQueryOptions<SummerProgramStatsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SummerProgramStatsQuery, TError, TData>(
      ['SummerProgramStats.infinite', variables],
      (metaData) => fetcher<SummerProgramStatsQuery, SummerProgramStatsQueryVariables>(SummerProgramStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSummerProgramStatsQuery.getKey = (variables: SummerProgramStatsQueryVariables) => ['SummerProgramStats.infinite', variables];
;

useSummerProgramStatsQuery.fetcher = (variables: SummerProgramStatsQueryVariables) => fetcher<SummerProgramStatsQuery, SummerProgramStatsQueryVariables>(SummerProgramStatsDocument, variables);
export const DiversityAndInclusionStatsDocument = `
    query DiversityAndInclusionStats($firmFriendlyName: String!) {
  firmProfileByFirmFriendlyName(firmFriendlyName: $firmFriendlyName) {
    id
    diversityAndInclusionSection {
      statistics {
        gender {
          selfIdDefault {
            label
          }
          selfIdDefaultOption {
            name
          }
          numAssociates
          numCounsels
          numNonEquityPartners
          numPartners
          numSummerAssociates
        }
        raceOrEthnicity {
          selfIdDefault {
            name
          }
          selfIdDefaultOption {
            name
          }
          numAssociates
          numCounsels
          numNonEquityPartners
          numPartners
          numSummerAssociates
        }
        additional {
          selfIdDefault {
            label
          }
          selfIdDefaultOption {
            name
          }
          numAssociates
          numCounsels
          numNonEquityPartners
          numPartners
          numSummerAssociates
        }
      }
      genderStatisticsAsOf
      ethnicityStatisticsAsOf
      additionalStatisticsAsOf
    }
  }
}
    `;
export const useDiversityAndInclusionStatsQuery = <
      TData = DiversityAndInclusionStatsQuery,
      TError = unknown
    >(
      variables: DiversityAndInclusionStatsQueryVariables,
      options?: UseQueryOptions<DiversityAndInclusionStatsQuery, TError, TData>
    ) =>
    useQuery<DiversityAndInclusionStatsQuery, TError, TData>(
      ['DiversityAndInclusionStats', variables],
      fetcher<DiversityAndInclusionStatsQuery, DiversityAndInclusionStatsQueryVariables>(DiversityAndInclusionStatsDocument, variables),
      options
    );

useDiversityAndInclusionStatsQuery.getKey = (variables: DiversityAndInclusionStatsQueryVariables) => ['DiversityAndInclusionStats', variables];
;

export const useInfiniteDiversityAndInclusionStatsQuery = <
      TData = DiversityAndInclusionStatsQuery,
      TError = unknown
    >(
      pageParamKey: keyof DiversityAndInclusionStatsQueryVariables,
      variables: DiversityAndInclusionStatsQueryVariables,
      options?: UseInfiniteQueryOptions<DiversityAndInclusionStatsQuery, TError, TData>
    ) =>
    useInfiniteQuery<DiversityAndInclusionStatsQuery, TError, TData>(
      ['DiversityAndInclusionStats.infinite', variables],
      (metaData) => fetcher<DiversityAndInclusionStatsQuery, DiversityAndInclusionStatsQueryVariables>(DiversityAndInclusionStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteDiversityAndInclusionStatsQuery.getKey = (variables: DiversityAndInclusionStatsQueryVariables) => ['DiversityAndInclusionStats.infinite', variables];
;

useDiversityAndInclusionStatsQuery.fetcher = (variables: DiversityAndInclusionStatsQueryVariables) => fetcher<DiversityAndInclusionStatsQuery, DiversityAndInclusionStatsQueryVariables>(DiversityAndInclusionStatsDocument, variables);
export const PracticeAreaStatsDocument = `
    query PracticeAreaStats($firmFriendlyName: String!) {
  firmProfileByFirmFriendlyName(firmFriendlyName: $firmFriendlyName) {
    id
    orgId
    practiceAreaSection {
      headcounts {
        totalNumAttorneys
        numAssociates
        numCounsels
        numPartners
        numNonEquityPartners
        numNonTraditionalTrackOrStaff
        numEntryLevelPlacements
        ranking
        orgPracticeArea {
          firmSpecificName
          offices {
            nodes {
              officeLocation {
                name
              }
            }
          }
        }
      }
      headcountsAsOf
    }
  }
}
    `;
export const usePracticeAreaStatsQuery = <
      TData = PracticeAreaStatsQuery,
      TError = unknown
    >(
      variables: PracticeAreaStatsQueryVariables,
      options?: UseQueryOptions<PracticeAreaStatsQuery, TError, TData>
    ) =>
    useQuery<PracticeAreaStatsQuery, TError, TData>(
      ['PracticeAreaStats', variables],
      fetcher<PracticeAreaStatsQuery, PracticeAreaStatsQueryVariables>(PracticeAreaStatsDocument, variables),
      options
    );

usePracticeAreaStatsQuery.getKey = (variables: PracticeAreaStatsQueryVariables) => ['PracticeAreaStats', variables];
;

export const useInfinitePracticeAreaStatsQuery = <
      TData = PracticeAreaStatsQuery,
      TError = unknown
    >(
      pageParamKey: keyof PracticeAreaStatsQueryVariables,
      variables: PracticeAreaStatsQueryVariables,
      options?: UseInfiniteQueryOptions<PracticeAreaStatsQuery, TError, TData>
    ) =>
    useInfiniteQuery<PracticeAreaStatsQuery, TError, TData>(
      ['PracticeAreaStats.infinite', variables],
      (metaData) => fetcher<PracticeAreaStatsQuery, PracticeAreaStatsQueryVariables>(PracticeAreaStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePracticeAreaStatsQuery.getKey = (variables: PracticeAreaStatsQueryVariables) => ['PracticeAreaStats.infinite', variables];
;

usePracticeAreaStatsQuery.fetcher = (variables: PracticeAreaStatsQueryVariables) => fetcher<PracticeAreaStatsQuery, PracticeAreaStatsQueryVariables>(PracticeAreaStatsDocument, variables);
export const ProBonoStatsDocument = `
    query ProBonoStats($firmFriendlyName: String!) {
  firmProfileByFirmFriendlyName(firmFriendlyName: $firmFriendlyName) {
    id
    proBonoSection {
      participationPercentage {
        associate
        partner
        otherLawyers
      }
      averageHours {
        associate
        partner
        otherLawyers
      }
      averageHoursAsOf
      participationPercentagesAsOf
    }
  }
}
    `;
export const useProBonoStatsQuery = <
      TData = ProBonoStatsQuery,
      TError = unknown
    >(
      variables: ProBonoStatsQueryVariables,
      options?: UseQueryOptions<ProBonoStatsQuery, TError, TData>
    ) =>
    useQuery<ProBonoStatsQuery, TError, TData>(
      ['ProBonoStats', variables],
      fetcher<ProBonoStatsQuery, ProBonoStatsQueryVariables>(ProBonoStatsDocument, variables),
      options
    );

useProBonoStatsQuery.getKey = (variables: ProBonoStatsQueryVariables) => ['ProBonoStats', variables];
;

export const useInfiniteProBonoStatsQuery = <
      TData = ProBonoStatsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProBonoStatsQueryVariables,
      variables: ProBonoStatsQueryVariables,
      options?: UseInfiniteQueryOptions<ProBonoStatsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProBonoStatsQuery, TError, TData>(
      ['ProBonoStats.infinite', variables],
      (metaData) => fetcher<ProBonoStatsQuery, ProBonoStatsQueryVariables>(ProBonoStatsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProBonoStatsQuery.getKey = (variables: ProBonoStatsQueryVariables) => ['ProBonoStats.infinite', variables];
;

useProBonoStatsQuery.fetcher = (variables: ProBonoStatsQueryVariables) => fetcher<ProBonoStatsQuery, ProBonoStatsQueryVariables>(ProBonoStatsDocument, variables);
export const FirmProfileEventCarouselDocument = `
    query FirmProfileEventCarousel($orgId: ID!, $first: Int, $after: String) {
  publicOrgInfoByOrgId(orgId: $orgId) {
    firmProfile {
      eventCarousel {
        isEnabled
        firmCarouselEvents(first: $first, after: $after) {
          totalCount
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...FirmEventCardFields
            }
          }
        }
      }
    }
  }
}
    ${FirmEventCardFieldsFragmentDoc}
${FirmEventCardHostFieldsFragmentDoc}
${FirmEventCardRegistrationButtonFieldsFragmentDoc}`;
export const useFirmProfileEventCarouselQuery = <
      TData = FirmProfileEventCarouselQuery,
      TError = unknown
    >(
      variables: FirmProfileEventCarouselQueryVariables,
      options?: UseQueryOptions<FirmProfileEventCarouselQuery, TError, TData>
    ) =>
    useQuery<FirmProfileEventCarouselQuery, TError, TData>(
      ['FirmProfileEventCarousel', variables],
      fetcher<FirmProfileEventCarouselQuery, FirmProfileEventCarouselQueryVariables>(FirmProfileEventCarouselDocument, variables),
      options
    );

useFirmProfileEventCarouselQuery.getKey = (variables: FirmProfileEventCarouselQueryVariables) => ['FirmProfileEventCarousel', variables];
;

export const useInfiniteFirmProfileEventCarouselQuery = <
      TData = FirmProfileEventCarouselQuery,
      TError = unknown
    >(
      pageParamKey: keyof FirmProfileEventCarouselQueryVariables,
      variables: FirmProfileEventCarouselQueryVariables,
      options?: UseInfiniteQueryOptions<FirmProfileEventCarouselQuery, TError, TData>
    ) =>
    useInfiniteQuery<FirmProfileEventCarouselQuery, TError, TData>(
      ['FirmProfileEventCarousel.infinite', variables],
      (metaData) => fetcher<FirmProfileEventCarouselQuery, FirmProfileEventCarouselQueryVariables>(FirmProfileEventCarouselDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFirmProfileEventCarouselQuery.getKey = (variables: FirmProfileEventCarouselQueryVariables) => ['FirmProfileEventCarousel.infinite', variables];
;

useFirmProfileEventCarouselQuery.fetcher = (variables: FirmProfileEventCarouselQueryVariables) => fetcher<FirmProfileEventCarouselQuery, FirmProfileEventCarouselQueryVariables>(FirmProfileEventCarouselDocument, variables);
export const FirmProfileJobCarouselDocument = `
    query FirmProfileJobCarousel($firmFriendlyName: String!, $first: Int!, $after: String, $descriptionTextContentNumChars: Int!) {
  publicOrgInfoByOrgFriendlyName(orgFriendlyName: $firmFriendlyName) {
    name
    openJobs(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          ...DiscoveryJobCardFields
        }
      }
    }
  }
}
    ${DiscoveryJobCardFieldsFragmentDoc}`;
export const useFirmProfileJobCarouselQuery = <
      TData = FirmProfileJobCarouselQuery,
      TError = unknown
    >(
      variables: FirmProfileJobCarouselQueryVariables,
      options?: UseQueryOptions<FirmProfileJobCarouselQuery, TError, TData>
    ) =>
    useQuery<FirmProfileJobCarouselQuery, TError, TData>(
      ['FirmProfileJobCarousel', variables],
      fetcher<FirmProfileJobCarouselQuery, FirmProfileJobCarouselQueryVariables>(FirmProfileJobCarouselDocument, variables),
      options
    );

useFirmProfileJobCarouselQuery.getKey = (variables: FirmProfileJobCarouselQueryVariables) => ['FirmProfileJobCarousel', variables];
;

export const useInfiniteFirmProfileJobCarouselQuery = <
      TData = FirmProfileJobCarouselQuery,
      TError = unknown
    >(
      pageParamKey: keyof FirmProfileJobCarouselQueryVariables,
      variables: FirmProfileJobCarouselQueryVariables,
      options?: UseInfiniteQueryOptions<FirmProfileJobCarouselQuery, TError, TData>
    ) =>
    useInfiniteQuery<FirmProfileJobCarouselQuery, TError, TData>(
      ['FirmProfileJobCarousel.infinite', variables],
      (metaData) => fetcher<FirmProfileJobCarouselQuery, FirmProfileJobCarouselQueryVariables>(FirmProfileJobCarouselDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFirmProfileJobCarouselQuery.getKey = (variables: FirmProfileJobCarouselQueryVariables) => ['FirmProfileJobCarousel.infinite', variables];
;

useFirmProfileJobCarouselQuery.fetcher = (variables: FirmProfileJobCarouselQueryVariables) => fetcher<FirmProfileJobCarouselQuery, FirmProfileJobCarouselQueryVariables>(FirmProfileJobCarouselDocument, variables);
export const FirmProfileByFirmFriendlyNameDocument = `
    query FirmProfileByFirmFriendlyName($firmFriendlyName: String!) {
  firmProfileByFirmFriendlyName(firmFriendlyName: $firmFriendlyName) {
    id
    bio
    firm {
      id
      name
      forwardTier {
        asEnum
      }
      logoUrl
      isFloCustomer
      forwardTier {
        asEnum
      }
      offices {
        nodes {
          officeLocation {
            id
            name
          }
        }
      }
      firmPracticeAreas {
        nodes {
          summerOffices {
            nodes {
              officeLocation {
                name
              }
            }
          }
        }
      }
      firmPracticeAreas {
        nodes {
          summerOffices {
            nodes {
              officeLocation {
                name
              }
            }
          }
        }
      }
    }
    revenueDollars
    profitsPerPartnerDollars
    numPartnershipTiers
    numAssociates
    numPartners
    numCounsels
    bio
    bioTextContent
    bannerImageSrc
    websiteLinkUrl
    customLink {
      url
      display
    }
    socialMediaLinks {
      ...FirmProfileSocialMediaLinksFields
    }
    isPublic
    daysInOfficePerWeek
    daysInOfficeContext
    customSection {
      firmProfileId
      title
      coverImageSrc
      answer
      moreAboutLifeAt
      learnMoreLink {
        url
        display
      }
      isEnabled
      richMediaSubsection {
        ...RichMedia
      }
    }
    diversityAndInclusionSection {
      answer
      learnMoreLink
      isEnabled
      statistics {
        gender {
          selfIdDefault {
            label
          }
          selfIdDefaultOption {
            name
          }
          numAssociates
          numCounsels
          numPartners
          numSummerAssociates
        }
        raceOrEthnicity {
          selfIdDefault {
            name
          }
          selfIdDefaultOption {
            name
          }
          numAssociates
          numCounsels
          numPartners
          numSummerAssociates
        }
        additional {
          selfIdDefault {
            label
          }
          selfIdDefaultOption {
            name
          }
          numAssociates
          numCounsels
          numPartners
          numSummerAssociates
        }
      }
      richMediaSubsection {
        ...RichMedia
      }
    }
    practiceAreaSection {
      id
      answer
      headcounts {
        numAssociates
        numCounsels
        numPartners
        numEntryLevelPlacements
        ranking
        orgPracticeArea {
          id
          firmSpecificName
          offices {
            totalCount
          }
        }
      }
      learnMoreLink
      isEnabled
      richMediaSubsection {
        ...RichMedia
      }
    }
    proBonoSection {
      id
      answer
      answer2
      learnMoreLink
      isEnabled
      participationPercentage {
        associate
        partner
        otherLawyers
      }
      haveOpportunitiesForSummersOption
      areProBonoHoursBillable
      numBillableProBonoHours
      billableHoursContext
      averageHours {
        associate
        partner
        otherLawyers
      }
      averageHours {
        associate
        partner
        otherLawyers
      }
      richMediaSubsection {
        ...RichMedia
      }
    }
    summerProgramSection {
      id
      isEnabled
      primaryContact {
        name
        title
        email
      }
      answer
      noResponse
      summerSalary {
        unit
        value
      }
      summerCount1L
      summerCount2L
      summerCountsAsOf
      programLength {
        unit
        value
      }
      earlyInterviewAvailableOption
      resumeAcceptanceDeadline1L
      resumeAcceptanceText1L
      resumeAcceptanceDeadline2L
      resumeAcceptanceText2L
      assignedPracticeAreasOption
      firstYearHiredIntoPracticeAreaOption
      howIsWorkAssignedOption
      howIsWorkAssignedContext
      learnMoreLink
      hasSummerByPracticeDataToInput
      summerByPracticeContext
      summerTopPracticeAreasAsOf
      summerTopPracticeAreas {
        orgPracticeAreaId
        numSummerAssociates
        orgPracticeArea {
          firmSpecificName
        }
      }
      summerTopOfficeLocationsAsOf
      summerTopOfficeLocations {
        orgOfficeId
        numSummerAssociate
        officeLocation {
          name
        }
      }
      richMediaSubsection {
        ...RichMedia
      }
    }
    customSection {
      title
      coverImageSrc
      answer
      moreAboutLifeAt
      learnMoreLink {
        url
        display
      }
      isEnabled
      richMediaSubsection {
        ...RichMedia
      }
    }
    eventCarousel {
      isEnabled
    }
  }
}
    ${FirmProfileSocialMediaLinksFieldsFragmentDoc}
${RichMediaFragmentDoc}`;
export const useFirmProfileByFirmFriendlyNameQuery = <
      TData = FirmProfileByFirmFriendlyNameQuery,
      TError = unknown
    >(
      variables: FirmProfileByFirmFriendlyNameQueryVariables,
      options?: UseQueryOptions<FirmProfileByFirmFriendlyNameQuery, TError, TData>
    ) =>
    useQuery<FirmProfileByFirmFriendlyNameQuery, TError, TData>(
      ['FirmProfileByFirmFriendlyName', variables],
      fetcher<FirmProfileByFirmFriendlyNameQuery, FirmProfileByFirmFriendlyNameQueryVariables>(FirmProfileByFirmFriendlyNameDocument, variables),
      options
    );

useFirmProfileByFirmFriendlyNameQuery.getKey = (variables: FirmProfileByFirmFriendlyNameQueryVariables) => ['FirmProfileByFirmFriendlyName', variables];
;

export const useInfiniteFirmProfileByFirmFriendlyNameQuery = <
      TData = FirmProfileByFirmFriendlyNameQuery,
      TError = unknown
    >(
      pageParamKey: keyof FirmProfileByFirmFriendlyNameQueryVariables,
      variables: FirmProfileByFirmFriendlyNameQueryVariables,
      options?: UseInfiniteQueryOptions<FirmProfileByFirmFriendlyNameQuery, TError, TData>
    ) =>
    useInfiniteQuery<FirmProfileByFirmFriendlyNameQuery, TError, TData>(
      ['FirmProfileByFirmFriendlyName.infinite', variables],
      (metaData) => fetcher<FirmProfileByFirmFriendlyNameQuery, FirmProfileByFirmFriendlyNameQueryVariables>(FirmProfileByFirmFriendlyNameDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFirmProfileByFirmFriendlyNameQuery.getKey = (variables: FirmProfileByFirmFriendlyNameQueryVariables) => ['FirmProfileByFirmFriendlyName.infinite', variables];
;

useFirmProfileByFirmFriendlyNameQuery.fetcher = (variables: FirmProfileByFirmFriendlyNameQueryVariables) => fetcher<FirmProfileByFirmFriendlyNameQuery, FirmProfileByFirmFriendlyNameQueryVariables>(FirmProfileByFirmFriendlyNameDocument, variables);
export const ForwardLoginGuardDocument = `
    query ForwardLoginGuard {
  whoAmI {
    isLoggedIn
    asCandidate {
      forwardAccountStatus
      loggedInEmail
    }
  }
}
    `;
export const useForwardLoginGuardQuery = <
      TData = ForwardLoginGuardQuery,
      TError = unknown
    >(
      variables?: ForwardLoginGuardQueryVariables,
      options?: UseQueryOptions<ForwardLoginGuardQuery, TError, TData>
    ) =>
    useQuery<ForwardLoginGuardQuery, TError, TData>(
      variables === undefined ? ['ForwardLoginGuard'] : ['ForwardLoginGuard', variables],
      fetcher<ForwardLoginGuardQuery, ForwardLoginGuardQueryVariables>(ForwardLoginGuardDocument, variables),
      options
    );

useForwardLoginGuardQuery.getKey = (variables?: ForwardLoginGuardQueryVariables) => variables === undefined ? ['ForwardLoginGuard'] : ['ForwardLoginGuard', variables];
;

export const useInfiniteForwardLoginGuardQuery = <
      TData = ForwardLoginGuardQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardLoginGuardQueryVariables,
      variables?: ForwardLoginGuardQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardLoginGuardQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardLoginGuardQuery, TError, TData>(
      variables === undefined ? ['ForwardLoginGuard.infinite'] : ['ForwardLoginGuard.infinite', variables],
      (metaData) => fetcher<ForwardLoginGuardQuery, ForwardLoginGuardQueryVariables>(ForwardLoginGuardDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardLoginGuardQuery.getKey = (variables?: ForwardLoginGuardQueryVariables) => variables === undefined ? ['ForwardLoginGuard.infinite'] : ['ForwardLoginGuard.infinite', variables];
;

useForwardLoginGuardQuery.fetcher = (variables?: ForwardLoginGuardQueryVariables) => fetcher<ForwardLoginGuardQuery, ForwardLoginGuardQueryVariables>(ForwardLoginGuardDocument, variables);
export const FirmCardDocument = `
    query FirmCard($first: Int, $filterBy: FirmDirectoryFilterBy, $sortBy: [FirmDirectorySortBy!]) {
  firmDirectory(first: $first, filterBy: $filterBy, sortBy: $sortBy) {
    edges {
      cursor
      node {
        name
        id
        urlFriendlyName
        logoUrl
        forwardTier {
          asEnum
        }
      }
    }
  }
}
    `;
export const useFirmCardQuery = <
      TData = FirmCardQuery,
      TError = unknown
    >(
      variables?: FirmCardQueryVariables,
      options?: UseQueryOptions<FirmCardQuery, TError, TData>
    ) =>
    useQuery<FirmCardQuery, TError, TData>(
      variables === undefined ? ['FirmCard'] : ['FirmCard', variables],
      fetcher<FirmCardQuery, FirmCardQueryVariables>(FirmCardDocument, variables),
      options
    );

useFirmCardQuery.getKey = (variables?: FirmCardQueryVariables) => variables === undefined ? ['FirmCard'] : ['FirmCard', variables];
;

export const useInfiniteFirmCardQuery = <
      TData = FirmCardQuery,
      TError = unknown
    >(
      pageParamKey: keyof FirmCardQueryVariables,
      variables?: FirmCardQueryVariables,
      options?: UseInfiniteQueryOptions<FirmCardQuery, TError, TData>
    ) =>
    useInfiniteQuery<FirmCardQuery, TError, TData>(
      variables === undefined ? ['FirmCard.infinite'] : ['FirmCard.infinite', variables],
      (metaData) => fetcher<FirmCardQuery, FirmCardQueryVariables>(FirmCardDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFirmCardQuery.getKey = (variables?: FirmCardQueryVariables) => variables === undefined ? ['FirmCard.infinite'] : ['FirmCard.infinite', variables];
;

useFirmCardQuery.fetcher = (variables?: FirmCardQueryVariables) => fetcher<FirmCardQuery, FirmCardQueryVariables>(FirmCardDocument, variables);
export const ForwardJobApplicationFeedDocument = `
    query ForwardJobApplicationFeed($first: Int, $after: String, $filterBy: ForwardJobApplicationFeedFilterBy, $sortBy: ForwardJobApplicationFeedSortBy) {
  forwardJobApplicationFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $sortBy
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    nodes {
      __typename
      id
      recruitId
      jobId
      isComplete
      submittedAt
      sourceLink
      job {
        __typename
        id
        orgId
        employer {
          name
          logoUrl
          isFloCustomer
          forwardTier {
            asEnum
          }
          ...FirmProfileLinkInfo
        }
        title
        descriptionTextContent
        closeDate {
          date
          time
          zone
        }
        offices {
          nodes {
            id
            name
          }
        }
        ... on ExternalJobNode {
          practiceCategories {
            nodes {
              id
              name
            }
          }
          salaryInfo {
            amount
            timeUnit
          }
        }
        ... on InterviewSchedulingJobNode {
          practiceAreas {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    ${FirmProfileLinkInfoFragmentDoc}`;
export const useForwardJobApplicationFeedQuery = <
      TData = ForwardJobApplicationFeedQuery,
      TError = unknown
    >(
      variables?: ForwardJobApplicationFeedQueryVariables,
      options?: UseQueryOptions<ForwardJobApplicationFeedQuery, TError, TData>
    ) =>
    useQuery<ForwardJobApplicationFeedQuery, TError, TData>(
      variables === undefined ? ['ForwardJobApplicationFeed'] : ['ForwardJobApplicationFeed', variables],
      fetcher<ForwardJobApplicationFeedQuery, ForwardJobApplicationFeedQueryVariables>(ForwardJobApplicationFeedDocument, variables),
      options
    );

useForwardJobApplicationFeedQuery.getKey = (variables?: ForwardJobApplicationFeedQueryVariables) => variables === undefined ? ['ForwardJobApplicationFeed'] : ['ForwardJobApplicationFeed', variables];
;

export const useInfiniteForwardJobApplicationFeedQuery = <
      TData = ForwardJobApplicationFeedQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardJobApplicationFeedQueryVariables,
      variables?: ForwardJobApplicationFeedQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardJobApplicationFeedQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardJobApplicationFeedQuery, TError, TData>(
      variables === undefined ? ['ForwardJobApplicationFeed.infinite'] : ['ForwardJobApplicationFeed.infinite', variables],
      (metaData) => fetcher<ForwardJobApplicationFeedQuery, ForwardJobApplicationFeedQueryVariables>(ForwardJobApplicationFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardJobApplicationFeedQuery.getKey = (variables?: ForwardJobApplicationFeedQueryVariables) => variables === undefined ? ['ForwardJobApplicationFeed.infinite'] : ['ForwardJobApplicationFeed.infinite', variables];
;

useForwardJobApplicationFeedQuery.fetcher = (variables?: ForwardJobApplicationFeedQueryVariables) => fetcher<ForwardJobApplicationFeedQuery, ForwardJobApplicationFeedQueryVariables>(ForwardJobApplicationFeedDocument, variables);
export const ForwardJobApplicationTotalCountDocument = `
    query ForwardJobApplicationTotalCount {
  forwardJobApplicationFeed {
    totalCount
  }
}
    `;
export const useForwardJobApplicationTotalCountQuery = <
      TData = ForwardJobApplicationTotalCountQuery,
      TError = unknown
    >(
      variables?: ForwardJobApplicationTotalCountQueryVariables,
      options?: UseQueryOptions<ForwardJobApplicationTotalCountQuery, TError, TData>
    ) =>
    useQuery<ForwardJobApplicationTotalCountQuery, TError, TData>(
      variables === undefined ? ['ForwardJobApplicationTotalCount'] : ['ForwardJobApplicationTotalCount', variables],
      fetcher<ForwardJobApplicationTotalCountQuery, ForwardJobApplicationTotalCountQueryVariables>(ForwardJobApplicationTotalCountDocument, variables),
      options
    );

useForwardJobApplicationTotalCountQuery.getKey = (variables?: ForwardJobApplicationTotalCountQueryVariables) => variables === undefined ? ['ForwardJobApplicationTotalCount'] : ['ForwardJobApplicationTotalCount', variables];
;

export const useInfiniteForwardJobApplicationTotalCountQuery = <
      TData = ForwardJobApplicationTotalCountQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardJobApplicationTotalCountQueryVariables,
      variables?: ForwardJobApplicationTotalCountQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardJobApplicationTotalCountQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardJobApplicationTotalCountQuery, TError, TData>(
      variables === undefined ? ['ForwardJobApplicationTotalCount.infinite'] : ['ForwardJobApplicationTotalCount.infinite', variables],
      (metaData) => fetcher<ForwardJobApplicationTotalCountQuery, ForwardJobApplicationTotalCountQueryVariables>(ForwardJobApplicationTotalCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardJobApplicationTotalCountQuery.getKey = (variables?: ForwardJobApplicationTotalCountQueryVariables) => variables === undefined ? ['ForwardJobApplicationTotalCount.infinite'] : ['ForwardJobApplicationTotalCount.infinite', variables];
;

useForwardJobApplicationTotalCountQuery.fetcher = (variables?: ForwardJobApplicationTotalCountQueryVariables) => fetcher<ForwardJobApplicationTotalCountQuery, ForwardJobApplicationTotalCountQueryVariables>(ForwardJobApplicationTotalCountDocument, variables);
export const JobBoardLoadTestFullDocument = `
    query JobBoardLoadTestFull($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $orderBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        ... on JobNode {
          id
          orgId
          employer {
            name
            logoUrl
          }
          title
          description
          openDate {
            date
            time
            zone
          }
          closeDate {
            date
            time
            zone
          }
          offices {
            nodes {
              id
              name
            }
          }
          requiredDocuments {
            id
            name
          }
        }
        ... on ExternalJobNode {
          practiceCategories {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const useJobBoardLoadTestFullQuery = <
      TData = JobBoardLoadTestFullQuery,
      TError = unknown
    >(
      variables?: JobBoardLoadTestFullQueryVariables,
      options?: UseQueryOptions<JobBoardLoadTestFullQuery, TError, TData>
    ) =>
    useQuery<JobBoardLoadTestFullQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestFull'] : ['JobBoardLoadTestFull', variables],
      fetcher<JobBoardLoadTestFullQuery, JobBoardLoadTestFullQueryVariables>(JobBoardLoadTestFullDocument, variables),
      options
    );

useJobBoardLoadTestFullQuery.getKey = (variables?: JobBoardLoadTestFullQueryVariables) => variables === undefined ? ['JobBoardLoadTestFull'] : ['JobBoardLoadTestFull', variables];
;

export const useInfiniteJobBoardLoadTestFullQuery = <
      TData = JobBoardLoadTestFullQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobBoardLoadTestFullQueryVariables,
      variables?: JobBoardLoadTestFullQueryVariables,
      options?: UseInfiniteQueryOptions<JobBoardLoadTestFullQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobBoardLoadTestFullQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestFull.infinite'] : ['JobBoardLoadTestFull.infinite', variables],
      (metaData) => fetcher<JobBoardLoadTestFullQuery, JobBoardLoadTestFullQueryVariables>(JobBoardLoadTestFullDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobBoardLoadTestFullQuery.getKey = (variables?: JobBoardLoadTestFullQueryVariables) => variables === undefined ? ['JobBoardLoadTestFull.infinite'] : ['JobBoardLoadTestFull.infinite', variables];
;

useJobBoardLoadTestFullQuery.fetcher = (variables?: JobBoardLoadTestFullQueryVariables) => fetcher<JobBoardLoadTestFullQuery, JobBoardLoadTestFullQueryVariables>(JobBoardLoadTestFullDocument, variables);
export const JobBoardLoadTestJobsOnlyNoDocumentsDocument = `
    query JobBoardLoadTestJobsOnlyNoDocuments($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $orderBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on JobNode {
          id
          orgId
          employer {
            name
            logoUrl
          }
          title
          description
          openDate {
            date
            time
            zone
          }
          closeDate {
            date
            time
            zone
          }
          offices {
            nodes {
              id
              name
            }
          }
        }
        ... on ExternalJobNode {
          practiceCategories {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const useJobBoardLoadTestJobsOnlyNoDocumentsQuery = <
      TData = JobBoardLoadTestJobsOnlyNoDocumentsQuery,
      TError = unknown
    >(
      variables?: JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables,
      options?: UseQueryOptions<JobBoardLoadTestJobsOnlyNoDocumentsQuery, TError, TData>
    ) =>
    useQuery<JobBoardLoadTestJobsOnlyNoDocumentsQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestJobsOnlyNoDocuments'] : ['JobBoardLoadTestJobsOnlyNoDocuments', variables],
      fetcher<JobBoardLoadTestJobsOnlyNoDocumentsQuery, JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables>(JobBoardLoadTestJobsOnlyNoDocumentsDocument, variables),
      options
    );

useJobBoardLoadTestJobsOnlyNoDocumentsQuery.getKey = (variables?: JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables) => variables === undefined ? ['JobBoardLoadTestJobsOnlyNoDocuments'] : ['JobBoardLoadTestJobsOnlyNoDocuments', variables];
;

export const useInfiniteJobBoardLoadTestJobsOnlyNoDocumentsQuery = <
      TData = JobBoardLoadTestJobsOnlyNoDocumentsQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables,
      variables?: JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables,
      options?: UseInfiniteQueryOptions<JobBoardLoadTestJobsOnlyNoDocumentsQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobBoardLoadTestJobsOnlyNoDocumentsQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestJobsOnlyNoDocuments.infinite'] : ['JobBoardLoadTestJobsOnlyNoDocuments.infinite', variables],
      (metaData) => fetcher<JobBoardLoadTestJobsOnlyNoDocumentsQuery, JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables>(JobBoardLoadTestJobsOnlyNoDocumentsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobBoardLoadTestJobsOnlyNoDocumentsQuery.getKey = (variables?: JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables) => variables === undefined ? ['JobBoardLoadTestJobsOnlyNoDocuments.infinite'] : ['JobBoardLoadTestJobsOnlyNoDocuments.infinite', variables];
;

useJobBoardLoadTestJobsOnlyNoDocumentsQuery.fetcher = (variables?: JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables) => fetcher<JobBoardLoadTestJobsOnlyNoDocumentsQuery, JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables>(JobBoardLoadTestJobsOnlyNoDocumentsDocument, variables);
export const JobBoardLoadTestCountDocument = `
    query JobBoardLoadTestCount($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $orderBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $orderBy
  ) {
    totalCount
  }
}
    `;
export const useJobBoardLoadTestCountQuery = <
      TData = JobBoardLoadTestCountQuery,
      TError = unknown
    >(
      variables?: JobBoardLoadTestCountQueryVariables,
      options?: UseQueryOptions<JobBoardLoadTestCountQuery, TError, TData>
    ) =>
    useQuery<JobBoardLoadTestCountQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestCount'] : ['JobBoardLoadTestCount', variables],
      fetcher<JobBoardLoadTestCountQuery, JobBoardLoadTestCountQueryVariables>(JobBoardLoadTestCountDocument, variables),
      options
    );

useJobBoardLoadTestCountQuery.getKey = (variables?: JobBoardLoadTestCountQueryVariables) => variables === undefined ? ['JobBoardLoadTestCount'] : ['JobBoardLoadTestCount', variables];
;

export const useInfiniteJobBoardLoadTestCountQuery = <
      TData = JobBoardLoadTestCountQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobBoardLoadTestCountQueryVariables,
      variables?: JobBoardLoadTestCountQueryVariables,
      options?: UseInfiniteQueryOptions<JobBoardLoadTestCountQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobBoardLoadTestCountQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestCount.infinite'] : ['JobBoardLoadTestCount.infinite', variables],
      (metaData) => fetcher<JobBoardLoadTestCountQuery, JobBoardLoadTestCountQueryVariables>(JobBoardLoadTestCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobBoardLoadTestCountQuery.getKey = (variables?: JobBoardLoadTestCountQueryVariables) => variables === undefined ? ['JobBoardLoadTestCount.infinite'] : ['JobBoardLoadTestCount.infinite', variables];
;

useJobBoardLoadTestCountQuery.fetcher = (variables?: JobBoardLoadTestCountQueryVariables) => fetcher<JobBoardLoadTestCountQuery, JobBoardLoadTestCountQueryVariables>(JobBoardLoadTestCountDocument, variables);
export const JobBoardLoadTestByIdDocument = `
    query JobBoardLoadTestById($jobId: ID!) {
  forwardJobById(id: $jobId) {
    ... on JobNode {
      id
      orgId
      employer {
        name
        logoUrl
      }
      title
      description
      openDate {
        date
        time
        zone
      }
      closeDate {
        date
        time
        zone
      }
      offices {
        nodes {
          id
          name
        }
      }
      requiredDocuments {
        id
        name
      }
    }
    ... on ExternalJobNode {
      practiceCategories {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
export const useJobBoardLoadTestByIdQuery = <
      TData = JobBoardLoadTestByIdQuery,
      TError = unknown
    >(
      variables: JobBoardLoadTestByIdQueryVariables,
      options?: UseQueryOptions<JobBoardLoadTestByIdQuery, TError, TData>
    ) =>
    useQuery<JobBoardLoadTestByIdQuery, TError, TData>(
      ['JobBoardLoadTestById', variables],
      fetcher<JobBoardLoadTestByIdQuery, JobBoardLoadTestByIdQueryVariables>(JobBoardLoadTestByIdDocument, variables),
      options
    );

useJobBoardLoadTestByIdQuery.getKey = (variables: JobBoardLoadTestByIdQueryVariables) => ['JobBoardLoadTestById', variables];
;

export const useInfiniteJobBoardLoadTestByIdQuery = <
      TData = JobBoardLoadTestByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobBoardLoadTestByIdQueryVariables,
      variables: JobBoardLoadTestByIdQueryVariables,
      options?: UseInfiniteQueryOptions<JobBoardLoadTestByIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobBoardLoadTestByIdQuery, TError, TData>(
      ['JobBoardLoadTestById.infinite', variables],
      (metaData) => fetcher<JobBoardLoadTestByIdQuery, JobBoardLoadTestByIdQueryVariables>(JobBoardLoadTestByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobBoardLoadTestByIdQuery.getKey = (variables: JobBoardLoadTestByIdQueryVariables) => ['JobBoardLoadTestById.infinite', variables];
;

useJobBoardLoadTestByIdQuery.fetcher = (variables: JobBoardLoadTestByIdQueryVariables) => fetcher<JobBoardLoadTestByIdQuery, JobBoardLoadTestByIdQueryVariables>(JobBoardLoadTestByIdDocument, variables);
export const JobBoardLoadTestWithoutDescriptionOrCountDocument = `
    query JobBoardLoadTestWithoutDescriptionOrCount($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $orderBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on JobNode {
          id
          orgId
          employer {
            name
            logoUrl
          }
          title
          openDate {
            date
            time
            zone
          }
          closeDate {
            date
            time
            zone
          }
          offices {
            nodes {
              id
              name
            }
          }
          requiredDocuments {
            id
            name
          }
        }
        ... on ExternalJobNode {
          practiceCategories {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const useJobBoardLoadTestWithoutDescriptionOrCountQuery = <
      TData = JobBoardLoadTestWithoutDescriptionOrCountQuery,
      TError = unknown
    >(
      variables?: JobBoardLoadTestWithoutDescriptionOrCountQueryVariables,
      options?: UseQueryOptions<JobBoardLoadTestWithoutDescriptionOrCountQuery, TError, TData>
    ) =>
    useQuery<JobBoardLoadTestWithoutDescriptionOrCountQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestWithoutDescriptionOrCount'] : ['JobBoardLoadTestWithoutDescriptionOrCount', variables],
      fetcher<JobBoardLoadTestWithoutDescriptionOrCountQuery, JobBoardLoadTestWithoutDescriptionOrCountQueryVariables>(JobBoardLoadTestWithoutDescriptionOrCountDocument, variables),
      options
    );

useJobBoardLoadTestWithoutDescriptionOrCountQuery.getKey = (variables?: JobBoardLoadTestWithoutDescriptionOrCountQueryVariables) => variables === undefined ? ['JobBoardLoadTestWithoutDescriptionOrCount'] : ['JobBoardLoadTestWithoutDescriptionOrCount', variables];
;

export const useInfiniteJobBoardLoadTestWithoutDescriptionOrCountQuery = <
      TData = JobBoardLoadTestWithoutDescriptionOrCountQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobBoardLoadTestWithoutDescriptionOrCountQueryVariables,
      variables?: JobBoardLoadTestWithoutDescriptionOrCountQueryVariables,
      options?: UseInfiniteQueryOptions<JobBoardLoadTestWithoutDescriptionOrCountQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobBoardLoadTestWithoutDescriptionOrCountQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestWithoutDescriptionOrCount.infinite'] : ['JobBoardLoadTestWithoutDescriptionOrCount.infinite', variables],
      (metaData) => fetcher<JobBoardLoadTestWithoutDescriptionOrCountQuery, JobBoardLoadTestWithoutDescriptionOrCountQueryVariables>(JobBoardLoadTestWithoutDescriptionOrCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobBoardLoadTestWithoutDescriptionOrCountQuery.getKey = (variables?: JobBoardLoadTestWithoutDescriptionOrCountQueryVariables) => variables === undefined ? ['JobBoardLoadTestWithoutDescriptionOrCount.infinite'] : ['JobBoardLoadTestWithoutDescriptionOrCount.infinite', variables];
;

useJobBoardLoadTestWithoutDescriptionOrCountQuery.fetcher = (variables?: JobBoardLoadTestWithoutDescriptionOrCountQueryVariables) => fetcher<JobBoardLoadTestWithoutDescriptionOrCountQuery, JobBoardLoadTestWithoutDescriptionOrCountQueryVariables>(JobBoardLoadTestWithoutDescriptionOrCountDocument, variables);
export const JobBoardLoadTestWithoutCountDocument = `
    query JobBoardLoadTestWithoutCount($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $orderBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on JobNode {
          id
          orgId
          description
          employer {
            name
            logoUrl
          }
          title
          openDate {
            date
            time
            zone
          }
          closeDate {
            date
            time
            zone
          }
          offices {
            nodes {
              id
              name
            }
          }
          requiredDocuments {
            id
            name
          }
        }
        ... on ExternalJobNode {
          practiceCategories {
            nodes {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;
export const useJobBoardLoadTestWithoutCountQuery = <
      TData = JobBoardLoadTestWithoutCountQuery,
      TError = unknown
    >(
      variables?: JobBoardLoadTestWithoutCountQueryVariables,
      options?: UseQueryOptions<JobBoardLoadTestWithoutCountQuery, TError, TData>
    ) =>
    useQuery<JobBoardLoadTestWithoutCountQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestWithoutCount'] : ['JobBoardLoadTestWithoutCount', variables],
      fetcher<JobBoardLoadTestWithoutCountQuery, JobBoardLoadTestWithoutCountQueryVariables>(JobBoardLoadTestWithoutCountDocument, variables),
      options
    );

useJobBoardLoadTestWithoutCountQuery.getKey = (variables?: JobBoardLoadTestWithoutCountQueryVariables) => variables === undefined ? ['JobBoardLoadTestWithoutCount'] : ['JobBoardLoadTestWithoutCount', variables];
;

export const useInfiniteJobBoardLoadTestWithoutCountQuery = <
      TData = JobBoardLoadTestWithoutCountQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobBoardLoadTestWithoutCountQueryVariables,
      variables?: JobBoardLoadTestWithoutCountQueryVariables,
      options?: UseInfiniteQueryOptions<JobBoardLoadTestWithoutCountQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobBoardLoadTestWithoutCountQuery, TError, TData>(
      variables === undefined ? ['JobBoardLoadTestWithoutCount.infinite'] : ['JobBoardLoadTestWithoutCount.infinite', variables],
      (metaData) => fetcher<JobBoardLoadTestWithoutCountQuery, JobBoardLoadTestWithoutCountQueryVariables>(JobBoardLoadTestWithoutCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobBoardLoadTestWithoutCountQuery.getKey = (variables?: JobBoardLoadTestWithoutCountQueryVariables) => variables === undefined ? ['JobBoardLoadTestWithoutCount.infinite'] : ['JobBoardLoadTestWithoutCount.infinite', variables];
;

useJobBoardLoadTestWithoutCountQuery.fetcher = (variables?: JobBoardLoadTestWithoutCountQueryVariables) => fetcher<JobBoardLoadTestWithoutCountQuery, JobBoardLoadTestWithoutCountQueryVariables>(JobBoardLoadTestWithoutCountDocument, variables);
export const ForwardFiltersDocument = `
    query ForwardFilters {
  allOfficeLocations {
    nodes {
      name
      id
    }
  }
  allPracticeCategories {
    nodes {
      name
      id
    }
  }
}
    `;
export const useForwardFiltersQuery = <
      TData = ForwardFiltersQuery,
      TError = unknown
    >(
      variables?: ForwardFiltersQueryVariables,
      options?: UseQueryOptions<ForwardFiltersQuery, TError, TData>
    ) =>
    useQuery<ForwardFiltersQuery, TError, TData>(
      variables === undefined ? ['ForwardFilters'] : ['ForwardFilters', variables],
      fetcher<ForwardFiltersQuery, ForwardFiltersQueryVariables>(ForwardFiltersDocument, variables),
      options
    );

useForwardFiltersQuery.getKey = (variables?: ForwardFiltersQueryVariables) => variables === undefined ? ['ForwardFilters'] : ['ForwardFilters', variables];
;

export const useInfiniteForwardFiltersQuery = <
      TData = ForwardFiltersQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardFiltersQueryVariables,
      variables?: ForwardFiltersQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardFiltersQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardFiltersQuery, TError, TData>(
      variables === undefined ? ['ForwardFilters.infinite'] : ['ForwardFilters.infinite', variables],
      (metaData) => fetcher<ForwardFiltersQuery, ForwardFiltersQueryVariables>(ForwardFiltersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardFiltersQuery.getKey = (variables?: ForwardFiltersQueryVariables) => variables === undefined ? ['ForwardFilters.infinite'] : ['ForwardFilters.infinite', variables];
;

useForwardFiltersQuery.fetcher = (variables?: ForwardFiltersQueryVariables) => fetcher<ForwardFiltersQuery, ForwardFiltersQueryVariables>(ForwardFiltersDocument, variables);
export const ForwardJobPreferencesDocument = `
    query ForwardJobPreferences {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      jobPreferences {
        officeLocationIds
        practiceCategoryIds
      }
    }
  }
}
    `;
export const useForwardJobPreferencesQuery = <
      TData = ForwardJobPreferencesQuery,
      TError = unknown
    >(
      variables?: ForwardJobPreferencesQueryVariables,
      options?: UseQueryOptions<ForwardJobPreferencesQuery, TError, TData>
    ) =>
    useQuery<ForwardJobPreferencesQuery, TError, TData>(
      variables === undefined ? ['ForwardJobPreferences'] : ['ForwardJobPreferences', variables],
      fetcher<ForwardJobPreferencesQuery, ForwardJobPreferencesQueryVariables>(ForwardJobPreferencesDocument, variables),
      options
    );

useForwardJobPreferencesQuery.getKey = (variables?: ForwardJobPreferencesQueryVariables) => variables === undefined ? ['ForwardJobPreferences'] : ['ForwardJobPreferences', variables];
;

export const useInfiniteForwardJobPreferencesQuery = <
      TData = ForwardJobPreferencesQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardJobPreferencesQueryVariables,
      variables?: ForwardJobPreferencesQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardJobPreferencesQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardJobPreferencesQuery, TError, TData>(
      variables === undefined ? ['ForwardJobPreferences.infinite'] : ['ForwardJobPreferences.infinite', variables],
      (metaData) => fetcher<ForwardJobPreferencesQuery, ForwardJobPreferencesQueryVariables>(ForwardJobPreferencesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardJobPreferencesQuery.getKey = (variables?: ForwardJobPreferencesQueryVariables) => variables === undefined ? ['ForwardJobPreferences.infinite'] : ['ForwardJobPreferences.infinite', variables];
;

useForwardJobPreferencesQuery.fetcher = (variables?: ForwardJobPreferencesQueryVariables) => fetcher<ForwardJobPreferencesQuery, ForwardJobPreferencesQueryVariables>(ForwardJobPreferencesDocument, variables);
export const SubmitForwardJobPreferencesDocument = `
    mutation SubmitForwardJobPreferences($input: SubmitForwardJobPreferencesInput!) {
  submitForwardJobPreferences(input: $input) {
    success
  }
}
    `;
export const useSubmitForwardJobPreferencesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitForwardJobPreferencesMutation, TError, SubmitForwardJobPreferencesMutationVariables, TContext>) =>
    useMutation<SubmitForwardJobPreferencesMutation, TError, SubmitForwardJobPreferencesMutationVariables, TContext>(
      ['SubmitForwardJobPreferences'],
      (variables?: SubmitForwardJobPreferencesMutationVariables) => fetcher<SubmitForwardJobPreferencesMutation, SubmitForwardJobPreferencesMutationVariables>(SubmitForwardJobPreferencesDocument, variables)(),
      options
    );
useSubmitForwardJobPreferencesMutation.fetcher = (variables: SubmitForwardJobPreferencesMutationVariables) => fetcher<SubmitForwardJobPreferencesMutation, SubmitForwardJobPreferencesMutationVariables>(SubmitForwardJobPreferencesDocument, variables);
export const ConfirmAppliedToExternalJobDocument = `
    mutation ConfirmAppliedToExternalJob($input: ConfirmAppliedToExternalJobInput!) {
  confirmAppliedToExternalJob(input: $input) {
    success
  }
}
    `;
export const useConfirmAppliedToExternalJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmAppliedToExternalJobMutation, TError, ConfirmAppliedToExternalJobMutationVariables, TContext>) =>
    useMutation<ConfirmAppliedToExternalJobMutation, TError, ConfirmAppliedToExternalJobMutationVariables, TContext>(
      ['ConfirmAppliedToExternalJob'],
      (variables?: ConfirmAppliedToExternalJobMutationVariables) => fetcher<ConfirmAppliedToExternalJobMutation, ConfirmAppliedToExternalJobMutationVariables>(ConfirmAppliedToExternalJobDocument, variables)(),
      options
    );
useConfirmAppliedToExternalJobMutation.fetcher = (variables: ConfirmAppliedToExternalJobMutationVariables) => fetcher<ConfirmAppliedToExternalJobMutation, ConfirmAppliedToExternalJobMutationVariables>(ConfirmAppliedToExternalJobDocument, variables);
export const TrackGoToExternalJobPageDocument = `
    mutation TrackGoToExternalJobPage($input: TrackGoToExternalJobPageInput!) {
  trackGoToExternalJobPage(input: $input) {
    success
  }
}
    `;
export const useTrackGoToExternalJobPageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TrackGoToExternalJobPageMutation, TError, TrackGoToExternalJobPageMutationVariables, TContext>) =>
    useMutation<TrackGoToExternalJobPageMutation, TError, TrackGoToExternalJobPageMutationVariables, TContext>(
      ['TrackGoToExternalJobPage'],
      (variables?: TrackGoToExternalJobPageMutationVariables) => fetcher<TrackGoToExternalJobPageMutation, TrackGoToExternalJobPageMutationVariables>(TrackGoToExternalJobPageDocument, variables)(),
      options
    );
useTrackGoToExternalJobPageMutation.fetcher = (variables: TrackGoToExternalJobPageMutationVariables) => fetcher<TrackGoToExternalJobPageMutation, TrackGoToExternalJobPageMutationVariables>(TrackGoToExternalJobPageDocument, variables);
export const TrackApplyToExternalJobDocument = `
    mutation TrackApplyToExternalJob($input: TrackApplyToExternalJobInput!) {
  trackApplyToExternalJob(input: $input) {
    success
  }
}
    `;
export const useTrackApplyToExternalJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TrackApplyToExternalJobMutation, TError, TrackApplyToExternalJobMutationVariables, TContext>) =>
    useMutation<TrackApplyToExternalJobMutation, TError, TrackApplyToExternalJobMutationVariables, TContext>(
      ['TrackApplyToExternalJob'],
      (variables?: TrackApplyToExternalJobMutationVariables) => fetcher<TrackApplyToExternalJobMutation, TrackApplyToExternalJobMutationVariables>(TrackApplyToExternalJobDocument, variables)(),
      options
    );
useTrackApplyToExternalJobMutation.fetcher = (variables: TrackApplyToExternalJobMutationVariables) => fetcher<TrackApplyToExternalJobMutation, TrackApplyToExternalJobMutationVariables>(TrackApplyToExternalJobDocument, variables);
export const TrackQuickApplyToJobDocument = `
    mutation TrackQuickApplyToJob($input: TrackQuickApplyToJobInput!) {
  trackQuickApplyToJob(input: $input) {
    success
  }
}
    `;
export const useTrackQuickApplyToJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TrackQuickApplyToJobMutation, TError, TrackQuickApplyToJobMutationVariables, TContext>) =>
    useMutation<TrackQuickApplyToJobMutation, TError, TrackQuickApplyToJobMutationVariables, TContext>(
      ['TrackQuickApplyToJob'],
      (variables?: TrackQuickApplyToJobMutationVariables) => fetcher<TrackQuickApplyToJobMutation, TrackQuickApplyToJobMutationVariables>(TrackQuickApplyToJobDocument, variables)(),
      options
    );
useTrackQuickApplyToJobMutation.fetcher = (variables: TrackQuickApplyToJobMutationVariables) => fetcher<TrackQuickApplyToJobMutation, TrackQuickApplyToJobMutationVariables>(TrackQuickApplyToJobDocument, variables);
export const ForwardAppliedJobIdsDocument = `
    query ForwardAppliedJobIds {
  forwardAppliedJobIds
}
    `;
export const useForwardAppliedJobIdsQuery = <
      TData = ForwardAppliedJobIdsQuery,
      TError = unknown
    >(
      variables?: ForwardAppliedJobIdsQueryVariables,
      options?: UseQueryOptions<ForwardAppliedJobIdsQuery, TError, TData>
    ) =>
    useQuery<ForwardAppliedJobIdsQuery, TError, TData>(
      variables === undefined ? ['ForwardAppliedJobIds'] : ['ForwardAppliedJobIds', variables],
      fetcher<ForwardAppliedJobIdsQuery, ForwardAppliedJobIdsQueryVariables>(ForwardAppliedJobIdsDocument, variables),
      options
    );

useForwardAppliedJobIdsQuery.getKey = (variables?: ForwardAppliedJobIdsQueryVariables) => variables === undefined ? ['ForwardAppliedJobIds'] : ['ForwardAppliedJobIds', variables];
;

export const useInfiniteForwardAppliedJobIdsQuery = <
      TData = ForwardAppliedJobIdsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardAppliedJobIdsQueryVariables,
      variables?: ForwardAppliedJobIdsQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardAppliedJobIdsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardAppliedJobIdsQuery, TError, TData>(
      variables === undefined ? ['ForwardAppliedJobIds.infinite'] : ['ForwardAppliedJobIds.infinite', variables],
      (metaData) => fetcher<ForwardAppliedJobIdsQuery, ForwardAppliedJobIdsQueryVariables>(ForwardAppliedJobIdsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardAppliedJobIdsQuery.getKey = (variables?: ForwardAppliedJobIdsQueryVariables) => variables === undefined ? ['ForwardAppliedJobIds.infinite'] : ['ForwardAppliedJobIds.infinite', variables];
;

useForwardAppliedJobIdsQuery.fetcher = (variables?: ForwardAppliedJobIdsQueryVariables) => fetcher<ForwardAppliedJobIdsQuery, ForwardAppliedJobIdsQueryVariables>(ForwardAppliedJobIdsDocument, variables);
export const ForwardJobBoardFeedDocument = `
    query ForwardJobBoardFeed($first: Int, $after: String, $filterBy: ForwardJobFeedFilterBy, $sortBy: [JobFeedSortBy!], $descriptionTextContentNumChars: Int!) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $sortBy
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPrevPage
    }
    edges {
      cursor
      node {
        ...DiscoveryJobCardFields
      }
    }
    totalCount
  }
}
    ${DiscoveryJobCardFieldsFragmentDoc}`;
export const useForwardJobBoardFeedQuery = <
      TData = ForwardJobBoardFeedQuery,
      TError = unknown
    >(
      variables: ForwardJobBoardFeedQueryVariables,
      options?: UseQueryOptions<ForwardJobBoardFeedQuery, TError, TData>
    ) =>
    useQuery<ForwardJobBoardFeedQuery, TError, TData>(
      ['ForwardJobBoardFeed', variables],
      fetcher<ForwardJobBoardFeedQuery, ForwardJobBoardFeedQueryVariables>(ForwardJobBoardFeedDocument, variables),
      options
    );

useForwardJobBoardFeedQuery.getKey = (variables: ForwardJobBoardFeedQueryVariables) => ['ForwardJobBoardFeed', variables];
;

export const useInfiniteForwardJobBoardFeedQuery = <
      TData = ForwardJobBoardFeedQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardJobBoardFeedQueryVariables,
      variables: ForwardJobBoardFeedQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardJobBoardFeedQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardJobBoardFeedQuery, TError, TData>(
      ['ForwardJobBoardFeed.infinite', variables],
      (metaData) => fetcher<ForwardJobBoardFeedQuery, ForwardJobBoardFeedQueryVariables>(ForwardJobBoardFeedDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardJobBoardFeedQuery.getKey = (variables: ForwardJobBoardFeedQueryVariables) => ['ForwardJobBoardFeed.infinite', variables];
;

useForwardJobBoardFeedQuery.fetcher = (variables: ForwardJobBoardFeedQueryVariables) => fetcher<ForwardJobBoardFeedQuery, ForwardJobBoardFeedQueryVariables>(ForwardJobBoardFeedDocument, variables);
export const ForwardAvailableJobsCountDocument = `
    query ForwardAvailableJobsCount($filterBy: ForwardJobFeedFilterBy!) {
  forwardJobFeed(filterBy: $filterBy) {
    totalCount
  }
}
    `;
export const useForwardAvailableJobsCountQuery = <
      TData = ForwardAvailableJobsCountQuery,
      TError = unknown
    >(
      variables: ForwardAvailableJobsCountQueryVariables,
      options?: UseQueryOptions<ForwardAvailableJobsCountQuery, TError, TData>
    ) =>
    useQuery<ForwardAvailableJobsCountQuery, TError, TData>(
      ['ForwardAvailableJobsCount', variables],
      fetcher<ForwardAvailableJobsCountQuery, ForwardAvailableJobsCountQueryVariables>(ForwardAvailableJobsCountDocument, variables),
      options
    );

useForwardAvailableJobsCountQuery.getKey = (variables: ForwardAvailableJobsCountQueryVariables) => ['ForwardAvailableJobsCount', variables];
;

export const useInfiniteForwardAvailableJobsCountQuery = <
      TData = ForwardAvailableJobsCountQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardAvailableJobsCountQueryVariables,
      variables: ForwardAvailableJobsCountQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardAvailableJobsCountQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardAvailableJobsCountQuery, TError, TData>(
      ['ForwardAvailableJobsCount.infinite', variables],
      (metaData) => fetcher<ForwardAvailableJobsCountQuery, ForwardAvailableJobsCountQueryVariables>(ForwardAvailableJobsCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardAvailableJobsCountQuery.getKey = (variables: ForwardAvailableJobsCountQueryVariables) => ['ForwardAvailableJobsCount.infinite', variables];
;

useForwardAvailableJobsCountQuery.fetcher = (variables: ForwardAvailableJobsCountQueryVariables) => fetcher<ForwardAvailableJobsCountQuery, ForwardAvailableJobsCountQueryVariables>(ForwardAvailableJobsCountDocument, variables);
export const ForwardJobDetailsDocument = `
    query ForwardJobDetails($jobId: ID!, $numChars: Int, $descriptionTextContentNumChars: Int!) {
  forwardJobById(id: $jobId) {
    __typename
    ...DiscoveryJobCardFields
    ... on JobNode {
      employer {
        ...FirmProfilePreviewFields
      }
      description
      requiredDocuments {
        id
        name
      }
    }
  }
}
    ${DiscoveryJobCardFieldsFragmentDoc}
${FirmProfilePreviewFieldsFragmentDoc}`;
export const useForwardJobDetailsQuery = <
      TData = ForwardJobDetailsQuery,
      TError = unknown
    >(
      variables: ForwardJobDetailsQueryVariables,
      options?: UseQueryOptions<ForwardJobDetailsQuery, TError, TData>
    ) =>
    useQuery<ForwardJobDetailsQuery, TError, TData>(
      ['ForwardJobDetails', variables],
      fetcher<ForwardJobDetailsQuery, ForwardJobDetailsQueryVariables>(ForwardJobDetailsDocument, variables),
      options
    );

useForwardJobDetailsQuery.getKey = (variables: ForwardJobDetailsQueryVariables) => ['ForwardJobDetails', variables];
;

export const useInfiniteForwardJobDetailsQuery = <
      TData = ForwardJobDetailsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardJobDetailsQueryVariables,
      variables: ForwardJobDetailsQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardJobDetailsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardJobDetailsQuery, TError, TData>(
      ['ForwardJobDetails.infinite', variables],
      (metaData) => fetcher<ForwardJobDetailsQuery, ForwardJobDetailsQueryVariables>(ForwardJobDetailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardJobDetailsQuery.getKey = (variables: ForwardJobDetailsQueryVariables) => ['ForwardJobDetails.infinite', variables];
;

useForwardJobDetailsQuery.fetcher = (variables: ForwardJobDetailsQueryVariables) => fetcher<ForwardJobDetailsQuery, ForwardJobDetailsQueryVariables>(ForwardJobDetailsDocument, variables);
export const CandidateNavBarDocument = `
    query CandidateNavBar {
  forwardAccount {
    __typename
    ... on InactiveForwardAccountNode {
      loggedInEmail
    }
    ... on ActiveForwardAccountNode {
      loggedInEmail
      profile {
        id
        firstName
        lastName
        profilePhotoUrl
      }
    }
  }
}
    `;
export const useCandidateNavBarQuery = <
      TData = CandidateNavBarQuery,
      TError = unknown
    >(
      variables?: CandidateNavBarQueryVariables,
      options?: UseQueryOptions<CandidateNavBarQuery, TError, TData>
    ) =>
    useQuery<CandidateNavBarQuery, TError, TData>(
      variables === undefined ? ['CandidateNavBar'] : ['CandidateNavBar', variables],
      fetcher<CandidateNavBarQuery, CandidateNavBarQueryVariables>(CandidateNavBarDocument, variables),
      options
    );

useCandidateNavBarQuery.getKey = (variables?: CandidateNavBarQueryVariables) => variables === undefined ? ['CandidateNavBar'] : ['CandidateNavBar', variables];
;

export const useInfiniteCandidateNavBarQuery = <
      TData = CandidateNavBarQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateNavBarQueryVariables,
      variables?: CandidateNavBarQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateNavBarQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateNavBarQuery, TError, TData>(
      variables === undefined ? ['CandidateNavBar.infinite'] : ['CandidateNavBar.infinite', variables],
      (metaData) => fetcher<CandidateNavBarQuery, CandidateNavBarQueryVariables>(CandidateNavBarDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateNavBarQuery.getKey = (variables?: CandidateNavBarQueryVariables) => variables === undefined ? ['CandidateNavBar.infinite'] : ['CandidateNavBar.infinite', variables];
;

useCandidateNavBarQuery.fetcher = (variables?: CandidateNavBarQueryVariables) => fetcher<CandidateNavBarQuery, CandidateNavBarQueryVariables>(CandidateNavBarDocument, variables);
export const MyForwardEducationHistoryDocument = `
    query MyForwardEducationHistory {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      profile {
        educationHistoryEntries {
          nodes {
            ...MyForwardEducationHistoryEntry
          }
        }
      }
    }
  }
}
    ${MyForwardEducationHistoryEntryFragmentDoc}
${MyForwardEducationHistoryEntryFormFieldsFragmentDoc}`;
export const useMyForwardEducationHistoryQuery = <
      TData = MyForwardEducationHistoryQuery,
      TError = unknown
    >(
      variables?: MyForwardEducationHistoryQueryVariables,
      options?: UseQueryOptions<MyForwardEducationHistoryQuery, TError, TData>
    ) =>
    useQuery<MyForwardEducationHistoryQuery, TError, TData>(
      variables === undefined ? ['MyForwardEducationHistory'] : ['MyForwardEducationHistory', variables],
      fetcher<MyForwardEducationHistoryQuery, MyForwardEducationHistoryQueryVariables>(MyForwardEducationHistoryDocument, variables),
      options
    );

useMyForwardEducationHistoryQuery.getKey = (variables?: MyForwardEducationHistoryQueryVariables) => variables === undefined ? ['MyForwardEducationHistory'] : ['MyForwardEducationHistory', variables];
;

export const useInfiniteMyForwardEducationHistoryQuery = <
      TData = MyForwardEducationHistoryQuery,
      TError = unknown
    >(
      pageParamKey: keyof MyForwardEducationHistoryQueryVariables,
      variables?: MyForwardEducationHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<MyForwardEducationHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<MyForwardEducationHistoryQuery, TError, TData>(
      variables === undefined ? ['MyForwardEducationHistory.infinite'] : ['MyForwardEducationHistory.infinite', variables],
      (metaData) => fetcher<MyForwardEducationHistoryQuery, MyForwardEducationHistoryQueryVariables>(MyForwardEducationHistoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteMyForwardEducationHistoryQuery.getKey = (variables?: MyForwardEducationHistoryQueryVariables) => variables === undefined ? ['MyForwardEducationHistory.infinite'] : ['MyForwardEducationHistory.infinite', variables];
;

useMyForwardEducationHistoryQuery.fetcher = (variables?: MyForwardEducationHistoryQueryVariables) => fetcher<MyForwardEducationHistoryQuery, MyForwardEducationHistoryQueryVariables>(MyForwardEducationHistoryDocument, variables);
export const MyForwardEducationHistoryDropdownDataDocument = `
    query MyForwardEducationHistoryDropdownData {
  allSchools {
    nodes {
      __typename
      id
      name
    }
  }
  allSchoolDegrees {
    nodes {
      id
      name
      schoolType
      distinguishedType
    }
  }
}
    `;
export const useMyForwardEducationHistoryDropdownDataQuery = <
      TData = MyForwardEducationHistoryDropdownDataQuery,
      TError = unknown
    >(
      variables?: MyForwardEducationHistoryDropdownDataQueryVariables,
      options?: UseQueryOptions<MyForwardEducationHistoryDropdownDataQuery, TError, TData>
    ) =>
    useQuery<MyForwardEducationHistoryDropdownDataQuery, TError, TData>(
      variables === undefined ? ['MyForwardEducationHistoryDropdownData'] : ['MyForwardEducationHistoryDropdownData', variables],
      fetcher<MyForwardEducationHistoryDropdownDataQuery, MyForwardEducationHistoryDropdownDataQueryVariables>(MyForwardEducationHistoryDropdownDataDocument, variables),
      options
    );

useMyForwardEducationHistoryDropdownDataQuery.getKey = (variables?: MyForwardEducationHistoryDropdownDataQueryVariables) => variables === undefined ? ['MyForwardEducationHistoryDropdownData'] : ['MyForwardEducationHistoryDropdownData', variables];
;

export const useInfiniteMyForwardEducationHistoryDropdownDataQuery = <
      TData = MyForwardEducationHistoryDropdownDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof MyForwardEducationHistoryDropdownDataQueryVariables,
      variables?: MyForwardEducationHistoryDropdownDataQueryVariables,
      options?: UseInfiniteQueryOptions<MyForwardEducationHistoryDropdownDataQuery, TError, TData>
    ) =>
    useInfiniteQuery<MyForwardEducationHistoryDropdownDataQuery, TError, TData>(
      variables === undefined ? ['MyForwardEducationHistoryDropdownData.infinite'] : ['MyForwardEducationHistoryDropdownData.infinite', variables],
      (metaData) => fetcher<MyForwardEducationHistoryDropdownDataQuery, MyForwardEducationHistoryDropdownDataQueryVariables>(MyForwardEducationHistoryDropdownDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteMyForwardEducationHistoryDropdownDataQuery.getKey = (variables?: MyForwardEducationHistoryDropdownDataQueryVariables) => variables === undefined ? ['MyForwardEducationHistoryDropdownData.infinite'] : ['MyForwardEducationHistoryDropdownData.infinite', variables];
;

useMyForwardEducationHistoryDropdownDataQuery.fetcher = (variables?: MyForwardEducationHistoryDropdownDataQueryVariables) => fetcher<MyForwardEducationHistoryDropdownDataQuery, MyForwardEducationHistoryDropdownDataQueryVariables>(MyForwardEducationHistoryDropdownDataDocument, variables);
export const SubmitEntryOfMyForwardEducationHistoryDocument = `
    mutation SubmitEntryOfMyForwardEducationHistory($input: SubmitCandidateEducationHistoryEntryInput!) {
  submitCandidateEducationHistoryEntry(input: $input) {
    success
  }
}
    `;
export const useSubmitEntryOfMyForwardEducationHistoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitEntryOfMyForwardEducationHistoryMutation, TError, SubmitEntryOfMyForwardEducationHistoryMutationVariables, TContext>) =>
    useMutation<SubmitEntryOfMyForwardEducationHistoryMutation, TError, SubmitEntryOfMyForwardEducationHistoryMutationVariables, TContext>(
      ['SubmitEntryOfMyForwardEducationHistory'],
      (variables?: SubmitEntryOfMyForwardEducationHistoryMutationVariables) => fetcher<SubmitEntryOfMyForwardEducationHistoryMutation, SubmitEntryOfMyForwardEducationHistoryMutationVariables>(SubmitEntryOfMyForwardEducationHistoryDocument, variables)(),
      options
    );
useSubmitEntryOfMyForwardEducationHistoryMutation.fetcher = (variables: SubmitEntryOfMyForwardEducationHistoryMutationVariables) => fetcher<SubmitEntryOfMyForwardEducationHistoryMutation, SubmitEntryOfMyForwardEducationHistoryMutationVariables>(SubmitEntryOfMyForwardEducationHistoryDocument, variables);
export const RemoveEntryFromMyForwardEducationHistoryDocument = `
    mutation RemoveEntryFromMyForwardEducationHistory($input: RemoveCandidateEducationHistoryEntryInput!) {
  removeCandidateEducationHistoryEntry(input: $input) {
    success
  }
}
    `;
export const useRemoveEntryFromMyForwardEducationHistoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEntryFromMyForwardEducationHistoryMutation, TError, RemoveEntryFromMyForwardEducationHistoryMutationVariables, TContext>) =>
    useMutation<RemoveEntryFromMyForwardEducationHistoryMutation, TError, RemoveEntryFromMyForwardEducationHistoryMutationVariables, TContext>(
      ['RemoveEntryFromMyForwardEducationHistory'],
      (variables?: RemoveEntryFromMyForwardEducationHistoryMutationVariables) => fetcher<RemoveEntryFromMyForwardEducationHistoryMutation, RemoveEntryFromMyForwardEducationHistoryMutationVariables>(RemoveEntryFromMyForwardEducationHistoryDocument, variables)(),
      options
    );
useRemoveEntryFromMyForwardEducationHistoryMutation.fetcher = (variables: RemoveEntryFromMyForwardEducationHistoryMutationVariables) => fetcher<RemoveEntryFromMyForwardEducationHistoryMutation, RemoveEntryFromMyForwardEducationHistoryMutationVariables>(RemoveEntryFromMyForwardEducationHistoryDocument, variables);
export const ForwardProfileAboutBioDocument = `
    query ForwardProfileAboutBio {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      candidateId
      profile {
        firstName
        bio
      }
    }
  }
}
    `;
export const useForwardProfileAboutBioQuery = <
      TData = ForwardProfileAboutBioQuery,
      TError = unknown
    >(
      variables?: ForwardProfileAboutBioQueryVariables,
      options?: UseQueryOptions<ForwardProfileAboutBioQuery, TError, TData>
    ) =>
    useQuery<ForwardProfileAboutBioQuery, TError, TData>(
      variables === undefined ? ['ForwardProfileAboutBio'] : ['ForwardProfileAboutBio', variables],
      fetcher<ForwardProfileAboutBioQuery, ForwardProfileAboutBioQueryVariables>(ForwardProfileAboutBioDocument, variables),
      options
    );

useForwardProfileAboutBioQuery.getKey = (variables?: ForwardProfileAboutBioQueryVariables) => variables === undefined ? ['ForwardProfileAboutBio'] : ['ForwardProfileAboutBio', variables];
;

export const useInfiniteForwardProfileAboutBioQuery = <
      TData = ForwardProfileAboutBioQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardProfileAboutBioQueryVariables,
      variables?: ForwardProfileAboutBioQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardProfileAboutBioQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardProfileAboutBioQuery, TError, TData>(
      variables === undefined ? ['ForwardProfileAboutBio.infinite'] : ['ForwardProfileAboutBio.infinite', variables],
      (metaData) => fetcher<ForwardProfileAboutBioQuery, ForwardProfileAboutBioQueryVariables>(ForwardProfileAboutBioDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardProfileAboutBioQuery.getKey = (variables?: ForwardProfileAboutBioQueryVariables) => variables === undefined ? ['ForwardProfileAboutBio.infinite'] : ['ForwardProfileAboutBio.infinite', variables];
;

useForwardProfileAboutBioQuery.fetcher = (variables?: ForwardProfileAboutBioQueryVariables) => fetcher<ForwardProfileAboutBioQuery, ForwardProfileAboutBioQueryVariables>(ForwardProfileAboutBioDocument, variables);
export const EditForwardProfileAboutBioDocument = `
    mutation EditForwardProfileAboutBio($input: EditForwardProfileAboutBioInput!) {
  editForwardProfileAboutBio(input: $input) {
    success
  }
}
    `;
export const useEditForwardProfileAboutBioMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditForwardProfileAboutBioMutation, TError, EditForwardProfileAboutBioMutationVariables, TContext>) =>
    useMutation<EditForwardProfileAboutBioMutation, TError, EditForwardProfileAboutBioMutationVariables, TContext>(
      ['EditForwardProfileAboutBio'],
      (variables?: EditForwardProfileAboutBioMutationVariables) => fetcher<EditForwardProfileAboutBioMutation, EditForwardProfileAboutBioMutationVariables>(EditForwardProfileAboutBioDocument, variables)(),
      options
    );
useEditForwardProfileAboutBioMutation.fetcher = (variables: EditForwardProfileAboutBioMutationVariables) => fetcher<EditForwardProfileAboutBioMutation, EditForwardProfileAboutBioMutationVariables>(EditForwardProfileAboutBioDocument, variables);
export const MyForwardWorkHistoryDocument = `
    query MyForwardWorkHistory {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      profile {
        workHistoryEntries {
          nodes {
            ...MyForwardWorkHistoryEntry
          }
        }
      }
    }
  }
}
    ${MyForwardWorkHistoryEntryFragmentDoc}
${MyForwardWorkHistoryEntryFormFieldsFragmentDoc}`;
export const useMyForwardWorkHistoryQuery = <
      TData = MyForwardWorkHistoryQuery,
      TError = unknown
    >(
      variables?: MyForwardWorkHistoryQueryVariables,
      options?: UseQueryOptions<MyForwardWorkHistoryQuery, TError, TData>
    ) =>
    useQuery<MyForwardWorkHistoryQuery, TError, TData>(
      variables === undefined ? ['MyForwardWorkHistory'] : ['MyForwardWorkHistory', variables],
      fetcher<MyForwardWorkHistoryQuery, MyForwardWorkHistoryQueryVariables>(MyForwardWorkHistoryDocument, variables),
      options
    );

useMyForwardWorkHistoryQuery.getKey = (variables?: MyForwardWorkHistoryQueryVariables) => variables === undefined ? ['MyForwardWorkHistory'] : ['MyForwardWorkHistory', variables];
;

export const useInfiniteMyForwardWorkHistoryQuery = <
      TData = MyForwardWorkHistoryQuery,
      TError = unknown
    >(
      pageParamKey: keyof MyForwardWorkHistoryQueryVariables,
      variables?: MyForwardWorkHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<MyForwardWorkHistoryQuery, TError, TData>
    ) =>
    useInfiniteQuery<MyForwardWorkHistoryQuery, TError, TData>(
      variables === undefined ? ['MyForwardWorkHistory.infinite'] : ['MyForwardWorkHistory.infinite', variables],
      (metaData) => fetcher<MyForwardWorkHistoryQuery, MyForwardWorkHistoryQueryVariables>(MyForwardWorkHistoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteMyForwardWorkHistoryQuery.getKey = (variables?: MyForwardWorkHistoryQueryVariables) => variables === undefined ? ['MyForwardWorkHistory.infinite'] : ['MyForwardWorkHistory.infinite', variables];
;

useMyForwardWorkHistoryQuery.fetcher = (variables?: MyForwardWorkHistoryQueryVariables) => fetcher<MyForwardWorkHistoryQuery, MyForwardWorkHistoryQueryVariables>(MyForwardWorkHistoryDocument, variables);
export const SubmitEntryOfMyForwardWorkHistoryDocument = `
    mutation SubmitEntryOfMyForwardWorkHistory($submitInput: SubmitCandidateWorkHistoryEntryInput!) {
  submitCandidateWorkHistoryEntry(input: $submitInput) {
    success
  }
}
    `;
export const useSubmitEntryOfMyForwardWorkHistoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitEntryOfMyForwardWorkHistoryMutation, TError, SubmitEntryOfMyForwardWorkHistoryMutationVariables, TContext>) =>
    useMutation<SubmitEntryOfMyForwardWorkHistoryMutation, TError, SubmitEntryOfMyForwardWorkHistoryMutationVariables, TContext>(
      ['SubmitEntryOfMyForwardWorkHistory'],
      (variables?: SubmitEntryOfMyForwardWorkHistoryMutationVariables) => fetcher<SubmitEntryOfMyForwardWorkHistoryMutation, SubmitEntryOfMyForwardWorkHistoryMutationVariables>(SubmitEntryOfMyForwardWorkHistoryDocument, variables)(),
      options
    );
useSubmitEntryOfMyForwardWorkHistoryMutation.fetcher = (variables: SubmitEntryOfMyForwardWorkHistoryMutationVariables) => fetcher<SubmitEntryOfMyForwardWorkHistoryMutation, SubmitEntryOfMyForwardWorkHistoryMutationVariables>(SubmitEntryOfMyForwardWorkHistoryDocument, variables);
export const RemoveEntryFromMyForwardWorkHistoryDocument = `
    mutation RemoveEntryFromMyForwardWorkHistory($removeInput: RemoveCandidateWorkHistoryEntryInput!) {
  removeCandidateWorkHistoryEntry(input: $removeInput) {
    success
  }
}
    `;
export const useRemoveEntryFromMyForwardWorkHistoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEntryFromMyForwardWorkHistoryMutation, TError, RemoveEntryFromMyForwardWorkHistoryMutationVariables, TContext>) =>
    useMutation<RemoveEntryFromMyForwardWorkHistoryMutation, TError, RemoveEntryFromMyForwardWorkHistoryMutationVariables, TContext>(
      ['RemoveEntryFromMyForwardWorkHistory'],
      (variables?: RemoveEntryFromMyForwardWorkHistoryMutationVariables) => fetcher<RemoveEntryFromMyForwardWorkHistoryMutation, RemoveEntryFromMyForwardWorkHistoryMutationVariables>(RemoveEntryFromMyForwardWorkHistoryDocument, variables)(),
      options
    );
useRemoveEntryFromMyForwardWorkHistoryMutation.fetcher = (variables: RemoveEntryFromMyForwardWorkHistoryMutationVariables) => fetcher<RemoveEntryFromMyForwardWorkHistoryMutation, RemoveEntryFromMyForwardWorkHistoryMutationVariables>(RemoveEntryFromMyForwardWorkHistoryDocument, variables);
export const MyForwardWorkHistoryDropdownDataDocument = `
    query MyForwardWorkHistoryDropdownData {
  allPracticeAreas {
    nodes {
      id
      name
    }
  }
  allOfficeLocations {
    nodes {
      id
      name
    }
  }
  workplaces {
    nodes {
      id
      name
    }
  }
}
    `;
export const useMyForwardWorkHistoryDropdownDataQuery = <
      TData = MyForwardWorkHistoryDropdownDataQuery,
      TError = unknown
    >(
      variables?: MyForwardWorkHistoryDropdownDataQueryVariables,
      options?: UseQueryOptions<MyForwardWorkHistoryDropdownDataQuery, TError, TData>
    ) =>
    useQuery<MyForwardWorkHistoryDropdownDataQuery, TError, TData>(
      variables === undefined ? ['MyForwardWorkHistoryDropdownData'] : ['MyForwardWorkHistoryDropdownData', variables],
      fetcher<MyForwardWorkHistoryDropdownDataQuery, MyForwardWorkHistoryDropdownDataQueryVariables>(MyForwardWorkHistoryDropdownDataDocument, variables),
      options
    );

useMyForwardWorkHistoryDropdownDataQuery.getKey = (variables?: MyForwardWorkHistoryDropdownDataQueryVariables) => variables === undefined ? ['MyForwardWorkHistoryDropdownData'] : ['MyForwardWorkHistoryDropdownData', variables];
;

export const useInfiniteMyForwardWorkHistoryDropdownDataQuery = <
      TData = MyForwardWorkHistoryDropdownDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof MyForwardWorkHistoryDropdownDataQueryVariables,
      variables?: MyForwardWorkHistoryDropdownDataQueryVariables,
      options?: UseInfiniteQueryOptions<MyForwardWorkHistoryDropdownDataQuery, TError, TData>
    ) =>
    useInfiniteQuery<MyForwardWorkHistoryDropdownDataQuery, TError, TData>(
      variables === undefined ? ['MyForwardWorkHistoryDropdownData.infinite'] : ['MyForwardWorkHistoryDropdownData.infinite', variables],
      (metaData) => fetcher<MyForwardWorkHistoryDropdownDataQuery, MyForwardWorkHistoryDropdownDataQueryVariables>(MyForwardWorkHistoryDropdownDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteMyForwardWorkHistoryDropdownDataQuery.getKey = (variables?: MyForwardWorkHistoryDropdownDataQueryVariables) => variables === undefined ? ['MyForwardWorkHistoryDropdownData.infinite'] : ['MyForwardWorkHistoryDropdownData.infinite', variables];
;

useMyForwardWorkHistoryDropdownDataQuery.fetcher = (variables?: MyForwardWorkHistoryDropdownDataQueryVariables) => fetcher<MyForwardWorkHistoryDropdownDataQuery, MyForwardWorkHistoryDropdownDataQueryVariables>(MyForwardWorkHistoryDropdownDataDocument, variables);
export const ForwardSettingsPersonalInfoDocument = `
    query ForwardSettingsPersonalInfo {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      demographicInfo {
        ethnicityAnswers
        genderAnswers
        sexualIdentityAnswers
        veteranStatusAnswer
      }
    }
  }
}
    `;
export const useForwardSettingsPersonalInfoQuery = <
      TData = ForwardSettingsPersonalInfoQuery,
      TError = unknown
    >(
      variables?: ForwardSettingsPersonalInfoQueryVariables,
      options?: UseQueryOptions<ForwardSettingsPersonalInfoQuery, TError, TData>
    ) =>
    useQuery<ForwardSettingsPersonalInfoQuery, TError, TData>(
      variables === undefined ? ['ForwardSettingsPersonalInfo'] : ['ForwardSettingsPersonalInfo', variables],
      fetcher<ForwardSettingsPersonalInfoQuery, ForwardSettingsPersonalInfoQueryVariables>(ForwardSettingsPersonalInfoDocument, variables),
      options
    );

useForwardSettingsPersonalInfoQuery.getKey = (variables?: ForwardSettingsPersonalInfoQueryVariables) => variables === undefined ? ['ForwardSettingsPersonalInfo'] : ['ForwardSettingsPersonalInfo', variables];
;

export const useInfiniteForwardSettingsPersonalInfoQuery = <
      TData = ForwardSettingsPersonalInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardSettingsPersonalInfoQueryVariables,
      variables?: ForwardSettingsPersonalInfoQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardSettingsPersonalInfoQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardSettingsPersonalInfoQuery, TError, TData>(
      variables === undefined ? ['ForwardSettingsPersonalInfo.infinite'] : ['ForwardSettingsPersonalInfo.infinite', variables],
      (metaData) => fetcher<ForwardSettingsPersonalInfoQuery, ForwardSettingsPersonalInfoQueryVariables>(ForwardSettingsPersonalInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardSettingsPersonalInfoQuery.getKey = (variables?: ForwardSettingsPersonalInfoQueryVariables) => variables === undefined ? ['ForwardSettingsPersonalInfo.infinite'] : ['ForwardSettingsPersonalInfo.infinite', variables];
;

useForwardSettingsPersonalInfoQuery.fetcher = (variables?: ForwardSettingsPersonalInfoQueryVariables) => fetcher<ForwardSettingsPersonalInfoQuery, ForwardSettingsPersonalInfoQueryVariables>(ForwardSettingsPersonalInfoDocument, variables);
export const EditForwardSettingsPersonalInfoDocument = `
    mutation EditForwardSettingsPersonalInfo($input: SubmitForwardDemographicInfoInput!) {
  submitForwardDemographicInfo(input: $input) {
    success
  }
}
    `;
export const useEditForwardSettingsPersonalInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditForwardSettingsPersonalInfoMutation, TError, EditForwardSettingsPersonalInfoMutationVariables, TContext>) =>
    useMutation<EditForwardSettingsPersonalInfoMutation, TError, EditForwardSettingsPersonalInfoMutationVariables, TContext>(
      ['EditForwardSettingsPersonalInfo'],
      (variables?: EditForwardSettingsPersonalInfoMutationVariables) => fetcher<EditForwardSettingsPersonalInfoMutation, EditForwardSettingsPersonalInfoMutationVariables>(EditForwardSettingsPersonalInfoDocument, variables)(),
      options
    );
useEditForwardSettingsPersonalInfoMutation.fetcher = (variables: EditForwardSettingsPersonalInfoMutationVariables) => fetcher<EditForwardSettingsPersonalInfoMutation, EditForwardSettingsPersonalInfoMutationVariables>(EditForwardSettingsPersonalInfoDocument, variables);
export const ForwardSettingsOfficeLocationPreferencesDocument = `
    query ForwardSettingsOfficeLocationPreferences {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      jobPreferences {
        officeLocationIds
      }
    }
  }
}
    `;
export const useForwardSettingsOfficeLocationPreferencesQuery = <
      TData = ForwardSettingsOfficeLocationPreferencesQuery,
      TError = unknown
    >(
      variables?: ForwardSettingsOfficeLocationPreferencesQueryVariables,
      options?: UseQueryOptions<ForwardSettingsOfficeLocationPreferencesQuery, TError, TData>
    ) =>
    useQuery<ForwardSettingsOfficeLocationPreferencesQuery, TError, TData>(
      variables === undefined ? ['ForwardSettingsOfficeLocationPreferences'] : ['ForwardSettingsOfficeLocationPreferences', variables],
      fetcher<ForwardSettingsOfficeLocationPreferencesQuery, ForwardSettingsOfficeLocationPreferencesQueryVariables>(ForwardSettingsOfficeLocationPreferencesDocument, variables),
      options
    );

useForwardSettingsOfficeLocationPreferencesQuery.getKey = (variables?: ForwardSettingsOfficeLocationPreferencesQueryVariables) => variables === undefined ? ['ForwardSettingsOfficeLocationPreferences'] : ['ForwardSettingsOfficeLocationPreferences', variables];
;

export const useInfiniteForwardSettingsOfficeLocationPreferencesQuery = <
      TData = ForwardSettingsOfficeLocationPreferencesQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardSettingsOfficeLocationPreferencesQueryVariables,
      variables?: ForwardSettingsOfficeLocationPreferencesQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardSettingsOfficeLocationPreferencesQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardSettingsOfficeLocationPreferencesQuery, TError, TData>(
      variables === undefined ? ['ForwardSettingsOfficeLocationPreferences.infinite'] : ['ForwardSettingsOfficeLocationPreferences.infinite', variables],
      (metaData) => fetcher<ForwardSettingsOfficeLocationPreferencesQuery, ForwardSettingsOfficeLocationPreferencesQueryVariables>(ForwardSettingsOfficeLocationPreferencesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardSettingsOfficeLocationPreferencesQuery.getKey = (variables?: ForwardSettingsOfficeLocationPreferencesQueryVariables) => variables === undefined ? ['ForwardSettingsOfficeLocationPreferences.infinite'] : ['ForwardSettingsOfficeLocationPreferences.infinite', variables];
;

useForwardSettingsOfficeLocationPreferencesQuery.fetcher = (variables?: ForwardSettingsOfficeLocationPreferencesQueryVariables) => fetcher<ForwardSettingsOfficeLocationPreferencesQuery, ForwardSettingsOfficeLocationPreferencesQueryVariables>(ForwardSettingsOfficeLocationPreferencesDocument, variables);
export const ForwardSettingsPracticeCategoryPreferencesDocument = `
    query ForwardSettingsPracticeCategoryPreferences {
  forwardAccount {
    __typename
    ... on ActiveForwardAccountNode {
      jobPreferences {
        practiceCategoryIds
      }
    }
  }
}
    `;
export const useForwardSettingsPracticeCategoryPreferencesQuery = <
      TData = ForwardSettingsPracticeCategoryPreferencesQuery,
      TError = unknown
    >(
      variables?: ForwardSettingsPracticeCategoryPreferencesQueryVariables,
      options?: UseQueryOptions<ForwardSettingsPracticeCategoryPreferencesQuery, TError, TData>
    ) =>
    useQuery<ForwardSettingsPracticeCategoryPreferencesQuery, TError, TData>(
      variables === undefined ? ['ForwardSettingsPracticeCategoryPreferences'] : ['ForwardSettingsPracticeCategoryPreferences', variables],
      fetcher<ForwardSettingsPracticeCategoryPreferencesQuery, ForwardSettingsPracticeCategoryPreferencesQueryVariables>(ForwardSettingsPracticeCategoryPreferencesDocument, variables),
      options
    );

useForwardSettingsPracticeCategoryPreferencesQuery.getKey = (variables?: ForwardSettingsPracticeCategoryPreferencesQueryVariables) => variables === undefined ? ['ForwardSettingsPracticeCategoryPreferences'] : ['ForwardSettingsPracticeCategoryPreferences', variables];
;

export const useInfiniteForwardSettingsPracticeCategoryPreferencesQuery = <
      TData = ForwardSettingsPracticeCategoryPreferencesQuery,
      TError = unknown
    >(
      pageParamKey: keyof ForwardSettingsPracticeCategoryPreferencesQueryVariables,
      variables?: ForwardSettingsPracticeCategoryPreferencesQueryVariables,
      options?: UseInfiniteQueryOptions<ForwardSettingsPracticeCategoryPreferencesQuery, TError, TData>
    ) =>
    useInfiniteQuery<ForwardSettingsPracticeCategoryPreferencesQuery, TError, TData>(
      variables === undefined ? ['ForwardSettingsPracticeCategoryPreferences.infinite'] : ['ForwardSettingsPracticeCategoryPreferences.infinite', variables],
      (metaData) => fetcher<ForwardSettingsPracticeCategoryPreferencesQuery, ForwardSettingsPracticeCategoryPreferencesQueryVariables>(ForwardSettingsPracticeCategoryPreferencesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteForwardSettingsPracticeCategoryPreferencesQuery.getKey = (variables?: ForwardSettingsPracticeCategoryPreferencesQueryVariables) => variables === undefined ? ['ForwardSettingsPracticeCategoryPreferences.infinite'] : ['ForwardSettingsPracticeCategoryPreferences.infinite', variables];
;

useForwardSettingsPracticeCategoryPreferencesQuery.fetcher = (variables?: ForwardSettingsPracticeCategoryPreferencesQueryVariables) => fetcher<ForwardSettingsPracticeCategoryPreferencesQuery, ForwardSettingsPracticeCategoryPreferencesQueryVariables>(ForwardSettingsPracticeCategoryPreferencesDocument, variables);
export const EditForwardSettingsOfficeLocationPreferencesDocument = `
    mutation EditForwardSettingsOfficeLocationPreferences($input: SubmitForwardOfficeLocationPreferencesInput!) {
  submitForwardOfficeLocationPreferences(input: $input) {
    success
  }
}
    `;
export const useEditForwardSettingsOfficeLocationPreferencesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditForwardSettingsOfficeLocationPreferencesMutation, TError, EditForwardSettingsOfficeLocationPreferencesMutationVariables, TContext>) =>
    useMutation<EditForwardSettingsOfficeLocationPreferencesMutation, TError, EditForwardSettingsOfficeLocationPreferencesMutationVariables, TContext>(
      ['EditForwardSettingsOfficeLocationPreferences'],
      (variables?: EditForwardSettingsOfficeLocationPreferencesMutationVariables) => fetcher<EditForwardSettingsOfficeLocationPreferencesMutation, EditForwardSettingsOfficeLocationPreferencesMutationVariables>(EditForwardSettingsOfficeLocationPreferencesDocument, variables)(),
      options
    );
useEditForwardSettingsOfficeLocationPreferencesMutation.fetcher = (variables: EditForwardSettingsOfficeLocationPreferencesMutationVariables) => fetcher<EditForwardSettingsOfficeLocationPreferencesMutation, EditForwardSettingsOfficeLocationPreferencesMutationVariables>(EditForwardSettingsOfficeLocationPreferencesDocument, variables);
export const EditForwardSettingsPracticeCategoryPreferencesDocument = `
    mutation EditForwardSettingsPracticeCategoryPreferences($input: SubmitForwardPracticeCategoryPreferencesInput!) {
  submitForwardPracticeCategoryPreferences(input: $input) {
    success
  }
}
    `;
export const useEditForwardSettingsPracticeCategoryPreferencesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditForwardSettingsPracticeCategoryPreferencesMutation, TError, EditForwardSettingsPracticeCategoryPreferencesMutationVariables, TContext>) =>
    useMutation<EditForwardSettingsPracticeCategoryPreferencesMutation, TError, EditForwardSettingsPracticeCategoryPreferencesMutationVariables, TContext>(
      ['EditForwardSettingsPracticeCategoryPreferences'],
      (variables?: EditForwardSettingsPracticeCategoryPreferencesMutationVariables) => fetcher<EditForwardSettingsPracticeCategoryPreferencesMutation, EditForwardSettingsPracticeCategoryPreferencesMutationVariables>(EditForwardSettingsPracticeCategoryPreferencesDocument, variables)(),
      options
    );
useEditForwardSettingsPracticeCategoryPreferencesMutation.fetcher = (variables: EditForwardSettingsPracticeCategoryPreferencesMutationVariables) => fetcher<EditForwardSettingsPracticeCategoryPreferencesMutation, EditForwardSettingsPracticeCategoryPreferencesMutationVariables>(EditForwardSettingsPracticeCategoryPreferencesDocument, variables);
export const RegisterForwardUserDocument = `
    mutation RegisterForwardUser($input: RegisterForwardUserInput!) {
  registerForwardUser(input: $input) {
    ... on RegisterForwardUserSuccess {
      accountId
    }
    ... on RegisterForwardUserAccountAlreadyExists {
      userMessage
    }
  }
}
    `;
export const useRegisterForwardUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RegisterForwardUserMutation, TError, RegisterForwardUserMutationVariables, TContext>) =>
    useMutation<RegisterForwardUserMutation, TError, RegisterForwardUserMutationVariables, TContext>(
      ['RegisterForwardUser'],
      (variables?: RegisterForwardUserMutationVariables) => fetcher<RegisterForwardUserMutation, RegisterForwardUserMutationVariables>(RegisterForwardUserDocument, variables)(),
      options
    );
useRegisterForwardUserMutation.fetcher = (variables: RegisterForwardUserMutationVariables) => fetcher<RegisterForwardUserMutation, RegisterForwardUserMutationVariables>(RegisterForwardUserDocument, variables);
export const EmployerAttendeesDocument = `
    query EmployerAttendees($universityEventId: Int!) {
  interviewSchedulingEventAttendees(universityEventId: $universityEventId) {
    ...EmployerAttendees
  }
}
    ${EmployerAttendeesFragmentDoc}`;
export const useEmployerAttendeesQuery = <
      TData = EmployerAttendeesQuery,
      TError = unknown
    >(
      variables: EmployerAttendeesQueryVariables,
      options?: UseQueryOptions<EmployerAttendeesQuery, TError, TData>
    ) =>
    useQuery<EmployerAttendeesQuery, TError, TData>(
      ['EmployerAttendees', variables],
      fetcher<EmployerAttendeesQuery, EmployerAttendeesQueryVariables>(EmployerAttendeesDocument, variables),
      options
    );

useEmployerAttendeesQuery.getKey = (variables: EmployerAttendeesQueryVariables) => ['EmployerAttendees', variables];
;

export const useInfiniteEmployerAttendeesQuery = <
      TData = EmployerAttendeesQuery,
      TError = unknown
    >(
      pageParamKey: keyof EmployerAttendeesQueryVariables,
      variables: EmployerAttendeesQueryVariables,
      options?: UseInfiniteQueryOptions<EmployerAttendeesQuery, TError, TData>
    ) =>
    useInfiniteQuery<EmployerAttendeesQuery, TError, TData>(
      ['EmployerAttendees.infinite', variables],
      (metaData) => fetcher<EmployerAttendeesQuery, EmployerAttendeesQueryVariables>(EmployerAttendeesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEmployerAttendeesQuery.getKey = (variables: EmployerAttendeesQueryVariables) => ['EmployerAttendees.infinite', variables];
;

useEmployerAttendeesQuery.fetcher = (variables: EmployerAttendeesQueryVariables) => fetcher<EmployerAttendeesQuery, EmployerAttendeesQueryVariables>(EmployerAttendeesDocument, variables);
export const StudentListOfAvailableJobsDocument = `
    query StudentListOfAvailableJobs($universityEventId: Int!, $universityOrgFriendlyName: String!, $studentExtension: String!) {
  studentListOfAvailableJobs(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    id
    studentUnmatchedBids {
      pageInfo {
        hasNextPage
      }
      nodes {
        id
        scheduleId
        universityOrgId
        universityEventId
        ranking
        job {
          id
          orgId
          title
          employer {
            id
            orgId
            name
            logoUrl
            isFloCustomer
            forwardTier {
              asEnum
            }
          }
          description
          supportingDocuments {
            id
            orgDocumentId
            eventDocumentId
            documentName
            documentVisibilityOption
            documentVisibilityTime {
              date
              time
              zone
            }
            isRequired
            userFilename
            fileLocation
            uploadDate {
              date
              time
              zone
            }
          }
          offices {
            pageInfo {
              hasNextPage
            }
            nodes {
              id
              name
            }
          }
          practiceAreas {
            pageInfo {
              hasNextPage
            }
            nodes {
              id
              name
            }
          }
        }
      }
    }
    studentAvailableJobs {
      pageInfo {
        hasNextPage
      }
      nodes {
        id
        orgId
        employer {
          id
          orgId
          name
          logoUrl
          isFloCustomer
          forwardTier {
            asEnum
          }
        }
        title
        description
        offices {
          pageInfo {
            hasNextPage
          }
          nodes {
            id
            name
          }
        }
        practiceAreas {
          pageInfo {
            hasNextPage
          }
          nodes {
            id
            name
          }
        }
        numberOfAvailableTimeSlots
        employerAllowsMultipleApplicants
        supportingDocuments {
          id
          orgDocumentId
          eventDocumentId
          documentName
          documentVisibilityOption
          documentVisibilityTime {
            date
            time
            zone
          }
          isRequired
          userFilename
          fileLocation
          uploadDate {
            date
            time
            zone
          }
        }
      }
    }
  }
}
    `;
export const useStudentListOfAvailableJobsQuery = <
      TData = StudentListOfAvailableJobsQuery,
      TError = unknown
    >(
      variables: StudentListOfAvailableJobsQueryVariables,
      options?: UseQueryOptions<StudentListOfAvailableJobsQuery, TError, TData>
    ) =>
    useQuery<StudentListOfAvailableJobsQuery, TError, TData>(
      ['StudentListOfAvailableJobs', variables],
      fetcher<StudentListOfAvailableJobsQuery, StudentListOfAvailableJobsQueryVariables>(StudentListOfAvailableJobsDocument, variables),
      options
    );

useStudentListOfAvailableJobsQuery.getKey = (variables: StudentListOfAvailableJobsQueryVariables) => ['StudentListOfAvailableJobs', variables];
;

export const useInfiniteStudentListOfAvailableJobsQuery = <
      TData = StudentListOfAvailableJobsQuery,
      TError = unknown
    >(
      pageParamKey: keyof StudentListOfAvailableJobsQueryVariables,
      variables: StudentListOfAvailableJobsQueryVariables,
      options?: UseInfiniteQueryOptions<StudentListOfAvailableJobsQuery, TError, TData>
    ) =>
    useInfiniteQuery<StudentListOfAvailableJobsQuery, TError, TData>(
      ['StudentListOfAvailableJobs.infinite', variables],
      (metaData) => fetcher<StudentListOfAvailableJobsQuery, StudentListOfAvailableJobsQueryVariables>(StudentListOfAvailableJobsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteStudentListOfAvailableJobsQuery.getKey = (variables: StudentListOfAvailableJobsQueryVariables) => ['StudentListOfAvailableJobs.infinite', variables];
;

useStudentListOfAvailableJobsQuery.fetcher = (variables: StudentListOfAvailableJobsQueryVariables) => fetcher<StudentListOfAvailableJobsQuery, StudentListOfAvailableJobsQueryVariables>(StudentListOfAvailableJobsDocument, variables);
export const AvailableTimeSlotsForJobDocument = `
    query AvailableTimeSlotsForJob($universityEventId: Int!, $universityOrgFriendlyName: String!, $scheduleId: Int!, $studentExtension: String!) {
  availableTimeSlotsForJob(
    universityEventId: $universityEventId
    scheduleId: $scheduleId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    id
    scheduleId
    startTime {
      date
      time
      zone
    }
    endTime {
      date
      time
      zone
    }
  }
}
    `;
export const useAvailableTimeSlotsForJobQuery = <
      TData = AvailableTimeSlotsForJobQuery,
      TError = unknown
    >(
      variables: AvailableTimeSlotsForJobQueryVariables,
      options?: UseQueryOptions<AvailableTimeSlotsForJobQuery, TError, TData>
    ) =>
    useQuery<AvailableTimeSlotsForJobQuery, TError, TData>(
      ['AvailableTimeSlotsForJob', variables],
      fetcher<AvailableTimeSlotsForJobQuery, AvailableTimeSlotsForJobQueryVariables>(AvailableTimeSlotsForJobDocument, variables),
      options
    );

useAvailableTimeSlotsForJobQuery.getKey = (variables: AvailableTimeSlotsForJobQueryVariables) => ['AvailableTimeSlotsForJob', variables];
;

export const useInfiniteAvailableTimeSlotsForJobQuery = <
      TData = AvailableTimeSlotsForJobQuery,
      TError = unknown
    >(
      pageParamKey: keyof AvailableTimeSlotsForJobQueryVariables,
      variables: AvailableTimeSlotsForJobQueryVariables,
      options?: UseInfiniteQueryOptions<AvailableTimeSlotsForJobQuery, TError, TData>
    ) =>
    useInfiniteQuery<AvailableTimeSlotsForJobQuery, TError, TData>(
      ['AvailableTimeSlotsForJob.infinite', variables],
      (metaData) => fetcher<AvailableTimeSlotsForJobQuery, AvailableTimeSlotsForJobQueryVariables>(AvailableTimeSlotsForJobDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAvailableTimeSlotsForJobQuery.getKey = (variables: AvailableTimeSlotsForJobQueryVariables) => ['AvailableTimeSlotsForJob.infinite', variables];
;

useAvailableTimeSlotsForJobQuery.fetcher = (variables: AvailableTimeSlotsForJobQueryVariables) => fetcher<AvailableTimeSlotsForJobQuery, AvailableTimeSlotsForJobQueryVariables>(AvailableTimeSlotsForJobDocument, variables);
export const StudentBidListDocument = `
    query StudentBidList($universityEventId: Int!, $universityOrgFriendlyName: String!, $studentExtension: String!) {
  studentBidList(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    id
    studentBids {
      id
      scheduleId
      ranking
    }
  }
}
    `;
export const useStudentBidListQuery = <
      TData = StudentBidListQuery,
      TError = unknown
    >(
      variables: StudentBidListQueryVariables,
      options?: UseQueryOptions<StudentBidListQuery, TError, TData>
    ) =>
    useQuery<StudentBidListQuery, TError, TData>(
      ['StudentBidList', variables],
      fetcher<StudentBidListQuery, StudentBidListQueryVariables>(StudentBidListDocument, variables),
      options
    );

useStudentBidListQuery.getKey = (variables: StudentBidListQueryVariables) => ['StudentBidList', variables];
;

export const useInfiniteStudentBidListQuery = <
      TData = StudentBidListQuery,
      TError = unknown
    >(
      pageParamKey: keyof StudentBidListQueryVariables,
      variables: StudentBidListQueryVariables,
      options?: UseInfiniteQueryOptions<StudentBidListQuery, TError, TData>
    ) =>
    useInfiniteQuery<StudentBidListQuery, TError, TData>(
      ['StudentBidList.infinite', variables],
      (metaData) => fetcher<StudentBidListQuery, StudentBidListQueryVariables>(StudentBidListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteStudentBidListQuery.getKey = (variables: StudentBidListQueryVariables) => ['StudentBidList.infinite', variables];
;

useStudentBidListQuery.fetcher = (variables: StudentBidListQueryVariables) => fetcher<StudentBidListQuery, StudentBidListQueryVariables>(StudentBidListDocument, variables);
export const LotteryUniversityEventByIdForStudentDocument = `
    query LotteryUniversityEventByIdForStudent($universityEventId: Int!, $universityOrgFriendlyName: String!, $studentExtension: String!) {
  lotteryUniversityEventByIdForStudent(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    id
    name
    start {
      date
      time
      zone
    }
    end {
      date
      time
      zone
    }
    eventDetails {
      id
      studentEventDescription
      eventOrganizerUserEmail
    }
    eventTimeline {
      ...LotteryEventTimelineFragment
    }
  }
}
    ${LotteryEventTimelineFragmentFragmentDoc}
${DateTimeZoneFragmentDoc}`;
export const useLotteryUniversityEventByIdForStudentQuery = <
      TData = LotteryUniversityEventByIdForStudentQuery,
      TError = unknown
    >(
      variables: LotteryUniversityEventByIdForStudentQueryVariables,
      options?: UseQueryOptions<LotteryUniversityEventByIdForStudentQuery, TError, TData>
    ) =>
    useQuery<LotteryUniversityEventByIdForStudentQuery, TError, TData>(
      ['LotteryUniversityEventByIdForStudent', variables],
      fetcher<LotteryUniversityEventByIdForStudentQuery, LotteryUniversityEventByIdForStudentQueryVariables>(LotteryUniversityEventByIdForStudentDocument, variables),
      options
    );

useLotteryUniversityEventByIdForStudentQuery.getKey = (variables: LotteryUniversityEventByIdForStudentQueryVariables) => ['LotteryUniversityEventByIdForStudent', variables];
;

export const useInfiniteLotteryUniversityEventByIdForStudentQuery = <
      TData = LotteryUniversityEventByIdForStudentQuery,
      TError = unknown
    >(
      pageParamKey: keyof LotteryUniversityEventByIdForStudentQueryVariables,
      variables: LotteryUniversityEventByIdForStudentQueryVariables,
      options?: UseInfiniteQueryOptions<LotteryUniversityEventByIdForStudentQuery, TError, TData>
    ) =>
    useInfiniteQuery<LotteryUniversityEventByIdForStudentQuery, TError, TData>(
      ['LotteryUniversityEventByIdForStudent.infinite', variables],
      (metaData) => fetcher<LotteryUniversityEventByIdForStudentQuery, LotteryUniversityEventByIdForStudentQueryVariables>(LotteryUniversityEventByIdForStudentDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLotteryUniversityEventByIdForStudentQuery.getKey = (variables: LotteryUniversityEventByIdForStudentQueryVariables) => ['LotteryUniversityEventByIdForStudent.infinite', variables];
;

useLotteryUniversityEventByIdForStudentQuery.fetcher = (variables: LotteryUniversityEventByIdForStudentQueryVariables) => fetcher<LotteryUniversityEventByIdForStudentQuery, LotteryUniversityEventByIdForStudentQueryVariables>(LotteryUniversityEventByIdForStudentDocument, variables);
export const SubmitStudentBidsDocument = `
    mutation SubmitStudentBids($universityEventId: Int!, $universityOrgFriendlyName: String!, $studentExtension: String!, $input: LotteryStudentBidListInput) {
  submitStudentBids(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
    input: $input
  ) {
    successful
  }
}
    `;
export const useSubmitStudentBidsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitStudentBidsMutation, TError, SubmitStudentBidsMutationVariables, TContext>) =>
    useMutation<SubmitStudentBidsMutation, TError, SubmitStudentBidsMutationVariables, TContext>(
      ['SubmitStudentBids'],
      (variables?: SubmitStudentBidsMutationVariables) => fetcher<SubmitStudentBidsMutation, SubmitStudentBidsMutationVariables>(SubmitStudentBidsDocument, variables)(),
      options
    );
useSubmitStudentBidsMutation.fetcher = (variables: SubmitStudentBidsMutationVariables) => fetcher<SubmitStudentBidsMutation, SubmitStudentBidsMutationVariables>(SubmitStudentBidsDocument, variables);
export const StudentInterviewSchedulingApplicationsDocument = `
    query StudentInterviewSchedulingApplications($universityEventId: ID!, $universityOrgFriendlyName: String!, $studentExtension: String!) {
  studentInterviewSchedulingApplications(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    nodes {
      id
      recruitId
      scheduleId
      documents {
        id
        recruitId
        documentName
        link
        uploadDate
        filename
      }
    }
  }
}
    `;
export const useStudentInterviewSchedulingApplicationsQuery = <
      TData = StudentInterviewSchedulingApplicationsQuery,
      TError = unknown
    >(
      variables: StudentInterviewSchedulingApplicationsQueryVariables,
      options?: UseQueryOptions<StudentInterviewSchedulingApplicationsQuery, TError, TData>
    ) =>
    useQuery<StudentInterviewSchedulingApplicationsQuery, TError, TData>(
      ['StudentInterviewSchedulingApplications', variables],
      fetcher<StudentInterviewSchedulingApplicationsQuery, StudentInterviewSchedulingApplicationsQueryVariables>(StudentInterviewSchedulingApplicationsDocument, variables),
      options
    );

useStudentInterviewSchedulingApplicationsQuery.getKey = (variables: StudentInterviewSchedulingApplicationsQueryVariables) => ['StudentInterviewSchedulingApplications', variables];
;

export const useInfiniteStudentInterviewSchedulingApplicationsQuery = <
      TData = StudentInterviewSchedulingApplicationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof StudentInterviewSchedulingApplicationsQueryVariables,
      variables: StudentInterviewSchedulingApplicationsQueryVariables,
      options?: UseInfiniteQueryOptions<StudentInterviewSchedulingApplicationsQuery, TError, TData>
    ) =>
    useInfiniteQuery<StudentInterviewSchedulingApplicationsQuery, TError, TData>(
      ['StudentInterviewSchedulingApplications.infinite', variables],
      (metaData) => fetcher<StudentInterviewSchedulingApplicationsQuery, StudentInterviewSchedulingApplicationsQueryVariables>(StudentInterviewSchedulingApplicationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteStudentInterviewSchedulingApplicationsQuery.getKey = (variables: StudentInterviewSchedulingApplicationsQueryVariables) => ['StudentInterviewSchedulingApplications.infinite', variables];
;

useStudentInterviewSchedulingApplicationsQuery.fetcher = (variables: StudentInterviewSchedulingApplicationsQueryVariables) => fetcher<StudentInterviewSchedulingApplicationsQuery, StudentInterviewSchedulingApplicationsQueryVariables>(StudentInterviewSchedulingApplicationsDocument, variables);
export const StudentLotteryMatchesDocument = `
    query StudentLotteryMatches($universityEventId: ID!, $universityOrgFriendlyName: String!, $studentExtension: String!) {
  studentLotteryMatches(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    nodes {
      id
      scheduleId
      start {
        date
        time
        zone
      }
      end {
        date
        time
        zone
      }
      bid {
        id
        scheduleId
        ranking
      }
      job {
        ...jobFields
      }
      isNewInterview
    }
  }
}
    ${JobFieldsFragmentDoc}`;
export const useStudentLotteryMatchesQuery = <
      TData = StudentLotteryMatchesQuery,
      TError = unknown
    >(
      variables: StudentLotteryMatchesQueryVariables,
      options?: UseQueryOptions<StudentLotteryMatchesQuery, TError, TData>
    ) =>
    useQuery<StudentLotteryMatchesQuery, TError, TData>(
      ['StudentLotteryMatches', variables],
      fetcher<StudentLotteryMatchesQuery, StudentLotteryMatchesQueryVariables>(StudentLotteryMatchesDocument, variables),
      options
    );

useStudentLotteryMatchesQuery.getKey = (variables: StudentLotteryMatchesQueryVariables) => ['StudentLotteryMatches', variables];
;

export const useInfiniteStudentLotteryMatchesQuery = <
      TData = StudentLotteryMatchesQuery,
      TError = unknown
    >(
      pageParamKey: keyof StudentLotteryMatchesQueryVariables,
      variables: StudentLotteryMatchesQueryVariables,
      options?: UseInfiniteQueryOptions<StudentLotteryMatchesQuery, TError, TData>
    ) =>
    useInfiniteQuery<StudentLotteryMatchesQuery, TError, TData>(
      ['StudentLotteryMatches.infinite', variables],
      (metaData) => fetcher<StudentLotteryMatchesQuery, StudentLotteryMatchesQueryVariables>(StudentLotteryMatchesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteStudentLotteryMatchesQuery.getKey = (variables: StudentLotteryMatchesQueryVariables) => ['StudentLotteryMatches.infinite', variables];
;

useStudentLotteryMatchesQuery.fetcher = (variables: StudentLotteryMatchesQueryVariables) => fetcher<StudentLotteryMatchesQuery, StudentLotteryMatchesQueryVariables>(StudentLotteryMatchesDocument, variables);
export const StudentLotteryUnmatchedBidsDocument = `
    query StudentLotteryUnmatchedBids($universityEventId: ID!, $universityOrgFriendlyName: String!, $studentExtension: String!, $first: Int, $after: String) {
  studentLotteryUnmatchedBids(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
    first: $first
    after: $after
  ) {
    totalCount
    nodes {
      id
      scheduleId
      ranking
      job {
        ...jobFields
      }
    }
  }
}
    ${JobFieldsFragmentDoc}`;
export const useStudentLotteryUnmatchedBidsQuery = <
      TData = StudentLotteryUnmatchedBidsQuery,
      TError = unknown
    >(
      variables: StudentLotteryUnmatchedBidsQueryVariables,
      options?: UseQueryOptions<StudentLotteryUnmatchedBidsQuery, TError, TData>
    ) =>
    useQuery<StudentLotteryUnmatchedBidsQuery, TError, TData>(
      ['StudentLotteryUnmatchedBids', variables],
      fetcher<StudentLotteryUnmatchedBidsQuery, StudentLotteryUnmatchedBidsQueryVariables>(StudentLotteryUnmatchedBidsDocument, variables),
      options
    );

useStudentLotteryUnmatchedBidsQuery.getKey = (variables: StudentLotteryUnmatchedBidsQueryVariables) => ['StudentLotteryUnmatchedBids', variables];
;

export const useInfiniteStudentLotteryUnmatchedBidsQuery = <
      TData = StudentLotteryUnmatchedBidsQuery,
      TError = unknown
    >(
      pageParamKey: keyof StudentLotteryUnmatchedBidsQueryVariables,
      variables: StudentLotteryUnmatchedBidsQueryVariables,
      options?: UseInfiniteQueryOptions<StudentLotteryUnmatchedBidsQuery, TError, TData>
    ) =>
    useInfiniteQuery<StudentLotteryUnmatchedBidsQuery, TError, TData>(
      ['StudentLotteryUnmatchedBids.infinite', variables],
      (metaData) => fetcher<StudentLotteryUnmatchedBidsQuery, StudentLotteryUnmatchedBidsQueryVariables>(StudentLotteryUnmatchedBidsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteStudentLotteryUnmatchedBidsQuery.getKey = (variables: StudentLotteryUnmatchedBidsQueryVariables) => ['StudentLotteryUnmatchedBids.infinite', variables];
;

useStudentLotteryUnmatchedBidsQuery.fetcher = (variables: StudentLotteryUnmatchedBidsQueryVariables) => fetcher<StudentLotteryUnmatchedBidsQuery, StudentLotteryUnmatchedBidsQueryVariables>(StudentLotteryUnmatchedBidsDocument, variables);
export const CancelLotteryStudentMatchDocument = `
    mutation CancelLotteryStudentMatch($universityEventId: ID!, $universityOrgFriendlyName: String!, $studentExtension: String!, $cancelLotteryStudentMatchInput: CancelLotteryStudentMatchInput!) {
  cancelLotteryStudentMatch(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
    input: $cancelLotteryStudentMatchInput
  ) {
    successful
  }
}
    `;
export const useCancelLotteryStudentMatchMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CancelLotteryStudentMatchMutation, TError, CancelLotteryStudentMatchMutationVariables, TContext>) =>
    useMutation<CancelLotteryStudentMatchMutation, TError, CancelLotteryStudentMatchMutationVariables, TContext>(
      ['CancelLotteryStudentMatch'],
      (variables?: CancelLotteryStudentMatchMutationVariables) => fetcher<CancelLotteryStudentMatchMutation, CancelLotteryStudentMatchMutationVariables>(CancelLotteryStudentMatchDocument, variables)(),
      options
    );
useCancelLotteryStudentMatchMutation.fetcher = (variables: CancelLotteryStudentMatchMutationVariables) => fetcher<CancelLotteryStudentMatchMutation, CancelLotteryStudentMatchMutationVariables>(CancelLotteryStudentMatchDocument, variables);
export const SubmitStudentInterviewSchedulingPreferencesForJobsDocument = `
    mutation SubmitStudentInterviewSchedulingPreferencesForJobs($universityEventId: Int!, $universityOrgFriendlyName: String!, $studentExtension: String!, $input: InterviewSchedulingStudentPreferencesListsInput) {
  submitStudentInterviewSchedulingPreferencesForJobs(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
    input: $input
  ) {
    successful
  }
}
    `;
export const useSubmitStudentInterviewSchedulingPreferencesForJobsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitStudentInterviewSchedulingPreferencesForJobsMutation, TError, SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables, TContext>) =>
    useMutation<SubmitStudentInterviewSchedulingPreferencesForJobsMutation, TError, SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables, TContext>(
      ['SubmitStudentInterviewSchedulingPreferencesForJobs'],
      (variables?: SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables) => fetcher<SubmitStudentInterviewSchedulingPreferencesForJobsMutation, SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables>(SubmitStudentInterviewSchedulingPreferencesForJobsDocument, variables)(),
      options
    );
useSubmitStudentInterviewSchedulingPreferencesForJobsMutation.fetcher = (variables: SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables) => fetcher<SubmitStudentInterviewSchedulingPreferencesForJobsMutation, SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables>(SubmitStudentInterviewSchedulingPreferencesForJobsDocument, variables);
export const StudentInterviewSchedulingOfficeLocationsPreferencesForJobsDocument = `
    query StudentInterviewSchedulingOfficeLocationsPreferencesForJobs($universityEventId: Int!, $universityOrgFriendlyName: String!, $studentExtension: String!) {
  studentInterviewSchedulingOfficeLocationsPreferencesForJobs(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    scheduleId
    officeLocationPreferences {
      id
      scheduleId
      universityOrgId
      universityEventId
      officeLocationId
      recruitId
    }
  }
}
    `;
export const useStudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery = <
      TData = StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery,
      TError = unknown
    >(
      variables: StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables,
      options?: UseQueryOptions<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, TError, TData>
    ) =>
    useQuery<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, TError, TData>(
      ['StudentInterviewSchedulingOfficeLocationsPreferencesForJobs', variables],
      fetcher<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables>(StudentInterviewSchedulingOfficeLocationsPreferencesForJobsDocument, variables),
      options
    );

useStudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery.getKey = (variables: StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables) => ['StudentInterviewSchedulingOfficeLocationsPreferencesForJobs', variables];
;

export const useInfiniteStudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery = <
      TData = StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery,
      TError = unknown
    >(
      pageParamKey: keyof StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables,
      variables: StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables,
      options?: UseInfiniteQueryOptions<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, TError, TData>
    ) =>
    useInfiniteQuery<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, TError, TData>(
      ['StudentInterviewSchedulingOfficeLocationsPreferencesForJobs.infinite', variables],
      (metaData) => fetcher<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables>(StudentInterviewSchedulingOfficeLocationsPreferencesForJobsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteStudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery.getKey = (variables: StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables) => ['StudentInterviewSchedulingOfficeLocationsPreferencesForJobs.infinite', variables];
;

useStudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery.fetcher = (variables: StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables) => fetcher<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables>(StudentInterviewSchedulingOfficeLocationsPreferencesForJobsDocument, variables);
export const StudentInterviewSchedulingPracticeAreasPreferencesForJobsDocument = `
    query StudentInterviewSchedulingPracticeAreasPreferencesForJobs($universityEventId: Int!, $universityOrgFriendlyName: String!, $studentExtension: String!) {
  studentInterviewSchedulingPracticeAreasPreferencesForJobs(
    universityEventId: $universityEventId
    universityOrgFriendlyName: $universityOrgFriendlyName
    studentExtension: $studentExtension
  ) {
    scheduleId
    practiceAreaPreferences {
      id
      scheduleId
      universityOrgId
      universityEventId
      practiceAreaId
      recruitId
    }
  }
}
    `;
export const useStudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery = <
      TData = StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery,
      TError = unknown
    >(
      variables: StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables,
      options?: UseQueryOptions<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, TError, TData>
    ) =>
    useQuery<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, TError, TData>(
      ['StudentInterviewSchedulingPracticeAreasPreferencesForJobs', variables],
      fetcher<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables>(StudentInterviewSchedulingPracticeAreasPreferencesForJobsDocument, variables),
      options
    );

useStudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery.getKey = (variables: StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables) => ['StudentInterviewSchedulingPracticeAreasPreferencesForJobs', variables];
;

export const useInfiniteStudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery = <
      TData = StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery,
      TError = unknown
    >(
      pageParamKey: keyof StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables,
      variables: StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables,
      options?: UseInfiniteQueryOptions<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, TError, TData>
    ) =>
    useInfiniteQuery<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, TError, TData>(
      ['StudentInterviewSchedulingPracticeAreasPreferencesForJobs.infinite', variables],
      (metaData) => fetcher<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables>(StudentInterviewSchedulingPracticeAreasPreferencesForJobsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteStudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery.getKey = (variables: StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables) => ['StudentInterviewSchedulingPracticeAreasPreferencesForJobs.infinite', variables];
;

useStudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery.fetcher = (variables: StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables) => fetcher<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables>(StudentInterviewSchedulingPracticeAreasPreferencesForJobsDocument, variables);
export const SubmitLotteryEventTimelineDocument = `
    mutation SubmitLotteryEventTimeline($input: LotteryEventTimelineInput!) {
  submitLotteryEventTimeline(input: $input) {
    successful
  }
}
    `;
export const useSubmitLotteryEventTimelineMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitLotteryEventTimelineMutation, TError, SubmitLotteryEventTimelineMutationVariables, TContext>) =>
    useMutation<SubmitLotteryEventTimelineMutation, TError, SubmitLotteryEventTimelineMutationVariables, TContext>(
      ['SubmitLotteryEventTimeline'],
      (variables?: SubmitLotteryEventTimelineMutationVariables) => fetcher<SubmitLotteryEventTimelineMutation, SubmitLotteryEventTimelineMutationVariables>(SubmitLotteryEventTimelineDocument, variables)(),
      options
    );
useSubmitLotteryEventTimelineMutation.fetcher = (variables: SubmitLotteryEventTimelineMutationVariables) => fetcher<SubmitLotteryEventTimelineMutation, SubmitLotteryEventTimelineMutationVariables>(SubmitLotteryEventTimelineDocument, variables);
export const LotteryEventTimelineDocument = `
    query LotteryEventTimeline($universityEventId: Int!) {
  lotteryUniversityEventById(universityEventId: $universityEventId) {
    id
    name
    isDraft
    eventTimeline {
      ...LotteryEventTimeline
    }
    stepperStatus {
      ...EventStepperStatus
    }
  }
}
    ${LotteryEventTimelineFragmentDoc}
${DateTimeZonePartsFragmentDoc}
${EventStepperStatusFragmentDoc}`;
export const useLotteryEventTimelineQuery = <
      TData = LotteryEventTimelineQuery,
      TError = unknown
    >(
      variables: LotteryEventTimelineQueryVariables,
      options?: UseQueryOptions<LotteryEventTimelineQuery, TError, TData>
    ) =>
    useQuery<LotteryEventTimelineQuery, TError, TData>(
      ['LotteryEventTimeline', variables],
      fetcher<LotteryEventTimelineQuery, LotteryEventTimelineQueryVariables>(LotteryEventTimelineDocument, variables),
      options
    );

useLotteryEventTimelineQuery.getKey = (variables: LotteryEventTimelineQueryVariables) => ['LotteryEventTimeline', variables];
;

export const useInfiniteLotteryEventTimelineQuery = <
      TData = LotteryEventTimelineQuery,
      TError = unknown
    >(
      pageParamKey: keyof LotteryEventTimelineQueryVariables,
      variables: LotteryEventTimelineQueryVariables,
      options?: UseInfiniteQueryOptions<LotteryEventTimelineQuery, TError, TData>
    ) =>
    useInfiniteQuery<LotteryEventTimelineQuery, TError, TData>(
      ['LotteryEventTimeline.infinite', variables],
      (metaData) => fetcher<LotteryEventTimelineQuery, LotteryEventTimelineQueryVariables>(LotteryEventTimelineDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLotteryEventTimelineQuery.getKey = (variables: LotteryEventTimelineQueryVariables) => ['LotteryEventTimeline.infinite', variables];
;

useLotteryEventTimelineQuery.fetcher = (variables: LotteryEventTimelineQueryVariables) => fetcher<LotteryEventTimelineQuery, LotteryEventTimelineQueryVariables>(LotteryEventTimelineDocument, variables);
export const LotteryEventDetailsDocument = `
    query LotteryEventDetails($universityEventId: Int!) {
  lotteryUniversityEventById(universityEventId: $universityEventId) {
    id
    name
    isDraft
    tags {
      nodes {
        id
        label
      }
    }
    eventDetails {
      ...LotteryEventDetails
    }
    stepperStatus {
      ...EventStepperStatus
    }
    eventTimeline {
      ...LotteryEventTimeline
    }
  }
}
    ${LotteryEventDetailsFragmentDoc}
${EventStepperStatusFragmentDoc}
${LotteryEventTimelineFragmentDoc}
${DateTimeZonePartsFragmentDoc}`;
export const useLotteryEventDetailsQuery = <
      TData = LotteryEventDetailsQuery,
      TError = unknown
    >(
      variables: LotteryEventDetailsQueryVariables,
      options?: UseQueryOptions<LotteryEventDetailsQuery, TError, TData>
    ) =>
    useQuery<LotteryEventDetailsQuery, TError, TData>(
      ['LotteryEventDetails', variables],
      fetcher<LotteryEventDetailsQuery, LotteryEventDetailsQueryVariables>(LotteryEventDetailsDocument, variables),
      options
    );

useLotteryEventDetailsQuery.getKey = (variables: LotteryEventDetailsQueryVariables) => ['LotteryEventDetails', variables];
;

export const useInfiniteLotteryEventDetailsQuery = <
      TData = LotteryEventDetailsQuery,
      TError = unknown
    >(
      pageParamKey: keyof LotteryEventDetailsQueryVariables,
      variables: LotteryEventDetailsQueryVariables,
      options?: UseInfiniteQueryOptions<LotteryEventDetailsQuery, TError, TData>
    ) =>
    useInfiniteQuery<LotteryEventDetailsQuery, TError, TData>(
      ['LotteryEventDetails.infinite', variables],
      (metaData) => fetcher<LotteryEventDetailsQuery, LotteryEventDetailsQueryVariables>(LotteryEventDetailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLotteryEventDetailsQuery.getKey = (variables: LotteryEventDetailsQueryVariables) => ['LotteryEventDetails.infinite', variables];
;

useLotteryEventDetailsQuery.fetcher = (variables: LotteryEventDetailsQueryVariables) => fetcher<LotteryEventDetailsQuery, LotteryEventDetailsQueryVariables>(LotteryEventDetailsDocument, variables);
export const LotteryEventTimeBlocksDocument = `
    query LotteryEventTimeBlocks($universityEventId: Int!) {
  lotteryUniversityEventById(universityEventId: $universityEventId) {
    id
    name
    isDraft
    eventSchedule {
      ...LotteryEventTimeBlocks
    }
    stepperStatus {
      ...EventStepperStatus
    }
  }
}
    ${LotteryEventTimeBlocksFragmentDoc}
${EventStepperStatusFragmentDoc}`;
export const useLotteryEventTimeBlocksQuery = <
      TData = LotteryEventTimeBlocksQuery,
      TError = unknown
    >(
      variables: LotteryEventTimeBlocksQueryVariables,
      options?: UseQueryOptions<LotteryEventTimeBlocksQuery, TError, TData>
    ) =>
    useQuery<LotteryEventTimeBlocksQuery, TError, TData>(
      ['LotteryEventTimeBlocks', variables],
      fetcher<LotteryEventTimeBlocksQuery, LotteryEventTimeBlocksQueryVariables>(LotteryEventTimeBlocksDocument, variables),
      options
    );

useLotteryEventTimeBlocksQuery.getKey = (variables: LotteryEventTimeBlocksQueryVariables) => ['LotteryEventTimeBlocks', variables];
;

export const useInfiniteLotteryEventTimeBlocksQuery = <
      TData = LotteryEventTimeBlocksQuery,
      TError = unknown
    >(
      pageParamKey: keyof LotteryEventTimeBlocksQueryVariables,
      variables: LotteryEventTimeBlocksQueryVariables,
      options?: UseInfiniteQueryOptions<LotteryEventTimeBlocksQuery, TError, TData>
    ) =>
    useInfiniteQuery<LotteryEventTimeBlocksQuery, TError, TData>(
      ['LotteryEventTimeBlocks.infinite', variables],
      (metaData) => fetcher<LotteryEventTimeBlocksQuery, LotteryEventTimeBlocksQueryVariables>(LotteryEventTimeBlocksDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLotteryEventTimeBlocksQuery.getKey = (variables: LotteryEventTimeBlocksQueryVariables) => ['LotteryEventTimeBlocks.infinite', variables];
;

useLotteryEventTimeBlocksQuery.fetcher = (variables: LotteryEventTimeBlocksQueryVariables) => fetcher<LotteryEventTimeBlocksQuery, LotteryEventTimeBlocksQueryVariables>(LotteryEventTimeBlocksDocument, variables);
export const LotteryEventDetailsEmployerDocument = `
    query LotteryEventDetailsEmployer($employerEventId: Int!) {
  lotteryEmployerEventById(employerEventId: $employerEventId) {
    __typename
    id
    name
    tags {
      nodes {
        id
        label
      }
    }
    employerOrgName
    associatedUniversityName
    eventDetails {
      ...LotteryEventDetails
    }
    eventTimeline {
      ...LotteryEventTimeline
    }
    employerSettings {
      id
      employerCustomQuestions {
        ...LotteryEmployerCustomQuestion
      }
      registrationSettings {
        ...LotteryEmployerRegistrationSettings
      }
    }
    preferredDateOptions {
      date
      time
      zone
    }
    recruitmentPolicy
  }
}
    ${LotteryEventDetailsFragmentDoc}
${LotteryEventTimelineFragmentDoc}
${DateTimeZonePartsFragmentDoc}
${LotteryEmployerCustomQuestionFragmentDoc}
${LotteryEmployerRegistrationSettingsFragmentDoc}`;
export const useLotteryEventDetailsEmployerQuery = <
      TData = LotteryEventDetailsEmployerQuery,
      TError = unknown
    >(
      variables: LotteryEventDetailsEmployerQueryVariables,
      options?: UseQueryOptions<LotteryEventDetailsEmployerQuery, TError, TData>
    ) =>
    useQuery<LotteryEventDetailsEmployerQuery, TError, TData>(
      ['LotteryEventDetailsEmployer', variables],
      fetcher<LotteryEventDetailsEmployerQuery, LotteryEventDetailsEmployerQueryVariables>(LotteryEventDetailsEmployerDocument, variables),
      options
    );

useLotteryEventDetailsEmployerQuery.getKey = (variables: LotteryEventDetailsEmployerQueryVariables) => ['LotteryEventDetailsEmployer', variables];
;

export const useInfiniteLotteryEventDetailsEmployerQuery = <
      TData = LotteryEventDetailsEmployerQuery,
      TError = unknown
    >(
      pageParamKey: keyof LotteryEventDetailsEmployerQueryVariables,
      variables: LotteryEventDetailsEmployerQueryVariables,
      options?: UseInfiniteQueryOptions<LotteryEventDetailsEmployerQuery, TError, TData>
    ) =>
    useInfiniteQuery<LotteryEventDetailsEmployerQuery, TError, TData>(
      ['LotteryEventDetailsEmployer.infinite', variables],
      (metaData) => fetcher<LotteryEventDetailsEmployerQuery, LotteryEventDetailsEmployerQueryVariables>(LotteryEventDetailsEmployerDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLotteryEventDetailsEmployerQuery.getKey = (variables: LotteryEventDetailsEmployerQueryVariables) => ['LotteryEventDetailsEmployer.infinite', variables];
;

useLotteryEventDetailsEmployerQuery.fetcher = (variables: LotteryEventDetailsEmployerQueryVariables) => fetcher<LotteryEventDetailsEmployerQuery, LotteryEventDetailsEmployerQueryVariables>(LotteryEventDetailsEmployerDocument, variables);
export const LotteryEmployerSettingsDocument = `
    query LotteryEmployerSettings($universityEventId: Int!) {
  lotteryUniversityEventById(universityEventId: $universityEventId) {
    id
    name
    isDraft
    eventTimeline {
      ...LotteryEventTimeline
    }
    employerSettings {
      id
      employerCustomQuestions {
        ...LotteryEmployerCustomQuestion
      }
      registrationSettings {
        ...LotteryEmployerRegistrationSettings
      }
    }
    stepperStatus {
      ...EventStepperStatus
    }
  }
}
    ${LotteryEventTimelineFragmentDoc}
${DateTimeZonePartsFragmentDoc}
${LotteryEmployerCustomQuestionFragmentDoc}
${LotteryEmployerRegistrationSettingsFragmentDoc}
${EventStepperStatusFragmentDoc}`;
export const useLotteryEmployerSettingsQuery = <
      TData = LotteryEmployerSettingsQuery,
      TError = unknown
    >(
      variables: LotteryEmployerSettingsQueryVariables,
      options?: UseQueryOptions<LotteryEmployerSettingsQuery, TError, TData>
    ) =>
    useQuery<LotteryEmployerSettingsQuery, TError, TData>(
      ['LotteryEmployerSettings', variables],
      fetcher<LotteryEmployerSettingsQuery, LotteryEmployerSettingsQueryVariables>(LotteryEmployerSettingsDocument, variables),
      options
    );

useLotteryEmployerSettingsQuery.getKey = (variables: LotteryEmployerSettingsQueryVariables) => ['LotteryEmployerSettings', variables];
;

export const useInfiniteLotteryEmployerSettingsQuery = <
      TData = LotteryEmployerSettingsQuery,
      TError = unknown
    >(
      pageParamKey: keyof LotteryEmployerSettingsQueryVariables,
      variables: LotteryEmployerSettingsQueryVariables,
      options?: UseInfiniteQueryOptions<LotteryEmployerSettingsQuery, TError, TData>
    ) =>
    useInfiniteQuery<LotteryEmployerSettingsQuery, TError, TData>(
      ['LotteryEmployerSettings.infinite', variables],
      (metaData) => fetcher<LotteryEmployerSettingsQuery, LotteryEmployerSettingsQueryVariables>(LotteryEmployerSettingsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLotteryEmployerSettingsQuery.getKey = (variables: LotteryEmployerSettingsQueryVariables) => ['LotteryEmployerSettings.infinite', variables];
;

useLotteryEmployerSettingsQuery.fetcher = (variables: LotteryEmployerSettingsQueryVariables) => fetcher<LotteryEmployerSettingsQuery, LotteryEmployerSettingsQueryVariables>(LotteryEmployerSettingsDocument, variables);
export const InternalFieldQuestionsDocument = `
    query InternalFieldQuestions {
  internalFieldQuestions {
    id
    title
    type
    options
    isDefaultQuestion
    showOnProfile
    showOnJobApplication
    archivedAt
    createdAt
    order
  }
}
    `;
export const useInternalFieldQuestionsQuery = <
      TData = InternalFieldQuestionsQuery,
      TError = unknown
    >(
      variables?: InternalFieldQuestionsQueryVariables,
      options?: UseQueryOptions<InternalFieldQuestionsQuery, TError, TData>
    ) =>
    useQuery<InternalFieldQuestionsQuery, TError, TData>(
      variables === undefined ? ['InternalFieldQuestions'] : ['InternalFieldQuestions', variables],
      fetcher<InternalFieldQuestionsQuery, InternalFieldQuestionsQueryVariables>(InternalFieldQuestionsDocument, variables),
      options
    );

useInternalFieldQuestionsQuery.getKey = (variables?: InternalFieldQuestionsQueryVariables) => variables === undefined ? ['InternalFieldQuestions'] : ['InternalFieldQuestions', variables];
;

export const useInfiniteInternalFieldQuestionsQuery = <
      TData = InternalFieldQuestionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof InternalFieldQuestionsQueryVariables,
      variables?: InternalFieldQuestionsQueryVariables,
      options?: UseInfiniteQueryOptions<InternalFieldQuestionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<InternalFieldQuestionsQuery, TError, TData>(
      variables === undefined ? ['InternalFieldQuestions.infinite'] : ['InternalFieldQuestions.infinite', variables],
      (metaData) => fetcher<InternalFieldQuestionsQuery, InternalFieldQuestionsQueryVariables>(InternalFieldQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteInternalFieldQuestionsQuery.getKey = (variables?: InternalFieldQuestionsQueryVariables) => variables === undefined ? ['InternalFieldQuestions.infinite'] : ['InternalFieldQuestions.infinite', variables];
;

useInternalFieldQuestionsQuery.fetcher = (variables?: InternalFieldQuestionsQueryVariables) => fetcher<InternalFieldQuestionsQuery, InternalFieldQuestionsQueryVariables>(InternalFieldQuestionsDocument, variables);
export const ActiveInternalFieldQuestionsDocument = `
    query ActiveInternalFieldQuestions {
  activeInternalFieldQuestions {
    id
    title
    type
    options
    isDefaultQuestion
    showOnProfile
    showOnJobApplication
    archivedAt
    createdAt
    order
  }
}
    `;
export const useActiveInternalFieldQuestionsQuery = <
      TData = ActiveInternalFieldQuestionsQuery,
      TError = unknown
    >(
      variables?: ActiveInternalFieldQuestionsQueryVariables,
      options?: UseQueryOptions<ActiveInternalFieldQuestionsQuery, TError, TData>
    ) =>
    useQuery<ActiveInternalFieldQuestionsQuery, TError, TData>(
      variables === undefined ? ['ActiveInternalFieldQuestions'] : ['ActiveInternalFieldQuestions', variables],
      fetcher<ActiveInternalFieldQuestionsQuery, ActiveInternalFieldQuestionsQueryVariables>(ActiveInternalFieldQuestionsDocument, variables),
      options
    );

useActiveInternalFieldQuestionsQuery.getKey = (variables?: ActiveInternalFieldQuestionsQueryVariables) => variables === undefined ? ['ActiveInternalFieldQuestions'] : ['ActiveInternalFieldQuestions', variables];
;

export const useInfiniteActiveInternalFieldQuestionsQuery = <
      TData = ActiveInternalFieldQuestionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ActiveInternalFieldQuestionsQueryVariables,
      variables?: ActiveInternalFieldQuestionsQueryVariables,
      options?: UseInfiniteQueryOptions<ActiveInternalFieldQuestionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ActiveInternalFieldQuestionsQuery, TError, TData>(
      variables === undefined ? ['ActiveInternalFieldQuestions.infinite'] : ['ActiveInternalFieldQuestions.infinite', variables],
      (metaData) => fetcher<ActiveInternalFieldQuestionsQuery, ActiveInternalFieldQuestionsQueryVariables>(ActiveInternalFieldQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteActiveInternalFieldQuestionsQuery.getKey = (variables?: ActiveInternalFieldQuestionsQueryVariables) => variables === undefined ? ['ActiveInternalFieldQuestions.infinite'] : ['ActiveInternalFieldQuestions.infinite', variables];
;

useActiveInternalFieldQuestionsQuery.fetcher = (variables?: ActiveInternalFieldQuestionsQueryVariables) => fetcher<ActiveInternalFieldQuestionsQuery, ActiveInternalFieldQuestionsQueryVariables>(ActiveInternalFieldQuestionsDocument, variables);
export const UpsertInternalFieldJobApplicationAnswerDocument = `
    mutation UpsertInternalFieldJobApplicationAnswer($recruitId: Int!, $jobAppId: Int!, $answers: [UpsertInternalFieldAnswerInput!]!) {
  upsertJobAppInternalFieldAnswers(
    recruitId: $recruitId
    jobAppId: $jobAppId
    answers: $answers
  )
}
    `;
export const useUpsertInternalFieldJobApplicationAnswerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertInternalFieldJobApplicationAnswerMutation, TError, UpsertInternalFieldJobApplicationAnswerMutationVariables, TContext>) =>
    useMutation<UpsertInternalFieldJobApplicationAnswerMutation, TError, UpsertInternalFieldJobApplicationAnswerMutationVariables, TContext>(
      ['UpsertInternalFieldJobApplicationAnswer'],
      (variables?: UpsertInternalFieldJobApplicationAnswerMutationVariables) => fetcher<UpsertInternalFieldJobApplicationAnswerMutation, UpsertInternalFieldJobApplicationAnswerMutationVariables>(UpsertInternalFieldJobApplicationAnswerDocument, variables)(),
      options
    );
useUpsertInternalFieldJobApplicationAnswerMutation.fetcher = (variables: UpsertInternalFieldJobApplicationAnswerMutationVariables) => fetcher<UpsertInternalFieldJobApplicationAnswerMutation, UpsertInternalFieldJobApplicationAnswerMutationVariables>(UpsertInternalFieldJobApplicationAnswerDocument, variables);
export const CreateCandidateMissingInfoRequestDocument = `
    mutation CreateCandidateMissingInfoRequest($recruitId: Int!, $jobAppId: Int!, $recipientType: CandidateMissingInfoRequestRecipientType!) {
  createCandidateMissingInfoRequest(
    recruitId: $recruitId
    jobAppId: $jobAppId
    recipientType: $recipientType
  )
}
    `;
export const useCreateCandidateMissingInfoRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCandidateMissingInfoRequestMutation, TError, CreateCandidateMissingInfoRequestMutationVariables, TContext>) =>
    useMutation<CreateCandidateMissingInfoRequestMutation, TError, CreateCandidateMissingInfoRequestMutationVariables, TContext>(
      ['CreateCandidateMissingInfoRequest'],
      (variables?: CreateCandidateMissingInfoRequestMutationVariables) => fetcher<CreateCandidateMissingInfoRequestMutation, CreateCandidateMissingInfoRequestMutationVariables>(CreateCandidateMissingInfoRequestDocument, variables)(),
      options
    );
useCreateCandidateMissingInfoRequestMutation.fetcher = (variables: CreateCandidateMissingInfoRequestMutationVariables) => fetcher<CreateCandidateMissingInfoRequestMutation, CreateCandidateMissingInfoRequestMutationVariables>(CreateCandidateMissingInfoRequestDocument, variables);
export const BulkCreateCandidateMissingInfoRequestDocument = `
    mutation BulkCreateCandidateMissingInfoRequest($input: BulkCreateCandidateMissingInfoRequestInput!) {
  bulkCreateCandidateMissingInfoRequest(input: $input) {
    successful
  }
}
    `;
export const useBulkCreateCandidateMissingInfoRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BulkCreateCandidateMissingInfoRequestMutation, TError, BulkCreateCandidateMissingInfoRequestMutationVariables, TContext>) =>
    useMutation<BulkCreateCandidateMissingInfoRequestMutation, TError, BulkCreateCandidateMissingInfoRequestMutationVariables, TContext>(
      ['BulkCreateCandidateMissingInfoRequest'],
      (variables?: BulkCreateCandidateMissingInfoRequestMutationVariables) => fetcher<BulkCreateCandidateMissingInfoRequestMutation, BulkCreateCandidateMissingInfoRequestMutationVariables>(BulkCreateCandidateMissingInfoRequestDocument, variables)(),
      options
    );
useBulkCreateCandidateMissingInfoRequestMutation.fetcher = (variables: BulkCreateCandidateMissingInfoRequestMutationVariables) => fetcher<BulkCreateCandidateMissingInfoRequestMutation, BulkCreateCandidateMissingInfoRequestMutationVariables>(BulkCreateCandidateMissingInfoRequestDocument, variables);
export const MissingInfoRequestJobEmailTemplateDocument = `
    query MissingInfoRequestJobEmailTemplate($jobId: Int!) {
  candidateMissingInfoRequestJobEmailTemplate(jobId: $jobId) {
    replyToUserId
    ccUserId
    bccUserId
    subject
    body
  }
}
    `;
export const useMissingInfoRequestJobEmailTemplateQuery = <
      TData = MissingInfoRequestJobEmailTemplateQuery,
      TError = unknown
    >(
      variables: MissingInfoRequestJobEmailTemplateQueryVariables,
      options?: UseQueryOptions<MissingInfoRequestJobEmailTemplateQuery, TError, TData>
    ) =>
    useQuery<MissingInfoRequestJobEmailTemplateQuery, TError, TData>(
      ['MissingInfoRequestJobEmailTemplate', variables],
      fetcher<MissingInfoRequestJobEmailTemplateQuery, MissingInfoRequestJobEmailTemplateQueryVariables>(MissingInfoRequestJobEmailTemplateDocument, variables),
      options
    );

useMissingInfoRequestJobEmailTemplateQuery.getKey = (variables: MissingInfoRequestJobEmailTemplateQueryVariables) => ['MissingInfoRequestJobEmailTemplate', variables];
;

export const useInfiniteMissingInfoRequestJobEmailTemplateQuery = <
      TData = MissingInfoRequestJobEmailTemplateQuery,
      TError = unknown
    >(
      pageParamKey: keyof MissingInfoRequestJobEmailTemplateQueryVariables,
      variables: MissingInfoRequestJobEmailTemplateQueryVariables,
      options?: UseInfiniteQueryOptions<MissingInfoRequestJobEmailTemplateQuery, TError, TData>
    ) =>
    useInfiniteQuery<MissingInfoRequestJobEmailTemplateQuery, TError, TData>(
      ['MissingInfoRequestJobEmailTemplate.infinite', variables],
      (metaData) => fetcher<MissingInfoRequestJobEmailTemplateQuery, MissingInfoRequestJobEmailTemplateQueryVariables>(MissingInfoRequestJobEmailTemplateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteMissingInfoRequestJobEmailTemplateQuery.getKey = (variables: MissingInfoRequestJobEmailTemplateQueryVariables) => ['MissingInfoRequestJobEmailTemplate.infinite', variables];
;

useMissingInfoRequestJobEmailTemplateQuery.fetcher = (variables: MissingInfoRequestJobEmailTemplateQueryVariables) => fetcher<MissingInfoRequestJobEmailTemplateQuery, MissingInfoRequestJobEmailTemplateQueryVariables>(MissingInfoRequestJobEmailTemplateDocument, variables);
export const UpdateMissingInfoRequestJobEmailTemplateDocument = `
    mutation UpdateMissingInfoRequestJobEmailTemplate($jobId: Int!, $input: CandidateMissingInfoRequestJobEmailTemplateInput!) {
  updateCandidateMissingInfoRequestJobEmailTemplate(jobId: $jobId, input: $input)
}
    `;
export const useUpdateMissingInfoRequestJobEmailTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMissingInfoRequestJobEmailTemplateMutation, TError, UpdateMissingInfoRequestJobEmailTemplateMutationVariables, TContext>) =>
    useMutation<UpdateMissingInfoRequestJobEmailTemplateMutation, TError, UpdateMissingInfoRequestJobEmailTemplateMutationVariables, TContext>(
      ['UpdateMissingInfoRequestJobEmailTemplate'],
      (variables?: UpdateMissingInfoRequestJobEmailTemplateMutationVariables) => fetcher<UpdateMissingInfoRequestJobEmailTemplateMutation, UpdateMissingInfoRequestJobEmailTemplateMutationVariables>(UpdateMissingInfoRequestJobEmailTemplateDocument, variables)(),
      options
    );
useUpdateMissingInfoRequestJobEmailTemplateMutation.fetcher = (variables: UpdateMissingInfoRequestJobEmailTemplateMutationVariables) => fetcher<UpdateMissingInfoRequestJobEmailTemplateMutation, UpdateMissingInfoRequestJobEmailTemplateMutationVariables>(UpdateMissingInfoRequestJobEmailTemplateDocument, variables);
export const RequestMissingInfoJobInfoDocument = `
    query RequestMissingInfoJobInfo($jobId: Int!) {
  job(jobId: $jobId) {
    title
    hiringLeads {
      id
    }
  }
  getOrg {
    name
    urlFriendlyName
  }
}
    `;
export const useRequestMissingInfoJobInfoQuery = <
      TData = RequestMissingInfoJobInfoQuery,
      TError = unknown
    >(
      variables: RequestMissingInfoJobInfoQueryVariables,
      options?: UseQueryOptions<RequestMissingInfoJobInfoQuery, TError, TData>
    ) =>
    useQuery<RequestMissingInfoJobInfoQuery, TError, TData>(
      ['RequestMissingInfoJobInfo', variables],
      fetcher<RequestMissingInfoJobInfoQuery, RequestMissingInfoJobInfoQueryVariables>(RequestMissingInfoJobInfoDocument, variables),
      options
    );

useRequestMissingInfoJobInfoQuery.getKey = (variables: RequestMissingInfoJobInfoQueryVariables) => ['RequestMissingInfoJobInfo', variables];
;

export const useInfiniteRequestMissingInfoJobInfoQuery = <
      TData = RequestMissingInfoJobInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof RequestMissingInfoJobInfoQueryVariables,
      variables: RequestMissingInfoJobInfoQueryVariables,
      options?: UseInfiniteQueryOptions<RequestMissingInfoJobInfoQuery, TError, TData>
    ) =>
    useInfiniteQuery<RequestMissingInfoJobInfoQuery, TError, TData>(
      ['RequestMissingInfoJobInfo.infinite', variables],
      (metaData) => fetcher<RequestMissingInfoJobInfoQuery, RequestMissingInfoJobInfoQueryVariables>(RequestMissingInfoJobInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteRequestMissingInfoJobInfoQuery.getKey = (variables: RequestMissingInfoJobInfoQueryVariables) => ['RequestMissingInfoJobInfo.infinite', variables];
;

useRequestMissingInfoJobInfoQuery.fetcher = (variables: RequestMissingInfoJobInfoQueryVariables) => fetcher<RequestMissingInfoJobInfoQuery, RequestMissingInfoJobInfoQueryVariables>(RequestMissingInfoJobInfoDocument, variables);
export const CandidateProfileCandidateInfoDocument = `
    query CandidateProfileCandidateInfo($candidateId: Int!) {
  getCandidate(candidateId: $candidateId) {
    firstName
    lastName
    email
  }
}
    `;
export const useCandidateProfileCandidateInfoQuery = <
      TData = CandidateProfileCandidateInfoQuery,
      TError = unknown
    >(
      variables: CandidateProfileCandidateInfoQueryVariables,
      options?: UseQueryOptions<CandidateProfileCandidateInfoQuery, TError, TData>
    ) =>
    useQuery<CandidateProfileCandidateInfoQuery, TError, TData>(
      ['CandidateProfileCandidateInfo', variables],
      fetcher<CandidateProfileCandidateInfoQuery, CandidateProfileCandidateInfoQueryVariables>(CandidateProfileCandidateInfoDocument, variables),
      options
    );

useCandidateProfileCandidateInfoQuery.getKey = (variables: CandidateProfileCandidateInfoQueryVariables) => ['CandidateProfileCandidateInfo', variables];
;

export const useInfiniteCandidateProfileCandidateInfoQuery = <
      TData = CandidateProfileCandidateInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateProfileCandidateInfoQueryVariables,
      variables: CandidateProfileCandidateInfoQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateProfileCandidateInfoQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateProfileCandidateInfoQuery, TError, TData>(
      ['CandidateProfileCandidateInfo.infinite', variables],
      (metaData) => fetcher<CandidateProfileCandidateInfoQuery, CandidateProfileCandidateInfoQueryVariables>(CandidateProfileCandidateInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateProfileCandidateInfoQuery.getKey = (variables: CandidateProfileCandidateInfoQueryVariables) => ['CandidateProfileCandidateInfo.infinite', variables];
;

useCandidateProfileCandidateInfoQuery.fetcher = (variables: CandidateProfileCandidateInfoQueryVariables) => fetcher<CandidateProfileCandidateInfoQuery, CandidateProfileCandidateInfoQueryVariables>(CandidateProfileCandidateInfoDocument, variables);
export const LoadTestHealthCheckDocument = `
    query LoadTestHealthCheck {
  healthCheck
}
    `;
export const useLoadTestHealthCheckQuery = <
      TData = LoadTestHealthCheckQuery,
      TError = unknown
    >(
      variables?: LoadTestHealthCheckQueryVariables,
      options?: UseQueryOptions<LoadTestHealthCheckQuery, TError, TData>
    ) =>
    useQuery<LoadTestHealthCheckQuery, TError, TData>(
      variables === undefined ? ['LoadTestHealthCheck'] : ['LoadTestHealthCheck', variables],
      fetcher<LoadTestHealthCheckQuery, LoadTestHealthCheckQueryVariables>(LoadTestHealthCheckDocument, variables),
      options
    );

useLoadTestHealthCheckQuery.getKey = (variables?: LoadTestHealthCheckQueryVariables) => variables === undefined ? ['LoadTestHealthCheck'] : ['LoadTestHealthCheck', variables];
;

export const useInfiniteLoadTestHealthCheckQuery = <
      TData = LoadTestHealthCheckQuery,
      TError = unknown
    >(
      pageParamKey: keyof LoadTestHealthCheckQueryVariables,
      variables?: LoadTestHealthCheckQueryVariables,
      options?: UseInfiniteQueryOptions<LoadTestHealthCheckQuery, TError, TData>
    ) =>
    useInfiniteQuery<LoadTestHealthCheckQuery, TError, TData>(
      variables === undefined ? ['LoadTestHealthCheck.infinite'] : ['LoadTestHealthCheck.infinite', variables],
      (metaData) => fetcher<LoadTestHealthCheckQuery, LoadTestHealthCheckQueryVariables>(LoadTestHealthCheckDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLoadTestHealthCheckQuery.getKey = (variables?: LoadTestHealthCheckQueryVariables) => variables === undefined ? ['LoadTestHealthCheck.infinite'] : ['LoadTestHealthCheck.infinite', variables];
;

useLoadTestHealthCheckQuery.fetcher = (variables?: LoadTestHealthCheckQueryVariables) => fetcher<LoadTestHealthCheckQuery, LoadTestHealthCheckQueryVariables>(LoadTestHealthCheckDocument, variables);
export const LoadTestSimpleDocument = `
    query LoadTestSimple {
  testString
}
    `;
export const useLoadTestSimpleQuery = <
      TData = LoadTestSimpleQuery,
      TError = unknown
    >(
      variables?: LoadTestSimpleQueryVariables,
      options?: UseQueryOptions<LoadTestSimpleQuery, TError, TData>
    ) =>
    useQuery<LoadTestSimpleQuery, TError, TData>(
      variables === undefined ? ['LoadTestSimple'] : ['LoadTestSimple', variables],
      fetcher<LoadTestSimpleQuery, LoadTestSimpleQueryVariables>(LoadTestSimpleDocument, variables),
      options
    );

useLoadTestSimpleQuery.getKey = (variables?: LoadTestSimpleQueryVariables) => variables === undefined ? ['LoadTestSimple'] : ['LoadTestSimple', variables];
;

export const useInfiniteLoadTestSimpleQuery = <
      TData = LoadTestSimpleQuery,
      TError = unknown
    >(
      pageParamKey: keyof LoadTestSimpleQueryVariables,
      variables?: LoadTestSimpleQueryVariables,
      options?: UseInfiniteQueryOptions<LoadTestSimpleQuery, TError, TData>
    ) =>
    useInfiniteQuery<LoadTestSimpleQuery, TError, TData>(
      variables === undefined ? ['LoadTestSimple.infinite'] : ['LoadTestSimple.infinite', variables],
      (metaData) => fetcher<LoadTestSimpleQuery, LoadTestSimpleQueryVariables>(LoadTestSimpleDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLoadTestSimpleQuery.getKey = (variables?: LoadTestSimpleQueryVariables) => variables === undefined ? ['LoadTestSimple.infinite'] : ['LoadTestSimple.infinite', variables];
;

useLoadTestSimpleQuery.fetcher = (variables?: LoadTestSimpleQueryVariables) => fetcher<LoadTestSimpleQuery, LoadTestSimpleQueryVariables>(LoadTestSimpleDocument, variables);
export const LoadTestFeatureFlagDocument = `
    query LoadTestFeatureFlag {
  testFeatureFlag
}
    `;
export const useLoadTestFeatureFlagQuery = <
      TData = LoadTestFeatureFlagQuery,
      TError = unknown
    >(
      variables?: LoadTestFeatureFlagQueryVariables,
      options?: UseQueryOptions<LoadTestFeatureFlagQuery, TError, TData>
    ) =>
    useQuery<LoadTestFeatureFlagQuery, TError, TData>(
      variables === undefined ? ['LoadTestFeatureFlag'] : ['LoadTestFeatureFlag', variables],
      fetcher<LoadTestFeatureFlagQuery, LoadTestFeatureFlagQueryVariables>(LoadTestFeatureFlagDocument, variables),
      options
    );

useLoadTestFeatureFlagQuery.getKey = (variables?: LoadTestFeatureFlagQueryVariables) => variables === undefined ? ['LoadTestFeatureFlag'] : ['LoadTestFeatureFlag', variables];
;

export const useInfiniteLoadTestFeatureFlagQuery = <
      TData = LoadTestFeatureFlagQuery,
      TError = unknown
    >(
      pageParamKey: keyof LoadTestFeatureFlagQueryVariables,
      variables?: LoadTestFeatureFlagQueryVariables,
      options?: UseInfiniteQueryOptions<LoadTestFeatureFlagQuery, TError, TData>
    ) =>
    useInfiniteQuery<LoadTestFeatureFlagQuery, TError, TData>(
      variables === undefined ? ['LoadTestFeatureFlag.infinite'] : ['LoadTestFeatureFlag.infinite', variables],
      (metaData) => fetcher<LoadTestFeatureFlagQuery, LoadTestFeatureFlagQueryVariables>(LoadTestFeatureFlagDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLoadTestFeatureFlagQuery.getKey = (variables?: LoadTestFeatureFlagQueryVariables) => variables === undefined ? ['LoadTestFeatureFlag.infinite'] : ['LoadTestFeatureFlag.infinite', variables];
;

useLoadTestFeatureFlagQuery.fetcher = (variables?: LoadTestFeatureFlagQueryVariables) => fetcher<LoadTestFeatureFlagQuery, LoadTestFeatureFlagQueryVariables>(LoadTestFeatureFlagDocument, variables);
export const LoadTestSimpleObjectDocument = `
    query LoadTestSimpleObject {
  testObject {
    test
    test2
    test3
    test4
    depth
  }
}
    `;
export const useLoadTestSimpleObjectQuery = <
      TData = LoadTestSimpleObjectQuery,
      TError = unknown
    >(
      variables?: LoadTestSimpleObjectQueryVariables,
      options?: UseQueryOptions<LoadTestSimpleObjectQuery, TError, TData>
    ) =>
    useQuery<LoadTestSimpleObjectQuery, TError, TData>(
      variables === undefined ? ['LoadTestSimpleObject'] : ['LoadTestSimpleObject', variables],
      fetcher<LoadTestSimpleObjectQuery, LoadTestSimpleObjectQueryVariables>(LoadTestSimpleObjectDocument, variables),
      options
    );

useLoadTestSimpleObjectQuery.getKey = (variables?: LoadTestSimpleObjectQueryVariables) => variables === undefined ? ['LoadTestSimpleObject'] : ['LoadTestSimpleObject', variables];
;

export const useInfiniteLoadTestSimpleObjectQuery = <
      TData = LoadTestSimpleObjectQuery,
      TError = unknown
    >(
      pageParamKey: keyof LoadTestSimpleObjectQueryVariables,
      variables?: LoadTestSimpleObjectQueryVariables,
      options?: UseInfiniteQueryOptions<LoadTestSimpleObjectQuery, TError, TData>
    ) =>
    useInfiniteQuery<LoadTestSimpleObjectQuery, TError, TData>(
      variables === undefined ? ['LoadTestSimpleObject.infinite'] : ['LoadTestSimpleObject.infinite', variables],
      (metaData) => fetcher<LoadTestSimpleObjectQuery, LoadTestSimpleObjectQueryVariables>(LoadTestSimpleObjectDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLoadTestSimpleObjectQuery.getKey = (variables?: LoadTestSimpleObjectQueryVariables) => variables === undefined ? ['LoadTestSimpleObject.infinite'] : ['LoadTestSimpleObject.infinite', variables];
;

useLoadTestSimpleObjectQuery.fetcher = (variables?: LoadTestSimpleObjectQueryVariables) => fetcher<LoadTestSimpleObjectQuery, LoadTestSimpleObjectQueryVariables>(LoadTestSimpleObjectDocument, variables);
export const LoadTestComplexObjectDocument = `
    query LoadTestComplexObject($argument1: ID, $argument2: Int, $argument3: [String!], $argument4: [Int!], $argument5: TestInput2) {
  testObject(
    argument1: $argument1
    argument2: $argument2
    argument3: $argument3
    argument4: $argument4
    argument5: $argument5
  ) {
    test
    test2
    test3
    test4
    depth
    testObject1 {
      test
      test2
      test3
      test4
      depth
      testObject1 {
        test
        test2
        test3
        test4
        depth
        testObject1 {
          test
          test2
          test3
          test4
          depth
          testObject1 {
            test
          }
          testObject2 {
            test
          }
          testObject3 {
            test
          }
        }
        testObject2 {
          test
          test2
          test3
          test4
          depth
          testObject1 {
            test
          }
          testObject2 {
            test
          }
          testObject3 {
            test
          }
        }
        testObject3 {
          test
          test2
          test3
          test4
          depth
          testObject1 {
            test
          }
          testObject2 {
            test
          }
          testObject3 {
            test
          }
        }
      }
      testObject2 {
        test
        test2
        test3
        test4
        depth
        testObject1 {
          test
          test2
          test3
          test4
          depth
          testObject1 {
            test
            test2
            test3
            test4
            depth
            testObject1 {
              test
            }
            testObject2 {
              test
            }
            testObject3 {
              test
            }
          }
          testObject2 {
            test
            test2
            test3
            test4
            depth
            testObject1 {
              test
            }
            testObject2 {
              test
            }
            testObject3 {
              test
            }
          }
          testObject3 {
            test
            test2
            test3
            test4
            depth
            testObject1 {
              test
            }
            testObject2 {
              test
            }
            testObject3 {
              test
            }
          }
        }
        testObject2 {
          test
        }
        testObject3 {
          test
        }
      }
      testObject3 {
        test
        test2
        test3
        test4
        depth
        testObject1 {
          test
          test2
          test3
          test4
          depth
          testObject1 {
            test
          }
          testObject2 {
            test
          }
          testObject3 {
            test
          }
        }
        testObject2 {
          test
          test2
          test3
          test4
          depth
          testObject1 {
            test
          }
          testObject2 {
            test
          }
          testObject3 {
            test
          }
        }
        testObject3 {
          test
          test2
          test3
          test4
          depth
          testObject1 {
            test
          }
          testObject2 {
            test
          }
          testObject3 {
            test
          }
        }
      }
    }
    testObject2 {
      test
    }
    testObject3 {
      test
    }
  }
}
    `;
export const useLoadTestComplexObjectQuery = <
      TData = LoadTestComplexObjectQuery,
      TError = unknown
    >(
      variables?: LoadTestComplexObjectQueryVariables,
      options?: UseQueryOptions<LoadTestComplexObjectQuery, TError, TData>
    ) =>
    useQuery<LoadTestComplexObjectQuery, TError, TData>(
      variables === undefined ? ['LoadTestComplexObject'] : ['LoadTestComplexObject', variables],
      fetcher<LoadTestComplexObjectQuery, LoadTestComplexObjectQueryVariables>(LoadTestComplexObjectDocument, variables),
      options
    );

useLoadTestComplexObjectQuery.getKey = (variables?: LoadTestComplexObjectQueryVariables) => variables === undefined ? ['LoadTestComplexObject'] : ['LoadTestComplexObject', variables];
;

export const useInfiniteLoadTestComplexObjectQuery = <
      TData = LoadTestComplexObjectQuery,
      TError = unknown
    >(
      pageParamKey: keyof LoadTestComplexObjectQueryVariables,
      variables?: LoadTestComplexObjectQueryVariables,
      options?: UseInfiniteQueryOptions<LoadTestComplexObjectQuery, TError, TData>
    ) =>
    useInfiniteQuery<LoadTestComplexObjectQuery, TError, TData>(
      variables === undefined ? ['LoadTestComplexObject.infinite'] : ['LoadTestComplexObject.infinite', variables],
      (metaData) => fetcher<LoadTestComplexObjectQuery, LoadTestComplexObjectQueryVariables>(LoadTestComplexObjectDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLoadTestComplexObjectQuery.getKey = (variables?: LoadTestComplexObjectQueryVariables) => variables === undefined ? ['LoadTestComplexObject.infinite'] : ['LoadTestComplexObject.infinite', variables];
;

useLoadTestComplexObjectQuery.fetcher = (variables?: LoadTestComplexObjectQueryVariables) => fetcher<LoadTestComplexObjectQuery, LoadTestComplexObjectQueryVariables>(LoadTestComplexObjectDocument, variables);
export const GetMembersForCurrentOrgDocument = `
    query GetMembersForCurrentOrg {
  getOrg {
    members {
      nodes {
        ...fullMemberInfo
      }
    }
  }
}
    ${FullMemberInfoFragmentDoc}`;
export const useGetMembersForCurrentOrgQuery = <
      TData = GetMembersForCurrentOrgQuery,
      TError = unknown
    >(
      variables?: GetMembersForCurrentOrgQueryVariables,
      options?: UseQueryOptions<GetMembersForCurrentOrgQuery, TError, TData>
    ) =>
    useQuery<GetMembersForCurrentOrgQuery, TError, TData>(
      variables === undefined ? ['GetMembersForCurrentOrg'] : ['GetMembersForCurrentOrg', variables],
      fetcher<GetMembersForCurrentOrgQuery, GetMembersForCurrentOrgQueryVariables>(GetMembersForCurrentOrgDocument, variables),
      options
    );

useGetMembersForCurrentOrgQuery.getKey = (variables?: GetMembersForCurrentOrgQueryVariables) => variables === undefined ? ['GetMembersForCurrentOrg'] : ['GetMembersForCurrentOrg', variables];
;

export const useInfiniteGetMembersForCurrentOrgQuery = <
      TData = GetMembersForCurrentOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMembersForCurrentOrgQueryVariables,
      variables?: GetMembersForCurrentOrgQueryVariables,
      options?: UseInfiniteQueryOptions<GetMembersForCurrentOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetMembersForCurrentOrgQuery, TError, TData>(
      variables === undefined ? ['GetMembersForCurrentOrg.infinite'] : ['GetMembersForCurrentOrg.infinite', variables],
      (metaData) => fetcher<GetMembersForCurrentOrgQuery, GetMembersForCurrentOrgQueryVariables>(GetMembersForCurrentOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetMembersForCurrentOrgQuery.getKey = (variables?: GetMembersForCurrentOrgQueryVariables) => variables === undefined ? ['GetMembersForCurrentOrg.infinite'] : ['GetMembersForCurrentOrg.infinite', variables];
;

useGetMembersForCurrentOrgQuery.fetcher = (variables?: GetMembersForCurrentOrgQueryVariables) => fetcher<GetMembersForCurrentOrgQuery, GetMembersForCurrentOrgQueryVariables>(GetMembersForCurrentOrgDocument, variables);
export const GetMemberByIdDocument = `
    query GetMemberById($id: ID!) {
  memberById(id: $id) {
    ...fullMemberInfo
  }
}
    ${FullMemberInfoFragmentDoc}`;
export const useGetMemberByIdQuery = <
      TData = GetMemberByIdQuery,
      TError = unknown
    >(
      variables: GetMemberByIdQueryVariables,
      options?: UseQueryOptions<GetMemberByIdQuery, TError, TData>
    ) =>
    useQuery<GetMemberByIdQuery, TError, TData>(
      ['GetMemberById', variables],
      fetcher<GetMemberByIdQuery, GetMemberByIdQueryVariables>(GetMemberByIdDocument, variables),
      options
    );

useGetMemberByIdQuery.getKey = (variables: GetMemberByIdQueryVariables) => ['GetMemberById', variables];
;

export const useInfiniteGetMemberByIdQuery = <
      TData = GetMemberByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMemberByIdQueryVariables,
      variables: GetMemberByIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetMemberByIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetMemberByIdQuery, TError, TData>(
      ['GetMemberById.infinite', variables],
      (metaData) => fetcher<GetMemberByIdQuery, GetMemberByIdQueryVariables>(GetMemberByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetMemberByIdQuery.getKey = (variables: GetMemberByIdQueryVariables) => ['GetMemberById.infinite', variables];
;

useGetMemberByIdQuery.fetcher = (variables: GetMemberByIdQueryVariables) => fetcher<GetMemberByIdQuery, GetMemberByIdQueryVariables>(GetMemberByIdDocument, variables);
export const GetOrgSsoInfoDocument = `
    query GetOrgSsoInfo {
  getOrg {
    isMfaEnabled
    ssoType
    ssoAuthInfo {
      ssoIdIsEmail
      frontendAttribute {
        isEmail
        label
        validationRegex
        validationErrorMessage
      }
    }
  }
}
    `;
export const useGetOrgSsoInfoQuery = <
      TData = GetOrgSsoInfoQuery,
      TError = unknown
    >(
      variables?: GetOrgSsoInfoQueryVariables,
      options?: UseQueryOptions<GetOrgSsoInfoQuery, TError, TData>
    ) =>
    useQuery<GetOrgSsoInfoQuery, TError, TData>(
      variables === undefined ? ['GetOrgSsoInfo'] : ['GetOrgSsoInfo', variables],
      fetcher<GetOrgSsoInfoQuery, GetOrgSsoInfoQueryVariables>(GetOrgSsoInfoDocument, variables),
      options
    );

useGetOrgSsoInfoQuery.getKey = (variables?: GetOrgSsoInfoQueryVariables) => variables === undefined ? ['GetOrgSsoInfo'] : ['GetOrgSsoInfo', variables];
;

export const useInfiniteGetOrgSsoInfoQuery = <
      TData = GetOrgSsoInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetOrgSsoInfoQueryVariables,
      variables?: GetOrgSsoInfoQueryVariables,
      options?: UseInfiniteQueryOptions<GetOrgSsoInfoQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetOrgSsoInfoQuery, TError, TData>(
      variables === undefined ? ['GetOrgSsoInfo.infinite'] : ['GetOrgSsoInfo.infinite', variables],
      (metaData) => fetcher<GetOrgSsoInfoQuery, GetOrgSsoInfoQueryVariables>(GetOrgSsoInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetOrgSsoInfoQuery.getKey = (variables?: GetOrgSsoInfoQueryVariables) => variables === undefined ? ['GetOrgSsoInfo.infinite'] : ['GetOrgSsoInfo.infinite', variables];
;

useGetOrgSsoInfoQuery.fetcher = (variables?: GetOrgSsoInfoQueryVariables) => fetcher<GetOrgSsoInfoQuery, GetOrgSsoInfoQueryVariables>(GetOrgSsoInfoDocument, variables);
export const CreateEmployerMemberDocument = `
    mutation CreateEmployerMember($input: CreateEmployerMemberInput!) {
  createEmployerMember(input: $input) {
    __typename
    ... on CreateEmployerMemberSuccess {
      member {
        id
      }
    }
    ... on EmailTakenWarning {
      userMessage
    }
    ... on SsoUserIdTakenWarning {
      userMessage
    }
    ... on UserWarning {
      userMessage
    }
  }
}
    `;
export const useCreateEmployerMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateEmployerMemberMutation, TError, CreateEmployerMemberMutationVariables, TContext>) =>
    useMutation<CreateEmployerMemberMutation, TError, CreateEmployerMemberMutationVariables, TContext>(
      ['CreateEmployerMember'],
      (variables?: CreateEmployerMemberMutationVariables) => fetcher<CreateEmployerMemberMutation, CreateEmployerMemberMutationVariables>(CreateEmployerMemberDocument, variables)(),
      options
    );
useCreateEmployerMemberMutation.fetcher = (variables: CreateEmployerMemberMutationVariables) => fetcher<CreateEmployerMemberMutation, CreateEmployerMemberMutationVariables>(CreateEmployerMemberDocument, variables);
export const EditEmployerMemberInfoDocument = `
    mutation EditEmployerMemberInfo($input: EditEmployerMemberInfoInput!) {
  editEmployerMemberInfo(input: $input) {
    member {
      id
    }
  }
}
    `;
export const useEditEmployerMemberInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditEmployerMemberInfoMutation, TError, EditEmployerMemberInfoMutationVariables, TContext>) =>
    useMutation<EditEmployerMemberInfoMutation, TError, EditEmployerMemberInfoMutationVariables, TContext>(
      ['EditEmployerMemberInfo'],
      (variables?: EditEmployerMemberInfoMutationVariables) => fetcher<EditEmployerMemberInfoMutation, EditEmployerMemberInfoMutationVariables>(EditEmployerMemberInfoDocument, variables)(),
      options
    );
useEditEmployerMemberInfoMutation.fetcher = (variables: EditEmployerMemberInfoMutationVariables) => fetcher<EditEmployerMemberInfoMutation, EditEmployerMemberInfoMutationVariables>(EditEmployerMemberInfoDocument, variables);
export const EditEmployerMemberAuthInfoDocument = `
    mutation EditEmployerMemberAuthInfo($input: EditEmployerMemberAuthInfoInput!) {
  editEmployerMemberAuthInfo(input: $input) {
    __typename
    ... on EditEmployerMemberAuthInfoSuccess {
      id
    }
    ... on UserWarning {
      userMessage
    }
  }
}
    `;
export const useEditEmployerMemberAuthInfoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<EditEmployerMemberAuthInfoMutation, TError, EditEmployerMemberAuthInfoMutationVariables, TContext>) =>
    useMutation<EditEmployerMemberAuthInfoMutation, TError, EditEmployerMemberAuthInfoMutationVariables, TContext>(
      ['EditEmployerMemberAuthInfo'],
      (variables?: EditEmployerMemberAuthInfoMutationVariables) => fetcher<EditEmployerMemberAuthInfoMutation, EditEmployerMemberAuthInfoMutationVariables>(EditEmployerMemberAuthInfoDocument, variables)(),
      options
    );
useEditEmployerMemberAuthInfoMutation.fetcher = (variables: EditEmployerMemberAuthInfoMutationVariables) => fetcher<EditEmployerMemberAuthInfoMutation, EditEmployerMemberAuthInfoMutationVariables>(EditEmployerMemberAuthInfoDocument, variables);
export const DeleteMemberDocument = `
    mutation DeleteMember($id: ID!) {
  deleteMember(input: {id: $id}) {
    member {
      id
    }
  }
}
    `;
export const useDeleteMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMemberMutation, TError, DeleteMemberMutationVariables, TContext>) =>
    useMutation<DeleteMemberMutation, TError, DeleteMemberMutationVariables, TContext>(
      ['DeleteMember'],
      (variables?: DeleteMemberMutationVariables) => fetcher<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, variables)(),
      options
    );
useDeleteMemberMutation.fetcher = (variables: DeleteMemberMutationVariables) => fetcher<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, variables);
export const UploadMembersCsvDocument = `
    mutation UploadMembersCsv($input: UploadMembersCsvInput!) {
  uploadMembersCsv(input: $input) {
    __typename
    ... on UploadMembersCsvSuccess {
      createdIds
      updatedIds
    }
    ... on UserWarning {
      userMessage
    }
  }
}
    `;
export const useUploadMembersCsvMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadMembersCsvMutation, TError, UploadMembersCsvMutationVariables, TContext>) =>
    useMutation<UploadMembersCsvMutation, TError, UploadMembersCsvMutationVariables, TContext>(
      ['UploadMembersCsv'],
      (variables?: UploadMembersCsvMutationVariables) => fetcher<UploadMembersCsvMutation, UploadMembersCsvMutationVariables>(UploadMembersCsvDocument, variables)(),
      options
    );
useUploadMembersCsvMutation.fetcher = (variables: UploadMembersCsvMutationVariables) => fetcher<UploadMembersCsvMutation, UploadMembersCsvMutationVariables>(UploadMembersCsvDocument, variables);
export const UpsertCannedReportDocument = `
    mutation UpsertCannedReport($input: CannedReportInput!) {
  upsertCannedReport(cannedReportInput: $input)
}
    `;
export const useUpsertCannedReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCannedReportMutation, TError, UpsertCannedReportMutationVariables, TContext>) =>
    useMutation<UpsertCannedReportMutation, TError, UpsertCannedReportMutationVariables, TContext>(
      ['UpsertCannedReport'],
      (variables?: UpsertCannedReportMutationVariables) => fetcher<UpsertCannedReportMutation, UpsertCannedReportMutationVariables>(UpsertCannedReportDocument, variables)(),
      options
    );
useUpsertCannedReportMutation.fetcher = (variables: UpsertCannedReportMutationVariables) => fetcher<UpsertCannedReportMutation, UpsertCannedReportMutationVariables>(UpsertCannedReportDocument, variables);
export const UpsertCannedReportIncludedJobsDocument = `
    mutation UpsertCannedReportIncludedJobs($input: CannedReportIncludedJobsInput!) {
  upsertCannedReportIncludedJobs(cannedReportIncludedJobsInput: $input)
}
    `;
export const useUpsertCannedReportIncludedJobsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCannedReportIncludedJobsMutation, TError, UpsertCannedReportIncludedJobsMutationVariables, TContext>) =>
    useMutation<UpsertCannedReportIncludedJobsMutation, TError, UpsertCannedReportIncludedJobsMutationVariables, TContext>(
      ['UpsertCannedReportIncludedJobs'],
      (variables?: UpsertCannedReportIncludedJobsMutationVariables) => fetcher<UpsertCannedReportIncludedJobsMutation, UpsertCannedReportIncludedJobsMutationVariables>(UpsertCannedReportIncludedJobsDocument, variables)(),
      options
    );
useUpsertCannedReportIncludedJobsMutation.fetcher = (variables: UpsertCannedReportIncludedJobsMutationVariables) => fetcher<UpsertCannedReportIncludedJobsMutation, UpsertCannedReportIncludedJobsMutationVariables>(UpsertCannedReportIncludedJobsDocument, variables);
export const InitialRunCannedReportDocument = `
    mutation InitialRunCannedReport($input: InitialRunCannedReportInput!) {
  initialRunCannedReport(initialRunCannedReportInput: $input)
}
    `;
export const useInitialRunCannedReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InitialRunCannedReportMutation, TError, InitialRunCannedReportMutationVariables, TContext>) =>
    useMutation<InitialRunCannedReportMutation, TError, InitialRunCannedReportMutationVariables, TContext>(
      ['InitialRunCannedReport'],
      (variables?: InitialRunCannedReportMutationVariables) => fetcher<InitialRunCannedReportMutation, InitialRunCannedReportMutationVariables>(InitialRunCannedReportDocument, variables)(),
      options
    );
useInitialRunCannedReportMutation.fetcher = (variables: InitialRunCannedReportMutationVariables) => fetcher<InitialRunCannedReportMutation, InitialRunCannedReportMutationVariables>(InitialRunCannedReportDocument, variables);
export const DeleteCannedReportDocument = `
    mutation DeleteCannedReport($id: Int!) {
  deleteCannedReport(cannedReportId: $id)
}
    `;
export const useDeleteCannedReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCannedReportMutation, TError, DeleteCannedReportMutationVariables, TContext>) =>
    useMutation<DeleteCannedReportMutation, TError, DeleteCannedReportMutationVariables, TContext>(
      ['DeleteCannedReport'],
      (variables?: DeleteCannedReportMutationVariables) => fetcher<DeleteCannedReportMutation, DeleteCannedReportMutationVariables>(DeleteCannedReportDocument, variables)(),
      options
    );
useDeleteCannedReportMutation.fetcher = (variables: DeleteCannedReportMutationVariables) => fetcher<DeleteCannedReportMutation, DeleteCannedReportMutationVariables>(DeleteCannedReportDocument, variables);
export const GetCannedReportDocument = `
    query GetCannedReport($cannedReportId: Int!) {
  getCannedReport(cannedReportId: $cannedReportId) {
    id
    title
    reportType
    createdBy
    createdAt
    updatedAt
    updatedBy
    creatorFirstName
    creatorLastName
    saved
    selectedJobs {
      jobId
      title
    }
  }
}
    `;
export const useGetCannedReportQuery = <
      TData = GetCannedReportQuery,
      TError = unknown
    >(
      variables: GetCannedReportQueryVariables,
      options?: UseQueryOptions<GetCannedReportQuery, TError, TData>
    ) =>
    useQuery<GetCannedReportQuery, TError, TData>(
      ['GetCannedReport', variables],
      fetcher<GetCannedReportQuery, GetCannedReportQueryVariables>(GetCannedReportDocument, variables),
      options
    );

useGetCannedReportQuery.getKey = (variables: GetCannedReportQueryVariables) => ['GetCannedReport', variables];
;

export const useInfiniteGetCannedReportQuery = <
      TData = GetCannedReportQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCannedReportQueryVariables,
      variables: GetCannedReportQueryVariables,
      options?: UseInfiniteQueryOptions<GetCannedReportQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCannedReportQuery, TError, TData>(
      ['GetCannedReport.infinite', variables],
      (metaData) => fetcher<GetCannedReportQuery, GetCannedReportQueryVariables>(GetCannedReportDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCannedReportQuery.getKey = (variables: GetCannedReportQueryVariables) => ['GetCannedReport.infinite', variables];
;

useGetCannedReportQuery.fetcher = (variables: GetCannedReportQueryVariables) => fetcher<GetCannedReportQuery, GetCannedReportQueryVariables>(GetCannedReportDocument, variables);
export const GetSavedCannedReportsForOrgDocument = `
    query GetSavedCannedReportsForOrg {
  getSavedCannedReportsForOrg {
    id
    title
    reportType
    createdBy
    createdAt
    updatedAt
    updatedBy
    creatorFirstName
    creatorLastName
    latestActivityDate
    selectedJobs {
      jobId
      title
    }
  }
}
    `;
export const useGetSavedCannedReportsForOrgQuery = <
      TData = GetSavedCannedReportsForOrgQuery,
      TError = unknown
    >(
      variables?: GetSavedCannedReportsForOrgQueryVariables,
      options?: UseQueryOptions<GetSavedCannedReportsForOrgQuery, TError, TData>
    ) =>
    useQuery<GetSavedCannedReportsForOrgQuery, TError, TData>(
      variables === undefined ? ['GetSavedCannedReportsForOrg'] : ['GetSavedCannedReportsForOrg', variables],
      fetcher<GetSavedCannedReportsForOrgQuery, GetSavedCannedReportsForOrgQueryVariables>(GetSavedCannedReportsForOrgDocument, variables),
      options
    );

useGetSavedCannedReportsForOrgQuery.getKey = (variables?: GetSavedCannedReportsForOrgQueryVariables) => variables === undefined ? ['GetSavedCannedReportsForOrg'] : ['GetSavedCannedReportsForOrg', variables];
;

export const useInfiniteGetSavedCannedReportsForOrgQuery = <
      TData = GetSavedCannedReportsForOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSavedCannedReportsForOrgQueryVariables,
      variables?: GetSavedCannedReportsForOrgQueryVariables,
      options?: UseInfiniteQueryOptions<GetSavedCannedReportsForOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetSavedCannedReportsForOrgQuery, TError, TData>(
      variables === undefined ? ['GetSavedCannedReportsForOrg.infinite'] : ['GetSavedCannedReportsForOrg.infinite', variables],
      (metaData) => fetcher<GetSavedCannedReportsForOrgQuery, GetSavedCannedReportsForOrgQueryVariables>(GetSavedCannedReportsForOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetSavedCannedReportsForOrgQuery.getKey = (variables?: GetSavedCannedReportsForOrgQueryVariables) => variables === undefined ? ['GetSavedCannedReportsForOrg.infinite'] : ['GetSavedCannedReportsForOrg.infinite', variables];
;

useGetSavedCannedReportsForOrgQuery.fetcher = (variables?: GetSavedCannedReportsForOrgQueryVariables) => fetcher<GetSavedCannedReportsForOrgQuery, GetSavedCannedReportsForOrgQueryVariables>(GetSavedCannedReportsForOrgDocument, variables);
export const GetTotalBucketValuesForLawSchoolDataTableDocument = `
    query GetTotalBucketValuesForLawSchoolDataTable($id: ID!) {
  getTotalBucketValuesForLawSchoolDataTable(id: $id) {
    id
    lawSchoolName
    applied {
      totalCount
    }
    screening {
      totalCount
    }
    interviewing {
      totalCount
    }
    offer {
      totalCount
    }
    hired {
      totalCount
    }
    rejected {
      totalCount
    }
    declined {
      totalCount
    }
    withdrew {
      totalCount
    }
    cancelled {
      totalCount
    }
  }
}
    `;
export const useGetTotalBucketValuesForLawSchoolDataTableQuery = <
      TData = GetTotalBucketValuesForLawSchoolDataTableQuery,
      TError = unknown
    >(
      variables: GetTotalBucketValuesForLawSchoolDataTableQueryVariables,
      options?: UseQueryOptions<GetTotalBucketValuesForLawSchoolDataTableQuery, TError, TData>
    ) =>
    useQuery<GetTotalBucketValuesForLawSchoolDataTableQuery, TError, TData>(
      ['GetTotalBucketValuesForLawSchoolDataTable', variables],
      fetcher<GetTotalBucketValuesForLawSchoolDataTableQuery, GetTotalBucketValuesForLawSchoolDataTableQueryVariables>(GetTotalBucketValuesForLawSchoolDataTableDocument, variables),
      options
    );

useGetTotalBucketValuesForLawSchoolDataTableQuery.getKey = (variables: GetTotalBucketValuesForLawSchoolDataTableQueryVariables) => ['GetTotalBucketValuesForLawSchoolDataTable', variables];
;

export const useInfiniteGetTotalBucketValuesForLawSchoolDataTableQuery = <
      TData = GetTotalBucketValuesForLawSchoolDataTableQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetTotalBucketValuesForLawSchoolDataTableQueryVariables,
      variables: GetTotalBucketValuesForLawSchoolDataTableQueryVariables,
      options?: UseInfiniteQueryOptions<GetTotalBucketValuesForLawSchoolDataTableQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetTotalBucketValuesForLawSchoolDataTableQuery, TError, TData>(
      ['GetTotalBucketValuesForLawSchoolDataTable.infinite', variables],
      (metaData) => fetcher<GetTotalBucketValuesForLawSchoolDataTableQuery, GetTotalBucketValuesForLawSchoolDataTableQueryVariables>(GetTotalBucketValuesForLawSchoolDataTableDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetTotalBucketValuesForLawSchoolDataTableQuery.getKey = (variables: GetTotalBucketValuesForLawSchoolDataTableQueryVariables) => ['GetTotalBucketValuesForLawSchoolDataTable.infinite', variables];
;

useGetTotalBucketValuesForLawSchoolDataTableQuery.fetcher = (variables: GetTotalBucketValuesForLawSchoolDataTableQueryVariables) => fetcher<GetTotalBucketValuesForLawSchoolDataTableQuery, GetTotalBucketValuesForLawSchoolDataTableQueryVariables>(GetTotalBucketValuesForLawSchoolDataTableDocument, variables);
export const GetTotalBucketValuesForAppSourceDataTableDocument = `
    query GetTotalBucketValuesForAppSourceDataTable($id: ID!) {
  getTotalBucketValuesForAppSourceDataTable(id: $id) {
    id
    appSourceName
    applied {
      totalCount
    }
    screening {
      totalCount
    }
    interviewing {
      totalCount
    }
    offer {
      totalCount
    }
    hired {
      totalCount
    }
    rejected {
      totalCount
    }
    declined {
      totalCount
    }
    withdrew {
      totalCount
    }
    cancelled {
      totalCount
    }
  }
}
    `;
export const useGetTotalBucketValuesForAppSourceDataTableQuery = <
      TData = GetTotalBucketValuesForAppSourceDataTableQuery,
      TError = unknown
    >(
      variables: GetTotalBucketValuesForAppSourceDataTableQueryVariables,
      options?: UseQueryOptions<GetTotalBucketValuesForAppSourceDataTableQuery, TError, TData>
    ) =>
    useQuery<GetTotalBucketValuesForAppSourceDataTableQuery, TError, TData>(
      ['GetTotalBucketValuesForAppSourceDataTable', variables],
      fetcher<GetTotalBucketValuesForAppSourceDataTableQuery, GetTotalBucketValuesForAppSourceDataTableQueryVariables>(GetTotalBucketValuesForAppSourceDataTableDocument, variables),
      options
    );

useGetTotalBucketValuesForAppSourceDataTableQuery.getKey = (variables: GetTotalBucketValuesForAppSourceDataTableQueryVariables) => ['GetTotalBucketValuesForAppSourceDataTable', variables];
;

export const useInfiniteGetTotalBucketValuesForAppSourceDataTableQuery = <
      TData = GetTotalBucketValuesForAppSourceDataTableQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetTotalBucketValuesForAppSourceDataTableQueryVariables,
      variables: GetTotalBucketValuesForAppSourceDataTableQueryVariables,
      options?: UseInfiniteQueryOptions<GetTotalBucketValuesForAppSourceDataTableQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetTotalBucketValuesForAppSourceDataTableQuery, TError, TData>(
      ['GetTotalBucketValuesForAppSourceDataTable.infinite', variables],
      (metaData) => fetcher<GetTotalBucketValuesForAppSourceDataTableQuery, GetTotalBucketValuesForAppSourceDataTableQueryVariables>(GetTotalBucketValuesForAppSourceDataTableDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetTotalBucketValuesForAppSourceDataTableQuery.getKey = (variables: GetTotalBucketValuesForAppSourceDataTableQueryVariables) => ['GetTotalBucketValuesForAppSourceDataTable.infinite', variables];
;

useGetTotalBucketValuesForAppSourceDataTableQuery.fetcher = (variables: GetTotalBucketValuesForAppSourceDataTableQueryVariables) => fetcher<GetTotalBucketValuesForAppSourceDataTableQuery, GetTotalBucketValuesForAppSourceDataTableQueryVariables>(GetTotalBucketValuesForAppSourceDataTableDocument, variables);
export const GetConversionReportSankeyDataDocument = `
    query GetConversionReportSankeyData($id: ID!) {
  getConversionReportSankeyData(id: $id) {
    id
    reportTitle
    totalCandidates
    offerAcceptedYieldRate
    offerRejectedYieldRate
    selectedJobs {
      id
      title
    }
    sankey {
      order
      node {
        title
        count
        color
      }
      link {
        source
        target
        count
      }
    }
    differingPipelineBuckets
  }
}
    `;
export const useGetConversionReportSankeyDataQuery = <
      TData = GetConversionReportSankeyDataQuery,
      TError = unknown
    >(
      variables: GetConversionReportSankeyDataQueryVariables,
      options?: UseQueryOptions<GetConversionReportSankeyDataQuery, TError, TData>
    ) =>
    useQuery<GetConversionReportSankeyDataQuery, TError, TData>(
      ['GetConversionReportSankeyData', variables],
      fetcher<GetConversionReportSankeyDataQuery, GetConversionReportSankeyDataQueryVariables>(GetConversionReportSankeyDataDocument, variables),
      options
    );

useGetConversionReportSankeyDataQuery.getKey = (variables: GetConversionReportSankeyDataQueryVariables) => ['GetConversionReportSankeyData', variables];
;

export const useInfiniteGetConversionReportSankeyDataQuery = <
      TData = GetConversionReportSankeyDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetConversionReportSankeyDataQueryVariables,
      variables: GetConversionReportSankeyDataQueryVariables,
      options?: UseInfiniteQueryOptions<GetConversionReportSankeyDataQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetConversionReportSankeyDataQuery, TError, TData>(
      ['GetConversionReportSankeyData.infinite', variables],
      (metaData) => fetcher<GetConversionReportSankeyDataQuery, GetConversionReportSankeyDataQueryVariables>(GetConversionReportSankeyDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetConversionReportSankeyDataQuery.getKey = (variables: GetConversionReportSankeyDataQueryVariables) => ['GetConversionReportSankeyData.infinite', variables];
;

useGetConversionReportSankeyDataQuery.fetcher = (variables: GetConversionReportSankeyDataQueryVariables) => fetcher<GetConversionReportSankeyDataQuery, GetConversionReportSankeyDataQueryVariables>(GetConversionReportSankeyDataDocument, variables);
export const GetConversionReportDataTableDocument = `
    query GetConversionReportDataTable($id: ID!) {
  getConversionReportDataTable(id: $id) {
    id
    lawSchoolValues {
      id
      lawSchoolName
      applied {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      screening {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      interviewing {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      offer {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      hired {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      rejected {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      declined {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      withdrew {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      cancelled {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
    }
    sourceValues {
      id
      appSourceName
      applied {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      screening {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      interviewing {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      offer {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      hired {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      rejected {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      declined {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      withdrew {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
      cancelled {
        nodes {
          id
          firstName
          lastName
          email
          appSource
          lawSchool
          jobId
          title
          status
        }
        totalCount
      }
    }
  }
}
    `;
export const useGetConversionReportDataTableQuery = <
      TData = GetConversionReportDataTableQuery,
      TError = unknown
    >(
      variables: GetConversionReportDataTableQueryVariables,
      options?: UseQueryOptions<GetConversionReportDataTableQuery, TError, TData>
    ) =>
    useQuery<GetConversionReportDataTableQuery, TError, TData>(
      ['GetConversionReportDataTable', variables],
      fetcher<GetConversionReportDataTableQuery, GetConversionReportDataTableQueryVariables>(GetConversionReportDataTableDocument, variables),
      options
    );

useGetConversionReportDataTableQuery.getKey = (variables: GetConversionReportDataTableQueryVariables) => ['GetConversionReportDataTable', variables];
;

export const useInfiniteGetConversionReportDataTableQuery = <
      TData = GetConversionReportDataTableQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetConversionReportDataTableQueryVariables,
      variables: GetConversionReportDataTableQueryVariables,
      options?: UseInfiniteQueryOptions<GetConversionReportDataTableQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetConversionReportDataTableQuery, TError, TData>(
      ['GetConversionReportDataTable.infinite', variables],
      (metaData) => fetcher<GetConversionReportDataTableQuery, GetConversionReportDataTableQueryVariables>(GetConversionReportDataTableDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetConversionReportDataTableQuery.getKey = (variables: GetConversionReportDataTableQueryVariables) => ['GetConversionReportDataTable.infinite', variables];
;

useGetConversionReportDataTableQuery.fetcher = (variables: GetConversionReportDataTableQueryVariables) => fetcher<GetConversionReportDataTableQuery, GetConversionReportDataTableQueryVariables>(GetConversionReportDataTableDocument, variables);
export const GetConversionReportCandidatesDocument = `
    query GetConversionReportCandidates($id: ID!, $first: Int, $after: String, $filterBy: ConversionReportFilterBy) {
  getConversionReportCandidates(
    id: $id
    first: $first
    after: $after
    filterBy: $filterBy
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      firstName
      lastName
      email
      appSource
      lawSchool
      jobId
      title
    }
    totalCount
  }
}
    `;
export const useGetConversionReportCandidatesQuery = <
      TData = GetConversionReportCandidatesQuery,
      TError = unknown
    >(
      variables: GetConversionReportCandidatesQueryVariables,
      options?: UseQueryOptions<GetConversionReportCandidatesQuery, TError, TData>
    ) =>
    useQuery<GetConversionReportCandidatesQuery, TError, TData>(
      ['GetConversionReportCandidates', variables],
      fetcher<GetConversionReportCandidatesQuery, GetConversionReportCandidatesQueryVariables>(GetConversionReportCandidatesDocument, variables),
      options
    );

useGetConversionReportCandidatesQuery.getKey = (variables: GetConversionReportCandidatesQueryVariables) => ['GetConversionReportCandidates', variables];
;

export const useInfiniteGetConversionReportCandidatesQuery = <
      TData = GetConversionReportCandidatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetConversionReportCandidatesQueryVariables,
      variables: GetConversionReportCandidatesQueryVariables,
      options?: UseInfiniteQueryOptions<GetConversionReportCandidatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetConversionReportCandidatesQuery, TError, TData>(
      ['GetConversionReportCandidates.infinite', variables],
      (metaData) => fetcher<GetConversionReportCandidatesQuery, GetConversionReportCandidatesQueryVariables>(GetConversionReportCandidatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetConversionReportCandidatesQuery.getKey = (variables: GetConversionReportCandidatesQueryVariables) => ['GetConversionReportCandidates.infinite', variables];
;

useGetConversionReportCandidatesQuery.fetcher = (variables: GetConversionReportCandidatesQueryVariables) => fetcher<GetConversionReportCandidatesQuery, GetConversionReportCandidatesQueryVariables>(GetConversionReportCandidatesDocument, variables);
export const GetTotalLawSchoolCandidatesByBucketDocument = `
    query GetTotalLawSchoolCandidatesByBucket($id: ID!, $bucket: String!, $first: Int, $after: String) {
  getTotalLawSchoolCandidatesByBucket(
    id: $id
    bucket: $bucket
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      firstName
      lastName
      email
      appSource
      lawSchool
      jobId
      title
      status
    }
    totalCount
  }
}
    `;
export const useGetTotalLawSchoolCandidatesByBucketQuery = <
      TData = GetTotalLawSchoolCandidatesByBucketQuery,
      TError = unknown
    >(
      variables: GetTotalLawSchoolCandidatesByBucketQueryVariables,
      options?: UseQueryOptions<GetTotalLawSchoolCandidatesByBucketQuery, TError, TData>
    ) =>
    useQuery<GetTotalLawSchoolCandidatesByBucketQuery, TError, TData>(
      ['GetTotalLawSchoolCandidatesByBucket', variables],
      fetcher<GetTotalLawSchoolCandidatesByBucketQuery, GetTotalLawSchoolCandidatesByBucketQueryVariables>(GetTotalLawSchoolCandidatesByBucketDocument, variables),
      options
    );

useGetTotalLawSchoolCandidatesByBucketQuery.getKey = (variables: GetTotalLawSchoolCandidatesByBucketQueryVariables) => ['GetTotalLawSchoolCandidatesByBucket', variables];
;

export const useInfiniteGetTotalLawSchoolCandidatesByBucketQuery = <
      TData = GetTotalLawSchoolCandidatesByBucketQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetTotalLawSchoolCandidatesByBucketQueryVariables,
      variables: GetTotalLawSchoolCandidatesByBucketQueryVariables,
      options?: UseInfiniteQueryOptions<GetTotalLawSchoolCandidatesByBucketQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetTotalLawSchoolCandidatesByBucketQuery, TError, TData>(
      ['GetTotalLawSchoolCandidatesByBucket.infinite', variables],
      (metaData) => fetcher<GetTotalLawSchoolCandidatesByBucketQuery, GetTotalLawSchoolCandidatesByBucketQueryVariables>(GetTotalLawSchoolCandidatesByBucketDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetTotalLawSchoolCandidatesByBucketQuery.getKey = (variables: GetTotalLawSchoolCandidatesByBucketQueryVariables) => ['GetTotalLawSchoolCandidatesByBucket.infinite', variables];
;

useGetTotalLawSchoolCandidatesByBucketQuery.fetcher = (variables: GetTotalLawSchoolCandidatesByBucketQueryVariables) => fetcher<GetTotalLawSchoolCandidatesByBucketQuery, GetTotalLawSchoolCandidatesByBucketQueryVariables>(GetTotalLawSchoolCandidatesByBucketDocument, variables);
export const GetTotalAppSourceCandidatesByBucketDocument = `
    query GetTotalAppSourceCandidatesByBucket($id: ID!, $bucket: String!, $first: Int, $after: String) {
  getTotalAppSourceCandidatesByBucket(
    id: $id
    bucket: $bucket
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      firstName
      lastName
      email
      appSource
      lawSchool
      jobId
      title
      status
    }
    totalCount
  }
}
    `;
export const useGetTotalAppSourceCandidatesByBucketQuery = <
      TData = GetTotalAppSourceCandidatesByBucketQuery,
      TError = unknown
    >(
      variables: GetTotalAppSourceCandidatesByBucketQueryVariables,
      options?: UseQueryOptions<GetTotalAppSourceCandidatesByBucketQuery, TError, TData>
    ) =>
    useQuery<GetTotalAppSourceCandidatesByBucketQuery, TError, TData>(
      ['GetTotalAppSourceCandidatesByBucket', variables],
      fetcher<GetTotalAppSourceCandidatesByBucketQuery, GetTotalAppSourceCandidatesByBucketQueryVariables>(GetTotalAppSourceCandidatesByBucketDocument, variables),
      options
    );

useGetTotalAppSourceCandidatesByBucketQuery.getKey = (variables: GetTotalAppSourceCandidatesByBucketQueryVariables) => ['GetTotalAppSourceCandidatesByBucket', variables];
;

export const useInfiniteGetTotalAppSourceCandidatesByBucketQuery = <
      TData = GetTotalAppSourceCandidatesByBucketQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetTotalAppSourceCandidatesByBucketQueryVariables,
      variables: GetTotalAppSourceCandidatesByBucketQueryVariables,
      options?: UseInfiniteQueryOptions<GetTotalAppSourceCandidatesByBucketQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetTotalAppSourceCandidatesByBucketQuery, TError, TData>(
      ['GetTotalAppSourceCandidatesByBucket.infinite', variables],
      (metaData) => fetcher<GetTotalAppSourceCandidatesByBucketQuery, GetTotalAppSourceCandidatesByBucketQueryVariables>(GetTotalAppSourceCandidatesByBucketDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetTotalAppSourceCandidatesByBucketQuery.getKey = (variables: GetTotalAppSourceCandidatesByBucketQueryVariables) => ['GetTotalAppSourceCandidatesByBucket.infinite', variables];
;

useGetTotalAppSourceCandidatesByBucketQuery.fetcher = (variables: GetTotalAppSourceCandidatesByBucketQueryVariables) => fetcher<GetTotalAppSourceCandidatesByBucketQuery, GetTotalAppSourceCandidatesByBucketQueryVariables>(GetTotalAppSourceCandidatesByBucketDocument, variables);
export const GetCandidatesForCandidateDataTableDocument = `
    query GetCandidatesForCandidateDataTable($id: ID!, $bucket: String!, $targetBucket: String, $first: Int, $after: String) {
  getCandidatesForCandidateDataTable(
    id: $id
    bucket: $bucket
    targetBucket: $targetBucket
    first: $first
    after: $after
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      id
      firstName
      lastName
      email
      appSource
      lawSchool
      jobId
      title
      status
    }
    totalCount
  }
}
    `;
export const useGetCandidatesForCandidateDataTableQuery = <
      TData = GetCandidatesForCandidateDataTableQuery,
      TError = unknown
    >(
      variables: GetCandidatesForCandidateDataTableQueryVariables,
      options?: UseQueryOptions<GetCandidatesForCandidateDataTableQuery, TError, TData>
    ) =>
    useQuery<GetCandidatesForCandidateDataTableQuery, TError, TData>(
      ['GetCandidatesForCandidateDataTable', variables],
      fetcher<GetCandidatesForCandidateDataTableQuery, GetCandidatesForCandidateDataTableQueryVariables>(GetCandidatesForCandidateDataTableDocument, variables),
      options
    );

useGetCandidatesForCandidateDataTableQuery.getKey = (variables: GetCandidatesForCandidateDataTableQueryVariables) => ['GetCandidatesForCandidateDataTable', variables];
;

export const useInfiniteGetCandidatesForCandidateDataTableQuery = <
      TData = GetCandidatesForCandidateDataTableQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidatesForCandidateDataTableQueryVariables,
      variables: GetCandidatesForCandidateDataTableQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidatesForCandidateDataTableQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidatesForCandidateDataTableQuery, TError, TData>(
      ['GetCandidatesForCandidateDataTable.infinite', variables],
      (metaData) => fetcher<GetCandidatesForCandidateDataTableQuery, GetCandidatesForCandidateDataTableQueryVariables>(GetCandidatesForCandidateDataTableDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidatesForCandidateDataTableQuery.getKey = (variables: GetCandidatesForCandidateDataTableQueryVariables) => ['GetCandidatesForCandidateDataTable.infinite', variables];
;

useGetCandidatesForCandidateDataTableQuery.fetcher = (variables: GetCandidatesForCandidateDataTableQueryVariables) => fetcher<GetCandidatesForCandidateDataTableQuery, GetCandidatesForCandidateDataTableQueryVariables>(GetCandidatesForCandidateDataTableDocument, variables);
export const UpdateJobAppOfferDetailsDocument = `
    mutation UpdateJobAppOfferDetails($jobAppId: Int, $input: OfferDetailsInput!) {
  updateJobAppOfferDetails(jobAppId: $jobAppId, offerDetails: $input) {
    id
    offerDate
    offerExpirationDate
    offerAffirmationDate
  }
}
    `;
export const useUpdateJobAppOfferDetailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateJobAppOfferDetailsMutation, TError, UpdateJobAppOfferDetailsMutationVariables, TContext>) =>
    useMutation<UpdateJobAppOfferDetailsMutation, TError, UpdateJobAppOfferDetailsMutationVariables, TContext>(
      ['UpdateJobAppOfferDetails'],
      (variables?: UpdateJobAppOfferDetailsMutationVariables) => fetcher<UpdateJobAppOfferDetailsMutation, UpdateJobAppOfferDetailsMutationVariables>(UpdateJobAppOfferDetailsDocument, variables)(),
      options
    );
useUpdateJobAppOfferDetailsMutation.fetcher = (variables: UpdateJobAppOfferDetailsMutationVariables) => fetcher<UpdateJobAppOfferDetailsMutation, UpdateJobAppOfferDetailsMutationVariables>(UpdateJobAppOfferDetailsDocument, variables);
export const MigrateOrgToGovernmentContractorDocument = `
    mutation MigrateOrgToGovernmentContractor {
  migrateOrgToGovernmentContractor
}
    `;
export const useMigrateOrgToGovernmentContractorMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MigrateOrgToGovernmentContractorMutation, TError, MigrateOrgToGovernmentContractorMutationVariables, TContext>) =>
    useMutation<MigrateOrgToGovernmentContractorMutation, TError, MigrateOrgToGovernmentContractorMutationVariables, TContext>(
      ['MigrateOrgToGovernmentContractor'],
      (variables?: MigrateOrgToGovernmentContractorMutationVariables) => fetcher<MigrateOrgToGovernmentContractorMutation, MigrateOrgToGovernmentContractorMutationVariables>(MigrateOrgToGovernmentContractorDocument, variables)(),
      options
    );
useMigrateOrgToGovernmentContractorMutation.fetcher = (variables?: MigrateOrgToGovernmentContractorMutationVariables) => fetcher<MigrateOrgToGovernmentContractorMutation, MigrateOrgToGovernmentContractorMutationVariables>(MigrateOrgToGovernmentContractorDocument, variables);
export const JobWithTitleDocument = `
    query JobWithTitle($jobId: Int) {
  job(jobId: $jobId) {
    title
    closeDate
  }
}
    `;
export const useJobWithTitleQuery = <
      TData = JobWithTitleQuery,
      TError = unknown
    >(
      variables?: JobWithTitleQueryVariables,
      options?: UseQueryOptions<JobWithTitleQuery, TError, TData>
    ) =>
    useQuery<JobWithTitleQuery, TError, TData>(
      variables === undefined ? ['JobWithTitle'] : ['JobWithTitle', variables],
      fetcher<JobWithTitleQuery, JobWithTitleQueryVariables>(JobWithTitleDocument, variables),
      options
    );

useJobWithTitleQuery.getKey = (variables?: JobWithTitleQueryVariables) => variables === undefined ? ['JobWithTitle'] : ['JobWithTitle', variables];
;

export const useInfiniteJobWithTitleQuery = <
      TData = JobWithTitleQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobWithTitleQueryVariables,
      variables?: JobWithTitleQueryVariables,
      options?: UseInfiniteQueryOptions<JobWithTitleQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobWithTitleQuery, TError, TData>(
      variables === undefined ? ['JobWithTitle.infinite'] : ['JobWithTitle.infinite', variables],
      (metaData) => fetcher<JobWithTitleQuery, JobWithTitleQueryVariables>(JobWithTitleDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobWithTitleQuery.getKey = (variables?: JobWithTitleQueryVariables) => variables === undefined ? ['JobWithTitle.infinite'] : ['JobWithTitle.infinite', variables];
;

useJobWithTitleQuery.fetcher = (variables?: JobWithTitleQueryVariables) => fetcher<JobWithTitleQuery, JobWithTitleQueryVariables>(JobWithTitleDocument, variables);
export const OrgJobSchemasDocument = `
    query OrgJobSchemas {
  jobs {
    id
    jobSchema {
      id
      name
      jobSectionType
      jobQuestions {
        id
        orgQuestionId
        label
        subText
        questionType
        isDeleted
        isRequired
        order
        jobQuestionOptions {
          id
          option
          isDeleted
        }
      }
    }
  }
}
    `;
export const useOrgJobSchemasQuery = <
      TData = OrgJobSchemasQuery,
      TError = unknown
    >(
      variables?: OrgJobSchemasQueryVariables,
      options?: UseQueryOptions<OrgJobSchemasQuery, TError, TData>
    ) =>
    useQuery<OrgJobSchemasQuery, TError, TData>(
      variables === undefined ? ['OrgJobSchemas'] : ['OrgJobSchemas', variables],
      fetcher<OrgJobSchemasQuery, OrgJobSchemasQueryVariables>(OrgJobSchemasDocument, variables),
      options
    );

useOrgJobSchemasQuery.getKey = (variables?: OrgJobSchemasQueryVariables) => variables === undefined ? ['OrgJobSchemas'] : ['OrgJobSchemas', variables];
;

export const useInfiniteOrgJobSchemasQuery = <
      TData = OrgJobSchemasQuery,
      TError = unknown
    >(
      pageParamKey: keyof OrgJobSchemasQueryVariables,
      variables?: OrgJobSchemasQueryVariables,
      options?: UseInfiniteQueryOptions<OrgJobSchemasQuery, TError, TData>
    ) =>
    useInfiniteQuery<OrgJobSchemasQuery, TError, TData>(
      variables === undefined ? ['OrgJobSchemas.infinite'] : ['OrgJobSchemas.infinite', variables],
      (metaData) => fetcher<OrgJobSchemasQuery, OrgJobSchemasQueryVariables>(OrgJobSchemasDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteOrgJobSchemasQuery.getKey = (variables?: OrgJobSchemasQueryVariables) => variables === undefined ? ['OrgJobSchemas.infinite'] : ['OrgJobSchemas.infinite', variables];
;

useOrgJobSchemasQuery.fetcher = (variables?: OrgJobSchemasQueryVariables) => fetcher<OrgJobSchemasQuery, OrgJobSchemasQueryVariables>(OrgJobSchemasDocument, variables);
export const JobSectionsAndQuestionsDocument = `
    query JobSectionsAndQuestions($jobIds: [Int!]!) {
  jobsFromIds(jobIds: $jobIds) {
    id
    title
    jobSchema {
      id
      name
      jobSectionType
      order
      jobQuestions {
        id
        orgQuestionId
        label
        subText
        questionType
        isDeleted
        isRequired
        order
      }
    }
  }
}
    `;
export const useJobSectionsAndQuestionsQuery = <
      TData = JobSectionsAndQuestionsQuery,
      TError = unknown
    >(
      variables: JobSectionsAndQuestionsQueryVariables,
      options?: UseQueryOptions<JobSectionsAndQuestionsQuery, TError, TData>
    ) =>
    useQuery<JobSectionsAndQuestionsQuery, TError, TData>(
      ['JobSectionsAndQuestions', variables],
      fetcher<JobSectionsAndQuestionsQuery, JobSectionsAndQuestionsQueryVariables>(JobSectionsAndQuestionsDocument, variables),
      options
    );

useJobSectionsAndQuestionsQuery.getKey = (variables: JobSectionsAndQuestionsQueryVariables) => ['JobSectionsAndQuestions', variables];
;

export const useInfiniteJobSectionsAndQuestionsQuery = <
      TData = JobSectionsAndQuestionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobSectionsAndQuestionsQueryVariables,
      variables: JobSectionsAndQuestionsQueryVariables,
      options?: UseInfiniteQueryOptions<JobSectionsAndQuestionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobSectionsAndQuestionsQuery, TError, TData>(
      ['JobSectionsAndQuestions.infinite', variables],
      (metaData) => fetcher<JobSectionsAndQuestionsQuery, JobSectionsAndQuestionsQueryVariables>(JobSectionsAndQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobSectionsAndQuestionsQuery.getKey = (variables: JobSectionsAndQuestionsQueryVariables) => ['JobSectionsAndQuestions.infinite', variables];
;

useJobSectionsAndQuestionsQuery.fetcher = (variables: JobSectionsAndQuestionsQueryVariables) => fetcher<JobSectionsAndQuestionsQuery, JobSectionsAndQuestionsQueryVariables>(JobSectionsAndQuestionsDocument, variables);
export const PublicJobDocument = `
    query PublicJob($jobExtension: String, $orgFriendlyName: String) {
  publicJob(jobExtension: $jobExtension, orgFriendlyName: $orgFriendlyName) {
    jobSections {
      id
      name
      jobSectionType
      description
      order
      isRequired
      jobCandidateDocuments {
        id
        docName
        jobSectionId
        isRequired
        orgDocId
        isDeleted
      }
      jobQuestions {
        id
        orgQuestionId
        label
        order
        subText
        questionType
        isRequired
        jobQuestionOptions {
          edges {
            node {
              id
              option
              orgQuestionOptionId
              jobQuestionId
            }
          }
        }
      }
    }
  }
}
    `;
export const usePublicJobQuery = <
      TData = PublicJobQuery,
      TError = unknown
    >(
      variables?: PublicJobQueryVariables,
      options?: UseQueryOptions<PublicJobQuery, TError, TData>
    ) =>
    useQuery<PublicJobQuery, TError, TData>(
      variables === undefined ? ['PublicJob'] : ['PublicJob', variables],
      fetcher<PublicJobQuery, PublicJobQueryVariables>(PublicJobDocument, variables),
      options
    );

usePublicJobQuery.getKey = (variables?: PublicJobQueryVariables) => variables === undefined ? ['PublicJob'] : ['PublicJob', variables];
;

export const useInfinitePublicJobQuery = <
      TData = PublicJobQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicJobQueryVariables,
      variables?: PublicJobQueryVariables,
      options?: UseInfiniteQueryOptions<PublicJobQuery, TError, TData>
    ) =>
    useInfiniteQuery<PublicJobQuery, TError, TData>(
      variables === undefined ? ['PublicJob.infinite'] : ['PublicJob.infinite', variables],
      (metaData) => fetcher<PublicJobQuery, PublicJobQueryVariables>(PublicJobDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePublicJobQuery.getKey = (variables?: PublicJobQueryVariables) => variables === undefined ? ['PublicJob.infinite'] : ['PublicJob.infinite', variables];
;

usePublicJobQuery.fetcher = (variables?: PublicJobQueryVariables) => fetcher<PublicJobQuery, PublicJobQueryVariables>(PublicJobDocument, variables);
export const CandidateOrgJobAppOverviewsDocument = `
    query CandidateOrgJobAppOverviews($orgFriendlyName: String) {
  publicCandidateOrgJobApps(orgFriendlyName: $orgFriendlyName) {
    id
    jobId
    createdAt
    isComplete
    creationType
  }
}
    `;
export const useCandidateOrgJobAppOverviewsQuery = <
      TData = CandidateOrgJobAppOverviewsQuery,
      TError = unknown
    >(
      variables?: CandidateOrgJobAppOverviewsQueryVariables,
      options?: UseQueryOptions<CandidateOrgJobAppOverviewsQuery, TError, TData>
    ) =>
    useQuery<CandidateOrgJobAppOverviewsQuery, TError, TData>(
      variables === undefined ? ['CandidateOrgJobAppOverviews'] : ['CandidateOrgJobAppOverviews', variables],
      fetcher<CandidateOrgJobAppOverviewsQuery, CandidateOrgJobAppOverviewsQueryVariables>(CandidateOrgJobAppOverviewsDocument, variables),
      options
    );

useCandidateOrgJobAppOverviewsQuery.getKey = (variables?: CandidateOrgJobAppOverviewsQueryVariables) => variables === undefined ? ['CandidateOrgJobAppOverviews'] : ['CandidateOrgJobAppOverviews', variables];
;

export const useInfiniteCandidateOrgJobAppOverviewsQuery = <
      TData = CandidateOrgJobAppOverviewsQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateOrgJobAppOverviewsQueryVariables,
      variables?: CandidateOrgJobAppOverviewsQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateOrgJobAppOverviewsQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateOrgJobAppOverviewsQuery, TError, TData>(
      variables === undefined ? ['CandidateOrgJobAppOverviews.infinite'] : ['CandidateOrgJobAppOverviews.infinite', variables],
      (metaData) => fetcher<CandidateOrgJobAppOverviewsQuery, CandidateOrgJobAppOverviewsQueryVariables>(CandidateOrgJobAppOverviewsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateOrgJobAppOverviewsQuery.getKey = (variables?: CandidateOrgJobAppOverviewsQueryVariables) => variables === undefined ? ['CandidateOrgJobAppOverviews.infinite'] : ['CandidateOrgJobAppOverviews.infinite', variables];
;

useCandidateOrgJobAppOverviewsQuery.fetcher = (variables?: CandidateOrgJobAppOverviewsQueryVariables) => fetcher<CandidateOrgJobAppOverviewsQuery, CandidateOrgJobAppOverviewsQueryVariables>(CandidateOrgJobAppOverviewsDocument, variables);
export const PublicJobAppDocument = `
    query PublicJobApp($orgFriendlyName: String, $jobExtension: String) {
  publicCandidateJobApp(
    orgFriendlyName: $orgFriendlyName
    jobExtension: $jobExtension
  ) {
    addressLineOne
    addressLineTwo
    city
    state
    country
    zipCode
    isComplete
    creationType
    recruitId
    missingInfoRequestToCandidate
    missingInfoRequestToAgencyContact
    workHistory {
      id
      employer
      position
      startDate
      endDate
      isCurrentEmployer
    }
    educationHistory {
      id
      university
      degreeEnum
      startDate
      endDate
    }
    jobAppDocuments {
      orgDocId
      documentName
      orgCustomDocName
      createdAt
      location
    }
    answers {
      id
      label
      subText
      questionType
      dateValue
      numericValue
      textValue
      orgQuestionId
      jobAppQuestionAnswerSelections {
        edges {
          node {
            id
            orgQuestionOptionId
            jobAppQuestionAnswerId
            option
          }
        }
      }
      options {
        orgQuestionId
        option
        order
        isDeleted
      }
    }
    selfIdAnswers {
      id
      orgSelfIdQuestionId
      jobAppSelfIdQuestionAnswerSelections {
        id
        orgSelfIdQuestionOptionId
      }
    }
  }
}
    `;
export const usePublicJobAppQuery = <
      TData = PublicJobAppQuery,
      TError = unknown
    >(
      variables?: PublicJobAppQueryVariables,
      options?: UseQueryOptions<PublicJobAppQuery, TError, TData>
    ) =>
    useQuery<PublicJobAppQuery, TError, TData>(
      variables === undefined ? ['PublicJobApp'] : ['PublicJobApp', variables],
      fetcher<PublicJobAppQuery, PublicJobAppQueryVariables>(PublicJobAppDocument, variables),
      options
    );

usePublicJobAppQuery.getKey = (variables?: PublicJobAppQueryVariables) => variables === undefined ? ['PublicJobApp'] : ['PublicJobApp', variables];
;

export const useInfinitePublicJobAppQuery = <
      TData = PublicJobAppQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicJobAppQueryVariables,
      variables?: PublicJobAppQueryVariables,
      options?: UseInfiniteQueryOptions<PublicJobAppQuery, TError, TData>
    ) =>
    useInfiniteQuery<PublicJobAppQuery, TError, TData>(
      variables === undefined ? ['PublicJobApp.infinite'] : ['PublicJobApp.infinite', variables],
      (metaData) => fetcher<PublicJobAppQuery, PublicJobAppQueryVariables>(PublicJobAppDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePublicJobAppQuery.getKey = (variables?: PublicJobAppQueryVariables) => variables === undefined ? ['PublicJobApp.infinite'] : ['PublicJobApp.infinite', variables];
;

usePublicJobAppQuery.fetcher = (variables?: PublicJobAppQueryVariables) => fetcher<PublicJobAppQuery, PublicJobAppQueryVariables>(PublicJobAppDocument, variables);
export const PublicJobAppAgencyViewDocument = `
    query PublicJobAppAgencyView($orgFriendlyName: String, $jobExtension: String, $recruitId: Int) {
  publicCandidateJobAppOfRecruit(
    orgFriendlyName: $orgFriendlyName
    jobExtension: $jobExtension
    recruitId: $recruitId
  ) {
    addressLineOne
    addressLineTwo
    city
    state
    country
    zipCode
    isComplete
    creationType
    recruitId
    missingInfoRequestToCandidate
    missingInfoRequestToAgencyContact
    workHistory {
      id
      employer
      position
      startDate
      endDate
      isCurrentEmployer
    }
    educationHistory {
      id
      university
      degreeEnum
      startDate
      endDate
    }
    jobAppDocuments {
      orgDocId
      documentName
      orgCustomDocName
      createdAt
      location
    }
    answers {
      id
      label
      subText
      questionType
      dateValue
      numericValue
      textValue
      orgQuestionId
      jobAppQuestionAnswerSelections {
        edges {
          node {
            id
            orgQuestionOptionId
            jobAppQuestionAnswerId
            option
          }
        }
      }
      options {
        orgQuestionId
        option
        order
        isDeleted
      }
    }
    selfIdAnswers {
      id
      orgSelfIdQuestionId
      jobAppSelfIdQuestionAnswerSelections {
        id
        orgSelfIdQuestionOptionId
      }
    }
  }
}
    `;
export const usePublicJobAppAgencyViewQuery = <
      TData = PublicJobAppAgencyViewQuery,
      TError = unknown
    >(
      variables?: PublicJobAppAgencyViewQueryVariables,
      options?: UseQueryOptions<PublicJobAppAgencyViewQuery, TError, TData>
    ) =>
    useQuery<PublicJobAppAgencyViewQuery, TError, TData>(
      variables === undefined ? ['PublicJobAppAgencyView'] : ['PublicJobAppAgencyView', variables],
      fetcher<PublicJobAppAgencyViewQuery, PublicJobAppAgencyViewQueryVariables>(PublicJobAppAgencyViewDocument, variables),
      options
    );

usePublicJobAppAgencyViewQuery.getKey = (variables?: PublicJobAppAgencyViewQueryVariables) => variables === undefined ? ['PublicJobAppAgencyView'] : ['PublicJobAppAgencyView', variables];
;

export const useInfinitePublicJobAppAgencyViewQuery = <
      TData = PublicJobAppAgencyViewQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicJobAppAgencyViewQueryVariables,
      variables?: PublicJobAppAgencyViewQueryVariables,
      options?: UseInfiniteQueryOptions<PublicJobAppAgencyViewQuery, TError, TData>
    ) =>
    useInfiniteQuery<PublicJobAppAgencyViewQuery, TError, TData>(
      variables === undefined ? ['PublicJobAppAgencyView.infinite'] : ['PublicJobAppAgencyView.infinite', variables],
      (metaData) => fetcher<PublicJobAppAgencyViewQuery, PublicJobAppAgencyViewQueryVariables>(PublicJobAppAgencyViewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePublicJobAppAgencyViewQuery.getKey = (variables?: PublicJobAppAgencyViewQueryVariables) => variables === undefined ? ['PublicJobAppAgencyView.infinite'] : ['PublicJobAppAgencyView.infinite', variables];
;

usePublicJobAppAgencyViewQuery.fetcher = (variables?: PublicJobAppAgencyViewQueryVariables) => fetcher<PublicJobAppAgencyViewQuery, PublicJobAppAgencyViewQueryVariables>(PublicJobAppAgencyViewDocument, variables);
export const PublicJobOverviewDocument = `
    query PublicJobOverview($jobExtension: String, $orgFriendlyName: String) {
  publicJob(jobExtension: $jobExtension, orgFriendlyName: $orgFriendlyName) {
    id
    orgId
    title
  }
}
    `;
export const usePublicJobOverviewQuery = <
      TData = PublicJobOverviewQuery,
      TError = unknown
    >(
      variables?: PublicJobOverviewQueryVariables,
      options?: UseQueryOptions<PublicJobOverviewQuery, TError, TData>
    ) =>
    useQuery<PublicJobOverviewQuery, TError, TData>(
      variables === undefined ? ['PublicJobOverview'] : ['PublicJobOverview', variables],
      fetcher<PublicJobOverviewQuery, PublicJobOverviewQueryVariables>(PublicJobOverviewDocument, variables),
      options
    );

usePublicJobOverviewQuery.getKey = (variables?: PublicJobOverviewQueryVariables) => variables === undefined ? ['PublicJobOverview'] : ['PublicJobOverview', variables];
;

export const useInfinitePublicJobOverviewQuery = <
      TData = PublicJobOverviewQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicJobOverviewQueryVariables,
      variables?: PublicJobOverviewQueryVariables,
      options?: UseInfiniteQueryOptions<PublicJobOverviewQuery, TError, TData>
    ) =>
    useInfiniteQuery<PublicJobOverviewQuery, TError, TData>(
      variables === undefined ? ['PublicJobOverview.infinite'] : ['PublicJobOverview.infinite', variables],
      (metaData) => fetcher<PublicJobOverviewQuery, PublicJobOverviewQueryVariables>(PublicJobOverviewDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePublicJobOverviewQuery.getKey = (variables?: PublicJobOverviewQueryVariables) => variables === undefined ? ['PublicJobOverview.infinite'] : ['PublicJobOverview.infinite', variables];
;

usePublicJobOverviewQuery.fetcher = (variables?: PublicJobOverviewQueryVariables) => fetcher<PublicJobOverviewQuery, PublicJobOverviewQueryVariables>(PublicJobOverviewDocument, variables);
export const AppSourceOptionsDocument = `
    query AppSourceOptions {
  fetchAppSourceOptions {
    name
    label
  }
}
    `;
export const useAppSourceOptionsQuery = <
      TData = AppSourceOptionsQuery,
      TError = unknown
    >(
      variables?: AppSourceOptionsQueryVariables,
      options?: UseQueryOptions<AppSourceOptionsQuery, TError, TData>
    ) =>
    useQuery<AppSourceOptionsQuery, TError, TData>(
      variables === undefined ? ['AppSourceOptions'] : ['AppSourceOptions', variables],
      fetcher<AppSourceOptionsQuery, AppSourceOptionsQueryVariables>(AppSourceOptionsDocument, variables),
      options
    );

useAppSourceOptionsQuery.getKey = (variables?: AppSourceOptionsQueryVariables) => variables === undefined ? ['AppSourceOptions'] : ['AppSourceOptions', variables];
;

export const useInfiniteAppSourceOptionsQuery = <
      TData = AppSourceOptionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof AppSourceOptionsQueryVariables,
      variables?: AppSourceOptionsQueryVariables,
      options?: UseInfiniteQueryOptions<AppSourceOptionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<AppSourceOptionsQuery, TError, TData>(
      variables === undefined ? ['AppSourceOptions.infinite'] : ['AppSourceOptions.infinite', variables],
      (metaData) => fetcher<AppSourceOptionsQuery, AppSourceOptionsQueryVariables>(AppSourceOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAppSourceOptionsQuery.getKey = (variables?: AppSourceOptionsQueryVariables) => variables === undefined ? ['AppSourceOptions.infinite'] : ['AppSourceOptions.infinite', variables];
;

useAppSourceOptionsQuery.fetcher = (variables?: AppSourceOptionsQueryVariables) => fetcher<AppSourceOptionsQuery, AppSourceOptionsQueryVariables>(AppSourceOptionsDocument, variables);
export const OrgSelfIdQuestionsDocument = `
    query OrgSelfIdQuestions($orgFriendlyName: String) {
  orgSelfIdQuestions(orgFriendlyName: $orgFriendlyName) {
    id
    label
    name
    description
    selfIdDefaultId
    enabled
    selfIdType
    isGovernment
    questionType
    orgSelfIdQuestionOptions {
      id
      name
      deletedAt
    }
  }
}
    `;
export const useOrgSelfIdQuestionsQuery = <
      TData = OrgSelfIdQuestionsQuery,
      TError = unknown
    >(
      variables?: OrgSelfIdQuestionsQueryVariables,
      options?: UseQueryOptions<OrgSelfIdQuestionsQuery, TError, TData>
    ) =>
    useQuery<OrgSelfIdQuestionsQuery, TError, TData>(
      variables === undefined ? ['OrgSelfIdQuestions'] : ['OrgSelfIdQuestions', variables],
      fetcher<OrgSelfIdQuestionsQuery, OrgSelfIdQuestionsQueryVariables>(OrgSelfIdQuestionsDocument, variables),
      options
    );

useOrgSelfIdQuestionsQuery.getKey = (variables?: OrgSelfIdQuestionsQueryVariables) => variables === undefined ? ['OrgSelfIdQuestions'] : ['OrgSelfIdQuestions', variables];
;

export const useInfiniteOrgSelfIdQuestionsQuery = <
      TData = OrgSelfIdQuestionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof OrgSelfIdQuestionsQueryVariables,
      variables?: OrgSelfIdQuestionsQueryVariables,
      options?: UseInfiniteQueryOptions<OrgSelfIdQuestionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<OrgSelfIdQuestionsQuery, TError, TData>(
      variables === undefined ? ['OrgSelfIdQuestions.infinite'] : ['OrgSelfIdQuestions.infinite', variables],
      (metaData) => fetcher<OrgSelfIdQuestionsQuery, OrgSelfIdQuestionsQueryVariables>(OrgSelfIdQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteOrgSelfIdQuestionsQuery.getKey = (variables?: OrgSelfIdQuestionsQueryVariables) => variables === undefined ? ['OrgSelfIdQuestions.infinite'] : ['OrgSelfIdQuestions.infinite', variables];
;

useOrgSelfIdQuestionsQuery.fetcher = (variables?: OrgSelfIdQuestionsQueryVariables) => fetcher<OrgSelfIdQuestionsQuery, OrgSelfIdQuestionsQueryVariables>(OrgSelfIdQuestionsDocument, variables);
export const GetSingleOrgSelfIdQuestionDocument = `
    query GetSingleOrgSelfIdQuestion($orgFriendlyName: String, $questionId: Int) {
  orgSelfIdQuestion(orgFriendlyName: $orgFriendlyName, questionId: $questionId) {
    id
    label
    name
    description
    selfIdDefaultId
    enabled
    selfIdType
    isGovernment
    questionType
    orgSelfIdQuestionOptions {
      id
      name
    }
  }
}
    `;
export const useGetSingleOrgSelfIdQuestionQuery = <
      TData = GetSingleOrgSelfIdQuestionQuery,
      TError = unknown
    >(
      variables?: GetSingleOrgSelfIdQuestionQueryVariables,
      options?: UseQueryOptions<GetSingleOrgSelfIdQuestionQuery, TError, TData>
    ) =>
    useQuery<GetSingleOrgSelfIdQuestionQuery, TError, TData>(
      variables === undefined ? ['GetSingleOrgSelfIdQuestion'] : ['GetSingleOrgSelfIdQuestion', variables],
      fetcher<GetSingleOrgSelfIdQuestionQuery, GetSingleOrgSelfIdQuestionQueryVariables>(GetSingleOrgSelfIdQuestionDocument, variables),
      options
    );

useGetSingleOrgSelfIdQuestionQuery.getKey = (variables?: GetSingleOrgSelfIdQuestionQueryVariables) => variables === undefined ? ['GetSingleOrgSelfIdQuestion'] : ['GetSingleOrgSelfIdQuestion', variables];
;

export const useInfiniteGetSingleOrgSelfIdQuestionQuery = <
      TData = GetSingleOrgSelfIdQuestionQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSingleOrgSelfIdQuestionQueryVariables,
      variables?: GetSingleOrgSelfIdQuestionQueryVariables,
      options?: UseInfiniteQueryOptions<GetSingleOrgSelfIdQuestionQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetSingleOrgSelfIdQuestionQuery, TError, TData>(
      variables === undefined ? ['GetSingleOrgSelfIdQuestion.infinite'] : ['GetSingleOrgSelfIdQuestion.infinite', variables],
      (metaData) => fetcher<GetSingleOrgSelfIdQuestionQuery, GetSingleOrgSelfIdQuestionQueryVariables>(GetSingleOrgSelfIdQuestionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetSingleOrgSelfIdQuestionQuery.getKey = (variables?: GetSingleOrgSelfIdQuestionQueryVariables) => variables === undefined ? ['GetSingleOrgSelfIdQuestion.infinite'] : ['GetSingleOrgSelfIdQuestion.infinite', variables];
;

useGetSingleOrgSelfIdQuestionQuery.fetcher = (variables?: GetSingleOrgSelfIdQuestionQueryVariables) => fetcher<GetSingleOrgSelfIdQuestionQuery, GetSingleOrgSelfIdQuestionQueryVariables>(GetSingleOrgSelfIdQuestionDocument, variables);
export const PublicOrgSelfIdQuestionsDocument = `
    query PublicOrgSelfIdQuestions($orgFriendlyName: String) {
  publicOrgSelfIdQuestions(orgFriendlyName: $orgFriendlyName) {
    id
    label
    name
    selfIdDefaultId
    enabled
    selfIdType
    questionType
    orgSelfIdQuestionOptions {
      id
      name
      deletedAt
    }
  }
}
    `;
export const usePublicOrgSelfIdQuestionsQuery = <
      TData = PublicOrgSelfIdQuestionsQuery,
      TError = unknown
    >(
      variables?: PublicOrgSelfIdQuestionsQueryVariables,
      options?: UseQueryOptions<PublicOrgSelfIdQuestionsQuery, TError, TData>
    ) =>
    useQuery<PublicOrgSelfIdQuestionsQuery, TError, TData>(
      variables === undefined ? ['PublicOrgSelfIdQuestions'] : ['PublicOrgSelfIdQuestions', variables],
      fetcher<PublicOrgSelfIdQuestionsQuery, PublicOrgSelfIdQuestionsQueryVariables>(PublicOrgSelfIdQuestionsDocument, variables),
      options
    );

usePublicOrgSelfIdQuestionsQuery.getKey = (variables?: PublicOrgSelfIdQuestionsQueryVariables) => variables === undefined ? ['PublicOrgSelfIdQuestions'] : ['PublicOrgSelfIdQuestions', variables];
;

export const useInfinitePublicOrgSelfIdQuestionsQuery = <
      TData = PublicOrgSelfIdQuestionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicOrgSelfIdQuestionsQueryVariables,
      variables?: PublicOrgSelfIdQuestionsQueryVariables,
      options?: UseInfiniteQueryOptions<PublicOrgSelfIdQuestionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<PublicOrgSelfIdQuestionsQuery, TError, TData>(
      variables === undefined ? ['PublicOrgSelfIdQuestions.infinite'] : ['PublicOrgSelfIdQuestions.infinite', variables],
      (metaData) => fetcher<PublicOrgSelfIdQuestionsQuery, PublicOrgSelfIdQuestionsQueryVariables>(PublicOrgSelfIdQuestionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePublicOrgSelfIdQuestionsQuery.getKey = (variables?: PublicOrgSelfIdQuestionsQueryVariables) => variables === undefined ? ['PublicOrgSelfIdQuestions.infinite'] : ['PublicOrgSelfIdQuestions.infinite', variables];
;

usePublicOrgSelfIdQuestionsQuery.fetcher = (variables?: PublicOrgSelfIdQuestionsQueryVariables) => fetcher<PublicOrgSelfIdQuestionsQuery, PublicOrgSelfIdQuestionsQueryVariables>(PublicOrgSelfIdQuestionsDocument, variables);
export const CandidateOrgSelfIdQuestionAnswersDocument = `
    query CandidateOrgSelfIdQuestionAnswers($recruitId: Int) {
  fetchCandidateOrgSelfIdQuestionAnswers(recruitId: $recruitId) {
    orgSelfIdQuestionId
    text
    appSource
    orgSelfIdQuestionOptions {
      id
      name
    }
    orgSelfIdQuestionAnswerSelections {
      id
      orgSelfIdQuestionAnswerId
      orgSelfIdQuestionOptionId
    }
  }
}
    `;
export const useCandidateOrgSelfIdQuestionAnswersQuery = <
      TData = CandidateOrgSelfIdQuestionAnswersQuery,
      TError = unknown
    >(
      variables?: CandidateOrgSelfIdQuestionAnswersQueryVariables,
      options?: UseQueryOptions<CandidateOrgSelfIdQuestionAnswersQuery, TError, TData>
    ) =>
    useQuery<CandidateOrgSelfIdQuestionAnswersQuery, TError, TData>(
      variables === undefined ? ['CandidateOrgSelfIdQuestionAnswers'] : ['CandidateOrgSelfIdQuestionAnswers', variables],
      fetcher<CandidateOrgSelfIdQuestionAnswersQuery, CandidateOrgSelfIdQuestionAnswersQueryVariables>(CandidateOrgSelfIdQuestionAnswersDocument, variables),
      options
    );

useCandidateOrgSelfIdQuestionAnswersQuery.getKey = (variables?: CandidateOrgSelfIdQuestionAnswersQueryVariables) => variables === undefined ? ['CandidateOrgSelfIdQuestionAnswers'] : ['CandidateOrgSelfIdQuestionAnswers', variables];
;

export const useInfiniteCandidateOrgSelfIdQuestionAnswersQuery = <
      TData = CandidateOrgSelfIdQuestionAnswersQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidateOrgSelfIdQuestionAnswersQueryVariables,
      variables?: CandidateOrgSelfIdQuestionAnswersQueryVariables,
      options?: UseInfiniteQueryOptions<CandidateOrgSelfIdQuestionAnswersQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidateOrgSelfIdQuestionAnswersQuery, TError, TData>(
      variables === undefined ? ['CandidateOrgSelfIdQuestionAnswers.infinite'] : ['CandidateOrgSelfIdQuestionAnswers.infinite', variables],
      (metaData) => fetcher<CandidateOrgSelfIdQuestionAnswersQuery, CandidateOrgSelfIdQuestionAnswersQueryVariables>(CandidateOrgSelfIdQuestionAnswersDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidateOrgSelfIdQuestionAnswersQuery.getKey = (variables?: CandidateOrgSelfIdQuestionAnswersQueryVariables) => variables === undefined ? ['CandidateOrgSelfIdQuestionAnswers.infinite'] : ['CandidateOrgSelfIdQuestionAnswers.infinite', variables];
;

useCandidateOrgSelfIdQuestionAnswersQuery.fetcher = (variables?: CandidateOrgSelfIdQuestionAnswersQueryVariables) => fetcher<CandidateOrgSelfIdQuestionAnswersQuery, CandidateOrgSelfIdQuestionAnswersQueryVariables>(CandidateOrgSelfIdQuestionAnswersDocument, variables);
export const AgencyListDocument = `
    query AgencyList {
  agencies {
    id
    name
    isEnabled
  }
}
    `;
export const useAgencyListQuery = <
      TData = AgencyListQuery,
      TError = unknown
    >(
      variables?: AgencyListQueryVariables,
      options?: UseQueryOptions<AgencyListQuery, TError, TData>
    ) =>
    useQuery<AgencyListQuery, TError, TData>(
      variables === undefined ? ['AgencyList'] : ['AgencyList', variables],
      fetcher<AgencyListQuery, AgencyListQueryVariables>(AgencyListDocument, variables),
      options
    );

useAgencyListQuery.getKey = (variables?: AgencyListQueryVariables) => variables === undefined ? ['AgencyList'] : ['AgencyList', variables];
;

export const useInfiniteAgencyListQuery = <
      TData = AgencyListQuery,
      TError = unknown
    >(
      pageParamKey: keyof AgencyListQueryVariables,
      variables?: AgencyListQueryVariables,
      options?: UseInfiniteQueryOptions<AgencyListQuery, TError, TData>
    ) =>
    useInfiniteQuery<AgencyListQuery, TError, TData>(
      variables === undefined ? ['AgencyList.infinite'] : ['AgencyList.infinite', variables],
      (metaData) => fetcher<AgencyListQuery, AgencyListQueryVariables>(AgencyListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAgencyListQuery.getKey = (variables?: AgencyListQueryVariables) => variables === undefined ? ['AgencyList.infinite'] : ['AgencyList.infinite', variables];
;

useAgencyListQuery.fetcher = (variables?: AgencyListQueryVariables) => fetcher<AgencyListQuery, AgencyListQueryVariables>(AgencyListDocument, variables);
export const RegisteredAgencyListDocument = `
    query RegisteredAgencyList {
  registeredAgencies {
    id
    name
    isEnabled
  }
}
    `;
export const useRegisteredAgencyListQuery = <
      TData = RegisteredAgencyListQuery,
      TError = unknown
    >(
      variables?: RegisteredAgencyListQueryVariables,
      options?: UseQueryOptions<RegisteredAgencyListQuery, TError, TData>
    ) =>
    useQuery<RegisteredAgencyListQuery, TError, TData>(
      variables === undefined ? ['RegisteredAgencyList'] : ['RegisteredAgencyList', variables],
      fetcher<RegisteredAgencyListQuery, RegisteredAgencyListQueryVariables>(RegisteredAgencyListDocument, variables),
      options
    );

useRegisteredAgencyListQuery.getKey = (variables?: RegisteredAgencyListQueryVariables) => variables === undefined ? ['RegisteredAgencyList'] : ['RegisteredAgencyList', variables];
;

export const useInfiniteRegisteredAgencyListQuery = <
      TData = RegisteredAgencyListQuery,
      TError = unknown
    >(
      pageParamKey: keyof RegisteredAgencyListQueryVariables,
      variables?: RegisteredAgencyListQueryVariables,
      options?: UseInfiniteQueryOptions<RegisteredAgencyListQuery, TError, TData>
    ) =>
    useInfiniteQuery<RegisteredAgencyListQuery, TError, TData>(
      variables === undefined ? ['RegisteredAgencyList.infinite'] : ['RegisteredAgencyList.infinite', variables],
      (metaData) => fetcher<RegisteredAgencyListQuery, RegisteredAgencyListQueryVariables>(RegisteredAgencyListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteRegisteredAgencyListQuery.getKey = (variables?: RegisteredAgencyListQueryVariables) => variables === undefined ? ['RegisteredAgencyList.infinite'] : ['RegisteredAgencyList.infinite', variables];
;

useRegisteredAgencyListQuery.fetcher = (variables?: RegisteredAgencyListQueryVariables) => fetcher<RegisteredAgencyListQuery, RegisteredAgencyListQueryVariables>(RegisteredAgencyListDocument, variables);
export const AgencyListWithContactsDocument = `
    query AgencyListWithContacts {
  agencies {
    id
    name
    isEnabled
    isUnregisteredAgency
    agencyContacts {
      id
      agencyId
      firstName
      lastName
      email
      phoneNumber
    }
  }
}
    `;
export const useAgencyListWithContactsQuery = <
      TData = AgencyListWithContactsQuery,
      TError = unknown
    >(
      variables?: AgencyListWithContactsQueryVariables,
      options?: UseQueryOptions<AgencyListWithContactsQuery, TError, TData>
    ) =>
    useQuery<AgencyListWithContactsQuery, TError, TData>(
      variables === undefined ? ['AgencyListWithContacts'] : ['AgencyListWithContacts', variables],
      fetcher<AgencyListWithContactsQuery, AgencyListWithContactsQueryVariables>(AgencyListWithContactsDocument, variables),
      options
    );

useAgencyListWithContactsQuery.getKey = (variables?: AgencyListWithContactsQueryVariables) => variables === undefined ? ['AgencyListWithContacts'] : ['AgencyListWithContacts', variables];
;

export const useInfiniteAgencyListWithContactsQuery = <
      TData = AgencyListWithContactsQuery,
      TError = unknown
    >(
      pageParamKey: keyof AgencyListWithContactsQueryVariables,
      variables?: AgencyListWithContactsQueryVariables,
      options?: UseInfiniteQueryOptions<AgencyListWithContactsQuery, TError, TData>
    ) =>
    useInfiniteQuery<AgencyListWithContactsQuery, TError, TData>(
      variables === undefined ? ['AgencyListWithContacts.infinite'] : ['AgencyListWithContacts.infinite', variables],
      (metaData) => fetcher<AgencyListWithContactsQuery, AgencyListWithContactsQueryVariables>(AgencyListWithContactsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAgencyListWithContactsQuery.getKey = (variables?: AgencyListWithContactsQueryVariables) => variables === undefined ? ['AgencyListWithContacts.infinite'] : ['AgencyListWithContacts.infinite', variables];
;

useAgencyListWithContactsQuery.fetcher = (variables?: AgencyListWithContactsQueryVariables) => fetcher<AgencyListWithContactsQuery, AgencyListWithContactsQueryVariables>(AgencyListWithContactsDocument, variables);
export const RegisteredAgencyListWithContactsDocument = `
    query RegisteredAgencyListWithContacts {
  registeredAgencies {
    id
    name
    isEnabled
    isUnregisteredAgency
    agencyContacts {
      id
      agencyId
      firstName
      lastName
      email
      phoneNumber
    }
  }
}
    `;
export const useRegisteredAgencyListWithContactsQuery = <
      TData = RegisteredAgencyListWithContactsQuery,
      TError = unknown
    >(
      variables?: RegisteredAgencyListWithContactsQueryVariables,
      options?: UseQueryOptions<RegisteredAgencyListWithContactsQuery, TError, TData>
    ) =>
    useQuery<RegisteredAgencyListWithContactsQuery, TError, TData>(
      variables === undefined ? ['RegisteredAgencyListWithContacts'] : ['RegisteredAgencyListWithContacts', variables],
      fetcher<RegisteredAgencyListWithContactsQuery, RegisteredAgencyListWithContactsQueryVariables>(RegisteredAgencyListWithContactsDocument, variables),
      options
    );

useRegisteredAgencyListWithContactsQuery.getKey = (variables?: RegisteredAgencyListWithContactsQueryVariables) => variables === undefined ? ['RegisteredAgencyListWithContacts'] : ['RegisteredAgencyListWithContacts', variables];
;

export const useInfiniteRegisteredAgencyListWithContactsQuery = <
      TData = RegisteredAgencyListWithContactsQuery,
      TError = unknown
    >(
      pageParamKey: keyof RegisteredAgencyListWithContactsQueryVariables,
      variables?: RegisteredAgencyListWithContactsQueryVariables,
      options?: UseInfiniteQueryOptions<RegisteredAgencyListWithContactsQuery, TError, TData>
    ) =>
    useInfiniteQuery<RegisteredAgencyListWithContactsQuery, TError, TData>(
      variables === undefined ? ['RegisteredAgencyListWithContacts.infinite'] : ['RegisteredAgencyListWithContacts.infinite', variables],
      (metaData) => fetcher<RegisteredAgencyListWithContactsQuery, RegisteredAgencyListWithContactsQueryVariables>(RegisteredAgencyListWithContactsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteRegisteredAgencyListWithContactsQuery.getKey = (variables?: RegisteredAgencyListWithContactsQueryVariables) => variables === undefined ? ['RegisteredAgencyListWithContacts.infinite'] : ['RegisteredAgencyListWithContacts.infinite', variables];
;

useRegisteredAgencyListWithContactsQuery.fetcher = (variables?: RegisteredAgencyListWithContactsQueryVariables) => fetcher<RegisteredAgencyListWithContactsQuery, RegisteredAgencyListWithContactsQueryVariables>(RegisteredAgencyListWithContactsDocument, variables);
export const GetAgencyDocument = `
    query GetAgency($agencyId: Int) {
  agency(agencyId: $agencyId) {
    id
    name
    isEnabled
    agencyContacts {
      id
      agencyId
      firstName
      lastName
      email
      phoneNumber
    }
  }
}
    `;
export const useGetAgencyQuery = <
      TData = GetAgencyQuery,
      TError = unknown
    >(
      variables?: GetAgencyQueryVariables,
      options?: UseQueryOptions<GetAgencyQuery, TError, TData>
    ) =>
    useQuery<GetAgencyQuery, TError, TData>(
      variables === undefined ? ['GetAgency'] : ['GetAgency', variables],
      fetcher<GetAgencyQuery, GetAgencyQueryVariables>(GetAgencyDocument, variables),
      options
    );

useGetAgencyQuery.getKey = (variables?: GetAgencyQueryVariables) => variables === undefined ? ['GetAgency'] : ['GetAgency', variables];
;

export const useInfiniteGetAgencyQuery = <
      TData = GetAgencyQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAgencyQueryVariables,
      variables?: GetAgencyQueryVariables,
      options?: UseInfiniteQueryOptions<GetAgencyQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetAgencyQuery, TError, TData>(
      variables === undefined ? ['GetAgency.infinite'] : ['GetAgency.infinite', variables],
      (metaData) => fetcher<GetAgencyQuery, GetAgencyQueryVariables>(GetAgencyDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetAgencyQuery.getKey = (variables?: GetAgencyQueryVariables) => variables === undefined ? ['GetAgency.infinite'] : ['GetAgency.infinite', variables];
;

useGetAgencyQuery.fetcher = (variables?: GetAgencyQueryVariables) => fetcher<GetAgencyQuery, GetAgencyQueryVariables>(GetAgencyDocument, variables);
export const GetAgencyContactDocument = `
    query GetAgencyContact($agencyContactId: Int) {
  agencyContact(agencyContactId: $agencyContactId) {
    id
    agencyId
    firstName
    lastName
    email
    phoneNumber
  }
}
    `;
export const useGetAgencyContactQuery = <
      TData = GetAgencyContactQuery,
      TError = unknown
    >(
      variables?: GetAgencyContactQueryVariables,
      options?: UseQueryOptions<GetAgencyContactQuery, TError, TData>
    ) =>
    useQuery<GetAgencyContactQuery, TError, TData>(
      variables === undefined ? ['GetAgencyContact'] : ['GetAgencyContact', variables],
      fetcher<GetAgencyContactQuery, GetAgencyContactQueryVariables>(GetAgencyContactDocument, variables),
      options
    );

useGetAgencyContactQuery.getKey = (variables?: GetAgencyContactQueryVariables) => variables === undefined ? ['GetAgencyContact'] : ['GetAgencyContact', variables];
;

export const useInfiniteGetAgencyContactQuery = <
      TData = GetAgencyContactQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAgencyContactQueryVariables,
      variables?: GetAgencyContactQueryVariables,
      options?: UseInfiniteQueryOptions<GetAgencyContactQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetAgencyContactQuery, TError, TData>(
      variables === undefined ? ['GetAgencyContact.infinite'] : ['GetAgencyContact.infinite', variables],
      (metaData) => fetcher<GetAgencyContactQuery, GetAgencyContactQueryVariables>(GetAgencyContactDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetAgencyContactQuery.getKey = (variables?: GetAgencyContactQueryVariables) => variables === undefined ? ['GetAgencyContact.infinite'] : ['GetAgencyContact.infinite', variables];
;

useGetAgencyContactQuery.fetcher = (variables?: GetAgencyContactQueryVariables) => fetcher<GetAgencyContactQuery, GetAgencyContactQueryVariables>(GetAgencyContactDocument, variables);
export const GetAgencyContactsDocument = `
    query GetAgencyContacts($agencyContactIds: [Int]) {
  agencyContacts(agencyContactIds: $agencyContactIds) {
    id
    agencyId
    firstName
    lastName
    email
    phoneNumber
  }
}
    `;
export const useGetAgencyContactsQuery = <
      TData = GetAgencyContactsQuery,
      TError = unknown
    >(
      variables?: GetAgencyContactsQueryVariables,
      options?: UseQueryOptions<GetAgencyContactsQuery, TError, TData>
    ) =>
    useQuery<GetAgencyContactsQuery, TError, TData>(
      variables === undefined ? ['GetAgencyContacts'] : ['GetAgencyContacts', variables],
      fetcher<GetAgencyContactsQuery, GetAgencyContactsQueryVariables>(GetAgencyContactsDocument, variables),
      options
    );

useGetAgencyContactsQuery.getKey = (variables?: GetAgencyContactsQueryVariables) => variables === undefined ? ['GetAgencyContacts'] : ['GetAgencyContacts', variables];
;

export const useInfiniteGetAgencyContactsQuery = <
      TData = GetAgencyContactsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetAgencyContactsQueryVariables,
      variables?: GetAgencyContactsQueryVariables,
      options?: UseInfiniteQueryOptions<GetAgencyContactsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetAgencyContactsQuery, TError, TData>(
      variables === undefined ? ['GetAgencyContacts.infinite'] : ['GetAgencyContacts.infinite', variables],
      (metaData) => fetcher<GetAgencyContactsQuery, GetAgencyContactsQueryVariables>(GetAgencyContactsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetAgencyContactsQuery.getKey = (variables?: GetAgencyContactsQueryVariables) => variables === undefined ? ['GetAgencyContacts.infinite'] : ['GetAgencyContacts.infinite', variables];
;

useGetAgencyContactsQuery.fetcher = (variables?: GetAgencyContactsQueryVariables) => fetcher<GetAgencyContactsQuery, GetAgencyContactsQueryVariables>(GetAgencyContactsDocument, variables);
export const SelfIdJobsCountDocument = `
    query SelfIdJobsCount($orgFriendlyName: String) {
  fetchSelfIdJobsCount(orgFriendlyName: $orgFriendlyName)
}
    `;
export const useSelfIdJobsCountQuery = <
      TData = SelfIdJobsCountQuery,
      TError = unknown
    >(
      variables?: SelfIdJobsCountQueryVariables,
      options?: UseQueryOptions<SelfIdJobsCountQuery, TError, TData>
    ) =>
    useQuery<SelfIdJobsCountQuery, TError, TData>(
      variables === undefined ? ['SelfIdJobsCount'] : ['SelfIdJobsCount', variables],
      fetcher<SelfIdJobsCountQuery, SelfIdJobsCountQueryVariables>(SelfIdJobsCountDocument, variables),
      options
    );

useSelfIdJobsCountQuery.getKey = (variables?: SelfIdJobsCountQueryVariables) => variables === undefined ? ['SelfIdJobsCount'] : ['SelfIdJobsCount', variables];
;

export const useInfiniteSelfIdJobsCountQuery = <
      TData = SelfIdJobsCountQuery,
      TError = unknown
    >(
      pageParamKey: keyof SelfIdJobsCountQueryVariables,
      variables?: SelfIdJobsCountQueryVariables,
      options?: UseInfiniteQueryOptions<SelfIdJobsCountQuery, TError, TData>
    ) =>
    useInfiniteQuery<SelfIdJobsCountQuery, TError, TData>(
      variables === undefined ? ['SelfIdJobsCount.infinite'] : ['SelfIdJobsCount.infinite', variables],
      (metaData) => fetcher<SelfIdJobsCountQuery, SelfIdJobsCountQueryVariables>(SelfIdJobsCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSelfIdJobsCountQuery.getKey = (variables?: SelfIdJobsCountQueryVariables) => variables === undefined ? ['SelfIdJobsCount.infinite'] : ['SelfIdJobsCount.infinite', variables];
;

useSelfIdJobsCountQuery.fetcher = (variables?: SelfIdJobsCountQueryVariables) => fetcher<SelfIdJobsCountQuery, SelfIdJobsCountQueryVariables>(SelfIdJobsCountDocument, variables);
export const PublicJobsForAgencyContactDocument = `
    query PublicJobsForAgencyContact {
  publicJobsForAgencyContact {
    id
    title
    orgId
    openDate
    closeDate
    openTimezone
    closeTimezone
    createdAt
    extension
    jobEmploymentTypes {
      id
      jobId
      employmentTypeId
      employmentType
    }
    positionTypes {
      id
      jobId
      positionTypeId
      name
    }
    departments {
      id
      jobId
      departmentId
      name
    }
    jobOffices {
      id
      jobId
      name
    }
  }
}
    `;
export const usePublicJobsForAgencyContactQuery = <
      TData = PublicJobsForAgencyContactQuery,
      TError = unknown
    >(
      variables?: PublicJobsForAgencyContactQueryVariables,
      options?: UseQueryOptions<PublicJobsForAgencyContactQuery, TError, TData>
    ) =>
    useQuery<PublicJobsForAgencyContactQuery, TError, TData>(
      variables === undefined ? ['PublicJobsForAgencyContact'] : ['PublicJobsForAgencyContact', variables],
      fetcher<PublicJobsForAgencyContactQuery, PublicJobsForAgencyContactQueryVariables>(PublicJobsForAgencyContactDocument, variables),
      options
    );

usePublicJobsForAgencyContactQuery.getKey = (variables?: PublicJobsForAgencyContactQueryVariables) => variables === undefined ? ['PublicJobsForAgencyContact'] : ['PublicJobsForAgencyContact', variables];
;

export const useInfinitePublicJobsForAgencyContactQuery = <
      TData = PublicJobsForAgencyContactQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicJobsForAgencyContactQueryVariables,
      variables?: PublicJobsForAgencyContactQueryVariables,
      options?: UseInfiniteQueryOptions<PublicJobsForAgencyContactQuery, TError, TData>
    ) =>
    useInfiniteQuery<PublicJobsForAgencyContactQuery, TError, TData>(
      variables === undefined ? ['PublicJobsForAgencyContact.infinite'] : ['PublicJobsForAgencyContact.infinite', variables],
      (metaData) => fetcher<PublicJobsForAgencyContactQuery, PublicJobsForAgencyContactQueryVariables>(PublicJobsForAgencyContactDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePublicJobsForAgencyContactQuery.getKey = (variables?: PublicJobsForAgencyContactQueryVariables) => variables === undefined ? ['PublicJobsForAgencyContact.infinite'] : ['PublicJobsForAgencyContact.infinite', variables];
;

usePublicJobsForAgencyContactQuery.fetcher = (variables?: PublicJobsForAgencyContactQueryVariables) => fetcher<PublicJobsForAgencyContactQuery, PublicJobsForAgencyContactQueryVariables>(PublicJobsForAgencyContactDocument, variables);
export const PublicJobForAgencyContactByExtensionDocument = `
    query PublicJobForAgencyContactByExtension($jobExtension: String) {
  publicJobForAgencyContactByExtension(jobExtension: $jobExtension) {
    id
    title
    orgId
    openDate
    closeDate
    description
    openTimezone
    closeTimezone
    createdAt
    extension
    jobEmploymentTypes {
      id
      jobId
      employmentTypeId
      employmentType
    }
    positionTypes {
      id
      jobId
      positionTypeId
      name
    }
    departments {
      id
      jobId
      departmentId
      name
    }
    jobOffices {
      id
      jobId
      name
    }
  }
}
    `;
export const usePublicJobForAgencyContactByExtensionQuery = <
      TData = PublicJobForAgencyContactByExtensionQuery,
      TError = unknown
    >(
      variables?: PublicJobForAgencyContactByExtensionQueryVariables,
      options?: UseQueryOptions<PublicJobForAgencyContactByExtensionQuery, TError, TData>
    ) =>
    useQuery<PublicJobForAgencyContactByExtensionQuery, TError, TData>(
      variables === undefined ? ['PublicJobForAgencyContactByExtension'] : ['PublicJobForAgencyContactByExtension', variables],
      fetcher<PublicJobForAgencyContactByExtensionQuery, PublicJobForAgencyContactByExtensionQueryVariables>(PublicJobForAgencyContactByExtensionDocument, variables),
      options
    );

usePublicJobForAgencyContactByExtensionQuery.getKey = (variables?: PublicJobForAgencyContactByExtensionQueryVariables) => variables === undefined ? ['PublicJobForAgencyContactByExtension'] : ['PublicJobForAgencyContactByExtension', variables];
;

export const useInfinitePublicJobForAgencyContactByExtensionQuery = <
      TData = PublicJobForAgencyContactByExtensionQuery,
      TError = unknown
    >(
      pageParamKey: keyof PublicJobForAgencyContactByExtensionQueryVariables,
      variables?: PublicJobForAgencyContactByExtensionQueryVariables,
      options?: UseInfiniteQueryOptions<PublicJobForAgencyContactByExtensionQuery, TError, TData>
    ) =>
    useInfiniteQuery<PublicJobForAgencyContactByExtensionQuery, TError, TData>(
      variables === undefined ? ['PublicJobForAgencyContactByExtension.infinite'] : ['PublicJobForAgencyContactByExtension.infinite', variables],
      (metaData) => fetcher<PublicJobForAgencyContactByExtensionQuery, PublicJobForAgencyContactByExtensionQueryVariables>(PublicJobForAgencyContactByExtensionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfinitePublicJobForAgencyContactByExtensionQuery.getKey = (variables?: PublicJobForAgencyContactByExtensionQueryVariables) => variables === undefined ? ['PublicJobForAgencyContactByExtension.infinite'] : ['PublicJobForAgencyContactByExtension.infinite', variables];
;

usePublicJobForAgencyContactByExtensionQuery.fetcher = (variables?: PublicJobForAgencyContactByExtensionQueryVariables) => fetcher<PublicJobForAgencyContactByExtensionQuery, PublicJobForAgencyContactByExtensionQueryVariables>(PublicJobForAgencyContactByExtensionDocument, variables);
export const OrgHistoricalDataDocument = `
    query OrgHistoricalData {
  getOrgHistoricalData {
    id
    firstName
    lastName
    email
    recruitId
    documents
    rows
  }
}
    `;
export const useOrgHistoricalDataQuery = <
      TData = OrgHistoricalDataQuery,
      TError = unknown
    >(
      variables?: OrgHistoricalDataQueryVariables,
      options?: UseQueryOptions<OrgHistoricalDataQuery, TError, TData>
    ) =>
    useQuery<OrgHistoricalDataQuery, TError, TData>(
      variables === undefined ? ['OrgHistoricalData'] : ['OrgHistoricalData', variables],
      fetcher<OrgHistoricalDataQuery, OrgHistoricalDataQueryVariables>(OrgHistoricalDataDocument, variables),
      options
    );

useOrgHistoricalDataQuery.getKey = (variables?: OrgHistoricalDataQueryVariables) => variables === undefined ? ['OrgHistoricalData'] : ['OrgHistoricalData', variables];
;

export const useInfiniteOrgHistoricalDataQuery = <
      TData = OrgHistoricalDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof OrgHistoricalDataQueryVariables,
      variables?: OrgHistoricalDataQueryVariables,
      options?: UseInfiniteQueryOptions<OrgHistoricalDataQuery, TError, TData>
    ) =>
    useInfiniteQuery<OrgHistoricalDataQuery, TError, TData>(
      variables === undefined ? ['OrgHistoricalData.infinite'] : ['OrgHistoricalData.infinite', variables],
      (metaData) => fetcher<OrgHistoricalDataQuery, OrgHistoricalDataQueryVariables>(OrgHistoricalDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteOrgHistoricalDataQuery.getKey = (variables?: OrgHistoricalDataQueryVariables) => variables === undefined ? ['OrgHistoricalData.infinite'] : ['OrgHistoricalData.infinite', variables];
;

useOrgHistoricalDataQuery.fetcher = (variables?: OrgHistoricalDataQueryVariables) => fetcher<OrgHistoricalDataQuery, OrgHistoricalDataQueryVariables>(OrgHistoricalDataDocument, variables);
export const HistoricalDataCandidateByEmailDocument = `
    query HistoricalDataCandidateByEmail($email: String) {
  getHistoricalCandidateByEmail(email: $email) {
    recruitId
  }
}
    `;
export const useHistoricalDataCandidateByEmailQuery = <
      TData = HistoricalDataCandidateByEmailQuery,
      TError = unknown
    >(
      variables?: HistoricalDataCandidateByEmailQueryVariables,
      options?: UseQueryOptions<HistoricalDataCandidateByEmailQuery, TError, TData>
    ) =>
    useQuery<HistoricalDataCandidateByEmailQuery, TError, TData>(
      variables === undefined ? ['HistoricalDataCandidateByEmail'] : ['HistoricalDataCandidateByEmail', variables],
      fetcher<HistoricalDataCandidateByEmailQuery, HistoricalDataCandidateByEmailQueryVariables>(HistoricalDataCandidateByEmailDocument, variables),
      options
    );

useHistoricalDataCandidateByEmailQuery.getKey = (variables?: HistoricalDataCandidateByEmailQueryVariables) => variables === undefined ? ['HistoricalDataCandidateByEmail'] : ['HistoricalDataCandidateByEmail', variables];
;

export const useInfiniteHistoricalDataCandidateByEmailQuery = <
      TData = HistoricalDataCandidateByEmailQuery,
      TError = unknown
    >(
      pageParamKey: keyof HistoricalDataCandidateByEmailQueryVariables,
      variables?: HistoricalDataCandidateByEmailQueryVariables,
      options?: UseInfiniteQueryOptions<HistoricalDataCandidateByEmailQuery, TError, TData>
    ) =>
    useInfiniteQuery<HistoricalDataCandidateByEmailQuery, TError, TData>(
      variables === undefined ? ['HistoricalDataCandidateByEmail.infinite'] : ['HistoricalDataCandidateByEmail.infinite', variables],
      (metaData) => fetcher<HistoricalDataCandidateByEmailQuery, HistoricalDataCandidateByEmailQueryVariables>(HistoricalDataCandidateByEmailDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteHistoricalDataCandidateByEmailQuery.getKey = (variables?: HistoricalDataCandidateByEmailQueryVariables) => variables === undefined ? ['HistoricalDataCandidateByEmail.infinite'] : ['HistoricalDataCandidateByEmail.infinite', variables];
;

useHistoricalDataCandidateByEmailQuery.fetcher = (variables?: HistoricalDataCandidateByEmailQueryVariables) => fetcher<HistoricalDataCandidateByEmailQuery, HistoricalDataCandidateByEmailQueryVariables>(HistoricalDataCandidateByEmailDocument, variables);
export const HistoricalDataCandidateByRecruitIdDocument = `
    query HistoricalDataCandidateByRecruitId($recruitId: Int!) {
  getHistoricalCandidateByRecruitId(recruitId: $recruitId) {
    email
  }
}
    `;
export const useHistoricalDataCandidateByRecruitIdQuery = <
      TData = HistoricalDataCandidateByRecruitIdQuery,
      TError = unknown
    >(
      variables: HistoricalDataCandidateByRecruitIdQueryVariables,
      options?: UseQueryOptions<HistoricalDataCandidateByRecruitIdQuery, TError, TData>
    ) =>
    useQuery<HistoricalDataCandidateByRecruitIdQuery, TError, TData>(
      ['HistoricalDataCandidateByRecruitId', variables],
      fetcher<HistoricalDataCandidateByRecruitIdQuery, HistoricalDataCandidateByRecruitIdQueryVariables>(HistoricalDataCandidateByRecruitIdDocument, variables),
      options
    );

useHistoricalDataCandidateByRecruitIdQuery.getKey = (variables: HistoricalDataCandidateByRecruitIdQueryVariables) => ['HistoricalDataCandidateByRecruitId', variables];
;

export const useInfiniteHistoricalDataCandidateByRecruitIdQuery = <
      TData = HistoricalDataCandidateByRecruitIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof HistoricalDataCandidateByRecruitIdQueryVariables,
      variables: HistoricalDataCandidateByRecruitIdQueryVariables,
      options?: UseInfiniteQueryOptions<HistoricalDataCandidateByRecruitIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<HistoricalDataCandidateByRecruitIdQuery, TError, TData>(
      ['HistoricalDataCandidateByRecruitId.infinite', variables],
      (metaData) => fetcher<HistoricalDataCandidateByRecruitIdQuery, HistoricalDataCandidateByRecruitIdQueryVariables>(HistoricalDataCandidateByRecruitIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteHistoricalDataCandidateByRecruitIdQuery.getKey = (variables: HistoricalDataCandidateByRecruitIdQueryVariables) => ['HistoricalDataCandidateByRecruitId.infinite', variables];
;

useHistoricalDataCandidateByRecruitIdQuery.fetcher = (variables: HistoricalDataCandidateByRecruitIdQueryVariables) => fetcher<HistoricalDataCandidateByRecruitIdQuery, HistoricalDataCandidateByRecruitIdQueryVariables>(HistoricalDataCandidateByRecruitIdDocument, variables);
export const GetJobAppsDocument = `
    query GetJobApps($jobId: Int) {
  jobApps(jobId: $jobId) {
    id
    jobId
    recruitId
    addressLineOne
    addressLineTwo
    city
    state
    country
    zipCode
    jobPipelineStatusId
    createdAt
    sectionResponses {
      id
      jobAppId
      sectionId
      sectionName
      sectionType
      order
    }
    statusUpdatedAt
    appSource
    agencyContactId
  }
}
    `;
export const useGetJobAppsQuery = <
      TData = GetJobAppsQuery,
      TError = unknown
    >(
      variables?: GetJobAppsQueryVariables,
      options?: UseQueryOptions<GetJobAppsQuery, TError, TData>
    ) =>
    useQuery<GetJobAppsQuery, TError, TData>(
      variables === undefined ? ['GetJobApps'] : ['GetJobApps', variables],
      fetcher<GetJobAppsQuery, GetJobAppsQueryVariables>(GetJobAppsDocument, variables),
      options
    );

useGetJobAppsQuery.getKey = (variables?: GetJobAppsQueryVariables) => variables === undefined ? ['GetJobApps'] : ['GetJobApps', variables];
;

export const useInfiniteGetJobAppsQuery = <
      TData = GetJobAppsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetJobAppsQueryVariables,
      variables?: GetJobAppsQueryVariables,
      options?: UseInfiniteQueryOptions<GetJobAppsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetJobAppsQuery, TError, TData>(
      variables === undefined ? ['GetJobApps.infinite'] : ['GetJobApps.infinite', variables],
      (metaData) => fetcher<GetJobAppsQuery, GetJobAppsQueryVariables>(GetJobAppsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetJobAppsQuery.getKey = (variables?: GetJobAppsQueryVariables) => variables === undefined ? ['GetJobApps.infinite'] : ['GetJobApps.infinite', variables];
;

useGetJobAppsQuery.fetcher = (variables?: GetJobAppsQueryVariables) => fetcher<GetJobAppsQuery, GetJobAppsQueryVariables>(GetJobAppsDocument, variables);
export const GetEmployerOrgFeedbackDocument = `
    query GetEmployerOrgFeedback {
  getOrg {
    __typename
    ... on EmployerOrgNode {
      evaluationQuestions {
        edges {
          cursor
          node {
            id
            lowScale
            highScale
            lowLabel
            highLabel
            selectOptions
            label
            evaluationType
            type
            commentsEnabled
            subtext
          }
        }
      }
    }
  }
}
    `;
export const useGetEmployerOrgFeedbackQuery = <
      TData = GetEmployerOrgFeedbackQuery,
      TError = unknown
    >(
      variables?: GetEmployerOrgFeedbackQueryVariables,
      options?: UseQueryOptions<GetEmployerOrgFeedbackQuery, TError, TData>
    ) =>
    useQuery<GetEmployerOrgFeedbackQuery, TError, TData>(
      variables === undefined ? ['GetEmployerOrgFeedback'] : ['GetEmployerOrgFeedback', variables],
      fetcher<GetEmployerOrgFeedbackQuery, GetEmployerOrgFeedbackQueryVariables>(GetEmployerOrgFeedbackDocument, variables),
      options
    );

useGetEmployerOrgFeedbackQuery.getKey = (variables?: GetEmployerOrgFeedbackQueryVariables) => variables === undefined ? ['GetEmployerOrgFeedback'] : ['GetEmployerOrgFeedback', variables];
;

export const useInfiniteGetEmployerOrgFeedbackQuery = <
      TData = GetEmployerOrgFeedbackQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetEmployerOrgFeedbackQueryVariables,
      variables?: GetEmployerOrgFeedbackQueryVariables,
      options?: UseInfiniteQueryOptions<GetEmployerOrgFeedbackQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetEmployerOrgFeedbackQuery, TError, TData>(
      variables === undefined ? ['GetEmployerOrgFeedback.infinite'] : ['GetEmployerOrgFeedback.infinite', variables],
      (metaData) => fetcher<GetEmployerOrgFeedbackQuery, GetEmployerOrgFeedbackQueryVariables>(GetEmployerOrgFeedbackDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetEmployerOrgFeedbackQuery.getKey = (variables?: GetEmployerOrgFeedbackQueryVariables) => variables === undefined ? ['GetEmployerOrgFeedback.infinite'] : ['GetEmployerOrgFeedback.infinite', variables];
;

useGetEmployerOrgFeedbackQuery.fetcher = (variables?: GetEmployerOrgFeedbackQueryVariables) => fetcher<GetEmployerOrgFeedbackQuery, GetEmployerOrgFeedbackQueryVariables>(GetEmployerOrgFeedbackDocument, variables);
export const GetCandidatesDocument = `
    query GetCandidates($jobId: Int, $first: Int, $after: String) {
  getCandidatesOfJob(jobId: $jobId, first: $first, after: $after) {
    nodes {
      id
      firstName
      lastName
      email
      qualifyingQuestions {
        totalCount
        edges {
          node {
            id
            question
            answers
            lastUpdated
            lastUpdatedAnswer
          }
        }
      }
    }
  }
}
    `;
export const useGetCandidatesQuery = <
      TData = GetCandidatesQuery,
      TError = unknown
    >(
      variables?: GetCandidatesQueryVariables,
      options?: UseQueryOptions<GetCandidatesQuery, TError, TData>
    ) =>
    useQuery<GetCandidatesQuery, TError, TData>(
      variables === undefined ? ['GetCandidates'] : ['GetCandidates', variables],
      fetcher<GetCandidatesQuery, GetCandidatesQueryVariables>(GetCandidatesDocument, variables),
      options
    );

useGetCandidatesQuery.getKey = (variables?: GetCandidatesQueryVariables) => variables === undefined ? ['GetCandidates'] : ['GetCandidates', variables];
;

export const useInfiniteGetCandidatesQuery = <
      TData = GetCandidatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidatesQueryVariables,
      variables?: GetCandidatesQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidatesQuery, TError, TData>(
      variables === undefined ? ['GetCandidates.infinite'] : ['GetCandidates.infinite', variables],
      (metaData) => fetcher<GetCandidatesQuery, GetCandidatesQueryVariables>(GetCandidatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidatesQuery.getKey = (variables?: GetCandidatesQueryVariables) => variables === undefined ? ['GetCandidates.infinite'] : ['GetCandidates.infinite', variables];
;

useGetCandidatesQuery.fetcher = (variables?: GetCandidatesQueryVariables) => fetcher<GetCandidatesQuery, GetCandidatesQueryVariables>(GetCandidatesDocument, variables);
export const GetCandidatesWithEventsDocument = `
    query GetCandidatesWithEvents($jobId: Int, $first: Int, $after: String) {
  getCandidatesOfJob(jobId: $jobId, first: $first, after: $after) {
    nodes {
      id
      firstName
      lastName
      email
      events {
        nodes {
          name
          id
        }
      }
    }
  }
}
    `;
export const useGetCandidatesWithEventsQuery = <
      TData = GetCandidatesWithEventsQuery,
      TError = unknown
    >(
      variables?: GetCandidatesWithEventsQueryVariables,
      options?: UseQueryOptions<GetCandidatesWithEventsQuery, TError, TData>
    ) =>
    useQuery<GetCandidatesWithEventsQuery, TError, TData>(
      variables === undefined ? ['GetCandidatesWithEvents'] : ['GetCandidatesWithEvents', variables],
      fetcher<GetCandidatesWithEventsQuery, GetCandidatesWithEventsQueryVariables>(GetCandidatesWithEventsDocument, variables),
      options
    );

useGetCandidatesWithEventsQuery.getKey = (variables?: GetCandidatesWithEventsQueryVariables) => variables === undefined ? ['GetCandidatesWithEvents'] : ['GetCandidatesWithEvents', variables];
;

export const useInfiniteGetCandidatesWithEventsQuery = <
      TData = GetCandidatesWithEventsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidatesWithEventsQueryVariables,
      variables?: GetCandidatesWithEventsQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidatesWithEventsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidatesWithEventsQuery, TError, TData>(
      variables === undefined ? ['GetCandidatesWithEvents.infinite'] : ['GetCandidatesWithEvents.infinite', variables],
      (metaData) => fetcher<GetCandidatesWithEventsQuery, GetCandidatesWithEventsQueryVariables>(GetCandidatesWithEventsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidatesWithEventsQuery.getKey = (variables?: GetCandidatesWithEventsQueryVariables) => variables === undefined ? ['GetCandidatesWithEvents.infinite'] : ['GetCandidatesWithEvents.infinite', variables];
;

useGetCandidatesWithEventsQuery.fetcher = (variables?: GetCandidatesWithEventsQueryVariables) => fetcher<GetCandidatesWithEventsQuery, GetCandidatesWithEventsQueryVariables>(GetCandidatesWithEventsDocument, variables);
export const GetCandidatesWithEventsAndJobsDocument = `
    query GetCandidatesWithEventsAndJobs($jobIds: [Int!]!, $first: Int, $after: String) {
  getCandidatesOfJobs(jobIds: $jobIds, first: $first, after: $after) {
    nodes {
      id
      firstName
      lastName
      email
      events {
        nodes {
          name
          id
        }
      }
      jobApps {
        nodes {
          job {
            id
            title
          }
          status {
            name
          }
        }
      }
    }
  }
}
    `;
export const useGetCandidatesWithEventsAndJobsQuery = <
      TData = GetCandidatesWithEventsAndJobsQuery,
      TError = unknown
    >(
      variables: GetCandidatesWithEventsAndJobsQueryVariables,
      options?: UseQueryOptions<GetCandidatesWithEventsAndJobsQuery, TError, TData>
    ) =>
    useQuery<GetCandidatesWithEventsAndJobsQuery, TError, TData>(
      ['GetCandidatesWithEventsAndJobs', variables],
      fetcher<GetCandidatesWithEventsAndJobsQuery, GetCandidatesWithEventsAndJobsQueryVariables>(GetCandidatesWithEventsAndJobsDocument, variables),
      options
    );

useGetCandidatesWithEventsAndJobsQuery.getKey = (variables: GetCandidatesWithEventsAndJobsQueryVariables) => ['GetCandidatesWithEventsAndJobs', variables];
;

export const useInfiniteGetCandidatesWithEventsAndJobsQuery = <
      TData = GetCandidatesWithEventsAndJobsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidatesWithEventsAndJobsQueryVariables,
      variables: GetCandidatesWithEventsAndJobsQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidatesWithEventsAndJobsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidatesWithEventsAndJobsQuery, TError, TData>(
      ['GetCandidatesWithEventsAndJobs.infinite', variables],
      (metaData) => fetcher<GetCandidatesWithEventsAndJobsQuery, GetCandidatesWithEventsAndJobsQueryVariables>(GetCandidatesWithEventsAndJobsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidatesWithEventsAndJobsQuery.getKey = (variables: GetCandidatesWithEventsAndJobsQueryVariables) => ['GetCandidatesWithEventsAndJobs.infinite', variables];
;

useGetCandidatesWithEventsAndJobsQuery.fetcher = (variables: GetCandidatesWithEventsAndJobsQueryVariables) => fetcher<GetCandidatesWithEventsAndJobsQuery, GetCandidatesWithEventsAndJobsQueryVariables>(GetCandidatesWithEventsAndJobsDocument, variables);
export const GetCandidatesForProgramsDocument = `
    query GetCandidatesForPrograms($programIds: [Int!]!) {
  getCandidatesOfPrograms(programIds: $programIds) {
    id
    firstName
    lastName
    email
  }
}
    `;
export const useGetCandidatesForProgramsQuery = <
      TData = GetCandidatesForProgramsQuery,
      TError = unknown
    >(
      variables: GetCandidatesForProgramsQueryVariables,
      options?: UseQueryOptions<GetCandidatesForProgramsQuery, TError, TData>
    ) =>
    useQuery<GetCandidatesForProgramsQuery, TError, TData>(
      ['GetCandidatesForPrograms', variables],
      fetcher<GetCandidatesForProgramsQuery, GetCandidatesForProgramsQueryVariables>(GetCandidatesForProgramsDocument, variables),
      options
    );

useGetCandidatesForProgramsQuery.getKey = (variables: GetCandidatesForProgramsQueryVariables) => ['GetCandidatesForPrograms', variables];
;

export const useInfiniteGetCandidatesForProgramsQuery = <
      TData = GetCandidatesForProgramsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidatesForProgramsQueryVariables,
      variables: GetCandidatesForProgramsQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidatesForProgramsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidatesForProgramsQuery, TError, TData>(
      ['GetCandidatesForPrograms.infinite', variables],
      (metaData) => fetcher<GetCandidatesForProgramsQuery, GetCandidatesForProgramsQueryVariables>(GetCandidatesForProgramsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidatesForProgramsQuery.getKey = (variables: GetCandidatesForProgramsQueryVariables) => ['GetCandidatesForPrograms.infinite', variables];
;

useGetCandidatesForProgramsQuery.fetcher = (variables: GetCandidatesForProgramsQueryVariables) => fetcher<GetCandidatesForProgramsQuery, GetCandidatesForProgramsQueryVariables>(GetCandidatesForProgramsDocument, variables);
export const GetCandidatesForEventsDocument = `
    query GetCandidatesForEvents($eventIds: [Int!]!) {
  getCandidatesOfEvents(eventIds: $eventIds) {
    id
    firstName
    lastName
    email
    events {
      nodes {
        name
        id
      }
    }
  }
}
    `;
export const useGetCandidatesForEventsQuery = <
      TData = GetCandidatesForEventsQuery,
      TError = unknown
    >(
      variables: GetCandidatesForEventsQueryVariables,
      options?: UseQueryOptions<GetCandidatesForEventsQuery, TError, TData>
    ) =>
    useQuery<GetCandidatesForEventsQuery, TError, TData>(
      ['GetCandidatesForEvents', variables],
      fetcher<GetCandidatesForEventsQuery, GetCandidatesForEventsQueryVariables>(GetCandidatesForEventsDocument, variables),
      options
    );

useGetCandidatesForEventsQuery.getKey = (variables: GetCandidatesForEventsQueryVariables) => ['GetCandidatesForEvents', variables];
;

export const useInfiniteGetCandidatesForEventsQuery = <
      TData = GetCandidatesForEventsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidatesForEventsQueryVariables,
      variables: GetCandidatesForEventsQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidatesForEventsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidatesForEventsQuery, TError, TData>(
      ['GetCandidatesForEvents.infinite', variables],
      (metaData) => fetcher<GetCandidatesForEventsQuery, GetCandidatesForEventsQueryVariables>(GetCandidatesForEventsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidatesForEventsQuery.getKey = (variables: GetCandidatesForEventsQueryVariables) => ['GetCandidatesForEvents.infinite', variables];
;

useGetCandidatesForEventsQuery.fetcher = (variables: GetCandidatesForEventsQueryVariables) => fetcher<GetCandidatesForEventsQuery, GetCandidatesForEventsQueryVariables>(GetCandidatesForEventsDocument, variables);
export const GetFullCandidatesDocument = `
    query GetFullCandidates($jobId: Int, $first: Int, $after: String) {
  getCandidatesOfJob(jobId: $jobId, first: $first, after: $after) {
    nodes {
      id
      firstName
      lastName
      email
      events {
        nodes {
          name
        }
      }
      qualifyingQuestions {
        totalCount
        edges {
          node {
            id
            question
            answers
            lastUpdated
          }
        }
      }
    }
  }
}
    `;
export const useGetFullCandidatesQuery = <
      TData = GetFullCandidatesQuery,
      TError = unknown
    >(
      variables?: GetFullCandidatesQueryVariables,
      options?: UseQueryOptions<GetFullCandidatesQuery, TError, TData>
    ) =>
    useQuery<GetFullCandidatesQuery, TError, TData>(
      variables === undefined ? ['GetFullCandidates'] : ['GetFullCandidates', variables],
      fetcher<GetFullCandidatesQuery, GetFullCandidatesQueryVariables>(GetFullCandidatesDocument, variables),
      options
    );

useGetFullCandidatesQuery.getKey = (variables?: GetFullCandidatesQueryVariables) => variables === undefined ? ['GetFullCandidates'] : ['GetFullCandidates', variables];
;

export const useInfiniteGetFullCandidatesQuery = <
      TData = GetFullCandidatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetFullCandidatesQueryVariables,
      variables?: GetFullCandidatesQueryVariables,
      options?: UseInfiniteQueryOptions<GetFullCandidatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetFullCandidatesQuery, TError, TData>(
      variables === undefined ? ['GetFullCandidates.infinite'] : ['GetFullCandidates.infinite', variables],
      (metaData) => fetcher<GetFullCandidatesQuery, GetFullCandidatesQueryVariables>(GetFullCandidatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetFullCandidatesQuery.getKey = (variables?: GetFullCandidatesQueryVariables) => variables === undefined ? ['GetFullCandidates.infinite'] : ['GetFullCandidates.infinite', variables];
;

useGetFullCandidatesQuery.fetcher = (variables?: GetFullCandidatesQueryVariables) => fetcher<GetFullCandidatesQuery, GetFullCandidatesQueryVariables>(GetFullCandidatesDocument, variables);
export const GetQualifyingQuestionsForCandidatesDocument = `
    query GetQualifyingQuestionsForCandidates($jobId: Int, $first: Int, $after: String) {
  getCandidatesOfJob(jobId: $jobId, first: $first, after: $after) {
    nodes {
      id
      qualifyingQuestions {
        totalCount
        edges {
          node {
            id
            question
            answers
            lastUpdated
          }
        }
      }
    }
  }
}
    `;
export const useGetQualifyingQuestionsForCandidatesQuery = <
      TData = GetQualifyingQuestionsForCandidatesQuery,
      TError = unknown
    >(
      variables?: GetQualifyingQuestionsForCandidatesQueryVariables,
      options?: UseQueryOptions<GetQualifyingQuestionsForCandidatesQuery, TError, TData>
    ) =>
    useQuery<GetQualifyingQuestionsForCandidatesQuery, TError, TData>(
      variables === undefined ? ['GetQualifyingQuestionsForCandidates'] : ['GetQualifyingQuestionsForCandidates', variables],
      fetcher<GetQualifyingQuestionsForCandidatesQuery, GetQualifyingQuestionsForCandidatesQueryVariables>(GetQualifyingQuestionsForCandidatesDocument, variables),
      options
    );

useGetQualifyingQuestionsForCandidatesQuery.getKey = (variables?: GetQualifyingQuestionsForCandidatesQueryVariables) => variables === undefined ? ['GetQualifyingQuestionsForCandidates'] : ['GetQualifyingQuestionsForCandidates', variables];
;

export const useInfiniteGetQualifyingQuestionsForCandidatesQuery = <
      TData = GetQualifyingQuestionsForCandidatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetQualifyingQuestionsForCandidatesQueryVariables,
      variables?: GetQualifyingQuestionsForCandidatesQueryVariables,
      options?: UseInfiniteQueryOptions<GetQualifyingQuestionsForCandidatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetQualifyingQuestionsForCandidatesQuery, TError, TData>(
      variables === undefined ? ['GetQualifyingQuestionsForCandidates.infinite'] : ['GetQualifyingQuestionsForCandidates.infinite', variables],
      (metaData) => fetcher<GetQualifyingQuestionsForCandidatesQuery, GetQualifyingQuestionsForCandidatesQueryVariables>(GetQualifyingQuestionsForCandidatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetQualifyingQuestionsForCandidatesQuery.getKey = (variables?: GetQualifyingQuestionsForCandidatesQueryVariables) => variables === undefined ? ['GetQualifyingQuestionsForCandidates.infinite'] : ['GetQualifyingQuestionsForCandidates.infinite', variables];
;

useGetQualifyingQuestionsForCandidatesQuery.fetcher = (variables?: GetQualifyingQuestionsForCandidatesQueryVariables) => fetcher<GetQualifyingQuestionsForCandidatesQuery, GetQualifyingQuestionsForCandidatesQueryVariables>(GetQualifyingQuestionsForCandidatesDocument, variables);
export const GetOfficeLocationsForCurrentOrgDocument = `
    query GetOfficeLocationsForCurrentOrg {
  getOrg {
    __typename
    ... on EmployerOrgNode {
      officeLocations {
        nodes {
          id
          name
        }
        edges {
          ugPresetId
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const useGetOfficeLocationsForCurrentOrgQuery = <
      TData = GetOfficeLocationsForCurrentOrgQuery,
      TError = unknown
    >(
      variables?: GetOfficeLocationsForCurrentOrgQueryVariables,
      options?: UseQueryOptions<GetOfficeLocationsForCurrentOrgQuery, TError, TData>
    ) =>
    useQuery<GetOfficeLocationsForCurrentOrgQuery, TError, TData>(
      variables === undefined ? ['GetOfficeLocationsForCurrentOrg'] : ['GetOfficeLocationsForCurrentOrg', variables],
      fetcher<GetOfficeLocationsForCurrentOrgQuery, GetOfficeLocationsForCurrentOrgQueryVariables>(GetOfficeLocationsForCurrentOrgDocument, variables),
      options
    );

useGetOfficeLocationsForCurrentOrgQuery.getKey = (variables?: GetOfficeLocationsForCurrentOrgQueryVariables) => variables === undefined ? ['GetOfficeLocationsForCurrentOrg'] : ['GetOfficeLocationsForCurrentOrg', variables];
;

export const useInfiniteGetOfficeLocationsForCurrentOrgQuery = <
      TData = GetOfficeLocationsForCurrentOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetOfficeLocationsForCurrentOrgQueryVariables,
      variables?: GetOfficeLocationsForCurrentOrgQueryVariables,
      options?: UseInfiniteQueryOptions<GetOfficeLocationsForCurrentOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetOfficeLocationsForCurrentOrgQuery, TError, TData>(
      variables === undefined ? ['GetOfficeLocationsForCurrentOrg.infinite'] : ['GetOfficeLocationsForCurrentOrg.infinite', variables],
      (metaData) => fetcher<GetOfficeLocationsForCurrentOrgQuery, GetOfficeLocationsForCurrentOrgQueryVariables>(GetOfficeLocationsForCurrentOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetOfficeLocationsForCurrentOrgQuery.getKey = (variables?: GetOfficeLocationsForCurrentOrgQueryVariables) => variables === undefined ? ['GetOfficeLocationsForCurrentOrg.infinite'] : ['GetOfficeLocationsForCurrentOrg.infinite', variables];
;

useGetOfficeLocationsForCurrentOrgQuery.fetcher = (variables?: GetOfficeLocationsForCurrentOrgQueryVariables) => fetcher<GetOfficeLocationsForCurrentOrgQuery, GetOfficeLocationsForCurrentOrgQueryVariables>(GetOfficeLocationsForCurrentOrgDocument, variables);
export const GetOfficeLocationsForCurrentOrgV2Document = `
    query GetOfficeLocationsForCurrentOrgV2 {
  getOrgEmployerMember {
    __typename
    ... on EmployerOrgNode {
      officeLocations {
        edges {
          ugPresetId
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const useGetOfficeLocationsForCurrentOrgV2Query = <
      TData = GetOfficeLocationsForCurrentOrgV2Query,
      TError = unknown
    >(
      variables?: GetOfficeLocationsForCurrentOrgV2QueryVariables,
      options?: UseQueryOptions<GetOfficeLocationsForCurrentOrgV2Query, TError, TData>
    ) =>
    useQuery<GetOfficeLocationsForCurrentOrgV2Query, TError, TData>(
      variables === undefined ? ['GetOfficeLocationsForCurrentOrgV2'] : ['GetOfficeLocationsForCurrentOrgV2', variables],
      fetcher<GetOfficeLocationsForCurrentOrgV2Query, GetOfficeLocationsForCurrentOrgV2QueryVariables>(GetOfficeLocationsForCurrentOrgV2Document, variables),
      options
    );

useGetOfficeLocationsForCurrentOrgV2Query.getKey = (variables?: GetOfficeLocationsForCurrentOrgV2QueryVariables) => variables === undefined ? ['GetOfficeLocationsForCurrentOrgV2'] : ['GetOfficeLocationsForCurrentOrgV2', variables];
;

export const useInfiniteGetOfficeLocationsForCurrentOrgV2Query = <
      TData = GetOfficeLocationsForCurrentOrgV2Query,
      TError = unknown
    >(
      pageParamKey: keyof GetOfficeLocationsForCurrentOrgV2QueryVariables,
      variables?: GetOfficeLocationsForCurrentOrgV2QueryVariables,
      options?: UseInfiniteQueryOptions<GetOfficeLocationsForCurrentOrgV2Query, TError, TData>
    ) =>
    useInfiniteQuery<GetOfficeLocationsForCurrentOrgV2Query, TError, TData>(
      variables === undefined ? ['GetOfficeLocationsForCurrentOrgV2.infinite'] : ['GetOfficeLocationsForCurrentOrgV2.infinite', variables],
      (metaData) => fetcher<GetOfficeLocationsForCurrentOrgV2Query, GetOfficeLocationsForCurrentOrgV2QueryVariables>(GetOfficeLocationsForCurrentOrgV2Document, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetOfficeLocationsForCurrentOrgV2Query.getKey = (variables?: GetOfficeLocationsForCurrentOrgV2QueryVariables) => variables === undefined ? ['GetOfficeLocationsForCurrentOrgV2.infinite'] : ['GetOfficeLocationsForCurrentOrgV2.infinite', variables];
;

useGetOfficeLocationsForCurrentOrgV2Query.fetcher = (variables?: GetOfficeLocationsForCurrentOrgV2QueryVariables) => fetcher<GetOfficeLocationsForCurrentOrgV2Query, GetOfficeLocationsForCurrentOrgV2QueryVariables>(GetOfficeLocationsForCurrentOrgV2Document, variables);
export const GetEmployerEventsDocument = `
    query GetEmployerEvents($first: Int, $after: String) {
  getOrg {
    __typename
    ... on EmployerOrgNode {
      organizingEvents(first: $first, after: $after) {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
export const useGetEmployerEventsQuery = <
      TData = GetEmployerEventsQuery,
      TError = unknown
    >(
      variables?: GetEmployerEventsQueryVariables,
      options?: UseQueryOptions<GetEmployerEventsQuery, TError, TData>
    ) =>
    useQuery<GetEmployerEventsQuery, TError, TData>(
      variables === undefined ? ['GetEmployerEvents'] : ['GetEmployerEvents', variables],
      fetcher<GetEmployerEventsQuery, GetEmployerEventsQueryVariables>(GetEmployerEventsDocument, variables),
      options
    );

useGetEmployerEventsQuery.getKey = (variables?: GetEmployerEventsQueryVariables) => variables === undefined ? ['GetEmployerEvents'] : ['GetEmployerEvents', variables];
;

export const useInfiniteGetEmployerEventsQuery = <
      TData = GetEmployerEventsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetEmployerEventsQueryVariables,
      variables?: GetEmployerEventsQueryVariables,
      options?: UseInfiniteQueryOptions<GetEmployerEventsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetEmployerEventsQuery, TError, TData>(
      variables === undefined ? ['GetEmployerEvents.infinite'] : ['GetEmployerEvents.infinite', variables],
      (metaData) => fetcher<GetEmployerEventsQuery, GetEmployerEventsQueryVariables>(GetEmployerEventsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetEmployerEventsQuery.getKey = (variables?: GetEmployerEventsQueryVariables) => variables === undefined ? ['GetEmployerEvents.infinite'] : ['GetEmployerEvents.infinite', variables];
;

useGetEmployerEventsQuery.fetcher = (variables?: GetEmployerEventsQueryVariables) => fetcher<GetEmployerEventsQuery, GetEmployerEventsQueryVariables>(GetEmployerEventsDocument, variables);
export const GetJobQuestionColumnDocument = `
    query GetJobQuestionColumn($jobId: Int, $jobQuestionId: Int) {
  jobQuestion(jobId: $jobId, jobQuestionId: $jobQuestionId) {
    id
    jobSectionId
    questionType
    isDeleted
    isRequired
    orgQuestionId
    label
    subText
    jobQuestionAnswers {
      edges {
        node {
          id
          jobAppId
          orgQuestionId
          questionType
          dateValue
          numericValue
          textValue
          options {
            id
            orgQuestionId
            option
            order
            isDeleted
            coreQuestionOptionId
          }
          jobAppQuestionAnswerSelections {
            edges {
              node {
                id
                option
                orgQuestionOptionId
                __typename
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const useGetJobQuestionColumnQuery = <
      TData = GetJobQuestionColumnQuery,
      TError = unknown
    >(
      variables?: GetJobQuestionColumnQueryVariables,
      options?: UseQueryOptions<GetJobQuestionColumnQuery, TError, TData>
    ) =>
    useQuery<GetJobQuestionColumnQuery, TError, TData>(
      variables === undefined ? ['GetJobQuestionColumn'] : ['GetJobQuestionColumn', variables],
      fetcher<GetJobQuestionColumnQuery, GetJobQuestionColumnQueryVariables>(GetJobQuestionColumnDocument, variables),
      options
    );

useGetJobQuestionColumnQuery.getKey = (variables?: GetJobQuestionColumnQueryVariables) => variables === undefined ? ['GetJobQuestionColumn'] : ['GetJobQuestionColumn', variables];
;

export const useInfiniteGetJobQuestionColumnQuery = <
      TData = GetJobQuestionColumnQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetJobQuestionColumnQueryVariables,
      variables?: GetJobQuestionColumnQueryVariables,
      options?: UseInfiniteQueryOptions<GetJobQuestionColumnQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetJobQuestionColumnQuery, TError, TData>(
      variables === undefined ? ['GetJobQuestionColumn.infinite'] : ['GetJobQuestionColumn.infinite', variables],
      (metaData) => fetcher<GetJobQuestionColumnQuery, GetJobQuestionColumnQueryVariables>(GetJobQuestionColumnDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetJobQuestionColumnQuery.getKey = (variables?: GetJobQuestionColumnQueryVariables) => variables === undefined ? ['GetJobQuestionColumn.infinite'] : ['GetJobQuestionColumn.infinite', variables];
;

useGetJobQuestionColumnQuery.fetcher = (variables?: GetJobQuestionColumnQueryVariables) => fetcher<GetJobQuestionColumnQuery, GetJobQuestionColumnQueryVariables>(GetJobQuestionColumnDocument, variables);
export const GetUserAnalyticsInfoDocument = `
    query GetUserAnalyticsInfo {
  userAnalyticsInfo {
    __typename
    ... on AdminUserAnalyticsInfo {
      id
      pendoVisitorId
      pendoAccountId
      fullStoryId
      orgId
      orgName
      isAdmin
      isPaying
      fullName
      email
    }
    ... on CandidateUserAnalyticsInfo {
      id
      pendoVisitorId
      pendoAccountId
      fullStoryId
      loggedInEmail
      fullName
      forwardAccount {
        id
        isActive
        activeSince
        primaryEmail
        numberOfEmails
        discoveryQuizAnswers {
          officeLocations {
            id
            name
          }
          practiceCategories {
            id
            name
          }
          demographicInfo {
            ethnicityAnswers
            genderAnswers
            veteranStatusAnswer
            sexualIdentityAnswer
          }
        }
      }
      biographicalInfo {
        graduationDate
        graduationYear
        lawSchool
        lawSchoolClassification
        humanReadableLawSchoolClassification
        undergraduateMajor
        gpa
      }
    }
  }
}
    `;
export const useGetUserAnalyticsInfoQuery = <
      TData = GetUserAnalyticsInfoQuery,
      TError = unknown
    >(
      variables?: GetUserAnalyticsInfoQueryVariables,
      options?: UseQueryOptions<GetUserAnalyticsInfoQuery, TError, TData>
    ) =>
    useQuery<GetUserAnalyticsInfoQuery, TError, TData>(
      variables === undefined ? ['GetUserAnalyticsInfo'] : ['GetUserAnalyticsInfo', variables],
      fetcher<GetUserAnalyticsInfoQuery, GetUserAnalyticsInfoQueryVariables>(GetUserAnalyticsInfoDocument, variables),
      options
    );

useGetUserAnalyticsInfoQuery.getKey = (variables?: GetUserAnalyticsInfoQueryVariables) => variables === undefined ? ['GetUserAnalyticsInfo'] : ['GetUserAnalyticsInfo', variables];
;

export const useInfiniteGetUserAnalyticsInfoQuery = <
      TData = GetUserAnalyticsInfoQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserAnalyticsInfoQueryVariables,
      variables?: GetUserAnalyticsInfoQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserAnalyticsInfoQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetUserAnalyticsInfoQuery, TError, TData>(
      variables === undefined ? ['GetUserAnalyticsInfo.infinite'] : ['GetUserAnalyticsInfo.infinite', variables],
      (metaData) => fetcher<GetUserAnalyticsInfoQuery, GetUserAnalyticsInfoQueryVariables>(GetUserAnalyticsInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetUserAnalyticsInfoQuery.getKey = (variables?: GetUserAnalyticsInfoQueryVariables) => variables === undefined ? ['GetUserAnalyticsInfo.infinite'] : ['GetUserAnalyticsInfo.infinite', variables];
;

useGetUserAnalyticsInfoQuery.fetcher = (variables?: GetUserAnalyticsInfoQueryVariables) => fetcher<GetUserAnalyticsInfoQuery, GetUserAnalyticsInfoQueryVariables>(GetUserAnalyticsInfoDocument, variables);
export const GetOrgIsGovernmentContractorDocument = `
    query GetOrgIsGovernmentContractor {
  getOrg {
    __typename
    ...contractorFragment
  }
}
    ${ContractorFragmentFragmentDoc}`;
export const useGetOrgIsGovernmentContractorQuery = <
      TData = GetOrgIsGovernmentContractorQuery,
      TError = unknown
    >(
      variables?: GetOrgIsGovernmentContractorQueryVariables,
      options?: UseQueryOptions<GetOrgIsGovernmentContractorQuery, TError, TData>
    ) =>
    useQuery<GetOrgIsGovernmentContractorQuery, TError, TData>(
      variables === undefined ? ['GetOrgIsGovernmentContractor'] : ['GetOrgIsGovernmentContractor', variables],
      fetcher<GetOrgIsGovernmentContractorQuery, GetOrgIsGovernmentContractorQueryVariables>(GetOrgIsGovernmentContractorDocument, variables),
      options
    );

useGetOrgIsGovernmentContractorQuery.getKey = (variables?: GetOrgIsGovernmentContractorQueryVariables) => variables === undefined ? ['GetOrgIsGovernmentContractor'] : ['GetOrgIsGovernmentContractor', variables];
;

export const useInfiniteGetOrgIsGovernmentContractorQuery = <
      TData = GetOrgIsGovernmentContractorQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetOrgIsGovernmentContractorQueryVariables,
      variables?: GetOrgIsGovernmentContractorQueryVariables,
      options?: UseInfiniteQueryOptions<GetOrgIsGovernmentContractorQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetOrgIsGovernmentContractorQuery, TError, TData>(
      variables === undefined ? ['GetOrgIsGovernmentContractor.infinite'] : ['GetOrgIsGovernmentContractor.infinite', variables],
      (metaData) => fetcher<GetOrgIsGovernmentContractorQuery, GetOrgIsGovernmentContractorQueryVariables>(GetOrgIsGovernmentContractorDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetOrgIsGovernmentContractorQuery.getKey = (variables?: GetOrgIsGovernmentContractorQueryVariables) => variables === undefined ? ['GetOrgIsGovernmentContractor.infinite'] : ['GetOrgIsGovernmentContractor.infinite', variables];
;

useGetOrgIsGovernmentContractorQuery.fetcher = (variables?: GetOrgIsGovernmentContractorQueryVariables) => fetcher<GetOrgIsGovernmentContractorQuery, GetOrgIsGovernmentContractorQueryVariables>(GetOrgIsGovernmentContractorDocument, variables);
export const JobsForPipelineTemplateDocument = `
    query JobsForPipelineTemplate($pipelineTemplateId: Int) {
  jobsForPipelineTemplate(pipelineTemplateId: $pipelineTemplateId) {
    id
    title
    jobOffices {
      id
      name
    }
  }
}
    `;
export const useJobsForPipelineTemplateQuery = <
      TData = JobsForPipelineTemplateQuery,
      TError = unknown
    >(
      variables?: JobsForPipelineTemplateQueryVariables,
      options?: UseQueryOptions<JobsForPipelineTemplateQuery, TError, TData>
    ) =>
    useQuery<JobsForPipelineTemplateQuery, TError, TData>(
      variables === undefined ? ['JobsForPipelineTemplate'] : ['JobsForPipelineTemplate', variables],
      fetcher<JobsForPipelineTemplateQuery, JobsForPipelineTemplateQueryVariables>(JobsForPipelineTemplateDocument, variables),
      options
    );

useJobsForPipelineTemplateQuery.getKey = (variables?: JobsForPipelineTemplateQueryVariables) => variables === undefined ? ['JobsForPipelineTemplate'] : ['JobsForPipelineTemplate', variables];
;

export const useInfiniteJobsForPipelineTemplateQuery = <
      TData = JobsForPipelineTemplateQuery,
      TError = unknown
    >(
      pageParamKey: keyof JobsForPipelineTemplateQueryVariables,
      variables?: JobsForPipelineTemplateQueryVariables,
      options?: UseInfiniteQueryOptions<JobsForPipelineTemplateQuery, TError, TData>
    ) =>
    useInfiniteQuery<JobsForPipelineTemplateQuery, TError, TData>(
      variables === undefined ? ['JobsForPipelineTemplate.infinite'] : ['JobsForPipelineTemplate.infinite', variables],
      (metaData) => fetcher<JobsForPipelineTemplateQuery, JobsForPipelineTemplateQueryVariables>(JobsForPipelineTemplateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteJobsForPipelineTemplateQuery.getKey = (variables?: JobsForPipelineTemplateQueryVariables) => variables === undefined ? ['JobsForPipelineTemplate.infinite'] : ['JobsForPipelineTemplate.infinite', variables];
;

useJobsForPipelineTemplateQuery.fetcher = (variables?: JobsForPipelineTemplateQueryVariables) => fetcher<JobsForPipelineTemplateQuery, JobsForPipelineTemplateQueryVariables>(JobsForPipelineTemplateDocument, variables);
export const CandidatePhotoManagementSettingsPageDocument = `
    query CandidatePhotoManagementSettingsPage {
  getOrg {
    ... on EmployerOrgNode {
      candidatePhotoManagementSettings {
        disableCandidatePhotoUpload
        disableCandidatePhotoSyncing
        hideUploadedCandidatePhotos
      }
    }
  }
}
    `;
export const useCandidatePhotoManagementSettingsPageQuery = <
      TData = CandidatePhotoManagementSettingsPageQuery,
      TError = unknown
    >(
      variables?: CandidatePhotoManagementSettingsPageQueryVariables,
      options?: UseQueryOptions<CandidatePhotoManagementSettingsPageQuery, TError, TData>
    ) =>
    useQuery<CandidatePhotoManagementSettingsPageQuery, TError, TData>(
      variables === undefined ? ['CandidatePhotoManagementSettingsPage'] : ['CandidatePhotoManagementSettingsPage', variables],
      fetcher<CandidatePhotoManagementSettingsPageQuery, CandidatePhotoManagementSettingsPageQueryVariables>(CandidatePhotoManagementSettingsPageDocument, variables),
      options
    );

useCandidatePhotoManagementSettingsPageQuery.getKey = (variables?: CandidatePhotoManagementSettingsPageQueryVariables) => variables === undefined ? ['CandidatePhotoManagementSettingsPage'] : ['CandidatePhotoManagementSettingsPage', variables];
;

export const useInfiniteCandidatePhotoManagementSettingsPageQuery = <
      TData = CandidatePhotoManagementSettingsPageQuery,
      TError = unknown
    >(
      pageParamKey: keyof CandidatePhotoManagementSettingsPageQueryVariables,
      variables?: CandidatePhotoManagementSettingsPageQueryVariables,
      options?: UseInfiniteQueryOptions<CandidatePhotoManagementSettingsPageQuery, TError, TData>
    ) =>
    useInfiniteQuery<CandidatePhotoManagementSettingsPageQuery, TError, TData>(
      variables === undefined ? ['CandidatePhotoManagementSettingsPage.infinite'] : ['CandidatePhotoManagementSettingsPage.infinite', variables],
      (metaData) => fetcher<CandidatePhotoManagementSettingsPageQuery, CandidatePhotoManagementSettingsPageQueryVariables>(CandidatePhotoManagementSettingsPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteCandidatePhotoManagementSettingsPageQuery.getKey = (variables?: CandidatePhotoManagementSettingsPageQueryVariables) => variables === undefined ? ['CandidatePhotoManagementSettingsPage.infinite'] : ['CandidatePhotoManagementSettingsPage.infinite', variables];
;

useCandidatePhotoManagementSettingsPageQuery.fetcher = (variables?: CandidatePhotoManagementSettingsPageQueryVariables) => fetcher<CandidatePhotoManagementSettingsPageQuery, CandidatePhotoManagementSettingsPageQueryVariables>(CandidatePhotoManagementSettingsPageDocument, variables);
export const UpdateCandidatePhotoManagementSettingsDocument = `
    mutation UpdateCandidatePhotoManagementSettings($input: UpdateOrgCandidatePhotoManagementSettingsInput!) {
  updateOrgCandidatePhotoManagementSettings(input: $input)
}
    `;
export const useUpdateCandidatePhotoManagementSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCandidatePhotoManagementSettingsMutation, TError, UpdateCandidatePhotoManagementSettingsMutationVariables, TContext>) =>
    useMutation<UpdateCandidatePhotoManagementSettingsMutation, TError, UpdateCandidatePhotoManagementSettingsMutationVariables, TContext>(
      ['UpdateCandidatePhotoManagementSettings'],
      (variables?: UpdateCandidatePhotoManagementSettingsMutationVariables) => fetcher<UpdateCandidatePhotoManagementSettingsMutation, UpdateCandidatePhotoManagementSettingsMutationVariables>(UpdateCandidatePhotoManagementSettingsDocument, variables)(),
      options
    );
useUpdateCandidatePhotoManagementSettingsMutation.fetcher = (variables: UpdateCandidatePhotoManagementSettingsMutationVariables) => fetcher<UpdateCandidatePhotoManagementSettingsMutation, UpdateCandidatePhotoManagementSettingsMutationVariables>(UpdateCandidatePhotoManagementSettingsDocument, variables);
export const InternalFieldQuestionsSettingsPageDocument = `
    query InternalFieldQuestionsSettingsPage {
  internalFieldQuestions {
    id
    title
    type
    options
    isDefaultQuestion
    showOnProfile
    showOnJobApplication
    archivedAt
    createdAt
    order
  }
}
    `;
export const useInternalFieldQuestionsSettingsPageQuery = <
      TData = InternalFieldQuestionsSettingsPageQuery,
      TError = unknown
    >(
      variables?: InternalFieldQuestionsSettingsPageQueryVariables,
      options?: UseQueryOptions<InternalFieldQuestionsSettingsPageQuery, TError, TData>
    ) =>
    useQuery<InternalFieldQuestionsSettingsPageQuery, TError, TData>(
      variables === undefined ? ['InternalFieldQuestionsSettingsPage'] : ['InternalFieldQuestionsSettingsPage', variables],
      fetcher<InternalFieldQuestionsSettingsPageQuery, InternalFieldQuestionsSettingsPageQueryVariables>(InternalFieldQuestionsSettingsPageDocument, variables),
      options
    );

useInternalFieldQuestionsSettingsPageQuery.getKey = (variables?: InternalFieldQuestionsSettingsPageQueryVariables) => variables === undefined ? ['InternalFieldQuestionsSettingsPage'] : ['InternalFieldQuestionsSettingsPage', variables];
;

export const useInfiniteInternalFieldQuestionsSettingsPageQuery = <
      TData = InternalFieldQuestionsSettingsPageQuery,
      TError = unknown
    >(
      pageParamKey: keyof InternalFieldQuestionsSettingsPageQueryVariables,
      variables?: InternalFieldQuestionsSettingsPageQueryVariables,
      options?: UseInfiniteQueryOptions<InternalFieldQuestionsSettingsPageQuery, TError, TData>
    ) =>
    useInfiniteQuery<InternalFieldQuestionsSettingsPageQuery, TError, TData>(
      variables === undefined ? ['InternalFieldQuestionsSettingsPage.infinite'] : ['InternalFieldQuestionsSettingsPage.infinite', variables],
      (metaData) => fetcher<InternalFieldQuestionsSettingsPageQuery, InternalFieldQuestionsSettingsPageQueryVariables>(InternalFieldQuestionsSettingsPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteInternalFieldQuestionsSettingsPageQuery.getKey = (variables?: InternalFieldQuestionsSettingsPageQueryVariables) => variables === undefined ? ['InternalFieldQuestionsSettingsPage.infinite'] : ['InternalFieldQuestionsSettingsPage.infinite', variables];
;

useInternalFieldQuestionsSettingsPageQuery.fetcher = (variables?: InternalFieldQuestionsSettingsPageQueryVariables) => fetcher<InternalFieldQuestionsSettingsPageQuery, InternalFieldQuestionsSettingsPageQueryVariables>(InternalFieldQuestionsSettingsPageDocument, variables);
export const UpsertInternalFieldQuestionDocument = `
    mutation UpsertInternalFieldQuestion($input: UpsertInternalFieldQuestionInput!) {
  upsertInternalFieldQuestion(input: $input)
}
    `;
export const useUpsertInternalFieldQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertInternalFieldQuestionMutation, TError, UpsertInternalFieldQuestionMutationVariables, TContext>) =>
    useMutation<UpsertInternalFieldQuestionMutation, TError, UpsertInternalFieldQuestionMutationVariables, TContext>(
      ['UpsertInternalFieldQuestion'],
      (variables?: UpsertInternalFieldQuestionMutationVariables) => fetcher<UpsertInternalFieldQuestionMutation, UpsertInternalFieldQuestionMutationVariables>(UpsertInternalFieldQuestionDocument, variables)(),
      options
    );
useUpsertInternalFieldQuestionMutation.fetcher = (variables: UpsertInternalFieldQuestionMutationVariables) => fetcher<UpsertInternalFieldQuestionMutation, UpsertInternalFieldQuestionMutationVariables>(UpsertInternalFieldQuestionDocument, variables);
export const ArchiveInternalFieldQuestionDocument = `
    mutation ArchiveInternalFieldQuestion($id: Int!) {
  archiveInternalFieldQuestion(id: $id)
}
    `;
export const useArchiveInternalFieldQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ArchiveInternalFieldQuestionMutation, TError, ArchiveInternalFieldQuestionMutationVariables, TContext>) =>
    useMutation<ArchiveInternalFieldQuestionMutation, TError, ArchiveInternalFieldQuestionMutationVariables, TContext>(
      ['ArchiveInternalFieldQuestion'],
      (variables?: ArchiveInternalFieldQuestionMutationVariables) => fetcher<ArchiveInternalFieldQuestionMutation, ArchiveInternalFieldQuestionMutationVariables>(ArchiveInternalFieldQuestionDocument, variables)(),
      options
    );
useArchiveInternalFieldQuestionMutation.fetcher = (variables: ArchiveInternalFieldQuestionMutationVariables) => fetcher<ArchiveInternalFieldQuestionMutation, ArchiveInternalFieldQuestionMutationVariables>(ArchiveInternalFieldQuestionDocument, variables);
export const UnarchiveInternalFieldQuestionDocument = `
    mutation UnarchiveInternalFieldQuestion($id: Int!) {
  unarchiveInternalFieldQuestion(id: $id)
}
    `;
export const useUnarchiveInternalFieldQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnarchiveInternalFieldQuestionMutation, TError, UnarchiveInternalFieldQuestionMutationVariables, TContext>) =>
    useMutation<UnarchiveInternalFieldQuestionMutation, TError, UnarchiveInternalFieldQuestionMutationVariables, TContext>(
      ['UnarchiveInternalFieldQuestion'],
      (variables?: UnarchiveInternalFieldQuestionMutationVariables) => fetcher<UnarchiveInternalFieldQuestionMutation, UnarchiveInternalFieldQuestionMutationVariables>(UnarchiveInternalFieldQuestionDocument, variables)(),
      options
    );
useUnarchiveInternalFieldQuestionMutation.fetcher = (variables: UnarchiveInternalFieldQuestionMutationVariables) => fetcher<UnarchiveInternalFieldQuestionMutation, UnarchiveInternalFieldQuestionMutationVariables>(UnarchiveInternalFieldQuestionDocument, variables);
export const UpdateInternalFieldsOrderDocument = `
    mutation UpdateInternalFieldsOrder($ids: [Int]!) {
  updateInternalFieldsOrder(ids: $ids)
}
    `;
export const useUpdateInternalFieldsOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateInternalFieldsOrderMutation, TError, UpdateInternalFieldsOrderMutationVariables, TContext>) =>
    useMutation<UpdateInternalFieldsOrderMutation, TError, UpdateInternalFieldsOrderMutationVariables, TContext>(
      ['UpdateInternalFieldsOrder'],
      (variables?: UpdateInternalFieldsOrderMutationVariables) => fetcher<UpdateInternalFieldsOrderMutation, UpdateInternalFieldsOrderMutationVariables>(UpdateInternalFieldsOrderDocument, variables)(),
      options
    );
useUpdateInternalFieldsOrderMutation.fetcher = (variables: UpdateInternalFieldsOrderMutationVariables) => fetcher<UpdateInternalFieldsOrderMutation, UpdateInternalFieldsOrderMutationVariables>(UpdateInternalFieldsOrderDocument, variables);
export const EmployerSettingsPageOrgOfficeLocationsDocument = `
    query EmployerSettingsPageOrgOfficeLocations {
  getOrg {
    __typename
    ... on EmployerOrgNode {
      __typename
      officeLocations {
        __typename
        nodes {
          __typename
          id
          name
        }
      }
    }
  }
}
    `;
export const useEmployerSettingsPageOrgOfficeLocationsQuery = <
      TData = EmployerSettingsPageOrgOfficeLocationsQuery,
      TError = unknown
    >(
      variables?: EmployerSettingsPageOrgOfficeLocationsQueryVariables,
      options?: UseQueryOptions<EmployerSettingsPageOrgOfficeLocationsQuery, TError, TData>
    ) =>
    useQuery<EmployerSettingsPageOrgOfficeLocationsQuery, TError, TData>(
      variables === undefined ? ['EmployerSettingsPageOrgOfficeLocations'] : ['EmployerSettingsPageOrgOfficeLocations', variables],
      fetcher<EmployerSettingsPageOrgOfficeLocationsQuery, EmployerSettingsPageOrgOfficeLocationsQueryVariables>(EmployerSettingsPageOrgOfficeLocationsDocument, variables),
      options
    );

useEmployerSettingsPageOrgOfficeLocationsQuery.getKey = (variables?: EmployerSettingsPageOrgOfficeLocationsQueryVariables) => variables === undefined ? ['EmployerSettingsPageOrgOfficeLocations'] : ['EmployerSettingsPageOrgOfficeLocations', variables];
;

export const useInfiniteEmployerSettingsPageOrgOfficeLocationsQuery = <
      TData = EmployerSettingsPageOrgOfficeLocationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof EmployerSettingsPageOrgOfficeLocationsQueryVariables,
      variables?: EmployerSettingsPageOrgOfficeLocationsQueryVariables,
      options?: UseInfiniteQueryOptions<EmployerSettingsPageOrgOfficeLocationsQuery, TError, TData>
    ) =>
    useInfiniteQuery<EmployerSettingsPageOrgOfficeLocationsQuery, TError, TData>(
      variables === undefined ? ['EmployerSettingsPageOrgOfficeLocations.infinite'] : ['EmployerSettingsPageOrgOfficeLocations.infinite', variables],
      (metaData) => fetcher<EmployerSettingsPageOrgOfficeLocationsQuery, EmployerSettingsPageOrgOfficeLocationsQueryVariables>(EmployerSettingsPageOrgOfficeLocationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEmployerSettingsPageOrgOfficeLocationsQuery.getKey = (variables?: EmployerSettingsPageOrgOfficeLocationsQueryVariables) => variables === undefined ? ['EmployerSettingsPageOrgOfficeLocations.infinite'] : ['EmployerSettingsPageOrgOfficeLocations.infinite', variables];
;

useEmployerSettingsPageOrgOfficeLocationsQuery.fetcher = (variables?: EmployerSettingsPageOrgOfficeLocationsQueryVariables) => fetcher<EmployerSettingsPageOrgOfficeLocationsQuery, EmployerSettingsPageOrgOfficeLocationsQueryVariables>(EmployerSettingsPageOrgOfficeLocationsDocument, variables);
export const AddOfficeToOrgDocument = `
    mutation AddOfficeToOrg($input: AddOfficeToOrgInput!) {
  addOfficeToOrg(input: $input) {
    success
  }
}
    `;
export const useAddOfficeToOrgMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddOfficeToOrgMutation, TError, AddOfficeToOrgMutationVariables, TContext>) =>
    useMutation<AddOfficeToOrgMutation, TError, AddOfficeToOrgMutationVariables, TContext>(
      ['AddOfficeToOrg'],
      (variables?: AddOfficeToOrgMutationVariables) => fetcher<AddOfficeToOrgMutation, AddOfficeToOrgMutationVariables>(AddOfficeToOrgDocument, variables)(),
      options
    );
useAddOfficeToOrgMutation.fetcher = (variables: AddOfficeToOrgMutationVariables) => fetcher<AddOfficeToOrgMutation, AddOfficeToOrgMutationVariables>(AddOfficeToOrgDocument, variables);
export const RemoveOfficeFromOrgDocument = `
    mutation RemoveOfficeFromOrg($input: RemoveOfficeFromOrgInput!) {
  removeOfficeFromOrg(input: $input) {
    success
  }
}
    `;
export const useRemoveOfficeFromOrgMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveOfficeFromOrgMutation, TError, RemoveOfficeFromOrgMutationVariables, TContext>) =>
    useMutation<RemoveOfficeFromOrgMutation, TError, RemoveOfficeFromOrgMutationVariables, TContext>(
      ['RemoveOfficeFromOrg'],
      (variables?: RemoveOfficeFromOrgMutationVariables) => fetcher<RemoveOfficeFromOrgMutation, RemoveOfficeFromOrgMutationVariables>(RemoveOfficeFromOrgDocument, variables)(),
      options
    );
useRemoveOfficeFromOrgMutation.fetcher = (variables: RemoveOfficeFromOrgMutationVariables) => fetcher<RemoveOfficeFromOrgMutation, RemoveOfficeFromOrgMutationVariables>(RemoveOfficeFromOrgDocument, variables);
export const SuperAdminCloseJobsListDocument = `
    query SuperAdminCloseJobsList($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $sortBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    nodes {
      ... on JobNode {
        ...SuperAdminCloseJobsJobFields
      }
    }
  }
}
    ${SuperAdminCloseJobsJobFieldsFragmentDoc}`;
export const useSuperAdminCloseJobsListQuery = <
      TData = SuperAdminCloseJobsListQuery,
      TError = unknown
    >(
      variables?: SuperAdminCloseJobsListQueryVariables,
      options?: UseQueryOptions<SuperAdminCloseJobsListQuery, TError, TData>
    ) =>
    useQuery<SuperAdminCloseJobsListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminCloseJobsList'] : ['SuperAdminCloseJobsList', variables],
      fetcher<SuperAdminCloseJobsListQuery, SuperAdminCloseJobsListQueryVariables>(SuperAdminCloseJobsListDocument, variables),
      options
    );

useSuperAdminCloseJobsListQuery.getKey = (variables?: SuperAdminCloseJobsListQueryVariables) => variables === undefined ? ['SuperAdminCloseJobsList'] : ['SuperAdminCloseJobsList', variables];
;

export const useInfiniteSuperAdminCloseJobsListQuery = <
      TData = SuperAdminCloseJobsListQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminCloseJobsListQueryVariables,
      variables?: SuperAdminCloseJobsListQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminCloseJobsListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminCloseJobsListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminCloseJobsList.infinite'] : ['SuperAdminCloseJobsList.infinite', variables],
      (metaData) => fetcher<SuperAdminCloseJobsListQuery, SuperAdminCloseJobsListQueryVariables>(SuperAdminCloseJobsListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminCloseJobsListQuery.getKey = (variables?: SuperAdminCloseJobsListQueryVariables) => variables === undefined ? ['SuperAdminCloseJobsList.infinite'] : ['SuperAdminCloseJobsList.infinite', variables];
;

useSuperAdminCloseJobsListQuery.fetcher = (variables?: SuperAdminCloseJobsListQueryVariables) => fetcher<SuperAdminCloseJobsListQuery, SuperAdminCloseJobsListQueryVariables>(SuperAdminCloseJobsListDocument, variables);
export const SuperAdminCloseJobsByIdDocument = `
    query SuperAdminCloseJobsById($ids: [ID!]!) {
  forwardJobsById(ids: $ids) {
    ...SuperAdminCloseJobsJobFields
  }
}
    ${SuperAdminCloseJobsJobFieldsFragmentDoc}`;
export const useSuperAdminCloseJobsByIdQuery = <
      TData = SuperAdminCloseJobsByIdQuery,
      TError = unknown
    >(
      variables: SuperAdminCloseJobsByIdQueryVariables,
      options?: UseQueryOptions<SuperAdminCloseJobsByIdQuery, TError, TData>
    ) =>
    useQuery<SuperAdminCloseJobsByIdQuery, TError, TData>(
      ['SuperAdminCloseJobsById', variables],
      fetcher<SuperAdminCloseJobsByIdQuery, SuperAdminCloseJobsByIdQueryVariables>(SuperAdminCloseJobsByIdDocument, variables),
      options
    );

useSuperAdminCloseJobsByIdQuery.getKey = (variables: SuperAdminCloseJobsByIdQueryVariables) => ['SuperAdminCloseJobsById', variables];
;

export const useInfiniteSuperAdminCloseJobsByIdQuery = <
      TData = SuperAdminCloseJobsByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminCloseJobsByIdQueryVariables,
      variables: SuperAdminCloseJobsByIdQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminCloseJobsByIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminCloseJobsByIdQuery, TError, TData>(
      ['SuperAdminCloseJobsById.infinite', variables],
      (metaData) => fetcher<SuperAdminCloseJobsByIdQuery, SuperAdminCloseJobsByIdQueryVariables>(SuperAdminCloseJobsByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminCloseJobsByIdQuery.getKey = (variables: SuperAdminCloseJobsByIdQueryVariables) => ['SuperAdminCloseJobsById.infinite', variables];
;

useSuperAdminCloseJobsByIdQuery.fetcher = (variables: SuperAdminCloseJobsByIdQueryVariables) => fetcher<SuperAdminCloseJobsByIdQuery, SuperAdminCloseJobsByIdQueryVariables>(SuperAdminCloseJobsByIdDocument, variables);
export const SuperAdminCloseJobsDocument = `
    mutation SuperAdminCloseJobs($closeJobsInput: SuperAdminCloseJobsInput!) {
  superAdminCloseJobs(input: $closeJobsInput) {
    success
  }
}
    `;
export const useSuperAdminCloseJobsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminCloseJobsMutation, TError, SuperAdminCloseJobsMutationVariables, TContext>) =>
    useMutation<SuperAdminCloseJobsMutation, TError, SuperAdminCloseJobsMutationVariables, TContext>(
      ['SuperAdminCloseJobs'],
      (variables?: SuperAdminCloseJobsMutationVariables) => fetcher<SuperAdminCloseJobsMutation, SuperAdminCloseJobsMutationVariables>(SuperAdminCloseJobsDocument, variables)(),
      options
    );
useSuperAdminCloseJobsMutation.fetcher = (variables: SuperAdminCloseJobsMutationVariables) => fetcher<SuperAdminCloseJobsMutation, SuperAdminCloseJobsMutationVariables>(SuperAdminCloseJobsDocument, variables);
export const SuperAdminFirmProfileCustomDocument = `
    query SuperAdminFirmProfileCustom($firmId: ID!) {
  firmProfileByFirmId(firmId: $firmId) {
    id
    orgId
    customSection {
      id
      orgId
      firmProfileId
      title
      answer
      coverImageSrc
      learnMoreLink {
        url
        display
      }
      isEnabled
      richMediaSubsection {
        ...SuperAdminFirmProfileRichMediaSubsection
      }
    }
  }
}
    ${SuperAdminFirmProfileRichMediaSubsectionFragmentDoc}`;
export const useSuperAdminFirmProfileCustomQuery = <
      TData = SuperAdminFirmProfileCustomQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfileCustomQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfileCustomQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfileCustomQuery, TError, TData>(
      ['SuperAdminFirmProfileCustom', variables],
      fetcher<SuperAdminFirmProfileCustomQuery, SuperAdminFirmProfileCustomQueryVariables>(SuperAdminFirmProfileCustomDocument, variables),
      options
    );

useSuperAdminFirmProfileCustomQuery.getKey = (variables: SuperAdminFirmProfileCustomQueryVariables) => ['SuperAdminFirmProfileCustom', variables];
;

export const useInfiniteSuperAdminFirmProfileCustomQuery = <
      TData = SuperAdminFirmProfileCustomQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfileCustomQueryVariables,
      variables: SuperAdminFirmProfileCustomQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfileCustomQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfileCustomQuery, TError, TData>(
      ['SuperAdminFirmProfileCustom.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfileCustomQuery, SuperAdminFirmProfileCustomQueryVariables>(SuperAdminFirmProfileCustomDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfileCustomQuery.getKey = (variables: SuperAdminFirmProfileCustomQueryVariables) => ['SuperAdminFirmProfileCustom.infinite', variables];
;

useSuperAdminFirmProfileCustomQuery.fetcher = (variables: SuperAdminFirmProfileCustomQueryVariables) => fetcher<SuperAdminFirmProfileCustomQuery, SuperAdminFirmProfileCustomQueryVariables>(SuperAdminFirmProfileCustomDocument, variables);
export const SuperAdminSubmitFirmProfileCustomSectionDocument = `
    mutation SuperAdminSubmitFirmProfileCustomSection($input: SuperAdminSubmitFirmProfileCustomSectionInput!) {
  superAdminSubmitFirmProfileCustomSection(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminSubmitFirmProfileCustomSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitFirmProfileCustomSectionMutation, TError, SuperAdminSubmitFirmProfileCustomSectionMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitFirmProfileCustomSectionMutation, TError, SuperAdminSubmitFirmProfileCustomSectionMutationVariables, TContext>(
      ['SuperAdminSubmitFirmProfileCustomSection'],
      (variables?: SuperAdminSubmitFirmProfileCustomSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfileCustomSectionMutation, SuperAdminSubmitFirmProfileCustomSectionMutationVariables>(SuperAdminSubmitFirmProfileCustomSectionDocument, variables)(),
      options
    );
useSuperAdminSubmitFirmProfileCustomSectionMutation.fetcher = (variables: SuperAdminSubmitFirmProfileCustomSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfileCustomSectionMutation, SuperAdminSubmitFirmProfileCustomSectionMutationVariables>(SuperAdminSubmitFirmProfileCustomSectionDocument, variables);
export const FirmProfileSelfIdDefaultsDocument = `
    query FirmProfileSelfIdDefaults {
  genderDefaults: selfIdDefaultsByType(type: GENDER_ID) {
    ...SelfIdDefault
    options {
      nodes {
        ...SelfIdDefaultOption
      }
    }
  }
  ethnicityDefaults: selfIdDefaultsByType(type: ETHNICITY_ID) {
    ...SelfIdDefault
    options {
      nodes {
        ...SelfIdDefaultOption
      }
    }
  }
  nalpAdditionalDefaults: selfIdDefaultsByType(type: NALP_ADDITIONAL) {
    ...SelfIdDefault
    options {
      nodes {
        ...SelfIdDefaultOption
      }
    }
  }
}
    ${SelfIdDefaultFragmentDoc}
${SelfIdDefaultOptionFragmentDoc}`;
export const useFirmProfileSelfIdDefaultsQuery = <
      TData = FirmProfileSelfIdDefaultsQuery,
      TError = unknown
    >(
      variables?: FirmProfileSelfIdDefaultsQueryVariables,
      options?: UseQueryOptions<FirmProfileSelfIdDefaultsQuery, TError, TData>
    ) =>
    useQuery<FirmProfileSelfIdDefaultsQuery, TError, TData>(
      variables === undefined ? ['FirmProfileSelfIdDefaults'] : ['FirmProfileSelfIdDefaults', variables],
      fetcher<FirmProfileSelfIdDefaultsQuery, FirmProfileSelfIdDefaultsQueryVariables>(FirmProfileSelfIdDefaultsDocument, variables),
      options
    );

useFirmProfileSelfIdDefaultsQuery.getKey = (variables?: FirmProfileSelfIdDefaultsQueryVariables) => variables === undefined ? ['FirmProfileSelfIdDefaults'] : ['FirmProfileSelfIdDefaults', variables];
;

export const useInfiniteFirmProfileSelfIdDefaultsQuery = <
      TData = FirmProfileSelfIdDefaultsQuery,
      TError = unknown
    >(
      pageParamKey: keyof FirmProfileSelfIdDefaultsQueryVariables,
      variables?: FirmProfileSelfIdDefaultsQueryVariables,
      options?: UseInfiniteQueryOptions<FirmProfileSelfIdDefaultsQuery, TError, TData>
    ) =>
    useInfiniteQuery<FirmProfileSelfIdDefaultsQuery, TError, TData>(
      variables === undefined ? ['FirmProfileSelfIdDefaults.infinite'] : ['FirmProfileSelfIdDefaults.infinite', variables],
      (metaData) => fetcher<FirmProfileSelfIdDefaultsQuery, FirmProfileSelfIdDefaultsQueryVariables>(FirmProfileSelfIdDefaultsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFirmProfileSelfIdDefaultsQuery.getKey = (variables?: FirmProfileSelfIdDefaultsQueryVariables) => variables === undefined ? ['FirmProfileSelfIdDefaults.infinite'] : ['FirmProfileSelfIdDefaults.infinite', variables];
;

useFirmProfileSelfIdDefaultsQuery.fetcher = (variables?: FirmProfileSelfIdDefaultsQueryVariables) => fetcher<FirmProfileSelfIdDefaultsQuery, FirmProfileSelfIdDefaultsQueryVariables>(FirmProfileSelfIdDefaultsDocument, variables);
export const SuperAdminFirmProfileDiversityAndInclusionDocument = `
    query SuperAdminFirmProfileDiversityAndInclusion($firmId: ID!) {
  firmProfileByFirmId(firmId: $firmId) {
    id
    orgId
    diversityAndInclusionSection {
      id
      orgId
      firmProfileId
      answer
      learnMoreLink
      genderStatisticsAsOf
      ethnicityStatisticsAsOf
      additionalStatisticsAsOf
      statistics {
        gender {
          ...SuperAdminFirmProfileDiversityStatistic
        }
        raceOrEthnicity {
          ...SuperAdminFirmProfileDiversityStatistic
        }
        additional {
          ...SuperAdminFirmProfileDiversityStatistic
        }
      }
      isEnabled
      richMediaSubsection {
        ...SuperAdminFirmProfileRichMediaSubsection
      }
    }
  }
}
    ${SuperAdminFirmProfileDiversityStatisticFragmentDoc}
${SuperAdminFirmProfileRichMediaSubsectionFragmentDoc}`;
export const useSuperAdminFirmProfileDiversityAndInclusionQuery = <
      TData = SuperAdminFirmProfileDiversityAndInclusionQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfileDiversityAndInclusionQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfileDiversityAndInclusionQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfileDiversityAndInclusionQuery, TError, TData>(
      ['SuperAdminFirmProfileDiversityAndInclusion', variables],
      fetcher<SuperAdminFirmProfileDiversityAndInclusionQuery, SuperAdminFirmProfileDiversityAndInclusionQueryVariables>(SuperAdminFirmProfileDiversityAndInclusionDocument, variables),
      options
    );

useSuperAdminFirmProfileDiversityAndInclusionQuery.getKey = (variables: SuperAdminFirmProfileDiversityAndInclusionQueryVariables) => ['SuperAdminFirmProfileDiversityAndInclusion', variables];
;

export const useInfiniteSuperAdminFirmProfileDiversityAndInclusionQuery = <
      TData = SuperAdminFirmProfileDiversityAndInclusionQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfileDiversityAndInclusionQueryVariables,
      variables: SuperAdminFirmProfileDiversityAndInclusionQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfileDiversityAndInclusionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfileDiversityAndInclusionQuery, TError, TData>(
      ['SuperAdminFirmProfileDiversityAndInclusion.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfileDiversityAndInclusionQuery, SuperAdminFirmProfileDiversityAndInclusionQueryVariables>(SuperAdminFirmProfileDiversityAndInclusionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfileDiversityAndInclusionQuery.getKey = (variables: SuperAdminFirmProfileDiversityAndInclusionQueryVariables) => ['SuperAdminFirmProfileDiversityAndInclusion.infinite', variables];
;

useSuperAdminFirmProfileDiversityAndInclusionQuery.fetcher = (variables: SuperAdminFirmProfileDiversityAndInclusionQueryVariables) => fetcher<SuperAdminFirmProfileDiversityAndInclusionQuery, SuperAdminFirmProfileDiversityAndInclusionQueryVariables>(SuperAdminFirmProfileDiversityAndInclusionDocument, variables);
export const SuperAdminSubmitDiversityAndInclusionDocument = `
    mutation SuperAdminSubmitDiversityAndInclusion($input: SuperAdminSubmitFirmProfileDiversityAndInclusionSectionInput!) {
  superAdminSubmitFirmProfileDiversityAndInclusionSection(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminSubmitDiversityAndInclusionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitDiversityAndInclusionMutation, TError, SuperAdminSubmitDiversityAndInclusionMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitDiversityAndInclusionMutation, TError, SuperAdminSubmitDiversityAndInclusionMutationVariables, TContext>(
      ['SuperAdminSubmitDiversityAndInclusion'],
      (variables?: SuperAdminSubmitDiversityAndInclusionMutationVariables) => fetcher<SuperAdminSubmitDiversityAndInclusionMutation, SuperAdminSubmitDiversityAndInclusionMutationVariables>(SuperAdminSubmitDiversityAndInclusionDocument, variables)(),
      options
    );
useSuperAdminSubmitDiversityAndInclusionMutation.fetcher = (variables: SuperAdminSubmitDiversityAndInclusionMutationVariables) => fetcher<SuperAdminSubmitDiversityAndInclusionMutation, SuperAdminSubmitDiversityAndInclusionMutationVariables>(SuperAdminSubmitDiversityAndInclusionDocument, variables);
export const SuperAdminFirmEventCarouselDocument = `
    query SuperAdminFirmEventCarousel($orgId: ID!) {
  publicOrgInfoByOrgId(orgId: $orgId) {
    firmProfile {
      eventCarousel {
        isEnabled
        firmCarouselEvents {
          pageInfo {
            startCursor
            endCursor
            hasNextPage
          }
          edges {
            cursor
            node {
              __typename
              id
              name
              start {
                date
                time
                zone
              }
              end {
                date
                time
                zone
              }
              host {
                orgId
                name
              }
              ... on CandidatePhysicalEventNode {
                university
                targetedSchools {
                  nodes {
                    id
                    name
                  }
                }
              }
              ... on CandidateWebinarEventNode {
                university
                targetedSchools {
                  nodes {
                    id
                    name
                  }
                }
              }
              ... on CandidateVirtualChatEventNode {
                university
                targetedSchools {
                  nodes {
                    id
                    name
                  }
                }
              }
            }
            metadata {
              carouselEventId
              isPinned
              ranking
            }
          }
        }
      }
    }
  }
}
    `;
export const useSuperAdminFirmEventCarouselQuery = <
      TData = SuperAdminFirmEventCarouselQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmEventCarouselQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmEventCarouselQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmEventCarouselQuery, TError, TData>(
      ['SuperAdminFirmEventCarousel', variables],
      fetcher<SuperAdminFirmEventCarouselQuery, SuperAdminFirmEventCarouselQueryVariables>(SuperAdminFirmEventCarouselDocument, variables),
      options
    );

useSuperAdminFirmEventCarouselQuery.getKey = (variables: SuperAdminFirmEventCarouselQueryVariables) => ['SuperAdminFirmEventCarousel', variables];
;

export const useInfiniteSuperAdminFirmEventCarouselQuery = <
      TData = SuperAdminFirmEventCarouselQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmEventCarouselQueryVariables,
      variables: SuperAdminFirmEventCarouselQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmEventCarouselQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmEventCarouselQuery, TError, TData>(
      ['SuperAdminFirmEventCarousel.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmEventCarouselQuery, SuperAdminFirmEventCarouselQueryVariables>(SuperAdminFirmEventCarouselDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmEventCarouselQuery.getKey = (variables: SuperAdminFirmEventCarouselQueryVariables) => ['SuperAdminFirmEventCarousel.infinite', variables];
;

useSuperAdminFirmEventCarouselQuery.fetcher = (variables: SuperAdminFirmEventCarouselQueryVariables) => fetcher<SuperAdminFirmEventCarouselQuery, SuperAdminFirmEventCarouselQueryVariables>(SuperAdminFirmEventCarouselDocument, variables);
export const SuperAdminSubmitEventCarouselSectionDocument = `
    mutation SuperAdminSubmitEventCarouselSection($enableInput: SuperAdminEnableEventCarouselInput!, $updateInput: SuperAdminUpdateEventCarouselRankingsInput!) {
  enablePayload: superAdminEnableEventCarousel(input: $enableInput) {
    success
  }
  updatePayload: superAdminUpdateEventCarouselRankings(input: $updateInput) {
    success
  }
}
    `;
export const useSuperAdminSubmitEventCarouselSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitEventCarouselSectionMutation, TError, SuperAdminSubmitEventCarouselSectionMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitEventCarouselSectionMutation, TError, SuperAdminSubmitEventCarouselSectionMutationVariables, TContext>(
      ['SuperAdminSubmitEventCarouselSection'],
      (variables?: SuperAdminSubmitEventCarouselSectionMutationVariables) => fetcher<SuperAdminSubmitEventCarouselSectionMutation, SuperAdminSubmitEventCarouselSectionMutationVariables>(SuperAdminSubmitEventCarouselSectionDocument, variables)(),
      options
    );
useSuperAdminSubmitEventCarouselSectionMutation.fetcher = (variables: SuperAdminSubmitEventCarouselSectionMutationVariables) => fetcher<SuperAdminSubmitEventCarouselSectionMutation, SuperAdminSubmitEventCarouselSectionMutationVariables>(SuperAdminSubmitEventCarouselSectionDocument, variables);
export const SuperAdminFirmProfileHighlightsDocument = `
    query SuperAdminFirmProfileHighlights($firmId: ID!) {
  firmProfileByFirmId(firmId: $firmId) {
    id
    orgId
    revenueDollars
    profitsPerPartnerDollars
    numPartnershipTiers
    numAssociates
    numPartners
    numCounsels
    bio
    bannerImageSrc
    websiteLinkUrl
    customLink {
      url
      display
    }
    socialMediaLinks {
      twitterUrl
      youtubeUrl
      facebookUrl
      instagramUrl
      linkedInUrl
    }
    isPublic
    daysInOfficePerWeek
    daysInOfficeContext
  }
}
    `;
export const useSuperAdminFirmProfileHighlightsQuery = <
      TData = SuperAdminFirmProfileHighlightsQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfileHighlightsQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfileHighlightsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfileHighlightsQuery, TError, TData>(
      ['SuperAdminFirmProfileHighlights', variables],
      fetcher<SuperAdminFirmProfileHighlightsQuery, SuperAdminFirmProfileHighlightsQueryVariables>(SuperAdminFirmProfileHighlightsDocument, variables),
      options
    );

useSuperAdminFirmProfileHighlightsQuery.getKey = (variables: SuperAdminFirmProfileHighlightsQueryVariables) => ['SuperAdminFirmProfileHighlights', variables];
;

export const useInfiniteSuperAdminFirmProfileHighlightsQuery = <
      TData = SuperAdminFirmProfileHighlightsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfileHighlightsQueryVariables,
      variables: SuperAdminFirmProfileHighlightsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfileHighlightsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfileHighlightsQuery, TError, TData>(
      ['SuperAdminFirmProfileHighlights.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfileHighlightsQuery, SuperAdminFirmProfileHighlightsQueryVariables>(SuperAdminFirmProfileHighlightsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfileHighlightsQuery.getKey = (variables: SuperAdminFirmProfileHighlightsQueryVariables) => ['SuperAdminFirmProfileHighlights.infinite', variables];
;

useSuperAdminFirmProfileHighlightsQuery.fetcher = (variables: SuperAdminFirmProfileHighlightsQueryVariables) => fetcher<SuperAdminFirmProfileHighlightsQuery, SuperAdminFirmProfileHighlightsQueryVariables>(SuperAdminFirmProfileHighlightsDocument, variables);
export const SuperAdminSubmitFirmProfileHighlightsDocument = `
    mutation SuperAdminSubmitFirmProfileHighlights($input: SuperAdminSubmitFirmProfileMainInput!) {
  superAdminSubmitFirmProfileMain(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminSubmitFirmProfileHighlightsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitFirmProfileHighlightsMutation, TError, SuperAdminSubmitFirmProfileHighlightsMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitFirmProfileHighlightsMutation, TError, SuperAdminSubmitFirmProfileHighlightsMutationVariables, TContext>(
      ['SuperAdminSubmitFirmProfileHighlights'],
      (variables?: SuperAdminSubmitFirmProfileHighlightsMutationVariables) => fetcher<SuperAdminSubmitFirmProfileHighlightsMutation, SuperAdminSubmitFirmProfileHighlightsMutationVariables>(SuperAdminSubmitFirmProfileHighlightsDocument, variables)(),
      options
    );
useSuperAdminSubmitFirmProfileHighlightsMutation.fetcher = (variables: SuperAdminSubmitFirmProfileHighlightsMutationVariables) => fetcher<SuperAdminSubmitFirmProfileHighlightsMutation, SuperAdminSubmitFirmProfileHighlightsMutationVariables>(SuperAdminSubmitFirmProfileHighlightsDocument, variables);
export const SuperAdminFirmProfilePracticeAreaSectionDocument = `
    query SuperAdminFirmProfilePracticeAreaSection($firmId: ID!) {
  firmProfileByFirmId(firmId: $firmId) {
    id
    orgId
    practiceAreaSection {
      id
      orgId
      firmProfileId
      answer
      learnMoreLink
      headcountsAsOf
      headcounts {
        numAssociates
        numCounsels
        numPartners
        numEntryLevelPlacements
        ranking
        orgId
        orgPracticeAreaId
        orgPracticeArea {
          id
          orgId
          firmSpecificName
        }
      }
      isEnabled
      richMediaSubsection {
        ...SuperAdminFirmProfileRichMediaSubsection
      }
    }
  }
}
    ${SuperAdminFirmProfileRichMediaSubsectionFragmentDoc}`;
export const useSuperAdminFirmProfilePracticeAreaSectionQuery = <
      TData = SuperAdminFirmProfilePracticeAreaSectionQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfilePracticeAreaSectionQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfilePracticeAreaSectionQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfilePracticeAreaSectionQuery, TError, TData>(
      ['SuperAdminFirmProfilePracticeAreaSection', variables],
      fetcher<SuperAdminFirmProfilePracticeAreaSectionQuery, SuperAdminFirmProfilePracticeAreaSectionQueryVariables>(SuperAdminFirmProfilePracticeAreaSectionDocument, variables),
      options
    );

useSuperAdminFirmProfilePracticeAreaSectionQuery.getKey = (variables: SuperAdminFirmProfilePracticeAreaSectionQueryVariables) => ['SuperAdminFirmProfilePracticeAreaSection', variables];
;

export const useInfiniteSuperAdminFirmProfilePracticeAreaSectionQuery = <
      TData = SuperAdminFirmProfilePracticeAreaSectionQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfilePracticeAreaSectionQueryVariables,
      variables: SuperAdminFirmProfilePracticeAreaSectionQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfilePracticeAreaSectionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfilePracticeAreaSectionQuery, TError, TData>(
      ['SuperAdminFirmProfilePracticeAreaSection.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfilePracticeAreaSectionQuery, SuperAdminFirmProfilePracticeAreaSectionQueryVariables>(SuperAdminFirmProfilePracticeAreaSectionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfilePracticeAreaSectionQuery.getKey = (variables: SuperAdminFirmProfilePracticeAreaSectionQueryVariables) => ['SuperAdminFirmProfilePracticeAreaSection.infinite', variables];
;

useSuperAdminFirmProfilePracticeAreaSectionQuery.fetcher = (variables: SuperAdminFirmProfilePracticeAreaSectionQueryVariables) => fetcher<SuperAdminFirmProfilePracticeAreaSectionQuery, SuperAdminFirmProfilePracticeAreaSectionQueryVariables>(SuperAdminFirmProfilePracticeAreaSectionDocument, variables);
export const SuperAdminSubmitFirmProfilePracticeAreaSectionDocument = `
    mutation SuperAdminSubmitFirmProfilePracticeAreaSection($input: SuperAdminSubmitFirmProfilePracticeAreaSectionInput!) {
  superAdminSubmitFirmProfilePracticeAreaSection(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminSubmitFirmProfilePracticeAreaSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitFirmProfilePracticeAreaSectionMutation, TError, SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitFirmProfilePracticeAreaSectionMutation, TError, SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables, TContext>(
      ['SuperAdminSubmitFirmProfilePracticeAreaSection'],
      (variables?: SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfilePracticeAreaSectionMutation, SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables>(SuperAdminSubmitFirmProfilePracticeAreaSectionDocument, variables)(),
      options
    );
useSuperAdminSubmitFirmProfilePracticeAreaSectionMutation.fetcher = (variables: SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfilePracticeAreaSectionMutation, SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables>(SuperAdminSubmitFirmProfilePracticeAreaSectionDocument, variables);
export const SuperAdminGetFirmPracticeAreasDocument = `
    query SuperAdminGetFirmPracticeAreas($orgId: ID!) {
  superAdminGetFirmPracticeAreas(orgId: $orgId) {
    nodes {
      id
      orgId
      firmSpecificName
      summerOffices {
        nodes {
          officeLocation {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const useSuperAdminGetFirmPracticeAreasQuery = <
      TData = SuperAdminGetFirmPracticeAreasQuery,
      TError = unknown
    >(
      variables: SuperAdminGetFirmPracticeAreasQueryVariables,
      options?: UseQueryOptions<SuperAdminGetFirmPracticeAreasQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetFirmPracticeAreasQuery, TError, TData>(
      ['SuperAdminGetFirmPracticeAreas', variables],
      fetcher<SuperAdminGetFirmPracticeAreasQuery, SuperAdminGetFirmPracticeAreasQueryVariables>(SuperAdminGetFirmPracticeAreasDocument, variables),
      options
    );

useSuperAdminGetFirmPracticeAreasQuery.getKey = (variables: SuperAdminGetFirmPracticeAreasQueryVariables) => ['SuperAdminGetFirmPracticeAreas', variables];
;

export const useInfiniteSuperAdminGetFirmPracticeAreasQuery = <
      TData = SuperAdminGetFirmPracticeAreasQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetFirmPracticeAreasQueryVariables,
      variables: SuperAdminGetFirmPracticeAreasQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetFirmPracticeAreasQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetFirmPracticeAreasQuery, TError, TData>(
      ['SuperAdminGetFirmPracticeAreas.infinite', variables],
      (metaData) => fetcher<SuperAdminGetFirmPracticeAreasQuery, SuperAdminGetFirmPracticeAreasQueryVariables>(SuperAdminGetFirmPracticeAreasDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetFirmPracticeAreasQuery.getKey = (variables: SuperAdminGetFirmPracticeAreasQueryVariables) => ['SuperAdminGetFirmPracticeAreas.infinite', variables];
;

useSuperAdminGetFirmPracticeAreasQuery.fetcher = (variables: SuperAdminGetFirmPracticeAreasQueryVariables) => fetcher<SuperAdminGetFirmPracticeAreasQuery, SuperAdminGetFirmPracticeAreasQueryVariables>(SuperAdminGetFirmPracticeAreasDocument, variables);
export const SuperAdminAddPracticeAreaToFirmDocument = `
    mutation SuperAdminAddPracticeAreaToFirm($addInput: SuperAdminAddPracticeAreaToFirmInput!) {
  superAdminAddPracticeAreaToFirm(input: $addInput) {
    success
  }
}
    `;
export const useSuperAdminAddPracticeAreaToFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddPracticeAreaToFirmMutation, TError, SuperAdminAddPracticeAreaToFirmMutationVariables, TContext>) =>
    useMutation<SuperAdminAddPracticeAreaToFirmMutation, TError, SuperAdminAddPracticeAreaToFirmMutationVariables, TContext>(
      ['SuperAdminAddPracticeAreaToFirm'],
      (variables?: SuperAdminAddPracticeAreaToFirmMutationVariables) => fetcher<SuperAdminAddPracticeAreaToFirmMutation, SuperAdminAddPracticeAreaToFirmMutationVariables>(SuperAdminAddPracticeAreaToFirmDocument, variables)(),
      options
    );
useSuperAdminAddPracticeAreaToFirmMutation.fetcher = (variables: SuperAdminAddPracticeAreaToFirmMutationVariables) => fetcher<SuperAdminAddPracticeAreaToFirmMutation, SuperAdminAddPracticeAreaToFirmMutationVariables>(SuperAdminAddPracticeAreaToFirmDocument, variables);
export const SuperAdminRemovePracticeAreaFromFirmDocument = `
    mutation SuperAdminRemovePracticeAreaFromFirm($removeInput: SuperAdminRemovePracticeAreaFromFirmInput!) {
  superAdminRemovePracticeAreaFromFirm(input: $removeInput) {
    success
  }
}
    `;
export const useSuperAdminRemovePracticeAreaFromFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminRemovePracticeAreaFromFirmMutation, TError, SuperAdminRemovePracticeAreaFromFirmMutationVariables, TContext>) =>
    useMutation<SuperAdminRemovePracticeAreaFromFirmMutation, TError, SuperAdminRemovePracticeAreaFromFirmMutationVariables, TContext>(
      ['SuperAdminRemovePracticeAreaFromFirm'],
      (variables?: SuperAdminRemovePracticeAreaFromFirmMutationVariables) => fetcher<SuperAdminRemovePracticeAreaFromFirmMutation, SuperAdminRemovePracticeAreaFromFirmMutationVariables>(SuperAdminRemovePracticeAreaFromFirmDocument, variables)(),
      options
    );
useSuperAdminRemovePracticeAreaFromFirmMutation.fetcher = (variables: SuperAdminRemovePracticeAreaFromFirmMutationVariables) => fetcher<SuperAdminRemovePracticeAreaFromFirmMutation, SuperAdminRemovePracticeAreaFromFirmMutationVariables>(SuperAdminRemovePracticeAreaFromFirmDocument, variables);
export const SuperAdminFirmProfilePreviewSectionDocument = `
    query SuperAdminFirmProfilePreviewSection($firmId: ID!) {
  firmProfileByFirmId(firmId: $firmId) {
    isPublic
  }
}
    `;
export const useSuperAdminFirmProfilePreviewSectionQuery = <
      TData = SuperAdminFirmProfilePreviewSectionQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfilePreviewSectionQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfilePreviewSectionQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfilePreviewSectionQuery, TError, TData>(
      ['SuperAdminFirmProfilePreviewSection', variables],
      fetcher<SuperAdminFirmProfilePreviewSectionQuery, SuperAdminFirmProfilePreviewSectionQueryVariables>(SuperAdminFirmProfilePreviewSectionDocument, variables),
      options
    );

useSuperAdminFirmProfilePreviewSectionQuery.getKey = (variables: SuperAdminFirmProfilePreviewSectionQueryVariables) => ['SuperAdminFirmProfilePreviewSection', variables];
;

export const useInfiniteSuperAdminFirmProfilePreviewSectionQuery = <
      TData = SuperAdminFirmProfilePreviewSectionQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfilePreviewSectionQueryVariables,
      variables: SuperAdminFirmProfilePreviewSectionQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfilePreviewSectionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfilePreviewSectionQuery, TError, TData>(
      ['SuperAdminFirmProfilePreviewSection.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfilePreviewSectionQuery, SuperAdminFirmProfilePreviewSectionQueryVariables>(SuperAdminFirmProfilePreviewSectionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfilePreviewSectionQuery.getKey = (variables: SuperAdminFirmProfilePreviewSectionQueryVariables) => ['SuperAdminFirmProfilePreviewSection.infinite', variables];
;

useSuperAdminFirmProfilePreviewSectionQuery.fetcher = (variables: SuperAdminFirmProfilePreviewSectionQueryVariables) => fetcher<SuperAdminFirmProfilePreviewSectionQuery, SuperAdminFirmProfilePreviewSectionQueryVariables>(SuperAdminFirmProfilePreviewSectionDocument, variables);
export const SuperAdminEditFirmProfileIsPublicDocument = `
    mutation SuperAdminEditFirmProfileIsPublic($input: SuperAdminSubmitFirmProfileIsPublicInput!) {
  superAdminSubmitFirmProfileIsPublic(input: $input) {
    success
  }
}
    `;
export const useSuperAdminEditFirmProfileIsPublicMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminEditFirmProfileIsPublicMutation, TError, SuperAdminEditFirmProfileIsPublicMutationVariables, TContext>) =>
    useMutation<SuperAdminEditFirmProfileIsPublicMutation, TError, SuperAdminEditFirmProfileIsPublicMutationVariables, TContext>(
      ['SuperAdminEditFirmProfileIsPublic'],
      (variables?: SuperAdminEditFirmProfileIsPublicMutationVariables) => fetcher<SuperAdminEditFirmProfileIsPublicMutation, SuperAdminEditFirmProfileIsPublicMutationVariables>(SuperAdminEditFirmProfileIsPublicDocument, variables)(),
      options
    );
useSuperAdminEditFirmProfileIsPublicMutation.fetcher = (variables: SuperAdminEditFirmProfileIsPublicMutationVariables) => fetcher<SuperAdminEditFirmProfileIsPublicMutation, SuperAdminEditFirmProfileIsPublicMutationVariables>(SuperAdminEditFirmProfileIsPublicDocument, variables);
export const SuperAdminFirmProfileProBonoDocument = `
    query SuperAdminFirmProfileProBono($firmId: ID!) {
  firmProfileByFirmId(firmId: $firmId) {
    id
    orgId
    proBonoSection {
      id
      orgId
      firmProfileId
      answer
      answer2
      learnMoreLink
      haveOpportunitiesForSummersOption
      areProBonoHoursBillable
      numBillableProBonoHours
      billableHoursContext
      participationPercentagesAsOf
      participationPercentage {
        associate
        partner
        otherLawyers
      }
      averageHoursAsOf
      averageHours {
        associate
        partner
        otherLawyers
      }
      isEnabled
      richMediaSubsection {
        ...SuperAdminFirmProfileRichMediaSubsection
      }
    }
  }
}
    ${SuperAdminFirmProfileRichMediaSubsectionFragmentDoc}`;
export const useSuperAdminFirmProfileProBonoQuery = <
      TData = SuperAdminFirmProfileProBonoQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfileProBonoQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfileProBonoQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfileProBonoQuery, TError, TData>(
      ['SuperAdminFirmProfileProBono', variables],
      fetcher<SuperAdminFirmProfileProBonoQuery, SuperAdminFirmProfileProBonoQueryVariables>(SuperAdminFirmProfileProBonoDocument, variables),
      options
    );

useSuperAdminFirmProfileProBonoQuery.getKey = (variables: SuperAdminFirmProfileProBonoQueryVariables) => ['SuperAdminFirmProfileProBono', variables];
;

export const useInfiniteSuperAdminFirmProfileProBonoQuery = <
      TData = SuperAdminFirmProfileProBonoQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfileProBonoQueryVariables,
      variables: SuperAdminFirmProfileProBonoQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfileProBonoQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfileProBonoQuery, TError, TData>(
      ['SuperAdminFirmProfileProBono.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfileProBonoQuery, SuperAdminFirmProfileProBonoQueryVariables>(SuperAdminFirmProfileProBonoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfileProBonoQuery.getKey = (variables: SuperAdminFirmProfileProBonoQueryVariables) => ['SuperAdminFirmProfileProBono.infinite', variables];
;

useSuperAdminFirmProfileProBonoQuery.fetcher = (variables: SuperAdminFirmProfileProBonoQueryVariables) => fetcher<SuperAdminFirmProfileProBonoQuery, SuperAdminFirmProfileProBonoQueryVariables>(SuperAdminFirmProfileProBonoDocument, variables);
export const SuperAdminSubmitFirmProfileProBonoSectionDocument = `
    mutation SuperAdminSubmitFirmProfileProBonoSection($input: SuperAdminSubmitFirmProfileProBonoSectionInput!) {
  superAdminSubmitFirmProfileProBonoSection(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminSubmitFirmProfileProBonoSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitFirmProfileProBonoSectionMutation, TError, SuperAdminSubmitFirmProfileProBonoSectionMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitFirmProfileProBonoSectionMutation, TError, SuperAdminSubmitFirmProfileProBonoSectionMutationVariables, TContext>(
      ['SuperAdminSubmitFirmProfileProBonoSection'],
      (variables?: SuperAdminSubmitFirmProfileProBonoSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfileProBonoSectionMutation, SuperAdminSubmitFirmProfileProBonoSectionMutationVariables>(SuperAdminSubmitFirmProfileProBonoSectionDocument, variables)(),
      options
    );
useSuperAdminSubmitFirmProfileProBonoSectionMutation.fetcher = (variables: SuperAdminSubmitFirmProfileProBonoSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfileProBonoSectionMutation, SuperAdminSubmitFirmProfileProBonoSectionMutationVariables>(SuperAdminSubmitFirmProfileProBonoSectionDocument, variables);
export const SuperAdminFirmProfileSummerProgramSectionDocument = `
    query SuperAdminFirmProfileSummerProgramSection($firmId: ID!) {
  firmProfileByFirmId(firmId: $firmId) {
    id
    orgId
    firm {
      firmPracticeAreas {
        nodes {
          id
          firmSpecificName
          summerOffices {
            nodes {
              id
              officeLocation {
                name
              }
            }
          }
        }
      }
    }
    summerProgramSection {
      id
      orgId
      firmProfileId
      primaryContact {
        name
        title
        email
      }
      answer
      noResponse
      summerSalary {
        value
        unit
      }
      programLength {
        value
        unit
      }
      summerCount1L
      summerCount2L
      summerCountsAsOf
      earlyInterviewAvailableOption
      resumeAcceptanceDeadline1L
      resumeAcceptanceText1L
      resumeAcceptanceDeadline2L
      resumeAcceptanceText2L
      assignedPracticeAreasOption
      firstYearHiredIntoPracticeAreaOption
      howIsWorkAssignedOption
      howIsWorkAssignedContext
      learnMoreLink
      hasSummerByPracticeDataToInput
      summerByPracticeContext
      summerTopPracticeAreasAsOf
      summerTopPracticeAreas {
        orgId
        orgPracticeAreaId
        numSummerAssociates
        orgPracticeArea {
          id
          orgId
          firmSpecificName
          summerOffices {
            nodes {
              id
              officeLocation {
                name
              }
            }
          }
        }
      }
      summerTopOfficeLocationsAsOf
      summerTopOfficeLocations {
        orgId
        orgOfficeId
        numSummerAssociate
        officeLocation {
          id
          name
        }
      }
      summerPracticeAreaByOfficeAsOf
      isEnabled
      richMediaSubsection {
        ...SuperAdminFirmProfileRichMediaSubsection
      }
    }
  }
}
    ${SuperAdminFirmProfileRichMediaSubsectionFragmentDoc}`;
export const useSuperAdminFirmProfileSummerProgramSectionQuery = <
      TData = SuperAdminFirmProfileSummerProgramSectionQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfileSummerProgramSectionQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfileSummerProgramSectionQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfileSummerProgramSectionQuery, TError, TData>(
      ['SuperAdminFirmProfileSummerProgramSection', variables],
      fetcher<SuperAdminFirmProfileSummerProgramSectionQuery, SuperAdminFirmProfileSummerProgramSectionQueryVariables>(SuperAdminFirmProfileSummerProgramSectionDocument, variables),
      options
    );

useSuperAdminFirmProfileSummerProgramSectionQuery.getKey = (variables: SuperAdminFirmProfileSummerProgramSectionQueryVariables) => ['SuperAdminFirmProfileSummerProgramSection', variables];
;

export const useInfiniteSuperAdminFirmProfileSummerProgramSectionQuery = <
      TData = SuperAdminFirmProfileSummerProgramSectionQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfileSummerProgramSectionQueryVariables,
      variables: SuperAdminFirmProfileSummerProgramSectionQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfileSummerProgramSectionQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfileSummerProgramSectionQuery, TError, TData>(
      ['SuperAdminFirmProfileSummerProgramSection.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfileSummerProgramSectionQuery, SuperAdminFirmProfileSummerProgramSectionQueryVariables>(SuperAdminFirmProfileSummerProgramSectionDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfileSummerProgramSectionQuery.getKey = (variables: SuperAdminFirmProfileSummerProgramSectionQueryVariables) => ['SuperAdminFirmProfileSummerProgramSection.infinite', variables];
;

useSuperAdminFirmProfileSummerProgramSectionQuery.fetcher = (variables: SuperAdminFirmProfileSummerProgramSectionQueryVariables) => fetcher<SuperAdminFirmProfileSummerProgramSectionQuery, SuperAdminFirmProfileSummerProgramSectionQueryVariables>(SuperAdminFirmProfileSummerProgramSectionDocument, variables);
export const SuperAdminSubmitFirmProfileSummerProgramSectionDocument = `
    mutation SuperAdminSubmitFirmProfileSummerProgramSection($input: SuperAdminSubmitFirmProfileSummerProgramSectionInput!) {
  superAdminSubmitFirmProfileSummerProgramSection(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminSubmitFirmProfileSummerProgramSectionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitFirmProfileSummerProgramSectionMutation, TError, SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitFirmProfileSummerProgramSectionMutation, TError, SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables, TContext>(
      ['SuperAdminSubmitFirmProfileSummerProgramSection'],
      (variables?: SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfileSummerProgramSectionMutation, SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables>(SuperAdminSubmitFirmProfileSummerProgramSectionDocument, variables)(),
      options
    );
useSuperAdminSubmitFirmProfileSummerProgramSectionMutation.fetcher = (variables: SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables) => fetcher<SuperAdminSubmitFirmProfileSummerProgramSectionMutation, SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables>(SuperAdminSubmitFirmProfileSummerProgramSectionDocument, variables);
export const SuperAdminFirmOfficesDocument = `
    query SuperAdminFirmOffices($orgId: ID!) {
  superAdminGetOfficesForFirm(orgId: $orgId) {
    id
    locationId
    name
  }
}
    `;
export const useSuperAdminFirmOfficesQuery = <
      TData = SuperAdminFirmOfficesQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmOfficesQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmOfficesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmOfficesQuery, TError, TData>(
      ['SuperAdminFirmOffices', variables],
      fetcher<SuperAdminFirmOfficesQuery, SuperAdminFirmOfficesQueryVariables>(SuperAdminFirmOfficesDocument, variables),
      options
    );

useSuperAdminFirmOfficesQuery.getKey = (variables: SuperAdminFirmOfficesQueryVariables) => ['SuperAdminFirmOffices', variables];
;

export const useInfiniteSuperAdminFirmOfficesQuery = <
      TData = SuperAdminFirmOfficesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmOfficesQueryVariables,
      variables: SuperAdminFirmOfficesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmOfficesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmOfficesQuery, TError, TData>(
      ['SuperAdminFirmOffices.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmOfficesQuery, SuperAdminFirmOfficesQueryVariables>(SuperAdminFirmOfficesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmOfficesQuery.getKey = (variables: SuperAdminFirmOfficesQueryVariables) => ['SuperAdminFirmOffices.infinite', variables];
;

useSuperAdminFirmOfficesQuery.fetcher = (variables: SuperAdminFirmOfficesQueryVariables) => fetcher<SuperAdminFirmOfficesQuery, SuperAdminFirmOfficesQueryVariables>(SuperAdminFirmOfficesDocument, variables);
export const OrgFriendlyNameByIdDocument = `
    query OrgFriendlyNameById($orgId: ID!) {
  publicOrgInfoByOrgId(orgId: $orgId) {
    urlFriendlyName
  }
}
    `;
export const useOrgFriendlyNameByIdQuery = <
      TData = OrgFriendlyNameByIdQuery,
      TError = unknown
    >(
      variables: OrgFriendlyNameByIdQueryVariables,
      options?: UseQueryOptions<OrgFriendlyNameByIdQuery, TError, TData>
    ) =>
    useQuery<OrgFriendlyNameByIdQuery, TError, TData>(
      ['OrgFriendlyNameById', variables],
      fetcher<OrgFriendlyNameByIdQuery, OrgFriendlyNameByIdQueryVariables>(OrgFriendlyNameByIdDocument, variables),
      options
    );

useOrgFriendlyNameByIdQuery.getKey = (variables: OrgFriendlyNameByIdQueryVariables) => ['OrgFriendlyNameById', variables];
;

export const useInfiniteOrgFriendlyNameByIdQuery = <
      TData = OrgFriendlyNameByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof OrgFriendlyNameByIdQueryVariables,
      variables: OrgFriendlyNameByIdQueryVariables,
      options?: UseInfiniteQueryOptions<OrgFriendlyNameByIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<OrgFriendlyNameByIdQuery, TError, TData>(
      ['OrgFriendlyNameById.infinite', variables],
      (metaData) => fetcher<OrgFriendlyNameByIdQuery, OrgFriendlyNameByIdQueryVariables>(OrgFriendlyNameByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteOrgFriendlyNameByIdQuery.getKey = (variables: OrgFriendlyNameByIdQueryVariables) => ['OrgFriendlyNameById.infinite', variables];
;

useOrgFriendlyNameByIdQuery.fetcher = (variables: OrgFriendlyNameByIdQueryVariables) => fetcher<OrgFriendlyNameByIdQuery, OrgFriendlyNameByIdQueryVariables>(OrgFriendlyNameByIdDocument, variables);
export const SuperAdminFirmProfileFormDocument = `
    query SuperAdminFirmProfileForm($firmId: ID!) {
  publicOrgInfoByOrgId(orgId: $firmId) {
    name
    forwardTier {
      asEnum
    }
  }
  firmProfileByFirmId(firmId: $firmId) {
    id
    summerProgramSection {
      id
    }
    diversityAndInclusionSection {
      id
    }
    practiceAreaSection {
      id
    }
    eventCarousel {
      id
    }
    proBonoSection {
      id
    }
    customSection {
      id
    }
  }
}
    `;
export const useSuperAdminFirmProfileFormQuery = <
      TData = SuperAdminFirmProfileFormQuery,
      TError = unknown
    >(
      variables: SuperAdminFirmProfileFormQueryVariables,
      options?: UseQueryOptions<SuperAdminFirmProfileFormQuery, TError, TData>
    ) =>
    useQuery<SuperAdminFirmProfileFormQuery, TError, TData>(
      ['SuperAdminFirmProfileForm', variables],
      fetcher<SuperAdminFirmProfileFormQuery, SuperAdminFirmProfileFormQueryVariables>(SuperAdminFirmProfileFormDocument, variables),
      options
    );

useSuperAdminFirmProfileFormQuery.getKey = (variables: SuperAdminFirmProfileFormQueryVariables) => ['SuperAdminFirmProfileForm', variables];
;

export const useInfiniteSuperAdminFirmProfileFormQuery = <
      TData = SuperAdminFirmProfileFormQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminFirmProfileFormQueryVariables,
      variables: SuperAdminFirmProfileFormQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminFirmProfileFormQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminFirmProfileFormQuery, TError, TData>(
      ['SuperAdminFirmProfileForm.infinite', variables],
      (metaData) => fetcher<SuperAdminFirmProfileFormQuery, SuperAdminFirmProfileFormQueryVariables>(SuperAdminFirmProfileFormDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminFirmProfileFormQuery.getKey = (variables: SuperAdminFirmProfileFormQueryVariables) => ['SuperAdminFirmProfileForm.infinite', variables];
;

useSuperAdminFirmProfileFormQuery.fetcher = (variables: SuperAdminFirmProfileFormQueryVariables) => fetcher<SuperAdminFirmProfileFormQuery, SuperAdminFirmProfileFormQueryVariables>(SuperAdminFirmProfileFormDocument, variables);
export const SuperAdminGetUpcomingOrgEventsDocument = `
    query SuperAdminGetUpcomingOrgEvents($orgId: ID!, $filterBy: EventDirectoryFilterBy, $sortBy: [EventDirectorySortBy!]) {
  publicOrgInfoByOrgId(orgId: $orgId) {
    name
  }
  eventDirectory(filterBy: $filterBy, sortBy: $sortBy) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        name
        start {
          date
          time
          zone
        }
        end {
          date
          time
          zone
        }
        __typename
        ... on CandidatePhysicalEventNode {
          university
          targetedSchools {
            nodes {
              id
              name
            }
          }
        }
        ... on CandidateWebinarEventNode {
          university
          targetedSchools {
            nodes {
              id
              name
            }
          }
        }
        ... on CandidateVirtualChatEventNode {
          university
          targetedSchools {
            nodes {
              id
              name
            }
          }
        }
      }
      metadata {
        eventDirectoryId
        isFeatured
      }
    }
  }
}
    `;
export const useSuperAdminGetUpcomingOrgEventsQuery = <
      TData = SuperAdminGetUpcomingOrgEventsQuery,
      TError = unknown
    >(
      variables: SuperAdminGetUpcomingOrgEventsQueryVariables,
      options?: UseQueryOptions<SuperAdminGetUpcomingOrgEventsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetUpcomingOrgEventsQuery, TError, TData>(
      ['SuperAdminGetUpcomingOrgEvents', variables],
      fetcher<SuperAdminGetUpcomingOrgEventsQuery, SuperAdminGetUpcomingOrgEventsQueryVariables>(SuperAdminGetUpcomingOrgEventsDocument, variables),
      options
    );

useSuperAdminGetUpcomingOrgEventsQuery.getKey = (variables: SuperAdminGetUpcomingOrgEventsQueryVariables) => ['SuperAdminGetUpcomingOrgEvents', variables];
;

export const useInfiniteSuperAdminGetUpcomingOrgEventsQuery = <
      TData = SuperAdminGetUpcomingOrgEventsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetUpcomingOrgEventsQueryVariables,
      variables: SuperAdminGetUpcomingOrgEventsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetUpcomingOrgEventsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetUpcomingOrgEventsQuery, TError, TData>(
      ['SuperAdminGetUpcomingOrgEvents.infinite', variables],
      (metaData) => fetcher<SuperAdminGetUpcomingOrgEventsQuery, SuperAdminGetUpcomingOrgEventsQueryVariables>(SuperAdminGetUpcomingOrgEventsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetUpcomingOrgEventsQuery.getKey = (variables: SuperAdminGetUpcomingOrgEventsQueryVariables) => ['SuperAdminGetUpcomingOrgEvents.infinite', variables];
;

useSuperAdminGetUpcomingOrgEventsQuery.fetcher = (variables: SuperAdminGetUpcomingOrgEventsQueryVariables) => fetcher<SuperAdminGetUpcomingOrgEventsQuery, SuperAdminGetUpcomingOrgEventsQueryVariables>(SuperAdminGetUpcomingOrgEventsDocument, variables);
export const SuperAdminGetUpcomingEventsDocument = `
    query SuperAdminGetUpcomingEvents($filterBy: EventDirectoryFilterBy, $sortBy: [EventDirectorySortBy!]) {
  eventDirectory(filterBy: $filterBy, sortBy: $sortBy) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        name
        start {
          date
          time
          zone
        }
        end {
          date
          time
          zone
        }
        host {
          id
          name
          logoUrl
        }
        __typename
      }
      metadata {
        eventDirectoryId
      }
    }
  }
}
    `;
export const useSuperAdminGetUpcomingEventsQuery = <
      TData = SuperAdminGetUpcomingEventsQuery,
      TError = unknown
    >(
      variables?: SuperAdminGetUpcomingEventsQueryVariables,
      options?: UseQueryOptions<SuperAdminGetUpcomingEventsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetUpcomingEventsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminGetUpcomingEvents'] : ['SuperAdminGetUpcomingEvents', variables],
      fetcher<SuperAdminGetUpcomingEventsQuery, SuperAdminGetUpcomingEventsQueryVariables>(SuperAdminGetUpcomingEventsDocument, variables),
      options
    );

useSuperAdminGetUpcomingEventsQuery.getKey = (variables?: SuperAdminGetUpcomingEventsQueryVariables) => variables === undefined ? ['SuperAdminGetUpcomingEvents'] : ['SuperAdminGetUpcomingEvents', variables];
;

export const useInfiniteSuperAdminGetUpcomingEventsQuery = <
      TData = SuperAdminGetUpcomingEventsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetUpcomingEventsQueryVariables,
      variables?: SuperAdminGetUpcomingEventsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetUpcomingEventsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetUpcomingEventsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminGetUpcomingEvents.infinite'] : ['SuperAdminGetUpcomingEvents.infinite', variables],
      (metaData) => fetcher<SuperAdminGetUpcomingEventsQuery, SuperAdminGetUpcomingEventsQueryVariables>(SuperAdminGetUpcomingEventsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetUpcomingEventsQuery.getKey = (variables?: SuperAdminGetUpcomingEventsQueryVariables) => variables === undefined ? ['SuperAdminGetUpcomingEvents.infinite'] : ['SuperAdminGetUpcomingEvents.infinite', variables];
;

useSuperAdminGetUpcomingEventsQuery.fetcher = (variables?: SuperAdminGetUpcomingEventsQueryVariables) => fetcher<SuperAdminGetUpcomingEventsQuery, SuperAdminGetUpcomingEventsQueryVariables>(SuperAdminGetUpcomingEventsDocument, variables);
export const SuperAdminUpdateOrgFeaturedEventsDocument = `
    mutation SuperAdminUpdateOrgFeaturedEvents($input: SuperAdminUpdateOrgFeaturedEventsInput!) {
  superAdminUpdateOrgFeaturedEvents(input: $input) {
    success
  }
}
    `;
export const useSuperAdminUpdateOrgFeaturedEventsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminUpdateOrgFeaturedEventsMutation, TError, SuperAdminUpdateOrgFeaturedEventsMutationVariables, TContext>) =>
    useMutation<SuperAdminUpdateOrgFeaturedEventsMutation, TError, SuperAdminUpdateOrgFeaturedEventsMutationVariables, TContext>(
      ['SuperAdminUpdateOrgFeaturedEvents'],
      (variables?: SuperAdminUpdateOrgFeaturedEventsMutationVariables) => fetcher<SuperAdminUpdateOrgFeaturedEventsMutation, SuperAdminUpdateOrgFeaturedEventsMutationVariables>(SuperAdminUpdateOrgFeaturedEventsDocument, variables)(),
      options
    );
useSuperAdminUpdateOrgFeaturedEventsMutation.fetcher = (variables: SuperAdminUpdateOrgFeaturedEventsMutationVariables) => fetcher<SuperAdminUpdateOrgFeaturedEventsMutation, SuperAdminUpdateOrgFeaturedEventsMutationVariables>(SuperAdminUpdateOrgFeaturedEventsDocument, variables);
export const SuperAdminSubmitForwardEventPublishingSettingsDocument = `
    mutation SuperAdminSubmitForwardEventPublishingSettings($input: SuperAdminSubmitForwardEventPublishingSettingsInput!) {
  superAdminSubmitForwardEventPublishingSettings(input: $input) {
    success
  }
}
    `;
export const useSuperAdminSubmitForwardEventPublishingSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitForwardEventPublishingSettingsMutation, TError, SuperAdminSubmitForwardEventPublishingSettingsMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitForwardEventPublishingSettingsMutation, TError, SuperAdminSubmitForwardEventPublishingSettingsMutationVariables, TContext>(
      ['SuperAdminSubmitForwardEventPublishingSettings'],
      (variables?: SuperAdminSubmitForwardEventPublishingSettingsMutationVariables) => fetcher<SuperAdminSubmitForwardEventPublishingSettingsMutation, SuperAdminSubmitForwardEventPublishingSettingsMutationVariables>(SuperAdminSubmitForwardEventPublishingSettingsDocument, variables)(),
      options
    );
useSuperAdminSubmitForwardEventPublishingSettingsMutation.fetcher = (variables: SuperAdminSubmitForwardEventPublishingSettingsMutationVariables) => fetcher<SuperAdminSubmitForwardEventPublishingSettingsMutation, SuperAdminSubmitForwardEventPublishingSettingsMutationVariables>(SuperAdminSubmitForwardEventPublishingSettingsDocument, variables);
export const SuperAdminForwardTierPanelFirmsDocument = `
    query SuperAdminForwardTierPanelFirms($first: Int, $after: String, $filterBy: FirmDirectoryFilterBy, $sortBy: [FirmDirectorySortBy!]) {
  firmDirectory(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    nodes {
      id
      name
      logoUrl
      urlFriendlyName
      forwardTier {
        id
        name
        asEnum
      }
      firmProfile {
        id
        isPublic
      }
    }
  }
}
    `;
export const useSuperAdminForwardTierPanelFirmsQuery = <
      TData = SuperAdminForwardTierPanelFirmsQuery,
      TError = unknown
    >(
      variables?: SuperAdminForwardTierPanelFirmsQueryVariables,
      options?: UseQueryOptions<SuperAdminForwardTierPanelFirmsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminForwardTierPanelFirmsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminForwardTierPanelFirms'] : ['SuperAdminForwardTierPanelFirms', variables],
      fetcher<SuperAdminForwardTierPanelFirmsQuery, SuperAdminForwardTierPanelFirmsQueryVariables>(SuperAdminForwardTierPanelFirmsDocument, variables),
      options
    );

useSuperAdminForwardTierPanelFirmsQuery.getKey = (variables?: SuperAdminForwardTierPanelFirmsQueryVariables) => variables === undefined ? ['SuperAdminForwardTierPanelFirms'] : ['SuperAdminForwardTierPanelFirms', variables];
;

export const useInfiniteSuperAdminForwardTierPanelFirmsQuery = <
      TData = SuperAdminForwardTierPanelFirmsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminForwardTierPanelFirmsQueryVariables,
      variables?: SuperAdminForwardTierPanelFirmsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminForwardTierPanelFirmsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminForwardTierPanelFirmsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminForwardTierPanelFirms.infinite'] : ['SuperAdminForwardTierPanelFirms.infinite', variables],
      (metaData) => fetcher<SuperAdminForwardTierPanelFirmsQuery, SuperAdminForwardTierPanelFirmsQueryVariables>(SuperAdminForwardTierPanelFirmsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminForwardTierPanelFirmsQuery.getKey = (variables?: SuperAdminForwardTierPanelFirmsQueryVariables) => variables === undefined ? ['SuperAdminForwardTierPanelFirms.infinite'] : ['SuperAdminForwardTierPanelFirms.infinite', variables];
;

useSuperAdminForwardTierPanelFirmsQuery.fetcher = (variables?: SuperAdminForwardTierPanelFirmsQueryVariables) => fetcher<SuperAdminForwardTierPanelFirmsQuery, SuperAdminForwardTierPanelFirmsQueryVariables>(SuperAdminForwardTierPanelFirmsDocument, variables);
export const SuperAdminUpdateForwardTierDocument = `
    mutation SuperAdminUpdateForwardTier($input: SuperAdminUpdateForwardTierInput!) {
  superAdminUpdateForwardTier(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminUpdateForwardTierMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminUpdateForwardTierMutation, TError, SuperAdminUpdateForwardTierMutationVariables, TContext>) =>
    useMutation<SuperAdminUpdateForwardTierMutation, TError, SuperAdminUpdateForwardTierMutationVariables, TContext>(
      ['SuperAdminUpdateForwardTier'],
      (variables?: SuperAdminUpdateForwardTierMutationVariables) => fetcher<SuperAdminUpdateForwardTierMutation, SuperAdminUpdateForwardTierMutationVariables>(SuperAdminUpdateForwardTierDocument, variables)(),
      options
    );
useSuperAdminUpdateForwardTierMutation.fetcher = (variables: SuperAdminUpdateForwardTierMutationVariables) => fetcher<SuperAdminUpdateForwardTierMutation, SuperAdminUpdateForwardTierMutationVariables>(SuperAdminUpdateForwardTierDocument, variables);
export const GenerateCandidateDocument = `
    mutation GenerateCandidate($orgId: Int!, $input: GenerateCandidateInput!) {
  superAdminGenerateCandidate(orgId: $orgId, input: $input) {
    id
    orgFriendlyName
    firstName
    lastName
    email
  }
}
    `;
export const useGenerateCandidateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateCandidateMutation, TError, GenerateCandidateMutationVariables, TContext>) =>
    useMutation<GenerateCandidateMutation, TError, GenerateCandidateMutationVariables, TContext>(
      ['GenerateCandidate'],
      (variables?: GenerateCandidateMutationVariables) => fetcher<GenerateCandidateMutation, GenerateCandidateMutationVariables>(GenerateCandidateDocument, variables)(),
      options
    );
useGenerateCandidateMutation.fetcher = (variables: GenerateCandidateMutationVariables) => fetcher<GenerateCandidateMutation, GenerateCandidateMutationVariables>(GenerateCandidateDocument, variables);
export const SuperAdminOrgForGenerateCandidatesDocument = `
    query SuperAdminOrgForGenerateCandidates($orgId: ID!) {
  superAdminGetOrg(orgId: $orgId) {
    ... on EmployerOrgNode {
      activeInternalFieldQuestions {
        id
        title
        showOnProfile
        showOnJobApplication
      }
      jobs {
        id
        title
        incomplete
      }
      organizingEvents {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
export const useSuperAdminOrgForGenerateCandidatesQuery = <
      TData = SuperAdminOrgForGenerateCandidatesQuery,
      TError = unknown
    >(
      variables: SuperAdminOrgForGenerateCandidatesQueryVariables,
      options?: UseQueryOptions<SuperAdminOrgForGenerateCandidatesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminOrgForGenerateCandidatesQuery, TError, TData>(
      ['SuperAdminOrgForGenerateCandidates', variables],
      fetcher<SuperAdminOrgForGenerateCandidatesQuery, SuperAdminOrgForGenerateCandidatesQueryVariables>(SuperAdminOrgForGenerateCandidatesDocument, variables),
      options
    );

useSuperAdminOrgForGenerateCandidatesQuery.getKey = (variables: SuperAdminOrgForGenerateCandidatesQueryVariables) => ['SuperAdminOrgForGenerateCandidates', variables];
;

export const useInfiniteSuperAdminOrgForGenerateCandidatesQuery = <
      TData = SuperAdminOrgForGenerateCandidatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminOrgForGenerateCandidatesQueryVariables,
      variables: SuperAdminOrgForGenerateCandidatesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminOrgForGenerateCandidatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminOrgForGenerateCandidatesQuery, TError, TData>(
      ['SuperAdminOrgForGenerateCandidates.infinite', variables],
      (metaData) => fetcher<SuperAdminOrgForGenerateCandidatesQuery, SuperAdminOrgForGenerateCandidatesQueryVariables>(SuperAdminOrgForGenerateCandidatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminOrgForGenerateCandidatesQuery.getKey = (variables: SuperAdminOrgForGenerateCandidatesQueryVariables) => ['SuperAdminOrgForGenerateCandidates.infinite', variables];
;

useSuperAdminOrgForGenerateCandidatesQuery.fetcher = (variables: SuperAdminOrgForGenerateCandidatesQueryVariables) => fetcher<SuperAdminOrgForGenerateCandidatesQuery, SuperAdminOrgForGenerateCandidatesQueryVariables>(SuperAdminOrgForGenerateCandidatesDocument, variables);
export const UpdateFlagUrlDocument = `
    mutation UpdateFlagUrl($key: String!, $url: String!) {
  updateFlagUrl(key: $key, url: $url)
}
    `;
export const useUpdateFlagUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateFlagUrlMutation, TError, UpdateFlagUrlMutationVariables, TContext>) =>
    useMutation<UpdateFlagUrlMutation, TError, UpdateFlagUrlMutationVariables, TContext>(
      ['UpdateFlagUrl'],
      (variables?: UpdateFlagUrlMutationVariables) => fetcher<UpdateFlagUrlMutation, UpdateFlagUrlMutationVariables>(UpdateFlagUrlDocument, variables)(),
      options
    );
useUpdateFlagUrlMutation.fetcher = (variables: UpdateFlagUrlMutationVariables) => fetcher<UpdateFlagUrlMutation, UpdateFlagUrlMutationVariables>(UpdateFlagUrlDocument, variables);
export const ToggleFlagDocument = `
    mutation ToggleFlag($key: String!) {
  toggleFlag(key: $key)
}
    `;
export const useToggleFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleFlagMutation, TError, ToggleFlagMutationVariables, TContext>) =>
    useMutation<ToggleFlagMutation, TError, ToggleFlagMutationVariables, TContext>(
      ['ToggleFlag'],
      (variables?: ToggleFlagMutationVariables) => fetcher<ToggleFlagMutation, ToggleFlagMutationVariables>(ToggleFlagDocument, variables)(),
      options
    );
useToggleFlagMutation.fetcher = (variables: ToggleFlagMutationVariables) => fetcher<ToggleFlagMutation, ToggleFlagMutationVariables>(ToggleFlagDocument, variables);
export const RemoveOrgDocument = `
    mutation RemoveOrg($key: String!, $orgId: Int!) {
  removeOrgFromFlag(key: $key, orgId: $orgId)
}
    `;
export const useRemoveOrgMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveOrgMutation, TError, RemoveOrgMutationVariables, TContext>) =>
    useMutation<RemoveOrgMutation, TError, RemoveOrgMutationVariables, TContext>(
      ['RemoveOrg'],
      (variables?: RemoveOrgMutationVariables) => fetcher<RemoveOrgMutation, RemoveOrgMutationVariables>(RemoveOrgDocument, variables)(),
      options
    );
useRemoveOrgMutation.fetcher = (variables: RemoveOrgMutationVariables) => fetcher<RemoveOrgMutation, RemoveOrgMutationVariables>(RemoveOrgDocument, variables);
export const AddOrgFlagDocument = `
    mutation AddOrgFlag($key: String!, $orgId: Int!) {
  addOrgToFlag(key: $key, orgId: $orgId)
}
    `;
export const useAddOrgFlagMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddOrgFlagMutation, TError, AddOrgFlagMutationVariables, TContext>) =>
    useMutation<AddOrgFlagMutation, TError, AddOrgFlagMutationVariables, TContext>(
      ['AddOrgFlag'],
      (variables?: AddOrgFlagMutationVariables) => fetcher<AddOrgFlagMutation, AddOrgFlagMutationVariables>(AddOrgFlagDocument, variables)(),
      options
    );
useAddOrgFlagMutation.fetcher = (variables: AddOrgFlagMutationVariables) => fetcher<AddOrgFlagMutation, AddOrgFlagMutationVariables>(AddOrgFlagDocument, variables);
export const FlagsDocument = `
    query Flags {
  flags {
    id
    name
    key
    url
    on
  }
}
    `;
export const useFlagsQuery = <
      TData = FlagsQuery,
      TError = unknown
    >(
      variables?: FlagsQueryVariables,
      options?: UseQueryOptions<FlagsQuery, TError, TData>
    ) =>
    useQuery<FlagsQuery, TError, TData>(
      variables === undefined ? ['Flags'] : ['Flags', variables],
      fetcher<FlagsQuery, FlagsQueryVariables>(FlagsDocument, variables),
      options
    );

useFlagsQuery.getKey = (variables?: FlagsQueryVariables) => variables === undefined ? ['Flags'] : ['Flags', variables];
;

export const useInfiniteFlagsQuery = <
      TData = FlagsQuery,
      TError = unknown
    >(
      pageParamKey: keyof FlagsQueryVariables,
      variables?: FlagsQueryVariables,
      options?: UseInfiniteQueryOptions<FlagsQuery, TError, TData>
    ) =>
    useInfiniteQuery<FlagsQuery, TError, TData>(
      variables === undefined ? ['Flags.infinite'] : ['Flags.infinite', variables],
      (metaData) => fetcher<FlagsQuery, FlagsQueryVariables>(FlagsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFlagsQuery.getKey = (variables?: FlagsQueryVariables) => variables === undefined ? ['Flags.infinite'] : ['Flags.infinite', variables];
;

useFlagsQuery.fetcher = (variables?: FlagsQueryVariables) => fetcher<FlagsQuery, FlagsQueryVariables>(FlagsDocument, variables);
export const FlagFromKeyDocument = `
    query FlagFromKey($key: String!) {
  flagFromKey(key: $key) {
    id
    name
    key
    url
    on
    orgEnabled
  }
}
    `;
export const useFlagFromKeyQuery = <
      TData = FlagFromKeyQuery,
      TError = unknown
    >(
      variables: FlagFromKeyQueryVariables,
      options?: UseQueryOptions<FlagFromKeyQuery, TError, TData>
    ) =>
    useQuery<FlagFromKeyQuery, TError, TData>(
      ['FlagFromKey', variables],
      fetcher<FlagFromKeyQuery, FlagFromKeyQueryVariables>(FlagFromKeyDocument, variables),
      options
    );

useFlagFromKeyQuery.getKey = (variables: FlagFromKeyQueryVariables) => ['FlagFromKey', variables];
;

export const useInfiniteFlagFromKeyQuery = <
      TData = FlagFromKeyQuery,
      TError = unknown
    >(
      pageParamKey: keyof FlagFromKeyQueryVariables,
      variables: FlagFromKeyQueryVariables,
      options?: UseInfiniteQueryOptions<FlagFromKeyQuery, TError, TData>
    ) =>
    useInfiniteQuery<FlagFromKeyQuery, TError, TData>(
      ['FlagFromKey.infinite', variables],
      (metaData) => fetcher<FlagFromKeyQuery, FlagFromKeyQueryVariables>(FlagFromKeyDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteFlagFromKeyQuery.getKey = (variables: FlagFromKeyQueryVariables) => ['FlagFromKey.infinite', variables];
;

useFlagFromKeyQuery.fetcher = (variables: FlagFromKeyQueryVariables) => fetcher<FlagFromKeyQuery, FlagFromKeyQueryVariables>(FlagFromKeyDocument, variables);
export const EnabledOrgsDocument = `
    query EnabledOrgs($key: String!) {
  flagFromKey(key: $key) {
    id
    enabledOrgIds
  }
}
    `;
export const useEnabledOrgsQuery = <
      TData = EnabledOrgsQuery,
      TError = unknown
    >(
      variables: EnabledOrgsQueryVariables,
      options?: UseQueryOptions<EnabledOrgsQuery, TError, TData>
    ) =>
    useQuery<EnabledOrgsQuery, TError, TData>(
      ['EnabledOrgs', variables],
      fetcher<EnabledOrgsQuery, EnabledOrgsQueryVariables>(EnabledOrgsDocument, variables),
      options
    );

useEnabledOrgsQuery.getKey = (variables: EnabledOrgsQueryVariables) => ['EnabledOrgs', variables];
;

export const useInfiniteEnabledOrgsQuery = <
      TData = EnabledOrgsQuery,
      TError = unknown
    >(
      pageParamKey: keyof EnabledOrgsQueryVariables,
      variables: EnabledOrgsQueryVariables,
      options?: UseInfiniteQueryOptions<EnabledOrgsQuery, TError, TData>
    ) =>
    useInfiniteQuery<EnabledOrgsQuery, TError, TData>(
      ['EnabledOrgs.infinite', variables],
      (metaData) => fetcher<EnabledOrgsQuery, EnabledOrgsQueryVariables>(EnabledOrgsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteEnabledOrgsQuery.getKey = (variables: EnabledOrgsQueryVariables) => ['EnabledOrgs.infinite', variables];
;

useEnabledOrgsQuery.fetcher = (variables: EnabledOrgsQueryVariables) => fetcher<EnabledOrgsQuery, EnabledOrgsQueryVariables>(EnabledOrgsDocument, variables);
export const SuperAdminExternalJobImportBatchesDocument = `
    query SuperAdminExternalJobImportBatches {
  superAdminExternalJobImportBatches {
    nodes {
      id
      importDate
      source
      processedJobsRatio {
        processed
        total
      }
    }
  }
}
    `;
export const useSuperAdminExternalJobImportBatchesQuery = <
      TData = SuperAdminExternalJobImportBatchesQuery,
      TError = unknown
    >(
      variables?: SuperAdminExternalJobImportBatchesQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobImportBatchesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobImportBatchesQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobImportBatches'] : ['SuperAdminExternalJobImportBatches', variables],
      fetcher<SuperAdminExternalJobImportBatchesQuery, SuperAdminExternalJobImportBatchesQueryVariables>(SuperAdminExternalJobImportBatchesDocument, variables),
      options
    );

useSuperAdminExternalJobImportBatchesQuery.getKey = (variables?: SuperAdminExternalJobImportBatchesQueryVariables) => variables === undefined ? ['SuperAdminExternalJobImportBatches'] : ['SuperAdminExternalJobImportBatches', variables];
;

export const useInfiniteSuperAdminExternalJobImportBatchesQuery = <
      TData = SuperAdminExternalJobImportBatchesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobImportBatchesQueryVariables,
      variables?: SuperAdminExternalJobImportBatchesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobImportBatchesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobImportBatchesQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobImportBatches.infinite'] : ['SuperAdminExternalJobImportBatches.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobImportBatchesQuery, SuperAdminExternalJobImportBatchesQueryVariables>(SuperAdminExternalJobImportBatchesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobImportBatchesQuery.getKey = (variables?: SuperAdminExternalJobImportBatchesQueryVariables) => variables === undefined ? ['SuperAdminExternalJobImportBatches.infinite'] : ['SuperAdminExternalJobImportBatches.infinite', variables];
;

useSuperAdminExternalJobImportBatchesQuery.fetcher = (variables?: SuperAdminExternalJobImportBatchesQueryVariables) => fetcher<SuperAdminExternalJobImportBatchesQuery, SuperAdminExternalJobImportBatchesQueryVariables>(SuperAdminExternalJobImportBatchesDocument, variables);
export const SuperAdminExternalJobImportBatchByIdDocument = `
    query SuperAdminExternalJobImportBatchById($id: ID!) {
  superAdminExternalJobImportBatchById(id: $id) {
    id
    importDate
    source
    processedJobsRatio {
      processed
      total
    }
    imports {
      nodes {
        id
        firmName
        jobTitle
        processingStatus
        jobId
      }
    }
  }
}
    `;
export const useSuperAdminExternalJobImportBatchByIdQuery = <
      TData = SuperAdminExternalJobImportBatchByIdQuery,
      TError = unknown
    >(
      variables: SuperAdminExternalJobImportBatchByIdQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobImportBatchByIdQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobImportBatchByIdQuery, TError, TData>(
      ['SuperAdminExternalJobImportBatchById', variables],
      fetcher<SuperAdminExternalJobImportBatchByIdQuery, SuperAdminExternalJobImportBatchByIdQueryVariables>(SuperAdminExternalJobImportBatchByIdDocument, variables),
      options
    );

useSuperAdminExternalJobImportBatchByIdQuery.getKey = (variables: SuperAdminExternalJobImportBatchByIdQueryVariables) => ['SuperAdminExternalJobImportBatchById', variables];
;

export const useInfiniteSuperAdminExternalJobImportBatchByIdQuery = <
      TData = SuperAdminExternalJobImportBatchByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobImportBatchByIdQueryVariables,
      variables: SuperAdminExternalJobImportBatchByIdQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobImportBatchByIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobImportBatchByIdQuery, TError, TData>(
      ['SuperAdminExternalJobImportBatchById.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobImportBatchByIdQuery, SuperAdminExternalJobImportBatchByIdQueryVariables>(SuperAdminExternalJobImportBatchByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobImportBatchByIdQuery.getKey = (variables: SuperAdminExternalJobImportBatchByIdQueryVariables) => ['SuperAdminExternalJobImportBatchById.infinite', variables];
;

useSuperAdminExternalJobImportBatchByIdQuery.fetcher = (variables: SuperAdminExternalJobImportBatchByIdQueryVariables) => fetcher<SuperAdminExternalJobImportBatchByIdQuery, SuperAdminExternalJobImportBatchByIdQueryVariables>(SuperAdminExternalJobImportBatchByIdDocument, variables);
export const SuperAdminExternalJobImportByIdDocument = `
    query SuperAdminExternalJobImportById($id: ID!) {
  superAdminExternalJobImportById(id: $id) {
    id
    batchId
    processingStatus
    jobId
    ...SuperAdminExternalJobImportCsvRow
  }
}
    ${SuperAdminExternalJobImportCsvRowFragmentDoc}`;
export const useSuperAdminExternalJobImportByIdQuery = <
      TData = SuperAdminExternalJobImportByIdQuery,
      TError = unknown
    >(
      variables: SuperAdminExternalJobImportByIdQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobImportByIdQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobImportByIdQuery, TError, TData>(
      ['SuperAdminExternalJobImportById', variables],
      fetcher<SuperAdminExternalJobImportByIdQuery, SuperAdminExternalJobImportByIdQueryVariables>(SuperAdminExternalJobImportByIdDocument, variables),
      options
    );

useSuperAdminExternalJobImportByIdQuery.getKey = (variables: SuperAdminExternalJobImportByIdQueryVariables) => ['SuperAdminExternalJobImportById', variables];
;

export const useInfiniteSuperAdminExternalJobImportByIdQuery = <
      TData = SuperAdminExternalJobImportByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobImportByIdQueryVariables,
      variables: SuperAdminExternalJobImportByIdQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobImportByIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobImportByIdQuery, TError, TData>(
      ['SuperAdminExternalJobImportById.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobImportByIdQuery, SuperAdminExternalJobImportByIdQueryVariables>(SuperAdminExternalJobImportByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobImportByIdQuery.getKey = (variables: SuperAdminExternalJobImportByIdQueryVariables) => ['SuperAdminExternalJobImportById.infinite', variables];
;

useSuperAdminExternalJobImportByIdQuery.fetcher = (variables: SuperAdminExternalJobImportByIdQueryVariables) => fetcher<SuperAdminExternalJobImportByIdQuery, SuperAdminExternalJobImportByIdQueryVariables>(SuperAdminExternalJobImportByIdDocument, variables);
export const SuperAdminExternalJobImportFirmIndependentDropdownDataDocument = `
    query SuperAdminExternalJobImportFirmIndependentDropdownData {
  superAdminGetExistingFirms {
    id
    name
  }
  allPracticeCategories {
    nodes {
      id
      name
    }
  }
}
    `;
export const useSuperAdminExternalJobImportFirmIndependentDropdownDataQuery = <
      TData = SuperAdminExternalJobImportFirmIndependentDropdownDataQuery,
      TError = unknown
    >(
      variables?: SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobImportFirmIndependentDropdownData'] : ['SuperAdminExternalJobImportFirmIndependentDropdownData', variables],
      fetcher<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables>(SuperAdminExternalJobImportFirmIndependentDropdownDataDocument, variables),
      options
    );

useSuperAdminExternalJobImportFirmIndependentDropdownDataQuery.getKey = (variables?: SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables) => variables === undefined ? ['SuperAdminExternalJobImportFirmIndependentDropdownData'] : ['SuperAdminExternalJobImportFirmIndependentDropdownData', variables];
;

export const useInfiniteSuperAdminExternalJobImportFirmIndependentDropdownDataQuery = <
      TData = SuperAdminExternalJobImportFirmIndependentDropdownDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables,
      variables?: SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobImportFirmIndependentDropdownData.infinite'] : ['SuperAdminExternalJobImportFirmIndependentDropdownData.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables>(SuperAdminExternalJobImportFirmIndependentDropdownDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobImportFirmIndependentDropdownDataQuery.getKey = (variables?: SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables) => variables === undefined ? ['SuperAdminExternalJobImportFirmIndependentDropdownData.infinite'] : ['SuperAdminExternalJobImportFirmIndependentDropdownData.infinite', variables];
;

useSuperAdminExternalJobImportFirmIndependentDropdownDataQuery.fetcher = (variables?: SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables) => fetcher<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables>(SuperAdminExternalJobImportFirmIndependentDropdownDataDocument, variables);
export const SuperAdminExternalJobImportFirmDependentDropdownDataDocument = `
    query SuperAdminExternalJobImportFirmDependentDropdownData($orgId: ID!) {
  publicOrgInfoByOrgId(orgId: $orgId) {
    isAtsCustomer
    forwardTier {
      asEnum
    }
  }
  superAdminGetOfficesForFirm(orgId: $orgId) {
    id
    name
  }
  superAdminGetDocumentsForFirm(orgId: $orgId) {
    id
    name
  }
}
    `;
export const useSuperAdminExternalJobImportFirmDependentDropdownDataQuery = <
      TData = SuperAdminExternalJobImportFirmDependentDropdownDataQuery,
      TError = unknown
    >(
      variables: SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, TError, TData>(
      ['SuperAdminExternalJobImportFirmDependentDropdownData', variables],
      fetcher<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables>(SuperAdminExternalJobImportFirmDependentDropdownDataDocument, variables),
      options
    );

useSuperAdminExternalJobImportFirmDependentDropdownDataQuery.getKey = (variables: SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables) => ['SuperAdminExternalJobImportFirmDependentDropdownData', variables];
;

export const useInfiniteSuperAdminExternalJobImportFirmDependentDropdownDataQuery = <
      TData = SuperAdminExternalJobImportFirmDependentDropdownDataQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables,
      variables: SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, TError, TData>(
      ['SuperAdminExternalJobImportFirmDependentDropdownData.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables>(SuperAdminExternalJobImportFirmDependentDropdownDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobImportFirmDependentDropdownDataQuery.getKey = (variables: SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables) => ['SuperAdminExternalJobImportFirmDependentDropdownData.infinite', variables];
;

useSuperAdminExternalJobImportFirmDependentDropdownDataQuery.fetcher = (variables: SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables) => fetcher<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables>(SuperAdminExternalJobImportFirmDependentDropdownDataDocument, variables);
export const SubmitExternalJobImportDocument = `
    mutation SubmitExternalJobImport($submitInput: SubmitAndMarkExternalJobImportAsCompletedInput!) {
  submitAndMarkExternalJobImportAsCompleted(input: $submitInput) {
    success
  }
}
    `;
export const useSubmitExternalJobImportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitExternalJobImportMutation, TError, SubmitExternalJobImportMutationVariables, TContext>) =>
    useMutation<SubmitExternalJobImportMutation, TError, SubmitExternalJobImportMutationVariables, TContext>(
      ['SubmitExternalJobImport'],
      (variables?: SubmitExternalJobImportMutationVariables) => fetcher<SubmitExternalJobImportMutation, SubmitExternalJobImportMutationVariables>(SubmitExternalJobImportDocument, variables)(),
      options
    );
useSubmitExternalJobImportMutation.fetcher = (variables: SubmitExternalJobImportMutationVariables) => fetcher<SubmitExternalJobImportMutation, SubmitExternalJobImportMutationVariables>(SubmitExternalJobImportDocument, variables);
export const ToggleExternalJobImportDoNotSubmitStatusDocument = `
    mutation ToggleExternalJobImportDoNotSubmitStatus($input: ToggleExternalJobImportDoNotSubmitStatusInput!) {
  toggleExternalJobImportDoNotSubmitStatus(input: $input) {
    success
  }
}
    `;
export const useToggleExternalJobImportDoNotSubmitStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleExternalJobImportDoNotSubmitStatusMutation, TError, ToggleExternalJobImportDoNotSubmitStatusMutationVariables, TContext>) =>
    useMutation<ToggleExternalJobImportDoNotSubmitStatusMutation, TError, ToggleExternalJobImportDoNotSubmitStatusMutationVariables, TContext>(
      ['ToggleExternalJobImportDoNotSubmitStatus'],
      (variables?: ToggleExternalJobImportDoNotSubmitStatusMutationVariables) => fetcher<ToggleExternalJobImportDoNotSubmitStatusMutation, ToggleExternalJobImportDoNotSubmitStatusMutationVariables>(ToggleExternalJobImportDoNotSubmitStatusDocument, variables)(),
      options
    );
useToggleExternalJobImportDoNotSubmitStatusMutation.fetcher = (variables: ToggleExternalJobImportDoNotSubmitStatusMutationVariables) => fetcher<ToggleExternalJobImportDoNotSubmitStatusMutation, ToggleExternalJobImportDoNotSubmitStatusMutationVariables>(ToggleExternalJobImportDoNotSubmitStatusDocument, variables);
export const SuperAdminAddLawSchoolDocument = `
    mutation SuperAdminAddLawSchool($input: SuperAdminCreateLawSchoolInput!) {
  superAdminCreateLawSchool(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminAddLawSchoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddLawSchoolMutation, TError, SuperAdminAddLawSchoolMutationVariables, TContext>) =>
    useMutation<SuperAdminAddLawSchoolMutation, TError, SuperAdminAddLawSchoolMutationVariables, TContext>(
      ['SuperAdminAddLawSchool'],
      (variables?: SuperAdminAddLawSchoolMutationVariables) => fetcher<SuperAdminAddLawSchoolMutation, SuperAdminAddLawSchoolMutationVariables>(SuperAdminAddLawSchoolDocument, variables)(),
      options
    );
useSuperAdminAddLawSchoolMutation.fetcher = (variables: SuperAdminAddLawSchoolMutationVariables) => fetcher<SuperAdminAddLawSchoolMutation, SuperAdminAddLawSchoolMutationVariables>(SuperAdminAddLawSchoolDocument, variables);
export const SuperAdminRenameLawSchoolDocument = `
    mutation SuperAdminRenameLawSchool($input: SuperAdminEditLawSchoolInput!) {
  superAdminEditLawSchool(input: $input) {
    success
  }
}
    `;
export const useSuperAdminRenameLawSchoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminRenameLawSchoolMutation, TError, SuperAdminRenameLawSchoolMutationVariables, TContext>) =>
    useMutation<SuperAdminRenameLawSchoolMutation, TError, SuperAdminRenameLawSchoolMutationVariables, TContext>(
      ['SuperAdminRenameLawSchool'],
      (variables?: SuperAdminRenameLawSchoolMutationVariables) => fetcher<SuperAdminRenameLawSchoolMutation, SuperAdminRenameLawSchoolMutationVariables>(SuperAdminRenameLawSchoolDocument, variables)(),
      options
    );
useSuperAdminRenameLawSchoolMutation.fetcher = (variables: SuperAdminRenameLawSchoolMutationVariables) => fetcher<SuperAdminRenameLawSchoolMutation, SuperAdminRenameLawSchoolMutationVariables>(SuperAdminRenameLawSchoolDocument, variables);
export const SuperAdminMergeLawSchoolDocument = `
    mutation SuperAdminMergeLawSchool($input: SuperAdminMergeLawSchoolInput!) {
  superAdminMergeLawSchool(input: $input) {
    success
  }
}
    `;
export const useSuperAdminMergeLawSchoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminMergeLawSchoolMutation, TError, SuperAdminMergeLawSchoolMutationVariables, TContext>) =>
    useMutation<SuperAdminMergeLawSchoolMutation, TError, SuperAdminMergeLawSchoolMutationVariables, TContext>(
      ['SuperAdminMergeLawSchool'],
      (variables?: SuperAdminMergeLawSchoolMutationVariables) => fetcher<SuperAdminMergeLawSchoolMutation, SuperAdminMergeLawSchoolMutationVariables>(SuperAdminMergeLawSchoolDocument, variables)(),
      options
    );
useSuperAdminMergeLawSchoolMutation.fetcher = (variables: SuperAdminMergeLawSchoolMutationVariables) => fetcher<SuperAdminMergeLawSchoolMutation, SuperAdminMergeLawSchoolMutationVariables>(SuperAdminMergeLawSchoolDocument, variables);
export const SuperAdminOutlierLawSchoolDataByNameDocument = `
    query SuperAdminOutlierLawSchoolDataByName {
  superAdminOutlierLawSchoolData {
    byName {
      outlierName
      lawSchoolQualifyingQuestionAnswerCount
      lawSchoolMemberAnswerCount
      jobAppEducationHistoryLawSchoolEntryCount
      eventLawSchoolCount
      universityDegreeLawSchoolCount
    }
  }
}
    `;
export const useSuperAdminOutlierLawSchoolDataByNameQuery = <
      TData = SuperAdminOutlierLawSchoolDataByNameQuery,
      TError = unknown
    >(
      variables?: SuperAdminOutlierLawSchoolDataByNameQueryVariables,
      options?: UseQueryOptions<SuperAdminOutlierLawSchoolDataByNameQuery, TError, TData>
    ) =>
    useQuery<SuperAdminOutlierLawSchoolDataByNameQuery, TError, TData>(
      variables === undefined ? ['SuperAdminOutlierLawSchoolDataByName'] : ['SuperAdminOutlierLawSchoolDataByName', variables],
      fetcher<SuperAdminOutlierLawSchoolDataByNameQuery, SuperAdminOutlierLawSchoolDataByNameQueryVariables>(SuperAdminOutlierLawSchoolDataByNameDocument, variables),
      options
    );

useSuperAdminOutlierLawSchoolDataByNameQuery.getKey = (variables?: SuperAdminOutlierLawSchoolDataByNameQueryVariables) => variables === undefined ? ['SuperAdminOutlierLawSchoolDataByName'] : ['SuperAdminOutlierLawSchoolDataByName', variables];
;

export const useInfiniteSuperAdminOutlierLawSchoolDataByNameQuery = <
      TData = SuperAdminOutlierLawSchoolDataByNameQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminOutlierLawSchoolDataByNameQueryVariables,
      variables?: SuperAdminOutlierLawSchoolDataByNameQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminOutlierLawSchoolDataByNameQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminOutlierLawSchoolDataByNameQuery, TError, TData>(
      variables === undefined ? ['SuperAdminOutlierLawSchoolDataByName.infinite'] : ['SuperAdminOutlierLawSchoolDataByName.infinite', variables],
      (metaData) => fetcher<SuperAdminOutlierLawSchoolDataByNameQuery, SuperAdminOutlierLawSchoolDataByNameQueryVariables>(SuperAdminOutlierLawSchoolDataByNameDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminOutlierLawSchoolDataByNameQuery.getKey = (variables?: SuperAdminOutlierLawSchoolDataByNameQueryVariables) => variables === undefined ? ['SuperAdminOutlierLawSchoolDataByName.infinite'] : ['SuperAdminOutlierLawSchoolDataByName.infinite', variables];
;

useSuperAdminOutlierLawSchoolDataByNameQuery.fetcher = (variables?: SuperAdminOutlierLawSchoolDataByNameQueryVariables) => fetcher<SuperAdminOutlierLawSchoolDataByNameQuery, SuperAdminOutlierLawSchoolDataByNameQueryVariables>(SuperAdminOutlierLawSchoolDataByNameDocument, variables);
export const SuperAdminAssignOutlierLawSchoolDataDocument = `
    mutation SuperAdminAssignOutlierLawSchoolData($input: SuperAdminAssignOutlierLawSchoolDataInput!) {
  superAdminAssignOutlierLawSchoolData(input: $input) {
    success
  }
}
    `;
export const useSuperAdminAssignOutlierLawSchoolDataMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAssignOutlierLawSchoolDataMutation, TError, SuperAdminAssignOutlierLawSchoolDataMutationVariables, TContext>) =>
    useMutation<SuperAdminAssignOutlierLawSchoolDataMutation, TError, SuperAdminAssignOutlierLawSchoolDataMutationVariables, TContext>(
      ['SuperAdminAssignOutlierLawSchoolData'],
      (variables?: SuperAdminAssignOutlierLawSchoolDataMutationVariables) => fetcher<SuperAdminAssignOutlierLawSchoolDataMutation, SuperAdminAssignOutlierLawSchoolDataMutationVariables>(SuperAdminAssignOutlierLawSchoolDataDocument, variables)(),
      options
    );
useSuperAdminAssignOutlierLawSchoolDataMutation.fetcher = (variables: SuperAdminAssignOutlierLawSchoolDataMutationVariables) => fetcher<SuperAdminAssignOutlierLawSchoolDataMutation, SuperAdminAssignOutlierLawSchoolDataMutationVariables>(SuperAdminAssignOutlierLawSchoolDataDocument, variables);
export const LawSchoolsWithDomainsDocument = `
    query LawSchoolsWithDomains {
  allLawSchools {
    nodes {
      id
      name
      emailDomains
    }
  }
}
    `;
export const useLawSchoolsWithDomainsQuery = <
      TData = LawSchoolsWithDomainsQuery,
      TError = unknown
    >(
      variables?: LawSchoolsWithDomainsQueryVariables,
      options?: UseQueryOptions<LawSchoolsWithDomainsQuery, TError, TData>
    ) =>
    useQuery<LawSchoolsWithDomainsQuery, TError, TData>(
      variables === undefined ? ['LawSchoolsWithDomains'] : ['LawSchoolsWithDomains', variables],
      fetcher<LawSchoolsWithDomainsQuery, LawSchoolsWithDomainsQueryVariables>(LawSchoolsWithDomainsDocument, variables),
      options
    );

useLawSchoolsWithDomainsQuery.getKey = (variables?: LawSchoolsWithDomainsQueryVariables) => variables === undefined ? ['LawSchoolsWithDomains'] : ['LawSchoolsWithDomains', variables];
;

export const useInfiniteLawSchoolsWithDomainsQuery = <
      TData = LawSchoolsWithDomainsQuery,
      TError = unknown
    >(
      pageParamKey: keyof LawSchoolsWithDomainsQueryVariables,
      variables?: LawSchoolsWithDomainsQueryVariables,
      options?: UseInfiniteQueryOptions<LawSchoolsWithDomainsQuery, TError, TData>
    ) =>
    useInfiniteQuery<LawSchoolsWithDomainsQuery, TError, TData>(
      variables === undefined ? ['LawSchoolsWithDomains.infinite'] : ['LawSchoolsWithDomains.infinite', variables],
      (metaData) => fetcher<LawSchoolsWithDomainsQuery, LawSchoolsWithDomainsQueryVariables>(LawSchoolsWithDomainsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteLawSchoolsWithDomainsQuery.getKey = (variables?: LawSchoolsWithDomainsQueryVariables) => variables === undefined ? ['LawSchoolsWithDomains.infinite'] : ['LawSchoolsWithDomains.infinite', variables];
;

useLawSchoolsWithDomainsQuery.fetcher = (variables?: LawSchoolsWithDomainsQueryVariables) => fetcher<LawSchoolsWithDomainsQuery, LawSchoolsWithDomainsQueryVariables>(LawSchoolsWithDomainsDocument, variables);
export const SuperAdminSubmitEmailDomainsForSchoolDocument = `
    mutation SuperAdminSubmitEmailDomainsForSchool($input: SuperAdminSubmitEmailDomainsForSchoolInput!) {
  superAdminSubmitEmailDomainsForSchool(input: $input) {
    success
  }
}
    `;
export const useSuperAdminSubmitEmailDomainsForSchoolMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitEmailDomainsForSchoolMutation, TError, SuperAdminSubmitEmailDomainsForSchoolMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitEmailDomainsForSchoolMutation, TError, SuperAdminSubmitEmailDomainsForSchoolMutationVariables, TContext>(
      ['SuperAdminSubmitEmailDomainsForSchool'],
      (variables?: SuperAdminSubmitEmailDomainsForSchoolMutationVariables) => fetcher<SuperAdminSubmitEmailDomainsForSchoolMutation, SuperAdminSubmitEmailDomainsForSchoolMutationVariables>(SuperAdminSubmitEmailDomainsForSchoolDocument, variables)(),
      options
    );
useSuperAdminSubmitEmailDomainsForSchoolMutation.fetcher = (variables: SuperAdminSubmitEmailDomainsForSchoolMutationVariables) => fetcher<SuperAdminSubmitEmailDomainsForSchoolMutation, SuperAdminSubmitEmailDomainsForSchoolMutationVariables>(SuperAdminSubmitEmailDomainsForSchoolDocument, variables);
export const SuperAdminAddOfficeLocationDocument = `
    mutation SuperAdminAddOfficeLocation($input: SuperAdminCreateOfficeLocationInput!) {
  superAdminCreateOfficeLocation(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminAddOfficeLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddOfficeLocationMutation, TError, SuperAdminAddOfficeLocationMutationVariables, TContext>) =>
    useMutation<SuperAdminAddOfficeLocationMutation, TError, SuperAdminAddOfficeLocationMutationVariables, TContext>(
      ['SuperAdminAddOfficeLocation'],
      (variables?: SuperAdminAddOfficeLocationMutationVariables) => fetcher<SuperAdminAddOfficeLocationMutation, SuperAdminAddOfficeLocationMutationVariables>(SuperAdminAddOfficeLocationDocument, variables)(),
      options
    );
useSuperAdminAddOfficeLocationMutation.fetcher = (variables: SuperAdminAddOfficeLocationMutationVariables) => fetcher<SuperAdminAddOfficeLocationMutation, SuperAdminAddOfficeLocationMutationVariables>(SuperAdminAddOfficeLocationDocument, variables);
export const SuperAdminRenameOfficeLocationDocument = `
    mutation SuperAdminRenameOfficeLocation($input: SuperAdminEditOfficeLocationInput!) {
  superAdminEditOfficeLocation(input: $input) {
    success
  }
}
    `;
export const useSuperAdminRenameOfficeLocationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminRenameOfficeLocationMutation, TError, SuperAdminRenameOfficeLocationMutationVariables, TContext>) =>
    useMutation<SuperAdminRenameOfficeLocationMutation, TError, SuperAdminRenameOfficeLocationMutationVariables, TContext>(
      ['SuperAdminRenameOfficeLocation'],
      (variables?: SuperAdminRenameOfficeLocationMutationVariables) => fetcher<SuperAdminRenameOfficeLocationMutation, SuperAdminRenameOfficeLocationMutationVariables>(SuperAdminRenameOfficeLocationDocument, variables)(),
      options
    );
useSuperAdminRenameOfficeLocationMutation.fetcher = (variables: SuperAdminRenameOfficeLocationMutationVariables) => fetcher<SuperAdminRenameOfficeLocationMutation, SuperAdminRenameOfficeLocationMutationVariables>(SuperAdminRenameOfficeLocationDocument, variables);
export const SuperAdminAddPracticeAreaDocument = `
    mutation SuperAdminAddPracticeArea($input: SuperAdminCreatePracticeAreaInput!) {
  superAdminCreatePracticeArea(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminAddPracticeAreaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddPracticeAreaMutation, TError, SuperAdminAddPracticeAreaMutationVariables, TContext>) =>
    useMutation<SuperAdminAddPracticeAreaMutation, TError, SuperAdminAddPracticeAreaMutationVariables, TContext>(
      ['SuperAdminAddPracticeArea'],
      (variables?: SuperAdminAddPracticeAreaMutationVariables) => fetcher<SuperAdminAddPracticeAreaMutation, SuperAdminAddPracticeAreaMutationVariables>(SuperAdminAddPracticeAreaDocument, variables)(),
      options
    );
useSuperAdminAddPracticeAreaMutation.fetcher = (variables: SuperAdminAddPracticeAreaMutationVariables) => fetcher<SuperAdminAddPracticeAreaMutation, SuperAdminAddPracticeAreaMutationVariables>(SuperAdminAddPracticeAreaDocument, variables);
export const SuperAdminRenamePracticeAreaDocument = `
    mutation SuperAdminRenamePracticeArea($input: SuperAdminEditPracticeAreaInput!) {
  superAdminEditPracticeArea(input: $input) {
    success
  }
}
    `;
export const useSuperAdminRenamePracticeAreaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminRenamePracticeAreaMutation, TError, SuperAdminRenamePracticeAreaMutationVariables, TContext>) =>
    useMutation<SuperAdminRenamePracticeAreaMutation, TError, SuperAdminRenamePracticeAreaMutationVariables, TContext>(
      ['SuperAdminRenamePracticeArea'],
      (variables?: SuperAdminRenamePracticeAreaMutationVariables) => fetcher<SuperAdminRenamePracticeAreaMutation, SuperAdminRenamePracticeAreaMutationVariables>(SuperAdminRenamePracticeAreaDocument, variables)(),
      options
    );
useSuperAdminRenamePracticeAreaMutation.fetcher = (variables: SuperAdminRenamePracticeAreaMutationVariables) => fetcher<SuperAdminRenamePracticeAreaMutation, SuperAdminRenamePracticeAreaMutationVariables>(SuperAdminRenamePracticeAreaDocument, variables);
export const SuperAdminAddPracticeCategoryDocument = `
    mutation SuperAdminAddPracticeCategory($input: SuperAdminCreatePracticeCategoryInput!) {
  superAdminCreatePracticeCategory(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminAddPracticeCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddPracticeCategoryMutation, TError, SuperAdminAddPracticeCategoryMutationVariables, TContext>) =>
    useMutation<SuperAdminAddPracticeCategoryMutation, TError, SuperAdminAddPracticeCategoryMutationVariables, TContext>(
      ['SuperAdminAddPracticeCategory'],
      (variables?: SuperAdminAddPracticeCategoryMutationVariables) => fetcher<SuperAdminAddPracticeCategoryMutation, SuperAdminAddPracticeCategoryMutationVariables>(SuperAdminAddPracticeCategoryDocument, variables)(),
      options
    );
useSuperAdminAddPracticeCategoryMutation.fetcher = (variables: SuperAdminAddPracticeCategoryMutationVariables) => fetcher<SuperAdminAddPracticeCategoryMutation, SuperAdminAddPracticeCategoryMutationVariables>(SuperAdminAddPracticeCategoryDocument, variables);
export const SuperAdminRenamePracticeCategoryDocument = `
    mutation SuperAdminRenamePracticeCategory($input: SuperAdminEditPracticeCategoryInput!) {
  superAdminEditPracticeCategory(input: $input) {
    success
  }
}
    `;
export const useSuperAdminRenamePracticeCategoryMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminRenamePracticeCategoryMutation, TError, SuperAdminRenamePracticeCategoryMutationVariables, TContext>) =>
    useMutation<SuperAdminRenamePracticeCategoryMutation, TError, SuperAdminRenamePracticeCategoryMutationVariables, TContext>(
      ['SuperAdminRenamePracticeCategory'],
      (variables?: SuperAdminRenamePracticeCategoryMutationVariables) => fetcher<SuperAdminRenamePracticeCategoryMutation, SuperAdminRenamePracticeCategoryMutationVariables>(SuperAdminRenamePracticeCategoryDocument, variables)(),
      options
    );
useSuperAdminRenamePracticeCategoryMutation.fetcher = (variables: SuperAdminRenamePracticeCategoryMutationVariables) => fetcher<SuperAdminRenamePracticeCategoryMutation, SuperAdminRenamePracticeCategoryMutationVariables>(SuperAdminRenamePracticeCategoryDocument, variables);
export const SuperAdminAddUniversityDocument = `
    mutation SuperAdminAddUniversity($input: SuperAdminCreateUniversityInput!) {
  superAdminCreateUniversity(input: $input) {
    success
    id
  }
}
    `;
export const useSuperAdminAddUniversityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddUniversityMutation, TError, SuperAdminAddUniversityMutationVariables, TContext>) =>
    useMutation<SuperAdminAddUniversityMutation, TError, SuperAdminAddUniversityMutationVariables, TContext>(
      ['SuperAdminAddUniversity'],
      (variables?: SuperAdminAddUniversityMutationVariables) => fetcher<SuperAdminAddUniversityMutation, SuperAdminAddUniversityMutationVariables>(SuperAdminAddUniversityDocument, variables)(),
      options
    );
useSuperAdminAddUniversityMutation.fetcher = (variables: SuperAdminAddUniversityMutationVariables) => fetcher<SuperAdminAddUniversityMutation, SuperAdminAddUniversityMutationVariables>(SuperAdminAddUniversityDocument, variables);
export const SuperAdminRenameUniversityDocument = `
    mutation SuperAdminRenameUniversity($input: SuperAdminEditUniversityInput!) {
  superAdminEditUniversity(input: $input) {
    success
  }
}
    `;
export const useSuperAdminRenameUniversityMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminRenameUniversityMutation, TError, SuperAdminRenameUniversityMutationVariables, TContext>) =>
    useMutation<SuperAdminRenameUniversityMutation, TError, SuperAdminRenameUniversityMutationVariables, TContext>(
      ['SuperAdminRenameUniversity'],
      (variables?: SuperAdminRenameUniversityMutationVariables) => fetcher<SuperAdminRenameUniversityMutation, SuperAdminRenameUniversityMutationVariables>(SuperAdminRenameUniversityDocument, variables)(),
      options
    );
useSuperAdminRenameUniversityMutation.fetcher = (variables: SuperAdminRenameUniversityMutationVariables) => fetcher<SuperAdminRenameUniversityMutation, SuperAdminRenameUniversityMutationVariables>(SuperAdminRenameUniversityDocument, variables);
export const SuperAdminActiveWorkplacesDocument = `
    query SuperAdminActiveWorkplaces {
  workplaces {
    nodes {
      ...SuperAdminListManagementWorkplace
    }
  }
}
    ${SuperAdminListManagementWorkplaceFragmentDoc}`;
export const useSuperAdminActiveWorkplacesQuery = <
      TData = SuperAdminActiveWorkplacesQuery,
      TError = unknown
    >(
      variables?: SuperAdminActiveWorkplacesQueryVariables,
      options?: UseQueryOptions<SuperAdminActiveWorkplacesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminActiveWorkplacesQuery, TError, TData>(
      variables === undefined ? ['SuperAdminActiveWorkplaces'] : ['SuperAdminActiveWorkplaces', variables],
      fetcher<SuperAdminActiveWorkplacesQuery, SuperAdminActiveWorkplacesQueryVariables>(SuperAdminActiveWorkplacesDocument, variables),
      options
    );

useSuperAdminActiveWorkplacesQuery.getKey = (variables?: SuperAdminActiveWorkplacesQueryVariables) => variables === undefined ? ['SuperAdminActiveWorkplaces'] : ['SuperAdminActiveWorkplaces', variables];
;

export const useInfiniteSuperAdminActiveWorkplacesQuery = <
      TData = SuperAdminActiveWorkplacesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminActiveWorkplacesQueryVariables,
      variables?: SuperAdminActiveWorkplacesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminActiveWorkplacesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminActiveWorkplacesQuery, TError, TData>(
      variables === undefined ? ['SuperAdminActiveWorkplaces.infinite'] : ['SuperAdminActiveWorkplaces.infinite', variables],
      (metaData) => fetcher<SuperAdminActiveWorkplacesQuery, SuperAdminActiveWorkplacesQueryVariables>(SuperAdminActiveWorkplacesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminActiveWorkplacesQuery.getKey = (variables?: SuperAdminActiveWorkplacesQueryVariables) => variables === undefined ? ['SuperAdminActiveWorkplaces.infinite'] : ['SuperAdminActiveWorkplaces.infinite', variables];
;

useSuperAdminActiveWorkplacesQuery.fetcher = (variables?: SuperAdminActiveWorkplacesQueryVariables) => fetcher<SuperAdminActiveWorkplacesQuery, SuperAdminActiveWorkplacesQueryVariables>(SuperAdminActiveWorkplacesDocument, variables);
export const SuperAdminArchivedWorkplacesDocument = `
    query SuperAdminArchivedWorkplaces {
  archivedWorkplaces {
    nodes {
      ...SuperAdminListManagementWorkplace
    }
  }
}
    ${SuperAdminListManagementWorkplaceFragmentDoc}`;
export const useSuperAdminArchivedWorkplacesQuery = <
      TData = SuperAdminArchivedWorkplacesQuery,
      TError = unknown
    >(
      variables?: SuperAdminArchivedWorkplacesQueryVariables,
      options?: UseQueryOptions<SuperAdminArchivedWorkplacesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminArchivedWorkplacesQuery, TError, TData>(
      variables === undefined ? ['SuperAdminArchivedWorkplaces'] : ['SuperAdminArchivedWorkplaces', variables],
      fetcher<SuperAdminArchivedWorkplacesQuery, SuperAdminArchivedWorkplacesQueryVariables>(SuperAdminArchivedWorkplacesDocument, variables),
      options
    );

useSuperAdminArchivedWorkplacesQuery.getKey = (variables?: SuperAdminArchivedWorkplacesQueryVariables) => variables === undefined ? ['SuperAdminArchivedWorkplaces'] : ['SuperAdminArchivedWorkplaces', variables];
;

export const useInfiniteSuperAdminArchivedWorkplacesQuery = <
      TData = SuperAdminArchivedWorkplacesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminArchivedWorkplacesQueryVariables,
      variables?: SuperAdminArchivedWorkplacesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminArchivedWorkplacesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminArchivedWorkplacesQuery, TError, TData>(
      variables === undefined ? ['SuperAdminArchivedWorkplaces.infinite'] : ['SuperAdminArchivedWorkplaces.infinite', variables],
      (metaData) => fetcher<SuperAdminArchivedWorkplacesQuery, SuperAdminArchivedWorkplacesQueryVariables>(SuperAdminArchivedWorkplacesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminArchivedWorkplacesQuery.getKey = (variables?: SuperAdminArchivedWorkplacesQueryVariables) => variables === undefined ? ['SuperAdminArchivedWorkplaces.infinite'] : ['SuperAdminArchivedWorkplaces.infinite', variables];
;

useSuperAdminArchivedWorkplacesQuery.fetcher = (variables?: SuperAdminArchivedWorkplacesQueryVariables) => fetcher<SuperAdminArchivedWorkplacesQuery, SuperAdminArchivedWorkplacesQueryVariables>(SuperAdminArchivedWorkplacesDocument, variables);
export const SuperAdminWorkplaceManagementExistingFirmsListDocument = `
    query SuperAdminWorkplaceManagementExistingFirmsList {
  superAdminGetExistingFirms {
    id
    name
  }
}
    `;
export const useSuperAdminWorkplaceManagementExistingFirmsListQuery = <
      TData = SuperAdminWorkplaceManagementExistingFirmsListQuery,
      TError = unknown
    >(
      variables?: SuperAdminWorkplaceManagementExistingFirmsListQueryVariables,
      options?: UseQueryOptions<SuperAdminWorkplaceManagementExistingFirmsListQuery, TError, TData>
    ) =>
    useQuery<SuperAdminWorkplaceManagementExistingFirmsListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminWorkplaceManagementExistingFirmsList'] : ['SuperAdminWorkplaceManagementExistingFirmsList', variables],
      fetcher<SuperAdminWorkplaceManagementExistingFirmsListQuery, SuperAdminWorkplaceManagementExistingFirmsListQueryVariables>(SuperAdminWorkplaceManagementExistingFirmsListDocument, variables),
      options
    );

useSuperAdminWorkplaceManagementExistingFirmsListQuery.getKey = (variables?: SuperAdminWorkplaceManagementExistingFirmsListQueryVariables) => variables === undefined ? ['SuperAdminWorkplaceManagementExistingFirmsList'] : ['SuperAdminWorkplaceManagementExistingFirmsList', variables];
;

export const useInfiniteSuperAdminWorkplaceManagementExistingFirmsListQuery = <
      TData = SuperAdminWorkplaceManagementExistingFirmsListQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminWorkplaceManagementExistingFirmsListQueryVariables,
      variables?: SuperAdminWorkplaceManagementExistingFirmsListQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminWorkplaceManagementExistingFirmsListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminWorkplaceManagementExistingFirmsListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminWorkplaceManagementExistingFirmsList.infinite'] : ['SuperAdminWorkplaceManagementExistingFirmsList.infinite', variables],
      (metaData) => fetcher<SuperAdminWorkplaceManagementExistingFirmsListQuery, SuperAdminWorkplaceManagementExistingFirmsListQueryVariables>(SuperAdminWorkplaceManagementExistingFirmsListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminWorkplaceManagementExistingFirmsListQuery.getKey = (variables?: SuperAdminWorkplaceManagementExistingFirmsListQueryVariables) => variables === undefined ? ['SuperAdminWorkplaceManagementExistingFirmsList.infinite'] : ['SuperAdminWorkplaceManagementExistingFirmsList.infinite', variables];
;

useSuperAdminWorkplaceManagementExistingFirmsListQuery.fetcher = (variables?: SuperAdminWorkplaceManagementExistingFirmsListQueryVariables) => fetcher<SuperAdminWorkplaceManagementExistingFirmsListQuery, SuperAdminWorkplaceManagementExistingFirmsListQueryVariables>(SuperAdminWorkplaceManagementExistingFirmsListDocument, variables);
export const SuperAdminAddWorkplaceDocument = `
    mutation SuperAdminAddWorkplace($input: SuperAdminCreateWorkplaceInput!) {
  superAdminCreateWorkplace(input: $input) {
    success
  }
}
    `;
export const useSuperAdminAddWorkplaceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddWorkplaceMutation, TError, SuperAdminAddWorkplaceMutationVariables, TContext>) =>
    useMutation<SuperAdminAddWorkplaceMutation, TError, SuperAdminAddWorkplaceMutationVariables, TContext>(
      ['SuperAdminAddWorkplace'],
      (variables?: SuperAdminAddWorkplaceMutationVariables) => fetcher<SuperAdminAddWorkplaceMutation, SuperAdminAddWorkplaceMutationVariables>(SuperAdminAddWorkplaceDocument, variables)(),
      options
    );
useSuperAdminAddWorkplaceMutation.fetcher = (variables: SuperAdminAddWorkplaceMutationVariables) => fetcher<SuperAdminAddWorkplaceMutation, SuperAdminAddWorkplaceMutationVariables>(SuperAdminAddWorkplaceDocument, variables);
export const SuperAdminEditWorkplaceDocument = `
    mutation SuperAdminEditWorkplace($input: SuperAdminEditWorkplaceInput!) {
  superAdminEditWorkplace(input: $input) {
    success
  }
}
    `;
export const useSuperAdminEditWorkplaceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminEditWorkplaceMutation, TError, SuperAdminEditWorkplaceMutationVariables, TContext>) =>
    useMutation<SuperAdminEditWorkplaceMutation, TError, SuperAdminEditWorkplaceMutationVariables, TContext>(
      ['SuperAdminEditWorkplace'],
      (variables?: SuperAdminEditWorkplaceMutationVariables) => fetcher<SuperAdminEditWorkplaceMutation, SuperAdminEditWorkplaceMutationVariables>(SuperAdminEditWorkplaceDocument, variables)(),
      options
    );
useSuperAdminEditWorkplaceMutation.fetcher = (variables: SuperAdminEditWorkplaceMutationVariables) => fetcher<SuperAdminEditWorkplaceMutation, SuperAdminEditWorkplaceMutationVariables>(SuperAdminEditWorkplaceDocument, variables);
export const SuperAdminArchiveWorkplaceDocument = `
    mutation SuperAdminArchiveWorkplace($input: SuperAdminArchiveWorkplaceInput!) {
  superAdminArchiveWorkplace(input: $input) {
    success
  }
}
    `;
export const useSuperAdminArchiveWorkplaceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminArchiveWorkplaceMutation, TError, SuperAdminArchiveWorkplaceMutationVariables, TContext>) =>
    useMutation<SuperAdminArchiveWorkplaceMutation, TError, SuperAdminArchiveWorkplaceMutationVariables, TContext>(
      ['SuperAdminArchiveWorkplace'],
      (variables?: SuperAdminArchiveWorkplaceMutationVariables) => fetcher<SuperAdminArchiveWorkplaceMutation, SuperAdminArchiveWorkplaceMutationVariables>(SuperAdminArchiveWorkplaceDocument, variables)(),
      options
    );
useSuperAdminArchiveWorkplaceMutation.fetcher = (variables: SuperAdminArchiveWorkplaceMutationVariables) => fetcher<SuperAdminArchiveWorkplaceMutation, SuperAdminArchiveWorkplaceMutationVariables>(SuperAdminArchiveWorkplaceDocument, variables);
export const SuperAdminAtsJobListDocument = `
    query SuperAdminAtsJobList($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $orderBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        __typename
        ... on AtsJobNode {
          ...SuperAdminAtsJob
        }
      }
    }
  }
}
    ${SuperAdminAtsJobFragmentDoc}`;
export const useSuperAdminAtsJobListQuery = <
      TData = SuperAdminAtsJobListQuery,
      TError = unknown
    >(
      variables?: SuperAdminAtsJobListQueryVariables,
      options?: UseQueryOptions<SuperAdminAtsJobListQuery, TError, TData>
    ) =>
    useQuery<SuperAdminAtsJobListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminAtsJobList'] : ['SuperAdminAtsJobList', variables],
      fetcher<SuperAdminAtsJobListQuery, SuperAdminAtsJobListQueryVariables>(SuperAdminAtsJobListDocument, variables),
      options
    );

useSuperAdminAtsJobListQuery.getKey = (variables?: SuperAdminAtsJobListQueryVariables) => variables === undefined ? ['SuperAdminAtsJobList'] : ['SuperAdminAtsJobList', variables];
;

export const useInfiniteSuperAdminAtsJobListQuery = <
      TData = SuperAdminAtsJobListQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminAtsJobListQueryVariables,
      variables?: SuperAdminAtsJobListQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminAtsJobListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminAtsJobListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminAtsJobList.infinite'] : ['SuperAdminAtsJobList.infinite', variables],
      (metaData) => fetcher<SuperAdminAtsJobListQuery, SuperAdminAtsJobListQueryVariables>(SuperAdminAtsJobListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminAtsJobListQuery.getKey = (variables?: SuperAdminAtsJobListQueryVariables) => variables === undefined ? ['SuperAdminAtsJobList.infinite'] : ['SuperAdminAtsJobList.infinite', variables];
;

useSuperAdminAtsJobListQuery.fetcher = (variables?: SuperAdminAtsJobListQueryVariables) => fetcher<SuperAdminAtsJobListQuery, SuperAdminAtsJobListQueryVariables>(SuperAdminAtsJobListDocument, variables);
export const SuperAdminSubmitJobBoardAudienceDocument = `
    mutation SuperAdminSubmitJobBoardAudience($input: SuperAdminSubmitJobBoardAudienceInput!) {
  superAdminSubmitJobBoardAudience(input: $input) {
    success
  }
}
    `;
export const useSuperAdminSubmitJobBoardAudienceMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitJobBoardAudienceMutation, TError, SuperAdminSubmitJobBoardAudienceMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitJobBoardAudienceMutation, TError, SuperAdminSubmitJobBoardAudienceMutationVariables, TContext>(
      ['SuperAdminSubmitJobBoardAudience'],
      (variables?: SuperAdminSubmitJobBoardAudienceMutationVariables) => fetcher<SuperAdminSubmitJobBoardAudienceMutation, SuperAdminSubmitJobBoardAudienceMutationVariables>(SuperAdminSubmitJobBoardAudienceDocument, variables)(),
      options
    );
useSuperAdminSubmitJobBoardAudienceMutation.fetcher = (variables: SuperAdminSubmitJobBoardAudienceMutationVariables) => fetcher<SuperAdminSubmitJobBoardAudienceMutation, SuperAdminSubmitJobBoardAudienceMutationVariables>(SuperAdminSubmitJobBoardAudienceDocument, variables);
export const SuperAdminExternalJobListDocument = `
    query SuperAdminExternalJobList($first: Int = 20, $after: String, $filterBy: ForwardJobFeedFilterBy, $orderBy: [JobFeedSortBy!]) {
  forwardJobFeed(
    first: $first
    after: $after
    filterBy: $filterBy
    sortBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        __typename
        ... on ExternalJobNode {
          id
          orgId
          employer {
            name
            logoUrl
          }
          title
          description
          sourceLink
          is1L
          is2L
        }
      }
    }
  }
}
    `;
export const useSuperAdminExternalJobListQuery = <
      TData = SuperAdminExternalJobListQuery,
      TError = unknown
    >(
      variables?: SuperAdminExternalJobListQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobListQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobList'] : ['SuperAdminExternalJobList', variables],
      fetcher<SuperAdminExternalJobListQuery, SuperAdminExternalJobListQueryVariables>(SuperAdminExternalJobListDocument, variables),
      options
    );

useSuperAdminExternalJobListQuery.getKey = (variables?: SuperAdminExternalJobListQueryVariables) => variables === undefined ? ['SuperAdminExternalJobList'] : ['SuperAdminExternalJobList', variables];
;

export const useInfiniteSuperAdminExternalJobListQuery = <
      TData = SuperAdminExternalJobListQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobListQueryVariables,
      variables?: SuperAdminExternalJobListQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobListQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobListQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobList.infinite'] : ['SuperAdminExternalJobList.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobListQuery, SuperAdminExternalJobListQueryVariables>(SuperAdminExternalJobListDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobListQuery.getKey = (variables?: SuperAdminExternalJobListQueryVariables) => variables === undefined ? ['SuperAdminExternalJobList.infinite'] : ['SuperAdminExternalJobList.infinite', variables];
;

useSuperAdminExternalJobListQuery.fetcher = (variables?: SuperAdminExternalJobListQueryVariables) => fetcher<SuperAdminExternalJobListQuery, SuperAdminExternalJobListQueryVariables>(SuperAdminExternalJobListDocument, variables);
export const SuperAdminJobByIdDocument = `
    query SuperAdminJobById($jobId: ID!) {
  forwardJobById(id: $jobId) {
    __typename
    ... on AtsJobNode {
      ...SuperAdminAtsJob
    }
    ... on ExternalJobNode {
      id
      orgId
      employer {
        name
        logoUrl
      }
      title
      description
      openDate {
        date
        time
        zone
      }
      closeDate {
        date
        time
        zone
      }
      offices {
        nodes {
          id
          name
        }
      }
      requiredDocuments {
        id
        name
      }
      practiceCategories {
        nodes {
          id
          name
        }
      }
      sourceLink
      salaryInfo {
        amount
        timeUnit
      }
      programLength {
        amount
        timeUnit
      }
      is1L
      is2L
    }
  }
}
    ${SuperAdminAtsJobFragmentDoc}`;
export const useSuperAdminJobByIdQuery = <
      TData = SuperAdminJobByIdQuery,
      TError = unknown
    >(
      variables: SuperAdminJobByIdQueryVariables,
      options?: UseQueryOptions<SuperAdminJobByIdQuery, TError, TData>
    ) =>
    useQuery<SuperAdminJobByIdQuery, TError, TData>(
      ['SuperAdminJobById', variables],
      fetcher<SuperAdminJobByIdQuery, SuperAdminJobByIdQueryVariables>(SuperAdminJobByIdDocument, variables),
      options
    );

useSuperAdminJobByIdQuery.getKey = (variables: SuperAdminJobByIdQueryVariables) => ['SuperAdminJobById', variables];
;

export const useInfiniteSuperAdminJobByIdQuery = <
      TData = SuperAdminJobByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminJobByIdQueryVariables,
      variables: SuperAdminJobByIdQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminJobByIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminJobByIdQuery, TError, TData>(
      ['SuperAdminJobById.infinite', variables],
      (metaData) => fetcher<SuperAdminJobByIdQuery, SuperAdminJobByIdQueryVariables>(SuperAdminJobByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminJobByIdQuery.getKey = (variables: SuperAdminJobByIdQueryVariables) => ['SuperAdminJobById.infinite', variables];
;

useSuperAdminJobByIdQuery.fetcher = (variables: SuperAdminJobByIdQueryVariables) => fetcher<SuperAdminJobByIdQuery, SuperAdminJobByIdQueryVariables>(SuperAdminJobByIdDocument, variables);
export const SuperAdminExternalJobFormStaticListsDocument = `
    query SuperAdminExternalJobFormStaticLists {
  superAdminGetExistingFirms {
    id
    name
  }
  allOfficeLocations {
    nodes {
      id
      name
    }
  }
  allPracticeCategories {
    nodes {
      id
      name
    }
  }
}
    `;
export const useSuperAdminExternalJobFormStaticListsQuery = <
      TData = SuperAdminExternalJobFormStaticListsQuery,
      TError = unknown
    >(
      variables?: SuperAdminExternalJobFormStaticListsQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobFormStaticListsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobFormStaticListsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobFormStaticLists'] : ['SuperAdminExternalJobFormStaticLists', variables],
      fetcher<SuperAdminExternalJobFormStaticListsQuery, SuperAdminExternalJobFormStaticListsQueryVariables>(SuperAdminExternalJobFormStaticListsDocument, variables),
      options
    );

useSuperAdminExternalJobFormStaticListsQuery.getKey = (variables?: SuperAdminExternalJobFormStaticListsQueryVariables) => variables === undefined ? ['SuperAdminExternalJobFormStaticLists'] : ['SuperAdminExternalJobFormStaticLists', variables];
;

export const useInfiniteSuperAdminExternalJobFormStaticListsQuery = <
      TData = SuperAdminExternalJobFormStaticListsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobFormStaticListsQueryVariables,
      variables?: SuperAdminExternalJobFormStaticListsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobFormStaticListsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobFormStaticListsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminExternalJobFormStaticLists.infinite'] : ['SuperAdminExternalJobFormStaticLists.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobFormStaticListsQuery, SuperAdminExternalJobFormStaticListsQueryVariables>(SuperAdminExternalJobFormStaticListsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobFormStaticListsQuery.getKey = (variables?: SuperAdminExternalJobFormStaticListsQueryVariables) => variables === undefined ? ['SuperAdminExternalJobFormStaticLists.infinite'] : ['SuperAdminExternalJobFormStaticLists.infinite', variables];
;

useSuperAdminExternalJobFormStaticListsQuery.fetcher = (variables?: SuperAdminExternalJobFormStaticListsQueryVariables) => fetcher<SuperAdminExternalJobFormStaticListsQuery, SuperAdminExternalJobFormStaticListsQueryVariables>(SuperAdminExternalJobFormStaticListsDocument, variables);
export const SuperAdminExternalJobFormFirmDependentListsDocument = `
    query SuperAdminExternalJobFormFirmDependentLists($orgId: ID!) {
  superAdminGetOfficesForFirm(orgId: $orgId) {
    id
    locationId
    name
  }
  superAdminGetDocumentsForFirm(orgId: $orgId) {
    id
    name
  }
}
    `;
export const useSuperAdminExternalJobFormFirmDependentListsQuery = <
      TData = SuperAdminExternalJobFormFirmDependentListsQuery,
      TError = unknown
    >(
      variables: SuperAdminExternalJobFormFirmDependentListsQueryVariables,
      options?: UseQueryOptions<SuperAdminExternalJobFormFirmDependentListsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminExternalJobFormFirmDependentListsQuery, TError, TData>(
      ['SuperAdminExternalJobFormFirmDependentLists', variables],
      fetcher<SuperAdminExternalJobFormFirmDependentListsQuery, SuperAdminExternalJobFormFirmDependentListsQueryVariables>(SuperAdminExternalJobFormFirmDependentListsDocument, variables),
      options
    );

useSuperAdminExternalJobFormFirmDependentListsQuery.getKey = (variables: SuperAdminExternalJobFormFirmDependentListsQueryVariables) => ['SuperAdminExternalJobFormFirmDependentLists', variables];
;

export const useInfiniteSuperAdminExternalJobFormFirmDependentListsQuery = <
      TData = SuperAdminExternalJobFormFirmDependentListsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminExternalJobFormFirmDependentListsQueryVariables,
      variables: SuperAdminExternalJobFormFirmDependentListsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminExternalJobFormFirmDependentListsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminExternalJobFormFirmDependentListsQuery, TError, TData>(
      ['SuperAdminExternalJobFormFirmDependentLists.infinite', variables],
      (metaData) => fetcher<SuperAdminExternalJobFormFirmDependentListsQuery, SuperAdminExternalJobFormFirmDependentListsQueryVariables>(SuperAdminExternalJobFormFirmDependentListsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminExternalJobFormFirmDependentListsQuery.getKey = (variables: SuperAdminExternalJobFormFirmDependentListsQueryVariables) => ['SuperAdminExternalJobFormFirmDependentLists.infinite', variables];
;

useSuperAdminExternalJobFormFirmDependentListsQuery.fetcher = (variables: SuperAdminExternalJobFormFirmDependentListsQueryVariables) => fetcher<SuperAdminExternalJobFormFirmDependentListsQuery, SuperAdminExternalJobFormFirmDependentListsQueryVariables>(SuperAdminExternalJobFormFirmDependentListsDocument, variables);
export const SuperAdminAddOfficeDocument = `
    mutation SuperAdminAddOffice($addOfficeInput: SuperAdminAddOfficeToFirmInput!) {
  superAdminAddOfficeToFirm(input: $addOfficeInput) {
    success
  }
}
    `;
export const useSuperAdminAddOfficeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddOfficeMutation, TError, SuperAdminAddOfficeMutationVariables, TContext>) =>
    useMutation<SuperAdminAddOfficeMutation, TError, SuperAdminAddOfficeMutationVariables, TContext>(
      ['SuperAdminAddOffice'],
      (variables?: SuperAdminAddOfficeMutationVariables) => fetcher<SuperAdminAddOfficeMutation, SuperAdminAddOfficeMutationVariables>(SuperAdminAddOfficeDocument, variables)(),
      options
    );
useSuperAdminAddOfficeMutation.fetcher = (variables: SuperAdminAddOfficeMutationVariables) => fetcher<SuperAdminAddOfficeMutation, SuperAdminAddOfficeMutationVariables>(SuperAdminAddOfficeDocument, variables);
export const SuperAdminAddDocumentDocument = `
    mutation SuperAdminAddDocument($addDocumentInput: SuperAdminAddDocumentToFirmInput!) {
  superAdminAddDocumentToFirm(input: $addDocumentInput) {
    success
    documentId
  }
}
    `;
export const useSuperAdminAddDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminAddDocumentMutation, TError, SuperAdminAddDocumentMutationVariables, TContext>) =>
    useMutation<SuperAdminAddDocumentMutation, TError, SuperAdminAddDocumentMutationVariables, TContext>(
      ['SuperAdminAddDocument'],
      (variables?: SuperAdminAddDocumentMutationVariables) => fetcher<SuperAdminAddDocumentMutation, SuperAdminAddDocumentMutationVariables>(SuperAdminAddDocumentDocument, variables)(),
      options
    );
useSuperAdminAddDocumentMutation.fetcher = (variables: SuperAdminAddDocumentMutationVariables) => fetcher<SuperAdminAddDocumentMutation, SuperAdminAddDocumentMutationVariables>(SuperAdminAddDocumentDocument, variables);
export const SuperAdminSubmitJobDocument = `
    mutation SuperAdminSubmitJob($submitJobInput: SuperAdminSubmitJobForFirmInput!) {
  superAdminSubmitJobForFirm(input: $submitJobInput) {
    success
    jobId
  }
}
    `;
export const useSuperAdminSubmitJobMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminSubmitJobMutation, TError, SuperAdminSubmitJobMutationVariables, TContext>) =>
    useMutation<SuperAdminSubmitJobMutation, TError, SuperAdminSubmitJobMutationVariables, TContext>(
      ['SuperAdminSubmitJob'],
      (variables?: SuperAdminSubmitJobMutationVariables) => fetcher<SuperAdminSubmitJobMutation, SuperAdminSubmitJobMutationVariables>(SuperAdminSubmitJobDocument, variables)(),
      options
    );
useSuperAdminSubmitJobMutation.fetcher = (variables: SuperAdminSubmitJobMutationVariables) => fetcher<SuperAdminSubmitJobMutation, SuperAdminSubmitJobMutationVariables>(SuperAdminSubmitJobDocument, variables);
export const SuperAdminGetOrgForwardPrivilegesDocument = `
    query SuperAdminGetOrgForwardPrivileges($orgId: ID!) {
  publicOrgInfoByOrgId(orgId: $orgId) {
    name
  }
  superAdminGetOrgForwardPrivileges(orgId: $orgId) {
    id
    carouselEventPublishing
    directoryEventPublishing
    lawSchoolTargeting
  }
}
    `;
export const useSuperAdminGetOrgForwardPrivilegesQuery = <
      TData = SuperAdminGetOrgForwardPrivilegesQuery,
      TError = unknown
    >(
      variables: SuperAdminGetOrgForwardPrivilegesQueryVariables,
      options?: UseQueryOptions<SuperAdminGetOrgForwardPrivilegesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetOrgForwardPrivilegesQuery, TError, TData>(
      ['SuperAdminGetOrgForwardPrivileges', variables],
      fetcher<SuperAdminGetOrgForwardPrivilegesQuery, SuperAdminGetOrgForwardPrivilegesQueryVariables>(SuperAdminGetOrgForwardPrivilegesDocument, variables),
      options
    );

useSuperAdminGetOrgForwardPrivilegesQuery.getKey = (variables: SuperAdminGetOrgForwardPrivilegesQueryVariables) => ['SuperAdminGetOrgForwardPrivileges', variables];
;

export const useInfiniteSuperAdminGetOrgForwardPrivilegesQuery = <
      TData = SuperAdminGetOrgForwardPrivilegesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetOrgForwardPrivilegesQueryVariables,
      variables: SuperAdminGetOrgForwardPrivilegesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetOrgForwardPrivilegesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetOrgForwardPrivilegesQuery, TError, TData>(
      ['SuperAdminGetOrgForwardPrivileges.infinite', variables],
      (metaData) => fetcher<SuperAdminGetOrgForwardPrivilegesQuery, SuperAdminGetOrgForwardPrivilegesQueryVariables>(SuperAdminGetOrgForwardPrivilegesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetOrgForwardPrivilegesQuery.getKey = (variables: SuperAdminGetOrgForwardPrivilegesQueryVariables) => ['SuperAdminGetOrgForwardPrivileges.infinite', variables];
;

useSuperAdminGetOrgForwardPrivilegesQuery.fetcher = (variables: SuperAdminGetOrgForwardPrivilegesQueryVariables) => fetcher<SuperAdminGetOrgForwardPrivilegesQuery, SuperAdminGetOrgForwardPrivilegesQueryVariables>(SuperAdminGetOrgForwardPrivilegesDocument, variables);
export const SuperAdminUpdateOrgForwardPrivilegesDocument = `
    mutation SuperAdminUpdateOrgForwardPrivileges($input: SuperAdminUpdateOrgForwardPrivilegesInput!) {
  superAdminUpdateOrgForwardPrivileges(input: $input) {
    success
  }
}
    `;
export const useSuperAdminUpdateOrgForwardPrivilegesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminUpdateOrgForwardPrivilegesMutation, TError, SuperAdminUpdateOrgForwardPrivilegesMutationVariables, TContext>) =>
    useMutation<SuperAdminUpdateOrgForwardPrivilegesMutation, TError, SuperAdminUpdateOrgForwardPrivilegesMutationVariables, TContext>(
      ['SuperAdminUpdateOrgForwardPrivileges'],
      (variables?: SuperAdminUpdateOrgForwardPrivilegesMutationVariables) => fetcher<SuperAdminUpdateOrgForwardPrivilegesMutation, SuperAdminUpdateOrgForwardPrivilegesMutationVariables>(SuperAdminUpdateOrgForwardPrivilegesDocument, variables)(),
      options
    );
useSuperAdminUpdateOrgForwardPrivilegesMutation.fetcher = (variables: SuperAdminUpdateOrgForwardPrivilegesMutationVariables) => fetcher<SuperAdminUpdateOrgForwardPrivilegesMutation, SuperAdminUpdateOrgForwardPrivilegesMutationVariables>(SuperAdminUpdateOrgForwardPrivilegesDocument, variables);
export const SuperAdminGetFirmAndItsOfficesDocument = `
    query SuperAdminGetFirmAndItsOffices($firmId: ID!) {
  publicOrgInfoByOrgId(orgId: $firmId) {
    name
  }
  superAdminGetOfficesForFirm(orgId: $firmId) {
    id
    locationId
    name
    ranking
  }
}
    `;
export const useSuperAdminGetFirmAndItsOfficesQuery = <
      TData = SuperAdminGetFirmAndItsOfficesQuery,
      TError = unknown
    >(
      variables: SuperAdminGetFirmAndItsOfficesQueryVariables,
      options?: UseQueryOptions<SuperAdminGetFirmAndItsOfficesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetFirmAndItsOfficesQuery, TError, TData>(
      ['SuperAdminGetFirmAndItsOffices', variables],
      fetcher<SuperAdminGetFirmAndItsOfficesQuery, SuperAdminGetFirmAndItsOfficesQueryVariables>(SuperAdminGetFirmAndItsOfficesDocument, variables),
      options
    );

useSuperAdminGetFirmAndItsOfficesQuery.getKey = (variables: SuperAdminGetFirmAndItsOfficesQueryVariables) => ['SuperAdminGetFirmAndItsOffices', variables];
;

export const useInfiniteSuperAdminGetFirmAndItsOfficesQuery = <
      TData = SuperAdminGetFirmAndItsOfficesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetFirmAndItsOfficesQueryVariables,
      variables: SuperAdminGetFirmAndItsOfficesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetFirmAndItsOfficesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetFirmAndItsOfficesQuery, TError, TData>(
      ['SuperAdminGetFirmAndItsOffices.infinite', variables],
      (metaData) => fetcher<SuperAdminGetFirmAndItsOfficesQuery, SuperAdminGetFirmAndItsOfficesQueryVariables>(SuperAdminGetFirmAndItsOfficesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetFirmAndItsOfficesQuery.getKey = (variables: SuperAdminGetFirmAndItsOfficesQueryVariables) => ['SuperAdminGetFirmAndItsOffices.infinite', variables];
;

useSuperAdminGetFirmAndItsOfficesQuery.fetcher = (variables: SuperAdminGetFirmAndItsOfficesQueryVariables) => fetcher<SuperAdminGetFirmAndItsOfficesQuery, SuperAdminGetFirmAndItsOfficesQueryVariables>(SuperAdminGetFirmAndItsOfficesDocument, variables);
export const SuperAdminCreateOfficeForFirmDocument = `
    mutation SuperAdminCreateOfficeForFirm($input: SuperAdminAddOfficeToFirmInput!) {
  superAdminAddOfficeToFirm(input: $input) {
    success
  }
}
    `;
export const useSuperAdminCreateOfficeForFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminCreateOfficeForFirmMutation, TError, SuperAdminCreateOfficeForFirmMutationVariables, TContext>) =>
    useMutation<SuperAdminCreateOfficeForFirmMutation, TError, SuperAdminCreateOfficeForFirmMutationVariables, TContext>(
      ['SuperAdminCreateOfficeForFirm'],
      (variables?: SuperAdminCreateOfficeForFirmMutationVariables) => fetcher<SuperAdminCreateOfficeForFirmMutation, SuperAdminCreateOfficeForFirmMutationVariables>(SuperAdminCreateOfficeForFirmDocument, variables)(),
      options
    );
useSuperAdminCreateOfficeForFirmMutation.fetcher = (variables: SuperAdminCreateOfficeForFirmMutationVariables) => fetcher<SuperAdminCreateOfficeForFirmMutation, SuperAdminCreateOfficeForFirmMutationVariables>(SuperAdminCreateOfficeForFirmDocument, variables);
export const SuperAdminRemoveOfficeFromFirmDocument = `
    mutation SuperAdminRemoveOfficeFromFirm($input: SuperAdminRemoveOfficeFromFirmInput!) {
  superAdminRemoveOfficeFromFirm(input: $input) {
    success
  }
}
    `;
export const useSuperAdminRemoveOfficeFromFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminRemoveOfficeFromFirmMutation, TError, SuperAdminRemoveOfficeFromFirmMutationVariables, TContext>) =>
    useMutation<SuperAdminRemoveOfficeFromFirmMutation, TError, SuperAdminRemoveOfficeFromFirmMutationVariables, TContext>(
      ['SuperAdminRemoveOfficeFromFirm'],
      (variables?: SuperAdminRemoveOfficeFromFirmMutationVariables) => fetcher<SuperAdminRemoveOfficeFromFirmMutation, SuperAdminRemoveOfficeFromFirmMutationVariables>(SuperAdminRemoveOfficeFromFirmDocument, variables)(),
      options
    );
useSuperAdminRemoveOfficeFromFirmMutation.fetcher = (variables: SuperAdminRemoveOfficeFromFirmMutationVariables) => fetcher<SuperAdminRemoveOfficeFromFirmMutation, SuperAdminRemoveOfficeFromFirmMutationVariables>(SuperAdminRemoveOfficeFromFirmDocument, variables);
export const SuperAdminUpdateOrgOfficeRankingsDocument = `
    mutation SuperAdminUpdateOrgOfficeRankings($input: SuperAdminUpdateOrgOfficeRankingInput!) {
  superAdminUpdateOrgOfficeRankings(input: $input) {
    success
  }
}
    `;
export const useSuperAdminUpdateOrgOfficeRankingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminUpdateOrgOfficeRankingsMutation, TError, SuperAdminUpdateOrgOfficeRankingsMutationVariables, TContext>) =>
    useMutation<SuperAdminUpdateOrgOfficeRankingsMutation, TError, SuperAdminUpdateOrgOfficeRankingsMutationVariables, TContext>(
      ['SuperAdminUpdateOrgOfficeRankings'],
      (variables?: SuperAdminUpdateOrgOfficeRankingsMutationVariables) => fetcher<SuperAdminUpdateOrgOfficeRankingsMutation, SuperAdminUpdateOrgOfficeRankingsMutationVariables>(SuperAdminUpdateOrgOfficeRankingsDocument, variables)(),
      options
    );
useSuperAdminUpdateOrgOfficeRankingsMutation.fetcher = (variables: SuperAdminUpdateOrgOfficeRankingsMutationVariables) => fetcher<SuperAdminUpdateOrgOfficeRankingsMutation, SuperAdminUpdateOrgOfficeRankingsMutationVariables>(SuperAdminUpdateOrgOfficeRankingsDocument, variables);
export const SuperAdminGetFirmAndItsPracticeAreasAndOfficesDocument = `
    query SuperAdminGetFirmAndItsPracticeAreasAndOffices($firmId: ID!) {
  publicOrgInfoByOrgId(orgId: $firmId) {
    name
    offices {
      nodes {
        id
        officeLocation {
          id
          name
        }
      }
    }
    firmPracticeAreas {
      nodes {
        ...SuperAdminGetFirmPracticeAreasFields
      }
    }
  }
}
    ${SuperAdminGetFirmPracticeAreasFieldsFragmentDoc}`;
export const useSuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery = <
      TData = SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery,
      TError = unknown
    >(
      variables: SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables,
      options?: UseQueryOptions<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, TError, TData>(
      ['SuperAdminGetFirmAndItsPracticeAreasAndOffices', variables],
      fetcher<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables>(SuperAdminGetFirmAndItsPracticeAreasAndOfficesDocument, variables),
      options
    );

useSuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery.getKey = (variables: SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables) => ['SuperAdminGetFirmAndItsPracticeAreasAndOffices', variables];
;

export const useInfiniteSuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery = <
      TData = SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables,
      variables: SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, TError, TData>(
      ['SuperAdminGetFirmAndItsPracticeAreasAndOffices.infinite', variables],
      (metaData) => fetcher<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables>(SuperAdminGetFirmAndItsPracticeAreasAndOfficesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery.getKey = (variables: SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables) => ['SuperAdminGetFirmAndItsPracticeAreasAndOffices.infinite', variables];
;

useSuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery.fetcher = (variables: SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables) => fetcher<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables>(SuperAdminGetFirmAndItsPracticeAreasAndOfficesDocument, variables);
export const SuperAdminCreatePracticeAreaForFirmDocument = `
    mutation SuperAdminCreatePracticeAreaForFirm($input: SuperAdminAddPracticeAreaToFirmInput!) {
  superAdminAddPracticeAreaToFirm(input: $input) {
    success
  }
}
    `;
export const useSuperAdminCreatePracticeAreaForFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminCreatePracticeAreaForFirmMutation, TError, SuperAdminCreatePracticeAreaForFirmMutationVariables, TContext>) =>
    useMutation<SuperAdminCreatePracticeAreaForFirmMutation, TError, SuperAdminCreatePracticeAreaForFirmMutationVariables, TContext>(
      ['SuperAdminCreatePracticeAreaForFirm'],
      (variables?: SuperAdminCreatePracticeAreaForFirmMutationVariables) => fetcher<SuperAdminCreatePracticeAreaForFirmMutation, SuperAdminCreatePracticeAreaForFirmMutationVariables>(SuperAdminCreatePracticeAreaForFirmDocument, variables)(),
      options
    );
useSuperAdminCreatePracticeAreaForFirmMutation.fetcher = (variables: SuperAdminCreatePracticeAreaForFirmMutationVariables) => fetcher<SuperAdminCreatePracticeAreaForFirmMutation, SuperAdminCreatePracticeAreaForFirmMutationVariables>(SuperAdminCreatePracticeAreaForFirmDocument, variables);
export const SuperAdminEditPracticeAreaForFirmDocument = `
    mutation SuperAdminEditPracticeAreaForFirm($input: SuperAdminEditPracticeAreaForFirmInput!) {
  superAdminEditPracticeAreaForFirm(input: $input) {
    success
  }
}
    `;
export const useSuperAdminEditPracticeAreaForFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminEditPracticeAreaForFirmMutation, TError, SuperAdminEditPracticeAreaForFirmMutationVariables, TContext>) =>
    useMutation<SuperAdminEditPracticeAreaForFirmMutation, TError, SuperAdminEditPracticeAreaForFirmMutationVariables, TContext>(
      ['SuperAdminEditPracticeAreaForFirm'],
      (variables?: SuperAdminEditPracticeAreaForFirmMutationVariables) => fetcher<SuperAdminEditPracticeAreaForFirmMutation, SuperAdminEditPracticeAreaForFirmMutationVariables>(SuperAdminEditPracticeAreaForFirmDocument, variables)(),
      options
    );
useSuperAdminEditPracticeAreaForFirmMutation.fetcher = (variables: SuperAdminEditPracticeAreaForFirmMutationVariables) => fetcher<SuperAdminEditPracticeAreaForFirmMutation, SuperAdminEditPracticeAreaForFirmMutationVariables>(SuperAdminEditPracticeAreaForFirmDocument, variables);
export const SuperAdminDeletePracticeAreaForFirmDocument = `
    mutation SuperAdminDeletePracticeAreaForFirm($input: SuperAdminRemovePracticeAreaFromFirmInput!) {
  superAdminRemovePracticeAreaFromFirm(input: $input) {
    success
  }
}
    `;
export const useSuperAdminDeletePracticeAreaForFirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SuperAdminDeletePracticeAreaForFirmMutation, TError, SuperAdminDeletePracticeAreaForFirmMutationVariables, TContext>) =>
    useMutation<SuperAdminDeletePracticeAreaForFirmMutation, TError, SuperAdminDeletePracticeAreaForFirmMutationVariables, TContext>(
      ['SuperAdminDeletePracticeAreaForFirm'],
      (variables?: SuperAdminDeletePracticeAreaForFirmMutationVariables) => fetcher<SuperAdminDeletePracticeAreaForFirmMutation, SuperAdminDeletePracticeAreaForFirmMutationVariables>(SuperAdminDeletePracticeAreaForFirmDocument, variables)(),
      options
    );
useSuperAdminDeletePracticeAreaForFirmMutation.fetcher = (variables: SuperAdminDeletePracticeAreaForFirmMutationVariables) => fetcher<SuperAdminDeletePracticeAreaForFirmMutation, SuperAdminDeletePracticeAreaForFirmMutationVariables>(SuperAdminDeletePracticeAreaForFirmDocument, variables);
export const UpdateOrgSsoDocument = `
    mutation UpdateOrgSSO($input: SuperAdminUpdateOrgSSOInput!) {
  superAdminUpdateOrgSSO(input: $input) {
    success
  }
}
    `;
export const useUpdateOrgSsoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateOrgSsoMutation, TError, UpdateOrgSsoMutationVariables, TContext>) =>
    useMutation<UpdateOrgSsoMutation, TError, UpdateOrgSsoMutationVariables, TContext>(
      ['UpdateOrgSSO'],
      (variables?: UpdateOrgSsoMutationVariables) => fetcher<UpdateOrgSsoMutation, UpdateOrgSsoMutationVariables>(UpdateOrgSsoDocument, variables)(),
      options
    );
useUpdateOrgSsoMutation.fetcher = (variables: UpdateOrgSsoMutationVariables) => fetcher<UpdateOrgSsoMutation, UpdateOrgSsoMutationVariables>(UpdateOrgSsoDocument, variables);
export const ToggleOrgSsoOnOffDocument = `
    mutation ToggleOrgSSOOnOff($orgId: ID!, $enabled: Boolean) {
  superAdminToggleOrgSSO(orgId: $orgId, enabled: $enabled)
}
    `;
export const useToggleOrgSsoOnOffMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ToggleOrgSsoOnOffMutation, TError, ToggleOrgSsoOnOffMutationVariables, TContext>) =>
    useMutation<ToggleOrgSsoOnOffMutation, TError, ToggleOrgSsoOnOffMutationVariables, TContext>(
      ['ToggleOrgSSOOnOff'],
      (variables?: ToggleOrgSsoOnOffMutationVariables) => fetcher<ToggleOrgSsoOnOffMutation, ToggleOrgSsoOnOffMutationVariables>(ToggleOrgSsoOnOffDocument, variables)(),
      options
    );
useToggleOrgSsoOnOffMutation.fetcher = (variables: ToggleOrgSsoOnOffMutationVariables) => fetcher<ToggleOrgSsoOnOffMutation, ToggleOrgSsoOnOffMutationVariables>(ToggleOrgSsoOnOffDocument, variables);
export const OrganizationSecuritySettingsPageDocument = `
    query OrganizationSecuritySettingsPage {
  superAdminGetAllActiveOrgs {
    id
    name
    ssoAuthInfo {
      id
      connectionName
      isEnabled
    }
  }
}
    `;
export const useOrganizationSecuritySettingsPageQuery = <
      TData = OrganizationSecuritySettingsPageQuery,
      TError = unknown
    >(
      variables?: OrganizationSecuritySettingsPageQueryVariables,
      options?: UseQueryOptions<OrganizationSecuritySettingsPageQuery, TError, TData>
    ) =>
    useQuery<OrganizationSecuritySettingsPageQuery, TError, TData>(
      variables === undefined ? ['OrganizationSecuritySettingsPage'] : ['OrganizationSecuritySettingsPage', variables],
      fetcher<OrganizationSecuritySettingsPageQuery, OrganizationSecuritySettingsPageQueryVariables>(OrganizationSecuritySettingsPageDocument, variables),
      options
    );

useOrganizationSecuritySettingsPageQuery.getKey = (variables?: OrganizationSecuritySettingsPageQueryVariables) => variables === undefined ? ['OrganizationSecuritySettingsPage'] : ['OrganizationSecuritySettingsPage', variables];
;

export const useInfiniteOrganizationSecuritySettingsPageQuery = <
      TData = OrganizationSecuritySettingsPageQuery,
      TError = unknown
    >(
      pageParamKey: keyof OrganizationSecuritySettingsPageQueryVariables,
      variables?: OrganizationSecuritySettingsPageQueryVariables,
      options?: UseInfiniteQueryOptions<OrganizationSecuritySettingsPageQuery, TError, TData>
    ) =>
    useInfiniteQuery<OrganizationSecuritySettingsPageQuery, TError, TData>(
      variables === undefined ? ['OrganizationSecuritySettingsPage.infinite'] : ['OrganizationSecuritySettingsPage.infinite', variables],
      (metaData) => fetcher<OrganizationSecuritySettingsPageQuery, OrganizationSecuritySettingsPageQueryVariables>(OrganizationSecuritySettingsPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteOrganizationSecuritySettingsPageQuery.getKey = (variables?: OrganizationSecuritySettingsPageQueryVariables) => variables === undefined ? ['OrganizationSecuritySettingsPage.infinite'] : ['OrganizationSecuritySettingsPage.infinite', variables];
;

useOrganizationSecuritySettingsPageQuery.fetcher = (variables?: OrganizationSecuritySettingsPageQueryVariables) => fetcher<OrganizationSecuritySettingsPageQuery, OrganizationSecuritySettingsPageQueryVariables>(OrganizationSecuritySettingsPageDocument, variables);
export const GetSsoConnectionOptionsDocument = `
    query GetSsoConnectionOptions {
  superAdminGetSsoConnectionOptions {
    id
    connectionName
    ssoIdIsEmail
  }
}
    `;
export const useGetSsoConnectionOptionsQuery = <
      TData = GetSsoConnectionOptionsQuery,
      TError = unknown
    >(
      variables?: GetSsoConnectionOptionsQueryVariables,
      options?: UseQueryOptions<GetSsoConnectionOptionsQuery, TError, TData>
    ) =>
    useQuery<GetSsoConnectionOptionsQuery, TError, TData>(
      variables === undefined ? ['GetSsoConnectionOptions'] : ['GetSsoConnectionOptions', variables],
      fetcher<GetSsoConnectionOptionsQuery, GetSsoConnectionOptionsQueryVariables>(GetSsoConnectionOptionsDocument, variables),
      options
    );

useGetSsoConnectionOptionsQuery.getKey = (variables?: GetSsoConnectionOptionsQueryVariables) => variables === undefined ? ['GetSsoConnectionOptions'] : ['GetSsoConnectionOptions', variables];
;

export const useInfiniteGetSsoConnectionOptionsQuery = <
      TData = GetSsoConnectionOptionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSsoConnectionOptionsQueryVariables,
      variables?: GetSsoConnectionOptionsQueryVariables,
      options?: UseInfiniteQueryOptions<GetSsoConnectionOptionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetSsoConnectionOptionsQuery, TError, TData>(
      variables === undefined ? ['GetSsoConnectionOptions.infinite'] : ['GetSsoConnectionOptions.infinite', variables],
      (metaData) => fetcher<GetSsoConnectionOptionsQuery, GetSsoConnectionOptionsQueryVariables>(GetSsoConnectionOptionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetSsoConnectionOptionsQuery.getKey = (variables?: GetSsoConnectionOptionsQueryVariables) => variables === undefined ? ['GetSsoConnectionOptions.infinite'] : ['GetSsoConnectionOptions.infinite', variables];
;

useGetSsoConnectionOptionsQuery.fetcher = (variables?: GetSsoConnectionOptionsQueryVariables) => fetcher<GetSsoConnectionOptionsQuery, GetSsoConnectionOptionsQueryVariables>(GetSsoConnectionOptionsDocument, variables);
export const SuperAdminGetAllActiveEmployerOrgsDocument = `
    query SuperAdminGetAllActiveEmployerOrgs {
  superAdminGetAllActiveOrgs {
    ... on EmployerOrgNode {
      id
      name
      urlFriendlyName
      emailDomain
    }
  }
}
    `;
export const useSuperAdminGetAllActiveEmployerOrgsQuery = <
      TData = SuperAdminGetAllActiveEmployerOrgsQuery,
      TError = unknown
    >(
      variables?: SuperAdminGetAllActiveEmployerOrgsQueryVariables,
      options?: UseQueryOptions<SuperAdminGetAllActiveEmployerOrgsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetAllActiveEmployerOrgsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminGetAllActiveEmployerOrgs'] : ['SuperAdminGetAllActiveEmployerOrgs', variables],
      fetcher<SuperAdminGetAllActiveEmployerOrgsQuery, SuperAdminGetAllActiveEmployerOrgsQueryVariables>(SuperAdminGetAllActiveEmployerOrgsDocument, variables),
      options
    );

useSuperAdminGetAllActiveEmployerOrgsQuery.getKey = (variables?: SuperAdminGetAllActiveEmployerOrgsQueryVariables) => variables === undefined ? ['SuperAdminGetAllActiveEmployerOrgs'] : ['SuperAdminGetAllActiveEmployerOrgs', variables];
;

export const useInfiniteSuperAdminGetAllActiveEmployerOrgsQuery = <
      TData = SuperAdminGetAllActiveEmployerOrgsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetAllActiveEmployerOrgsQueryVariables,
      variables?: SuperAdminGetAllActiveEmployerOrgsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetAllActiveEmployerOrgsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetAllActiveEmployerOrgsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminGetAllActiveEmployerOrgs.infinite'] : ['SuperAdminGetAllActiveEmployerOrgs.infinite', variables],
      (metaData) => fetcher<SuperAdminGetAllActiveEmployerOrgsQuery, SuperAdminGetAllActiveEmployerOrgsQueryVariables>(SuperAdminGetAllActiveEmployerOrgsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetAllActiveEmployerOrgsQuery.getKey = (variables?: SuperAdminGetAllActiveEmployerOrgsQueryVariables) => variables === undefined ? ['SuperAdminGetAllActiveEmployerOrgs.infinite'] : ['SuperAdminGetAllActiveEmployerOrgs.infinite', variables];
;

useSuperAdminGetAllActiveEmployerOrgsQuery.fetcher = (variables?: SuperAdminGetAllActiveEmployerOrgsQueryVariables) => fetcher<SuperAdminGetAllActiveEmployerOrgsQuery, SuperAdminGetAllActiveEmployerOrgsQueryVariables>(SuperAdminGetAllActiveEmployerOrgsDocument, variables);
export const SuperAdminGetAllActiveUniversityOrgsDocument = `
    query SuperAdminGetAllActiveUniversityOrgs {
  superAdminGetAllActiveOrgs {
    ... on EmployerOrgNode {
      id
      name
      urlFriendlyName
      emailDomain
    }
  }
}
    `;
export const useSuperAdminGetAllActiveUniversityOrgsQuery = <
      TData = SuperAdminGetAllActiveUniversityOrgsQuery,
      TError = unknown
    >(
      variables?: SuperAdminGetAllActiveUniversityOrgsQueryVariables,
      options?: UseQueryOptions<SuperAdminGetAllActiveUniversityOrgsQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetAllActiveUniversityOrgsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminGetAllActiveUniversityOrgs'] : ['SuperAdminGetAllActiveUniversityOrgs', variables],
      fetcher<SuperAdminGetAllActiveUniversityOrgsQuery, SuperAdminGetAllActiveUniversityOrgsQueryVariables>(SuperAdminGetAllActiveUniversityOrgsDocument, variables),
      options
    );

useSuperAdminGetAllActiveUniversityOrgsQuery.getKey = (variables?: SuperAdminGetAllActiveUniversityOrgsQueryVariables) => variables === undefined ? ['SuperAdminGetAllActiveUniversityOrgs'] : ['SuperAdminGetAllActiveUniversityOrgs', variables];
;

export const useInfiniteSuperAdminGetAllActiveUniversityOrgsQuery = <
      TData = SuperAdminGetAllActiveUniversityOrgsQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetAllActiveUniversityOrgsQueryVariables,
      variables?: SuperAdminGetAllActiveUniversityOrgsQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetAllActiveUniversityOrgsQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetAllActiveUniversityOrgsQuery, TError, TData>(
      variables === undefined ? ['SuperAdminGetAllActiveUniversityOrgs.infinite'] : ['SuperAdminGetAllActiveUniversityOrgs.infinite', variables],
      (metaData) => fetcher<SuperAdminGetAllActiveUniversityOrgsQuery, SuperAdminGetAllActiveUniversityOrgsQueryVariables>(SuperAdminGetAllActiveUniversityOrgsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetAllActiveUniversityOrgsQuery.getKey = (variables?: SuperAdminGetAllActiveUniversityOrgsQueryVariables) => variables === undefined ? ['SuperAdminGetAllActiveUniversityOrgs.infinite'] : ['SuperAdminGetAllActiveUniversityOrgs.infinite', variables];
;

useSuperAdminGetAllActiveUniversityOrgsQuery.fetcher = (variables?: SuperAdminGetAllActiveUniversityOrgsQueryVariables) => fetcher<SuperAdminGetAllActiveUniversityOrgsQuery, SuperAdminGetAllActiveUniversityOrgsQueryVariables>(SuperAdminGetAllActiveUniversityOrgsDocument, variables);
export const SuperAdminGetEventsForOrgDocument = `
    query SuperAdminGetEventsForOrg($orgId: ID!, $eventTypes: [EventType!]!) {
  superAdminGetEventsForOrg(orgId: $orgId, eventTypes: $eventTypes) {
    id
    name
    eventType
    memberFeedbackDisabled
    candidateReminderDisabled
    inviteOnly
    start {
      date
    }
  }
}
    `;
export const useSuperAdminGetEventsForOrgQuery = <
      TData = SuperAdminGetEventsForOrgQuery,
      TError = unknown
    >(
      variables: SuperAdminGetEventsForOrgQueryVariables,
      options?: UseQueryOptions<SuperAdminGetEventsForOrgQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetEventsForOrgQuery, TError, TData>(
      ['SuperAdminGetEventsForOrg', variables],
      fetcher<SuperAdminGetEventsForOrgQuery, SuperAdminGetEventsForOrgQueryVariables>(SuperAdminGetEventsForOrgDocument, variables),
      options
    );

useSuperAdminGetEventsForOrgQuery.getKey = (variables: SuperAdminGetEventsForOrgQueryVariables) => ['SuperAdminGetEventsForOrg', variables];
;

export const useInfiniteSuperAdminGetEventsForOrgQuery = <
      TData = SuperAdminGetEventsForOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetEventsForOrgQueryVariables,
      variables: SuperAdminGetEventsForOrgQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetEventsForOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetEventsForOrgQuery, TError, TData>(
      ['SuperAdminGetEventsForOrg.infinite', variables],
      (metaData) => fetcher<SuperAdminGetEventsForOrgQuery, SuperAdminGetEventsForOrgQueryVariables>(SuperAdminGetEventsForOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetEventsForOrgQuery.getKey = (variables: SuperAdminGetEventsForOrgQueryVariables) => ['SuperAdminGetEventsForOrg.infinite', variables];
;

useSuperAdminGetEventsForOrgQuery.fetcher = (variables: SuperAdminGetEventsForOrgQueryVariables) => fetcher<SuperAdminGetEventsForOrgQuery, SuperAdminGetEventsForOrgQueryVariables>(SuperAdminGetEventsForOrgDocument, variables);
export const SuperAdminGetMemberAttendeesForOrgDocument = `
    query SuperAdminGetMemberAttendeesForOrg($orgId: ID!, $eventId: ID!) {
  superAdminGetEventForOrg(orgId: $orgId, eventId: $eventId) {
    ... on PhysicalEventNode {
      ...RegisteredMemberDetails
    }
    ... on WebinarEventNode {
      ...RegisteredMemberDetails
    }
    ... on CoffeeChatEventNode {
      ...RegisteredMemberDetails
    }
    ... on InvitedEmployerEventNode {
      ...RegisteredMemberDetails
    }
    ... on OCIEmployerEventNode {
      ...RegisteredMemberDetails
    }
    ... on SharedNetworkingEventNode {
      ...RegisteredMemberDetails
    }
    ... on CallbackEventNode {
      ...RegisteredMemberDetails
    }
    ... on InterviewSchedulingEmployerEventNode {
      ...RegisteredMemberDetails
    }
    ... on LotteryEmployerEventNode {
      ...RegisteredMemberDetails
    }
  }
}
    ${RegisteredMemberDetailsFragmentDoc}`;
export const useSuperAdminGetMemberAttendeesForOrgQuery = <
      TData = SuperAdminGetMemberAttendeesForOrgQuery,
      TError = unknown
    >(
      variables: SuperAdminGetMemberAttendeesForOrgQueryVariables,
      options?: UseQueryOptions<SuperAdminGetMemberAttendeesForOrgQuery, TError, TData>
    ) =>
    useQuery<SuperAdminGetMemberAttendeesForOrgQuery, TError, TData>(
      ['SuperAdminGetMemberAttendeesForOrg', variables],
      fetcher<SuperAdminGetMemberAttendeesForOrgQuery, SuperAdminGetMemberAttendeesForOrgQueryVariables>(SuperAdminGetMemberAttendeesForOrgDocument, variables),
      options
    );

useSuperAdminGetMemberAttendeesForOrgQuery.getKey = (variables: SuperAdminGetMemberAttendeesForOrgQueryVariables) => ['SuperAdminGetMemberAttendeesForOrg', variables];
;

export const useInfiniteSuperAdminGetMemberAttendeesForOrgQuery = <
      TData = SuperAdminGetMemberAttendeesForOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminGetMemberAttendeesForOrgQueryVariables,
      variables: SuperAdminGetMemberAttendeesForOrgQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminGetMemberAttendeesForOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminGetMemberAttendeesForOrgQuery, TError, TData>(
      ['SuperAdminGetMemberAttendeesForOrg.infinite', variables],
      (metaData) => fetcher<SuperAdminGetMemberAttendeesForOrgQuery, SuperAdminGetMemberAttendeesForOrgQueryVariables>(SuperAdminGetMemberAttendeesForOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminGetMemberAttendeesForOrgQuery.getKey = (variables: SuperAdminGetMemberAttendeesForOrgQueryVariables) => ['SuperAdminGetMemberAttendeesForOrg.infinite', variables];
;

useSuperAdminGetMemberAttendeesForOrgQuery.fetcher = (variables: SuperAdminGetMemberAttendeesForOrgQueryVariables) => fetcher<SuperAdminGetMemberAttendeesForOrgQuery, SuperAdminGetMemberAttendeesForOrgQueryVariables>(SuperAdminGetMemberAttendeesForOrgDocument, variables);
export const GetCandidatesSclpDocument = `
    query getCandidatesSCLP($filterBy: CandidateFilterBy, $sortBy: CandidateSortBy, $first: Int, $after: String) {
  getCandidatesSCLP(
    filterBy: $filterBy
    sortBy: $sortBy
    first: $first
    after: $after
  ) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPrevPage
    }
    nodes {
      id
      firstName
      lastName
      email
      phone
      lawSchool
    }
    edges {
      node {
        id
      }
      cursor
    }
    totalCount
  }
}
    `;
export const useGetCandidatesSclpQuery = <
      TData = GetCandidatesSclpQuery,
      TError = unknown
    >(
      variables?: GetCandidatesSclpQueryVariables,
      options?: UseQueryOptions<GetCandidatesSclpQuery, TError, TData>
    ) =>
    useQuery<GetCandidatesSclpQuery, TError, TData>(
      variables === undefined ? ['getCandidatesSCLP'] : ['getCandidatesSCLP', variables],
      fetcher<GetCandidatesSclpQuery, GetCandidatesSclpQueryVariables>(GetCandidatesSclpDocument, variables),
      options
    );

useGetCandidatesSclpQuery.getKey = (variables?: GetCandidatesSclpQueryVariables) => variables === undefined ? ['getCandidatesSCLP'] : ['getCandidatesSCLP', variables];
;

export const useInfiniteGetCandidatesSclpQuery = <
      TData = GetCandidatesSclpQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetCandidatesSclpQueryVariables,
      variables?: GetCandidatesSclpQueryVariables,
      options?: UseInfiniteQueryOptions<GetCandidatesSclpQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetCandidatesSclpQuery, TError, TData>(
      variables === undefined ? ['getCandidatesSCLP.infinite'] : ['getCandidatesSCLP.infinite', variables],
      (metaData) => fetcher<GetCandidatesSclpQuery, GetCandidatesSclpQueryVariables>(GetCandidatesSclpDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetCandidatesSclpQuery.getKey = (variables?: GetCandidatesSclpQueryVariables) => variables === undefined ? ['getCandidatesSCLP.infinite'] : ['getCandidatesSCLP.infinite', variables];
;

useGetCandidatesSclpQuery.fetcher = (variables?: GetCandidatesSclpQueryVariables) => fetcher<GetCandidatesSclpQuery, GetCandidatesSclpQueryVariables>(GetCandidatesSclpDocument, variables);
export const AllLawSchoolsDocument = `
    query AllLawSchools {
  allLawSchools {
    nodes {
      id
      name
    }
  }
}
    `;
export const useAllLawSchoolsQuery = <
      TData = AllLawSchoolsQuery,
      TError = unknown
    >(
      variables?: AllLawSchoolsQueryVariables,
      options?: UseQueryOptions<AllLawSchoolsQuery, TError, TData>
    ) =>
    useQuery<AllLawSchoolsQuery, TError, TData>(
      variables === undefined ? ['AllLawSchools'] : ['AllLawSchools', variables],
      fetcher<AllLawSchoolsQuery, AllLawSchoolsQueryVariables>(AllLawSchoolsDocument, variables),
      options
    );

useAllLawSchoolsQuery.getKey = (variables?: AllLawSchoolsQueryVariables) => variables === undefined ? ['AllLawSchools'] : ['AllLawSchools', variables];
;

export const useInfiniteAllLawSchoolsQuery = <
      TData = AllLawSchoolsQuery,
      TError = unknown
    >(
      pageParamKey: keyof AllLawSchoolsQueryVariables,
      variables?: AllLawSchoolsQueryVariables,
      options?: UseInfiniteQueryOptions<AllLawSchoolsQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllLawSchoolsQuery, TError, TData>(
      variables === undefined ? ['AllLawSchools.infinite'] : ['AllLawSchools.infinite', variables],
      (metaData) => fetcher<AllLawSchoolsQuery, AllLawSchoolsQueryVariables>(AllLawSchoolsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAllLawSchoolsQuery.getKey = (variables?: AllLawSchoolsQueryVariables) => variables === undefined ? ['AllLawSchools.infinite'] : ['AllLawSchools.infinite', variables];
;

useAllLawSchoolsQuery.fetcher = (variables?: AllLawSchoolsQueryVariables) => fetcher<AllLawSchoolsQuery, AllLawSchoolsQueryVariables>(AllLawSchoolsDocument, variables);
export const AllOfficeLocationsDocument = `
    query AllOfficeLocations {
  allOfficeLocations {
    nodes {
      id
      name
    }
  }
}
    `;
export const useAllOfficeLocationsQuery = <
      TData = AllOfficeLocationsQuery,
      TError = unknown
    >(
      variables?: AllOfficeLocationsQueryVariables,
      options?: UseQueryOptions<AllOfficeLocationsQuery, TError, TData>
    ) =>
    useQuery<AllOfficeLocationsQuery, TError, TData>(
      variables === undefined ? ['AllOfficeLocations'] : ['AllOfficeLocations', variables],
      fetcher<AllOfficeLocationsQuery, AllOfficeLocationsQueryVariables>(AllOfficeLocationsDocument, variables),
      options
    );

useAllOfficeLocationsQuery.getKey = (variables?: AllOfficeLocationsQueryVariables) => variables === undefined ? ['AllOfficeLocations'] : ['AllOfficeLocations', variables];
;

export const useInfiniteAllOfficeLocationsQuery = <
      TData = AllOfficeLocationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof AllOfficeLocationsQueryVariables,
      variables?: AllOfficeLocationsQueryVariables,
      options?: UseInfiniteQueryOptions<AllOfficeLocationsQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllOfficeLocationsQuery, TError, TData>(
      variables === undefined ? ['AllOfficeLocations.infinite'] : ['AllOfficeLocations.infinite', variables],
      (metaData) => fetcher<AllOfficeLocationsQuery, AllOfficeLocationsQueryVariables>(AllOfficeLocationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAllOfficeLocationsQuery.getKey = (variables?: AllOfficeLocationsQueryVariables) => variables === undefined ? ['AllOfficeLocations.infinite'] : ['AllOfficeLocations.infinite', variables];
;

useAllOfficeLocationsQuery.fetcher = (variables?: AllOfficeLocationsQueryVariables) => fetcher<AllOfficeLocationsQuery, AllOfficeLocationsQueryVariables>(AllOfficeLocationsDocument, variables);
export const AllPracticeAreasDocument = `
    query AllPracticeAreas {
  allPracticeAreas {
    nodes {
      id
      name
    }
  }
}
    `;
export const useAllPracticeAreasQuery = <
      TData = AllPracticeAreasQuery,
      TError = unknown
    >(
      variables?: AllPracticeAreasQueryVariables,
      options?: UseQueryOptions<AllPracticeAreasQuery, TError, TData>
    ) =>
    useQuery<AllPracticeAreasQuery, TError, TData>(
      variables === undefined ? ['AllPracticeAreas'] : ['AllPracticeAreas', variables],
      fetcher<AllPracticeAreasQuery, AllPracticeAreasQueryVariables>(AllPracticeAreasDocument, variables),
      options
    );

useAllPracticeAreasQuery.getKey = (variables?: AllPracticeAreasQueryVariables) => variables === undefined ? ['AllPracticeAreas'] : ['AllPracticeAreas', variables];
;

export const useInfiniteAllPracticeAreasQuery = <
      TData = AllPracticeAreasQuery,
      TError = unknown
    >(
      pageParamKey: keyof AllPracticeAreasQueryVariables,
      variables?: AllPracticeAreasQueryVariables,
      options?: UseInfiniteQueryOptions<AllPracticeAreasQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllPracticeAreasQuery, TError, TData>(
      variables === undefined ? ['AllPracticeAreas.infinite'] : ['AllPracticeAreas.infinite', variables],
      (metaData) => fetcher<AllPracticeAreasQuery, AllPracticeAreasQueryVariables>(AllPracticeAreasDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAllPracticeAreasQuery.getKey = (variables?: AllPracticeAreasQueryVariables) => variables === undefined ? ['AllPracticeAreas.infinite'] : ['AllPracticeAreas.infinite', variables];
;

useAllPracticeAreasQuery.fetcher = (variables?: AllPracticeAreasQueryVariables) => fetcher<AllPracticeAreasQuery, AllPracticeAreasQueryVariables>(AllPracticeAreasDocument, variables);
export const AllPracticeCategoriesDocument = `
    query AllPracticeCategories {
  allPracticeCategories {
    nodes {
      id
      name
    }
  }
}
    `;
export const useAllPracticeCategoriesQuery = <
      TData = AllPracticeCategoriesQuery,
      TError = unknown
    >(
      variables?: AllPracticeCategoriesQueryVariables,
      options?: UseQueryOptions<AllPracticeCategoriesQuery, TError, TData>
    ) =>
    useQuery<AllPracticeCategoriesQuery, TError, TData>(
      variables === undefined ? ['AllPracticeCategories'] : ['AllPracticeCategories', variables],
      fetcher<AllPracticeCategoriesQuery, AllPracticeCategoriesQueryVariables>(AllPracticeCategoriesDocument, variables),
      options
    );

useAllPracticeCategoriesQuery.getKey = (variables?: AllPracticeCategoriesQueryVariables) => variables === undefined ? ['AllPracticeCategories'] : ['AllPracticeCategories', variables];
;

export const useInfiniteAllPracticeCategoriesQuery = <
      TData = AllPracticeCategoriesQuery,
      TError = unknown
    >(
      pageParamKey: keyof AllPracticeCategoriesQueryVariables,
      variables?: AllPracticeCategoriesQueryVariables,
      options?: UseInfiniteQueryOptions<AllPracticeCategoriesQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllPracticeCategoriesQuery, TError, TData>(
      variables === undefined ? ['AllPracticeCategories.infinite'] : ['AllPracticeCategories.infinite', variables],
      (metaData) => fetcher<AllPracticeCategoriesQuery, AllPracticeCategoriesQueryVariables>(AllPracticeCategoriesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAllPracticeCategoriesQuery.getKey = (variables?: AllPracticeCategoriesQueryVariables) => variables === undefined ? ['AllPracticeCategories.infinite'] : ['AllPracticeCategories.infinite', variables];
;

useAllPracticeCategoriesQuery.fetcher = (variables?: AllPracticeCategoriesQueryVariables) => fetcher<AllPracticeCategoriesQuery, AllPracticeCategoriesQueryVariables>(AllPracticeCategoriesDocument, variables);
export const AllUniversitiesDocument = `
    query AllUniversities {
  allUniversities {
    nodes {
      id
      name
    }
  }
}
    `;
export const useAllUniversitiesQuery = <
      TData = AllUniversitiesQuery,
      TError = unknown
    >(
      variables?: AllUniversitiesQueryVariables,
      options?: UseQueryOptions<AllUniversitiesQuery, TError, TData>
    ) =>
    useQuery<AllUniversitiesQuery, TError, TData>(
      variables === undefined ? ['AllUniversities'] : ['AllUniversities', variables],
      fetcher<AllUniversitiesQuery, AllUniversitiesQueryVariables>(AllUniversitiesDocument, variables),
      options
    );

useAllUniversitiesQuery.getKey = (variables?: AllUniversitiesQueryVariables) => variables === undefined ? ['AllUniversities'] : ['AllUniversities', variables];
;

export const useInfiniteAllUniversitiesQuery = <
      TData = AllUniversitiesQuery,
      TError = unknown
    >(
      pageParamKey: keyof AllUniversitiesQueryVariables,
      variables?: AllUniversitiesQueryVariables,
      options?: UseInfiniteQueryOptions<AllUniversitiesQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllUniversitiesQuery, TError, TData>(
      variables === undefined ? ['AllUniversities.infinite'] : ['AllUniversities.infinite', variables],
      (metaData) => fetcher<AllUniversitiesQuery, AllUniversitiesQueryVariables>(AllUniversitiesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAllUniversitiesQuery.getKey = (variables?: AllUniversitiesQueryVariables) => variables === undefined ? ['AllUniversities.infinite'] : ['AllUniversities.infinite', variables];
;

useAllUniversitiesQuery.fetcher = (variables?: AllUniversitiesQueryVariables) => fetcher<AllUniversitiesQuery, AllUniversitiesQueryVariables>(AllUniversitiesDocument, variables);
export const SuperAdminLoginGuardDocument = `
    query SuperAdminLoginGuard {
  whoAmI {
    isLoggedIn
    asOrgUser {
      __typename
      orgId
      userId
      loggedInEmail
      orgType
      orgFriendlyName
    }
  }
}
    `;
export const useSuperAdminLoginGuardQuery = <
      TData = SuperAdminLoginGuardQuery,
      TError = unknown
    >(
      variables?: SuperAdminLoginGuardQueryVariables,
      options?: UseQueryOptions<SuperAdminLoginGuardQuery, TError, TData>
    ) =>
    useQuery<SuperAdminLoginGuardQuery, TError, TData>(
      variables === undefined ? ['SuperAdminLoginGuard'] : ['SuperAdminLoginGuard', variables],
      fetcher<SuperAdminLoginGuardQuery, SuperAdminLoginGuardQueryVariables>(SuperAdminLoginGuardDocument, variables),
      options
    );

useSuperAdminLoginGuardQuery.getKey = (variables?: SuperAdminLoginGuardQueryVariables) => variables === undefined ? ['SuperAdminLoginGuard'] : ['SuperAdminLoginGuard', variables];
;

export const useInfiniteSuperAdminLoginGuardQuery = <
      TData = SuperAdminLoginGuardQuery,
      TError = unknown
    >(
      pageParamKey: keyof SuperAdminLoginGuardQueryVariables,
      variables?: SuperAdminLoginGuardQueryVariables,
      options?: UseInfiniteQueryOptions<SuperAdminLoginGuardQuery, TError, TData>
    ) =>
    useInfiniteQuery<SuperAdminLoginGuardQuery, TError, TData>(
      variables === undefined ? ['SuperAdminLoginGuard.infinite'] : ['SuperAdminLoginGuard.infinite', variables],
      (metaData) => fetcher<SuperAdminLoginGuardQuery, SuperAdminLoginGuardQueryVariables>(SuperAdminLoginGuardDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteSuperAdminLoginGuardQuery.getKey = (variables?: SuperAdminLoginGuardQueryVariables) => variables === undefined ? ['SuperAdminLoginGuard.infinite'] : ['SuperAdminLoginGuard.infinite', variables];
;

useSuperAdminLoginGuardQuery.fetcher = (variables?: SuperAdminLoginGuardQueryVariables) => fetcher<SuperAdminLoginGuardQuery, SuperAdminLoginGuardQueryVariables>(SuperAdminLoginGuardDocument, variables);
export const AllCustomProgramEvaluationResponsesDocument = `
    query AllCustomProgramEvaluationResponses($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    customEvaluations {
      id
      evaluationType
      evaluationName
      feedbackReminderEmailEnabled
      questions {
        evaluationQuestion {
          id
          label
          subtext
          highScale
          lowScale
          type
        }
      }
      responses {
        id
        requestedAt
        completedAt
        associate {
          id
          candidate {
            id
            firstName
            lastName
          }
        }
        attorney {
          id
          firstName
          lastName
        }
        answers {
          id
          orgFeedbackId
          ratingAnswer
          yesNoAnswer
          singleSelectAnswer
          multiSelectAnswers
          freeText
          comment
        }
      }
    }
  }
}
    `;
export const useAllCustomProgramEvaluationResponsesQuery = <
      TData = AllCustomProgramEvaluationResponsesQuery,
      TError = unknown
    >(
      variables: AllCustomProgramEvaluationResponsesQueryVariables,
      options?: UseQueryOptions<AllCustomProgramEvaluationResponsesQuery, TError, TData>
    ) =>
    useQuery<AllCustomProgramEvaluationResponsesQuery, TError, TData>(
      ['AllCustomProgramEvaluationResponses', variables],
      fetcher<AllCustomProgramEvaluationResponsesQuery, AllCustomProgramEvaluationResponsesQueryVariables>(AllCustomProgramEvaluationResponsesDocument, variables),
      options
    );

useAllCustomProgramEvaluationResponsesQuery.getKey = (variables: AllCustomProgramEvaluationResponsesQueryVariables) => ['AllCustomProgramEvaluationResponses', variables];
;

export const useInfiniteAllCustomProgramEvaluationResponsesQuery = <
      TData = AllCustomProgramEvaluationResponsesQuery,
      TError = unknown
    >(
      pageParamKey: keyof AllCustomProgramEvaluationResponsesQueryVariables,
      variables: AllCustomProgramEvaluationResponsesQueryVariables,
      options?: UseInfiniteQueryOptions<AllCustomProgramEvaluationResponsesQuery, TError, TData>
    ) =>
    useInfiniteQuery<AllCustomProgramEvaluationResponsesQuery, TError, TData>(
      ['AllCustomProgramEvaluationResponses.infinite', variables],
      (metaData) => fetcher<AllCustomProgramEvaluationResponsesQuery, AllCustomProgramEvaluationResponsesQueryVariables>(AllCustomProgramEvaluationResponsesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAllCustomProgramEvaluationResponsesQuery.getKey = (variables: AllCustomProgramEvaluationResponsesQueryVariables) => ['AllCustomProgramEvaluationResponses.infinite', variables];
;

useAllCustomProgramEvaluationResponsesQuery.fetcher = (variables: AllCustomProgramEvaluationResponsesQueryVariables) => fetcher<AllCustomProgramEvaluationResponsesQuery, AllCustomProgramEvaluationResponsesQueryVariables>(AllCustomProgramEvaluationResponsesDocument, variables);
export const SendProjectEvaluationRequestEmailDocument = `
    mutation SendProjectEvaluationRequestEmail($programId: ID!, $projectId: ID!, $associateRecruitId: ID!, $attorneyUserId: ID!) {
  sendProjectEvaluationRequestEmail(
    programId: $programId
    projectId: $projectId
    associateRecruitId: $associateRecruitId
    attorneyUserId: $attorneyUserId
  )
}
    `;
export const useSendProjectEvaluationRequestEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendProjectEvaluationRequestEmailMutation, TError, SendProjectEvaluationRequestEmailMutationVariables, TContext>) =>
    useMutation<SendProjectEvaluationRequestEmailMutation, TError, SendProjectEvaluationRequestEmailMutationVariables, TContext>(
      ['SendProjectEvaluationRequestEmail'],
      (variables?: SendProjectEvaluationRequestEmailMutationVariables) => fetcher<SendProjectEvaluationRequestEmailMutation, SendProjectEvaluationRequestEmailMutationVariables>(SendProjectEvaluationRequestEmailDocument, variables)(),
      options
    );
useSendProjectEvaluationRequestEmailMutation.fetcher = (variables: SendProjectEvaluationRequestEmailMutationVariables) => fetcher<SendProjectEvaluationRequestEmailMutation, SendProjectEvaluationRequestEmailMutationVariables>(SendProjectEvaluationRequestEmailDocument, variables);
export const SendProgramEvaluationRequestEmailForAssociatesDocument = `
    mutation SendProgramEvaluationRequestEmailForAssociates($programId: ID!, $programEvaluationId: ID!, $associateRecruitIds: [ID!]!, $options: ProgramEvaluationRequestOptions) {
  sendProgramEvaluationRequestEmailForAssociates(
    programId: $programId
    programEvaluationId: $programEvaluationId
    associateRecruitIds: $associateRecruitIds
    options: $options
  )
}
    `;
export const useSendProgramEvaluationRequestEmailForAssociatesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendProgramEvaluationRequestEmailForAssociatesMutation, TError, SendProgramEvaluationRequestEmailForAssociatesMutationVariables, TContext>) =>
    useMutation<SendProgramEvaluationRequestEmailForAssociatesMutation, TError, SendProgramEvaluationRequestEmailForAssociatesMutationVariables, TContext>(
      ['SendProgramEvaluationRequestEmailForAssociates'],
      (variables?: SendProgramEvaluationRequestEmailForAssociatesMutationVariables) => fetcher<SendProgramEvaluationRequestEmailForAssociatesMutation, SendProgramEvaluationRequestEmailForAssociatesMutationVariables>(SendProgramEvaluationRequestEmailForAssociatesDocument, variables)(),
      options
    );
useSendProgramEvaluationRequestEmailForAssociatesMutation.fetcher = (variables: SendProgramEvaluationRequestEmailForAssociatesMutationVariables) => fetcher<SendProgramEvaluationRequestEmailForAssociatesMutation, SendProgramEvaluationRequestEmailForAssociatesMutationVariables>(SendProgramEvaluationRequestEmailForAssociatesDocument, variables);
export const CreateProgramAssociateDocument = `
    mutation CreateProgramAssociate($associate: ProgramAssociateInput!) {
  createProgramAssociate(associate: $associate)
}
    `;
export const useCreateProgramAssociateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProgramAssociateMutation, TError, CreateProgramAssociateMutationVariables, TContext>) =>
    useMutation<CreateProgramAssociateMutation, TError, CreateProgramAssociateMutationVariables, TContext>(
      ['CreateProgramAssociate'],
      (variables?: CreateProgramAssociateMutationVariables) => fetcher<CreateProgramAssociateMutation, CreateProgramAssociateMutationVariables>(CreateProgramAssociateDocument, variables)(),
      options
    );
useCreateProgramAssociateMutation.fetcher = (variables: CreateProgramAssociateMutationVariables) => fetcher<CreateProgramAssociateMutation, CreateProgramAssociateMutationVariables>(CreateProgramAssociateDocument, variables);
export const UpdateProgramAssociateDocument = `
    mutation UpdateProgramAssociate($updateInfo: ProgramAssociateUpdateInput!) {
  updateProgramAssociate(updateInfo: $updateInfo) {
    id
  }
}
    `;
export const useUpdateProgramAssociateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProgramAssociateMutation, TError, UpdateProgramAssociateMutationVariables, TContext>) =>
    useMutation<UpdateProgramAssociateMutation, TError, UpdateProgramAssociateMutationVariables, TContext>(
      ['UpdateProgramAssociate'],
      (variables?: UpdateProgramAssociateMutationVariables) => fetcher<UpdateProgramAssociateMutation, UpdateProgramAssociateMutationVariables>(UpdateProgramAssociateDocument, variables)(),
      options
    );
useUpdateProgramAssociateMutation.fetcher = (variables: UpdateProgramAssociateMutationVariables) => fetcher<UpdateProgramAssociateMutation, UpdateProgramAssociateMutationVariables>(UpdateProgramAssociateDocument, variables);
export const UpdateProgramAssociatePracticeAreasDocument = `
    mutation UpdateProgramAssociatePracticeAreas($updateInfo: ProgramAssociatePreferredPracticeAreasUpdateInput!) {
  updateProgramAssociatePracticeAreas(practiceAreaUpdate: $updateInfo) {
    id
  }
}
    `;
export const useUpdateProgramAssociatePracticeAreasMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProgramAssociatePracticeAreasMutation, TError, UpdateProgramAssociatePracticeAreasMutationVariables, TContext>) =>
    useMutation<UpdateProgramAssociatePracticeAreasMutation, TError, UpdateProgramAssociatePracticeAreasMutationVariables, TContext>(
      ['UpdateProgramAssociatePracticeAreas'],
      (variables?: UpdateProgramAssociatePracticeAreasMutationVariables) => fetcher<UpdateProgramAssociatePracticeAreasMutation, UpdateProgramAssociatePracticeAreasMutationVariables>(UpdateProgramAssociatePracticeAreasDocument, variables)(),
      options
    );
useUpdateProgramAssociatePracticeAreasMutation.fetcher = (variables: UpdateProgramAssociatePracticeAreasMutationVariables) => fetcher<UpdateProgramAssociatePracticeAreasMutation, UpdateProgramAssociatePracticeAreasMutationVariables>(UpdateProgramAssociatePracticeAreasDocument, variables);
export const ProgramAssociatesForOrgDocument = `
    query ProgramAssociatesForOrg {
  programAssociatesForOrg {
    id
    programId
    firstName
    lastName
    email
    phoneNumber
    phoneExtension
    location
    languages
    lawSchools
    employersEmployeeId
    startDate
    endDate
    preferredPracticeAreas {
      order
      practiceAreaId
      orgSpecificPracticeAreaId
      preferredPracticeAreaName
    }
    splitOffice
    mentors {
      memberId
      firstName
      lastName
      email
      mentorRole
    }
    recruitIdForAssociateWorkEmail
    linkedRecruitIds
  }
}
    `;
export const useProgramAssociatesForOrgQuery = <
      TData = ProgramAssociatesForOrgQuery,
      TError = unknown
    >(
      variables?: ProgramAssociatesForOrgQueryVariables,
      options?: UseQueryOptions<ProgramAssociatesForOrgQuery, TError, TData>
    ) =>
    useQuery<ProgramAssociatesForOrgQuery, TError, TData>(
      variables === undefined ? ['ProgramAssociatesForOrg'] : ['ProgramAssociatesForOrg', variables],
      fetcher<ProgramAssociatesForOrgQuery, ProgramAssociatesForOrgQueryVariables>(ProgramAssociatesForOrgDocument, variables),
      options
    );

useProgramAssociatesForOrgQuery.getKey = (variables?: ProgramAssociatesForOrgQueryVariables) => variables === undefined ? ['ProgramAssociatesForOrg'] : ['ProgramAssociatesForOrg', variables];
;

export const useInfiniteProgramAssociatesForOrgQuery = <
      TData = ProgramAssociatesForOrgQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramAssociatesForOrgQueryVariables,
      variables?: ProgramAssociatesForOrgQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramAssociatesForOrgQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramAssociatesForOrgQuery, TError, TData>(
      variables === undefined ? ['ProgramAssociatesForOrg.infinite'] : ['ProgramAssociatesForOrg.infinite', variables],
      (metaData) => fetcher<ProgramAssociatesForOrgQuery, ProgramAssociatesForOrgQueryVariables>(ProgramAssociatesForOrgDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramAssociatesForOrgQuery.getKey = (variables?: ProgramAssociatesForOrgQueryVariables) => variables === undefined ? ['ProgramAssociatesForOrg.infinite'] : ['ProgramAssociatesForOrg.infinite', variables];
;

useProgramAssociatesForOrgQuery.fetcher = (variables?: ProgramAssociatesForOrgQueryVariables) => fetcher<ProgramAssociatesForOrgQuery, ProgramAssociatesForOrgQueryVariables>(ProgramAssociatesForOrgDocument, variables);
export const ProgramAssociatesByProgramIdDocument = `
    query ProgramAssociatesByProgramId($programId: ID!) {
  programAssociatesByProgramId(programId: $programId) {
    id
    programId
    firstName
    lastName
    email
    phoneNumber
    phoneExtension
    location
    languages
    lawSchools
    employersEmployeeId
    startDate
    endDate
    preferredPracticeAreas {
      order
      practiceAreaId
      orgSpecificPracticeAreaId
      preferredPracticeAreaName
    }
    splitOffice
    mentors {
      memberId
      firstName
      lastName
      email
      mentorRole
    }
    recruitIdForAssociateWorkEmail
    linkedRecruitIds
  }
}
    `;
export const useProgramAssociatesByProgramIdQuery = <
      TData = ProgramAssociatesByProgramIdQuery,
      TError = unknown
    >(
      variables: ProgramAssociatesByProgramIdQueryVariables,
      options?: UseQueryOptions<ProgramAssociatesByProgramIdQuery, TError, TData>
    ) =>
    useQuery<ProgramAssociatesByProgramIdQuery, TError, TData>(
      ['ProgramAssociatesByProgramId', variables],
      fetcher<ProgramAssociatesByProgramIdQuery, ProgramAssociatesByProgramIdQueryVariables>(ProgramAssociatesByProgramIdDocument, variables),
      options
    );

useProgramAssociatesByProgramIdQuery.getKey = (variables: ProgramAssociatesByProgramIdQueryVariables) => ['ProgramAssociatesByProgramId', variables];
;

export const useInfiniteProgramAssociatesByProgramIdQuery = <
      TData = ProgramAssociatesByProgramIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramAssociatesByProgramIdQueryVariables,
      variables: ProgramAssociatesByProgramIdQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramAssociatesByProgramIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramAssociatesByProgramIdQuery, TError, TData>(
      ['ProgramAssociatesByProgramId.infinite', variables],
      (metaData) => fetcher<ProgramAssociatesByProgramIdQuery, ProgramAssociatesByProgramIdQueryVariables>(ProgramAssociatesByProgramIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramAssociatesByProgramIdQuery.getKey = (variables: ProgramAssociatesByProgramIdQueryVariables) => ['ProgramAssociatesByProgramId.infinite', variables];
;

useProgramAssociatesByProgramIdQuery.fetcher = (variables: ProgramAssociatesByProgramIdQueryVariables) => fetcher<ProgramAssociatesByProgramIdQuery, ProgramAssociatesByProgramIdQueryVariables>(ProgramAssociatesByProgramIdDocument, variables);
export const ProgramAssociateByRecruitIdAndProgramIdDocument = `
    query ProgramAssociateByRecruitIdAndProgramId($programId: ID!, $associateRecruitId: Int!) {
  programAssociateByRecruitIdAndProgramId(
    programId: $programId
    associateRecruitId: $associateRecruitId
  ) {
    id
    programId
    firstName
    lastName
    email
    phoneNumber
    phoneExtension
    location
    languages
    lawSchools
    employersEmployeeId
    startDate
    endDate
    preferredPracticeAreas {
      order
      practiceAreaId
      orgSpecificPracticeAreaId
      preferredPracticeAreaName
    }
    splitOffice
    mentors {
      memberId
      firstName
      lastName
      email
      mentorRole
    }
    recruitIdForAssociateWorkEmail
    linkedRecruitIds
  }
}
    `;
export const useProgramAssociateByRecruitIdAndProgramIdQuery = <
      TData = ProgramAssociateByRecruitIdAndProgramIdQuery,
      TError = unknown
    >(
      variables: ProgramAssociateByRecruitIdAndProgramIdQueryVariables,
      options?: UseQueryOptions<ProgramAssociateByRecruitIdAndProgramIdQuery, TError, TData>
    ) =>
    useQuery<ProgramAssociateByRecruitIdAndProgramIdQuery, TError, TData>(
      ['ProgramAssociateByRecruitIdAndProgramId', variables],
      fetcher<ProgramAssociateByRecruitIdAndProgramIdQuery, ProgramAssociateByRecruitIdAndProgramIdQueryVariables>(ProgramAssociateByRecruitIdAndProgramIdDocument, variables),
      options
    );

useProgramAssociateByRecruitIdAndProgramIdQuery.getKey = (variables: ProgramAssociateByRecruitIdAndProgramIdQueryVariables) => ['ProgramAssociateByRecruitIdAndProgramId', variables];
;

export const useInfiniteProgramAssociateByRecruitIdAndProgramIdQuery = <
      TData = ProgramAssociateByRecruitIdAndProgramIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramAssociateByRecruitIdAndProgramIdQueryVariables,
      variables: ProgramAssociateByRecruitIdAndProgramIdQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramAssociateByRecruitIdAndProgramIdQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramAssociateByRecruitIdAndProgramIdQuery, TError, TData>(
      ['ProgramAssociateByRecruitIdAndProgramId.infinite', variables],
      (metaData) => fetcher<ProgramAssociateByRecruitIdAndProgramIdQuery, ProgramAssociateByRecruitIdAndProgramIdQueryVariables>(ProgramAssociateByRecruitIdAndProgramIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramAssociateByRecruitIdAndProgramIdQuery.getKey = (variables: ProgramAssociateByRecruitIdAndProgramIdQueryVariables) => ['ProgramAssociateByRecruitIdAndProgramId.infinite', variables];
;

useProgramAssociateByRecruitIdAndProgramIdQuery.fetcher = (variables: ProgramAssociateByRecruitIdAndProgramIdQueryVariables) => fetcher<ProgramAssociateByRecruitIdAndProgramIdQuery, ProgramAssociateByRecruitIdAndProgramIdQueryVariables>(ProgramAssociateByRecruitIdAndProgramIdDocument, variables);
export const ProgramDetailsDocument = `
    query ProgramDetails($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    ...ProgramDetails
  }
}
    ${ProgramDetailsFragmentDoc}`;
export const useProgramDetailsQuery = <
      TData = ProgramDetailsQuery,
      TError = unknown
    >(
      variables: ProgramDetailsQueryVariables,
      options?: UseQueryOptions<ProgramDetailsQuery, TError, TData>
    ) =>
    useQuery<ProgramDetailsQuery, TError, TData>(
      ['ProgramDetails', variables],
      fetcher<ProgramDetailsQuery, ProgramDetailsQueryVariables>(ProgramDetailsDocument, variables),
      options
    );

useProgramDetailsQuery.getKey = (variables: ProgramDetailsQueryVariables) => ['ProgramDetails', variables];
;

export const useInfiniteProgramDetailsQuery = <
      TData = ProgramDetailsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramDetailsQueryVariables,
      variables: ProgramDetailsQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramDetailsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramDetailsQuery, TError, TData>(
      ['ProgramDetails.infinite', variables],
      (metaData) => fetcher<ProgramDetailsQuery, ProgramDetailsQueryVariables>(ProgramDetailsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramDetailsQuery.getKey = (variables: ProgramDetailsQueryVariables) => ['ProgramDetails.infinite', variables];
;

useProgramDetailsQuery.fetcher = (variables: ProgramDetailsQueryVariables) => fetcher<ProgramDetailsQuery, ProgramDetailsQueryVariables>(ProgramDetailsDocument, variables);
export const WorkAllocationProgramContributorsDocument = `
    query WorkAllocationProgramContributors($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    contributors {
      ...ProgramContributor
    }
  }
}
    ${ProgramContributorFragmentDoc}`;
export const useWorkAllocationProgramContributorsQuery = <
      TData = WorkAllocationProgramContributorsQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramContributorsQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramContributorsQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramContributorsQuery, TError, TData>(
      ['WorkAllocationProgramContributors', variables],
      fetcher<WorkAllocationProgramContributorsQuery, WorkAllocationProgramContributorsQueryVariables>(WorkAllocationProgramContributorsDocument, variables),
      options
    );

useWorkAllocationProgramContributorsQuery.getKey = (variables: WorkAllocationProgramContributorsQueryVariables) => ['WorkAllocationProgramContributors', variables];
;

export const useInfiniteWorkAllocationProgramContributorsQuery = <
      TData = WorkAllocationProgramContributorsQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramContributorsQueryVariables,
      variables: WorkAllocationProgramContributorsQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramContributorsQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramContributorsQuery, TError, TData>(
      ['WorkAllocationProgramContributors.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramContributorsQuery, WorkAllocationProgramContributorsQueryVariables>(WorkAllocationProgramContributorsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramContributorsQuery.getKey = (variables: WorkAllocationProgramContributorsQueryVariables) => ['WorkAllocationProgramContributors.infinite', variables];
;

useWorkAllocationProgramContributorsQuery.fetcher = (variables: WorkAllocationProgramContributorsQueryVariables) => fetcher<WorkAllocationProgramContributorsQuery, WorkAllocationProgramContributorsQueryVariables>(WorkAllocationProgramContributorsDocument, variables);
export const ProgramPermissionsDocument = `
    query ProgramPermissions($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    ...ProgramPermissions
  }
}
    ${ProgramPermissionsFragmentDoc}`;
export const useProgramPermissionsQuery = <
      TData = ProgramPermissionsQuery,
      TError = unknown
    >(
      variables: ProgramPermissionsQueryVariables,
      options?: UseQueryOptions<ProgramPermissionsQuery, TError, TData>
    ) =>
    useQuery<ProgramPermissionsQuery, TError, TData>(
      ['ProgramPermissions', variables],
      fetcher<ProgramPermissionsQuery, ProgramPermissionsQueryVariables>(ProgramPermissionsDocument, variables),
      options
    );

useProgramPermissionsQuery.getKey = (variables: ProgramPermissionsQueryVariables) => ['ProgramPermissions', variables];
;

export const useInfiniteProgramPermissionsQuery = <
      TData = ProgramPermissionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramPermissionsQueryVariables,
      variables: ProgramPermissionsQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramPermissionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramPermissionsQuery, TError, TData>(
      ['ProgramPermissions.infinite', variables],
      (metaData) => fetcher<ProgramPermissionsQuery, ProgramPermissionsQueryVariables>(ProgramPermissionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramPermissionsQuery.getKey = (variables: ProgramPermissionsQueryVariables) => ['ProgramPermissions.infinite', variables];
;

useProgramPermissionsQuery.fetcher = (variables: ProgramPermissionsQueryVariables) => fetcher<ProgramPermissionsQuery, ProgramPermissionsQueryVariables>(ProgramPermissionsDocument, variables);
export const ProgramEmailAlertsDocument = `
    query ProgramEmailAlerts($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    ...ProgramEmailAlerts
  }
}
    ${ProgramEmailAlertsFragmentDoc}`;
export const useProgramEmailAlertsQuery = <
      TData = ProgramEmailAlertsQuery,
      TError = unknown
    >(
      variables: ProgramEmailAlertsQueryVariables,
      options?: UseQueryOptions<ProgramEmailAlertsQuery, TError, TData>
    ) =>
    useQuery<ProgramEmailAlertsQuery, TError, TData>(
      ['ProgramEmailAlerts', variables],
      fetcher<ProgramEmailAlertsQuery, ProgramEmailAlertsQueryVariables>(ProgramEmailAlertsDocument, variables),
      options
    );

useProgramEmailAlertsQuery.getKey = (variables: ProgramEmailAlertsQueryVariables) => ['ProgramEmailAlerts', variables];
;

export const useInfiniteProgramEmailAlertsQuery = <
      TData = ProgramEmailAlertsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramEmailAlertsQueryVariables,
      variables: ProgramEmailAlertsQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramEmailAlertsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramEmailAlertsQuery, TError, TData>(
      ['ProgramEmailAlerts.infinite', variables],
      (metaData) => fetcher<ProgramEmailAlertsQuery, ProgramEmailAlertsQueryVariables>(ProgramEmailAlertsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramEmailAlertsQuery.getKey = (variables: ProgramEmailAlertsQueryVariables) => ['ProgramEmailAlerts.infinite', variables];
;

useProgramEmailAlertsQuery.fetcher = (variables: ProgramEmailAlertsQueryVariables) => fetcher<ProgramEmailAlertsQuery, ProgramEmailAlertsQueryVariables>(ProgramEmailAlertsDocument, variables);
export const CreateWorkAllocationAssociateDocument = `
    mutation CreateWorkAllocationAssociate($associate: CandidateInput) {
  createWorkAllocationAssociate(associate: $associate)
}
    `;
export const useCreateWorkAllocationAssociateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateWorkAllocationAssociateMutation, TError, CreateWorkAllocationAssociateMutationVariables, TContext>) =>
    useMutation<CreateWorkAllocationAssociateMutation, TError, CreateWorkAllocationAssociateMutationVariables, TContext>(
      ['CreateWorkAllocationAssociate'],
      (variables?: CreateWorkAllocationAssociateMutationVariables) => fetcher<CreateWorkAllocationAssociateMutation, CreateWorkAllocationAssociateMutationVariables>(CreateWorkAllocationAssociateDocument, variables)(),
      options
    );
useCreateWorkAllocationAssociateMutation.fetcher = (variables?: CreateWorkAllocationAssociateMutationVariables) => fetcher<CreateWorkAllocationAssociateMutation, CreateWorkAllocationAssociateMutationVariables>(CreateWorkAllocationAssociateDocument, variables);
export const SelfAssignToMatterDocument = `
    mutation SelfAssignToMatter($matterId: ID!, $programId: ID!) {
  selfAssignToMatter(matterId: $matterId, programId: $programId)
}
    `;
export const useSelfAssignToMatterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SelfAssignToMatterMutation, TError, SelfAssignToMatterMutationVariables, TContext>) =>
    useMutation<SelfAssignToMatterMutation, TError, SelfAssignToMatterMutationVariables, TContext>(
      ['SelfAssignToMatter'],
      (variables?: SelfAssignToMatterMutationVariables) => fetcher<SelfAssignToMatterMutation, SelfAssignToMatterMutationVariables>(SelfAssignToMatterDocument, variables)(),
      options
    );
useSelfAssignToMatterMutation.fetcher = (variables: SelfAssignToMatterMutationVariables) => fetcher<SelfAssignToMatterMutation, SelfAssignToMatterMutationVariables>(SelfAssignToMatterDocument, variables);
export const AddAssociatesToWorkAllocationMatterDocument = `
    mutation AddAssociatesToWorkAllocationMatter($matterId: ID!, $associateIds: [ID!]!) {
  addAssociatesToWorkAllocationMatter(
    matterId: $matterId
    associateIds: $associateIds
  )
}
    `;
export const useAddAssociatesToWorkAllocationMatterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddAssociatesToWorkAllocationMatterMutation, TError, AddAssociatesToWorkAllocationMatterMutationVariables, TContext>) =>
    useMutation<AddAssociatesToWorkAllocationMatterMutation, TError, AddAssociatesToWorkAllocationMatterMutationVariables, TContext>(
      ['AddAssociatesToWorkAllocationMatter'],
      (variables?: AddAssociatesToWorkAllocationMatterMutationVariables) => fetcher<AddAssociatesToWorkAllocationMatterMutation, AddAssociatesToWorkAllocationMatterMutationVariables>(AddAssociatesToWorkAllocationMatterDocument, variables)(),
      options
    );
useAddAssociatesToWorkAllocationMatterMutation.fetcher = (variables: AddAssociatesToWorkAllocationMatterMutationVariables) => fetcher<AddAssociatesToWorkAllocationMatterMutation, AddAssociatesToWorkAllocationMatterMutationVariables>(AddAssociatesToWorkAllocationMatterDocument, variables);
export const AddAssociatesToWorkAllocationProgramDocument = `
    mutation addAssociatesToWorkAllocationProgram($programId: ID!, $associateIds: [ID!]!) {
  addAssociatesToWorkAllocationProgram(
    programId: $programId
    associateIds: $associateIds
  )
}
    `;
export const useAddAssociatesToWorkAllocationProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddAssociatesToWorkAllocationProgramMutation, TError, AddAssociatesToWorkAllocationProgramMutationVariables, TContext>) =>
    useMutation<AddAssociatesToWorkAllocationProgramMutation, TError, AddAssociatesToWorkAllocationProgramMutationVariables, TContext>(
      ['addAssociatesToWorkAllocationProgram'],
      (variables?: AddAssociatesToWorkAllocationProgramMutationVariables) => fetcher<AddAssociatesToWorkAllocationProgramMutation, AddAssociatesToWorkAllocationProgramMutationVariables>(AddAssociatesToWorkAllocationProgramDocument, variables)(),
      options
    );
useAddAssociatesToWorkAllocationProgramMutation.fetcher = (variables: AddAssociatesToWorkAllocationProgramMutationVariables) => fetcher<AddAssociatesToWorkAllocationProgramMutation, AddAssociatesToWorkAllocationProgramMutationVariables>(AddAssociatesToWorkAllocationProgramDocument, variables);
export const UpsertWorkAllocationProgramMatterByAssociateDocument = `
    mutation UpsertWorkAllocationProgramMatterByAssociate($programId: ID!, $input: UpsertWorkAllocationProgramMatterInput!) {
  upsertWorkAllocationProgramMatterByAssociate(
    programId: $programId
    input: $input
  )
}
    `;
export const useUpsertWorkAllocationProgramMatterByAssociateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationProgramMatterByAssociateMutation, TError, UpsertWorkAllocationProgramMatterByAssociateMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationProgramMatterByAssociateMutation, TError, UpsertWorkAllocationProgramMatterByAssociateMutationVariables, TContext>(
      ['UpsertWorkAllocationProgramMatterByAssociate'],
      (variables?: UpsertWorkAllocationProgramMatterByAssociateMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterByAssociateMutation, UpsertWorkAllocationProgramMatterByAssociateMutationVariables>(UpsertWorkAllocationProgramMatterByAssociateDocument, variables)(),
      options
    );
useUpsertWorkAllocationProgramMatterByAssociateMutation.fetcher = (variables: UpsertWorkAllocationProgramMatterByAssociateMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterByAssociateMutation, UpsertWorkAllocationProgramMatterByAssociateMutationVariables>(UpsertWorkAllocationProgramMatterByAssociateDocument, variables);
export const UpdateMatterWorkStatusByAssociateDocument = `
    mutation updateMatterWorkStatusByAssociate($matterId: ID!, $status: MatterStatus!) {
  updateMatterWorkStatusByAssociate(matterId: $matterId, status: $status)
}
    `;
export const useUpdateMatterWorkStatusByAssociateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMatterWorkStatusByAssociateMutation, TError, UpdateMatterWorkStatusByAssociateMutationVariables, TContext>) =>
    useMutation<UpdateMatterWorkStatusByAssociateMutation, TError, UpdateMatterWorkStatusByAssociateMutationVariables, TContext>(
      ['updateMatterWorkStatusByAssociate'],
      (variables?: UpdateMatterWorkStatusByAssociateMutationVariables) => fetcher<UpdateMatterWorkStatusByAssociateMutation, UpdateMatterWorkStatusByAssociateMutationVariables>(UpdateMatterWorkStatusByAssociateDocument, variables)(),
      options
    );
useUpdateMatterWorkStatusByAssociateMutation.fetcher = (variables: UpdateMatterWorkStatusByAssociateMutationVariables) => fetcher<UpdateMatterWorkStatusByAssociateMutation, UpdateMatterWorkStatusByAssociateMutationVariables>(UpdateMatterWorkStatusByAssociateDocument, variables);
export const DeleteMatterByAssociateDocument = `
    mutation DeleteMatterByAssociate($matterId: ID!) {
  deleteMatter(matterId: $matterId)
}
    `;
export const useDeleteMatterByAssociateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMatterByAssociateMutation, TError, DeleteMatterByAssociateMutationVariables, TContext>) =>
    useMutation<DeleteMatterByAssociateMutation, TError, DeleteMatterByAssociateMutationVariables, TContext>(
      ['DeleteMatterByAssociate'],
      (variables?: DeleteMatterByAssociateMutationVariables) => fetcher<DeleteMatterByAssociateMutation, DeleteMatterByAssociateMutationVariables>(DeleteMatterByAssociateDocument, variables)(),
      options
    );
useDeleteMatterByAssociateMutation.fetcher = (variables: DeleteMatterByAssociateMutationVariables) => fetcher<DeleteMatterByAssociateMutation, DeleteMatterByAssociateMutationVariables>(DeleteMatterByAssociateDocument, variables);
export const WorkAllocationOrgAssociatesDocument = `
    query WorkAllocationOrgAssociates {
  workAllocationOrgAssociates {
    id
    firstName
    lastName
    email
  }
}
    `;
export const useWorkAllocationOrgAssociatesQuery = <
      TData = WorkAllocationOrgAssociatesQuery,
      TError = unknown
    >(
      variables?: WorkAllocationOrgAssociatesQueryVariables,
      options?: UseQueryOptions<WorkAllocationOrgAssociatesQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationOrgAssociatesQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationOrgAssociates'] : ['WorkAllocationOrgAssociates', variables],
      fetcher<WorkAllocationOrgAssociatesQuery, WorkAllocationOrgAssociatesQueryVariables>(WorkAllocationOrgAssociatesDocument, variables),
      options
    );

useWorkAllocationOrgAssociatesQuery.getKey = (variables?: WorkAllocationOrgAssociatesQueryVariables) => variables === undefined ? ['WorkAllocationOrgAssociates'] : ['WorkAllocationOrgAssociates', variables];
;

export const useInfiniteWorkAllocationOrgAssociatesQuery = <
      TData = WorkAllocationOrgAssociatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationOrgAssociatesQueryVariables,
      variables?: WorkAllocationOrgAssociatesQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationOrgAssociatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationOrgAssociatesQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationOrgAssociates.infinite'] : ['WorkAllocationOrgAssociates.infinite', variables],
      (metaData) => fetcher<WorkAllocationOrgAssociatesQuery, WorkAllocationOrgAssociatesQueryVariables>(WorkAllocationOrgAssociatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationOrgAssociatesQuery.getKey = (variables?: WorkAllocationOrgAssociatesQueryVariables) => variables === undefined ? ['WorkAllocationOrgAssociates.infinite'] : ['WorkAllocationOrgAssociates.infinite', variables];
;

useWorkAllocationOrgAssociatesQuery.fetcher = (variables?: WorkAllocationOrgAssociatesQueryVariables) => fetcher<WorkAllocationOrgAssociatesQuery, WorkAllocationOrgAssociatesQueryVariables>(WorkAllocationOrgAssociatesDocument, variables);
export const WorkAllocationProgramAssociatesDocument = `
    query WorkAllocationProgramAssociates($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    programAssociates {
      firstName
      lastName
      id
      email
      authzReasons
    }
    groups {
      name
      associates {
        id
      }
    }
  }
}
    `;
export const useWorkAllocationProgramAssociatesQuery = <
      TData = WorkAllocationProgramAssociatesQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramAssociatesQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramAssociatesQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramAssociatesQuery, TError, TData>(
      ['WorkAllocationProgramAssociates', variables],
      fetcher<WorkAllocationProgramAssociatesQuery, WorkAllocationProgramAssociatesQueryVariables>(WorkAllocationProgramAssociatesDocument, variables),
      options
    );

useWorkAllocationProgramAssociatesQuery.getKey = (variables: WorkAllocationProgramAssociatesQueryVariables) => ['WorkAllocationProgramAssociates', variables];
;

export const useInfiniteWorkAllocationProgramAssociatesQuery = <
      TData = WorkAllocationProgramAssociatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramAssociatesQueryVariables,
      variables: WorkAllocationProgramAssociatesQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramAssociatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramAssociatesQuery, TError, TData>(
      ['WorkAllocationProgramAssociates.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramAssociatesQuery, WorkAllocationProgramAssociatesQueryVariables>(WorkAllocationProgramAssociatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramAssociatesQuery.getKey = (variables: WorkAllocationProgramAssociatesQueryVariables) => ['WorkAllocationProgramAssociates.infinite', variables];
;

useWorkAllocationProgramAssociatesQuery.fetcher = (variables: WorkAllocationProgramAssociatesQueryVariables) => fetcher<WorkAllocationProgramAssociatesQuery, WorkAllocationProgramAssociatesQueryVariables>(WorkAllocationProgramAssociatesDocument, variables);
export const ProgramAssociatesForSummerAssociateTableDocument = `
    query ProgramAssociatesForSummerAssociateTable($programId: ID!) {
  programAssociatesByProgramId(programId: $programId) {
    recruitIdForAssociateWorkEmail
    startDate
    endDate
  }
}
    `;
export const useProgramAssociatesForSummerAssociateTableQuery = <
      TData = ProgramAssociatesForSummerAssociateTableQuery,
      TError = unknown
    >(
      variables: ProgramAssociatesForSummerAssociateTableQueryVariables,
      options?: UseQueryOptions<ProgramAssociatesForSummerAssociateTableQuery, TError, TData>
    ) =>
    useQuery<ProgramAssociatesForSummerAssociateTableQuery, TError, TData>(
      ['ProgramAssociatesForSummerAssociateTable', variables],
      fetcher<ProgramAssociatesForSummerAssociateTableQuery, ProgramAssociatesForSummerAssociateTableQueryVariables>(ProgramAssociatesForSummerAssociateTableDocument, variables),
      options
    );

useProgramAssociatesForSummerAssociateTableQuery.getKey = (variables: ProgramAssociatesForSummerAssociateTableQueryVariables) => ['ProgramAssociatesForSummerAssociateTable', variables];
;

export const useInfiniteProgramAssociatesForSummerAssociateTableQuery = <
      TData = ProgramAssociatesForSummerAssociateTableQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramAssociatesForSummerAssociateTableQueryVariables,
      variables: ProgramAssociatesForSummerAssociateTableQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramAssociatesForSummerAssociateTableQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramAssociatesForSummerAssociateTableQuery, TError, TData>(
      ['ProgramAssociatesForSummerAssociateTable.infinite', variables],
      (metaData) => fetcher<ProgramAssociatesForSummerAssociateTableQuery, ProgramAssociatesForSummerAssociateTableQueryVariables>(ProgramAssociatesForSummerAssociateTableDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramAssociatesForSummerAssociateTableQuery.getKey = (variables: ProgramAssociatesForSummerAssociateTableQueryVariables) => ['ProgramAssociatesForSummerAssociateTable.infinite', variables];
;

useProgramAssociatesForSummerAssociateTableQuery.fetcher = (variables: ProgramAssociatesForSummerAssociateTableQueryVariables) => fetcher<ProgramAssociatesForSummerAssociateTableQuery, ProgramAssociatesForSummerAssociateTableQueryVariables>(ProgramAssociatesForSummerAssociateTableDocument, variables);
export const WorkAllocationUnassignedMattersForProgramDocument = `
    query WorkAllocationUnassignedMattersForProgram($programId: ID!) {
  unassignedWorkAllocationMattersForAssociate(programId: $programId) {
    createdBy
    assignees {
      id
      firstName
      lastName
      email
    }
    assignmentType
    attorneys {
      id
      firstName
      lastName
      email
    }
    clientMatterName
    clientMatterNumber
    clientNumber
    deadline
    timezone
    description
    id
    offices {
      id
      name
    }
    org
    practiceAreas {
      id
      name
    }
    orgPracticeAreas {
      id
      firmSpecificName
    }
    timeToComplete {
      unit
      value
    }
    workStatus
    workStatusUpdatedAt
    documents {
      id
      userFileName
      documentFileName
      createdAt
      createdBy
      updatedBy
      updatedAt
    }
    createdAt
  }
}
    `;
export const useWorkAllocationUnassignedMattersForProgramQuery = <
      TData = WorkAllocationUnassignedMattersForProgramQuery,
      TError = unknown
    >(
      variables: WorkAllocationUnassignedMattersForProgramQueryVariables,
      options?: UseQueryOptions<WorkAllocationUnassignedMattersForProgramQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationUnassignedMattersForProgramQuery, TError, TData>(
      ['WorkAllocationUnassignedMattersForProgram', variables],
      fetcher<WorkAllocationUnassignedMattersForProgramQuery, WorkAllocationUnassignedMattersForProgramQueryVariables>(WorkAllocationUnassignedMattersForProgramDocument, variables),
      options
    );

useWorkAllocationUnassignedMattersForProgramQuery.getKey = (variables: WorkAllocationUnassignedMattersForProgramQueryVariables) => ['WorkAllocationUnassignedMattersForProgram', variables];
;

export const useInfiniteWorkAllocationUnassignedMattersForProgramQuery = <
      TData = WorkAllocationUnassignedMattersForProgramQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationUnassignedMattersForProgramQueryVariables,
      variables: WorkAllocationUnassignedMattersForProgramQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationUnassignedMattersForProgramQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationUnassignedMattersForProgramQuery, TError, TData>(
      ['WorkAllocationUnassignedMattersForProgram.infinite', variables],
      (metaData) => fetcher<WorkAllocationUnassignedMattersForProgramQuery, WorkAllocationUnassignedMattersForProgramQueryVariables>(WorkAllocationUnassignedMattersForProgramDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationUnassignedMattersForProgramQuery.getKey = (variables: WorkAllocationUnassignedMattersForProgramQueryVariables) => ['WorkAllocationUnassignedMattersForProgram.infinite', variables];
;

useWorkAllocationUnassignedMattersForProgramQuery.fetcher = (variables: WorkAllocationUnassignedMattersForProgramQueryVariables) => fetcher<WorkAllocationUnassignedMattersForProgramQuery, WorkAllocationUnassignedMattersForProgramQueryVariables>(WorkAllocationUnassignedMattersForProgramDocument, variables);
export const WorkAllocationMattersForAssociateDocument = `
    query workAllocationMattersForAssociate($programId: ID!) {
  workAllocationMattersForAssociate(programId: $programId) {
    createdBy
    assignees {
      id
      firstName
      lastName
      email
    }
    assignmentType
    attorneys {
      id
      firstName
      lastName
      email
    }
    clientMatterName
    clientMatterNumber
    clientNumber
    deadline
    timezone
    description
    id
    offices {
      id
      name
    }
    org
    practiceAreas {
      id
      name
    }
    orgPracticeAreas {
      id
      firmSpecificName
    }
    timeToComplete {
      unit
      value
    }
    workStatus
    workStatusUpdatedAt
    documents {
      id
      userFileName
      documentFileName
      createdAt
      createdBy
      updatedBy
      updatedAt
    }
    createdAt
  }
}
    `;
export const useWorkAllocationMattersForAssociateQuery = <
      TData = WorkAllocationMattersForAssociateQuery,
      TError = unknown
    >(
      variables: WorkAllocationMattersForAssociateQueryVariables,
      options?: UseQueryOptions<WorkAllocationMattersForAssociateQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationMattersForAssociateQuery, TError, TData>(
      ['workAllocationMattersForAssociate', variables],
      fetcher<WorkAllocationMattersForAssociateQuery, WorkAllocationMattersForAssociateQueryVariables>(WorkAllocationMattersForAssociateDocument, variables),
      options
    );

useWorkAllocationMattersForAssociateQuery.getKey = (variables: WorkAllocationMattersForAssociateQueryVariables) => ['workAllocationMattersForAssociate', variables];
;

export const useInfiniteWorkAllocationMattersForAssociateQuery = <
      TData = WorkAllocationMattersForAssociateQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationMattersForAssociateQueryVariables,
      variables: WorkAllocationMattersForAssociateQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationMattersForAssociateQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationMattersForAssociateQuery, TError, TData>(
      ['workAllocationMattersForAssociate.infinite', variables],
      (metaData) => fetcher<WorkAllocationMattersForAssociateQuery, WorkAllocationMattersForAssociateQueryVariables>(WorkAllocationMattersForAssociateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationMattersForAssociateQuery.getKey = (variables: WorkAllocationMattersForAssociateQueryVariables) => ['workAllocationMattersForAssociate.infinite', variables];
;

useWorkAllocationMattersForAssociateQuery.fetcher = (variables: WorkAllocationMattersForAssociateQueryVariables) => fetcher<WorkAllocationMattersForAssociateQuery, WorkAllocationMattersForAssociateQueryVariables>(WorkAllocationMattersForAssociateDocument, variables);
export const AssignedWorkAllocationMattersForAssociateDocument = `
    query assignedWorkAllocationMattersForAssociate($programId: ID!) {
  assignedWorkAllocationMattersForAssociate(programId: $programId) {
    createdBy
    assignees {
      id
      firstName
      lastName
      email
    }
    assignmentType
    attorneys {
      id
      firstName
      lastName
      email
    }
    clientMatterName
    clientMatterNumber
    clientNumber
    deadline
    timezone
    description
    id
    offices {
      id
      name
    }
    org
    practiceAreas {
      id
      name
    }
    orgPracticeAreas {
      id
      firmSpecificName
    }
    timeToComplete {
      unit
      value
    }
    workStatus
    workStatusUpdatedAt
    documents {
      id
      userFileName
      documentFileName
      createdAt
      createdBy
      updatedBy
      updatedAt
    }
    createdAt
  }
}
    `;
export const useAssignedWorkAllocationMattersForAssociateQuery = <
      TData = AssignedWorkAllocationMattersForAssociateQuery,
      TError = unknown
    >(
      variables: AssignedWorkAllocationMattersForAssociateQueryVariables,
      options?: UseQueryOptions<AssignedWorkAllocationMattersForAssociateQuery, TError, TData>
    ) =>
    useQuery<AssignedWorkAllocationMattersForAssociateQuery, TError, TData>(
      ['assignedWorkAllocationMattersForAssociate', variables],
      fetcher<AssignedWorkAllocationMattersForAssociateQuery, AssignedWorkAllocationMattersForAssociateQueryVariables>(AssignedWorkAllocationMattersForAssociateDocument, variables),
      options
    );

useAssignedWorkAllocationMattersForAssociateQuery.getKey = (variables: AssignedWorkAllocationMattersForAssociateQueryVariables) => ['assignedWorkAllocationMattersForAssociate', variables];
;

export const useInfiniteAssignedWorkAllocationMattersForAssociateQuery = <
      TData = AssignedWorkAllocationMattersForAssociateQuery,
      TError = unknown
    >(
      pageParamKey: keyof AssignedWorkAllocationMattersForAssociateQueryVariables,
      variables: AssignedWorkAllocationMattersForAssociateQueryVariables,
      options?: UseInfiniteQueryOptions<AssignedWorkAllocationMattersForAssociateQuery, TError, TData>
    ) =>
    useInfiniteQuery<AssignedWorkAllocationMattersForAssociateQuery, TError, TData>(
      ['assignedWorkAllocationMattersForAssociate.infinite', variables],
      (metaData) => fetcher<AssignedWorkAllocationMattersForAssociateQuery, AssignedWorkAllocationMattersForAssociateQueryVariables>(AssignedWorkAllocationMattersForAssociateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteAssignedWorkAllocationMattersForAssociateQuery.getKey = (variables: AssignedWorkAllocationMattersForAssociateQueryVariables) => ['assignedWorkAllocationMattersForAssociate.infinite', variables];
;

useAssignedWorkAllocationMattersForAssociateQuery.fetcher = (variables: AssignedWorkAllocationMattersForAssociateQueryVariables) => fetcher<AssignedWorkAllocationMattersForAssociateQuery, AssignedWorkAllocationMattersForAssociateQueryVariables>(AssignedWorkAllocationMattersForAssociateDocument, variables);
export const WorkAllocationMatterForAssociateDocument = `
    query WorkAllocationMatterForAssociate($matterId: ID!) {
  workAllocationMatterForAssociate(matterId: $matterId) {
    createdBy
    assignees {
      id
      firstName
      lastName
      email
    }
    assignmentType
    attorneys {
      id
      firstName
      lastName
      email
    }
    clientMatterName
    clientMatterNumber
    clientNumber
    deadline
    timezone
    description
    id
    offices {
      id
      name
    }
    org
    practiceAreas {
      id
      name
    }
    orgPracticeAreas {
      id
      firmSpecificName
    }
    timeToComplete {
      unit
      value
    }
    workStatus
    workStatusUpdatedAt
    documents {
      id
      userFileName
      documentFileName
      createdAt
      createdBy
      updatedBy
      updatedAt
    }
    createdAt
  }
}
    `;
export const useWorkAllocationMatterForAssociateQuery = <
      TData = WorkAllocationMatterForAssociateQuery,
      TError = unknown
    >(
      variables: WorkAllocationMatterForAssociateQueryVariables,
      options?: UseQueryOptions<WorkAllocationMatterForAssociateQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationMatterForAssociateQuery, TError, TData>(
      ['WorkAllocationMatterForAssociate', variables],
      fetcher<WorkAllocationMatterForAssociateQuery, WorkAllocationMatterForAssociateQueryVariables>(WorkAllocationMatterForAssociateDocument, variables),
      options
    );

useWorkAllocationMatterForAssociateQuery.getKey = (variables: WorkAllocationMatterForAssociateQueryVariables) => ['WorkAllocationMatterForAssociate', variables];
;

export const useInfiniteWorkAllocationMatterForAssociateQuery = <
      TData = WorkAllocationMatterForAssociateQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationMatterForAssociateQueryVariables,
      variables: WorkAllocationMatterForAssociateQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationMatterForAssociateQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationMatterForAssociateQuery, TError, TData>(
      ['WorkAllocationMatterForAssociate.infinite', variables],
      (metaData) => fetcher<WorkAllocationMatterForAssociateQuery, WorkAllocationMatterForAssociateQueryVariables>(WorkAllocationMatterForAssociateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationMatterForAssociateQuery.getKey = (variables: WorkAllocationMatterForAssociateQueryVariables) => ['WorkAllocationMatterForAssociate.infinite', variables];
;

useWorkAllocationMatterForAssociateQuery.fetcher = (variables: WorkAllocationMatterForAssociateQueryVariables) => fetcher<WorkAllocationMatterForAssociateQuery, WorkAllocationMatterForAssociateQueryVariables>(WorkAllocationMatterForAssociateDocument, variables);
export const WorkAllocationProgramForAssociateDocument = `
    query WorkAllocationProgramForAssociate($programId: ID!, $associateRecruitId: ID!) {
  workAllocationProgramForAssociate(programId: $programId) {
    title
    createdAt
    description
    endDate
    startDate
    id
    attorneyFeedbackReminderEmailEnabled
    allowSummerAssociatesToCreateEditProjects
    allowSummerAssociatesToDeleteProjects
    allowSummerAssociatesToSelfAssignProjects
    emailAdminWhenAttorneyCreatesProject
    emailAdminWhenSummerAssociateCreatesProject
    emailAdminWhenSummerAssociateIsAssignedToProject
    emailAssignedAttorneysWhenDocumentsAreUploadedToProject
    emailSummerAssociateWhenAssignedToProject
    ownerUser {
      id
      admin
      fname
      lname
      email
    }
    customEvaluations {
      id
      evaluationName
      evaluationType
      questions {
        id
        orgFeedbackId
        isRequired
        evaluationQuestion {
          id
          label
          subtext
          type
          evaluationType
          lowScale
          highScale
          lowLabel
          highLabel
          commentsEnabled
          selectOptions
        }
      }
      responsesForAssociate(associateRecruitId: $associateRecruitId) {
        id
        answers {
          id
          orgFeedbackId
          ratingAnswer
          yesNoAnswer
          singleSelectAnswer
          multiSelectAnswers
          freeText
          comment
        }
      }
    }
  }
}
    `;
export const useWorkAllocationProgramForAssociateQuery = <
      TData = WorkAllocationProgramForAssociateQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramForAssociateQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramForAssociateQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramForAssociateQuery, TError, TData>(
      ['WorkAllocationProgramForAssociate', variables],
      fetcher<WorkAllocationProgramForAssociateQuery, WorkAllocationProgramForAssociateQueryVariables>(WorkAllocationProgramForAssociateDocument, variables),
      options
    );

useWorkAllocationProgramForAssociateQuery.getKey = (variables: WorkAllocationProgramForAssociateQueryVariables) => ['WorkAllocationProgramForAssociate', variables];
;

export const useInfiniteWorkAllocationProgramForAssociateQuery = <
      TData = WorkAllocationProgramForAssociateQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramForAssociateQueryVariables,
      variables: WorkAllocationProgramForAssociateQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramForAssociateQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramForAssociateQuery, TError, TData>(
      ['WorkAllocationProgramForAssociate.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramForAssociateQuery, WorkAllocationProgramForAssociateQueryVariables>(WorkAllocationProgramForAssociateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramForAssociateQuery.getKey = (variables: WorkAllocationProgramForAssociateQueryVariables) => ['WorkAllocationProgramForAssociate.infinite', variables];
;

useWorkAllocationProgramForAssociateQuery.fetcher = (variables: WorkAllocationProgramForAssociateQueryVariables) => fetcher<WorkAllocationProgramForAssociateQuery, WorkAllocationProgramForAssociateQueryVariables>(WorkAllocationProgramForAssociateDocument, variables);
export const SubmitProgramEvaluationResponseForAssociateDocument = `
    mutation SubmitProgramEvaluationResponseForAssociate($programId: ID!, $customProgramEvaluationId: ID!, $associateRecruitId: ID!, $attorneyUserId: ID, $answers: [ProgramEvaluationAnswerInput!]!) {
  upsertIndividualProgramEvaluationResponse(
    programId: $programId
    customProgramEvaluationId: $customProgramEvaluationId
    associateRecruitId: $associateRecruitId
    attorneyUserId: $attorneyUserId
    answers: $answers
  )
}
    `;
export const useSubmitProgramEvaluationResponseForAssociateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitProgramEvaluationResponseForAssociateMutation, TError, SubmitProgramEvaluationResponseForAssociateMutationVariables, TContext>) =>
    useMutation<SubmitProgramEvaluationResponseForAssociateMutation, TError, SubmitProgramEvaluationResponseForAssociateMutationVariables, TContext>(
      ['SubmitProgramEvaluationResponseForAssociate'],
      (variables?: SubmitProgramEvaluationResponseForAssociateMutationVariables) => fetcher<SubmitProgramEvaluationResponseForAssociateMutation, SubmitProgramEvaluationResponseForAssociateMutationVariables>(SubmitProgramEvaluationResponseForAssociateDocument, variables)(),
      options
    );
useSubmitProgramEvaluationResponseForAssociateMutation.fetcher = (variables: SubmitProgramEvaluationResponseForAssociateMutationVariables) => fetcher<SubmitProgramEvaluationResponseForAssociateMutation, SubmitProgramEvaluationResponseForAssociateMutationVariables>(SubmitProgramEvaluationResponseForAssociateDocument, variables);
export const ProgramAssociateExistsByEmployeeEmailDocument = `
    query ProgramAssociateExistsByEmployeeEmail($email: String!) {
  programAssociateByEmployeeEmail(email: $email) {
    email
  }
}
    `;
export const useProgramAssociateExistsByEmployeeEmailQuery = <
      TData = ProgramAssociateExistsByEmployeeEmailQuery,
      TError = unknown
    >(
      variables: ProgramAssociateExistsByEmployeeEmailQueryVariables,
      options?: UseQueryOptions<ProgramAssociateExistsByEmployeeEmailQuery, TError, TData>
    ) =>
    useQuery<ProgramAssociateExistsByEmployeeEmailQuery, TError, TData>(
      ['ProgramAssociateExistsByEmployeeEmail', variables],
      fetcher<ProgramAssociateExistsByEmployeeEmailQuery, ProgramAssociateExistsByEmployeeEmailQueryVariables>(ProgramAssociateExistsByEmployeeEmailDocument, variables),
      options
    );

useProgramAssociateExistsByEmployeeEmailQuery.getKey = (variables: ProgramAssociateExistsByEmployeeEmailQueryVariables) => ['ProgramAssociateExistsByEmployeeEmail', variables];
;

export const useInfiniteProgramAssociateExistsByEmployeeEmailQuery = <
      TData = ProgramAssociateExistsByEmployeeEmailQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramAssociateExistsByEmployeeEmailQueryVariables,
      variables: ProgramAssociateExistsByEmployeeEmailQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramAssociateExistsByEmployeeEmailQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramAssociateExistsByEmployeeEmailQuery, TError, TData>(
      ['ProgramAssociateExistsByEmployeeEmail.infinite', variables],
      (metaData) => fetcher<ProgramAssociateExistsByEmployeeEmailQuery, ProgramAssociateExistsByEmployeeEmailQueryVariables>(ProgramAssociateExistsByEmployeeEmailDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramAssociateExistsByEmployeeEmailQuery.getKey = (variables: ProgramAssociateExistsByEmployeeEmailQueryVariables) => ['ProgramAssociateExistsByEmployeeEmail.infinite', variables];
;

useProgramAssociateExistsByEmployeeEmailQuery.fetcher = (variables: ProgramAssociateExistsByEmployeeEmailQueryVariables) => fetcher<ProgramAssociateExistsByEmployeeEmailQuery, ProgramAssociateExistsByEmployeeEmailQueryVariables>(ProgramAssociateExistsByEmployeeEmailDocument, variables);
export const UpdateWorkAllocationProgramContributorsAndPermissionsDocument = `
    mutation UpdateWorkAllocationProgramContributorsAndPermissions($contributorsInput: UpdateProgramContributorsInput!, $permissionsInput: UpsertWorkAllocationPermissionsInput!) {
  updateWorkAllocationProgramContributors(input: $contributorsInput) {
    contributors {
      member {
        id
        firstName
        lastName
      }
      accessLevel
    }
  }
  upsertWorkAllocationPermissions(input: $permissionsInput)
}
    `;
export const useUpdateWorkAllocationProgramContributorsAndPermissionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkAllocationProgramContributorsAndPermissionsMutation, TError, UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables, TContext>) =>
    useMutation<UpdateWorkAllocationProgramContributorsAndPermissionsMutation, TError, UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables, TContext>(
      ['UpdateWorkAllocationProgramContributorsAndPermissions'],
      (variables?: UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables) => fetcher<UpdateWorkAllocationProgramContributorsAndPermissionsMutation, UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables>(UpdateWorkAllocationProgramContributorsAndPermissionsDocument, variables)(),
      options
    );
useUpdateWorkAllocationProgramContributorsAndPermissionsMutation.fetcher = (variables: UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables) => fetcher<UpdateWorkAllocationProgramContributorsAndPermissionsMutation, UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables>(UpdateWorkAllocationProgramContributorsAndPermissionsDocument, variables);
export const UpdateWorkAllocationProgramContributorsDocument = `
    mutation UpdateWorkAllocationProgramContributors($programId: ID!, $contributors: [ProgramContributorInput!]!) {
  updateWorkAllocationProgramContributors(
    input: {programId: $programId, contributors: $contributors}
  ) {
    contributors {
      member {
        id
        firstName
        lastName
      }
      accessLevel
    }
  }
}
    `;
export const useUpdateWorkAllocationProgramContributorsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateWorkAllocationProgramContributorsMutation, TError, UpdateWorkAllocationProgramContributorsMutationVariables, TContext>) =>
    useMutation<UpdateWorkAllocationProgramContributorsMutation, TError, UpdateWorkAllocationProgramContributorsMutationVariables, TContext>(
      ['UpdateWorkAllocationProgramContributors'],
      (variables?: UpdateWorkAllocationProgramContributorsMutationVariables) => fetcher<UpdateWorkAllocationProgramContributorsMutation, UpdateWorkAllocationProgramContributorsMutationVariables>(UpdateWorkAllocationProgramContributorsDocument, variables)(),
      options
    );
useUpdateWorkAllocationProgramContributorsMutation.fetcher = (variables: UpdateWorkAllocationProgramContributorsMutationVariables) => fetcher<UpdateWorkAllocationProgramContributorsMutation, UpdateWorkAllocationProgramContributorsMutationVariables>(UpdateWorkAllocationProgramContributorsDocument, variables);
export const UpsertProgramGroupDocument = `
    mutation UpsertProgramGroup($id: ID, $programId: ID, $name: String!) {
  upsertProgramGroup(input: {id: $id, programId: $programId, name: $name}) {
    group {
      id
      name
      programId
    }
  }
}
    `;
export const useUpsertProgramGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertProgramGroupMutation, TError, UpsertProgramGroupMutationVariables, TContext>) =>
    useMutation<UpsertProgramGroupMutation, TError, UpsertProgramGroupMutationVariables, TContext>(
      ['UpsertProgramGroup'],
      (variables?: UpsertProgramGroupMutationVariables) => fetcher<UpsertProgramGroupMutation, UpsertProgramGroupMutationVariables>(UpsertProgramGroupDocument, variables)(),
      options
    );
useUpsertProgramGroupMutation.fetcher = (variables: UpsertProgramGroupMutationVariables) => fetcher<UpsertProgramGroupMutation, UpsertProgramGroupMutationVariables>(UpsertProgramGroupDocument, variables);
export const UpdateProgramGroupMembersDocument = `
    mutation UpdateProgramGroupMembers($groupId: ID!, $memberIds: [ID!]!) {
  updateProgramGroupMembers(input: {id: $groupId, memberIds: $memberIds}) {
    group {
      ...ProgramGroup
    }
  }
}
    ${ProgramGroupFragmentDoc}
${ProgramGroupContributorFragmentDoc}`;
export const useUpdateProgramGroupMembersMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProgramGroupMembersMutation, TError, UpdateProgramGroupMembersMutationVariables, TContext>) =>
    useMutation<UpdateProgramGroupMembersMutation, TError, UpdateProgramGroupMembersMutationVariables, TContext>(
      ['UpdateProgramGroupMembers'],
      (variables?: UpdateProgramGroupMembersMutationVariables) => fetcher<UpdateProgramGroupMembersMutation, UpdateProgramGroupMembersMutationVariables>(UpdateProgramGroupMembersDocument, variables)(),
      options
    );
useUpdateProgramGroupMembersMutation.fetcher = (variables: UpdateProgramGroupMembersMutationVariables) => fetcher<UpdateProgramGroupMembersMutation, UpdateProgramGroupMembersMutationVariables>(UpdateProgramGroupMembersDocument, variables);
export const UpdateProgramGroupAssociatesDocument = `
    mutation UpdateProgramGroupAssociates($groupId: ID!, $associateIds: [ID!]!) {
  updateProgramGroupAssociates(input: {id: $groupId, associateIds: $associateIds}) {
    group {
      ...ProgramGroup
    }
  }
}
    ${ProgramGroupFragmentDoc}
${ProgramGroupContributorFragmentDoc}`;
export const useUpdateProgramGroupAssociatesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProgramGroupAssociatesMutation, TError, UpdateProgramGroupAssociatesMutationVariables, TContext>) =>
    useMutation<UpdateProgramGroupAssociatesMutation, TError, UpdateProgramGroupAssociatesMutationVariables, TContext>(
      ['UpdateProgramGroupAssociates'],
      (variables?: UpdateProgramGroupAssociatesMutationVariables) => fetcher<UpdateProgramGroupAssociatesMutation, UpdateProgramGroupAssociatesMutationVariables>(UpdateProgramGroupAssociatesDocument, variables)(),
      options
    );
useUpdateProgramGroupAssociatesMutation.fetcher = (variables: UpdateProgramGroupAssociatesMutationVariables) => fetcher<UpdateProgramGroupAssociatesMutation, UpdateProgramGroupAssociatesMutationVariables>(UpdateProgramGroupAssociatesDocument, variables);
export const DeleteProgramGroupDocument = `
    mutation DeleteProgramGroup($id: ID!) {
  deleteProgramGroup(input: {id: $id}) {
    deletedGroupId
  }
}
    `;
export const useDeleteProgramGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProgramGroupMutation, TError, DeleteProgramGroupMutationVariables, TContext>) =>
    useMutation<DeleteProgramGroupMutation, TError, DeleteProgramGroupMutationVariables, TContext>(
      ['DeleteProgramGroup'],
      (variables?: DeleteProgramGroupMutationVariables) => fetcher<DeleteProgramGroupMutation, DeleteProgramGroupMutationVariables>(DeleteProgramGroupDocument, variables)(),
      options
    );
useDeleteProgramGroupMutation.fetcher = (variables: DeleteProgramGroupMutationVariables) => fetcher<DeleteProgramGroupMutation, DeleteProgramGroupMutationVariables>(DeleteProgramGroupDocument, variables);
export const ProgramGroupsDocument = `
    query ProgramGroups($programId: ID!) {
  programGroups(programId: $programId) {
    ...ProgramGroup
  }
}
    ${ProgramGroupFragmentDoc}
${ProgramGroupContributorFragmentDoc}`;
export const useProgramGroupsQuery = <
      TData = ProgramGroupsQuery,
      TError = unknown
    >(
      variables: ProgramGroupsQueryVariables,
      options?: UseQueryOptions<ProgramGroupsQuery, TError, TData>
    ) =>
    useQuery<ProgramGroupsQuery, TError, TData>(
      ['ProgramGroups', variables],
      fetcher<ProgramGroupsQuery, ProgramGroupsQueryVariables>(ProgramGroupsDocument, variables),
      options
    );

useProgramGroupsQuery.getKey = (variables: ProgramGroupsQueryVariables) => ['ProgramGroups', variables];
;

export const useInfiniteProgramGroupsQuery = <
      TData = ProgramGroupsQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramGroupsQueryVariables,
      variables: ProgramGroupsQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramGroupsQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramGroupsQuery, TError, TData>(
      ['ProgramGroups.infinite', variables],
      (metaData) => fetcher<ProgramGroupsQuery, ProgramGroupsQueryVariables>(ProgramGroupsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramGroupsQuery.getKey = (variables: ProgramGroupsQueryVariables) => ['ProgramGroups.infinite', variables];
;

useProgramGroupsQuery.fetcher = (variables: ProgramGroupsQueryVariables) => fetcher<ProgramGroupsQuery, ProgramGroupsQueryVariables>(ProgramGroupsDocument, variables);
export const ProgramGroupDocument = `
    query ProgramGroup($groupId: ID!) {
  programGroup(id: $groupId) {
    ...ProgramGroup
  }
}
    ${ProgramGroupFragmentDoc}
${ProgramGroupContributorFragmentDoc}`;
export const useProgramGroupQuery = <
      TData = ProgramGroupQuery,
      TError = unknown
    >(
      variables: ProgramGroupQueryVariables,
      options?: UseQueryOptions<ProgramGroupQuery, TError, TData>
    ) =>
    useQuery<ProgramGroupQuery, TError, TData>(
      ['ProgramGroup', variables],
      fetcher<ProgramGroupQuery, ProgramGroupQueryVariables>(ProgramGroupDocument, variables),
      options
    );

useProgramGroupQuery.getKey = (variables: ProgramGroupQueryVariables) => ['ProgramGroup', variables];
;

export const useInfiniteProgramGroupQuery = <
      TData = ProgramGroupQuery,
      TError = unknown
    >(
      pageParamKey: keyof ProgramGroupQueryVariables,
      variables: ProgramGroupQueryVariables,
      options?: UseInfiniteQueryOptions<ProgramGroupQuery, TError, TData>
    ) =>
    useInfiniteQuery<ProgramGroupQuery, TError, TData>(
      ['ProgramGroup.infinite', variables],
      (metaData) => fetcher<ProgramGroupQuery, ProgramGroupQueryVariables>(ProgramGroupDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteProgramGroupQuery.getKey = (variables: ProgramGroupQueryVariables) => ['ProgramGroup.infinite', variables];
;

useProgramGroupQuery.fetcher = (variables: ProgramGroupQueryVariables) => fetcher<ProgramGroupQuery, ProgramGroupQueryVariables>(ProgramGroupDocument, variables);
export const DeleteWorkAllocationProgramDocument = `
    mutation DeleteWorkAllocationProgram($id: ID!) {
  deleteWorkAllocationProgram(id: $id)
}
    `;
export const useDeleteWorkAllocationProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWorkAllocationProgramMutation, TError, DeleteWorkAllocationProgramMutationVariables, TContext>) =>
    useMutation<DeleteWorkAllocationProgramMutation, TError, DeleteWorkAllocationProgramMutationVariables, TContext>(
      ['DeleteWorkAllocationProgram'],
      (variables?: DeleteWorkAllocationProgramMutationVariables) => fetcher<DeleteWorkAllocationProgramMutation, DeleteWorkAllocationProgramMutationVariables>(DeleteWorkAllocationProgramDocument, variables)(),
      options
    );
useDeleteWorkAllocationProgramMutation.fetcher = (variables: DeleteWorkAllocationProgramMutationVariables) => fetcher<DeleteWorkAllocationProgramMutation, DeleteWorkAllocationProgramMutationVariables>(DeleteWorkAllocationProgramDocument, variables);
export const DeleteWorkAllocationProgramMatterDocument = `
    mutation DeleteWorkAllocationProgramMatter($id: ID!) {
  deleteWorkAllocationProgramMatter(id: $id)
}
    `;
export const useDeleteWorkAllocationProgramMatterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWorkAllocationProgramMatterMutation, TError, DeleteWorkAllocationProgramMatterMutationVariables, TContext>) =>
    useMutation<DeleteWorkAllocationProgramMatterMutation, TError, DeleteWorkAllocationProgramMatterMutationVariables, TContext>(
      ['DeleteWorkAllocationProgramMatter'],
      (variables?: DeleteWorkAllocationProgramMatterMutationVariables) => fetcher<DeleteWorkAllocationProgramMatterMutation, DeleteWorkAllocationProgramMatterMutationVariables>(DeleteWorkAllocationProgramMatterDocument, variables)(),
      options
    );
useDeleteWorkAllocationProgramMatterMutation.fetcher = (variables: DeleteWorkAllocationProgramMatterMutationVariables) => fetcher<DeleteWorkAllocationProgramMatterMutation, DeleteWorkAllocationProgramMatterMutationVariables>(DeleteWorkAllocationProgramMatterDocument, variables);
export const UpsertWorkAllocationProgramEvaluationTemplateDocument = `
    mutation UpsertWorkAllocationProgramEvaluationTemplate($input: UpsertEvaluationTemplateOnProgramInput!) {
  upsertWorkAllocationProgramEvaluationTemplate(input: $input)
}
    `;
export const useUpsertWorkAllocationProgramEvaluationTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationProgramEvaluationTemplateMutation, TError, UpsertWorkAllocationProgramEvaluationTemplateMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationProgramEvaluationTemplateMutation, TError, UpsertWorkAllocationProgramEvaluationTemplateMutationVariables, TContext>(
      ['UpsertWorkAllocationProgramEvaluationTemplate'],
      (variables?: UpsertWorkAllocationProgramEvaluationTemplateMutationVariables) => fetcher<UpsertWorkAllocationProgramEvaluationTemplateMutation, UpsertWorkAllocationProgramEvaluationTemplateMutationVariables>(UpsertWorkAllocationProgramEvaluationTemplateDocument, variables)(),
      options
    );
useUpsertWorkAllocationProgramEvaluationTemplateMutation.fetcher = (variables: UpsertWorkAllocationProgramEvaluationTemplateMutationVariables) => fetcher<UpsertWorkAllocationProgramEvaluationTemplateMutation, UpsertWorkAllocationProgramEvaluationTemplateMutationVariables>(UpsertWorkAllocationProgramEvaluationTemplateDocument, variables);
export const UupsertWorkAllocationProgramReminderEmailDocument = `
    mutation UupsertWorkAllocationProgramReminderEmail($input: UpsertReminderEmailsOnProgramInput!) {
  upsertWorkAllocationProgramReminderEmail(input: $input)
}
    `;
export const useUupsertWorkAllocationProgramReminderEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UupsertWorkAllocationProgramReminderEmailMutation, TError, UupsertWorkAllocationProgramReminderEmailMutationVariables, TContext>) =>
    useMutation<UupsertWorkAllocationProgramReminderEmailMutation, TError, UupsertWorkAllocationProgramReminderEmailMutationVariables, TContext>(
      ['UupsertWorkAllocationProgramReminderEmail'],
      (variables?: UupsertWorkAllocationProgramReminderEmailMutationVariables) => fetcher<UupsertWorkAllocationProgramReminderEmailMutation, UupsertWorkAllocationProgramReminderEmailMutationVariables>(UupsertWorkAllocationProgramReminderEmailDocument, variables)(),
      options
    );
useUupsertWorkAllocationProgramReminderEmailMutation.fetcher = (variables: UupsertWorkAllocationProgramReminderEmailMutationVariables) => fetcher<UupsertWorkAllocationProgramReminderEmailMutation, UupsertWorkAllocationProgramReminderEmailMutationVariables>(UupsertWorkAllocationProgramReminderEmailDocument, variables);
export const UpsertWorkAllocationProgramDocument = `
    mutation UpsertWorkAllocationProgram($input: UpsertWorkAllocationProgramInput!) {
  upsertWorkAllocationProgram(input: $input)
}
    `;
export const useUpsertWorkAllocationProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationProgramMutation, TError, UpsertWorkAllocationProgramMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationProgramMutation, TError, UpsertWorkAllocationProgramMutationVariables, TContext>(
      ['UpsertWorkAllocationProgram'],
      (variables?: UpsertWorkAllocationProgramMutationVariables) => fetcher<UpsertWorkAllocationProgramMutation, UpsertWorkAllocationProgramMutationVariables>(UpsertWorkAllocationProgramDocument, variables)(),
      options
    );
useUpsertWorkAllocationProgramMutation.fetcher = (variables: UpsertWorkAllocationProgramMutationVariables) => fetcher<UpsertWorkAllocationProgramMutation, UpsertWorkAllocationProgramMutationVariables>(UpsertWorkAllocationProgramDocument, variables);
export const UpsertWorkAllocationProgramMatterDocument = `
    mutation UpsertWorkAllocationProgramMatter($programId: ID!, $input: UpsertWorkAllocationProgramMatterInput!) {
  upsertWorkAllocationProgramMatter(programId: $programId, input: $input)
}
    `;
export const useUpsertWorkAllocationProgramMatterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationProgramMatterMutation, TError, UpsertWorkAllocationProgramMatterMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationProgramMatterMutation, TError, UpsertWorkAllocationProgramMatterMutationVariables, TContext>(
      ['UpsertWorkAllocationProgramMatter'],
      (variables?: UpsertWorkAllocationProgramMatterMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterMutation, UpsertWorkAllocationProgramMatterMutationVariables>(UpsertWorkAllocationProgramMatterDocument, variables)(),
      options
    );
useUpsertWorkAllocationProgramMatterMutation.fetcher = (variables: UpsertWorkAllocationProgramMatterMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterMutation, UpsertWorkAllocationProgramMatterMutationVariables>(UpsertWorkAllocationProgramMatterDocument, variables);
export const UpsertWorkAllocationProgramMatterByMemberDocument = `
    mutation UpsertWorkAllocationProgramMatterByMember($programId: ID!, $input: UpsertWorkAllocationProgramMatterInput!) {
  upsertWorkAllocationProgramMatterByMember(programId: $programId, input: $input)
}
    `;
export const useUpsertWorkAllocationProgramMatterByMemberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationProgramMatterByMemberMutation, TError, UpsertWorkAllocationProgramMatterByMemberMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationProgramMatterByMemberMutation, TError, UpsertWorkAllocationProgramMatterByMemberMutationVariables, TContext>(
      ['UpsertWorkAllocationProgramMatterByMember'],
      (variables?: UpsertWorkAllocationProgramMatterByMemberMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterByMemberMutation, UpsertWorkAllocationProgramMatterByMemberMutationVariables>(UpsertWorkAllocationProgramMatterByMemberDocument, variables)(),
      options
    );
useUpsertWorkAllocationProgramMatterByMemberMutation.fetcher = (variables: UpsertWorkAllocationProgramMatterByMemberMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterByMemberMutation, UpsertWorkAllocationProgramMatterByMemberMutationVariables>(UpsertWorkAllocationProgramMatterByMemberDocument, variables);
export const UpsertWorkAllocationProgramMatterDocumentDocument = `
    mutation UpsertWorkAllocationProgramMatterDocument($input: UploadMatterDocumentInput!, $file: Upload) {
  uploadMatterDocument(input: $input, file: $file)
}
    `;
export const useUpsertWorkAllocationProgramMatterDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationProgramMatterDocumentMutation, TError, UpsertWorkAllocationProgramMatterDocumentMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationProgramMatterDocumentMutation, TError, UpsertWorkAllocationProgramMatterDocumentMutationVariables, TContext>(
      ['UpsertWorkAllocationProgramMatterDocument'],
      (variables?: UpsertWorkAllocationProgramMatterDocumentMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterDocumentMutation, UpsertWorkAllocationProgramMatterDocumentMutationVariables>(UpsertWorkAllocationProgramMatterDocumentDocument, variables)(),
      options
    );
useUpsertWorkAllocationProgramMatterDocumentMutation.fetcher = (variables: UpsertWorkAllocationProgramMatterDocumentMutationVariables) => fetcher<UpsertWorkAllocationProgramMatterDocumentMutation, UpsertWorkAllocationProgramMatterDocumentMutationVariables>(UpsertWorkAllocationProgramMatterDocumentDocument, variables);
export const DeleteMatterDocumentDocument = `
    mutation DeleteMatterDocument($matterId: ID!, $ids: [ID!]!) {
  deleteMatterDocuments(matterId: $matterId, documentIds: $ids)
}
    `;
export const useDeleteMatterDocumentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMatterDocumentMutation, TError, DeleteMatterDocumentMutationVariables, TContext>) =>
    useMutation<DeleteMatterDocumentMutation, TError, DeleteMatterDocumentMutationVariables, TContext>(
      ['DeleteMatterDocument'],
      (variables?: DeleteMatterDocumentMutationVariables) => fetcher<DeleteMatterDocumentMutation, DeleteMatterDocumentMutationVariables>(DeleteMatterDocumentDocument, variables)(),
      options
    );
useDeleteMatterDocumentMutation.fetcher = (variables: DeleteMatterDocumentMutationVariables) => fetcher<DeleteMatterDocumentMutation, DeleteMatterDocumentMutationVariables>(DeleteMatterDocumentDocument, variables);
export const UpdateMatterWorkStatusDocument = `
    mutation UpdateMatterWorkStatus($matterId: ID!, $status: MatterStatus!) {
  updateMatterWorkStatus(matterId: $matterId, status: $status)
}
    `;
export const useUpdateMatterWorkStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMatterWorkStatusMutation, TError, UpdateMatterWorkStatusMutationVariables, TContext>) =>
    useMutation<UpdateMatterWorkStatusMutation, TError, UpdateMatterWorkStatusMutationVariables, TContext>(
      ['UpdateMatterWorkStatus'],
      (variables?: UpdateMatterWorkStatusMutationVariables) => fetcher<UpdateMatterWorkStatusMutation, UpdateMatterWorkStatusMutationVariables>(UpdateMatterWorkStatusDocument, variables)(),
      options
    );
useUpdateMatterWorkStatusMutation.fetcher = (variables: UpdateMatterWorkStatusMutationVariables) => fetcher<UpdateMatterWorkStatusMutation, UpdateMatterWorkStatusMutationVariables>(UpdateMatterWorkStatusDocument, variables);
export const UpsertMatterAssociateEvaluationDocument = `
    mutation upsertMatterAssociateEvaluation($matterId: ID!, $candidateId: ID!, $answers: [CandidateEvaluationAnswerInput!]!) {
  upsertMatterAssociateEvaluation(
    matterId: $matterId
    candidateId: $candidateId
    answers: $answers
  )
}
    `;
export const useUpsertMatterAssociateEvaluationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertMatterAssociateEvaluationMutation, TError, UpsertMatterAssociateEvaluationMutationVariables, TContext>) =>
    useMutation<UpsertMatterAssociateEvaluationMutation, TError, UpsertMatterAssociateEvaluationMutationVariables, TContext>(
      ['upsertMatterAssociateEvaluation'],
      (variables?: UpsertMatterAssociateEvaluationMutationVariables) => fetcher<UpsertMatterAssociateEvaluationMutation, UpsertMatterAssociateEvaluationMutationVariables>(UpsertMatterAssociateEvaluationDocument, variables)(),
      options
    );
useUpsertMatterAssociateEvaluationMutation.fetcher = (variables: UpsertMatterAssociateEvaluationMutationVariables) => fetcher<UpsertMatterAssociateEvaluationMutation, UpsertMatterAssociateEvaluationMutationVariables>(UpsertMatterAssociateEvaluationDocument, variables);
export const UpsertWorkAllocationPermissionsDocument = `
    mutation UpsertWorkAllocationPermissions($input: UpsertWorkAllocationPermissionsInput!) {
  upsertWorkAllocationPermissions(input: $input)
}
    `;
export const useUpsertWorkAllocationPermissionsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationPermissionsMutation, TError, UpsertWorkAllocationPermissionsMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationPermissionsMutation, TError, UpsertWorkAllocationPermissionsMutationVariables, TContext>(
      ['UpsertWorkAllocationPermissions'],
      (variables?: UpsertWorkAllocationPermissionsMutationVariables) => fetcher<UpsertWorkAllocationPermissionsMutation, UpsertWorkAllocationPermissionsMutationVariables>(UpsertWorkAllocationPermissionsDocument, variables)(),
      options
    );
useUpsertWorkAllocationPermissionsMutation.fetcher = (variables: UpsertWorkAllocationPermissionsMutationVariables) => fetcher<UpsertWorkAllocationPermissionsMutation, UpsertWorkAllocationPermissionsMutationVariables>(UpsertWorkAllocationPermissionsDocument, variables);
export const UpsertWorkAllocationEmailAlertsDocument = `
    mutation UpsertWorkAllocationEmailAlerts($input: UpsertWorkAllocationEmailAlertsInput!) {
  upsertWorkAllocationEmailAlerts(input: $input)
}
    `;
export const useUpsertWorkAllocationEmailAlertsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationEmailAlertsMutation, TError, UpsertWorkAllocationEmailAlertsMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationEmailAlertsMutation, TError, UpsertWorkAllocationEmailAlertsMutationVariables, TContext>(
      ['UpsertWorkAllocationEmailAlerts'],
      (variables?: UpsertWorkAllocationEmailAlertsMutationVariables) => fetcher<UpsertWorkAllocationEmailAlertsMutation, UpsertWorkAllocationEmailAlertsMutationVariables>(UpsertWorkAllocationEmailAlertsDocument, variables)(),
      options
    );
useUpsertWorkAllocationEmailAlertsMutation.fetcher = (variables: UpsertWorkAllocationEmailAlertsMutationVariables) => fetcher<UpsertWorkAllocationEmailAlertsMutation, UpsertWorkAllocationEmailAlertsMutationVariables>(UpsertWorkAllocationEmailAlertsDocument, variables);
export const WorkAllocationMatterDocument = `
    query WorkAllocationMatter($id: ID!) {
  workAllocationMatter(id: $id) {
    createdBy
    assignees {
      id
      firstName
      lastName
      email
      phone
      linkedin
      authzReasons
    }
    assignmentType
    attorneys {
      id
      firstName
      lastName
      email
    }
    clientMatterName
    clientMatterNumber
    clientNumber
    deadline
    timezone
    description
    id
    offices {
      id
      name
    }
    org
    evaluations {
      id
      recruitId
      userId
      ratingAnswer
      yesNoAnswer
      singleSelectAnswer
      multiSelectAnswers
      freeText
      comment
      orgFeedbackId
      createdAt
    }
    requestedProjectEvaluations {
      id
      matterId
      associateRecruitId
      attorneyUserId
      requestedAt
      submittedAt
    }
    practiceAreas {
      id
      name
    }
    orgPracticeAreas {
      id
      firmSpecificName
    }
    submittedStatus
    timeToComplete {
      unit
      value
    }
    workStatus
    documents {
      id
      userFileName
      documentFileName
      createdAt
      createdBy
      updatedBy
      updatedAt
    }
    createdAt
    evaluations {
      id
      orgFeedbackId
      recruitId
      userId
      ratingAnswer
      yesNoAnswer
      singleSelectAnswer
      multiSelectAnswers
      freeText
      comment
    }
  }
}
    `;
export const useWorkAllocationMatterQuery = <
      TData = WorkAllocationMatterQuery,
      TError = unknown
    >(
      variables: WorkAllocationMatterQueryVariables,
      options?: UseQueryOptions<WorkAllocationMatterQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationMatterQuery, TError, TData>(
      ['WorkAllocationMatter', variables],
      fetcher<WorkAllocationMatterQuery, WorkAllocationMatterQueryVariables>(WorkAllocationMatterDocument, variables),
      options
    );

useWorkAllocationMatterQuery.getKey = (variables: WorkAllocationMatterQueryVariables) => ['WorkAllocationMatter', variables];
;

export const useInfiniteWorkAllocationMatterQuery = <
      TData = WorkAllocationMatterQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationMatterQueryVariables,
      variables: WorkAllocationMatterQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationMatterQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationMatterQuery, TError, TData>(
      ['WorkAllocationMatter.infinite', variables],
      (metaData) => fetcher<WorkAllocationMatterQuery, WorkAllocationMatterQueryVariables>(WorkAllocationMatterDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationMatterQuery.getKey = (variables: WorkAllocationMatterQueryVariables) => ['WorkAllocationMatter.infinite', variables];
;

useWorkAllocationMatterQuery.fetcher = (variables: WorkAllocationMatterQueryVariables) => fetcher<WorkAllocationMatterQuery, WorkAllocationMatterQueryVariables>(WorkAllocationMatterDocument, variables);
export const WorkAllocationMattersByProgramDocument = `
    query WorkAllocationMattersByProgram($programId: ID!) {
  workAllocationMattersByProgram(programId: $programId) {
    assignees {
      id
      firstName
      lastName
      email
    }
    assignmentType
    attorneys {
      id
      firstName
      lastName
      email
    }
    clientMatterName
    clientMatterNumber
    clientNumber
    deadline
    timezone
    description
    id
    offices {
      id
      name
    }
    org
    practiceAreas {
      id
      name
    }
    orgPracticeAreas {
      id
      firmSpecificName
    }
    submittedStatus
    timeToComplete {
      unit
      value
    }
    workStatus
    documents {
      id
      userFileName
      createdAt
      createdBy
      updatedBy
      updatedAt
    }
    createdBy
  }
}
    `;
export const useWorkAllocationMattersByProgramQuery = <
      TData = WorkAllocationMattersByProgramQuery,
      TError = unknown
    >(
      variables: WorkAllocationMattersByProgramQueryVariables,
      options?: UseQueryOptions<WorkAllocationMattersByProgramQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationMattersByProgramQuery, TError, TData>(
      ['WorkAllocationMattersByProgram', variables],
      fetcher<WorkAllocationMattersByProgramQuery, WorkAllocationMattersByProgramQueryVariables>(WorkAllocationMattersByProgramDocument, variables),
      options
    );

useWorkAllocationMattersByProgramQuery.getKey = (variables: WorkAllocationMattersByProgramQueryVariables) => ['WorkAllocationMattersByProgram', variables];
;

export const useInfiniteWorkAllocationMattersByProgramQuery = <
      TData = WorkAllocationMattersByProgramQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationMattersByProgramQueryVariables,
      variables: WorkAllocationMattersByProgramQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationMattersByProgramQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationMattersByProgramQuery, TError, TData>(
      ['WorkAllocationMattersByProgram.infinite', variables],
      (metaData) => fetcher<WorkAllocationMattersByProgramQuery, WorkAllocationMattersByProgramQueryVariables>(WorkAllocationMattersByProgramDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationMattersByProgramQuery.getKey = (variables: WorkAllocationMattersByProgramQueryVariables) => ['WorkAllocationMattersByProgram.infinite', variables];
;

useWorkAllocationMattersByProgramQuery.fetcher = (variables: WorkAllocationMattersByProgramQueryVariables) => fetcher<WorkAllocationMattersByProgramQuery, WorkAllocationMattersByProgramQueryVariables>(WorkAllocationMattersByProgramDocument, variables);
export const WorkAllocationProgramDocument = `
    query WorkAllocationProgram($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    description
    endDate
    startDate
    id
    attorneyFeedbackReminderEmailEnabled
    allowSummerAssociatesToCreateEditProjects
    allowSummerAssociatesToDeleteProjects
    allowSummerAssociatesToSelfAssignProjects
    emailSummerAssociateWhenAssignedToProject
    emailAdminWhenAttorneyCreatesProject
    emailAdminWhenSummerAssociateCreatesProject
    emailAdminWhenSummerAssociateIsAssignedToProject
    emailAdminWhenSummerAssociateDeletesProject
    emailAdminWhenSummerAssociateIsRemovedFromProject
    emailAdminWhenFeedbackSubmitted
    emailAssignedAttorneysWhenDocumentsAreUploadedToProject
    emailAssignedAttorneysWhenAssociateAssignedToProject
    emailAssignedAttorneysWhenAssociateIsRemovedFromProject
    emailAssignedAttorneysWhenAssociateDeletesProject
    emailContributorWhenAttorneyCreatesProject
    emailContributorWhenAssociateCreatesProject
    emailContributorWhenAssociateDeletesProject
    emailContributorWhenAssociateIsRemovedFromProject
    programAssociates {
      id
      firstName
      lastName
      email
      phone
    }
    ownerUser {
      id
      admin
      fname
      lname
      email
    }
    emails {
      id
      fromEmail
      replyToEmail
      subject
      body
      bccEmail
      ccEmail
    }
    evaluationQuestions {
      id
      orgFeedbackId
      isRequired
      evaluationQuestion {
        id
        label
        subtext
        type
        evaluationType
        lowScale
        highScale
        lowLabel
        highLabel
        commentsEnabled
        selectOptions
      }
    }
    matters {
      authzReasons
      assignees {
        id
        firstName
        lastName
        email
        authzReasons
      }
      assignmentType
      attorneys {
        id
        firstName
        lastName
        email
      }
      clientMatterName
      clientMatterNumber
      clientNumber
      deadline
      timezone
      description
      id
      offices {
        id
        name
      }
      org
      practiceAreas {
        id
        name
      }
      orgPracticeAreas {
        id
        firmSpecificName
      }
      submittedStatus
      timeToComplete {
        unit
        value
      }
      workStatus
      workStatusUpdatedAt
      documents {
        id
        userFileName
        createdAt
        createdBy
        updatedBy
        updatedAt
      }
      createdAt
      createdBy
      requestedProjectEvaluations {
        id
        matterId
        associateRecruitId
        attorneyUserId
        requestedAt
        submittedAt
      }
      evaluations {
        id
        orgFeedbackId
        recruitId
        userId
        ratingAnswer
        yesNoAnswer
        singleSelectAnswer
        multiSelectAnswers
        freeText
        comment
        createdAt
      }
    }
    timezone
    title
    customEvaluations {
      id
      evaluationName
      evaluationType
      feedbackReminderEmailEnabled
      feedbackReminderEmailTemplateId
      questions {
        id
        orgFeedbackId
        isRequired
        evaluationQuestion {
          id
          label
          subtext
          type
          evaluationType
          lowScale
          highScale
          lowLabel
          highLabel
          commentsEnabled
          selectOptions
        }
      }
      email {
        id
        fromEmail
        replyToEmail
        subject
        body
        bccEmail
        ccEmail
      }
    }
    groups {
      ...ProgramGroup
    }
  }
}
    ${ProgramGroupFragmentDoc}
${ProgramGroupContributorFragmentDoc}`;
export const useWorkAllocationProgramQuery = <
      TData = WorkAllocationProgramQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramQuery, TError, TData>(
      ['WorkAllocationProgram', variables],
      fetcher<WorkAllocationProgramQuery, WorkAllocationProgramQueryVariables>(WorkAllocationProgramDocument, variables),
      options
    );

useWorkAllocationProgramQuery.getKey = (variables: WorkAllocationProgramQueryVariables) => ['WorkAllocationProgram', variables];
;

export const useInfiniteWorkAllocationProgramQuery = <
      TData = WorkAllocationProgramQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramQueryVariables,
      variables: WorkAllocationProgramQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramQuery, TError, TData>(
      ['WorkAllocationProgram.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramQuery, WorkAllocationProgramQueryVariables>(WorkAllocationProgramDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramQuery.getKey = (variables: WorkAllocationProgramQueryVariables) => ['WorkAllocationProgram.infinite', variables];
;

useWorkAllocationProgramQuery.fetcher = (variables: WorkAllocationProgramQueryVariables) => fetcher<WorkAllocationProgramQuery, WorkAllocationProgramQueryVariables>(WorkAllocationProgramDocument, variables);
export const WorkAllocationProgramTitleDocument = `
    query WorkAllocationProgramTitle($programId: ID!) {
  programTitle(programId: $programId)
}
    `;
export const useWorkAllocationProgramTitleQuery = <
      TData = WorkAllocationProgramTitleQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramTitleQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramTitleQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramTitleQuery, TError, TData>(
      ['WorkAllocationProgramTitle', variables],
      fetcher<WorkAllocationProgramTitleQuery, WorkAllocationProgramTitleQueryVariables>(WorkAllocationProgramTitleDocument, variables),
      options
    );

useWorkAllocationProgramTitleQuery.getKey = (variables: WorkAllocationProgramTitleQueryVariables) => ['WorkAllocationProgramTitle', variables];
;

export const useInfiniteWorkAllocationProgramTitleQuery = <
      TData = WorkAllocationProgramTitleQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramTitleQueryVariables,
      variables: WorkAllocationProgramTitleQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramTitleQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramTitleQuery, TError, TData>(
      ['WorkAllocationProgramTitle.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramTitleQuery, WorkAllocationProgramTitleQueryVariables>(WorkAllocationProgramTitleDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramTitleQuery.getKey = (variables: WorkAllocationProgramTitleQueryVariables) => ['WorkAllocationProgramTitle.infinite', variables];
;

useWorkAllocationProgramTitleQuery.fetcher = (variables: WorkAllocationProgramTitleQueryVariables) => fetcher<WorkAllocationProgramTitleQuery, WorkAllocationProgramTitleQueryVariables>(WorkAllocationProgramTitleDocument, variables);
export const WorkAllocationProgramsDocument = `
    query WorkAllocationPrograms($programIds: [ID]) {
  workAllocationPrograms(programIds: $programIds) {
    description
    endDate
    startDate
    id
    allowSummerAssociatesToCreateEditProjects
    allowSummerAssociatesToDeleteProjects
    allowSummerAssociatesToSelfAssignProjects
    emailAdminWhenAttorneyCreatesProject
    emailAdminWhenSummerAssociateCreatesProject
    emailAdminWhenSummerAssociateIsAssignedToProject
    emailAssignedAttorneysWhenDocumentsAreUploadedToProject
    emailSummerAssociateWhenAssignedToProject
    emails {
      id
      fromEmail
      replyToEmail
      subject
      body
      bccEmail
      ccEmail
    }
    evaluationQuestions {
      id
      orgFeedbackId
      isRequired
      evaluationQuestion {
        id
        label
        subtext
        type
        evaluationType
        lowScale
        highScale
        lowLabel
        highLabel
        commentsEnabled
        selectOptions
      }
    }
    ownerUser {
      id
      admin
      fname
      lname
      email
    }
    timezone
    title
  }
}
    `;
export const useWorkAllocationProgramsQuery = <
      TData = WorkAllocationProgramsQuery,
      TError = unknown
    >(
      variables?: WorkAllocationProgramsQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramsQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramsQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationPrograms'] : ['WorkAllocationPrograms', variables],
      fetcher<WorkAllocationProgramsQuery, WorkAllocationProgramsQueryVariables>(WorkAllocationProgramsDocument, variables),
      options
    );

useWorkAllocationProgramsQuery.getKey = (variables?: WorkAllocationProgramsQueryVariables) => variables === undefined ? ['WorkAllocationPrograms'] : ['WorkAllocationPrograms', variables];
;

export const useInfiniteWorkAllocationProgramsQuery = <
      TData = WorkAllocationProgramsQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramsQueryVariables,
      variables?: WorkAllocationProgramsQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramsQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramsQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationPrograms.infinite'] : ['WorkAllocationPrograms.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramsQuery, WorkAllocationProgramsQueryVariables>(WorkAllocationProgramsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramsQuery.getKey = (variables?: WorkAllocationProgramsQueryVariables) => variables === undefined ? ['WorkAllocationPrograms.infinite'] : ['WorkAllocationPrograms.infinite', variables];
;

useWorkAllocationProgramsQuery.fetcher = (variables?: WorkAllocationProgramsQueryVariables) => fetcher<WorkAllocationProgramsQuery, WorkAllocationProgramsQueryVariables>(WorkAllocationProgramsDocument, variables);
export const WorkAllocationOrgProgramsDocument = `
    query WorkAllocationOrgPrograms {
  workAllocationOrgPrograms {
    description
    endDate
    startDate
    id
    allowSummerAssociatesToCreateEditProjects
    allowSummerAssociatesToDeleteProjects
    allowSummerAssociatesToSelfAssignProjects
    emailAdminWhenAttorneyCreatesProject
    emailAdminWhenSummerAssociateCreatesProject
    emailAdminWhenSummerAssociateIsAssignedToProject
    emailAssignedAttorneysWhenDocumentsAreUploadedToProject
    emailSummerAssociateWhenAssignedToProject
    emails {
      id
      fromEmail
      replyToEmail
      subject
      body
      bccEmail
      ccEmail
    }
    evaluationQuestions {
      id
      orgFeedbackId
      isRequired
      evaluationQuestion {
        id
        label
        subtext
        type
        evaluationType
        lowScale
        highScale
        lowLabel
        highLabel
        commentsEnabled
        selectOptions
      }
    }
    ownerUser {
      id
      admin
      fname
      lname
      email
    }
    timezone
    title
  }
}
    `;
export const useWorkAllocationOrgProgramsQuery = <
      TData = WorkAllocationOrgProgramsQuery,
      TError = unknown
    >(
      variables?: WorkAllocationOrgProgramsQueryVariables,
      options?: UseQueryOptions<WorkAllocationOrgProgramsQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationOrgProgramsQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationOrgPrograms'] : ['WorkAllocationOrgPrograms', variables],
      fetcher<WorkAllocationOrgProgramsQuery, WorkAllocationOrgProgramsQueryVariables>(WorkAllocationOrgProgramsDocument, variables),
      options
    );

useWorkAllocationOrgProgramsQuery.getKey = (variables?: WorkAllocationOrgProgramsQueryVariables) => variables === undefined ? ['WorkAllocationOrgPrograms'] : ['WorkAllocationOrgPrograms', variables];
;

export const useInfiniteWorkAllocationOrgProgramsQuery = <
      TData = WorkAllocationOrgProgramsQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationOrgProgramsQueryVariables,
      variables?: WorkAllocationOrgProgramsQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationOrgProgramsQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationOrgProgramsQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationOrgPrograms.infinite'] : ['WorkAllocationOrgPrograms.infinite', variables],
      (metaData) => fetcher<WorkAllocationOrgProgramsQuery, WorkAllocationOrgProgramsQueryVariables>(WorkAllocationOrgProgramsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationOrgProgramsQuery.getKey = (variables?: WorkAllocationOrgProgramsQueryVariables) => variables === undefined ? ['WorkAllocationOrgPrograms.infinite'] : ['WorkAllocationOrgPrograms.infinite', variables];
;

useWorkAllocationOrgProgramsQuery.fetcher = (variables?: WorkAllocationOrgProgramsQueryVariables) => fetcher<WorkAllocationOrgProgramsQuery, WorkAllocationOrgProgramsQueryVariables>(WorkAllocationOrgProgramsDocument, variables);
export const WorkAllocationOrgProgramsForProgramsPageDocument = `
    query WorkAllocationOrgProgramsForProgramsPage {
  workAllocationOrgPrograms {
    description
    endDate
    startDate
    id
    allowSummerAssociatesToCreateEditProjects
    allowSummerAssociatesToDeleteProjects
    allowSummerAssociatesToSelfAssignProjects
    emailAdminWhenAttorneyCreatesProject
    emailAdminWhenSummerAssociateCreatesProject
    emailAdminWhenSummerAssociateIsAssignedToProject
    emailAssignedAttorneysWhenDocumentsAreUploadedToProject
    emailSummerAssociateWhenAssignedToProject
    evaluationQuestions {
      id
      orgFeedbackId
      isRequired
      evaluationQuestion {
        id
        label
        subtext
        type
        evaluationType
        lowScale
        highScale
        lowLabel
        highLabel
        commentsEnabled
        selectOptions
      }
    }
    ownerUser {
      id
      admin
      fname
      lname
      email
    }
    timezone
    title
    authzReasons
  }
}
    `;
export const useWorkAllocationOrgProgramsForProgramsPageQuery = <
      TData = WorkAllocationOrgProgramsForProgramsPageQuery,
      TError = unknown
    >(
      variables?: WorkAllocationOrgProgramsForProgramsPageQueryVariables,
      options?: UseQueryOptions<WorkAllocationOrgProgramsForProgramsPageQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationOrgProgramsForProgramsPageQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationOrgProgramsForProgramsPage'] : ['WorkAllocationOrgProgramsForProgramsPage', variables],
      fetcher<WorkAllocationOrgProgramsForProgramsPageQuery, WorkAllocationOrgProgramsForProgramsPageQueryVariables>(WorkAllocationOrgProgramsForProgramsPageDocument, variables),
      options
    );

useWorkAllocationOrgProgramsForProgramsPageQuery.getKey = (variables?: WorkAllocationOrgProgramsForProgramsPageQueryVariables) => variables === undefined ? ['WorkAllocationOrgProgramsForProgramsPage'] : ['WorkAllocationOrgProgramsForProgramsPage', variables];
;

export const useInfiniteWorkAllocationOrgProgramsForProgramsPageQuery = <
      TData = WorkAllocationOrgProgramsForProgramsPageQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationOrgProgramsForProgramsPageQueryVariables,
      variables?: WorkAllocationOrgProgramsForProgramsPageQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationOrgProgramsForProgramsPageQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationOrgProgramsForProgramsPageQuery, TError, TData>(
      variables === undefined ? ['WorkAllocationOrgProgramsForProgramsPage.infinite'] : ['WorkAllocationOrgProgramsForProgramsPage.infinite', variables],
      (metaData) => fetcher<WorkAllocationOrgProgramsForProgramsPageQuery, WorkAllocationOrgProgramsForProgramsPageQueryVariables>(WorkAllocationOrgProgramsForProgramsPageDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationOrgProgramsForProgramsPageQuery.getKey = (variables?: WorkAllocationOrgProgramsForProgramsPageQueryVariables) => variables === undefined ? ['WorkAllocationOrgProgramsForProgramsPage.infinite'] : ['WorkAllocationOrgProgramsForProgramsPage.infinite', variables];
;

useWorkAllocationOrgProgramsForProgramsPageQuery.fetcher = (variables?: WorkAllocationOrgProgramsForProgramsPageQueryVariables) => fetcher<WorkAllocationOrgProgramsForProgramsPageQuery, WorkAllocationOrgProgramsForProgramsPageQueryVariables>(WorkAllocationOrgProgramsForProgramsPageDocument, variables);
export const GetWorkAllocationProgramEvaluationsDocument = `
    query GetWorkAllocationProgramEvaluations($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    customEvaluations {
      id
      evaluationName
      evaluationType
      feedbackReminderEmailEnabled
    }
  }
}
    `;
export const useGetWorkAllocationProgramEvaluationsQuery = <
      TData = GetWorkAllocationProgramEvaluationsQuery,
      TError = unknown
    >(
      variables: GetWorkAllocationProgramEvaluationsQueryVariables,
      options?: UseQueryOptions<GetWorkAllocationProgramEvaluationsQuery, TError, TData>
    ) =>
    useQuery<GetWorkAllocationProgramEvaluationsQuery, TError, TData>(
      ['GetWorkAllocationProgramEvaluations', variables],
      fetcher<GetWorkAllocationProgramEvaluationsQuery, GetWorkAllocationProgramEvaluationsQueryVariables>(GetWorkAllocationProgramEvaluationsDocument, variables),
      options
    );

useGetWorkAllocationProgramEvaluationsQuery.getKey = (variables: GetWorkAllocationProgramEvaluationsQueryVariables) => ['GetWorkAllocationProgramEvaluations', variables];
;

export const useInfiniteGetWorkAllocationProgramEvaluationsQuery = <
      TData = GetWorkAllocationProgramEvaluationsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetWorkAllocationProgramEvaluationsQueryVariables,
      variables: GetWorkAllocationProgramEvaluationsQueryVariables,
      options?: UseInfiniteQueryOptions<GetWorkAllocationProgramEvaluationsQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetWorkAllocationProgramEvaluationsQuery, TError, TData>(
      ['GetWorkAllocationProgramEvaluations.infinite', variables],
      (metaData) => fetcher<GetWorkAllocationProgramEvaluationsQuery, GetWorkAllocationProgramEvaluationsQueryVariables>(GetWorkAllocationProgramEvaluationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetWorkAllocationProgramEvaluationsQuery.getKey = (variables: GetWorkAllocationProgramEvaluationsQueryVariables) => ['GetWorkAllocationProgramEvaluations.infinite', variables];
;

useGetWorkAllocationProgramEvaluationsQuery.fetcher = (variables: GetWorkAllocationProgramEvaluationsQueryVariables) => fetcher<GetWorkAllocationProgramEvaluationsQuery, GetWorkAllocationProgramEvaluationsQueryVariables>(GetWorkAllocationProgramEvaluationsDocument, variables);
export const WorkAllocationProgramEvaluationsForAssociatePortalDocument = `
    query WorkAllocationProgramEvaluationsForAssociatePortal($programId: ID!, $associateRecruitId: ID!) {
  workAllocationProgram(programId: $programId) {
    customEvaluations {
      id
      evaluationName
      evaluationType
      responsesForAssociate(associateRecruitId: $associateRecruitId) {
        requestedAt
        completedAt
      }
    }
  }
}
    `;
export const useWorkAllocationProgramEvaluationsForAssociatePortalQuery = <
      TData = WorkAllocationProgramEvaluationsForAssociatePortalQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramEvaluationsForAssociatePortalQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramEvaluationsForAssociatePortalQuery, TError, TData>(
      ['WorkAllocationProgramEvaluationsForAssociatePortal', variables],
      fetcher<WorkAllocationProgramEvaluationsForAssociatePortalQuery, WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables>(WorkAllocationProgramEvaluationsForAssociatePortalDocument, variables),
      options
    );

useWorkAllocationProgramEvaluationsForAssociatePortalQuery.getKey = (variables: WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables) => ['WorkAllocationProgramEvaluationsForAssociatePortal', variables];
;

export const useInfiniteWorkAllocationProgramEvaluationsForAssociatePortalQuery = <
      TData = WorkAllocationProgramEvaluationsForAssociatePortalQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables,
      variables: WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramEvaluationsForAssociatePortalQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramEvaluationsForAssociatePortalQuery, TError, TData>(
      ['WorkAllocationProgramEvaluationsForAssociatePortal.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramEvaluationsForAssociatePortalQuery, WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables>(WorkAllocationProgramEvaluationsForAssociatePortalDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramEvaluationsForAssociatePortalQuery.getKey = (variables: WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables) => ['WorkAllocationProgramEvaluationsForAssociatePortal.infinite', variables];
;

useWorkAllocationProgramEvaluationsForAssociatePortalQuery.fetcher = (variables: WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables) => fetcher<WorkAllocationProgramEvaluationsForAssociatePortalQuery, WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables>(WorkAllocationProgramEvaluationsForAssociatePortalDocument, variables);
export const WorkAllocationProgramEvaluationsForAttorneyPortalDocument = `
    query WorkAllocationProgramEvaluationsForAttorneyPortal($programId: ID!, $attorneyUserId: ID!) {
  workAllocationProgram(programId: $programId) {
    customEvaluations {
      id
      evaluationName
      evaluationType
      responsesForAttorney(attorneyUserId: $attorneyUserId) {
        requestedAt
        completedAt
        associateRecruitId
        associate {
          candidate {
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;
export const useWorkAllocationProgramEvaluationsForAttorneyPortalQuery = <
      TData = WorkAllocationProgramEvaluationsForAttorneyPortalQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, TError, TData>(
      ['WorkAllocationProgramEvaluationsForAttorneyPortal', variables],
      fetcher<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables>(WorkAllocationProgramEvaluationsForAttorneyPortalDocument, variables),
      options
    );

useWorkAllocationProgramEvaluationsForAttorneyPortalQuery.getKey = (variables: WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables) => ['WorkAllocationProgramEvaluationsForAttorneyPortal', variables];
;

export const useInfiniteWorkAllocationProgramEvaluationsForAttorneyPortalQuery = <
      TData = WorkAllocationProgramEvaluationsForAttorneyPortalQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables,
      variables: WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, TError, TData>(
      ['WorkAllocationProgramEvaluationsForAttorneyPortal.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables>(WorkAllocationProgramEvaluationsForAttorneyPortalDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramEvaluationsForAttorneyPortalQuery.getKey = (variables: WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables) => ['WorkAllocationProgramEvaluationsForAttorneyPortal.infinite', variables];
;

useWorkAllocationProgramEvaluationsForAttorneyPortalQuery.fetcher = (variables: WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables) => fetcher<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables>(WorkAllocationProgramEvaluationsForAttorneyPortalDocument, variables);
export const WorkAllocationProjectEvaluationsDatesForAttorneyDocument = `
    query WorkAllocationProjectEvaluationsDatesForAttorney($programId: ID!) {
  workAllocationEvaluationsForAttorney(programId: $programId) {
    projectEvaluationResponses {
      matterId
      associateRecruitId
      requestedAt
      submittedAt
    }
  }
}
    `;
export const useWorkAllocationProjectEvaluationsDatesForAttorneyQuery = <
      TData = WorkAllocationProjectEvaluationsDatesForAttorneyQuery,
      TError = unknown
    >(
      variables: WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables,
      options?: UseQueryOptions<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, TError, TData>(
      ['WorkAllocationProjectEvaluationsDatesForAttorney', variables],
      fetcher<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables>(WorkAllocationProjectEvaluationsDatesForAttorneyDocument, variables),
      options
    );

useWorkAllocationProjectEvaluationsDatesForAttorneyQuery.getKey = (variables: WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables) => ['WorkAllocationProjectEvaluationsDatesForAttorney', variables];
;

export const useInfiniteWorkAllocationProjectEvaluationsDatesForAttorneyQuery = <
      TData = WorkAllocationProjectEvaluationsDatesForAttorneyQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables,
      variables: WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, TError, TData>(
      ['WorkAllocationProjectEvaluationsDatesForAttorney.infinite', variables],
      (metaData) => fetcher<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables>(WorkAllocationProjectEvaluationsDatesForAttorneyDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProjectEvaluationsDatesForAttorneyQuery.getKey = (variables: WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables) => ['WorkAllocationProjectEvaluationsDatesForAttorney.infinite', variables];
;

useWorkAllocationProjectEvaluationsDatesForAttorneyQuery.fetcher = (variables: WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables) => fetcher<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables>(WorkAllocationProjectEvaluationsDatesForAttorneyDocument, variables);
export const WorkAllocationProgramEvaluationForAttorneyReviewingAssociateDocument = `
    query WorkAllocationProgramEvaluationForAttorneyReviewingAssociate($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    customEvaluations {
      id
      evaluationName
      evaluationType
      questions {
        id
        orgFeedbackId
        isRequired
        evaluationQuestion {
          id
          label
          subtext
          type
          evaluationType
          lowScale
          highScale
          lowLabel
          highLabel
          commentsEnabled
          selectOptions
        }
      }
      responses {
        id
        attorneyUserId
        associateRecruitId
        associate {
          candidate {
            id
            firstName
            lastName
            email
          }
        }
        answers {
          id
          orgFeedbackId
          ratingAnswer
          yesNoAnswer
          singleSelectAnswer
          multiSelectAnswers
          freeText
          comment
        }
      }
    }
  }
}
    `;
export const useWorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery = <
      TData = WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery,
      TError = unknown
    >(
      variables: WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables,
      options?: UseQueryOptions<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, TError, TData>
    ) =>
    useQuery<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, TError, TData>(
      ['WorkAllocationProgramEvaluationForAttorneyReviewingAssociate', variables],
      fetcher<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables>(WorkAllocationProgramEvaluationForAttorneyReviewingAssociateDocument, variables),
      options
    );

useWorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery.getKey = (variables: WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables) => ['WorkAllocationProgramEvaluationForAttorneyReviewingAssociate', variables];
;

export const useInfiniteWorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery = <
      TData = WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery,
      TError = unknown
    >(
      pageParamKey: keyof WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables,
      variables: WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables,
      options?: UseInfiniteQueryOptions<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, TError, TData>
    ) =>
    useInfiniteQuery<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, TError, TData>(
      ['WorkAllocationProgramEvaluationForAttorneyReviewingAssociate.infinite', variables],
      (metaData) => fetcher<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables>(WorkAllocationProgramEvaluationForAttorneyReviewingAssociateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteWorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery.getKey = (variables: WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables) => ['WorkAllocationProgramEvaluationForAttorneyReviewingAssociate.infinite', variables];
;

useWorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery.fetcher = (variables: WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables) => fetcher<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables>(WorkAllocationProgramEvaluationForAttorneyReviewingAssociateDocument, variables);
export const UserWorkAllocationPermissionsDocument = `
    query UserWorkAllocationPermissions($programId: ID!) {
  userWorkAllocationPermissions(programId: $programId) {
    programId
    permissions
  }
}
    `;
export const useUserWorkAllocationPermissionsQuery = <
      TData = UserWorkAllocationPermissionsQuery,
      TError = unknown
    >(
      variables: UserWorkAllocationPermissionsQueryVariables,
      options?: UseQueryOptions<UserWorkAllocationPermissionsQuery, TError, TData>
    ) =>
    useQuery<UserWorkAllocationPermissionsQuery, TError, TData>(
      ['UserWorkAllocationPermissions', variables],
      fetcher<UserWorkAllocationPermissionsQuery, UserWorkAllocationPermissionsQueryVariables>(UserWorkAllocationPermissionsDocument, variables),
      options
    );

useUserWorkAllocationPermissionsQuery.getKey = (variables: UserWorkAllocationPermissionsQueryVariables) => ['UserWorkAllocationPermissions', variables];
;

export const useInfiniteUserWorkAllocationPermissionsQuery = <
      TData = UserWorkAllocationPermissionsQuery,
      TError = unknown
    >(
      pageParamKey: keyof UserWorkAllocationPermissionsQueryVariables,
      variables: UserWorkAllocationPermissionsQueryVariables,
      options?: UseInfiniteQueryOptions<UserWorkAllocationPermissionsQuery, TError, TData>
    ) =>
    useInfiniteQuery<UserWorkAllocationPermissionsQuery, TError, TData>(
      ['UserWorkAllocationPermissions.infinite', variables],
      (metaData) => fetcher<UserWorkAllocationPermissionsQuery, UserWorkAllocationPermissionsQueryVariables>(UserWorkAllocationPermissionsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteUserWorkAllocationPermissionsQuery.getKey = (variables: UserWorkAllocationPermissionsQueryVariables) => ['UserWorkAllocationPermissions.infinite', variables];
;

useUserWorkAllocationPermissionsQuery.fetcher = (variables: UserWorkAllocationPermissionsQueryVariables) => fetcher<UserWorkAllocationPermissionsQuery, UserWorkAllocationPermissionsQueryVariables>(UserWorkAllocationPermissionsDocument, variables);
export const RemoveAssociatesFromWorkAllocationProgramDocument = `
    mutation RemoveAssociatesFromWorkAllocationProgram($programId: ID!, $associateIds: [ID!]!) {
  removeAssociatesFromWorkAllocationProgram(
    programId: $programId
    associateIds: $associateIds
  )
}
    `;
export const useRemoveAssociatesFromWorkAllocationProgramMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAssociatesFromWorkAllocationProgramMutation, TError, RemoveAssociatesFromWorkAllocationProgramMutationVariables, TContext>) =>
    useMutation<RemoveAssociatesFromWorkAllocationProgramMutation, TError, RemoveAssociatesFromWorkAllocationProgramMutationVariables, TContext>(
      ['RemoveAssociatesFromWorkAllocationProgram'],
      (variables?: RemoveAssociatesFromWorkAllocationProgramMutationVariables) => fetcher<RemoveAssociatesFromWorkAllocationProgramMutation, RemoveAssociatesFromWorkAllocationProgramMutationVariables>(RemoveAssociatesFromWorkAllocationProgramDocument, variables)(),
      options
    );
useRemoveAssociatesFromWorkAllocationProgramMutation.fetcher = (variables: RemoveAssociatesFromWorkAllocationProgramMutationVariables) => fetcher<RemoveAssociatesFromWorkAllocationProgramMutation, RemoveAssociatesFromWorkAllocationProgramMutationVariables>(RemoveAssociatesFromWorkAllocationProgramDocument, variables);
export const RemoveAssociatesFromWorkAllocationMatterDocument = `
    mutation RemoveAssociatesFromWorkAllocationMatter($matterId: ID!, $associateIds: [ID!]!) {
  removeAssociatesFromWorkAllocationMatter(
    matterId: $matterId
    associateIds: $associateIds
  )
}
    `;
export const useRemoveAssociatesFromWorkAllocationMatterMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveAssociatesFromWorkAllocationMatterMutation, TError, RemoveAssociatesFromWorkAllocationMatterMutationVariables, TContext>) =>
    useMutation<RemoveAssociatesFromWorkAllocationMatterMutation, TError, RemoveAssociatesFromWorkAllocationMatterMutationVariables, TContext>(
      ['RemoveAssociatesFromWorkAllocationMatter'],
      (variables?: RemoveAssociatesFromWorkAllocationMatterMutationVariables) => fetcher<RemoveAssociatesFromWorkAllocationMatterMutation, RemoveAssociatesFromWorkAllocationMatterMutationVariables>(RemoveAssociatesFromWorkAllocationMatterDocument, variables)(),
      options
    );
useRemoveAssociatesFromWorkAllocationMatterMutation.fetcher = (variables: RemoveAssociatesFromWorkAllocationMatterMutationVariables) => fetcher<RemoveAssociatesFromWorkAllocationMatterMutation, RemoveAssociatesFromWorkAllocationMatterMutationVariables>(RemoveAssociatesFromWorkAllocationMatterDocument, variables);
export const SubmitProgramEvaluationResponseForAttorneyDocument = `
    mutation SubmitProgramEvaluationResponseForAttorney($programId: ID!, $customProgramEvaluationId: ID!, $associateRecruitId: ID!, $attorneyUserId: ID!, $answers: [ProgramEvaluationAnswerInput!]!) {
  upsertIndividualProgramEvaluationResponse(
    programId: $programId
    customProgramEvaluationId: $customProgramEvaluationId
    associateRecruitId: $associateRecruitId
    attorneyUserId: $attorneyUserId
    answers: $answers
  )
}
    `;
export const useSubmitProgramEvaluationResponseForAttorneyMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitProgramEvaluationResponseForAttorneyMutation, TError, SubmitProgramEvaluationResponseForAttorneyMutationVariables, TContext>) =>
    useMutation<SubmitProgramEvaluationResponseForAttorneyMutation, TError, SubmitProgramEvaluationResponseForAttorneyMutationVariables, TContext>(
      ['SubmitProgramEvaluationResponseForAttorney'],
      (variables?: SubmitProgramEvaluationResponseForAttorneyMutationVariables) => fetcher<SubmitProgramEvaluationResponseForAttorneyMutation, SubmitProgramEvaluationResponseForAttorneyMutationVariables>(SubmitProgramEvaluationResponseForAttorneyDocument, variables)(),
      options
    );
useSubmitProgramEvaluationResponseForAttorneyMutation.fetcher = (variables: SubmitProgramEvaluationResponseForAttorneyMutationVariables) => fetcher<SubmitProgramEvaluationResponseForAttorneyMutation, SubmitProgramEvaluationResponseForAttorneyMutationVariables>(SubmitProgramEvaluationResponseForAttorneyDocument, variables);
export const DeleteEvaluationQuestionDocument = `
    mutation DeleteEvaluationQuestion($questionId: ID!) {
  deleteEvaluationQuestion(questionId: $questionId)
}
    `;
export const useDeleteEvaluationQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteEvaluationQuestionMutation, TError, DeleteEvaluationQuestionMutationVariables, TContext>) =>
    useMutation<DeleteEvaluationQuestionMutation, TError, DeleteEvaluationQuestionMutationVariables, TContext>(
      ['DeleteEvaluationQuestion'],
      (variables?: DeleteEvaluationQuestionMutationVariables) => fetcher<DeleteEvaluationQuestionMutation, DeleteEvaluationQuestionMutationVariables>(DeleteEvaluationQuestionDocument, variables)(),
      options
    );
useDeleteEvaluationQuestionMutation.fetcher = (variables: DeleteEvaluationQuestionMutationVariables) => fetcher<DeleteEvaluationQuestionMutation, DeleteEvaluationQuestionMutationVariables>(DeleteEvaluationQuestionDocument, variables);
export const UpsertEvaluationQuestionDocument = `
    mutation UpsertEvaluationQuestion($input: EvaluationQuestionInput!) {
  upsertEvaluationQuestion(input: $input)
}
    `;
export const useUpsertEvaluationQuestionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertEvaluationQuestionMutation, TError, UpsertEvaluationQuestionMutationVariables, TContext>) =>
    useMutation<UpsertEvaluationQuestionMutation, TError, UpsertEvaluationQuestionMutationVariables, TContext>(
      ['UpsertEvaluationQuestion'],
      (variables?: UpsertEvaluationQuestionMutationVariables) => fetcher<UpsertEvaluationQuestionMutation, UpsertEvaluationQuestionMutationVariables>(UpsertEvaluationQuestionDocument, variables)(),
      options
    );
useUpsertEvaluationQuestionMutation.fetcher = (variables: UpsertEvaluationQuestionMutationVariables) => fetcher<UpsertEvaluationQuestionMutation, UpsertEvaluationQuestionMutationVariables>(UpsertEvaluationQuestionDocument, variables);
export const OrgWorkAllocationEvaluationTemplatesDocument = `
    query OrgWorkAllocationEvaluationTemplates {
  getOrg {
    ... on EmployerOrgNode {
      evaluationQuestionTemplates {
        id
        evaluationType
        title
        createdAt
        updatedAt
        questions {
          id
          label
          subtext
          type
          selectOptions
          commentsEnabled
          isRequired
        }
      }
    }
  }
}
    `;
export const useOrgWorkAllocationEvaluationTemplatesQuery = <
      TData = OrgWorkAllocationEvaluationTemplatesQuery,
      TError = unknown
    >(
      variables?: OrgWorkAllocationEvaluationTemplatesQueryVariables,
      options?: UseQueryOptions<OrgWorkAllocationEvaluationTemplatesQuery, TError, TData>
    ) =>
    useQuery<OrgWorkAllocationEvaluationTemplatesQuery, TError, TData>(
      variables === undefined ? ['OrgWorkAllocationEvaluationTemplates'] : ['OrgWorkAllocationEvaluationTemplates', variables],
      fetcher<OrgWorkAllocationEvaluationTemplatesQuery, OrgWorkAllocationEvaluationTemplatesQueryVariables>(OrgWorkAllocationEvaluationTemplatesDocument, variables),
      options
    );

useOrgWorkAllocationEvaluationTemplatesQuery.getKey = (variables?: OrgWorkAllocationEvaluationTemplatesQueryVariables) => variables === undefined ? ['OrgWorkAllocationEvaluationTemplates'] : ['OrgWorkAllocationEvaluationTemplates', variables];
;

export const useInfiniteOrgWorkAllocationEvaluationTemplatesQuery = <
      TData = OrgWorkAllocationEvaluationTemplatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof OrgWorkAllocationEvaluationTemplatesQueryVariables,
      variables?: OrgWorkAllocationEvaluationTemplatesQueryVariables,
      options?: UseInfiniteQueryOptions<OrgWorkAllocationEvaluationTemplatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<OrgWorkAllocationEvaluationTemplatesQuery, TError, TData>(
      variables === undefined ? ['OrgWorkAllocationEvaluationTemplates.infinite'] : ['OrgWorkAllocationEvaluationTemplates.infinite', variables],
      (metaData) => fetcher<OrgWorkAllocationEvaluationTemplatesQuery, OrgWorkAllocationEvaluationTemplatesQueryVariables>(OrgWorkAllocationEvaluationTemplatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteOrgWorkAllocationEvaluationTemplatesQuery.getKey = (variables?: OrgWorkAllocationEvaluationTemplatesQueryVariables) => variables === undefined ? ['OrgWorkAllocationEvaluationTemplates.infinite'] : ['OrgWorkAllocationEvaluationTemplates.infinite', variables];
;

useOrgWorkAllocationEvaluationTemplatesQuery.fetcher = (variables?: OrgWorkAllocationEvaluationTemplatesQueryVariables) => fetcher<OrgWorkAllocationEvaluationTemplatesQuery, OrgWorkAllocationEvaluationTemplatesQueryVariables>(OrgWorkAllocationEvaluationTemplatesDocument, variables);
export const UpsertWorkAllocationEvaluationTemplateDocument = `
    mutation UpsertWorkAllocationEvaluationTemplate($input: EvaluationQuestionTemplateInput!) {
  upsertEvaluationQuestionTemplate(input: $input)
}
    `;
export const useUpsertWorkAllocationEvaluationTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationEvaluationTemplateMutation, TError, UpsertWorkAllocationEvaluationTemplateMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationEvaluationTemplateMutation, TError, UpsertWorkAllocationEvaluationTemplateMutationVariables, TContext>(
      ['UpsertWorkAllocationEvaluationTemplate'],
      (variables?: UpsertWorkAllocationEvaluationTemplateMutationVariables) => fetcher<UpsertWorkAllocationEvaluationTemplateMutation, UpsertWorkAllocationEvaluationTemplateMutationVariables>(UpsertWorkAllocationEvaluationTemplateDocument, variables)(),
      options
    );
useUpsertWorkAllocationEvaluationTemplateMutation.fetcher = (variables: UpsertWorkAllocationEvaluationTemplateMutationVariables) => fetcher<UpsertWorkAllocationEvaluationTemplateMutation, UpsertWorkAllocationEvaluationTemplateMutationVariables>(UpsertWorkAllocationEvaluationTemplateDocument, variables);
export const DeleteWorkAllocationEvaluationTemplateDocument = `
    mutation DeleteWorkAllocationEvaluationTemplate($id: Int!) {
  deleteEvaluationQuestionTemplate(id: $id)
}
    `;
export const useDeleteWorkAllocationEvaluationTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteWorkAllocationEvaluationTemplateMutation, TError, DeleteWorkAllocationEvaluationTemplateMutationVariables, TContext>) =>
    useMutation<DeleteWorkAllocationEvaluationTemplateMutation, TError, DeleteWorkAllocationEvaluationTemplateMutationVariables, TContext>(
      ['DeleteWorkAllocationEvaluationTemplate'],
      (variables?: DeleteWorkAllocationEvaluationTemplateMutationVariables) => fetcher<DeleteWorkAllocationEvaluationTemplateMutation, DeleteWorkAllocationEvaluationTemplateMutationVariables>(DeleteWorkAllocationEvaluationTemplateDocument, variables)(),
      options
    );
useDeleteWorkAllocationEvaluationTemplateMutation.fetcher = (variables: DeleteWorkAllocationEvaluationTemplateMutationVariables) => fetcher<DeleteWorkAllocationEvaluationTemplateMutation, DeleteWorkAllocationEvaluationTemplateMutationVariables>(DeleteWorkAllocationEvaluationTemplateDocument, variables);
export const UpsertWorkAllocationCustomProgramEvaluationTemplatesDocument = `
    mutation UpsertWorkAllocationCustomProgramEvaluationTemplates($input: UpsertCustomEvaluationTemplateOnProgramInput!) {
  upsertWorkAllocationCustomProgramEvaluationTemplates(input: $input)
}
    `;
export const useUpsertWorkAllocationCustomProgramEvaluationTemplatesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertWorkAllocationCustomProgramEvaluationTemplatesMutation, TError, UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables, TContext>) =>
    useMutation<UpsertWorkAllocationCustomProgramEvaluationTemplatesMutation, TError, UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables, TContext>(
      ['UpsertWorkAllocationCustomProgramEvaluationTemplates'],
      (variables?: UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables) => fetcher<UpsertWorkAllocationCustomProgramEvaluationTemplatesMutation, UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables>(UpsertWorkAllocationCustomProgramEvaluationTemplatesDocument, variables)(),
      options
    );
useUpsertWorkAllocationCustomProgramEvaluationTemplatesMutation.fetcher = (variables: UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables) => fetcher<UpsertWorkAllocationCustomProgramEvaluationTemplatesMutation, UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables>(UpsertWorkAllocationCustomProgramEvaluationTemplatesDocument, variables);
export const UpdateMatterPetDocument = `
    mutation UpdateMatterPet($petName: String!, $matterId: ID!) {
  updateMatterPet(petName: $petName, matterId: $matterId)
}
    `;
export const useUpdateMatterPetMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMatterPetMutation, TError, UpdateMatterPetMutationVariables, TContext>) =>
    useMutation<UpdateMatterPetMutation, TError, UpdateMatterPetMutationVariables, TContext>(
      ['UpdateMatterPet'],
      (variables?: UpdateMatterPetMutationVariables) => fetcher<UpdateMatterPetMutation, UpdateMatterPetMutationVariables>(UpdateMatterPetDocument, variables)(),
      options
    );
useUpdateMatterPetMutation.fetcher = (variables: UpdateMatterPetMutationVariables) => fetcher<UpdateMatterPetMutation, UpdateMatterPetMutationVariables>(UpdateMatterPetDocument, variables);
export const MatterPetDocument = `
    query MatterPet($matterId: ID!) {
  matterPet(matterId: $matterId) {
    id
    matterId
    petName
  }
}
    `;
export const useMatterPetQuery = <
      TData = MatterPetQuery,
      TError = unknown
    >(
      variables: MatterPetQueryVariables,
      options?: UseQueryOptions<MatterPetQuery, TError, TData>
    ) =>
    useQuery<MatterPetQuery, TError, TData>(
      ['MatterPet', variables],
      fetcher<MatterPetQuery, MatterPetQueryVariables>(MatterPetDocument, variables),
      options
    );

useMatterPetQuery.getKey = (variables: MatterPetQueryVariables) => ['MatterPet', variables];
;

export const useInfiniteMatterPetQuery = <
      TData = MatterPetQuery,
      TError = unknown
    >(
      pageParamKey: keyof MatterPetQueryVariables,
      variables: MatterPetQueryVariables,
      options?: UseInfiniteQueryOptions<MatterPetQuery, TError, TData>
    ) =>
    useInfiniteQuery<MatterPetQuery, TError, TData>(
      ['MatterPet.infinite', variables],
      (metaData) => fetcher<MatterPetQuery, MatterPetQueryVariables>(MatterPetDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteMatterPetQuery.getKey = (variables: MatterPetQueryVariables) => ['MatterPet.infinite', variables];
;

useMatterPetQuery.fetcher = (variables: MatterPetQueryVariables) => fetcher<MatterPetQuery, MatterPetQueryVariables>(MatterPetDocument, variables);
export const GetSavedEvaluationQuestionTemplatesDocument = `
    query GetSavedEvaluationQuestionTemplates {
  getSavedEvaluationQuestionTemplatesForOrg {
    id
    evaluationType
    title
    createdAt
    updatedAt
    questions {
      id
      label
    }
  }
}
    `;
export const useGetSavedEvaluationQuestionTemplatesQuery = <
      TData = GetSavedEvaluationQuestionTemplatesQuery,
      TError = unknown
    >(
      variables?: GetSavedEvaluationQuestionTemplatesQueryVariables,
      options?: UseQueryOptions<GetSavedEvaluationQuestionTemplatesQuery, TError, TData>
    ) =>
    useQuery<GetSavedEvaluationQuestionTemplatesQuery, TError, TData>(
      variables === undefined ? ['GetSavedEvaluationQuestionTemplates'] : ['GetSavedEvaluationQuestionTemplates', variables],
      fetcher<GetSavedEvaluationQuestionTemplatesQuery, GetSavedEvaluationQuestionTemplatesQueryVariables>(GetSavedEvaluationQuestionTemplatesDocument, variables),
      options
    );

useGetSavedEvaluationQuestionTemplatesQuery.getKey = (variables?: GetSavedEvaluationQuestionTemplatesQueryVariables) => variables === undefined ? ['GetSavedEvaluationQuestionTemplates'] : ['GetSavedEvaluationQuestionTemplates', variables];
;

export const useInfiniteGetSavedEvaluationQuestionTemplatesQuery = <
      TData = GetSavedEvaluationQuestionTemplatesQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetSavedEvaluationQuestionTemplatesQueryVariables,
      variables?: GetSavedEvaluationQuestionTemplatesQueryVariables,
      options?: UseInfiniteQueryOptions<GetSavedEvaluationQuestionTemplatesQuery, TError, TData>
    ) =>
    useInfiniteQuery<GetSavedEvaluationQuestionTemplatesQuery, TError, TData>(
      variables === undefined ? ['GetSavedEvaluationQuestionTemplates.infinite'] : ['GetSavedEvaluationQuestionTemplates.infinite', variables],
      (metaData) => fetcher<GetSavedEvaluationQuestionTemplatesQuery, GetSavedEvaluationQuestionTemplatesQueryVariables>(GetSavedEvaluationQuestionTemplatesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteGetSavedEvaluationQuestionTemplatesQuery.getKey = (variables?: GetSavedEvaluationQuestionTemplatesQueryVariables) => variables === undefined ? ['GetSavedEvaluationQuestionTemplates.infinite'] : ['GetSavedEvaluationQuestionTemplates.infinite', variables];
;

useGetSavedEvaluationQuestionTemplatesQuery.fetcher = (variables?: GetSavedEvaluationQuestionTemplatesQueryVariables) => fetcher<GetSavedEvaluationQuestionTemplatesQuery, GetSavedEvaluationQuestionTemplatesQueryVariables>(GetSavedEvaluationQuestionTemplatesDocument, variables);
export const SendBulkProjectEvaluationRequestEmailsDocument = `
    mutation SendBulkProjectEvaluationRequestEmails($programId: ID!, $projectIds: [ID!]!) {
  sendBulkProjectEvaluationRequestEmails(
    programId: $programId
    projectIds: $projectIds
  )
}
    `;
export const useSendBulkProjectEvaluationRequestEmailsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendBulkProjectEvaluationRequestEmailsMutation, TError, SendBulkProjectEvaluationRequestEmailsMutationVariables, TContext>) =>
    useMutation<SendBulkProjectEvaluationRequestEmailsMutation, TError, SendBulkProjectEvaluationRequestEmailsMutationVariables, TContext>(
      ['SendBulkProjectEvaluationRequestEmails'],
      (variables?: SendBulkProjectEvaluationRequestEmailsMutationVariables) => fetcher<SendBulkProjectEvaluationRequestEmailsMutation, SendBulkProjectEvaluationRequestEmailsMutationVariables>(SendBulkProjectEvaluationRequestEmailsDocument, variables)(),
      options
    );
useSendBulkProjectEvaluationRequestEmailsMutation.fetcher = (variables: SendBulkProjectEvaluationRequestEmailsMutationVariables) => fetcher<SendBulkProjectEvaluationRequestEmailsMutation, SendBulkProjectEvaluationRequestEmailsMutationVariables>(SendBulkProjectEvaluationRequestEmailsDocument, variables);
export const IsProjectEvaluationEmailEnabledDocument = `
    query IsProjectEvaluationEmailEnabled($programId: ID!) {
  workAllocationProgram(programId: $programId) {
    attorneyFeedbackReminderEmailEnabled
  }
}
    `;
export const useIsProjectEvaluationEmailEnabledQuery = <
      TData = IsProjectEvaluationEmailEnabledQuery,
      TError = unknown
    >(
      variables: IsProjectEvaluationEmailEnabledQueryVariables,
      options?: UseQueryOptions<IsProjectEvaluationEmailEnabledQuery, TError, TData>
    ) =>
    useQuery<IsProjectEvaluationEmailEnabledQuery, TError, TData>(
      ['IsProjectEvaluationEmailEnabled', variables],
      fetcher<IsProjectEvaluationEmailEnabledQuery, IsProjectEvaluationEmailEnabledQueryVariables>(IsProjectEvaluationEmailEnabledDocument, variables),
      options
    );

useIsProjectEvaluationEmailEnabledQuery.getKey = (variables: IsProjectEvaluationEmailEnabledQueryVariables) => ['IsProjectEvaluationEmailEnabled', variables];
;

export const useInfiniteIsProjectEvaluationEmailEnabledQuery = <
      TData = IsProjectEvaluationEmailEnabledQuery,
      TError = unknown
    >(
      pageParamKey: keyof IsProjectEvaluationEmailEnabledQueryVariables,
      variables: IsProjectEvaluationEmailEnabledQueryVariables,
      options?: UseInfiniteQueryOptions<IsProjectEvaluationEmailEnabledQuery, TError, TData>
    ) =>
    useInfiniteQuery<IsProjectEvaluationEmailEnabledQuery, TError, TData>(
      ['IsProjectEvaluationEmailEnabled.infinite', variables],
      (metaData) => fetcher<IsProjectEvaluationEmailEnabledQuery, IsProjectEvaluationEmailEnabledQueryVariables>(IsProjectEvaluationEmailEnabledDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    );


useInfiniteIsProjectEvaluationEmailEnabledQuery.getKey = (variables: IsProjectEvaluationEmailEnabledQueryVariables) => ['IsProjectEvaluationEmailEnabled.infinite', variables];
;

useIsProjectEvaluationEmailEnabledQuery.fetcher = (variables: IsProjectEvaluationEmailEnabledQueryVariables) => fetcher<IsProjectEvaluationEmailEnabledQuery, IsProjectEvaluationEmailEnabledQueryVariables>(IsProjectEvaluationEmailEnabledDocument, variables);

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAgencyRegistrationStatusMutation(
 *   ({ query, variables }) => {
 *     const { agencyId, isUnregisteredAgency } = variables;
 *     return HttpResponse.json({
 *       data: { updateAgencyRegistrationStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateAgencyRegistrationStatusMutation = (resolver: GraphQLResponseResolver<UpdateAgencyRegistrationStatusMutation, UpdateAgencyRegistrationStatusMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateAgencyRegistrationStatusMutation, UpdateAgencyRegistrationStatusMutationVariables>(
    'UpdateAgencyRegistrationStatus',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFindAgencyByLoggedInUserEmailQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { findAgencyByLoggedInUserEmail }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFindAgencyByLoggedInUserEmailQuery = (resolver: GraphQLResponseResolver<FindAgencyByLoggedInUserEmailQuery, FindAgencyByLoggedInUserEmailQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FindAgencyByLoggedInUserEmailQuery, FindAgencyByLoggedInUserEmailQueryVariables>(
    'FindAgencyByLoggedInUserEmail',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSendPasswordResetEmailMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { sendPasswordResetEmail }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSendPasswordResetEmailMutation = (resolver: GraphQLResponseResolver<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables>(
    'SendPasswordResetEmail',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockResetUserPasswordMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { resetUserPassword }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockResetUserPasswordMutation = (resolver: GraphQLResponseResolver<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(
    'ResetUserPassword',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidatesToBeMergedQuery(
 *   ({ query, variables }) => {
 *     const { recruitIds } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidatesToBeMergedQuery = (resolver: GraphQLResponseResolver<CandidatesToBeMergedQuery, CandidatesToBeMergedQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidatesToBeMergedQuery, CandidatesToBeMergedQueryVariables>(
    'CandidatesToBeMerged',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMergeCandidatesMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { mergeCandidates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMergeCandidatesMutation = (resolver: GraphQLResponseResolver<MergeCandidatesMutation, MergeCandidatesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<MergeCandidatesMutation, MergeCandidatesMutationVariables>(
    'MergeCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobAppSourceOptionsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { fetchAppSourceOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobAppSourceOptionsQuery = (resolver: GraphQLResponseResolver<JobAppSourceOptionsQuery, JobAppSourceOptionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobAppSourceOptionsQuery, JobAppSourceOptionsQueryVariables>(
    'JobAppSourceOptions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockConflictingJobAppsOfCandidatesQuery(
 *   ({ query, variables }) => {
 *     const { recruitId1, recruitId2 } = variables;
 *     return HttpResponse.json({
 *       data: { conflictingJobAppsOfCandidates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockConflictingJobAppsOfCandidatesQuery = (resolver: GraphQLResponseResolver<ConflictingJobAppsOfCandidatesQuery, ConflictingJobAppsOfCandidatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ConflictingJobAppsOfCandidatesQuery, ConflictingJobAppsOfCandidatesQueryVariables>(
    'ConflictingJobAppsOfCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidateReviewContentForCandidateQuery(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateId, recruitId } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidateReviewContentForCandidate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidateReviewContentForCandidateQuery = (resolver: GraphQLResponseResolver<GetCandidateReviewContentForCandidateQuery, GetCandidateReviewContentForCandidateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidateReviewContentForCandidateQuery, GetCandidateReviewContentForCandidateQueryVariables>(
    'GetCandidateReviewContentForCandidate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIndividualCandidateReviewQuery(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateId } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidateReviewTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockIndividualCandidateReviewQuery = (resolver: GraphQLResponseResolver<IndividualCandidateReviewQuery, IndividualCandidateReviewQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<IndividualCandidateReviewQuery, IndividualCandidateReviewQueryVariables>(
    'IndividualCandidateReview',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateId } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidateReviewTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockIndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery = (resolver: GraphQLResponseResolver<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQuery, IndividualCandidateReviewIncludeCandidateJobsAndEventsAndProgramsQueryVariables>(
    'IndividualCandidateReviewIncludeCandidateJobsAndEventsAndPrograms',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateReviewVotingRecordsQuery(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateId } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidateReviewTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateReviewVotingRecordsQuery = (resolver: GraphQLResponseResolver<CandidateReviewVotingRecordsQuery, CandidateReviewVotingRecordsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateReviewVotingRecordsQuery, CandidateReviewVotingRecordsQueryVariables>(
    'CandidateReviewVotingRecords',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateReviewVotingRecordsOfIndividualRecruitQuery(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateId, recruitId } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidateReviewTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateReviewVotingRecordsOfIndividualRecruitQuery = (resolver: GraphQLResponseResolver<CandidateReviewVotingRecordsOfIndividualRecruitQuery, CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateReviewVotingRecordsOfIndividualRecruitQuery, CandidateReviewVotingRecordsOfIndividualRecruitQueryVariables>(
    'CandidateReviewVotingRecordsOfIndividualRecruit',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateReviewTemplatesForOrgQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getCandidateReviewTemplatesForOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateReviewTemplatesForOrgQuery = (resolver: GraphQLResponseResolver<CandidateReviewTemplatesForOrgQuery, CandidateReviewTemplatesForOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateReviewTemplatesForOrgQuery, CandidateReviewTemplatesForOrgQueryVariables>(
    'CandidateReviewTemplatesForOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateReviewTemplateOverviewsForOrgQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getCandidateReviewTemplatesForOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateReviewTemplateOverviewsForOrgQuery = (resolver: GraphQLResponseResolver<CandidateReviewTemplateOverviewsForOrgQuery, CandidateReviewTemplateOverviewsForOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateReviewTemplateOverviewsForOrgQuery, CandidateReviewTemplateOverviewsForOrgQueryVariables>(
    'CandidateReviewTemplateOverviewsForOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateReviewProgramAssociatesQuery(
 *   ({ query, variables }) => {
 *     const { programId, associateRecruitIds } = variables;
 *     return HttpResponse.json({
 *       data: { programAssociatesByRecruitIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateReviewProgramAssociatesQuery = (resolver: GraphQLResponseResolver<CandidateReviewProgramAssociatesQuery, CandidateReviewProgramAssociatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateReviewProgramAssociatesQuery, CandidateReviewProgramAssociatesQueryVariables>(
    'CandidateReviewProgramAssociates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateMutation, UpsertCandidateReviewTemplateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateMutation, UpsertCandidateReviewTemplateMutationVariables>(
    'UpsertCandidateReviewTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateCandidatesMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateCandidatesInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplateCandidates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateCandidatesMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateCandidatesMutation, UpsertCandidateReviewTemplateCandidatesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateCandidatesMutation, UpsertCandidateReviewTemplateCandidatesMutationVariables>(
    'UpsertCandidateReviewTemplateCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateEventsMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateEventsInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplateEvents }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateEventsMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateEventsMutation, UpsertCandidateReviewTemplateEventsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateEventsMutation, UpsertCandidateReviewTemplateEventsMutationVariables>(
    'UpsertCandidateReviewTemplateEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateJobsMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateJobsInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplateJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateJobsMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateJobsMutation, UpsertCandidateReviewTemplateJobsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateJobsMutation, UpsertCandidateReviewTemplateJobsMutationVariables>(
    'UpsertCandidateReviewTemplateJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateJobsWithEventsMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateJobsWithEventsInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplateJobsWithEvents }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateJobsWithEventsMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateJobsWithEventsMutation, UpsertCandidateReviewTemplateJobsWithEventsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateJobsWithEventsMutation, UpsertCandidateReviewTemplateJobsWithEventsMutationVariables>(
    'UpsertCandidateReviewTemplateJobsWithEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateProgramsMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateProgramsInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplatePrograms }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateProgramsMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateProgramsMutation, UpsertCandidateReviewTemplateProgramsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateProgramsMutation, UpsertCandidateReviewTemplateProgramsMutationVariables>(
    'UpsertCandidateReviewTemplatePrograms',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateSectionsMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateId, documentSectionInput, evaluationSectionInput, additionalInformationSectionInput, interviewScheduleSectionInput, jobAppSectionInput, projectDocumentsSectionInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplateSections }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateSectionsMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateSectionsMutation, UpsertCandidateReviewTemplateSectionsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateSectionsMutation, UpsertCandidateReviewTemplateSectionsMutationVariables>(
    'UpsertCandidateReviewTemplateSections',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCandidateReviewTemplateMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewTemplateId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCandidateReviewTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteCandidateReviewTemplateMutation = (resolver: GraphQLResponseResolver<DeleteCandidateReviewTemplateMutation, DeleteCandidateReviewTemplateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteCandidateReviewTemplateMutation, DeleteCandidateReviewTemplateMutationVariables>(
    'DeleteCandidateReviewTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewTemplateCandidateVotingRecordMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewCandidateVotingInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewTemplateCandidateVotingRecord }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewTemplateCandidateVotingRecordMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewTemplateCandidateVotingRecordMutation, UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewTemplateCandidateVotingRecordMutation, UpsertCandidateReviewTemplateCandidateVotingRecordMutationVariables>(
    'UpsertCandidateReviewTemplateCandidateVotingRecord',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewVotingRecordCastedVotedMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewVotingRecordCastedVotedInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewVotingRecordCastedVoted }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewVotingRecordCastedVotedMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewVotingRecordCastedVotedMutation, UpsertCandidateReviewVotingRecordCastedVotedMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewVotingRecordCastedVotedMutation, UpsertCandidateReviewVotingRecordCastedVotedMutationVariables>(
    'UpsertCandidateReviewVotingRecordCastedVoted',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCandidateReviewVotingRecordCommentMutation(
 *   ({ query, variables }) => {
 *     const { candidateReviewVotingRecordCommentInput } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCandidateReviewVotingRecordComment }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCandidateReviewVotingRecordCommentMutation = (resolver: GraphQLResponseResolver<UpsertCandidateReviewVotingRecordCommentMutation, UpsertCandidateReviewVotingRecordCommentMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCandidateReviewVotingRecordCommentMutation, UpsertCandidateReviewVotingRecordCommentMutationVariables>(
    'UpsertCandidateReviewVotingRecordComment',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventEvaluationQuestionsByEventIdQuery(
 *   ({ query, variables }) => {
 *     const { eventIds } = variables;
 *     return HttpResponse.json({
 *       data: { eventEvaluationQuestionsByEventIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventEvaluationQuestionsByEventIdQuery = (resolver: GraphQLResponseResolver<EventEvaluationQuestionsByEventIdQuery, EventEvaluationQuestionsByEventIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventEvaluationQuestionsByEventIdQuery, EventEvaluationQuestionsByEventIdQueryVariables>(
    'EventEvaluationQuestionsByEventId',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllLanguagesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allLanguages }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllLanguagesQuery = (resolver: GraphQLResponseResolver<AllLanguagesQuery, AllLanguagesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllLanguagesQuery, AllLanguagesQueryVariables>(
    'AllLanguages',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrackActivateForwardAccountFromEventMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { trackActivateForwardAccountFromEvent }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrackActivateForwardAccountFromEventMutation = (resolver: GraphQLResponseResolver<TrackActivateForwardAccountFromEventMutation, TrackActivateForwardAccountFromEventMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<TrackActivateForwardAccountFromEventMutation, TrackActivateForwardAccountFromEventMutationVariables>(
    'TrackActivateForwardAccountFromEvent',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardEventDetailPageQuery(
 *   ({ query, variables }) => {
 *     const { eventId, numChars } = variables;
 *     return HttpResponse.json({
 *       data: { forwardCandidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardEventDetailPageQuery = (resolver: GraphQLResponseResolver<ForwardEventDetailPageQuery, ForwardEventDetailPageQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardEventDetailPageQuery, ForwardEventDetailPageQueryVariables>(
    'ForwardEventDetailPage',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventDirectoryQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { eventDirectory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventDirectoryQuery = (resolver: GraphQLResponseResolver<EventDirectoryQuery, EventDirectoryQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventDirectoryQuery, EventDirectoryQueryVariables>(
    'EventDirectory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventDirectoryAvailableCountQuery(
 *   ({ query, variables }) => {
 *     const { filterBy } = variables;
 *     return HttpResponse.json({
 *       data: { eventDirectory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventDirectoryAvailableCountQuery = (resolver: GraphQLResponseResolver<EventDirectoryAvailableCountQuery, EventDirectoryAvailableCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventDirectoryAvailableCountQuery, EventDirectoryAvailableCountQueryVariables>(
    'EventDirectoryAvailableCount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationModalDemographicInfoQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationModalDemographicInfoQuery = (resolver: GraphQLResponseResolver<EventRegistrationModalDemographicInfoQuery, EventRegistrationModalDemographicInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventRegistrationModalDemographicInfoQuery, EventRegistrationModalDemographicInfoQueryVariables>(
    'EventRegistrationModalDemographicInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationSubmitDemographicInfoMutation(
 *   ({ query, variables }) => {
 *     const { input, shouldCompleteRegistration, finishRegistrationInput } = variables;
 *     return HttpResponse.json({
 *       data: { submitDemographicAnswersForOutreachEventCandidateRegistration, completeOutreachEventCandidateRegistration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationSubmitDemographicInfoMutation = (resolver: GraphQLResponseResolver<EventRegistrationSubmitDemographicInfoMutation, EventRegistrationSubmitDemographicInfoMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EventRegistrationSubmitDemographicInfoMutation, EventRegistrationSubmitDemographicInfoMutationVariables>(
    'EventRegistrationSubmitDemographicInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationModalDocumentSubmissionQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationModalDocumentSubmissionQuery = (resolver: GraphQLResponseResolver<EventRegistrationModalDocumentSubmissionQuery, EventRegistrationModalDocumentSubmissionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventRegistrationModalDocumentSubmissionQuery, EventRegistrationModalDocumentSubmissionQueryVariables>(
    'EventRegistrationModalDocumentSubmission',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationSubmitDocumentsMutation(
 *   ({ query, variables }) => {
 *     const { input, shouldCompleteRegistration, finishRegistrationInput } = variables;
 *     return HttpResponse.json({
 *       data: { submitDocumentsForEmployerEvent, completeOutreachEventCandidateRegistration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationSubmitDocumentsMutation = (resolver: GraphQLResponseResolver<EventRegistrationSubmitDocumentsMutation, EventRegistrationSubmitDocumentsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EventRegistrationSubmitDocumentsMutation, EventRegistrationSubmitDocumentsMutationVariables>(
    'EventRegistrationSubmitDocuments',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationModalQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { forwardAccount, candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationModalQuery = (resolver: GraphQLResponseResolver<EventRegistrationModalQuery, EventRegistrationModalQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventRegistrationModalQuery, EventRegistrationModalQueryVariables>(
    'EventRegistrationModal',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrackForwardEventStartRegistrationMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { trackForwardEventStartRegistration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrackForwardEventStartRegistrationMutation = (resolver: GraphQLResponseResolver<TrackForwardEventStartRegistrationMutation, TrackForwardEventStartRegistrationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<TrackForwardEventStartRegistrationMutation, TrackForwardEventStartRegistrationMutationVariables>(
    'TrackForwardEventStartRegistration',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrackForwardEventCompleteRegistrationMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { trackForwardEventCompleteRegistration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrackForwardEventCompleteRegistrationMutation = (resolver: GraphQLResponseResolver<TrackForwardEventCompleteRegistrationMutation, TrackForwardEventCompleteRegistrationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<TrackForwardEventCompleteRegistrationMutation, TrackForwardEventCompleteRegistrationMutationVariables>(
    'TrackForwardEventCompleteRegistration',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationModalPersonalInfoQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { forwardAccount, candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationModalPersonalInfoQuery = (resolver: GraphQLResponseResolver<EventRegistrationModalPersonalInfoQuery, EventRegistrationModalPersonalInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventRegistrationModalPersonalInfoQuery, EventRegistrationModalPersonalInfoQueryVariables>(
    'EventRegistrationModalPersonalInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationSubmitPersonalInfoMutation(
 *   ({ query, variables }) => {
 *     const { input, shouldCompleteRegistration, finishRegistrationInput } = variables;
 *     return HttpResponse.json({
 *       data: { submitPersonalInfoForOutreachEventCandidateRegistration, completeOutreachEventCandidateRegistration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationSubmitPersonalInfoMutation = (resolver: GraphQLResponseResolver<EventRegistrationSubmitPersonalInfoMutation, EventRegistrationSubmitPersonalInfoMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EventRegistrationSubmitPersonalInfoMutation, EventRegistrationSubmitPersonalInfoMutationVariables>(
    'EventRegistrationSubmitPersonalInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationModalQualifyingQuestionsQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationModalQualifyingQuestionsQuery = (resolver: GraphQLResponseResolver<EventRegistrationModalQualifyingQuestionsQuery, EventRegistrationModalQualifyingQuestionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventRegistrationModalQualifyingQuestionsQuery, EventRegistrationModalQualifyingQuestionsQueryVariables>(
    'EventRegistrationModalQualifyingQuestions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationSubmitQualifyingQuestionAnswersMutation(
 *   ({ query, variables }) => {
 *     const { input, shouldCompleteRegistration, finishRegistrationInput } = variables;
 *     return HttpResponse.json({
 *       data: { submitQualifyingQuestionAnswersForOutreachEventCandidateRegistration, completeOutreachEventCandidateRegistration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationSubmitQualifyingQuestionAnswersMutation = (resolver: GraphQLResponseResolver<EventRegistrationSubmitQualifyingQuestionAnswersMutation, EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EventRegistrationSubmitQualifyingQuestionAnswersMutation, EventRegistrationSubmitQualifyingQuestionAnswersMutationVariables>(
    'EventRegistrationSubmitQualifyingQuestionAnswers',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationModalVirtualChatSchedulerQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationModalVirtualChatSchedulerQuery = (resolver: GraphQLResponseResolver<EventRegistrationModalVirtualChatSchedulerQuery, EventRegistrationModalVirtualChatSchedulerQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventRegistrationModalVirtualChatSchedulerQuery, EventRegistrationModalVirtualChatSchedulerQueryVariables>(
    'EventRegistrationModalVirtualChatScheduler',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationSubmitVirtualChatTimeslotSelectionsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitVirtualChatRecruitTimeslotSelections }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationSubmitVirtualChatTimeslotSelectionsMutation = (resolver: GraphQLResponseResolver<EventRegistrationSubmitVirtualChatTimeslotSelectionsMutation, EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EventRegistrationSubmitVirtualChatTimeslotSelectionsMutation, EventRegistrationSubmitVirtualChatTimeslotSelectionsMutationVariables>(
    'EventRegistrationSubmitVirtualChatTimeslotSelections',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationModalSubmitHeadshotQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { forwardAccount, candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationModalSubmitHeadshotQuery = (resolver: GraphQLResponseResolver<EventRegistrationModalSubmitHeadshotQuery, EventRegistrationModalSubmitHeadshotQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EventRegistrationModalSubmitHeadshotQuery, EventRegistrationModalSubmitHeadshotQueryVariables>(
    'EventRegistrationModalSubmitHeadshot',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEventRegistrationSubmitHeadshotMutation(
 *   ({ query, variables }) => {
 *     const { input, shouldCompleteRegistration, finishRegistrationInput } = variables;
 *     return HttpResponse.json({
 *       data: { submitHeadshotForOutreachEventCandidateRegistration, completeOutreachEventCandidateRegistration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEventRegistrationSubmitHeadshotMutation = (resolver: GraphQLResponseResolver<EventRegistrationSubmitHeadshotMutation, EventRegistrationSubmitHeadshotMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EventRegistrationSubmitHeadshotMutation, EventRegistrationSubmitHeadshotMutationVariables>(
    'EventRegistrationSubmitHeadshot',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardAccountQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardAccountQuery = (resolver: GraphQLResponseResolver<ForwardAccountQuery, ForwardAccountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardAccountQuery, ForwardAccountQueryVariables>(
    'ForwardAccount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSendAddEmailToForwardAccountLinkMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { sendAddEmailToForwardAccountLink }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSendAddEmailToForwardAccountLinkMutation = (resolver: GraphQLResponseResolver<SendAddEmailToForwardAccountLinkMutation, SendAddEmailToForwardAccountLinkMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SendAddEmailToForwardAccountLinkMutation, SendAddEmailToForwardAccountLinkMutationVariables>(
    'SendAddEmailToForwardAccountLink',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveEmailFromForwardAccountMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { removeEmailFromForwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveEmailFromForwardAccountMutation = (resolver: GraphQLResponseResolver<RemoveEmailFromForwardAccountMutation, RemoveEmailFromForwardAccountMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveEmailFromForwardAccountMutation, RemoveEmailFromForwardAccountMutationVariables>(
    'RemoveEmailFromForwardAccount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIncrementTimesViewedForwardEventsInterviewsFeedMutation(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { incrementTimesViewedForwardEventsInterviewsFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockIncrementTimesViewedForwardEventsInterviewsFeedMutation = (resolver: GraphQLResponseResolver<IncrementTimesViewedForwardEventsInterviewsFeedMutation, IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<IncrementTimesViewedForwardEventsInterviewsFeedMutation, IncrementTimesViewedForwardEventsInterviewsFeedMutationVariables>(
    'IncrementTimesViewedForwardEventsInterviewsFeed',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEditForwardProfileMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { editForwardProfile }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEditForwardProfileMutation = (resolver: GraphQLResponseResolver<EditForwardProfileMutation, EditForwardProfileMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EditForwardProfileMutation, EditForwardProfileMutationVariables>(
    'EditForwardProfile',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardDashboardRecentJobApplicationsQuery(
 *   ({ query, variables }) => {
 *     const { first, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobApplicationFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardDashboardRecentJobApplicationsQuery = (resolver: GraphQLResponseResolver<ForwardDashboardRecentJobApplicationsQuery, ForwardDashboardRecentJobApplicationsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardDashboardRecentJobApplicationsQuery, ForwardDashboardRecentJobApplicationsQueryVariables>(
    'ForwardDashboardRecentJobApplications',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardEventsInterviewsFeedQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardEventsInterviewsFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardEventsInterviewsFeedQuery = (resolver: GraphQLResponseResolver<ForwardEventsInterviewsFeedQuery, ForwardEventsInterviewsFeedQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardEventsInterviewsFeedQuery, ForwardEventsInterviewsFeedQueryVariables>(
    'ForwardEventsInterviewsFeed',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFirmEventCardRegistrationButtonFieldsByEventIdQuery(
 *   ({ query, variables }) => {
 *     const { eventId, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { candidateEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFirmEventCardRegistrationButtonFieldsByEventIdQuery = (resolver: GraphQLResponseResolver<FirmEventCardRegistrationButtonFieldsByEventIdQuery, FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FirmEventCardRegistrationButtonFieldsByEventIdQuery, FirmEventCardRegistrationButtonFieldsByEventIdQueryVariables>(
    'FirmEventCardRegistrationButtonFieldsByEventId',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockManageForwardEventPublishingSettingsQuery(
 *   ({ query, variables }) => {
 *     const { eventId } = variables;
 *     return HttpResponse.json({
 *       data: { eventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockManageForwardEventPublishingSettingsQuery = (resolver: GraphQLResponseResolver<ManageForwardEventPublishingSettingsQuery, ManageForwardEventPublishingSettingsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ManageForwardEventPublishingSettingsQuery, ManageForwardEventPublishingSettingsQueryVariables>(
    'ManageForwardEventPublishingSettings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOrgForwardPrivilegesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrgEmployerMember }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetOrgForwardPrivilegesQuery = (resolver: GraphQLResponseResolver<GetOrgForwardPrivilegesQuery, GetOrgForwardPrivilegesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetOrgForwardPrivilegesQuery, GetOrgForwardPrivilegesQueryVariables>(
    'GetOrgForwardPrivileges',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitForwardEventPublishingSettingsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitForwardEventPublishingSettings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitForwardEventPublishingSettingsMutation = (resolver: GraphQLResponseResolver<SubmitForwardEventPublishingSettingsMutation, SubmitForwardEventPublishingSettingsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitForwardEventPublishingSettingsMutation, SubmitForwardEventPublishingSettingsMutationVariables>(
    'SubmitForwardEventPublishingSettings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitEventSchoolTargetingMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitEventSchoolTargeting }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitEventSchoolTargetingMutation = (resolver: GraphQLResponseResolver<SubmitEventSchoolTargetingMutation, SubmitEventSchoolTargetingMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitEventSchoolTargetingMutation, SubmitEventSchoolTargetingMutationVariables>(
    'SubmitEventSchoolTargeting',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFirmDirectoryQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, sortBy, numChars } = variables;
 *     return HttpResponse.json({
 *       data: { firmDirectory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFirmDirectoryQuery = (resolver: GraphQLResponseResolver<FirmDirectoryQuery, FirmDirectoryQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FirmDirectoryQuery, FirmDirectoryQueryVariables>(
    'FirmDirectory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSummerProgramStatsQuery(
 *   ({ query, variables }) => {
 *     const { firmFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmFriendlyName }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSummerProgramStatsQuery = (resolver: GraphQLResponseResolver<SummerProgramStatsQuery, SummerProgramStatsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SummerProgramStatsQuery, SummerProgramStatsQueryVariables>(
    'SummerProgramStats',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDiversityAndInclusionStatsQuery(
 *   ({ query, variables }) => {
 *     const { firmFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmFriendlyName }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDiversityAndInclusionStatsQuery = (resolver: GraphQLResponseResolver<DiversityAndInclusionStatsQuery, DiversityAndInclusionStatsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<DiversityAndInclusionStatsQuery, DiversityAndInclusionStatsQueryVariables>(
    'DiversityAndInclusionStats',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPracticeAreaStatsQuery(
 *   ({ query, variables }) => {
 *     const { firmFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmFriendlyName }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPracticeAreaStatsQuery = (resolver: GraphQLResponseResolver<PracticeAreaStatsQuery, PracticeAreaStatsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PracticeAreaStatsQuery, PracticeAreaStatsQueryVariables>(
    'PracticeAreaStats',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProBonoStatsQuery(
 *   ({ query, variables }) => {
 *     const { firmFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmFriendlyName }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProBonoStatsQuery = (resolver: GraphQLResponseResolver<ProBonoStatsQuery, ProBonoStatsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProBonoStatsQuery, ProBonoStatsQueryVariables>(
    'ProBonoStats',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFirmProfileEventCarouselQuery(
 *   ({ query, variables }) => {
 *     const { orgId, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFirmProfileEventCarouselQuery = (resolver: GraphQLResponseResolver<FirmProfileEventCarouselQuery, FirmProfileEventCarouselQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FirmProfileEventCarouselQuery, FirmProfileEventCarouselQueryVariables>(
    'FirmProfileEventCarousel',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFirmProfileJobCarouselQuery(
 *   ({ query, variables }) => {
 *     const { firmFriendlyName, first, after, descriptionTextContentNumChars } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgFriendlyName }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFirmProfileJobCarouselQuery = (resolver: GraphQLResponseResolver<FirmProfileJobCarouselQuery, FirmProfileJobCarouselQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FirmProfileJobCarouselQuery, FirmProfileJobCarouselQueryVariables>(
    'FirmProfileJobCarousel',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFirmProfileByFirmFriendlyNameQuery(
 *   ({ query, variables }) => {
 *     const { firmFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmFriendlyName }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFirmProfileByFirmFriendlyNameQuery = (resolver: GraphQLResponseResolver<FirmProfileByFirmFriendlyNameQuery, FirmProfileByFirmFriendlyNameQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FirmProfileByFirmFriendlyNameQuery, FirmProfileByFirmFriendlyNameQueryVariables>(
    'FirmProfileByFirmFriendlyName',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardLoginGuardQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { whoAmI }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardLoginGuardQuery = (resolver: GraphQLResponseResolver<ForwardLoginGuardQuery, ForwardLoginGuardQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardLoginGuardQuery, ForwardLoginGuardQueryVariables>(
    'ForwardLoginGuard',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFirmCardQuery(
 *   ({ query, variables }) => {
 *     const { first, filterBy, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { firmDirectory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFirmCardQuery = (resolver: GraphQLResponseResolver<FirmCardQuery, FirmCardQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FirmCardQuery, FirmCardQueryVariables>(
    'FirmCard',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardJobApplicationFeedQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobApplicationFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardJobApplicationFeedQuery = (resolver: GraphQLResponseResolver<ForwardJobApplicationFeedQuery, ForwardJobApplicationFeedQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardJobApplicationFeedQuery, ForwardJobApplicationFeedQueryVariables>(
    'ForwardJobApplicationFeed',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardJobApplicationTotalCountQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardJobApplicationFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardJobApplicationTotalCountQuery = (resolver: GraphQLResponseResolver<ForwardJobApplicationTotalCountQuery, ForwardJobApplicationTotalCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardJobApplicationTotalCountQuery, ForwardJobApplicationTotalCountQueryVariables>(
    'ForwardJobApplicationTotalCount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobBoardLoadTestFullQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, orderBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobBoardLoadTestFullQuery = (resolver: GraphQLResponseResolver<JobBoardLoadTestFullQuery, JobBoardLoadTestFullQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobBoardLoadTestFullQuery, JobBoardLoadTestFullQueryVariables>(
    'JobBoardLoadTestFull',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobBoardLoadTestJobsOnlyNoDocumentsQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, orderBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobBoardLoadTestJobsOnlyNoDocumentsQuery = (resolver: GraphQLResponseResolver<JobBoardLoadTestJobsOnlyNoDocumentsQuery, JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobBoardLoadTestJobsOnlyNoDocumentsQuery, JobBoardLoadTestJobsOnlyNoDocumentsQueryVariables>(
    'JobBoardLoadTestJobsOnlyNoDocuments',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobBoardLoadTestCountQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, orderBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobBoardLoadTestCountQuery = (resolver: GraphQLResponseResolver<JobBoardLoadTestCountQuery, JobBoardLoadTestCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobBoardLoadTestCountQuery, JobBoardLoadTestCountQueryVariables>(
    'JobBoardLoadTestCount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobBoardLoadTestByIdQuery(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobBoardLoadTestByIdQuery = (resolver: GraphQLResponseResolver<JobBoardLoadTestByIdQuery, JobBoardLoadTestByIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobBoardLoadTestByIdQuery, JobBoardLoadTestByIdQueryVariables>(
    'JobBoardLoadTestById',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobBoardLoadTestWithoutDescriptionOrCountQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, orderBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobBoardLoadTestWithoutDescriptionOrCountQuery = (resolver: GraphQLResponseResolver<JobBoardLoadTestWithoutDescriptionOrCountQuery, JobBoardLoadTestWithoutDescriptionOrCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobBoardLoadTestWithoutDescriptionOrCountQuery, JobBoardLoadTestWithoutDescriptionOrCountQueryVariables>(
    'JobBoardLoadTestWithoutDescriptionOrCount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobBoardLoadTestWithoutCountQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, orderBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobBoardLoadTestWithoutCountQuery = (resolver: GraphQLResponseResolver<JobBoardLoadTestWithoutCountQuery, JobBoardLoadTestWithoutCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobBoardLoadTestWithoutCountQuery, JobBoardLoadTestWithoutCountQueryVariables>(
    'JobBoardLoadTestWithoutCount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardFiltersQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allOfficeLocations, allPracticeCategories }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardFiltersQuery = (resolver: GraphQLResponseResolver<ForwardFiltersQuery, ForwardFiltersQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardFiltersQuery, ForwardFiltersQueryVariables>(
    'ForwardFilters',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardJobPreferencesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardJobPreferencesQuery = (resolver: GraphQLResponseResolver<ForwardJobPreferencesQuery, ForwardJobPreferencesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardJobPreferencesQuery, ForwardJobPreferencesQueryVariables>(
    'ForwardJobPreferences',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitForwardJobPreferencesMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitForwardJobPreferences }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitForwardJobPreferencesMutation = (resolver: GraphQLResponseResolver<SubmitForwardJobPreferencesMutation, SubmitForwardJobPreferencesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitForwardJobPreferencesMutation, SubmitForwardJobPreferencesMutationVariables>(
    'SubmitForwardJobPreferences',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockConfirmAppliedToExternalJobMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { confirmAppliedToExternalJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockConfirmAppliedToExternalJobMutation = (resolver: GraphQLResponseResolver<ConfirmAppliedToExternalJobMutation, ConfirmAppliedToExternalJobMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ConfirmAppliedToExternalJobMutation, ConfirmAppliedToExternalJobMutationVariables>(
    'ConfirmAppliedToExternalJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrackGoToExternalJobPageMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { trackGoToExternalJobPage }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrackGoToExternalJobPageMutation = (resolver: GraphQLResponseResolver<TrackGoToExternalJobPageMutation, TrackGoToExternalJobPageMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<TrackGoToExternalJobPageMutation, TrackGoToExternalJobPageMutationVariables>(
    'TrackGoToExternalJobPage',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrackApplyToExternalJobMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { trackApplyToExternalJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrackApplyToExternalJobMutation = (resolver: GraphQLResponseResolver<TrackApplyToExternalJobMutation, TrackApplyToExternalJobMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<TrackApplyToExternalJobMutation, TrackApplyToExternalJobMutationVariables>(
    'TrackApplyToExternalJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTrackQuickApplyToJobMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { trackQuickApplyToJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTrackQuickApplyToJobMutation = (resolver: GraphQLResponseResolver<TrackQuickApplyToJobMutation, TrackQuickApplyToJobMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<TrackQuickApplyToJobMutation, TrackQuickApplyToJobMutationVariables>(
    'TrackQuickApplyToJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardAppliedJobIdsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAppliedJobIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardAppliedJobIdsQuery = (resolver: GraphQLResponseResolver<ForwardAppliedJobIdsQuery, ForwardAppliedJobIdsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardAppliedJobIdsQuery, ForwardAppliedJobIdsQueryVariables>(
    'ForwardAppliedJobIds',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardJobBoardFeedQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, sortBy, descriptionTextContentNumChars } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardJobBoardFeedQuery = (resolver: GraphQLResponseResolver<ForwardJobBoardFeedQuery, ForwardJobBoardFeedQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardJobBoardFeedQuery, ForwardJobBoardFeedQueryVariables>(
    'ForwardJobBoardFeed',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardAvailableJobsCountQuery(
 *   ({ query, variables }) => {
 *     const { filterBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardAvailableJobsCountQuery = (resolver: GraphQLResponseResolver<ForwardAvailableJobsCountQuery, ForwardAvailableJobsCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardAvailableJobsCountQuery, ForwardAvailableJobsCountQueryVariables>(
    'ForwardAvailableJobsCount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardJobDetailsQuery(
 *   ({ query, variables }) => {
 *     const { jobId, numChars, descriptionTextContentNumChars } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardJobDetailsQuery = (resolver: GraphQLResponseResolver<ForwardJobDetailsQuery, ForwardJobDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardJobDetailsQuery, ForwardJobDetailsQueryVariables>(
    'ForwardJobDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateNavBarQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateNavBarQuery = (resolver: GraphQLResponseResolver<CandidateNavBarQuery, CandidateNavBarQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateNavBarQuery, CandidateNavBarQueryVariables>(
    'CandidateNavBar',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyForwardEducationHistoryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyForwardEducationHistoryQuery = (resolver: GraphQLResponseResolver<MyForwardEducationHistoryQuery, MyForwardEducationHistoryQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyForwardEducationHistoryQuery, MyForwardEducationHistoryQueryVariables>(
    'MyForwardEducationHistory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyForwardEducationHistoryDropdownDataQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allSchools, allSchoolDegrees }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyForwardEducationHistoryDropdownDataQuery = (resolver: GraphQLResponseResolver<MyForwardEducationHistoryDropdownDataQuery, MyForwardEducationHistoryDropdownDataQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyForwardEducationHistoryDropdownDataQuery, MyForwardEducationHistoryDropdownDataQueryVariables>(
    'MyForwardEducationHistoryDropdownData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitEntryOfMyForwardEducationHistoryMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitCandidateEducationHistoryEntry }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitEntryOfMyForwardEducationHistoryMutation = (resolver: GraphQLResponseResolver<SubmitEntryOfMyForwardEducationHistoryMutation, SubmitEntryOfMyForwardEducationHistoryMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitEntryOfMyForwardEducationHistoryMutation, SubmitEntryOfMyForwardEducationHistoryMutationVariables>(
    'SubmitEntryOfMyForwardEducationHistory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveEntryFromMyForwardEducationHistoryMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { removeCandidateEducationHistoryEntry }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveEntryFromMyForwardEducationHistoryMutation = (resolver: GraphQLResponseResolver<RemoveEntryFromMyForwardEducationHistoryMutation, RemoveEntryFromMyForwardEducationHistoryMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveEntryFromMyForwardEducationHistoryMutation, RemoveEntryFromMyForwardEducationHistoryMutationVariables>(
    'RemoveEntryFromMyForwardEducationHistory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardProfileAboutBioQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardProfileAboutBioQuery = (resolver: GraphQLResponseResolver<ForwardProfileAboutBioQuery, ForwardProfileAboutBioQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardProfileAboutBioQuery, ForwardProfileAboutBioQueryVariables>(
    'ForwardProfileAboutBio',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEditForwardProfileAboutBioMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { editForwardProfileAboutBio }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEditForwardProfileAboutBioMutation = (resolver: GraphQLResponseResolver<EditForwardProfileAboutBioMutation, EditForwardProfileAboutBioMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EditForwardProfileAboutBioMutation, EditForwardProfileAboutBioMutationVariables>(
    'EditForwardProfileAboutBio',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyForwardWorkHistoryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyForwardWorkHistoryQuery = (resolver: GraphQLResponseResolver<MyForwardWorkHistoryQuery, MyForwardWorkHistoryQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyForwardWorkHistoryQuery, MyForwardWorkHistoryQueryVariables>(
    'MyForwardWorkHistory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitEntryOfMyForwardWorkHistoryMutation(
 *   ({ query, variables }) => {
 *     const { submitInput } = variables;
 *     return HttpResponse.json({
 *       data: { submitCandidateWorkHistoryEntry }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitEntryOfMyForwardWorkHistoryMutation = (resolver: GraphQLResponseResolver<SubmitEntryOfMyForwardWorkHistoryMutation, SubmitEntryOfMyForwardWorkHistoryMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitEntryOfMyForwardWorkHistoryMutation, SubmitEntryOfMyForwardWorkHistoryMutationVariables>(
    'SubmitEntryOfMyForwardWorkHistory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveEntryFromMyForwardWorkHistoryMutation(
 *   ({ query, variables }) => {
 *     const { removeInput } = variables;
 *     return HttpResponse.json({
 *       data: { removeCandidateWorkHistoryEntry }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveEntryFromMyForwardWorkHistoryMutation = (resolver: GraphQLResponseResolver<RemoveEntryFromMyForwardWorkHistoryMutation, RemoveEntryFromMyForwardWorkHistoryMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveEntryFromMyForwardWorkHistoryMutation, RemoveEntryFromMyForwardWorkHistoryMutationVariables>(
    'RemoveEntryFromMyForwardWorkHistory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMyForwardWorkHistoryDropdownDataQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allPracticeAreas, allOfficeLocations, workplaces }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMyForwardWorkHistoryDropdownDataQuery = (resolver: GraphQLResponseResolver<MyForwardWorkHistoryDropdownDataQuery, MyForwardWorkHistoryDropdownDataQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MyForwardWorkHistoryDropdownDataQuery, MyForwardWorkHistoryDropdownDataQueryVariables>(
    'MyForwardWorkHistoryDropdownData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardSettingsPersonalInfoQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardSettingsPersonalInfoQuery = (resolver: GraphQLResponseResolver<ForwardSettingsPersonalInfoQuery, ForwardSettingsPersonalInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardSettingsPersonalInfoQuery, ForwardSettingsPersonalInfoQueryVariables>(
    'ForwardSettingsPersonalInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEditForwardSettingsPersonalInfoMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitForwardDemographicInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEditForwardSettingsPersonalInfoMutation = (resolver: GraphQLResponseResolver<EditForwardSettingsPersonalInfoMutation, EditForwardSettingsPersonalInfoMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EditForwardSettingsPersonalInfoMutation, EditForwardSettingsPersonalInfoMutationVariables>(
    'EditForwardSettingsPersonalInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardSettingsOfficeLocationPreferencesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardSettingsOfficeLocationPreferencesQuery = (resolver: GraphQLResponseResolver<ForwardSettingsOfficeLocationPreferencesQuery, ForwardSettingsOfficeLocationPreferencesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardSettingsOfficeLocationPreferencesQuery, ForwardSettingsOfficeLocationPreferencesQueryVariables>(
    'ForwardSettingsOfficeLocationPreferences',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockForwardSettingsPracticeCategoryPreferencesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { forwardAccount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockForwardSettingsPracticeCategoryPreferencesQuery = (resolver: GraphQLResponseResolver<ForwardSettingsPracticeCategoryPreferencesQuery, ForwardSettingsPracticeCategoryPreferencesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ForwardSettingsPracticeCategoryPreferencesQuery, ForwardSettingsPracticeCategoryPreferencesQueryVariables>(
    'ForwardSettingsPracticeCategoryPreferences',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEditForwardSettingsOfficeLocationPreferencesMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitForwardOfficeLocationPreferences }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEditForwardSettingsOfficeLocationPreferencesMutation = (resolver: GraphQLResponseResolver<EditForwardSettingsOfficeLocationPreferencesMutation, EditForwardSettingsOfficeLocationPreferencesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EditForwardSettingsOfficeLocationPreferencesMutation, EditForwardSettingsOfficeLocationPreferencesMutationVariables>(
    'EditForwardSettingsOfficeLocationPreferences',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEditForwardSettingsPracticeCategoryPreferencesMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitForwardPracticeCategoryPreferences }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEditForwardSettingsPracticeCategoryPreferencesMutation = (resolver: GraphQLResponseResolver<EditForwardSettingsPracticeCategoryPreferencesMutation, EditForwardSettingsPracticeCategoryPreferencesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EditForwardSettingsPracticeCategoryPreferencesMutation, EditForwardSettingsPracticeCategoryPreferencesMutationVariables>(
    'EditForwardSettingsPracticeCategoryPreferences',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRegisterForwardUserMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { registerForwardUser }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRegisterForwardUserMutation = (resolver: GraphQLResponseResolver<RegisterForwardUserMutation, RegisterForwardUserMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RegisterForwardUserMutation, RegisterForwardUserMutationVariables>(
    'RegisterForwardUser',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEmployerAttendeesQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId } = variables;
 *     return HttpResponse.json({
 *       data: { interviewSchedulingEventAttendees }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEmployerAttendeesQuery = (resolver: GraphQLResponseResolver<EmployerAttendeesQuery, EmployerAttendeesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EmployerAttendeesQuery, EmployerAttendeesQueryVariables>(
    'EmployerAttendees',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStudentListOfAvailableJobsQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { studentListOfAvailableJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStudentListOfAvailableJobsQuery = (resolver: GraphQLResponseResolver<StudentListOfAvailableJobsQuery, StudentListOfAvailableJobsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<StudentListOfAvailableJobsQuery, StudentListOfAvailableJobsQueryVariables>(
    'StudentListOfAvailableJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAvailableTimeSlotsForJobQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, scheduleId, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { availableTimeSlotsForJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAvailableTimeSlotsForJobQuery = (resolver: GraphQLResponseResolver<AvailableTimeSlotsForJobQuery, AvailableTimeSlotsForJobQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AvailableTimeSlotsForJobQuery, AvailableTimeSlotsForJobQueryVariables>(
    'AvailableTimeSlotsForJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStudentBidListQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { studentBidList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStudentBidListQuery = (resolver: GraphQLResponseResolver<StudentBidListQuery, StudentBidListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<StudentBidListQuery, StudentBidListQueryVariables>(
    'StudentBidList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLotteryUniversityEventByIdForStudentQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { lotteryUniversityEventByIdForStudent }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLotteryUniversityEventByIdForStudentQuery = (resolver: GraphQLResponseResolver<LotteryUniversityEventByIdForStudentQuery, LotteryUniversityEventByIdForStudentQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LotteryUniversityEventByIdForStudentQuery, LotteryUniversityEventByIdForStudentQueryVariables>(
    'LotteryUniversityEventByIdForStudent',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitStudentBidsMutation(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension, input } = variables;
 *     return HttpResponse.json({
 *       data: { submitStudentBids }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitStudentBidsMutation = (resolver: GraphQLResponseResolver<SubmitStudentBidsMutation, SubmitStudentBidsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitStudentBidsMutation, SubmitStudentBidsMutationVariables>(
    'SubmitStudentBids',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStudentInterviewSchedulingApplicationsQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { studentInterviewSchedulingApplications }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStudentInterviewSchedulingApplicationsQuery = (resolver: GraphQLResponseResolver<StudentInterviewSchedulingApplicationsQuery, StudentInterviewSchedulingApplicationsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<StudentInterviewSchedulingApplicationsQuery, StudentInterviewSchedulingApplicationsQueryVariables>(
    'StudentInterviewSchedulingApplications',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStudentLotteryMatchesQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { studentLotteryMatches }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStudentLotteryMatchesQuery = (resolver: GraphQLResponseResolver<StudentLotteryMatchesQuery, StudentLotteryMatchesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<StudentLotteryMatchesQuery, StudentLotteryMatchesQueryVariables>(
    'StudentLotteryMatches',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStudentLotteryUnmatchedBidsQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { studentLotteryUnmatchedBids }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStudentLotteryUnmatchedBidsQuery = (resolver: GraphQLResponseResolver<StudentLotteryUnmatchedBidsQuery, StudentLotteryUnmatchedBidsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<StudentLotteryUnmatchedBidsQuery, StudentLotteryUnmatchedBidsQueryVariables>(
    'StudentLotteryUnmatchedBids',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCancelLotteryStudentMatchMutation(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension, cancelLotteryStudentMatchInput } = variables;
 *     return HttpResponse.json({
 *       data: { cancelLotteryStudentMatch }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCancelLotteryStudentMatchMutation = (resolver: GraphQLResponseResolver<CancelLotteryStudentMatchMutation, CancelLotteryStudentMatchMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CancelLotteryStudentMatchMutation, CancelLotteryStudentMatchMutationVariables>(
    'CancelLotteryStudentMatch',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitStudentInterviewSchedulingPreferencesForJobsMutation(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension, input } = variables;
 *     return HttpResponse.json({
 *       data: { submitStudentInterviewSchedulingPreferencesForJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitStudentInterviewSchedulingPreferencesForJobsMutation = (resolver: GraphQLResponseResolver<SubmitStudentInterviewSchedulingPreferencesForJobsMutation, SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitStudentInterviewSchedulingPreferencesForJobsMutation, SubmitStudentInterviewSchedulingPreferencesForJobsMutationVariables>(
    'SubmitStudentInterviewSchedulingPreferencesForJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { studentInterviewSchedulingOfficeLocationsPreferencesForJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery = (resolver: GraphQLResponseResolver<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQuery, StudentInterviewSchedulingOfficeLocationsPreferencesForJobsQueryVariables>(
    'StudentInterviewSchedulingOfficeLocationsPreferencesForJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId, universityOrgFriendlyName, studentExtension } = variables;
 *     return HttpResponse.json({
 *       data: { studentInterviewSchedulingPracticeAreasPreferencesForJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery = (resolver: GraphQLResponseResolver<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<StudentInterviewSchedulingPracticeAreasPreferencesForJobsQuery, StudentInterviewSchedulingPracticeAreasPreferencesForJobsQueryVariables>(
    'StudentInterviewSchedulingPracticeAreasPreferencesForJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitLotteryEventTimelineMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { submitLotteryEventTimeline }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitLotteryEventTimelineMutation = (resolver: GraphQLResponseResolver<SubmitLotteryEventTimelineMutation, SubmitLotteryEventTimelineMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitLotteryEventTimelineMutation, SubmitLotteryEventTimelineMutationVariables>(
    'SubmitLotteryEventTimeline',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLotteryEventTimelineQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId } = variables;
 *     return HttpResponse.json({
 *       data: { lotteryUniversityEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLotteryEventTimelineQuery = (resolver: GraphQLResponseResolver<LotteryEventTimelineQuery, LotteryEventTimelineQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LotteryEventTimelineQuery, LotteryEventTimelineQueryVariables>(
    'LotteryEventTimeline',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLotteryEventDetailsQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId } = variables;
 *     return HttpResponse.json({
 *       data: { lotteryUniversityEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLotteryEventDetailsQuery = (resolver: GraphQLResponseResolver<LotteryEventDetailsQuery, LotteryEventDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LotteryEventDetailsQuery, LotteryEventDetailsQueryVariables>(
    'LotteryEventDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLotteryEventTimeBlocksQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId } = variables;
 *     return HttpResponse.json({
 *       data: { lotteryUniversityEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLotteryEventTimeBlocksQuery = (resolver: GraphQLResponseResolver<LotteryEventTimeBlocksQuery, LotteryEventTimeBlocksQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LotteryEventTimeBlocksQuery, LotteryEventTimeBlocksQueryVariables>(
    'LotteryEventTimeBlocks',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLotteryEventDetailsEmployerQuery(
 *   ({ query, variables }) => {
 *     const { employerEventId } = variables;
 *     return HttpResponse.json({
 *       data: { lotteryEmployerEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLotteryEventDetailsEmployerQuery = (resolver: GraphQLResponseResolver<LotteryEventDetailsEmployerQuery, LotteryEventDetailsEmployerQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LotteryEventDetailsEmployerQuery, LotteryEventDetailsEmployerQueryVariables>(
    'LotteryEventDetailsEmployer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLotteryEmployerSettingsQuery(
 *   ({ query, variables }) => {
 *     const { universityEventId } = variables;
 *     return HttpResponse.json({
 *       data: { lotteryUniversityEventById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLotteryEmployerSettingsQuery = (resolver: GraphQLResponseResolver<LotteryEmployerSettingsQuery, LotteryEmployerSettingsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LotteryEmployerSettingsQuery, LotteryEmployerSettingsQueryVariables>(
    'LotteryEmployerSettings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInternalFieldQuestionsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { internalFieldQuestions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInternalFieldQuestionsQuery = (resolver: GraphQLResponseResolver<InternalFieldQuestionsQuery, InternalFieldQuestionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InternalFieldQuestionsQuery, InternalFieldQuestionsQueryVariables>(
    'InternalFieldQuestions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockActiveInternalFieldQuestionsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { activeInternalFieldQuestions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockActiveInternalFieldQuestionsQuery = (resolver: GraphQLResponseResolver<ActiveInternalFieldQuestionsQuery, ActiveInternalFieldQuestionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ActiveInternalFieldQuestionsQuery, ActiveInternalFieldQuestionsQueryVariables>(
    'ActiveInternalFieldQuestions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertInternalFieldJobApplicationAnswerMutation(
 *   ({ query, variables }) => {
 *     const { recruitId, jobAppId, answers } = variables;
 *     return HttpResponse.json({
 *       data: { upsertJobAppInternalFieldAnswers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertInternalFieldJobApplicationAnswerMutation = (resolver: GraphQLResponseResolver<UpsertInternalFieldJobApplicationAnswerMutation, UpsertInternalFieldJobApplicationAnswerMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertInternalFieldJobApplicationAnswerMutation, UpsertInternalFieldJobApplicationAnswerMutationVariables>(
    'UpsertInternalFieldJobApplicationAnswer',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCandidateMissingInfoRequestMutation(
 *   ({ query, variables }) => {
 *     const { recruitId, jobAppId, recipientType } = variables;
 *     return HttpResponse.json({
 *       data: { createCandidateMissingInfoRequest }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCandidateMissingInfoRequestMutation = (resolver: GraphQLResponseResolver<CreateCandidateMissingInfoRequestMutation, CreateCandidateMissingInfoRequestMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCandidateMissingInfoRequestMutation, CreateCandidateMissingInfoRequestMutationVariables>(
    'CreateCandidateMissingInfoRequest',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkCreateCandidateMissingInfoRequestMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { bulkCreateCandidateMissingInfoRequest }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkCreateCandidateMissingInfoRequestMutation = (resolver: GraphQLResponseResolver<BulkCreateCandidateMissingInfoRequestMutation, BulkCreateCandidateMissingInfoRequestMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BulkCreateCandidateMissingInfoRequestMutation, BulkCreateCandidateMissingInfoRequestMutationVariables>(
    'BulkCreateCandidateMissingInfoRequest',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMissingInfoRequestJobEmailTemplateQuery(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { candidateMissingInfoRequestJobEmailTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMissingInfoRequestJobEmailTemplateQuery = (resolver: GraphQLResponseResolver<MissingInfoRequestJobEmailTemplateQuery, MissingInfoRequestJobEmailTemplateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MissingInfoRequestJobEmailTemplateQuery, MissingInfoRequestJobEmailTemplateQueryVariables>(
    'MissingInfoRequestJobEmailTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMissingInfoRequestJobEmailTemplateMutation(
 *   ({ query, variables }) => {
 *     const { jobId, input } = variables;
 *     return HttpResponse.json({
 *       data: { updateCandidateMissingInfoRequestJobEmailTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMissingInfoRequestJobEmailTemplateMutation = (resolver: GraphQLResponseResolver<UpdateMissingInfoRequestJobEmailTemplateMutation, UpdateMissingInfoRequestJobEmailTemplateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMissingInfoRequestJobEmailTemplateMutation, UpdateMissingInfoRequestJobEmailTemplateMutationVariables>(
    'UpdateMissingInfoRequestJobEmailTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRequestMissingInfoJobInfoQuery(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { job, getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRequestMissingInfoJobInfoQuery = (resolver: GraphQLResponseResolver<RequestMissingInfoJobInfoQuery, RequestMissingInfoJobInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RequestMissingInfoJobInfoQuery, RequestMissingInfoJobInfoQueryVariables>(
    'RequestMissingInfoJobInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateProfileCandidateInfoQuery(
 *   ({ query, variables }) => {
 *     const { candidateId } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateProfileCandidateInfoQuery = (resolver: GraphQLResponseResolver<CandidateProfileCandidateInfoQuery, CandidateProfileCandidateInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateProfileCandidateInfoQuery, CandidateProfileCandidateInfoQueryVariables>(
    'CandidateProfileCandidateInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLoadTestHealthCheckQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { healthCheck }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLoadTestHealthCheckQuery = (resolver: GraphQLResponseResolver<LoadTestHealthCheckQuery, LoadTestHealthCheckQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LoadTestHealthCheckQuery, LoadTestHealthCheckQueryVariables>(
    'LoadTestHealthCheck',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLoadTestSimpleQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { testString }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLoadTestSimpleQuery = (resolver: GraphQLResponseResolver<LoadTestSimpleQuery, LoadTestSimpleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LoadTestSimpleQuery, LoadTestSimpleQueryVariables>(
    'LoadTestSimple',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLoadTestFeatureFlagQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { testFeatureFlag }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLoadTestFeatureFlagQuery = (resolver: GraphQLResponseResolver<LoadTestFeatureFlagQuery, LoadTestFeatureFlagQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LoadTestFeatureFlagQuery, LoadTestFeatureFlagQueryVariables>(
    'LoadTestFeatureFlag',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLoadTestSimpleObjectQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { testObject }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLoadTestSimpleObjectQuery = (resolver: GraphQLResponseResolver<LoadTestSimpleObjectQuery, LoadTestSimpleObjectQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LoadTestSimpleObjectQuery, LoadTestSimpleObjectQueryVariables>(
    'LoadTestSimpleObject',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLoadTestComplexObjectQuery(
 *   ({ query, variables }) => {
 *     const { argument1, argument2, argument3, argument4, argument5 } = variables;
 *     return HttpResponse.json({
 *       data: { testObject }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLoadTestComplexObjectQuery = (resolver: GraphQLResponseResolver<LoadTestComplexObjectQuery, LoadTestComplexObjectQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LoadTestComplexObjectQuery, LoadTestComplexObjectQueryVariables>(
    'LoadTestComplexObject',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetMembersForCurrentOrgQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetMembersForCurrentOrgQuery = (resolver: GraphQLResponseResolver<GetMembersForCurrentOrgQuery, GetMembersForCurrentOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetMembersForCurrentOrgQuery, GetMembersForCurrentOrgQueryVariables>(
    'GetMembersForCurrentOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetMemberByIdQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { memberById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetMemberByIdQuery = (resolver: GraphQLResponseResolver<GetMemberByIdQuery, GetMemberByIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetMemberByIdQuery, GetMemberByIdQueryVariables>(
    'GetMemberById',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOrgSsoInfoQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetOrgSsoInfoQuery = (resolver: GraphQLResponseResolver<GetOrgSsoInfoQuery, GetOrgSsoInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetOrgSsoInfoQuery, GetOrgSsoInfoQueryVariables>(
    'GetOrgSsoInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateEmployerMemberMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { createEmployerMember }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateEmployerMemberMutation = (resolver: GraphQLResponseResolver<CreateEmployerMemberMutation, CreateEmployerMemberMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateEmployerMemberMutation, CreateEmployerMemberMutationVariables>(
    'CreateEmployerMember',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEditEmployerMemberInfoMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { editEmployerMemberInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEditEmployerMemberInfoMutation = (resolver: GraphQLResponseResolver<EditEmployerMemberInfoMutation, EditEmployerMemberInfoMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EditEmployerMemberInfoMutation, EditEmployerMemberInfoMutationVariables>(
    'EditEmployerMemberInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEditEmployerMemberAuthInfoMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { editEmployerMemberAuthInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEditEmployerMemberAuthInfoMutation = (resolver: GraphQLResponseResolver<EditEmployerMemberAuthInfoMutation, EditEmployerMemberAuthInfoMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EditEmployerMemberAuthInfoMutation, EditEmployerMemberAuthInfoMutationVariables>(
    'EditEmployerMemberAuthInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteMemberMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteMember }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteMemberMutation = (resolver: GraphQLResponseResolver<DeleteMemberMutation, DeleteMemberMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteMemberMutation, DeleteMemberMutationVariables>(
    'DeleteMember',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadMembersCsvMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { uploadMembersCsv }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUploadMembersCsvMutation = (resolver: GraphQLResponseResolver<UploadMembersCsvMutation, UploadMembersCsvMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UploadMembersCsvMutation, UploadMembersCsvMutationVariables>(
    'UploadMembersCsv',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCannedReportMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCannedReport }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCannedReportMutation = (resolver: GraphQLResponseResolver<UpsertCannedReportMutation, UpsertCannedReportMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCannedReportMutation, UpsertCannedReportMutationVariables>(
    'UpsertCannedReport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertCannedReportIncludedJobsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertCannedReportIncludedJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertCannedReportIncludedJobsMutation = (resolver: GraphQLResponseResolver<UpsertCannedReportIncludedJobsMutation, UpsertCannedReportIncludedJobsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertCannedReportIncludedJobsMutation, UpsertCannedReportIncludedJobsMutationVariables>(
    'UpsertCannedReportIncludedJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInitialRunCannedReportMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { initialRunCannedReport }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInitialRunCannedReportMutation = (resolver: GraphQLResponseResolver<InitialRunCannedReportMutation, InitialRunCannedReportMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<InitialRunCannedReportMutation, InitialRunCannedReportMutationVariables>(
    'InitialRunCannedReport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCannedReportMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCannedReport }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteCannedReportMutation = (resolver: GraphQLResponseResolver<DeleteCannedReportMutation, DeleteCannedReportMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteCannedReportMutation, DeleteCannedReportMutationVariables>(
    'DeleteCannedReport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCannedReportQuery(
 *   ({ query, variables }) => {
 *     const { cannedReportId } = variables;
 *     return HttpResponse.json({
 *       data: { getCannedReport }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCannedReportQuery = (resolver: GraphQLResponseResolver<GetCannedReportQuery, GetCannedReportQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCannedReportQuery, GetCannedReportQueryVariables>(
    'GetCannedReport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSavedCannedReportsForOrgQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getSavedCannedReportsForOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSavedCannedReportsForOrgQuery = (resolver: GraphQLResponseResolver<GetSavedCannedReportsForOrgQuery, GetSavedCannedReportsForOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSavedCannedReportsForOrgQuery, GetSavedCannedReportsForOrgQueryVariables>(
    'GetSavedCannedReportsForOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTotalBucketValuesForLawSchoolDataTableQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { getTotalBucketValuesForLawSchoolDataTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetTotalBucketValuesForLawSchoolDataTableQuery = (resolver: GraphQLResponseResolver<GetTotalBucketValuesForLawSchoolDataTableQuery, GetTotalBucketValuesForLawSchoolDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetTotalBucketValuesForLawSchoolDataTableQuery, GetTotalBucketValuesForLawSchoolDataTableQueryVariables>(
    'GetTotalBucketValuesForLawSchoolDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTotalBucketValuesForAppSourceDataTableQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { getTotalBucketValuesForAppSourceDataTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetTotalBucketValuesForAppSourceDataTableQuery = (resolver: GraphQLResponseResolver<GetTotalBucketValuesForAppSourceDataTableQuery, GetTotalBucketValuesForAppSourceDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetTotalBucketValuesForAppSourceDataTableQuery, GetTotalBucketValuesForAppSourceDataTableQueryVariables>(
    'GetTotalBucketValuesForAppSourceDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetConversionReportSankeyDataQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { getConversionReportSankeyData }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetConversionReportSankeyDataQuery = (resolver: GraphQLResponseResolver<GetConversionReportSankeyDataQuery, GetConversionReportSankeyDataQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetConversionReportSankeyDataQuery, GetConversionReportSankeyDataQueryVariables>(
    'GetConversionReportSankeyData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetConversionReportDataTableQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { getConversionReportDataTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetConversionReportDataTableQuery = (resolver: GraphQLResponseResolver<GetConversionReportDataTableQuery, GetConversionReportDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetConversionReportDataTableQuery, GetConversionReportDataTableQueryVariables>(
    'GetConversionReportDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetConversionReportCandidatesQuery(
 *   ({ query, variables }) => {
 *     const { id, first, after, filterBy } = variables;
 *     return HttpResponse.json({
 *       data: { getConversionReportCandidates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetConversionReportCandidatesQuery = (resolver: GraphQLResponseResolver<GetConversionReportCandidatesQuery, GetConversionReportCandidatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetConversionReportCandidatesQuery, GetConversionReportCandidatesQueryVariables>(
    'GetConversionReportCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTotalLawSchoolCandidatesByBucketQuery(
 *   ({ query, variables }) => {
 *     const { id, bucket, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getTotalLawSchoolCandidatesByBucket }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetTotalLawSchoolCandidatesByBucketQuery = (resolver: GraphQLResponseResolver<GetTotalLawSchoolCandidatesByBucketQuery, GetTotalLawSchoolCandidatesByBucketQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetTotalLawSchoolCandidatesByBucketQuery, GetTotalLawSchoolCandidatesByBucketQueryVariables>(
    'GetTotalLawSchoolCandidatesByBucket',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetTotalAppSourceCandidatesByBucketQuery(
 *   ({ query, variables }) => {
 *     const { id, bucket, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getTotalAppSourceCandidatesByBucket }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetTotalAppSourceCandidatesByBucketQuery = (resolver: GraphQLResponseResolver<GetTotalAppSourceCandidatesByBucketQuery, GetTotalAppSourceCandidatesByBucketQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetTotalAppSourceCandidatesByBucketQuery, GetTotalAppSourceCandidatesByBucketQueryVariables>(
    'GetTotalAppSourceCandidatesByBucket',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidatesForCandidateDataTableQuery(
 *   ({ query, variables }) => {
 *     const { id, bucket, targetBucket, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesForCandidateDataTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidatesForCandidateDataTableQuery = (resolver: GraphQLResponseResolver<GetCandidatesForCandidateDataTableQuery, GetCandidatesForCandidateDataTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidatesForCandidateDataTableQuery, GetCandidatesForCandidateDataTableQueryVariables>(
    'GetCandidatesForCandidateDataTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateJobAppOfferDetailsMutation(
 *   ({ query, variables }) => {
 *     const { jobAppId, input } = variables;
 *     return HttpResponse.json({
 *       data: { updateJobAppOfferDetails }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateJobAppOfferDetailsMutation = (resolver: GraphQLResponseResolver<UpdateJobAppOfferDetailsMutation, UpdateJobAppOfferDetailsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateJobAppOfferDetailsMutation, UpdateJobAppOfferDetailsMutationVariables>(
    'UpdateJobAppOfferDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMigrateOrgToGovernmentContractorMutation(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { migrateOrgToGovernmentContractor }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMigrateOrgToGovernmentContractorMutation = (resolver: GraphQLResponseResolver<MigrateOrgToGovernmentContractorMutation, MigrateOrgToGovernmentContractorMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<MigrateOrgToGovernmentContractorMutation, MigrateOrgToGovernmentContractorMutationVariables>(
    'MigrateOrgToGovernmentContractor',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobWithTitleQuery(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { job }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobWithTitleQuery = (resolver: GraphQLResponseResolver<JobWithTitleQuery, JobWithTitleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobWithTitleQuery, JobWithTitleQueryVariables>(
    'JobWithTitle',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOrgJobSchemasQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { jobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOrgJobSchemasQuery = (resolver: GraphQLResponseResolver<OrgJobSchemasQuery, OrgJobSchemasQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<OrgJobSchemasQuery, OrgJobSchemasQueryVariables>(
    'OrgJobSchemas',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobSectionsAndQuestionsQuery(
 *   ({ query, variables }) => {
 *     const { jobIds } = variables;
 *     return HttpResponse.json({
 *       data: { jobsFromIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobSectionsAndQuestionsQuery = (resolver: GraphQLResponseResolver<JobSectionsAndQuestionsQuery, JobSectionsAndQuestionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobSectionsAndQuestionsQuery, JobSectionsAndQuestionsQueryVariables>(
    'JobSectionsAndQuestions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPublicJobQuery(
 *   ({ query, variables }) => {
 *     const { jobExtension, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { publicJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPublicJobQuery = (resolver: GraphQLResponseResolver<PublicJobQuery, PublicJobQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PublicJobQuery, PublicJobQueryVariables>(
    'PublicJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateOrgJobAppOverviewsQuery(
 *   ({ query, variables }) => {
 *     const { orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { publicCandidateOrgJobApps }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateOrgJobAppOverviewsQuery = (resolver: GraphQLResponseResolver<CandidateOrgJobAppOverviewsQuery, CandidateOrgJobAppOverviewsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateOrgJobAppOverviewsQuery, CandidateOrgJobAppOverviewsQueryVariables>(
    'CandidateOrgJobAppOverviews',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPublicJobAppQuery(
 *   ({ query, variables }) => {
 *     const { orgFriendlyName, jobExtension } = variables;
 *     return HttpResponse.json({
 *       data: { publicCandidateJobApp }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPublicJobAppQuery = (resolver: GraphQLResponseResolver<PublicJobAppQuery, PublicJobAppQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PublicJobAppQuery, PublicJobAppQueryVariables>(
    'PublicJobApp',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPublicJobAppAgencyViewQuery(
 *   ({ query, variables }) => {
 *     const { orgFriendlyName, jobExtension, recruitId } = variables;
 *     return HttpResponse.json({
 *       data: { publicCandidateJobAppOfRecruit }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPublicJobAppAgencyViewQuery = (resolver: GraphQLResponseResolver<PublicJobAppAgencyViewQuery, PublicJobAppAgencyViewQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PublicJobAppAgencyViewQuery, PublicJobAppAgencyViewQueryVariables>(
    'PublicJobAppAgencyView',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPublicJobOverviewQuery(
 *   ({ query, variables }) => {
 *     const { jobExtension, orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { publicJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPublicJobOverviewQuery = (resolver: GraphQLResponseResolver<PublicJobOverviewQuery, PublicJobOverviewQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PublicJobOverviewQuery, PublicJobOverviewQueryVariables>(
    'PublicJobOverview',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAppSourceOptionsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { fetchAppSourceOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAppSourceOptionsQuery = (resolver: GraphQLResponseResolver<AppSourceOptionsQuery, AppSourceOptionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AppSourceOptionsQuery, AppSourceOptionsQueryVariables>(
    'AppSourceOptions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOrgSelfIdQuestionsQuery(
 *   ({ query, variables }) => {
 *     const { orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { orgSelfIdQuestions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOrgSelfIdQuestionsQuery = (resolver: GraphQLResponseResolver<OrgSelfIdQuestionsQuery, OrgSelfIdQuestionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<OrgSelfIdQuestionsQuery, OrgSelfIdQuestionsQueryVariables>(
    'OrgSelfIdQuestions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSingleOrgSelfIdQuestionQuery(
 *   ({ query, variables }) => {
 *     const { orgFriendlyName, questionId } = variables;
 *     return HttpResponse.json({
 *       data: { orgSelfIdQuestion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSingleOrgSelfIdQuestionQuery = (resolver: GraphQLResponseResolver<GetSingleOrgSelfIdQuestionQuery, GetSingleOrgSelfIdQuestionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSingleOrgSelfIdQuestionQuery, GetSingleOrgSelfIdQuestionQueryVariables>(
    'GetSingleOrgSelfIdQuestion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPublicOrgSelfIdQuestionsQuery(
 *   ({ query, variables }) => {
 *     const { orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgSelfIdQuestions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPublicOrgSelfIdQuestionsQuery = (resolver: GraphQLResponseResolver<PublicOrgSelfIdQuestionsQuery, PublicOrgSelfIdQuestionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PublicOrgSelfIdQuestionsQuery, PublicOrgSelfIdQuestionsQueryVariables>(
    'PublicOrgSelfIdQuestions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidateOrgSelfIdQuestionAnswersQuery(
 *   ({ query, variables }) => {
 *     const { recruitId } = variables;
 *     return HttpResponse.json({
 *       data: { fetchCandidateOrgSelfIdQuestionAnswers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidateOrgSelfIdQuestionAnswersQuery = (resolver: GraphQLResponseResolver<CandidateOrgSelfIdQuestionAnswersQuery, CandidateOrgSelfIdQuestionAnswersQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidateOrgSelfIdQuestionAnswersQuery, CandidateOrgSelfIdQuestionAnswersQueryVariables>(
    'CandidateOrgSelfIdQuestionAnswers',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAgencyListQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { agencies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAgencyListQuery = (resolver: GraphQLResponseResolver<AgencyListQuery, AgencyListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AgencyListQuery, AgencyListQueryVariables>(
    'AgencyList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRegisteredAgencyListQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { registeredAgencies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRegisteredAgencyListQuery = (resolver: GraphQLResponseResolver<RegisteredAgencyListQuery, RegisteredAgencyListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RegisteredAgencyListQuery, RegisteredAgencyListQueryVariables>(
    'RegisteredAgencyList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAgencyListWithContactsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { agencies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAgencyListWithContactsQuery = (resolver: GraphQLResponseResolver<AgencyListWithContactsQuery, AgencyListWithContactsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AgencyListWithContactsQuery, AgencyListWithContactsQueryVariables>(
    'AgencyListWithContacts',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRegisteredAgencyListWithContactsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { registeredAgencies }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRegisteredAgencyListWithContactsQuery = (resolver: GraphQLResponseResolver<RegisteredAgencyListWithContactsQuery, RegisteredAgencyListWithContactsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RegisteredAgencyListWithContactsQuery, RegisteredAgencyListWithContactsQueryVariables>(
    'RegisteredAgencyListWithContacts',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAgencyQuery(
 *   ({ query, variables }) => {
 *     const { agencyId } = variables;
 *     return HttpResponse.json({
 *       data: { agency }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetAgencyQuery = (resolver: GraphQLResponseResolver<GetAgencyQuery, GetAgencyQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetAgencyQuery, GetAgencyQueryVariables>(
    'GetAgency',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAgencyContactQuery(
 *   ({ query, variables }) => {
 *     const { agencyContactId } = variables;
 *     return HttpResponse.json({
 *       data: { agencyContact }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetAgencyContactQuery = (resolver: GraphQLResponseResolver<GetAgencyContactQuery, GetAgencyContactQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetAgencyContactQuery, GetAgencyContactQueryVariables>(
    'GetAgencyContact',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetAgencyContactsQuery(
 *   ({ query, variables }) => {
 *     const { agencyContactIds } = variables;
 *     return HttpResponse.json({
 *       data: { agencyContacts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetAgencyContactsQuery = (resolver: GraphQLResponseResolver<GetAgencyContactsQuery, GetAgencyContactsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetAgencyContactsQuery, GetAgencyContactsQueryVariables>(
    'GetAgencyContacts',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSelfIdJobsCountQuery(
 *   ({ query, variables }) => {
 *     const { orgFriendlyName } = variables;
 *     return HttpResponse.json({
 *       data: { fetchSelfIdJobsCount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSelfIdJobsCountQuery = (resolver: GraphQLResponseResolver<SelfIdJobsCountQuery, SelfIdJobsCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SelfIdJobsCountQuery, SelfIdJobsCountQueryVariables>(
    'SelfIdJobsCount',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPublicJobsForAgencyContactQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { publicJobsForAgencyContact }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPublicJobsForAgencyContactQuery = (resolver: GraphQLResponseResolver<PublicJobsForAgencyContactQuery, PublicJobsForAgencyContactQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PublicJobsForAgencyContactQuery, PublicJobsForAgencyContactQueryVariables>(
    'PublicJobsForAgencyContact',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPublicJobForAgencyContactByExtensionQuery(
 *   ({ query, variables }) => {
 *     const { jobExtension } = variables;
 *     return HttpResponse.json({
 *       data: { publicJobForAgencyContactByExtension }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPublicJobForAgencyContactByExtensionQuery = (resolver: GraphQLResponseResolver<PublicJobForAgencyContactByExtensionQuery, PublicJobForAgencyContactByExtensionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PublicJobForAgencyContactByExtensionQuery, PublicJobForAgencyContactByExtensionQueryVariables>(
    'PublicJobForAgencyContactByExtension',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOrgHistoricalDataQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrgHistoricalData }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOrgHistoricalDataQuery = (resolver: GraphQLResponseResolver<OrgHistoricalDataQuery, OrgHistoricalDataQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<OrgHistoricalDataQuery, OrgHistoricalDataQueryVariables>(
    'OrgHistoricalData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockHistoricalDataCandidateByEmailQuery(
 *   ({ query, variables }) => {
 *     const { email } = variables;
 *     return HttpResponse.json({
 *       data: { getHistoricalCandidateByEmail }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockHistoricalDataCandidateByEmailQuery = (resolver: GraphQLResponseResolver<HistoricalDataCandidateByEmailQuery, HistoricalDataCandidateByEmailQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<HistoricalDataCandidateByEmailQuery, HistoricalDataCandidateByEmailQueryVariables>(
    'HistoricalDataCandidateByEmail',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockHistoricalDataCandidateByRecruitIdQuery(
 *   ({ query, variables }) => {
 *     const { recruitId } = variables;
 *     return HttpResponse.json({
 *       data: { getHistoricalCandidateByRecruitId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockHistoricalDataCandidateByRecruitIdQuery = (resolver: GraphQLResponseResolver<HistoricalDataCandidateByRecruitIdQuery, HistoricalDataCandidateByRecruitIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<HistoricalDataCandidateByRecruitIdQuery, HistoricalDataCandidateByRecruitIdQueryVariables>(
    'HistoricalDataCandidateByRecruitId',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetJobAppsQuery(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { jobApps }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetJobAppsQuery = (resolver: GraphQLResponseResolver<GetJobAppsQuery, GetJobAppsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetJobAppsQuery, GetJobAppsQueryVariables>(
    'GetJobApps',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetEmployerOrgFeedbackQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetEmployerOrgFeedbackQuery = (resolver: GraphQLResponseResolver<GetEmployerOrgFeedbackQuery, GetEmployerOrgFeedbackQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetEmployerOrgFeedbackQuery, GetEmployerOrgFeedbackQueryVariables>(
    'GetEmployerOrgFeedback',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidatesQuery(
 *   ({ query, variables }) => {
 *     const { jobId, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesOfJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidatesQuery = (resolver: GraphQLResponseResolver<GetCandidatesQuery, GetCandidatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidatesQuery, GetCandidatesQueryVariables>(
    'GetCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidatesWithEventsQuery(
 *   ({ query, variables }) => {
 *     const { jobId, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesOfJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidatesWithEventsQuery = (resolver: GraphQLResponseResolver<GetCandidatesWithEventsQuery, GetCandidatesWithEventsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidatesWithEventsQuery, GetCandidatesWithEventsQueryVariables>(
    'GetCandidatesWithEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidatesWithEventsAndJobsQuery(
 *   ({ query, variables }) => {
 *     const { jobIds, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesOfJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidatesWithEventsAndJobsQuery = (resolver: GraphQLResponseResolver<GetCandidatesWithEventsAndJobsQuery, GetCandidatesWithEventsAndJobsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidatesWithEventsAndJobsQuery, GetCandidatesWithEventsAndJobsQueryVariables>(
    'GetCandidatesWithEventsAndJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidatesForProgramsQuery(
 *   ({ query, variables }) => {
 *     const { programIds } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesOfPrograms }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidatesForProgramsQuery = (resolver: GraphQLResponseResolver<GetCandidatesForProgramsQuery, GetCandidatesForProgramsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidatesForProgramsQuery, GetCandidatesForProgramsQueryVariables>(
    'GetCandidatesForPrograms',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidatesForEventsQuery(
 *   ({ query, variables }) => {
 *     const { eventIds } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesOfEvents }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidatesForEventsQuery = (resolver: GraphQLResponseResolver<GetCandidatesForEventsQuery, GetCandidatesForEventsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidatesForEventsQuery, GetCandidatesForEventsQueryVariables>(
    'GetCandidatesForEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetFullCandidatesQuery(
 *   ({ query, variables }) => {
 *     const { jobId, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesOfJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetFullCandidatesQuery = (resolver: GraphQLResponseResolver<GetFullCandidatesQuery, GetFullCandidatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetFullCandidatesQuery, GetFullCandidatesQueryVariables>(
    'GetFullCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetQualifyingQuestionsForCandidatesQuery(
 *   ({ query, variables }) => {
 *     const { jobId, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesOfJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetQualifyingQuestionsForCandidatesQuery = (resolver: GraphQLResponseResolver<GetQualifyingQuestionsForCandidatesQuery, GetQualifyingQuestionsForCandidatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetQualifyingQuestionsForCandidatesQuery, GetQualifyingQuestionsForCandidatesQueryVariables>(
    'GetQualifyingQuestionsForCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOfficeLocationsForCurrentOrgQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetOfficeLocationsForCurrentOrgQuery = (resolver: GraphQLResponseResolver<GetOfficeLocationsForCurrentOrgQuery, GetOfficeLocationsForCurrentOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetOfficeLocationsForCurrentOrgQuery, GetOfficeLocationsForCurrentOrgQueryVariables>(
    'GetOfficeLocationsForCurrentOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOfficeLocationsForCurrentOrgV2Query(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrgEmployerMember }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetOfficeLocationsForCurrentOrgV2Query = (resolver: GraphQLResponseResolver<GetOfficeLocationsForCurrentOrgV2Query, GetOfficeLocationsForCurrentOrgV2QueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetOfficeLocationsForCurrentOrgV2Query, GetOfficeLocationsForCurrentOrgV2QueryVariables>(
    'GetOfficeLocationsForCurrentOrgV2',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetEmployerEventsQuery(
 *   ({ query, variables }) => {
 *     const { first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetEmployerEventsQuery = (resolver: GraphQLResponseResolver<GetEmployerEventsQuery, GetEmployerEventsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetEmployerEventsQuery, GetEmployerEventsQueryVariables>(
    'GetEmployerEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetJobQuestionColumnQuery(
 *   ({ query, variables }) => {
 *     const { jobId, jobQuestionId } = variables;
 *     return HttpResponse.json({
 *       data: { jobQuestion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetJobQuestionColumnQuery = (resolver: GraphQLResponseResolver<GetJobQuestionColumnQuery, GetJobQuestionColumnQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetJobQuestionColumnQuery, GetJobQuestionColumnQueryVariables>(
    'GetJobQuestionColumn',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetUserAnalyticsInfoQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { userAnalyticsInfo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetUserAnalyticsInfoQuery = (resolver: GraphQLResponseResolver<GetUserAnalyticsInfoQuery, GetUserAnalyticsInfoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetUserAnalyticsInfoQuery, GetUserAnalyticsInfoQueryVariables>(
    'GetUserAnalyticsInfo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetOrgIsGovernmentContractorQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetOrgIsGovernmentContractorQuery = (resolver: GraphQLResponseResolver<GetOrgIsGovernmentContractorQuery, GetOrgIsGovernmentContractorQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetOrgIsGovernmentContractorQuery, GetOrgIsGovernmentContractorQueryVariables>(
    'GetOrgIsGovernmentContractor',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockJobsForPipelineTemplateQuery(
 *   ({ query, variables }) => {
 *     const { pipelineTemplateId } = variables;
 *     return HttpResponse.json({
 *       data: { jobsForPipelineTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockJobsForPipelineTemplateQuery = (resolver: GraphQLResponseResolver<JobsForPipelineTemplateQuery, JobsForPipelineTemplateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<JobsForPipelineTemplateQuery, JobsForPipelineTemplateQueryVariables>(
    'JobsForPipelineTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCandidatePhotoManagementSettingsPageQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCandidatePhotoManagementSettingsPageQuery = (resolver: GraphQLResponseResolver<CandidatePhotoManagementSettingsPageQuery, CandidatePhotoManagementSettingsPageQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CandidatePhotoManagementSettingsPageQuery, CandidatePhotoManagementSettingsPageQueryVariables>(
    'CandidatePhotoManagementSettingsPage',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCandidatePhotoManagementSettingsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { updateOrgCandidatePhotoManagementSettings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCandidatePhotoManagementSettingsMutation = (resolver: GraphQLResponseResolver<UpdateCandidatePhotoManagementSettingsMutation, UpdateCandidatePhotoManagementSettingsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCandidatePhotoManagementSettingsMutation, UpdateCandidatePhotoManagementSettingsMutationVariables>(
    'UpdateCandidatePhotoManagementSettings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInternalFieldQuestionsSettingsPageQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { internalFieldQuestions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInternalFieldQuestionsSettingsPageQuery = (resolver: GraphQLResponseResolver<InternalFieldQuestionsSettingsPageQuery, InternalFieldQuestionsSettingsPageQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InternalFieldQuestionsSettingsPageQuery, InternalFieldQuestionsSettingsPageQueryVariables>(
    'InternalFieldQuestionsSettingsPage',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertInternalFieldQuestionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertInternalFieldQuestion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertInternalFieldQuestionMutation = (resolver: GraphQLResponseResolver<UpsertInternalFieldQuestionMutation, UpsertInternalFieldQuestionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertInternalFieldQuestionMutation, UpsertInternalFieldQuestionMutationVariables>(
    'UpsertInternalFieldQuestion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockArchiveInternalFieldQuestionMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { archiveInternalFieldQuestion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockArchiveInternalFieldQuestionMutation = (resolver: GraphQLResponseResolver<ArchiveInternalFieldQuestionMutation, ArchiveInternalFieldQuestionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ArchiveInternalFieldQuestionMutation, ArchiveInternalFieldQuestionMutationVariables>(
    'ArchiveInternalFieldQuestion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUnarchiveInternalFieldQuestionMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { unarchiveInternalFieldQuestion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUnarchiveInternalFieldQuestionMutation = (resolver: GraphQLResponseResolver<UnarchiveInternalFieldQuestionMutation, UnarchiveInternalFieldQuestionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UnarchiveInternalFieldQuestionMutation, UnarchiveInternalFieldQuestionMutationVariables>(
    'UnarchiveInternalFieldQuestion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInternalFieldsOrderMutation(
 *   ({ query, variables }) => {
 *     const { ids } = variables;
 *     return HttpResponse.json({
 *       data: { updateInternalFieldsOrder }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInternalFieldsOrderMutation = (resolver: GraphQLResponseResolver<UpdateInternalFieldsOrderMutation, UpdateInternalFieldsOrderMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInternalFieldsOrderMutation, UpdateInternalFieldsOrderMutationVariables>(
    'UpdateInternalFieldsOrder',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEmployerSettingsPageOrgOfficeLocationsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEmployerSettingsPageOrgOfficeLocationsQuery = (resolver: GraphQLResponseResolver<EmployerSettingsPageOrgOfficeLocationsQuery, EmployerSettingsPageOrgOfficeLocationsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EmployerSettingsPageOrgOfficeLocationsQuery, EmployerSettingsPageOrgOfficeLocationsQueryVariables>(
    'EmployerSettingsPageOrgOfficeLocations',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddOfficeToOrgMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { addOfficeToOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddOfficeToOrgMutation = (resolver: GraphQLResponseResolver<AddOfficeToOrgMutation, AddOfficeToOrgMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddOfficeToOrgMutation, AddOfficeToOrgMutationVariables>(
    'AddOfficeToOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveOfficeFromOrgMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { removeOfficeFromOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveOfficeFromOrgMutation = (resolver: GraphQLResponseResolver<RemoveOfficeFromOrgMutation, RemoveOfficeFromOrgMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveOfficeFromOrgMutation, RemoveOfficeFromOrgMutationVariables>(
    'RemoveOfficeFromOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminCloseJobsListQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminCloseJobsListQuery = (resolver: GraphQLResponseResolver<SuperAdminCloseJobsListQuery, SuperAdminCloseJobsListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminCloseJobsListQuery, SuperAdminCloseJobsListQueryVariables>(
    'SuperAdminCloseJobsList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminCloseJobsByIdQuery(
 *   ({ query, variables }) => {
 *     const { ids } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobsById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminCloseJobsByIdQuery = (resolver: GraphQLResponseResolver<SuperAdminCloseJobsByIdQuery, SuperAdminCloseJobsByIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminCloseJobsByIdQuery, SuperAdminCloseJobsByIdQueryVariables>(
    'SuperAdminCloseJobsById',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminCloseJobsMutation(
 *   ({ query, variables }) => {
 *     const { closeJobsInput } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminCloseJobs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminCloseJobsMutation = (resolver: GraphQLResponseResolver<SuperAdminCloseJobsMutation, SuperAdminCloseJobsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminCloseJobsMutation, SuperAdminCloseJobsMutationVariables>(
    'SuperAdminCloseJobs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfileCustomQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfileCustomQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfileCustomQuery, SuperAdminFirmProfileCustomQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfileCustomQuery, SuperAdminFirmProfileCustomQueryVariables>(
    'SuperAdminFirmProfileCustom',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitFirmProfileCustomSectionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitFirmProfileCustomSection }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitFirmProfileCustomSectionMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitFirmProfileCustomSectionMutation, SuperAdminSubmitFirmProfileCustomSectionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitFirmProfileCustomSectionMutation, SuperAdminSubmitFirmProfileCustomSectionMutationVariables>(
    'SuperAdminSubmitFirmProfileCustomSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFirmProfileSelfIdDefaultsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { selfIdDefaultsByType, selfIdDefaultsByType, selfIdDefaultsByType }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFirmProfileSelfIdDefaultsQuery = (resolver: GraphQLResponseResolver<FirmProfileSelfIdDefaultsQuery, FirmProfileSelfIdDefaultsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FirmProfileSelfIdDefaultsQuery, FirmProfileSelfIdDefaultsQueryVariables>(
    'FirmProfileSelfIdDefaults',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfileDiversityAndInclusionQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfileDiversityAndInclusionQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfileDiversityAndInclusionQuery, SuperAdminFirmProfileDiversityAndInclusionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfileDiversityAndInclusionQuery, SuperAdminFirmProfileDiversityAndInclusionQueryVariables>(
    'SuperAdminFirmProfileDiversityAndInclusion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitDiversityAndInclusionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitFirmProfileDiversityAndInclusionSection }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitDiversityAndInclusionMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitDiversityAndInclusionMutation, SuperAdminSubmitDiversityAndInclusionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitDiversityAndInclusionMutation, SuperAdminSubmitDiversityAndInclusionMutationVariables>(
    'SuperAdminSubmitDiversityAndInclusion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmEventCarouselQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmEventCarouselQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmEventCarouselQuery, SuperAdminFirmEventCarouselQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmEventCarouselQuery, SuperAdminFirmEventCarouselQueryVariables>(
    'SuperAdminFirmEventCarousel',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitEventCarouselSectionMutation(
 *   ({ query, variables }) => {
 *     const { enableInput, updateInput } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEnableEventCarousel, superAdminUpdateEventCarouselRankings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitEventCarouselSectionMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitEventCarouselSectionMutation, SuperAdminSubmitEventCarouselSectionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitEventCarouselSectionMutation, SuperAdminSubmitEventCarouselSectionMutationVariables>(
    'SuperAdminSubmitEventCarouselSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfileHighlightsQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfileHighlightsQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfileHighlightsQuery, SuperAdminFirmProfileHighlightsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfileHighlightsQuery, SuperAdminFirmProfileHighlightsQueryVariables>(
    'SuperAdminFirmProfileHighlights',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitFirmProfileHighlightsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitFirmProfileMain }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitFirmProfileHighlightsMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitFirmProfileHighlightsMutation, SuperAdminSubmitFirmProfileHighlightsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitFirmProfileHighlightsMutation, SuperAdminSubmitFirmProfileHighlightsMutationVariables>(
    'SuperAdminSubmitFirmProfileHighlights',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfilePracticeAreaSectionQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfilePracticeAreaSectionQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfilePracticeAreaSectionQuery, SuperAdminFirmProfilePracticeAreaSectionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfilePracticeAreaSectionQuery, SuperAdminFirmProfilePracticeAreaSectionQueryVariables>(
    'SuperAdminFirmProfilePracticeAreaSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitFirmProfilePracticeAreaSectionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitFirmProfilePracticeAreaSection }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitFirmProfilePracticeAreaSectionMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitFirmProfilePracticeAreaSectionMutation, SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitFirmProfilePracticeAreaSectionMutation, SuperAdminSubmitFirmProfilePracticeAreaSectionMutationVariables>(
    'SuperAdminSubmitFirmProfilePracticeAreaSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetFirmPracticeAreasQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminGetFirmPracticeAreas }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetFirmPracticeAreasQuery = (resolver: GraphQLResponseResolver<SuperAdminGetFirmPracticeAreasQuery, SuperAdminGetFirmPracticeAreasQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetFirmPracticeAreasQuery, SuperAdminGetFirmPracticeAreasQueryVariables>(
    'SuperAdminGetFirmPracticeAreas',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddPracticeAreaToFirmMutation(
 *   ({ query, variables }) => {
 *     const { addInput } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminAddPracticeAreaToFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddPracticeAreaToFirmMutation = (resolver: GraphQLResponseResolver<SuperAdminAddPracticeAreaToFirmMutation, SuperAdminAddPracticeAreaToFirmMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddPracticeAreaToFirmMutation, SuperAdminAddPracticeAreaToFirmMutationVariables>(
    'SuperAdminAddPracticeAreaToFirm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminRemovePracticeAreaFromFirmMutation(
 *   ({ query, variables }) => {
 *     const { removeInput } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminRemovePracticeAreaFromFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminRemovePracticeAreaFromFirmMutation = (resolver: GraphQLResponseResolver<SuperAdminRemovePracticeAreaFromFirmMutation, SuperAdminRemovePracticeAreaFromFirmMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminRemovePracticeAreaFromFirmMutation, SuperAdminRemovePracticeAreaFromFirmMutationVariables>(
    'SuperAdminRemovePracticeAreaFromFirm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfilePreviewSectionQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfilePreviewSectionQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfilePreviewSectionQuery, SuperAdminFirmProfilePreviewSectionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfilePreviewSectionQuery, SuperAdminFirmProfilePreviewSectionQueryVariables>(
    'SuperAdminFirmProfilePreviewSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminEditFirmProfileIsPublicMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitFirmProfileIsPublic }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminEditFirmProfileIsPublicMutation = (resolver: GraphQLResponseResolver<SuperAdminEditFirmProfileIsPublicMutation, SuperAdminEditFirmProfileIsPublicMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminEditFirmProfileIsPublicMutation, SuperAdminEditFirmProfileIsPublicMutationVariables>(
    'SuperAdminEditFirmProfileIsPublic',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfileProBonoQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfileProBonoQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfileProBonoQuery, SuperAdminFirmProfileProBonoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfileProBonoQuery, SuperAdminFirmProfileProBonoQueryVariables>(
    'SuperAdminFirmProfileProBono',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitFirmProfileProBonoSectionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitFirmProfileProBonoSection }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitFirmProfileProBonoSectionMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitFirmProfileProBonoSectionMutation, SuperAdminSubmitFirmProfileProBonoSectionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitFirmProfileProBonoSectionMutation, SuperAdminSubmitFirmProfileProBonoSectionMutationVariables>(
    'SuperAdminSubmitFirmProfileProBonoSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfileSummerProgramSectionQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfileSummerProgramSectionQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfileSummerProgramSectionQuery, SuperAdminFirmProfileSummerProgramSectionQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfileSummerProgramSectionQuery, SuperAdminFirmProfileSummerProgramSectionQueryVariables>(
    'SuperAdminFirmProfileSummerProgramSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitFirmProfileSummerProgramSectionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitFirmProfileSummerProgramSection }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitFirmProfileSummerProgramSectionMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitFirmProfileSummerProgramSectionMutation, SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitFirmProfileSummerProgramSectionMutation, SuperAdminSubmitFirmProfileSummerProgramSectionMutationVariables>(
    'SuperAdminSubmitFirmProfileSummerProgramSection',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmOfficesQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminGetOfficesForFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmOfficesQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmOfficesQuery, SuperAdminFirmOfficesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmOfficesQuery, SuperAdminFirmOfficesQueryVariables>(
    'SuperAdminFirmOffices',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOrgFriendlyNameByIdQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOrgFriendlyNameByIdQuery = (resolver: GraphQLResponseResolver<OrgFriendlyNameByIdQuery, OrgFriendlyNameByIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<OrgFriendlyNameByIdQuery, OrgFriendlyNameByIdQueryVariables>(
    'OrgFriendlyNameById',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminFirmProfileFormQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId, firmProfileByFirmId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminFirmProfileFormQuery = (resolver: GraphQLResponseResolver<SuperAdminFirmProfileFormQuery, SuperAdminFirmProfileFormQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminFirmProfileFormQuery, SuperAdminFirmProfileFormQueryVariables>(
    'SuperAdminFirmProfileForm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetUpcomingOrgEventsQuery(
 *   ({ query, variables }) => {
 *     const { orgId, filterBy, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId, eventDirectory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetUpcomingOrgEventsQuery = (resolver: GraphQLResponseResolver<SuperAdminGetUpcomingOrgEventsQuery, SuperAdminGetUpcomingOrgEventsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetUpcomingOrgEventsQuery, SuperAdminGetUpcomingOrgEventsQueryVariables>(
    'SuperAdminGetUpcomingOrgEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetUpcomingEventsQuery(
 *   ({ query, variables }) => {
 *     const { filterBy, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { eventDirectory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetUpcomingEventsQuery = (resolver: GraphQLResponseResolver<SuperAdminGetUpcomingEventsQuery, SuperAdminGetUpcomingEventsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetUpcomingEventsQuery, SuperAdminGetUpcomingEventsQueryVariables>(
    'SuperAdminGetUpcomingEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminUpdateOrgFeaturedEventsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminUpdateOrgFeaturedEvents }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminUpdateOrgFeaturedEventsMutation = (resolver: GraphQLResponseResolver<SuperAdminUpdateOrgFeaturedEventsMutation, SuperAdminUpdateOrgFeaturedEventsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminUpdateOrgFeaturedEventsMutation, SuperAdminUpdateOrgFeaturedEventsMutationVariables>(
    'SuperAdminUpdateOrgFeaturedEvents',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitForwardEventPublishingSettingsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitForwardEventPublishingSettings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitForwardEventPublishingSettingsMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitForwardEventPublishingSettingsMutation, SuperAdminSubmitForwardEventPublishingSettingsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitForwardEventPublishingSettingsMutation, SuperAdminSubmitForwardEventPublishingSettingsMutationVariables>(
    'SuperAdminSubmitForwardEventPublishingSettings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminForwardTierPanelFirmsQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, sortBy } = variables;
 *     return HttpResponse.json({
 *       data: { firmDirectory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminForwardTierPanelFirmsQuery = (resolver: GraphQLResponseResolver<SuperAdminForwardTierPanelFirmsQuery, SuperAdminForwardTierPanelFirmsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminForwardTierPanelFirmsQuery, SuperAdminForwardTierPanelFirmsQueryVariables>(
    'SuperAdminForwardTierPanelFirms',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminUpdateForwardTierMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminUpdateForwardTier }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminUpdateForwardTierMutation = (resolver: GraphQLResponseResolver<SuperAdminUpdateForwardTierMutation, SuperAdminUpdateForwardTierMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminUpdateForwardTierMutation, SuperAdminUpdateForwardTierMutationVariables>(
    'SuperAdminUpdateForwardTier',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGenerateCandidateMutation(
 *   ({ query, variables }) => {
 *     const { orgId, input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminGenerateCandidate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGenerateCandidateMutation = (resolver: GraphQLResponseResolver<GenerateCandidateMutation, GenerateCandidateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<GenerateCandidateMutation, GenerateCandidateMutationVariables>(
    'GenerateCandidate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminOrgForGenerateCandidatesQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminGetOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminOrgForGenerateCandidatesQuery = (resolver: GraphQLResponseResolver<SuperAdminOrgForGenerateCandidatesQuery, SuperAdminOrgForGenerateCandidatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminOrgForGenerateCandidatesQuery, SuperAdminOrgForGenerateCandidatesQueryVariables>(
    'SuperAdminOrgForGenerateCandidates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateFlagUrlMutation(
 *   ({ query, variables }) => {
 *     const { key, url } = variables;
 *     return HttpResponse.json({
 *       data: { updateFlagUrl }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateFlagUrlMutation = (resolver: GraphQLResponseResolver<UpdateFlagUrlMutation, UpdateFlagUrlMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateFlagUrlMutation, UpdateFlagUrlMutationVariables>(
    'UpdateFlagUrl',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockToggleFlagMutation(
 *   ({ query, variables }) => {
 *     const { key } = variables;
 *     return HttpResponse.json({
 *       data: { toggleFlag }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockToggleFlagMutation = (resolver: GraphQLResponseResolver<ToggleFlagMutation, ToggleFlagMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ToggleFlagMutation, ToggleFlagMutationVariables>(
    'ToggleFlag',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveOrgMutation(
 *   ({ query, variables }) => {
 *     const { key, orgId } = variables;
 *     return HttpResponse.json({
 *       data: { removeOrgFromFlag }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveOrgMutation = (resolver: GraphQLResponseResolver<RemoveOrgMutation, RemoveOrgMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveOrgMutation, RemoveOrgMutationVariables>(
    'RemoveOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddOrgFlagMutation(
 *   ({ query, variables }) => {
 *     const { key, orgId } = variables;
 *     return HttpResponse.json({
 *       data: { addOrgToFlag }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddOrgFlagMutation = (resolver: GraphQLResponseResolver<AddOrgFlagMutation, AddOrgFlagMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddOrgFlagMutation, AddOrgFlagMutationVariables>(
    'AddOrgFlag',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFlagsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { flags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFlagsQuery = (resolver: GraphQLResponseResolver<FlagsQuery, FlagsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FlagsQuery, FlagsQueryVariables>(
    'Flags',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFlagFromKeyQuery(
 *   ({ query, variables }) => {
 *     const { key } = variables;
 *     return HttpResponse.json({
 *       data: { flagFromKey }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFlagFromKeyQuery = (resolver: GraphQLResponseResolver<FlagFromKeyQuery, FlagFromKeyQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FlagFromKeyQuery, FlagFromKeyQueryVariables>(
    'FlagFromKey',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEnabledOrgsQuery(
 *   ({ query, variables }) => {
 *     const { key } = variables;
 *     return HttpResponse.json({
 *       data: { flagFromKey }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEnabledOrgsQuery = (resolver: GraphQLResponseResolver<EnabledOrgsQuery, EnabledOrgsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EnabledOrgsQuery, EnabledOrgsQueryVariables>(
    'EnabledOrgs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobImportBatchesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminExternalJobImportBatches }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobImportBatchesQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobImportBatchesQuery, SuperAdminExternalJobImportBatchesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobImportBatchesQuery, SuperAdminExternalJobImportBatchesQueryVariables>(
    'SuperAdminExternalJobImportBatches',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobImportBatchByIdQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminExternalJobImportBatchById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobImportBatchByIdQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobImportBatchByIdQuery, SuperAdminExternalJobImportBatchByIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobImportBatchByIdQuery, SuperAdminExternalJobImportBatchByIdQueryVariables>(
    'SuperAdminExternalJobImportBatchById',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobImportByIdQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminExternalJobImportById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobImportByIdQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobImportByIdQuery, SuperAdminExternalJobImportByIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobImportByIdQuery, SuperAdminExternalJobImportByIdQueryVariables>(
    'SuperAdminExternalJobImportById',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobImportFirmIndependentDropdownDataQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminGetExistingFirms, allPracticeCategories }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobImportFirmIndependentDropdownDataQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobImportFirmIndependentDropdownDataQuery, SuperAdminExternalJobImportFirmIndependentDropdownDataQueryVariables>(
    'SuperAdminExternalJobImportFirmIndependentDropdownData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobImportFirmDependentDropdownDataQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId, superAdminGetOfficesForFirm, superAdminGetDocumentsForFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobImportFirmDependentDropdownDataQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobImportFirmDependentDropdownDataQuery, SuperAdminExternalJobImportFirmDependentDropdownDataQueryVariables>(
    'SuperAdminExternalJobImportFirmDependentDropdownData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitExternalJobImportMutation(
 *   ({ query, variables }) => {
 *     const { submitInput } = variables;
 *     return HttpResponse.json({
 *       data: { submitAndMarkExternalJobImportAsCompleted }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitExternalJobImportMutation = (resolver: GraphQLResponseResolver<SubmitExternalJobImportMutation, SubmitExternalJobImportMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitExternalJobImportMutation, SubmitExternalJobImportMutationVariables>(
    'SubmitExternalJobImport',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockToggleExternalJobImportDoNotSubmitStatusMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { toggleExternalJobImportDoNotSubmitStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockToggleExternalJobImportDoNotSubmitStatusMutation = (resolver: GraphQLResponseResolver<ToggleExternalJobImportDoNotSubmitStatusMutation, ToggleExternalJobImportDoNotSubmitStatusMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ToggleExternalJobImportDoNotSubmitStatusMutation, ToggleExternalJobImportDoNotSubmitStatusMutationVariables>(
    'ToggleExternalJobImportDoNotSubmitStatus',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddLawSchoolMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminCreateLawSchool }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddLawSchoolMutation = (resolver: GraphQLResponseResolver<SuperAdminAddLawSchoolMutation, SuperAdminAddLawSchoolMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddLawSchoolMutation, SuperAdminAddLawSchoolMutationVariables>(
    'SuperAdminAddLawSchool',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminRenameLawSchoolMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEditLawSchool }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminRenameLawSchoolMutation = (resolver: GraphQLResponseResolver<SuperAdminRenameLawSchoolMutation, SuperAdminRenameLawSchoolMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminRenameLawSchoolMutation, SuperAdminRenameLawSchoolMutationVariables>(
    'SuperAdminRenameLawSchool',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminMergeLawSchoolMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminMergeLawSchool }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminMergeLawSchoolMutation = (resolver: GraphQLResponseResolver<SuperAdminMergeLawSchoolMutation, SuperAdminMergeLawSchoolMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminMergeLawSchoolMutation, SuperAdminMergeLawSchoolMutationVariables>(
    'SuperAdminMergeLawSchool',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminOutlierLawSchoolDataByNameQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminOutlierLawSchoolData }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminOutlierLawSchoolDataByNameQuery = (resolver: GraphQLResponseResolver<SuperAdminOutlierLawSchoolDataByNameQuery, SuperAdminOutlierLawSchoolDataByNameQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminOutlierLawSchoolDataByNameQuery, SuperAdminOutlierLawSchoolDataByNameQueryVariables>(
    'SuperAdminOutlierLawSchoolDataByName',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAssignOutlierLawSchoolDataMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminAssignOutlierLawSchoolData }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAssignOutlierLawSchoolDataMutation = (resolver: GraphQLResponseResolver<SuperAdminAssignOutlierLawSchoolDataMutation, SuperAdminAssignOutlierLawSchoolDataMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAssignOutlierLawSchoolDataMutation, SuperAdminAssignOutlierLawSchoolDataMutationVariables>(
    'SuperAdminAssignOutlierLawSchoolData',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLawSchoolsWithDomainsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allLawSchools }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLawSchoolsWithDomainsQuery = (resolver: GraphQLResponseResolver<LawSchoolsWithDomainsQuery, LawSchoolsWithDomainsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LawSchoolsWithDomainsQuery, LawSchoolsWithDomainsQueryVariables>(
    'LawSchoolsWithDomains',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitEmailDomainsForSchoolMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitEmailDomainsForSchool }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitEmailDomainsForSchoolMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitEmailDomainsForSchoolMutation, SuperAdminSubmitEmailDomainsForSchoolMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitEmailDomainsForSchoolMutation, SuperAdminSubmitEmailDomainsForSchoolMutationVariables>(
    'SuperAdminSubmitEmailDomainsForSchool',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddOfficeLocationMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminCreateOfficeLocation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddOfficeLocationMutation = (resolver: GraphQLResponseResolver<SuperAdminAddOfficeLocationMutation, SuperAdminAddOfficeLocationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddOfficeLocationMutation, SuperAdminAddOfficeLocationMutationVariables>(
    'SuperAdminAddOfficeLocation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminRenameOfficeLocationMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEditOfficeLocation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminRenameOfficeLocationMutation = (resolver: GraphQLResponseResolver<SuperAdminRenameOfficeLocationMutation, SuperAdminRenameOfficeLocationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminRenameOfficeLocationMutation, SuperAdminRenameOfficeLocationMutationVariables>(
    'SuperAdminRenameOfficeLocation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddPracticeAreaMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminCreatePracticeArea }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddPracticeAreaMutation = (resolver: GraphQLResponseResolver<SuperAdminAddPracticeAreaMutation, SuperAdminAddPracticeAreaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddPracticeAreaMutation, SuperAdminAddPracticeAreaMutationVariables>(
    'SuperAdminAddPracticeArea',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminRenamePracticeAreaMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEditPracticeArea }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminRenamePracticeAreaMutation = (resolver: GraphQLResponseResolver<SuperAdminRenamePracticeAreaMutation, SuperAdminRenamePracticeAreaMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminRenamePracticeAreaMutation, SuperAdminRenamePracticeAreaMutationVariables>(
    'SuperAdminRenamePracticeArea',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddPracticeCategoryMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminCreatePracticeCategory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddPracticeCategoryMutation = (resolver: GraphQLResponseResolver<SuperAdminAddPracticeCategoryMutation, SuperAdminAddPracticeCategoryMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddPracticeCategoryMutation, SuperAdminAddPracticeCategoryMutationVariables>(
    'SuperAdminAddPracticeCategory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminRenamePracticeCategoryMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEditPracticeCategory }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminRenamePracticeCategoryMutation = (resolver: GraphQLResponseResolver<SuperAdminRenamePracticeCategoryMutation, SuperAdminRenamePracticeCategoryMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminRenamePracticeCategoryMutation, SuperAdminRenamePracticeCategoryMutationVariables>(
    'SuperAdminRenamePracticeCategory',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddUniversityMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminCreateUniversity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddUniversityMutation = (resolver: GraphQLResponseResolver<SuperAdminAddUniversityMutation, SuperAdminAddUniversityMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddUniversityMutation, SuperAdminAddUniversityMutationVariables>(
    'SuperAdminAddUniversity',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminRenameUniversityMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEditUniversity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminRenameUniversityMutation = (resolver: GraphQLResponseResolver<SuperAdminRenameUniversityMutation, SuperAdminRenameUniversityMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminRenameUniversityMutation, SuperAdminRenameUniversityMutationVariables>(
    'SuperAdminRenameUniversity',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminActiveWorkplacesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { workplaces }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminActiveWorkplacesQuery = (resolver: GraphQLResponseResolver<SuperAdminActiveWorkplacesQuery, SuperAdminActiveWorkplacesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminActiveWorkplacesQuery, SuperAdminActiveWorkplacesQueryVariables>(
    'SuperAdminActiveWorkplaces',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminArchivedWorkplacesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { archivedWorkplaces }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminArchivedWorkplacesQuery = (resolver: GraphQLResponseResolver<SuperAdminArchivedWorkplacesQuery, SuperAdminArchivedWorkplacesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminArchivedWorkplacesQuery, SuperAdminArchivedWorkplacesQueryVariables>(
    'SuperAdminArchivedWorkplaces',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminWorkplaceManagementExistingFirmsListQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminGetExistingFirms }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminWorkplaceManagementExistingFirmsListQuery = (resolver: GraphQLResponseResolver<SuperAdminWorkplaceManagementExistingFirmsListQuery, SuperAdminWorkplaceManagementExistingFirmsListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminWorkplaceManagementExistingFirmsListQuery, SuperAdminWorkplaceManagementExistingFirmsListQueryVariables>(
    'SuperAdminWorkplaceManagementExistingFirmsList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddWorkplaceMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminCreateWorkplace }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddWorkplaceMutation = (resolver: GraphQLResponseResolver<SuperAdminAddWorkplaceMutation, SuperAdminAddWorkplaceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddWorkplaceMutation, SuperAdminAddWorkplaceMutationVariables>(
    'SuperAdminAddWorkplace',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminEditWorkplaceMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEditWorkplace }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminEditWorkplaceMutation = (resolver: GraphQLResponseResolver<SuperAdminEditWorkplaceMutation, SuperAdminEditWorkplaceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminEditWorkplaceMutation, SuperAdminEditWorkplaceMutationVariables>(
    'SuperAdminEditWorkplace',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminArchiveWorkplaceMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminArchiveWorkplace }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminArchiveWorkplaceMutation = (resolver: GraphQLResponseResolver<SuperAdminArchiveWorkplaceMutation, SuperAdminArchiveWorkplaceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminArchiveWorkplaceMutation, SuperAdminArchiveWorkplaceMutationVariables>(
    'SuperAdminArchiveWorkplace',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAtsJobListQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, orderBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAtsJobListQuery = (resolver: GraphQLResponseResolver<SuperAdminAtsJobListQuery, SuperAdminAtsJobListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminAtsJobListQuery, SuperAdminAtsJobListQueryVariables>(
    'SuperAdminAtsJobList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitJobBoardAudienceMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitJobBoardAudience }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitJobBoardAudienceMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitJobBoardAudienceMutation, SuperAdminSubmitJobBoardAudienceMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitJobBoardAudienceMutation, SuperAdminSubmitJobBoardAudienceMutationVariables>(
    'SuperAdminSubmitJobBoardAudience',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobListQuery(
 *   ({ query, variables }) => {
 *     const { first, after, filterBy, orderBy } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobFeed }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobListQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobListQuery, SuperAdminExternalJobListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobListQuery, SuperAdminExternalJobListQueryVariables>(
    'SuperAdminExternalJobList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminJobByIdQuery(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { forwardJobById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminJobByIdQuery = (resolver: GraphQLResponseResolver<SuperAdminJobByIdQuery, SuperAdminJobByIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminJobByIdQuery, SuperAdminJobByIdQueryVariables>(
    'SuperAdminJobById',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobFormStaticListsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminGetExistingFirms, allOfficeLocations, allPracticeCategories }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobFormStaticListsQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobFormStaticListsQuery, SuperAdminExternalJobFormStaticListsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobFormStaticListsQuery, SuperAdminExternalJobFormStaticListsQueryVariables>(
    'SuperAdminExternalJobFormStaticLists',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminExternalJobFormFirmDependentListsQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminGetOfficesForFirm, superAdminGetDocumentsForFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminExternalJobFormFirmDependentListsQuery = (resolver: GraphQLResponseResolver<SuperAdminExternalJobFormFirmDependentListsQuery, SuperAdminExternalJobFormFirmDependentListsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminExternalJobFormFirmDependentListsQuery, SuperAdminExternalJobFormFirmDependentListsQueryVariables>(
    'SuperAdminExternalJobFormFirmDependentLists',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddOfficeMutation(
 *   ({ query, variables }) => {
 *     const { addOfficeInput } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminAddOfficeToFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddOfficeMutation = (resolver: GraphQLResponseResolver<SuperAdminAddOfficeMutation, SuperAdminAddOfficeMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddOfficeMutation, SuperAdminAddOfficeMutationVariables>(
    'SuperAdminAddOffice',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminAddDocumentMutation(
 *   ({ query, variables }) => {
 *     const { addDocumentInput } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminAddDocumentToFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminAddDocumentMutation = (resolver: GraphQLResponseResolver<SuperAdminAddDocumentMutation, SuperAdminAddDocumentMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminAddDocumentMutation, SuperAdminAddDocumentMutationVariables>(
    'SuperAdminAddDocument',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminSubmitJobMutation(
 *   ({ query, variables }) => {
 *     const { submitJobInput } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminSubmitJobForFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminSubmitJobMutation = (resolver: GraphQLResponseResolver<SuperAdminSubmitJobMutation, SuperAdminSubmitJobMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminSubmitJobMutation, SuperAdminSubmitJobMutationVariables>(
    'SuperAdminSubmitJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetOrgForwardPrivilegesQuery(
 *   ({ query, variables }) => {
 *     const { orgId } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId, superAdminGetOrgForwardPrivileges }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetOrgForwardPrivilegesQuery = (resolver: GraphQLResponseResolver<SuperAdminGetOrgForwardPrivilegesQuery, SuperAdminGetOrgForwardPrivilegesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetOrgForwardPrivilegesQuery, SuperAdminGetOrgForwardPrivilegesQueryVariables>(
    'SuperAdminGetOrgForwardPrivileges',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminUpdateOrgForwardPrivilegesMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminUpdateOrgForwardPrivileges }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminUpdateOrgForwardPrivilegesMutation = (resolver: GraphQLResponseResolver<SuperAdminUpdateOrgForwardPrivilegesMutation, SuperAdminUpdateOrgForwardPrivilegesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminUpdateOrgForwardPrivilegesMutation, SuperAdminUpdateOrgForwardPrivilegesMutationVariables>(
    'SuperAdminUpdateOrgForwardPrivileges',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetFirmAndItsOfficesQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId, superAdminGetOfficesForFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetFirmAndItsOfficesQuery = (resolver: GraphQLResponseResolver<SuperAdminGetFirmAndItsOfficesQuery, SuperAdminGetFirmAndItsOfficesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetFirmAndItsOfficesQuery, SuperAdminGetFirmAndItsOfficesQueryVariables>(
    'SuperAdminGetFirmAndItsOffices',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminCreateOfficeForFirmMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminAddOfficeToFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminCreateOfficeForFirmMutation = (resolver: GraphQLResponseResolver<SuperAdminCreateOfficeForFirmMutation, SuperAdminCreateOfficeForFirmMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminCreateOfficeForFirmMutation, SuperAdminCreateOfficeForFirmMutationVariables>(
    'SuperAdminCreateOfficeForFirm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminRemoveOfficeFromFirmMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminRemoveOfficeFromFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminRemoveOfficeFromFirmMutation = (resolver: GraphQLResponseResolver<SuperAdminRemoveOfficeFromFirmMutation, SuperAdminRemoveOfficeFromFirmMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminRemoveOfficeFromFirmMutation, SuperAdminRemoveOfficeFromFirmMutationVariables>(
    'SuperAdminRemoveOfficeFromFirm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminUpdateOrgOfficeRankingsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminUpdateOrgOfficeRankings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminUpdateOrgOfficeRankingsMutation = (resolver: GraphQLResponseResolver<SuperAdminUpdateOrgOfficeRankingsMutation, SuperAdminUpdateOrgOfficeRankingsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminUpdateOrgOfficeRankingsMutation, SuperAdminUpdateOrgOfficeRankingsMutationVariables>(
    'SuperAdminUpdateOrgOfficeRankings',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery(
 *   ({ query, variables }) => {
 *     const { firmId } = variables;
 *     return HttpResponse.json({
 *       data: { publicOrgInfoByOrgId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery = (resolver: GraphQLResponseResolver<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetFirmAndItsPracticeAreasAndOfficesQuery, SuperAdminGetFirmAndItsPracticeAreasAndOfficesQueryVariables>(
    'SuperAdminGetFirmAndItsPracticeAreasAndOffices',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminCreatePracticeAreaForFirmMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminAddPracticeAreaToFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminCreatePracticeAreaForFirmMutation = (resolver: GraphQLResponseResolver<SuperAdminCreatePracticeAreaForFirmMutation, SuperAdminCreatePracticeAreaForFirmMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminCreatePracticeAreaForFirmMutation, SuperAdminCreatePracticeAreaForFirmMutationVariables>(
    'SuperAdminCreatePracticeAreaForFirm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminEditPracticeAreaForFirmMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminEditPracticeAreaForFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminEditPracticeAreaForFirmMutation = (resolver: GraphQLResponseResolver<SuperAdminEditPracticeAreaForFirmMutation, SuperAdminEditPracticeAreaForFirmMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminEditPracticeAreaForFirmMutation, SuperAdminEditPracticeAreaForFirmMutationVariables>(
    'SuperAdminEditPracticeAreaForFirm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminDeletePracticeAreaForFirmMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminRemovePracticeAreaFromFirm }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminDeletePracticeAreaForFirmMutation = (resolver: GraphQLResponseResolver<SuperAdminDeletePracticeAreaForFirmMutation, SuperAdminDeletePracticeAreaForFirmMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SuperAdminDeletePracticeAreaForFirmMutation, SuperAdminDeletePracticeAreaForFirmMutationVariables>(
    'SuperAdminDeletePracticeAreaForFirm',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateOrgSsoMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminUpdateOrgSSO }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateOrgSsoMutation = (resolver: GraphQLResponseResolver<UpdateOrgSsoMutation, UpdateOrgSsoMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateOrgSsoMutation, UpdateOrgSsoMutationVariables>(
    'UpdateOrgSSO',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockToggleOrgSsoOnOffMutation(
 *   ({ query, variables }) => {
 *     const { orgId, enabled } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminToggleOrgSSO }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockToggleOrgSsoOnOffMutation = (resolver: GraphQLResponseResolver<ToggleOrgSsoOnOffMutation, ToggleOrgSsoOnOffMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ToggleOrgSsoOnOffMutation, ToggleOrgSsoOnOffMutationVariables>(
    'ToggleOrgSSOOnOff',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOrganizationSecuritySettingsPageQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminGetAllActiveOrgs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOrganizationSecuritySettingsPageQuery = (resolver: GraphQLResponseResolver<OrganizationSecuritySettingsPageQuery, OrganizationSecuritySettingsPageQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<OrganizationSecuritySettingsPageQuery, OrganizationSecuritySettingsPageQueryVariables>(
    'OrganizationSecuritySettingsPage',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSsoConnectionOptionsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminGetSsoConnectionOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSsoConnectionOptionsQuery = (resolver: GraphQLResponseResolver<GetSsoConnectionOptionsQuery, GetSsoConnectionOptionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSsoConnectionOptionsQuery, GetSsoConnectionOptionsQueryVariables>(
    'GetSsoConnectionOptions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetAllActiveEmployerOrgsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminGetAllActiveOrgs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetAllActiveEmployerOrgsQuery = (resolver: GraphQLResponseResolver<SuperAdminGetAllActiveEmployerOrgsQuery, SuperAdminGetAllActiveEmployerOrgsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetAllActiveEmployerOrgsQuery, SuperAdminGetAllActiveEmployerOrgsQueryVariables>(
    'SuperAdminGetAllActiveEmployerOrgs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetAllActiveUniversityOrgsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { superAdminGetAllActiveOrgs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetAllActiveUniversityOrgsQuery = (resolver: GraphQLResponseResolver<SuperAdminGetAllActiveUniversityOrgsQuery, SuperAdminGetAllActiveUniversityOrgsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetAllActiveUniversityOrgsQuery, SuperAdminGetAllActiveUniversityOrgsQueryVariables>(
    'SuperAdminGetAllActiveUniversityOrgs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetEventsForOrgQuery(
 *   ({ query, variables }) => {
 *     const { orgId, eventTypes } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminGetEventsForOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetEventsForOrgQuery = (resolver: GraphQLResponseResolver<SuperAdminGetEventsForOrgQuery, SuperAdminGetEventsForOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetEventsForOrgQuery, SuperAdminGetEventsForOrgQueryVariables>(
    'SuperAdminGetEventsForOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminGetMemberAttendeesForOrgQuery(
 *   ({ query, variables }) => {
 *     const { orgId, eventId } = variables;
 *     return HttpResponse.json({
 *       data: { superAdminGetEventForOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminGetMemberAttendeesForOrgQuery = (resolver: GraphQLResponseResolver<SuperAdminGetMemberAttendeesForOrgQuery, SuperAdminGetMemberAttendeesForOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminGetMemberAttendeesForOrgQuery, SuperAdminGetMemberAttendeesForOrgQueryVariables>(
    'SuperAdminGetMemberAttendeesForOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetCandidatesSclpQuery(
 *   ({ query, variables }) => {
 *     const { filterBy, sortBy, first, after } = variables;
 *     return HttpResponse.json({
 *       data: { getCandidatesSCLP }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetCandidatesSclpQuery = (resolver: GraphQLResponseResolver<GetCandidatesSclpQuery, GetCandidatesSclpQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetCandidatesSclpQuery, GetCandidatesSclpQueryVariables>(
    'getCandidatesSCLP',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllLawSchoolsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allLawSchools }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllLawSchoolsQuery = (resolver: GraphQLResponseResolver<AllLawSchoolsQuery, AllLawSchoolsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllLawSchoolsQuery, AllLawSchoolsQueryVariables>(
    'AllLawSchools',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllOfficeLocationsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allOfficeLocations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllOfficeLocationsQuery = (resolver: GraphQLResponseResolver<AllOfficeLocationsQuery, AllOfficeLocationsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllOfficeLocationsQuery, AllOfficeLocationsQueryVariables>(
    'AllOfficeLocations',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllPracticeAreasQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allPracticeAreas }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllPracticeAreasQuery = (resolver: GraphQLResponseResolver<AllPracticeAreasQuery, AllPracticeAreasQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllPracticeAreasQuery, AllPracticeAreasQueryVariables>(
    'AllPracticeAreas',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllPracticeCategoriesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allPracticeCategories }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllPracticeCategoriesQuery = (resolver: GraphQLResponseResolver<AllPracticeCategoriesQuery, AllPracticeCategoriesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllPracticeCategoriesQuery, AllPracticeCategoriesQueryVariables>(
    'AllPracticeCategories',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllUniversitiesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { allUniversities }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllUniversitiesQuery = (resolver: GraphQLResponseResolver<AllUniversitiesQuery, AllUniversitiesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllUniversitiesQuery, AllUniversitiesQueryVariables>(
    'AllUniversities',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuperAdminLoginGuardQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { whoAmI }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuperAdminLoginGuardQuery = (resolver: GraphQLResponseResolver<SuperAdminLoginGuardQuery, SuperAdminLoginGuardQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuperAdminLoginGuardQuery, SuperAdminLoginGuardQueryVariables>(
    'SuperAdminLoginGuard',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllCustomProgramEvaluationResponsesQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllCustomProgramEvaluationResponsesQuery = (resolver: GraphQLResponseResolver<AllCustomProgramEvaluationResponsesQuery, AllCustomProgramEvaluationResponsesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllCustomProgramEvaluationResponsesQuery, AllCustomProgramEvaluationResponsesQueryVariables>(
    'AllCustomProgramEvaluationResponses',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSendProjectEvaluationRequestEmailMutation(
 *   ({ query, variables }) => {
 *     const { programId, projectId, associateRecruitId, attorneyUserId } = variables;
 *     return HttpResponse.json({
 *       data: { sendProjectEvaluationRequestEmail }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSendProjectEvaluationRequestEmailMutation = (resolver: GraphQLResponseResolver<SendProjectEvaluationRequestEmailMutation, SendProjectEvaluationRequestEmailMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SendProjectEvaluationRequestEmailMutation, SendProjectEvaluationRequestEmailMutationVariables>(
    'SendProjectEvaluationRequestEmail',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSendProgramEvaluationRequestEmailForAssociatesMutation(
 *   ({ query, variables }) => {
 *     const { programId, programEvaluationId, associateRecruitIds, options } = variables;
 *     return HttpResponse.json({
 *       data: { sendProgramEvaluationRequestEmailForAssociates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSendProgramEvaluationRequestEmailForAssociatesMutation = (resolver: GraphQLResponseResolver<SendProgramEvaluationRequestEmailForAssociatesMutation, SendProgramEvaluationRequestEmailForAssociatesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SendProgramEvaluationRequestEmailForAssociatesMutation, SendProgramEvaluationRequestEmailForAssociatesMutationVariables>(
    'SendProgramEvaluationRequestEmailForAssociates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateProgramAssociateMutation(
 *   ({ query, variables }) => {
 *     const { associate } = variables;
 *     return HttpResponse.json({
 *       data: { createProgramAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateProgramAssociateMutation = (resolver: GraphQLResponseResolver<CreateProgramAssociateMutation, CreateProgramAssociateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateProgramAssociateMutation, CreateProgramAssociateMutationVariables>(
    'CreateProgramAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateProgramAssociateMutation(
 *   ({ query, variables }) => {
 *     const { updateInfo } = variables;
 *     return HttpResponse.json({
 *       data: { updateProgramAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateProgramAssociateMutation = (resolver: GraphQLResponseResolver<UpdateProgramAssociateMutation, UpdateProgramAssociateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateProgramAssociateMutation, UpdateProgramAssociateMutationVariables>(
    'UpdateProgramAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateProgramAssociatePracticeAreasMutation(
 *   ({ query, variables }) => {
 *     const { updateInfo } = variables;
 *     return HttpResponse.json({
 *       data: { updateProgramAssociatePracticeAreas }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateProgramAssociatePracticeAreasMutation = (resolver: GraphQLResponseResolver<UpdateProgramAssociatePracticeAreasMutation, UpdateProgramAssociatePracticeAreasMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateProgramAssociatePracticeAreasMutation, UpdateProgramAssociatePracticeAreasMutationVariables>(
    'UpdateProgramAssociatePracticeAreas',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramAssociatesForOrgQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { programAssociatesForOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramAssociatesForOrgQuery = (resolver: GraphQLResponseResolver<ProgramAssociatesForOrgQuery, ProgramAssociatesForOrgQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramAssociatesForOrgQuery, ProgramAssociatesForOrgQueryVariables>(
    'ProgramAssociatesForOrg',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramAssociatesByProgramIdQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { programAssociatesByProgramId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramAssociatesByProgramIdQuery = (resolver: GraphQLResponseResolver<ProgramAssociatesByProgramIdQuery, ProgramAssociatesByProgramIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramAssociatesByProgramIdQuery, ProgramAssociatesByProgramIdQueryVariables>(
    'ProgramAssociatesByProgramId',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramAssociateByRecruitIdAndProgramIdQuery(
 *   ({ query, variables }) => {
 *     const { programId, associateRecruitId } = variables;
 *     return HttpResponse.json({
 *       data: { programAssociateByRecruitIdAndProgramId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramAssociateByRecruitIdAndProgramIdQuery = (resolver: GraphQLResponseResolver<ProgramAssociateByRecruitIdAndProgramIdQuery, ProgramAssociateByRecruitIdAndProgramIdQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramAssociateByRecruitIdAndProgramIdQuery, ProgramAssociateByRecruitIdAndProgramIdQueryVariables>(
    'ProgramAssociateByRecruitIdAndProgramId',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramDetailsQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramDetailsQuery = (resolver: GraphQLResponseResolver<ProgramDetailsQuery, ProgramDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramDetailsQuery, ProgramDetailsQueryVariables>(
    'ProgramDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramContributorsQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramContributorsQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramContributorsQuery, WorkAllocationProgramContributorsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramContributorsQuery, WorkAllocationProgramContributorsQueryVariables>(
    'WorkAllocationProgramContributors',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramPermissionsQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramPermissionsQuery = (resolver: GraphQLResponseResolver<ProgramPermissionsQuery, ProgramPermissionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramPermissionsQuery, ProgramPermissionsQueryVariables>(
    'ProgramPermissions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramEmailAlertsQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramEmailAlertsQuery = (resolver: GraphQLResponseResolver<ProgramEmailAlertsQuery, ProgramEmailAlertsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramEmailAlertsQuery, ProgramEmailAlertsQueryVariables>(
    'ProgramEmailAlerts',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateWorkAllocationAssociateMutation(
 *   ({ query, variables }) => {
 *     const { associate } = variables;
 *     return HttpResponse.json({
 *       data: { createWorkAllocationAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateWorkAllocationAssociateMutation = (resolver: GraphQLResponseResolver<CreateWorkAllocationAssociateMutation, CreateWorkAllocationAssociateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateWorkAllocationAssociateMutation, CreateWorkAllocationAssociateMutationVariables>(
    'CreateWorkAllocationAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSelfAssignToMatterMutation(
 *   ({ query, variables }) => {
 *     const { matterId, programId } = variables;
 *     return HttpResponse.json({
 *       data: { selfAssignToMatter }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSelfAssignToMatterMutation = (resolver: GraphQLResponseResolver<SelfAssignToMatterMutation, SelfAssignToMatterMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SelfAssignToMatterMutation, SelfAssignToMatterMutationVariables>(
    'SelfAssignToMatter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddAssociatesToWorkAllocationMatterMutation(
 *   ({ query, variables }) => {
 *     const { matterId, associateIds } = variables;
 *     return HttpResponse.json({
 *       data: { addAssociatesToWorkAllocationMatter }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddAssociatesToWorkAllocationMatterMutation = (resolver: GraphQLResponseResolver<AddAssociatesToWorkAllocationMatterMutation, AddAssociatesToWorkAllocationMatterMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddAssociatesToWorkAllocationMatterMutation, AddAssociatesToWorkAllocationMatterMutationVariables>(
    'AddAssociatesToWorkAllocationMatter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddAssociatesToWorkAllocationProgramMutation(
 *   ({ query, variables }) => {
 *     const { programId, associateIds } = variables;
 *     return HttpResponse.json({
 *       data: { addAssociatesToWorkAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddAssociatesToWorkAllocationProgramMutation = (resolver: GraphQLResponseResolver<AddAssociatesToWorkAllocationProgramMutation, AddAssociatesToWorkAllocationProgramMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddAssociatesToWorkAllocationProgramMutation, AddAssociatesToWorkAllocationProgramMutationVariables>(
    'addAssociatesToWorkAllocationProgram',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationProgramMatterByAssociateMutation(
 *   ({ query, variables }) => {
 *     const { programId, input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationProgramMatterByAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationProgramMatterByAssociateMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationProgramMatterByAssociateMutation, UpsertWorkAllocationProgramMatterByAssociateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationProgramMatterByAssociateMutation, UpsertWorkAllocationProgramMatterByAssociateMutationVariables>(
    'UpsertWorkAllocationProgramMatterByAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMatterWorkStatusByAssociateMutation(
 *   ({ query, variables }) => {
 *     const { matterId, status } = variables;
 *     return HttpResponse.json({
 *       data: { updateMatterWorkStatusByAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMatterWorkStatusByAssociateMutation = (resolver: GraphQLResponseResolver<UpdateMatterWorkStatusByAssociateMutation, UpdateMatterWorkStatusByAssociateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMatterWorkStatusByAssociateMutation, UpdateMatterWorkStatusByAssociateMutationVariables>(
    'updateMatterWorkStatusByAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteMatterByAssociateMutation(
 *   ({ query, variables }) => {
 *     const { matterId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteMatter }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteMatterByAssociateMutation = (resolver: GraphQLResponseResolver<DeleteMatterByAssociateMutation, DeleteMatterByAssociateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteMatterByAssociateMutation, DeleteMatterByAssociateMutationVariables>(
    'DeleteMatterByAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationOrgAssociatesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { workAllocationOrgAssociates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationOrgAssociatesQuery = (resolver: GraphQLResponseResolver<WorkAllocationOrgAssociatesQuery, WorkAllocationOrgAssociatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationOrgAssociatesQuery, WorkAllocationOrgAssociatesQueryVariables>(
    'WorkAllocationOrgAssociates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramAssociatesQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramAssociatesQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramAssociatesQuery, WorkAllocationProgramAssociatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramAssociatesQuery, WorkAllocationProgramAssociatesQueryVariables>(
    'WorkAllocationProgramAssociates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramAssociatesForSummerAssociateTableQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { programAssociatesByProgramId }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramAssociatesForSummerAssociateTableQuery = (resolver: GraphQLResponseResolver<ProgramAssociatesForSummerAssociateTableQuery, ProgramAssociatesForSummerAssociateTableQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramAssociatesForSummerAssociateTableQuery, ProgramAssociatesForSummerAssociateTableQueryVariables>(
    'ProgramAssociatesForSummerAssociateTable',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationUnassignedMattersForProgramQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { unassignedWorkAllocationMattersForAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationUnassignedMattersForProgramQuery = (resolver: GraphQLResponseResolver<WorkAllocationUnassignedMattersForProgramQuery, WorkAllocationUnassignedMattersForProgramQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationUnassignedMattersForProgramQuery, WorkAllocationUnassignedMattersForProgramQueryVariables>(
    'WorkAllocationUnassignedMattersForProgram',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationMattersForAssociateQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationMattersForAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationMattersForAssociateQuery = (resolver: GraphQLResponseResolver<WorkAllocationMattersForAssociateQuery, WorkAllocationMattersForAssociateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationMattersForAssociateQuery, WorkAllocationMattersForAssociateQueryVariables>(
    'workAllocationMattersForAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssignedWorkAllocationMattersForAssociateQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { assignedWorkAllocationMattersForAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssignedWorkAllocationMattersForAssociateQuery = (resolver: GraphQLResponseResolver<AssignedWorkAllocationMattersForAssociateQuery, AssignedWorkAllocationMattersForAssociateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AssignedWorkAllocationMattersForAssociateQuery, AssignedWorkAllocationMattersForAssociateQueryVariables>(
    'assignedWorkAllocationMattersForAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationMatterForAssociateQuery(
 *   ({ query, variables }) => {
 *     const { matterId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationMatterForAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationMatterForAssociateQuery = (resolver: GraphQLResponseResolver<WorkAllocationMatterForAssociateQuery, WorkAllocationMatterForAssociateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationMatterForAssociateQuery, WorkAllocationMatterForAssociateQueryVariables>(
    'WorkAllocationMatterForAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramForAssociateQuery(
 *   ({ query, variables }) => {
 *     const { programId, associateRecruitId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgramForAssociate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramForAssociateQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramForAssociateQuery, WorkAllocationProgramForAssociateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramForAssociateQuery, WorkAllocationProgramForAssociateQueryVariables>(
    'WorkAllocationProgramForAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitProgramEvaluationResponseForAssociateMutation(
 *   ({ query, variables }) => {
 *     const { programId, customProgramEvaluationId, associateRecruitId, attorneyUserId, answers } = variables;
 *     return HttpResponse.json({
 *       data: { upsertIndividualProgramEvaluationResponse }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitProgramEvaluationResponseForAssociateMutation = (resolver: GraphQLResponseResolver<SubmitProgramEvaluationResponseForAssociateMutation, SubmitProgramEvaluationResponseForAssociateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitProgramEvaluationResponseForAssociateMutation, SubmitProgramEvaluationResponseForAssociateMutationVariables>(
    'SubmitProgramEvaluationResponseForAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramAssociateExistsByEmployeeEmailQuery(
 *   ({ query, variables }) => {
 *     const { email } = variables;
 *     return HttpResponse.json({
 *       data: { programAssociateByEmployeeEmail }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramAssociateExistsByEmployeeEmailQuery = (resolver: GraphQLResponseResolver<ProgramAssociateExistsByEmployeeEmailQuery, ProgramAssociateExistsByEmployeeEmailQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramAssociateExistsByEmployeeEmailQuery, ProgramAssociateExistsByEmployeeEmailQueryVariables>(
    'ProgramAssociateExistsByEmployeeEmail',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateWorkAllocationProgramContributorsAndPermissionsMutation(
 *   ({ query, variables }) => {
 *     const { contributorsInput, permissionsInput } = variables;
 *     return HttpResponse.json({
 *       data: { updateWorkAllocationProgramContributors, upsertWorkAllocationPermissions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateWorkAllocationProgramContributorsAndPermissionsMutation = (resolver: GraphQLResponseResolver<UpdateWorkAllocationProgramContributorsAndPermissionsMutation, UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateWorkAllocationProgramContributorsAndPermissionsMutation, UpdateWorkAllocationProgramContributorsAndPermissionsMutationVariables>(
    'UpdateWorkAllocationProgramContributorsAndPermissions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateWorkAllocationProgramContributorsMutation(
 *   ({ query, variables }) => {
 *     const { programId, contributors } = variables;
 *     return HttpResponse.json({
 *       data: { updateWorkAllocationProgramContributors }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateWorkAllocationProgramContributorsMutation = (resolver: GraphQLResponseResolver<UpdateWorkAllocationProgramContributorsMutation, UpdateWorkAllocationProgramContributorsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateWorkAllocationProgramContributorsMutation, UpdateWorkAllocationProgramContributorsMutationVariables>(
    'UpdateWorkAllocationProgramContributors',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertProgramGroupMutation(
 *   ({ query, variables }) => {
 *     const { id, programId, name } = variables;
 *     return HttpResponse.json({
 *       data: { upsertProgramGroup }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertProgramGroupMutation = (resolver: GraphQLResponseResolver<UpsertProgramGroupMutation, UpsertProgramGroupMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertProgramGroupMutation, UpsertProgramGroupMutationVariables>(
    'UpsertProgramGroup',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateProgramGroupMembersMutation(
 *   ({ query, variables }) => {
 *     const { groupId, memberIds } = variables;
 *     return HttpResponse.json({
 *       data: { updateProgramGroupMembers }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateProgramGroupMembersMutation = (resolver: GraphQLResponseResolver<UpdateProgramGroupMembersMutation, UpdateProgramGroupMembersMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateProgramGroupMembersMutation, UpdateProgramGroupMembersMutationVariables>(
    'UpdateProgramGroupMembers',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateProgramGroupAssociatesMutation(
 *   ({ query, variables }) => {
 *     const { groupId, associateIds } = variables;
 *     return HttpResponse.json({
 *       data: { updateProgramGroupAssociates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateProgramGroupAssociatesMutation = (resolver: GraphQLResponseResolver<UpdateProgramGroupAssociatesMutation, UpdateProgramGroupAssociatesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateProgramGroupAssociatesMutation, UpdateProgramGroupAssociatesMutationVariables>(
    'UpdateProgramGroupAssociates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteProgramGroupMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteProgramGroup }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteProgramGroupMutation = (resolver: GraphQLResponseResolver<DeleteProgramGroupMutation, DeleteProgramGroupMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteProgramGroupMutation, DeleteProgramGroupMutationVariables>(
    'DeleteProgramGroup',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramGroupsQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { programGroups }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramGroupsQuery = (resolver: GraphQLResponseResolver<ProgramGroupsQuery, ProgramGroupsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramGroupsQuery, ProgramGroupsQueryVariables>(
    'ProgramGroups',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockProgramGroupQuery(
 *   ({ query, variables }) => {
 *     const { groupId } = variables;
 *     return HttpResponse.json({
 *       data: { programGroup }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockProgramGroupQuery = (resolver: GraphQLResponseResolver<ProgramGroupQuery, ProgramGroupQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ProgramGroupQuery, ProgramGroupQueryVariables>(
    'ProgramGroup',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteWorkAllocationProgramMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteWorkAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteWorkAllocationProgramMutation = (resolver: GraphQLResponseResolver<DeleteWorkAllocationProgramMutation, DeleteWorkAllocationProgramMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteWorkAllocationProgramMutation, DeleteWorkAllocationProgramMutationVariables>(
    'DeleteWorkAllocationProgram',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteWorkAllocationProgramMatterMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteWorkAllocationProgramMatter }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteWorkAllocationProgramMatterMutation = (resolver: GraphQLResponseResolver<DeleteWorkAllocationProgramMatterMutation, DeleteWorkAllocationProgramMatterMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteWorkAllocationProgramMatterMutation, DeleteWorkAllocationProgramMatterMutationVariables>(
    'DeleteWorkAllocationProgramMatter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationProgramEvaluationTemplateMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationProgramEvaluationTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationProgramEvaluationTemplateMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationProgramEvaluationTemplateMutation, UpsertWorkAllocationProgramEvaluationTemplateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationProgramEvaluationTemplateMutation, UpsertWorkAllocationProgramEvaluationTemplateMutationVariables>(
    'UpsertWorkAllocationProgramEvaluationTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUupsertWorkAllocationProgramReminderEmailMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationProgramReminderEmail }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUupsertWorkAllocationProgramReminderEmailMutation = (resolver: GraphQLResponseResolver<UupsertWorkAllocationProgramReminderEmailMutation, UupsertWorkAllocationProgramReminderEmailMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UupsertWorkAllocationProgramReminderEmailMutation, UupsertWorkAllocationProgramReminderEmailMutationVariables>(
    'UupsertWorkAllocationProgramReminderEmail',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationProgramMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationProgramMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationProgramMutation, UpsertWorkAllocationProgramMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationProgramMutation, UpsertWorkAllocationProgramMutationVariables>(
    'UpsertWorkAllocationProgram',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationProgramMatterMutation(
 *   ({ query, variables }) => {
 *     const { programId, input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationProgramMatter }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationProgramMatterMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationProgramMatterMutation, UpsertWorkAllocationProgramMatterMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationProgramMatterMutation, UpsertWorkAllocationProgramMatterMutationVariables>(
    'UpsertWorkAllocationProgramMatter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationProgramMatterByMemberMutation(
 *   ({ query, variables }) => {
 *     const { programId, input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationProgramMatterByMember }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationProgramMatterByMemberMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationProgramMatterByMemberMutation, UpsertWorkAllocationProgramMatterByMemberMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationProgramMatterByMemberMutation, UpsertWorkAllocationProgramMatterByMemberMutationVariables>(
    'UpsertWorkAllocationProgramMatterByMember',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationProgramMatterDocumentMutation(
 *   ({ query, variables }) => {
 *     const { input, file } = variables;
 *     return HttpResponse.json({
 *       data: { uploadMatterDocument }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationProgramMatterDocumentMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationProgramMatterDocumentMutation, UpsertWorkAllocationProgramMatterDocumentMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationProgramMatterDocumentMutation, UpsertWorkAllocationProgramMatterDocumentMutationVariables>(
    'UpsertWorkAllocationProgramMatterDocument',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteMatterDocumentMutation(
 *   ({ query, variables }) => {
 *     const { matterId, ids } = variables;
 *     return HttpResponse.json({
 *       data: { deleteMatterDocuments }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteMatterDocumentMutation = (resolver: GraphQLResponseResolver<DeleteMatterDocumentMutation, DeleteMatterDocumentMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteMatterDocumentMutation, DeleteMatterDocumentMutationVariables>(
    'DeleteMatterDocument',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMatterWorkStatusMutation(
 *   ({ query, variables }) => {
 *     const { matterId, status } = variables;
 *     return HttpResponse.json({
 *       data: { updateMatterWorkStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMatterWorkStatusMutation = (resolver: GraphQLResponseResolver<UpdateMatterWorkStatusMutation, UpdateMatterWorkStatusMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMatterWorkStatusMutation, UpdateMatterWorkStatusMutationVariables>(
    'UpdateMatterWorkStatus',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertMatterAssociateEvaluationMutation(
 *   ({ query, variables }) => {
 *     const { matterId, candidateId, answers } = variables;
 *     return HttpResponse.json({
 *       data: { upsertMatterAssociateEvaluation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertMatterAssociateEvaluationMutation = (resolver: GraphQLResponseResolver<UpsertMatterAssociateEvaluationMutation, UpsertMatterAssociateEvaluationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertMatterAssociateEvaluationMutation, UpsertMatterAssociateEvaluationMutationVariables>(
    'upsertMatterAssociateEvaluation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationPermissionsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationPermissions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationPermissionsMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationPermissionsMutation, UpsertWorkAllocationPermissionsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationPermissionsMutation, UpsertWorkAllocationPermissionsMutationVariables>(
    'UpsertWorkAllocationPermissions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationEmailAlertsMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationEmailAlerts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationEmailAlertsMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationEmailAlertsMutation, UpsertWorkAllocationEmailAlertsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationEmailAlertsMutation, UpsertWorkAllocationEmailAlertsMutationVariables>(
    'UpsertWorkAllocationEmailAlerts',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationMatterQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationMatter }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationMatterQuery = (resolver: GraphQLResponseResolver<WorkAllocationMatterQuery, WorkAllocationMatterQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationMatterQuery, WorkAllocationMatterQueryVariables>(
    'WorkAllocationMatter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationMattersByProgramQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationMattersByProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationMattersByProgramQuery = (resolver: GraphQLResponseResolver<WorkAllocationMattersByProgramQuery, WorkAllocationMattersByProgramQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationMattersByProgramQuery, WorkAllocationMattersByProgramQueryVariables>(
    'WorkAllocationMattersByProgram',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramQuery, WorkAllocationProgramQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramQuery, WorkAllocationProgramQueryVariables>(
    'WorkAllocationProgram',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramTitleQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { programTitle }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramTitleQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramTitleQuery, WorkAllocationProgramTitleQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramTitleQuery, WorkAllocationProgramTitleQueryVariables>(
    'WorkAllocationProgramTitle',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramsQuery(
 *   ({ query, variables }) => {
 *     const { programIds } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationPrograms }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramsQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramsQuery, WorkAllocationProgramsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramsQuery, WorkAllocationProgramsQueryVariables>(
    'WorkAllocationPrograms',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationOrgProgramsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { workAllocationOrgPrograms }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationOrgProgramsQuery = (resolver: GraphQLResponseResolver<WorkAllocationOrgProgramsQuery, WorkAllocationOrgProgramsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationOrgProgramsQuery, WorkAllocationOrgProgramsQueryVariables>(
    'WorkAllocationOrgPrograms',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationOrgProgramsForProgramsPageQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { workAllocationOrgPrograms }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationOrgProgramsForProgramsPageQuery = (resolver: GraphQLResponseResolver<WorkAllocationOrgProgramsForProgramsPageQuery, WorkAllocationOrgProgramsForProgramsPageQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationOrgProgramsForProgramsPageQuery, WorkAllocationOrgProgramsForProgramsPageQueryVariables>(
    'WorkAllocationOrgProgramsForProgramsPage',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetWorkAllocationProgramEvaluationsQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetWorkAllocationProgramEvaluationsQuery = (resolver: GraphQLResponseResolver<GetWorkAllocationProgramEvaluationsQuery, GetWorkAllocationProgramEvaluationsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetWorkAllocationProgramEvaluationsQuery, GetWorkAllocationProgramEvaluationsQueryVariables>(
    'GetWorkAllocationProgramEvaluations',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramEvaluationsForAssociatePortalQuery(
 *   ({ query, variables }) => {
 *     const { programId, associateRecruitId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramEvaluationsForAssociatePortalQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramEvaluationsForAssociatePortalQuery, WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramEvaluationsForAssociatePortalQuery, WorkAllocationProgramEvaluationsForAssociatePortalQueryVariables>(
    'WorkAllocationProgramEvaluationsForAssociatePortal',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramEvaluationsForAttorneyPortalQuery(
 *   ({ query, variables }) => {
 *     const { programId, attorneyUserId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramEvaluationsForAttorneyPortalQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramEvaluationsForAttorneyPortalQuery, WorkAllocationProgramEvaluationsForAttorneyPortalQueryVariables>(
    'WorkAllocationProgramEvaluationsForAttorneyPortal',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProjectEvaluationsDatesForAttorneyQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationEvaluationsForAttorney }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProjectEvaluationsDatesForAttorneyQuery = (resolver: GraphQLResponseResolver<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProjectEvaluationsDatesForAttorneyQuery, WorkAllocationProjectEvaluationsDatesForAttorneyQueryVariables>(
    'WorkAllocationProjectEvaluationsDatesForAttorney',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockWorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockWorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery = (resolver: GraphQLResponseResolver<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQuery, WorkAllocationProgramEvaluationForAttorneyReviewingAssociateQueryVariables>(
    'WorkAllocationProgramEvaluationForAttorneyReviewingAssociate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserWorkAllocationPermissionsQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { userWorkAllocationPermissions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserWorkAllocationPermissionsQuery = (resolver: GraphQLResponseResolver<UserWorkAllocationPermissionsQuery, UserWorkAllocationPermissionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserWorkAllocationPermissionsQuery, UserWorkAllocationPermissionsQueryVariables>(
    'UserWorkAllocationPermissions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveAssociatesFromWorkAllocationProgramMutation(
 *   ({ query, variables }) => {
 *     const { programId, associateIds } = variables;
 *     return HttpResponse.json({
 *       data: { removeAssociatesFromWorkAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveAssociatesFromWorkAllocationProgramMutation = (resolver: GraphQLResponseResolver<RemoveAssociatesFromWorkAllocationProgramMutation, RemoveAssociatesFromWorkAllocationProgramMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveAssociatesFromWorkAllocationProgramMutation, RemoveAssociatesFromWorkAllocationProgramMutationVariables>(
    'RemoveAssociatesFromWorkAllocationProgram',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveAssociatesFromWorkAllocationMatterMutation(
 *   ({ query, variables }) => {
 *     const { matterId, associateIds } = variables;
 *     return HttpResponse.json({
 *       data: { removeAssociatesFromWorkAllocationMatter }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveAssociatesFromWorkAllocationMatterMutation = (resolver: GraphQLResponseResolver<RemoveAssociatesFromWorkAllocationMatterMutation, RemoveAssociatesFromWorkAllocationMatterMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveAssociatesFromWorkAllocationMatterMutation, RemoveAssociatesFromWorkAllocationMatterMutationVariables>(
    'RemoveAssociatesFromWorkAllocationMatter',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSubmitProgramEvaluationResponseForAttorneyMutation(
 *   ({ query, variables }) => {
 *     const { programId, customProgramEvaluationId, associateRecruitId, attorneyUserId, answers } = variables;
 *     return HttpResponse.json({
 *       data: { upsertIndividualProgramEvaluationResponse }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSubmitProgramEvaluationResponseForAttorneyMutation = (resolver: GraphQLResponseResolver<SubmitProgramEvaluationResponseForAttorneyMutation, SubmitProgramEvaluationResponseForAttorneyMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SubmitProgramEvaluationResponseForAttorneyMutation, SubmitProgramEvaluationResponseForAttorneyMutationVariables>(
    'SubmitProgramEvaluationResponseForAttorney',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteEvaluationQuestionMutation(
 *   ({ query, variables }) => {
 *     const { questionId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteEvaluationQuestion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteEvaluationQuestionMutation = (resolver: GraphQLResponseResolver<DeleteEvaluationQuestionMutation, DeleteEvaluationQuestionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteEvaluationQuestionMutation, DeleteEvaluationQuestionMutationVariables>(
    'DeleteEvaluationQuestion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertEvaluationQuestionMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertEvaluationQuestion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertEvaluationQuestionMutation = (resolver: GraphQLResponseResolver<UpsertEvaluationQuestionMutation, UpsertEvaluationQuestionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertEvaluationQuestionMutation, UpsertEvaluationQuestionMutationVariables>(
    'UpsertEvaluationQuestion',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOrgWorkAllocationEvaluationTemplatesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOrgWorkAllocationEvaluationTemplatesQuery = (resolver: GraphQLResponseResolver<OrgWorkAllocationEvaluationTemplatesQuery, OrgWorkAllocationEvaluationTemplatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<OrgWorkAllocationEvaluationTemplatesQuery, OrgWorkAllocationEvaluationTemplatesQueryVariables>(
    'OrgWorkAllocationEvaluationTemplates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationEvaluationTemplateMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertEvaluationQuestionTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationEvaluationTemplateMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationEvaluationTemplateMutation, UpsertWorkAllocationEvaluationTemplateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationEvaluationTemplateMutation, UpsertWorkAllocationEvaluationTemplateMutationVariables>(
    'UpsertWorkAllocationEvaluationTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteWorkAllocationEvaluationTemplateMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteEvaluationQuestionTemplate }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteWorkAllocationEvaluationTemplateMutation = (resolver: GraphQLResponseResolver<DeleteWorkAllocationEvaluationTemplateMutation, DeleteWorkAllocationEvaluationTemplateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteWorkAllocationEvaluationTemplateMutation, DeleteWorkAllocationEvaluationTemplateMutationVariables>(
    'DeleteWorkAllocationEvaluationTemplate',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpsertWorkAllocationCustomProgramEvaluationTemplatesMutation(
 *   ({ query, variables }) => {
 *     const { input } = variables;
 *     return HttpResponse.json({
 *       data: { upsertWorkAllocationCustomProgramEvaluationTemplates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpsertWorkAllocationCustomProgramEvaluationTemplatesMutation = (resolver: GraphQLResponseResolver<UpsertWorkAllocationCustomProgramEvaluationTemplatesMutation, UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpsertWorkAllocationCustomProgramEvaluationTemplatesMutation, UpsertWorkAllocationCustomProgramEvaluationTemplatesMutationVariables>(
    'UpsertWorkAllocationCustomProgramEvaluationTemplates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMatterPetMutation(
 *   ({ query, variables }) => {
 *     const { petName, matterId } = variables;
 *     return HttpResponse.json({
 *       data: { updateMatterPet }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMatterPetMutation = (resolver: GraphQLResponseResolver<UpdateMatterPetMutation, UpdateMatterPetMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMatterPetMutation, UpdateMatterPetMutationVariables>(
    'UpdateMatterPet',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMatterPetQuery(
 *   ({ query, variables }) => {
 *     const { matterId } = variables;
 *     return HttpResponse.json({
 *       data: { matterPet }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMatterPetQuery = (resolver: GraphQLResponseResolver<MatterPetQuery, MatterPetQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MatterPetQuery, MatterPetQueryVariables>(
    'MatterPet',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetSavedEvaluationQuestionTemplatesQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { getSavedEvaluationQuestionTemplatesForOrg }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetSavedEvaluationQuestionTemplatesQuery = (resolver: GraphQLResponseResolver<GetSavedEvaluationQuestionTemplatesQuery, GetSavedEvaluationQuestionTemplatesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetSavedEvaluationQuestionTemplatesQuery, GetSavedEvaluationQuestionTemplatesQueryVariables>(
    'GetSavedEvaluationQuestionTemplates',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSendBulkProjectEvaluationRequestEmailsMutation(
 *   ({ query, variables }) => {
 *     const { programId, projectIds } = variables;
 *     return HttpResponse.json({
 *       data: { sendBulkProjectEvaluationRequestEmails }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSendBulkProjectEvaluationRequestEmailsMutation = (resolver: GraphQLResponseResolver<SendBulkProjectEvaluationRequestEmailsMutation, SendBulkProjectEvaluationRequestEmailsMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<SendBulkProjectEvaluationRequestEmailsMutation, SendBulkProjectEvaluationRequestEmailsMutationVariables>(
    'SendBulkProjectEvaluationRequestEmails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIsProjectEvaluationEmailEnabledQuery(
 *   ({ query, variables }) => {
 *     const { programId } = variables;
 *     return HttpResponse.json({
 *       data: { workAllocationProgram }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockIsProjectEvaluationEmailEnabledQuery = (resolver: GraphQLResponseResolver<IsProjectEvaluationEmailEnabledQuery, IsProjectEvaluationEmailEnabledQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<IsProjectEvaluationEmailEnabledQuery, IsProjectEvaluationEmailEnabledQueryVariables>(
    'IsProjectEvaluationEmailEnabled',
    resolver,
    options
  )
